
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("exkzN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bb80c5e41397c940$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $e9YVH = parcelRequire("e9YVH");

var $jLOUq = parcelRequire("jLOUq");

var $4dRjY = parcelRequire("4dRjY");

var $13lzj = parcelRequire("13lzj");
const $bb80c5e41397c940$var$KbRequestsReportsApp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLOUq.default), {
        pageId: "reports-requests",
        appName: (0, $e9YVH.APP_NAMES).KB_REPORTS_REQUESTS,
        dontShowHeader: (0, $3HwlS.getWillShowNav4)()
    }, ({ pageContext: pageContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13lzj.default), {
            pageContext: pageContext
        })));
var $bb80c5e41397c940$export$2e2bcd8739ae039 = $bb80c5e41397c940$var$KbRequestsReportsApp;

});
parcelRegister("jLOUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf67f44913f9c86$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $jD5no = parcelRequire("jD5no");

var $81ps3 = parcelRequire("81ps3");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $9noxX = parcelRequire("9noxX");

var $aLLc7 = parcelRequire("aLLc7");

var $cf7yQ = parcelRequire("cf7yQ");

var $e33py = parcelRequire("e33py");

var $8pMQX = parcelRequire("8pMQX");

var $gq0sA = parcelRequire("gq0sA");

var $4S0uJ = parcelRequire("4S0uJ");

var $cz40O = parcelRequire("cz40O");

var $8ubVf = parcelRequire("8ubVf");

var $dIdda = parcelRequire("dIdda");

var $1BIUA = parcelRequire("1BIUA");

var $cHb7s = parcelRequire("cHb7s");

var $gMO5K = parcelRequire("gMO5K");
const $bcf67f44913f9c86$var$ReportsAppBase = ({ appName: appName, pageId: pageId, pageTitle: pageTitle, children: children, AppBase: AppBase, ErrorView: ErrorView, PageStyle: PageStyle, actions: actions, dontShowHeader: dontShowHeader = false })=>{
    const [{ match: match }] = (0, $dIdda.useRouter)();
    const [{ data: pageContextData, error: error }] = (0, $gq0sA.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName } = projectContext || {};
    const { baseUrl: baseUrl } = tenantContext || {};
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const pageContextProps = (0, $5uXOq.useMemo)(()=>({
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }), [
        projectContext,
        serviceDeskContext,
        tenantContext
    ]);
    const breadcrumbs = [
        {
            href: '/jira/projects',
            text: formatMessage((0, $gMO5K.default).projectsBreadcrumb)
        },
        {
            href: (0, $81ps3.createProjectUrl)(projectKey || ''),
            text: projectName || ''
        },
        {
            href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
            text: formatMessage((0, $gMO5K.default).reportsBreadcrumb)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cz40O.SpaPageWrapper), {
        pageId: pageId,
        baseUrl: baseUrl,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: !pageContextData && !error,
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e33py.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "reports"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppBase, {
        id: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aLLc7.ServiceDeskErrorBoundary), {
        appName: appName,
        ErrorView: ErrorView
    }, !dontShowHeader && ((0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ubVf.Header), {
        title: pageTitle ? formatMessage(pageTitle) : '',
        breadcrumbs: breadcrumbs,
        actions: actions
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $bcf67f44913f9c86$var$HeaderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PageStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHb7s.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BIUA.default), {
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            baseUrl: baseUrl,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectKey: projectKey,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectName: projectName
        }),
        title: pageTitle,
        actions: actions
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PageStyle, null, children({
        pageContext: pageContextProps
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null));
};
const $bcf67f44913f9c86$var$HeaderContainer = (0, $jJ1Sb.xcss)({
    paddingBottom: 'space.200'
});
$bcf67f44913f9c86$var$ReportsAppBase.defaultProps = {
    AppBase: (0, $jD5no.default),
    ErrorView: (0, $8pMQX.GenericError),
    PageStyle: (0, $4S0uJ.PageStyle)
};
var $bcf67f44913f9c86$export$2e2bcd8739ae039 = $bcf67f44913f9c86$var$ReportsAppBase;

});
parcelRegister("aLLc7", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskErrorBoundary", () => $8803d19bf51a79cd$export$d999c9325a45f4cf);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $e9YVH = parcelRequire("e9YVH");
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $8803d19bf51a79cd$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $8803d19bf51a79cd$var$toErrorOrUndefined = (error)=>{
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return undefined;
};
class $8803d19bf51a79cd$export$d999c9325a45f4cf extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
        this.triggerEvent = $8803d19bf51a79cd$var$triggerAnalyticsEvent(`${props.appName}`);
    }
    componentDidCatch(error) {
        const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
        const data = error instanceof Error ? {
            message: error.message,
            stack: error.stack
        } : {
            message: error
        };
        this.triggerEvent('error-boundary.error-caught', data);
        (0, $jcw0u.default)({
            meta: {
                id: 'unhandled',
                packageName: (0, $e9YVH.toPackageName)(appName) || 'jiraServicedeskCommon'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event: this.triggerEvent,
            error: $8803d19bf51a79cd$var$toErrorOrUndefined(error),
            sendToPrivacyUnsafeSplunk: true
        });
        // If error view is present then allow error view to handle errors.
        if (ErrorView) return;
        // Some of the non spa apps uses this call back function which doesn't have any error view
        if (onErrorHandler) onErrorHandler(error);
        else // Rethrow for error boundary handling by app-base
        throw error;
    }
    render() {
        const { hasError: hasError } = this.state;
        const { ErrorView: ErrorView, children: children } = this.props;
        if (hasError && ErrorView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorView, null);
        return children;
    }
}

});

parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $hPtZI = parcelRequire("hPtZI");

var $lfTZh = parcelRequire("lfTZh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("6MoH3")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("ejgPJ")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("2VzMc")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("ahFso")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("6MoH3", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("chQyv").then(()=>parcelRequire('hZyYK'));

});

parcelRegister("ejgPJ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("3Xgpx")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("2VzMc", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hlGg7")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("ahFso", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("eXDqW")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("e33py", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $ae40b537a934bf9c$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $ae40b537a934bf9c$export$c7841d2c1c13065e);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $ew1Lk = parcelRequire("ew1Lk");

var $koVbs = parcelRequire("koVbs");

var $2BHCj = parcelRequire("2BHCj");
const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${subsection} - ${formatMessage((0, $2BHCj.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${formatMessage((0, $2BHCj.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
        title: title
    });
};
const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, $9sGI6.default)($ae40b537a934bf9c$export$155581e8dc02007a, {
    DocumentTitle: (0, $ew1Lk.DocumentTitle)
});
var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;

});
parcelRegister("ew1Lk", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $41b549fa18234081$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $6nkVm = parcelRequire("6nkVm");

class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $6nkVm.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6nkVm.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("2BHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7eb5ce3479323e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    projectSummary: {
        "id": "servicedesk-spa-commons.common.utils.document-title.project-summary.non-final",
        "defaultMessage": "Summary"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $4hGw3 = parcelRequire("4hGw3");

var $ew1Lk = parcelRequire("ew1Lk");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: formatMessage((0, $4AdE6.default).genericErrorDescription)
    }));
};

});
parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});


parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("4S0uJ", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $7307247c9fc02c84$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aHqrR = parcelRequire("aHqrR");
const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null, children));
$7307247c9fc02c84$export$c59987a647e9a55.defaultProps = {
    Page: (0, $aHqrR.default)
};
var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7307247c9fc02c84$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aHqrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa66aa050f59c1b8$export$2e2bcd8739ae039);

var $7mDUF = parcelRequire("7mDUF");

var $8bHfj = parcelRequire("8bHfj");

var $jMaea = parcelRequire("jMaea");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa66aa050f59c1b8$export$2e2bcd8739ae039 = (0, $7mDUF.default);

});
parcelRegister("7mDUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6282b4eef5766075$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $11b0c = parcelRequire("11b0c");
function $6282b4eef5766075$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6282b4eef5766075$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $6282b4eef5766075$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $6282b4eef5766075$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $6282b4eef5766075$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $6282b4eef5766075$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $6282b4eef5766075$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $6282b4eef5766075$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $11b0c.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$pageContentStyles
    }, children)));
};
var $6282b4eef5766075$export$2e2bcd8739ae039 = $6282b4eef5766075$var$Page;

});
parcelRegister("11b0c", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $f44176f7e15183a6$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $f44176f7e15183a6$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $f44176f7e15183a6$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $f44176f7e15183a6$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $f44176f7e15183a6$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $f44176f7e15183a6$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $f44176f7e15183a6$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $f44176f7e15183a6$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $f44176f7e15183a6$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $f44176f7e15183a6$export$936829b4511db3e4);
const $f44176f7e15183a6$export$3aaf3a78c909ea56 = 8;
const $f44176f7e15183a6$export$74797698e12f8baa = 12;
const $f44176f7e15183a6$export$b8241a1616ab1b96 = $f44176f7e15183a6$export$3aaf3a78c909ea56 * 10;
const $f44176f7e15183a6$export$2a89a65a43bab52d = {
    comfortable: $f44176f7e15183a6$export$3aaf3a78c909ea56 * 5,
    cosy: $f44176f7e15183a6$export$3aaf3a78c909ea56 * 2,
    compact: $f44176f7e15183a6$export$3aaf3a78c909ea56 * 0.5
};
const $f44176f7e15183a6$export$8ec7372efd74b753 = 'cosy';
const $f44176f7e15183a6$export$d77f83c3d17a7b8a = 52;
const $f44176f7e15183a6$export$f8725d21f81f3e01 = 0;
const $f44176f7e15183a6$export$2303d2bd9eeff99a = 'fixed';
const $f44176f7e15183a6$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $f44176f7e15183a6$export$8b7e31f391e6e681 = '--ds-column-span';
const $f44176f7e15183a6$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("8bHfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dcf7cd802acc3dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $11b0c = parcelRequire("11b0c");

var $ivppf = parcelRequire("ivppf");

var $jMaea = parcelRequire("jMaea");

var $htEEQ = parcelRequire("htEEQ");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $8dcf7cd802acc3dc$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $htEEQ.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $jMaea.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $11b0c.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $11b0c.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htEEQ.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivppf.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $8dcf7cd802acc3dc$export$2e2bcd8739ae039 = $8dcf7cd802acc3dc$var$GridWrapper;

});
parcelRegister("ivppf", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $1cdfa0aca94d366d$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $11b0c = parcelRequire("11b0c");

var $htEEQ = parcelRequire("htEEQ");
function $1cdfa0aca94d366d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1cdfa0aca94d366d$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $11b0c.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $1cdfa0aca94d366d$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $11b0c.varColumnsNum)}) * ${(0, $11b0c.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $1cdfa0aca94d366d$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $11b0c.varGridSpacing)}))`
});
const $1cdfa0aca94d366d$export$ef2184bd89960b14 = ({ layout: layout = (0, $11b0c.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $htEEQ.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $1cdfa0aca94d366d$var$gridStyles,
            $1cdfa0aca94d366d$var$gridLayoutStyles[layout],
            isNested && $1cdfa0aca94d366d$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $11b0c.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $11b0c.varGridSpacing)]: `${(0, $11b0c.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("htEEQ", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $0003b8639fb07aed$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $11b0c = parcelRequire("11b0c");
const $0003b8639fb07aed$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $11b0c.defaultSpacing),
    columns: (0, $11b0c.defaultGridColumns)
});

});


parcelRegister("jMaea", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $e8cfd28f42e3bb74$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $e8cfd28f42e3bb74$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $11b0c = parcelRequire("11b0c");

var $htEEQ = parcelRequire("htEEQ");
var $e8cfd28f42e3bb74$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($e8cfd28f42e3bb74$var$ColumnVariant || ($e8cfd28f42e3bb74$var$ColumnVariant = {}));
const $e8cfd28f42e3bb74$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $11b0c.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $e8cfd28f42e3bb74$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e8cfd28f42e3bb74$var$singleColumnWidth = `(${$e8cfd28f42e3bb74$var$availableWidth} / var(${(0, $11b0c.varColumnsNum)}))`;
const $e8cfd28f42e3bb74$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$e8cfd28f42e3bb74$var$singleColumnWidth} - var(${(0, $11b0c.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $11b0c.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $e8cfd28f42e3bb74$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $11b0c.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$e8cfd28f42e3bb74$var$singleColumnWidth} *  var(${(0, $11b0c.varColumnSpan)}) - var(${(0, $11b0c.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $11b0c.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $e8cfd28f42e3bb74$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $11b0c.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $e8cfd28f42e3bb74$var$GridColumn = ({ medium: medium = (0, $11b0c.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $htEEQ.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $e8cfd28f42e3bb74$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($e8cfd28f42e3bb74$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $e8cfd28f42e3bb74$var$gridColumnStyles,
            $e8cfd28f42e3bb74$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $11b0c.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $e8cfd28f42e3bb74$export$2e2bcd8739ae039 = $e8cfd28f42e3bb74$var$GridColumn;

});




parcelRegister("cz40O", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $2099b56eb86565d0$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $dJl1T = parcelRequire("dJl1T");

var $9sGI6 = parcelRequire("9sGI6");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $cYaqS = parcelRequire("cYaqS");

var $8pMQX = parcelRequire("8pMQX");
const $2099b56eb86565d0$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AccessCheck, null, children)));
    return null;
};
const $2099b56eb86565d0$export$577514961fbf4842 = (0, $9sGI6.default)($2099b56eb86565d0$export$91f88695e0d311a5, {
    AccessCheck: (0, $cYaqS.default),
    GenericError: (0, $8pMQX.GenericError),
    ProjectNotFound: (0, $8pMQX.ProjectNotFound),
    AuthenticationCheck: (0, $9NiTW.AuthenticationCheck),
    SubProductUpdater: (0, $9dbF6.SubProductUpdater)
});
var $2099b56eb86565d0$export$2e2bcd8739ae039 = $2099b56eb86565d0$export$577514961fbf4842;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1u3Jv = parcelRequire("1u3Jv");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $6BZYo.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $dIdda = parcelRequire("dIdda");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;




parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});



parcelRegister("8ubVf", function(module, exports) {

$parcel$export(module.exports, "Header", () => $0532a94f373aae43$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $1eHCV = parcelRequire("1eHCV");
var $dkxUw = parcelRequire("dkxUw");

var $53KbV = parcelRequire("53KbV");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $iaTnv = parcelRequire("iaTnv");
var $jJ1Sb = parcelRequire("jJ1Sb");
const $0532a94f373aae43$var$headerContainerStyles = (0, $jJ1Sb.xcss)({
    marginTop: 'space.200',
    marginBottom: 'space.200',
    marginLeft: 'space.300',
    marginRight: 'space.300',
    gap: 'space.050'
});
const $0532a94f373aae43$var$headerBorder = (0, $jJ1Sb.xcss)({
    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $0532a94f373aae43$var$headerElementsSpace = (0, $jJ1Sb.xcss)({
    justifyContent: 'space-between',
    alignItems: 'end'
});
const $0532a94f373aae43$export$8b251419efc915eb = ({ title: title, breadcrumbs: breadcrumbs, actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
        xcss: $0532a94f373aae43$var$headerBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
        xcss: $0532a94f373aae43$var$headerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkxUw.default), null, breadcrumbs.map((crumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eHCV.default), {
            href: crumb.href,
            text: crumb.text
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        xcss: $0532a94f373aae43$var$headerElementsSpace
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        size: "large"
    }, title), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, actions)))));
};

});

parcelRegister("1BIUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c84489faf50721$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e0Brz = parcelRequire("e0Brz");

var $jS4lj = parcelRequire("jS4lj");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $koVbs = parcelRequire("koVbs");

var $kwX4O = parcelRequire("kwX4O");
const $73c84489faf50721$var$ProjectSettingsBreadcrumb = ({ baseUrl: baseUrl, projectKey: projectKey, projectName: projectName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
            text: formatMessage((0, $kwX4O.default).reportsBreadcrumbTitle),
            type: 'projectSettings'
        }
    })));
};
var $73c84489faf50721$export$2e2bcd8739ae039 = $73c84489faf50721$var$ProjectSettingsBreadcrumb;

});
parcelRegister("kwX4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $0683f400a1ea0c3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0683f400a1ea0c3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reportsBreadcrumbTitle: {
        "id": "spa-apps-servicedesk-reports-base.breadcrumb.reports-breadcrumb-title",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("cHb7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $595a97230cddb61d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $53KbV = parcelRequire("53KbV");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $cS37j = parcelRequire("cS37j");

var $az4zD = parcelRequire("az4zD");
const $595a97230cddb61d$var$Header = ({ title: title, breadcrumbs: breadcrumbs, intl: { formatMessage: formatMessage }, actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        breadcrumbs: breadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $595a97230cddb61d$var$titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        level: "h700",
        as: "h1"
    }, title && formatMessage(title))), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, actions)));
var $595a97230cddb61d$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($595a97230cddb61d$var$Header);
const $595a97230cddb61d$var$titleContainer = (0, $jJ1Sb.xcss)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1jYIE = parcelRequire("1jYIE");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1jYIE.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1jYIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $622b85ee800d74dc$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $5uXOq = parcelRequire("5uXOq");

var $fIdIO = parcelRequire("fIdIO");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $622b85ee800d74dc$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $622b85ee800d74dc$export$2e2bcd8739ae039 = $622b85ee800d74dc$var$PageHeader;

});
parcelRegister("fIdIO", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $63eaf4260decdc00$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $63eaf4260decdc00$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $63eaf4260decdc00$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $63eaf4260decdc00$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $63eaf4260decdc00$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $63eaf4260decdc00$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");
function $63eaf4260decdc00$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $63eaf4260decdc00$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $63eaf4260decdc00$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $63eaf4260decdc00$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $63eaf4260decdc00$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $63eaf4260decdc00$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $63eaf4260decdc00$var$titleContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $63eaf4260decdc00$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $63eaf4260decdc00$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $63eaf4260decdc00$var$bottomBarStyles = (0, $jJ1Sb.xcss)({
    marginBlockStart: 'space.200'
});
const $63eaf4260decdc00$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $63eaf4260decdc00$var$outerStyles
    }, children);
};
const $63eaf4260decdc00$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("h1", {
        css: [
            $63eaf4260decdc00$var$titleStyles,
            truncateTitle && $63eaf4260decdc00$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $63eaf4260decdc00$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $63eaf4260decdc00$var$titleWrapperStyles,
            truncateTitle && $63eaf4260decdc00$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $63eaf4260decdc00$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $63eaf4260decdc00$var$titleContainerStyles,
            truncateTitle && $63eaf4260decdc00$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $63eaf4260decdc00$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $63eaf4260decdc00$var$actionStyles
    }, children);
};
const $63eaf4260decdc00$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        xcss: $63eaf4260decdc00$var$bottomBarStyles
    }, children);
};

});




parcelRegister("gMO5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ceb509eee39709$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6ceb509eee39709$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsBreadcrumb: {
        "id": "spa-apps-servicedesk-reports-base.projects-breadcrumb",
        "defaultMessage": "Projects"
    },
    reportsBreadcrumb: {
        "id": "spa-apps-servicedesk-reports-base.reports-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("13lzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $efff5bc3f5eed044$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bYGxE = parcelRequire("bYGxE");

var $g5X3G = parcelRequire("g5X3G");

var $eEETY = parcelRequire("eEETY");
const $efff5bc3f5eed044$var$KbRequestsReportsSpa = ({ pageContext: pageContext })=>{
    const { projectKey: projectKey, projectId: projectId, projectName: projectName } = pageContext;
    const routerProps = (0, $eEETY.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYGxE.default), {
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        projectKey: (0, $g5X3G.toProjectKey)(projectKey),
        projectId: (0, $g5X3G.toProjectId)(String(projectId)),
        routerProps: routerProps,
        projectName: projectName
    });
};
var $efff5bc3f5eed044$export$2e2bcd8739ae039 = $efff5bc3f5eed044$var$KbRequestsReportsSpa;

});
parcelRegister("bYGxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d61cfdb457a8833$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $6jY6G = parcelRequire("6jY6G");

var $dp7nU = parcelRequire("dp7nU");

var $5GhjE = parcelRequire("5GhjE");

var $4Kc9u = parcelRequire("4Kc9u");
const $4d61cfdb457a8833$var$KbRequestsReports = ({ routerProps: routerProps, baseUrl: baseUrl, projectId: projectId, projectKey: projectKey, projectName: projectName })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    (0, $5uXOq.useEffect)(()=>{
        if (route.perfMetricKey) (0, $5GhjE.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey);
    }, [
        routerProps.reportId,
        route.perfMetricKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "reportsKBRequests",
        packageName: "jiraServicedeskKbRequestsReports",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dp7nU.UIStateContainer), {
        scope: "kb-requests",
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectId: projectId,
        routerProps: routerProps,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Kc9u.KbRequestsReportsMain), {
        routerProps: routerProps,
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    })));
};
var $4d61cfdb457a8833$export$2e2bcd8739ae039 = $4d61cfdb457a8833$var$KbRequestsReports;

});
parcelRegister("dp7nU", function(module, exports) {

$parcel$export(module.exports, "useUIStateStore", () => $59f9dc999a2e968d$export$bc19f6a0f463699c);
$parcel$export(module.exports, "UIStateContainer", () => $59f9dc999a2e968d$export$7a236534a832e2a0);

var $g5X3G = parcelRequire("g5X3G");

var $7JoAD = parcelRequire("7JoAD");

var $kmKHQ = parcelRequire("kmKHQ");

var $39vSm = parcelRequire("39vSm");
const $59f9dc999a2e968d$export$d4c72bab9d6cc13a = {
    dateFilterQuery: {
        reportId: '',
        timescaleId: 0
    },
    baseUrl: (0, $g5X3G.toBaseUrl)(''),
    projectKey: (0, $g5X3G.toProjectKey)(''),
    projectId: (0, $g5X3G.toProjectId)(''),
    projectName: ''
};
const $59f9dc999a2e968d$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    name: 'CustomReportsUiState',
    initialState: $59f9dc999a2e968d$export$d4c72bab9d6cc13a,
    actions: $39vSm
});
const $59f9dc999a2e968d$export$bc19f6a0f463699c = (0, $7JoAD.createHook)($59f9dc999a2e968d$export$6f57813fe9f31bf9);
const $59f9dc999a2e968d$var$onContainerChange = ()=>// @ts-expect-error - TS7031 - Binding element 'getState' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'routerProps' implicitly has an 'any' type.
    ({ getState: getState, setState: setState }, { routerProps: routerProps, ...projectContext })=>{
        const { dateFilterQuery: dateFilterQuery } = getState();
        if (routerProps && routerProps.timescaleId === undefined) setState({
            dateFilterQuery: (0, $kmKHQ.getReportsQueryParams)({
                ...dateFilterQuery,
                reportId: routerProps.reportId || ''
            }),
            ...projectContext
        });
        else setState({
            dateFilterQuery: (0, $kmKHQ.getReportsQueryParams)(routerProps || {
                reportId: ''
            }),
            ...projectContext
        });
    };
const $59f9dc999a2e968d$export$7a236534a832e2a0 = (0, $7JoAD.createContainer)($59f9dc999a2e968d$export$6f57813fe9f31bf9, {
    // @ts-expect-error - TS2322 - Type '() => ({ getState, setState }: { getState: any; setState: any; }, { routerProps, ...projectContext }: { [x: string]: any; routerProps: any; }) => void' is not assignable to type '() => Action<State, PropType, void | Promise<void>>'.
    onInit: $59f9dc999a2e968d$var$onContainerChange,
    // @ts-expect-error - TS2322 - Type '() => ({ getState, setState }: { getState: any; setState: any; }, { routerProps, ...projectContext }: { [x: string]: any; routerProps: any; }) => void' is not assignable to type '() => Action<State, PropType, void | Promise<void>>'.
    onUpdate: $59f9dc999a2e968d$var$onContainerChange
});

});
parcelRegister("kmKHQ", function(module, exports) {

$parcel$export(module.exports, "getReportsQueryParams", () => $99d62706a41aea1a$export$7f3783713a221f4d);

var $32TkL = parcelRequire("32TkL");

var $bvS9p = parcelRequire("bvS9p");

var $88d59 = parcelRequire("88d59");
const $99d62706a41aea1a$export$7f3783713a221f4d = (routerProps, defaultQuery)=>{
    const timescaleId = Number(routerProps.timescaleId) || Number(defaultQuery && defaultQuery.timescaleId) || Number((0, $88d59.REPORT_DEFAULTS).searchByPastSevenDays);
    if ((0, $bvS9p.isCustomTimeScale)(timescaleId)) {
        const { startDate: startDate, endDate: endDate, timeBreakdown: timeBreakdown } = routerProps;
        if (startDate !== undefined && endDate !== undefined) return {
            reportId: routerProps.reportId,
            timescaleId: timescaleId,
            startDate: startDate,
            endDate: endDate,
            timeBreakdown: timeBreakdown || (0, $88d59.REPORT_DEFAULTS).timeBreakdown
        };
        if (defaultQuery !== undefined) return {
            ...defaultQuery,
            reportId: routerProps.reportId
        };
    }
    return {
        reportId: routerProps.reportId,
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{ readonly 1: { readonly timeBreakdown: "h"; readonly timePeriod: "PT48H"; }; readonly 2: { readonly timeBreakdown: "d"; readonly timePeriod: "P7D"; }; readonly 3: { readonly timeBreakdown: "d"; readonly timePeriod: "P14D"; }; ... 4 more ...; readonly 8: { ...; }; }'.
        ...(0, $32TkL.timescaleToTimePeriodBreakdownMap)[timescaleId],
        timescaleId: timescaleId
    };
};

});
parcelRegister("32TkL", function(module, exports) {

$parcel$export(module.exports, "ABORT_ERR", () => $e9f584bc433c5797$export$16e59c3676e6ec88);
$parcel$export(module.exports, "stringifyOptions", () => $e9f584bc433c5797$export$8ca327d1d4eb828a);
$parcel$export(module.exports, "timescaleToTimePeriodBreakdownMap", () => $e9f584bc433c5797$export$60e856ddfbc4076a);

var $9nenm = parcelRequire("9nenm");
const $e9f584bc433c5797$export$16e59c3676e6ec88 = 20;
const $e9f584bc433c5797$export$8ca327d1d4eb828a = {
    skipNull: true,
    sort: false
};
const $e9f584bc433c5797$export$60e856ddfbc4076a = {
    [(0, $9nenm.TIME_SCALES).past48Hours]: {
        timeBreakdown: 'h',
        timePeriod: 'PT48H'
    },
    [(0, $9nenm.TIME_SCALES).past7Days]: {
        timeBreakdown: 'd',
        timePeriod: 'P7D'
    },
    [(0, $9nenm.TIME_SCALES).past14Days]: {
        timeBreakdown: 'd',
        timePeriod: 'P14D'
    },
    [(0, $9nenm.TIME_SCALES).past30Days]: {
        timeBreakdown: 'd',
        timePeriod: 'P30D'
    },
    [(0, $9nenm.TIME_SCALES).pastQuarterByDay]: {
        timeBreakdown: 'd',
        timePeriod: 'P3M'
    },
    [(0, $9nenm.TIME_SCALES).pastQuarterByWeek]: {
        timeBreakdown: 'w',
        timePeriod: 'P3M'
    },
    [(0, $9nenm.TIME_SCALES).pastYearByWeek]: {
        timeBreakdown: 'w',
        timePeriod: 'P1Y'
    },
    [(0, $9nenm.TIME_SCALES).pastYearByMonth]: {
        timeBreakdown: 'm',
        timePeriod: 'P1Y'
    }
};

});
parcelRegister("9nenm", function(module, exports) {

$parcel$export(module.exports, "LINE", () => $118c88390a21cde0$export$f4dbacc416028787);
$parcel$export(module.exports, "ISO_DATE_FORMAT", () => $118c88390a21cde0$export$e63e1e1c17a0e8b);
$parcel$export(module.exports, "SEARCH_BY", () => $118c88390a21cde0$export$73579ee3a6c6da2d);
$parcel$export(module.exports, "TIME_SCALES", () => $118c88390a21cde0$export$f4b7bd2d183699);
$parcel$export(module.exports, "TIME_SCALE_TO_LABEL_FORMAT_MAP", () => $118c88390a21cde0$export$d294667ef4c55b77);
$parcel$export(module.exports, "TIME_SCALE_TO_ACCESS_POINT_FORMAT_MAP", () => $118c88390a21cde0$export$d747786a0fd0612a);
$parcel$export(module.exports, "TIME_SCALE_TO_EXPANDED_FORMAT_MAP", () => $118c88390a21cde0$export$10269a0feece8850);
$parcel$export(module.exports, "HOUR_TIME_SCALES", () => $118c88390a21cde0$export$3a0518a58fb5a137);
$parcel$export(module.exports, "WEEK_TIME_SCALES", () => $118c88390a21cde0$export$4a7e81f242db56eb);
$parcel$export(module.exports, "MONTH_TIME_SCALES", () => $118c88390a21cde0$export$4d0f9c0d6ea181d8);
const $118c88390a21cde0$export$f4dbacc416028787 = 'line';
const $118c88390a21cde0$export$819df699d4b89202 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
};
const $118c88390a21cde0$export$aeb3068fe93add26 = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};
const $118c88390a21cde0$export$91f5690a90ac7547 = {
    weekday: 'short',
    hour: 'numeric',
    hour12: true
};
const $118c88390a21cde0$export$2879907f3ed21511 = {
    day: 'numeric',
    month: 'short'
};
const $118c88390a21cde0$export$717efa0dc6e0515d = {
    weekday: 'long',
    hour: 'numeric',
    hour12: true
};
const $118c88390a21cde0$export$d8a30ff1ae1d321e = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};
const $118c88390a21cde0$export$6da506db6d19da8d = {
    month: 'long',
    year: 'numeric'
};
const $118c88390a21cde0$export$94f447fe753c3528 = {
    month: 'short'
};
const $118c88390a21cde0$export$c003002ffeb9f3c0 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
};
const $118c88390a21cde0$export$e63e1e1c17a0e8b = 'yyyy-MM-dd';
const $118c88390a21cde0$export$430f49a23dab85d4 = 'YYYY-MM-DD';
const $118c88390a21cde0$export$73579ee3a6c6da2d = {
    hourly: 'h',
    daily: 'd',
    weekly: 'w',
    monthly: 'm'
};
const $118c88390a21cde0$export$f4b7bd2d183699 = {
    past48Hours: '1',
    past7Days: '2',
    past14Days: '3',
    past30Days: '4',
    pastQuarterByDay: '5',
    pastQuarterByWeek: '6',
    pastYearByWeek: '7',
    pastYearByMonth: '8',
    customTimeScale: 9,
    customDatesByHours: `9${$118c88390a21cde0$export$73579ee3a6c6da2d.hourly}`,
    customDatesByDays: `9${$118c88390a21cde0$export$73579ee3a6c6da2d.daily}`,
    customDatesByWeeks: `9${$118c88390a21cde0$export$73579ee3a6c6da2d.weekly}`,
    customDatesByMonth: `9${$118c88390a21cde0$export$73579ee3a6c6da2d.monthly}`
};
const $118c88390a21cde0$export$d294667ef4c55b77 = {
    [$118c88390a21cde0$export$f4b7bd2d183699.past48Hours]: $118c88390a21cde0$export$91f5690a90ac7547,
    [$118c88390a21cde0$export$f4b7bd2d183699.past7Days]: $118c88390a21cde0$export$2879907f3ed21511,
    [$118c88390a21cde0$export$f4b7bd2d183699.past14Days]: $118c88390a21cde0$export$2879907f3ed21511,
    [$118c88390a21cde0$export$f4b7bd2d183699.past30Days]: $118c88390a21cde0$export$2879907f3ed21511,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByDay]: $118c88390a21cde0$export$2879907f3ed21511,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByWeek]: $118c88390a21cde0$export$2879907f3ed21511,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByMonth]: $118c88390a21cde0$export$94f447fe753c3528,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByHours]: $118c88390a21cde0$export$91f5690a90ac7547,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByDays]: $118c88390a21cde0$export$2879907f3ed21511,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByWeeks]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByMonth]: $118c88390a21cde0$export$94f447fe753c3528
};
const $118c88390a21cde0$export$d747786a0fd0612a = {
    [$118c88390a21cde0$export$f4b7bd2d183699.past48Hours]: $118c88390a21cde0$export$717efa0dc6e0515d,
    [$118c88390a21cde0$export$f4b7bd2d183699.past7Days]: $118c88390a21cde0$export$aeb3068fe93add26,
    [$118c88390a21cde0$export$f4b7bd2d183699.past14Days]: $118c88390a21cde0$export$aeb3068fe93add26,
    [$118c88390a21cde0$export$f4b7bd2d183699.past30Days]: $118c88390a21cde0$export$aeb3068fe93add26,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByDay]: $118c88390a21cde0$export$2879907f3ed21511,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByMonth]: $118c88390a21cde0$export$6da506db6d19da8d,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByHours]: $118c88390a21cde0$export$717efa0dc6e0515d,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByDays]: $118c88390a21cde0$export$aeb3068fe93add26,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByWeeks]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByMonth]: $118c88390a21cde0$export$6da506db6d19da8d
};
const $118c88390a21cde0$export$10269a0feece8850 = {
    [$118c88390a21cde0$export$f4b7bd2d183699.past48Hours]: $118c88390a21cde0$export$819df699d4b89202,
    [$118c88390a21cde0$export$f4b7bd2d183699.past7Days]: $118c88390a21cde0$export$c003002ffeb9f3c0,
    [$118c88390a21cde0$export$f4b7bd2d183699.past14Days]: $118c88390a21cde0$export$c003002ffeb9f3c0,
    [$118c88390a21cde0$export$f4b7bd2d183699.past30Days]: $118c88390a21cde0$export$c003002ffeb9f3c0,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByDay]: $118c88390a21cde0$export$2879907f3ed21511,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
    [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByMonth]: $118c88390a21cde0$export$6da506db6d19da8d,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByHours]: $118c88390a21cde0$export$819df699d4b89202,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByDays]: $118c88390a21cde0$export$aeb3068fe93add26,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByWeeks]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
    [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByMonth]: $118c88390a21cde0$export$6da506db6d19da8d
};
const $118c88390a21cde0$export$3a0518a58fb5a137 = [
    $118c88390a21cde0$export$f4b7bd2d183699.past48Hours,
    $118c88390a21cde0$export$f4b7bd2d183699.customDatesByHours
];
const $118c88390a21cde0$export$4a7e81f242db56eb = [
    $118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByWeek,
    $118c88390a21cde0$export$f4b7bd2d183699.pastYearByWeek,
    $118c88390a21cde0$export$f4b7bd2d183699.customDatesByWeeks
];
const $118c88390a21cde0$export$4d0f9c0d6ea181d8 = [
    $118c88390a21cde0$export$f4b7bd2d183699.pastYearByMonth,
    $118c88390a21cde0$export$f4b7bd2d183699.customDatesByMonth
];

});


parcelRegister("bvS9p", function(module, exports) {

$parcel$export(module.exports, "isCustomTimeScale", () => $6fa57c5281275469$export$a0a0756dadf12882);
$parcel$export(module.exports, "transformSummarySource", () => $6fa57c5281275469$export$a1b7447ceadada1e);
$parcel$export(module.exports, "transformCustomSummarySource", () => $6fa57c5281275469$export$ca4cf779304602d7);

var $jcw0u = parcelRequire("jcw0u");

var $8npOo = parcelRequire("8npOo");

var $9nenm = parcelRequire("9nenm");

var $V3NN5 = parcelRequire("V3NN5");

var $cnldZ = parcelRequire("cnldZ");
const $6fa57c5281275469$export$a0a0756dadf12882 = (timescaleId)=>timescaleId === (0, $9nenm.TIME_SCALES).customTimeScale;
const $6fa57c5281275469$var$formatChartData = (source, searchQueryString)=>{
    const result = {
        id: '',
        label: '',
        timezone: '',
        startDate: '',
        endDate: '',
        // @ts-expect-error - TS2322 - Type '""' is not assignable to type '"d" | "m" | "h" | "w"'.
        searchBy: '',
        axisLabels: [],
        chartSeries: [],
        isPercentage: false,
        yAxisMinMax: {}
    };
    result.id = source.reportId;
    result.label = source.name;
    result.timezone = source.timezone;
    try {
        result.startDate = (0, $V3NN5.formatDateISO)(source.startTime, source.timezone);
        result.endDate = (0, $V3NN5.formatDateISO)(source.endTime, source.timezone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $jcw0u.default)({
            meta: {
                id: 'formatChartData',
                packageName: 'jiraServicedeskReportsCommon',
                teamName: 'itsm-saga'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: err,
            attributes: {
                startDate: source.startTime,
                endDate: source.endTime,
                timezone: source.timezone
            }
        });
        throw err;
    }
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"8" | "9m"'.
    if ((0, $9nenm.MONTH_TIME_SCALES).includes(searchQueryString)) result.searchBy = (0, $9nenm.SEARCH_BY).monthly;
    else if ((0, $9nenm.WEEK_TIME_SCALES).includes(searchQueryString)) result.searchBy = (0, $9nenm.SEARCH_BY).weekly;
    else if ((0, $9nenm.HOUR_TIME_SCALES).includes(searchQueryString)) result.searchBy = (0, $9nenm.SEARCH_BY).hourly;
    else result.searchBy = (0, $9nenm.SEARCH_BY).daily;
    return result;
};
const $6fa57c5281275469$export$a1b7447ceadada1e = (source, searchParams, intl)=>{
    const searchQueryString = $6fa57c5281275469$export$a0a0756dadf12882(searchParams.timescaleId) ? `${searchParams.timescaleId}${searchParams.timeBreakdown || ''}` : `${searchParams.timescaleId}`;
    const result = $6fa57c5281275469$var$formatChartData(source, searchQueryString);
    result.yAxisMinMax = (0, $cnldZ.getYAxisMinMax)(source);
    const formatter = (0, $cnldZ.getValueFormatter)(source);
    // map source series to chart Item series
    const chartItems = source.series.map((s, seriesIndex)=>({
            type: (0, $9nenm.LINE),
            seriesIndex: seriesIndex,
            seriesId: s.seriesId,
            name: s.label,
            summaryValue: formatter(s.seriesSummaryValue),
            itemStyle: {
                color: (0, $8npOo.dynamicColorToToken)(s.color),
                borderWidth: 2,
                shadowColor: (0, $8npOo.dynamicColorToToken)(s.color)
            },
            showAllSymbol: true,
            emphasis: {
                itemStyle: {
                    borderColor: (0, $8npOo.dynamicColorToToken)(s.color),
                    shadowColor: (0, $8npOo.dynamicColorToToken)(s.color),
                    borderWidth: 7,
                    shadowBlur: 0
                }
            },
            symbolSize: 9,
            data: s.data.map(({ x: x, y: y }, dataIndex)=>({
                    id: x,
                    seriesId: s.seriesId,
                    seriesIndex: seriesIndex,
                    dataIndex: dataIndex,
                    label: (0, $V3NN5.getLabel)(x, source.timezone, searchQueryString, intl),
                    ...formatter(y),
                    ...(0, $V3NN5.getMetaData)(x, source.timezone, searchQueryString, intl)
                }))
        }));
    // @ts-expect-error - TS2322 - Type '{ type: string; seriesIndex: number; seriesId: string; name: string; summaryValue: YAxisData; itemStyle: { color: string; borderWidth: number; shadowColor: string; }; showAllSymbol: boolean; emphasis: { ...; }; symbolSize: number; data: { ...; }[]; }[]' is not assignable to type 'Series[]'.
    result.chartSeries = chartItems;
    result.taskId = source.taskId;
    if (chartItems.length > 0) result.axisLabels = chartItems[0].data.map(({ label: label })=>label);
    return result;
};
const $6fa57c5281275469$export$ca4cf779304602d7 = (source, searchParams, intl)=>{
    const searchQueryString = $6fa57c5281275469$export$a0a0756dadf12882(searchParams.timescaleId) ? `${searchParams.timescaleId}${searchParams.timeBreakdown || ''}` : `${searchParams.timescaleId}`;
    const result = $6fa57c5281275469$var$formatChartData(source, searchQueryString);
    result.isPercentage = (0, $cnldZ.isPercentageChart)(source);
    result.yAxisMinMax = (0, $cnldZ.getYAxisMinMax)(source);
    const formatter = (0, $cnldZ.getValueFormatter)(source);
    // map source series to chart Item series
    const chartItems = source.series.map((s, seriesIndex)=>({
            type: (0, $9nenm.LINE),
            // @ts-expect-error - TS2339 - Property 'seriesType' does not exist on type 'SeriesEntity'.
            typeKey: s.seriesType.typeKey,
            seriesIndex: seriesIndex,
            seriesId: s.seriesId,
            name: s.label,
            summaryValue: formatter(s.seriesSummaryValue),
            itemStyle: {
                color: (0, $8npOo.dynamicColorToToken)(s.color),
                borderWidth: 2,
                shadowColor: (0, $8npOo.dynamicColorToToken)(s.color)
            },
            showAllSymbol: true,
            emphasis: {
                itemStyle: {
                    borderColor: (0, $8npOo.dynamicColorToToken)(s.color),
                    shadowColor: (0, $8npOo.dynamicColorToToken)(s.color),
                    borderWidth: 7,
                    shadowBlur: 0
                }
            },
            symbolSize: 9,
            data: s.data.map(({ x: x, y: y }, dataIndex)=>({
                    id: x,
                    seriesId: s.seriesId,
                    seriesIndex: seriesIndex,
                    dataIndex: dataIndex,
                    label: (0, $V3NN5.getLabel)(x, source.timezone, searchQueryString, intl),
                    ...formatter(y),
                    ...(0, $V3NN5.getMetaData)(x, source.timezone, searchQueryString, intl)
                })),
            markLine: (0, $cnldZ.getTargetMarkLine)(source),
            // @ts-expect-error - TS2339 - Property 'seriesType' does not exist on type 'SeriesEntity'.
            seriesType: s.seriesType
        }));
    // @ts-expect-error - TS2322 - Type '{ type: string; typeKey: any; seriesIndex: number; seriesId: string; name: string; summaryValue: YAxisData; itemStyle: { color: string; borderWidth: number; shadowColor: string; }; showAllSymbol: boolean; ... 4 more ...; seriesType: any; }[]' is not assignable to type 'Series[]'.
    result.chartSeries = chartItems;
    result.target = source.target;
    if (chartItems.length > 0) result.axisLabels = chartItems[0].data.map(({ label: label })=>label);
    result.taskId = source.taskId;
    return result;
};

});
parcelRegister("8npOo", function(module, exports) {

$parcel$export(module.exports, "dynamicColorToToken", () => $3d4e9fa54280eebb$export$6429b014bf18a94b);

var $kh4KP = parcelRequire("kh4KP");

var $jcw0u = parcelRequire("jcw0u");
const $3d4e9fa54280eebb$export$6429b014bf18a94b = (color, isCanvas = true)=>{
    switch(color){
        case '#d04437':
            return isCanvas ? (0, $kh4KP.default)('color.chart.red.bolder', '#d04437') : "var(--ds-chart-red-bolder, #d04437)";
        // ADG_RED
        case '#e7a19B':
            return isCanvas ? (0, $kh4KP.default)('color.chart.red.bold', '#e7a19B') : "var(--ds-chart-red-bold, #e7a19B)";
        // ADG_HALF_RED
        case '#14892c':
            return isCanvas ? (0, $kh4KP.default)('color.chart.green.bolder', '#14892c') : "var(--ds-chart-green-bolder, #14892c)";
        // ADG_GREEN
        case '#89c495':
            return isCanvas ? (0, $kh4KP.default)('color.chart.green.bold', '#89c495') : "var(--ds-chart-green-bold, #89c495)";
        // ADG_HALF_GREEN
        case '#815b3a':
            return isCanvas ? (0, $kh4KP.default)('color.chart.yellow.bolder', '#815b3a') : "var(--ds-chart-yellow-bolder, #815b3a)";
        // ADG_BROWN
        case '#c0ad9c':
            return isCanvas ? (0, $kh4KP.default)('color.chart.yellow.bold', '#c0ad9c') : "var(--ds-chart-yellow-bold, #c0ad9c)";
        // ADG_HALF_BROWN
        case '#ea632b':
            return isCanvas ? (0, $kh4KP.default)('color.chart.orange.bolder', '#ea632b') : "var(--ds-chart-orange-bolder, #ea632b)";
        // ADG_ORANGE
        case '#f8d0ab':
            return isCanvas ? (0, $kh4KP.default)('color.chart.orange.bold', '#f8d0ab') : "var(--ds-chart-orange-bold, #f8d0ab)";
        // ADG_HALF_ORANGE
        case '#d39c3f':
            return isCanvas ? (0, $kh4KP.default)('color.chart.orange.boldest', '#d39c3f') : "var(--ds-chart-orange-boldest, #d39c3f)";
        // ADG_LIGHT_BROWN
        case '#e9cd9f':
            return isCanvas ? (0, $kh4KP.default)('color.chart.yellow.boldest', '#e9cd9f') : "var(--ds-chart-yellow-boldest, #e9cd9f)";
        // ADG_HALF_LIGHT_BROWN
        case '#8eb021':
            return isCanvas ? (0, $kh4KP.default)('color.chart.green.boldest', '#8eb021') : "var(--ds-chart-green-boldest, #8eb021)";
        // ADG_LIME_GREEN
        case '#c6d790':
            return isCanvas ? (0, $kh4KP.default)('color.chart.green.bold', '#c6d790') : "var(--ds-chart-green-bold, #c6d790)";
        // ADG_HALF_LIME_GREEN
        case '#ac707a':
            return isCanvas ? (0, $kh4KP.default)('color.chart.red.boldest', '#ac707a') : "var(--ds-chart-red-boldest, #ac707a)";
        // ADG_MAUVE
        case '#d5b7bc':
            return isCanvas ? (0, $kh4KP.default)('color.chart.red.bolder.hovered', '#d5b7bc') : "var(--ds-chart-red-bolder-hovered, #d5b7bc)";
        // ADG_HALF_MAUVE
        case '#654982':
            return isCanvas ? (0, $kh4KP.default)('color.chart.purple.bolder', '#654982') : "var(--ds-chart-purple-bolder, #654982)";
        // ADG_VIOLET
        case '#b2a4c0':
            return isCanvas ? (0, $kh4KP.default)('color.chart.purple.bold', '#b2a4c0') : "var(--ds-chart-purple-bold, #b2a4c0)";
        // ADG_HALF_VIOLET
        case '#7bc1a1':
            return isCanvas ? (0, $kh4KP.default)('color.chart.green.bolder', '#7bc1a1') : "var(--ds-chart-green-bolder, #7bc1a1)";
        // ADG_EMERALD
        case '#bde0d0':
            return isCanvas ? (0, $kh4KP.default)('color.chart.green.bold', '#bde0d0') : "var(--ds-chart-green-bold, #bde0d0)";
        // ADG_HALF_EMERALD
        case '#f15c75':
            return isCanvas ? (0, $kh4KP.default)('color.chart.magenta.bolder', '#f15c75') : "var(--ds-chart-magenta-bolder, #f15c75)";
        // ADG_BRIGHT_PINK
        case '#fac8d8':
            return isCanvas ? (0, $kh4KP.default)('color.chart.magenta.bold', '#fac8d8') : "var(--ds-chart-magenta-bold, #fac8d8)";
        // ADG_HALF_BRIGHT_PINK
        case '#59afe1':
            return isCanvas ? (0, $kh4KP.default)('color.chart.teal.bolder', '#59afe1') : "var(--ds-chart-teal-bolder, #59afe1)";
        // ADG_CYAN
        case '#acd7f0':
            return isCanvas ? (0, $kh4KP.default)('color.chart.teal.bold', '#acd7f0') : "var(--ds-chart-teal-bold, #acd7f0)";
        // ADG_HALF_CYAN
        case '#333':
            return isCanvas ? (0, $kh4KP.default)('color.chart.gray.bolder', '#333') : "var(--ds-chart-gray-bolder, #333)";
        // ADG_CHARCOAL
        case '#999':
            return isCanvas ? (0, $kh4KP.default)('color.chart.gray.bold', '#999') : "var(--ds-chart-gray-bold, #999)";
        // ADG_HALF_CHARCOAL
        case '#3572b0':
            return isCanvas ? (0, $kh4KP.default)('color.chart.blue.bolder', '#3572b0') : "var(--ds-chart-blue-bolder, #3572b0)";
        // ADG_BLUE
        case '#84bbc6':
            return isCanvas ? (0, $kh4KP.default)('color.chart.blue.bold', '#84bbc6') : "var(--ds-chart-blue-bold, #84bbc6)";
        // ADG_COOL_BLUE
        case '#67ab49':
            return isCanvas ? (0, $kh4KP.default)('color.chart.green.boldest', '#67ab49') : "var(--ds-chart-green-boldest, #67ab49)";
        // ADG_MID_GREEN
        default:
            (0, $jcw0u.default)({
                meta: {
                    id: 'dynamicColorToToken',
                    packageName: 'jiraServicedeskReportsCommon',
                    teamName: 'itsm-saga'
                },
                attributes: {
                    color: color
                }
            });
            return color;
    }
};

});

parcelRegister("V3NN5", function(module, exports) {

$parcel$export(module.exports, "getLabel", () => $a1ecb66eda455221$export$236350842f3cd9bc);
$parcel$export(module.exports, "getMetaData", () => $a1ecb66eda455221$export$929b5cc2a4ac0922);
$parcel$export(module.exports, "formatDateISO", () => $a1ecb66eda455221$export$70d0d14fb4385eaf);

var $dwDIK = parcelRequire("dwDIK");
var $7CMcV = parcelRequire("7CMcV");

var $9nenm = parcelRequire("9nenm");
const $a1ecb66eda455221$var$formatDateWithInternationalisation = (intl, utcTimestamp, timezone, formatOps)=>{
    const options = {
        ...formatOps,
        timeZone: timezone
    };
    return intl.formatDate(utcTimestamp, options);
};
const $a1ecb66eda455221$export$236350842f3cd9bc = (utcTimestamp, timezone, searchQueryString, intl)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 1: { readonly weekday: "short"; readonly hour: "numeric"; readonly hour12: true; }; readonly 2: { readonly day: "numeric"; readonly month: "short"; }; readonly 3: { readonly day: "numeric"; readonly month: "short"; }; ... 8 more ...; readonly "9m": { ...; }; }'.
    const formatType = (0, $9nenm.TIME_SCALE_TO_LABEL_FORMAT_MAP)[searchQueryString];
    return $a1ecb66eda455221$var$formatDateWithInternationalisation(intl, utcTimestamp, timezone, formatType);
};
const $a1ecb66eda455221$export$929b5cc2a4ac0922 = (utcTimestamp, timezone, searchQueryString, intl)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 1: { readonly weekday: "long"; readonly hour: "numeric"; readonly hour12: true; }; readonly 2: { readonly weekday: "long"; readonly day: "numeric"; readonly month: "long"; readonly year: "numeric"; }; ... 9 more ...; readonly "9m": { ...; }; }'.
    const formatType = (0, $9nenm.TIME_SCALE_TO_ACCESS_POINT_FORMAT_MAP)[searchQueryString];
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 1: { readonly day: "numeric"; readonly month: "short"; readonly year: "numeric"; readonly hour: "numeric"; readonly minute: "numeric"; readonly hour12: true; }; readonly 2: { readonly day: "numeric"; readonly month: "short"; readonly year: "numeric"; }; ... 9 more ...; readonly "9m": { ...; }; }'.
    const expandedFormatType = (0, $9nenm.TIME_SCALE_TO_EXPANDED_FORMAT_MAP)[searchQueryString];
    return {
        formattedDate: `${$a1ecb66eda455221$var$formatDateWithInternationalisation(intl, utcTimestamp, timezone, formatType)}`,
        expandedDate: `${$a1ecb66eda455221$var$formatDateWithInternationalisation(intl, utcTimestamp, timezone, expandedFormatType)}`
    };
};
const $a1ecb66eda455221$export$70d0d14fb4385eaf = (utcTimestamp, timezone)=>(0, $dwDIK.default)((0, $7CMcV.default)(utcTimestamp, timezone), (0, $9nenm.ISO_DATE_FORMAT), {
        timeZone: timezone
    });

});

parcelRegister("cnldZ", function(module, exports) {

$parcel$export(module.exports, "getFormattedLabel", () => $2da17c9210f90187$export$73d65be4271316b7);
$parcel$export(module.exports, "getYAxisMinMax", () => $2da17c9210f90187$export$6ee7d486ec3c7c13);
$parcel$export(module.exports, "getValueFormatter", () => $2da17c9210f90187$export$f037bf6aad5a4e75);
$parcel$export(module.exports, "isPercentageType", () => $2da17c9210f90187$export$dc62ac670e083e7f);
$parcel$export(module.exports, "isPercentageChart", () => $2da17c9210f90187$export$b76b4efc5e57034a);
$parcel$export(module.exports, "createMarkLine", () => $2da17c9210f90187$export$6d48878d5c505874);
$parcel$export(module.exports, "getTargetMarkLine", () => $2da17c9210f90187$export$d0f6b554d3bfbf7c);

var $fEeCa = parcelRequire("fEeCa");

var $gwejS = parcelRequire("gwejS");
var $7XUeK = parcelRequire("7XUeK");
var $3DR3e = parcelRequire("3DR3e");
var $4s7ll = parcelRequire("4s7ll");


var $kh4KP = parcelRequire("kh4KP");

var $1p96B = parcelRequire("1p96B");

var $bHMD8 = parcelRequire("bHMD8");

var $dRNTN = parcelRequire("dRNTN");
const $2da17c9210f90187$var$minimumInterval = 5;
const $2da17c9210f90187$var$fiveMinutesInMilliSeconds = (0, $4s7ll.default)($2da17c9210f90187$var$minimumInterval);
const $2da17c9210f90187$export$a7575cf0cdf968c5 = (value)=>({
        yAxisValue: value,
        value: (0, $1p96B.floatDifferenceOfDates)(new Date(value), new Date(0), 'months').toFixed((0, $bHMD8.TYPE_TIME_DECIMAL_PLACES)).toString(),
        valueType: (0, $bHMD8.VALUE_TYPES).months
    });
const $2da17c9210f90187$export$7677066daa99156a = (value)=>({
        yAxisValue: value,
        value: (0, $1p96B.floatDifferenceOfDates)(new Date(value), new Date(0), 'days').toFixed((0, $bHMD8.TYPE_TIME_DECIMAL_PLACES)).toString(),
        valueType: (0, $bHMD8.VALUE_TYPES).days
    });
const $2da17c9210f90187$export$537b2b4658db7016 = (value)=>({
        yAxisValue: value,
        value: (0, $1p96B.floatDifferenceOfDates)(new Date(value), new Date(0), 'hours').toFixed((0, $bHMD8.TYPE_TIME_DECIMAL_PLACES)).toString(),
        valueType: (0, $bHMD8.VALUE_TYPES).hours
    });
const $2da17c9210f90187$export$c0ceab4d963647f5 = (value)=>({
        yAxisValue: value,
        value: (0, $1p96B.floatDifferenceOfDates)(new Date(value), new Date(0), 'minutes').toFixed((0, $bHMD8.TYPE_TIME_DECIMAL_PLACES)).toString(),
        valueType: (0, $bHMD8.VALUE_TYPES).minutes
    });
const $2da17c9210f90187$export$8aab500945125417 = (value)=>({
        yAxisValue: value,
        value: value.toFixed((0, $bHMD8.TYPE_STAR_DECIMAL_PLACES)),
        valueType: ''
    });
const $2da17c9210f90187$export$3e1eee59f5dc52be = (value)=>({
        yAxisValue: value,
        value: (value * 100).toFixed((0, $bHMD8.TYPE_PERCENTAGE_DECIMAL_PLACES)),
        valueType: (0, $bHMD8.VALUE_TYPES).percentage
    });
const $2da17c9210f90187$export$ac7aad1fd2ffc519 = (value)=>({
        yAxisValue: value,
        value: value.toString(),
        valueType: ''
    });
const $2da17c9210f90187$export$978ad5764137b5ad = (source)=>{
    const eachSeriesMaxValues = source.series.map(({ data: data })=>(0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(data.map(({ y: y })=>y)));
    // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
    return (0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(eachSeriesMaxValues);
};
const $2da17c9210f90187$export$73d65be4271316b7 = (type, value, formatMessage)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ percentage: MessageDescriptorV2; minutes: MessageDescriptorV2; hours: MessageDescriptorV2; days: MessageDescriptorV2; months: MessageDescriptorV2; }'.
    if ((0, $dRNTN.default)[type]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ percentage: MessageDescriptorV2; minutes: MessageDescriptorV2; hours: MessageDescriptorV2; days: MessageDescriptorV2; months: MessageDescriptorV2; }'.
    return `${value} ${formatMessage((0, $dRNTN.default)[type])}`;
    return value;
};
const $2da17c9210f90187$export$d039bddcd4b404fc = (maxYValue)=>{
    if (maxYValue > (0, $3DR3e.default)(new Date(0), 6).getTime()) return $2da17c9210f90187$export$a7575cf0cdf968c5;
    if (maxYValue > (0, $gwejS.default)(new Date(0), 30).getTime()) return $2da17c9210f90187$export$7677066daa99156a;
    if (maxYValue > (0, $7XUeK.default)(new Date(0), 2).getTime()) return $2da17c9210f90187$export$537b2b4658db7016;
    return $2da17c9210f90187$export$c0ceab4d963647f5;
};
const $2da17c9210f90187$export$4e29c52c0ab49da1 = (source)=>{
    if (source.series.length > 0) // all series in a report have the same y-axis type
    return source.series[0].yAxisType;
    return '';
};
const $2da17c9210f90187$export$6ee7d486ec3c7c13 = (source)=>{
    const yAxisType = $2da17c9210f90187$export$4e29c52c0ab49da1(source);
    let maxInterval;
    switch(yAxisType){
        case 0, $bHMD8.TYPE_TIME:
            {
                const maxYValue = $2da17c9210f90187$export$978ad5764137b5ad(source);
                if (maxYValue <= $2da17c9210f90187$var$fiveMinutesInMilliSeconds) maxInterval = $2da17c9210f90187$var$minimumInterval;
                return {
                    min: 0,
                    max: maxInterval
                };
            }
        case 0, $bHMD8.TYPE_PERCENTAGE:
            return {
                min: 0,
                max: 100
            };
        default:
            {
                const maxYValue = $2da17c9210f90187$export$978ad5764137b5ad(source);
                if (maxYValue <= $2da17c9210f90187$var$minimumInterval) maxInterval = $2da17c9210f90187$var$minimumInterval;
                return {
                    min: 0,
                    max: maxInterval
                };
            }
    }
};
const $2da17c9210f90187$export$f037bf6aad5a4e75 = (source)=>{
    const yAxisType = $2da17c9210f90187$export$4e29c52c0ab49da1(source);
    switch(yAxisType){
        case 0, $bHMD8.TYPE_TIME:
            {
                const maxYValue = $2da17c9210f90187$export$978ad5764137b5ad(source);
                return $2da17c9210f90187$export$d039bddcd4b404fc(maxYValue);
            }
        case 0, $bHMD8.TYPE_STAR:
            return $2da17c9210f90187$export$8aab500945125417;
        case 0, $bHMD8.TYPE_PERCENTAGE:
            return $2da17c9210f90187$export$3e1eee59f5dc52be;
        default:
            return $2da17c9210f90187$export$ac7aad1fd2ffc519;
    }
};
const $2da17c9210f90187$export$dc62ac670e083e7f = (type)=>type === (0, $bHMD8.PERCENTAGE_TYPE);
const $2da17c9210f90187$export$b76b4efc5e57034a = (source)=>// @ts-expect-error - TS2339 - Property 'seriesType' does not exist on type 'SeriesEntity'.
    source.series.some((_series)=>$2da17c9210f90187$export$dc62ac670e083e7f(_series.seriesType.yaxis.typeKey));
const $2da17c9210f90187$export$6d48878d5c505874 = (target)=>({
        label: {
            formatter: `${target}%`,
            color: (0, $kh4KP.default)('color.chart.neutral', (0, $5e0c0d4e15efb4a6$exports).N800)
        },
        silent: true,
        lineStyle: {
            color: (0, $kh4KP.default)('color.chart.neutral', (0, $5e0c0d4e15efb4a6$exports).N800)
        },
        animation: false,
        data: [
            {
                name: 'Target',
                yAxis: target
            }
        ]
    });
const $2da17c9210f90187$export$d0f6b554d3bfbf7c = (source)=>{
    if ($2da17c9210f90187$export$b76b4efc5e57034a(source) && source.target !== undefined && source.target !== 0) return $2da17c9210f90187$export$6d48878d5c505874(source.target);
    return undefined;
};

});
parcelRegister("fEeCa", function(module, exports) {

var $la2vn = parcelRequire("la2vn");

var $5JMmU = parcelRequire("5JMmU");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $b645ed9a7ba1767e$var$max(array) {
    return array && array.length ? $la2vn(array, $etyzk, $5JMmU) : undefined;
}
module.exports = $b645ed9a7ba1767e$var$max;

});
parcelRegister("la2vn", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $f67c7999c5b61dcb$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$4faK3(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $f67c7999c5b61dcb$var$baseExtremum;

});

parcelRegister("5JMmU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $42d6acb577163acc$var$baseGt(value, other) {
    return value > other;
}
module.exports = $42d6acb577163acc$var$baseGt;

});


var $5e0c0d4e15efb4a6$exports = {};

$parcel$export($5e0c0d4e15efb4a6$exports, "R50", () => $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd);
$parcel$export($5e0c0d4e15efb4a6$exports, "R75", () => $5e0c0d4e15efb4a6$export$b34b069eff244586);
$parcel$export($5e0c0d4e15efb4a6$exports, "R100", () => $5e0c0d4e15efb4a6$export$be802dd0d8b57f35);
$parcel$export($5e0c0d4e15efb4a6$exports, "R200", () => $5e0c0d4e15efb4a6$export$60847d42f9da92a6);
$parcel$export($5e0c0d4e15efb4a6$exports, "R300", () => $5e0c0d4e15efb4a6$export$4a7404f376229999);
$parcel$export($5e0c0d4e15efb4a6$exports, "R400", () => $5e0c0d4e15efb4a6$export$2010d0fb4295b346);
$parcel$export($5e0c0d4e15efb4a6$exports, "R500", () => $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y50", () => $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y75", () => $5e0c0d4e15efb4a6$export$41060a744ab0b7ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y100", () => $5e0c0d4e15efb4a6$export$1cc05bbbf340e559);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y200", () => $5e0c0d4e15efb4a6$export$5aae31392d72caaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y300", () => $5e0c0d4e15efb4a6$export$c6930421db9fa514);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y400", () => $5e0c0d4e15efb4a6$export$59619663aa6500fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y500", () => $5e0c0d4e15efb4a6$export$874739ea9e379ab6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G50", () => $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G75", () => $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b);
$parcel$export($5e0c0d4e15efb4a6$exports, "G100", () => $5e0c0d4e15efb4a6$export$afbce1382ec95f73);
$parcel$export($5e0c0d4e15efb4a6$exports, "G200", () => $5e0c0d4e15efb4a6$export$747d86715d4175de);
$parcel$export($5e0c0d4e15efb4a6$exports, "G300", () => $5e0c0d4e15efb4a6$export$940e1f69e873f202);
$parcel$export($5e0c0d4e15efb4a6$exports, "G400", () => $5e0c0d4e15efb4a6$export$a49394138f7b8e85);
$parcel$export($5e0c0d4e15efb4a6$exports, "G500", () => $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "B50", () => $5e0c0d4e15efb4a6$export$226de0355ed012f8);
$parcel$export($5e0c0d4e15efb4a6$exports, "B75", () => $5e0c0d4e15efb4a6$export$8c13c2ee36917869);
$parcel$export($5e0c0d4e15efb4a6$exports, "B100", () => $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a);
$parcel$export($5e0c0d4e15efb4a6$exports, "B200", () => $5e0c0d4e15efb4a6$export$215b7063051591f1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B300", () => $5e0c0d4e15efb4a6$export$e62e8919cca44969);
$parcel$export($5e0c0d4e15efb4a6$exports, "B400", () => $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64);
$parcel$export($5e0c0d4e15efb4a6$exports, "B500", () => $5e0c0d4e15efb4a6$export$a6ee3d71bc067634);
$parcel$export($5e0c0d4e15efb4a6$exports, "B600", () => $5e0c0d4e15efb4a6$export$67f15409e87642a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B700", () => $5e0c0d4e15efb4a6$export$f0539dbc42dbb067);
$parcel$export($5e0c0d4e15efb4a6$exports, "P50", () => $5e0c0d4e15efb4a6$export$363e4475840015bb);
$parcel$export($5e0c0d4e15efb4a6$exports, "P75", () => $5e0c0d4e15efb4a6$export$4b0a4417ed59760f);
$parcel$export($5e0c0d4e15efb4a6$exports, "P100", () => $5e0c0d4e15efb4a6$export$6011520a64d9a187);
$parcel$export($5e0c0d4e15efb4a6$exports, "P200", () => $5e0c0d4e15efb4a6$export$a7175d4e9206bc80);
$parcel$export($5e0c0d4e15efb4a6$exports, "P300", () => $5e0c0d4e15efb4a6$export$b48405b95304b5a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "P400", () => $5e0c0d4e15efb4a6$export$c71e4279dd54a18d);
$parcel$export($5e0c0d4e15efb4a6$exports, "P500", () => $5e0c0d4e15efb4a6$export$147899de772240ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "T50", () => $5e0c0d4e15efb4a6$export$2cf711fe14c66f06);
$parcel$export($5e0c0d4e15efb4a6$exports, "T75", () => $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c);
$parcel$export($5e0c0d4e15efb4a6$exports, "T100", () => $5e0c0d4e15efb4a6$export$776c9c497ef08533);
$parcel$export($5e0c0d4e15efb4a6$exports, "T200", () => $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e);
$parcel$export($5e0c0d4e15efb4a6$exports, "T300", () => $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b);
$parcel$export($5e0c0d4e15efb4a6$exports, "T400", () => $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8);
$parcel$export($5e0c0d4e15efb4a6$exports, "T500", () => $5e0c0d4e15efb4a6$export$6036577f95c3877e);
$parcel$export($5e0c0d4e15efb4a6$exports, "N0", () => $5e0c0d4e15efb4a6$export$29a4f05edc054374);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10", () => $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20", () => $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30", () => $5e0c0d4e15efb4a6$export$3e51e8f1440314ba);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40", () => $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50", () => $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60", () => $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70", () => $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80", () => $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90", () => $5e0c0d4e15efb4a6$export$7c87d337fb91a97d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100", () => $5e0c0d4e15efb4a6$export$d6447c357493214f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200", () => $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300", () => $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400", () => $5e0c0d4e15efb4a6$export$eece5f492e429f08);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500", () => $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600", () => $5e0c0d4e15efb4a6$export$7090862dc3038a9f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700", () => $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800", () => $5e0c0d4e15efb4a6$export$7d61b15e0da132af);
$parcel$export($5e0c0d4e15efb4a6$exports, "N900", () => $5e0c0d4e15efb4a6$export$fbda843f0a27fe96);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10A", () => $5e0c0d4e15efb4a6$export$791e57b27ca738ef);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20A", () => $5e0c0d4e15efb4a6$export$8d43898f60b96a82);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30A", () => $5e0c0d4e15efb4a6$export$920c0d5c49070351);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40A", () => $5e0c0d4e15efb4a6$export$46987b49aab6d1a8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50A", () => $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60A", () => $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70A", () => $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80A", () => $5e0c0d4e15efb4a6$export$59264b346c877fa7);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90A", () => $5e0c0d4e15efb4a6$export$d092757d7c64925c);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100A", () => $5e0c0d4e15efb4a6$export$486ab785e4bac3c6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200A", () => $5e0c0d4e15efb4a6$export$fba592bbc6419fea);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300A", () => $5e0c0d4e15efb4a6$export$13609db0e6812ab8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400A", () => $5e0c0d4e15efb4a6$export$fbae4efaa892d883);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500A", () => $5e0c0d4e15efb4a6$export$f13946d26f440ce6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600A", () => $5e0c0d4e15efb4a6$export$19f58225ac52a306);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700A", () => $5e0c0d4e15efb4a6$export$6384f09da70e7b62);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800A", () => $5e0c0d4e15efb4a6$export$d0dccc730683edc2);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN900", () => $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800", () => $5e0c0d4e15efb4a6$export$95126bc8884d6634);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700", () => $5e0c0d4e15efb4a6$export$8338d8c35d44ff1);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600", () => $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500", () => $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400", () => $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300", () => $5e0c0d4e15efb4a6$export$97e81faa16a182c7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200", () => $5e0c0d4e15efb4a6$export$bfe21c59123ecf33);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100", () => $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90", () => $5e0c0d4e15efb4a6$export$682927c6ed76be02);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80", () => $5e0c0d4e15efb4a6$export$91fd9994c5be9757);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70", () => $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60", () => $5e0c0d4e15efb4a6$export$3902c91d8b98a753);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50", () => $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40", () => $5e0c0d4e15efb4a6$export$33ff357f6620b39);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30", () => $5e0c0d4e15efb4a6$export$633847cf062b69e0);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20", () => $5e0c0d4e15efb4a6$export$9776a6e503bdbf76);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10", () => $5e0c0d4e15efb4a6$export$6c813d5160dff5db);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN0", () => $5e0c0d4e15efb4a6$export$3d4f271a500072a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800A", () => $5e0c0d4e15efb4a6$export$fe151285c22759ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700A", () => $5e0c0d4e15efb4a6$export$a101c6190d0da34);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600A", () => $5e0c0d4e15efb4a6$export$4b16f52932fda51);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500A", () => $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400A", () => $5e0c0d4e15efb4a6$export$9209c179316d1751);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300A", () => $5e0c0d4e15efb4a6$export$88f55133f636c8dd);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200A", () => $5e0c0d4e15efb4a6$export$51126f85d1009512);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100A", () => $5e0c0d4e15efb4a6$export$a069b547bd23af78);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90A", () => $5e0c0d4e15efb4a6$export$40cce05af3b2600a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80A", () => $5e0c0d4e15efb4a6$export$b78942185925a0d);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70A", () => $5e0c0d4e15efb4a6$export$e058fb44b8eaafca);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60A", () => $5e0c0d4e15efb4a6$export$92b0b8de26920c18);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50A", () => $5e0c0d4e15efb4a6$export$67564f7459d3fc9e);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40A", () => $5e0c0d4e15efb4a6$export$77868e1ca884ffa3);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30A", () => $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20A", () => $5e0c0d4e15efb4a6$export$f2a0acaab9972c70);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10A", () => $5e0c0d4e15efb4a6$export$9ab70e67d6475361);
$parcel$export($5e0c0d4e15efb4a6$exports, "T30", () => $5e0c0d4e15efb4a6$export$d2adc5dedf09fced);
$parcel$export($5e0c0d4e15efb4a6$exports, "L50", () => $5e0c0d4e15efb4a6$export$f51762073d2bb381);
$parcel$export($5e0c0d4e15efb4a6$exports, "L75", () => $5e0c0d4e15efb4a6$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd = '#FFEBE6';
const $5e0c0d4e15efb4a6$export$b34b069eff244586 = '#FFBDAD';
const $5e0c0d4e15efb4a6$export$be802dd0d8b57f35 = '#FF8F73';
const $5e0c0d4e15efb4a6$export$60847d42f9da92a6 = '#FF7452';
const $5e0c0d4e15efb4a6$export$4a7404f376229999 = '#FF5630';
const $5e0c0d4e15efb4a6$export$2010d0fb4295b346 = '#DE350B';
const $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02 = '#BF2600';
const $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf = '#FFFAE6';
const $5e0c0d4e15efb4a6$export$41060a744ab0b7ae = '#FFF0B3';
const $5e0c0d4e15efb4a6$export$1cc05bbbf340e559 = '#FFE380';
const $5e0c0d4e15efb4a6$export$5aae31392d72caaa = '#FFC400';
const $5e0c0d4e15efb4a6$export$c6930421db9fa514 = '#FFAB00';
const $5e0c0d4e15efb4a6$export$59619663aa6500fb = '#FF991F';
const $5e0c0d4e15efb4a6$export$874739ea9e379ab6 = '#FF8B00';
const $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b = '#ABF5D1';
const $5e0c0d4e15efb4a6$export$afbce1382ec95f73 = '#79F2C0';
const $5e0c0d4e15efb4a6$export$747d86715d4175de = '#57D9A3';
const $5e0c0d4e15efb4a6$export$940e1f69e873f202 = '#36B37E';
const $5e0c0d4e15efb4a6$export$a49394138f7b8e85 = '#00875A';
const $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb = '#006644';
const $5e0c0d4e15efb4a6$export$226de0355ed012f8 = '#DEEBFF';
const $5e0c0d4e15efb4a6$export$8c13c2ee36917869 = '#B3D4FF';
const $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5e0c0d4e15efb4a6$export$215b7063051591f1 = '#2684FF';
const $5e0c0d4e15efb4a6$export$e62e8919cca44969 = '#0065FF';
const $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64 = '#0052CC';
const $5e0c0d4e15efb4a6$export$a6ee3d71bc067634 = '#0747A6';
const $5e0c0d4e15efb4a6$export$67f15409e87642a1 = '#669DF1';
const $5e0c0d4e15efb4a6$export$f0539dbc42dbb067 = '#8FB8F6';
const $5e0c0d4e15efb4a6$export$363e4475840015bb = '#EAE6FF';
const $5e0c0d4e15efb4a6$export$4b0a4417ed59760f = '#C0B6F2';
const $5e0c0d4e15efb4a6$export$6011520a64d9a187 = '#998DD9';
const $5e0c0d4e15efb4a6$export$a7175d4e9206bc80 = '#8777D9';
const $5e0c0d4e15efb4a6$export$b48405b95304b5a1 = '#6554C0';
const $5e0c0d4e15efb4a6$export$c71e4279dd54a18d = '#5243AA';
const $5e0c0d4e15efb4a6$export$147899de772240ec = '#403294';
const $5e0c0d4e15efb4a6$export$2cf711fe14c66f06 = '#E6FCFF';
const $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5e0c0d4e15efb4a6$export$776c9c497ef08533 = '#79E2F2';
const $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e = '#00C7E6';
const $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b = '#00B8D9';
const $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8 = '#00A3BF';
const $5e0c0d4e15efb4a6$export$6036577f95c3877e = '#008DA6';
const $5e0c0d4e15efb4a6$export$29a4f05edc054374 = '#FFFFFF';
const $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5e0c0d4e15efb4a6$export$3e51e8f1440314ba = '#EBECF0';
const $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb = '#DFE1E6';
const $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b = '#B3BAC5';
const $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806 = '#97A0AF';
const $5e0c0d4e15efb4a6$export$7c87d337fb91a97d = '#8993A4';
const $5e0c0d4e15efb4a6$export$d6447c357493214f = '#7A869A';
const $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd = '#6B778C';
const $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1 = '#5E6C84';
const $5e0c0d4e15efb4a6$export$eece5f492e429f08 = '#505F79';
const $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae = '#42526E';
const $5e0c0d4e15efb4a6$export$7090862dc3038a9f = '#344563';
const $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa = '#253858';
const $5e0c0d4e15efb4a6$export$7d61b15e0da132af = '#172B4D';
const $5e0c0d4e15efb4a6$export$fbda843f0a27fe96 = '#091E42';
const $5e0c0d4e15efb4a6$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5e0c0d4e15efb4a6$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5e0c0d4e15efb4a6$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5e0c0d4e15efb4a6$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5e0c0d4e15efb4a6$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5e0c0d4e15efb4a6$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5e0c0d4e15efb4a6$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5e0c0d4e15efb4a6$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5e0c0d4e15efb4a6$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5e0c0d4e15efb4a6$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5e0c0d4e15efb4a6$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5e0c0d4e15efb4a6$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5e0c0d4e15efb4a6$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5e0c0d4e15efb4a6$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a = '#E6EDFA';
const $5e0c0d4e15efb4a6$export$95126bc8884d6634 = '#DCE5F5';
const $5e0c0d4e15efb4a6$export$8338d8c35d44ff1 = '#CED9EB';
const $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5e0c0d4e15efb4a6$export$97e81faa16a182c7 = '#8C9CB8';
const $5e0c0d4e15efb4a6$export$bfe21c59123ecf33 = '#7988A3';
const $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558 = '#67758F';
const $5e0c0d4e15efb4a6$export$682927c6ed76be02 = '#56637A';
const $5e0c0d4e15efb4a6$export$91fd9994c5be9757 = '#455166';
const $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6 = '#3B475C';
const $5e0c0d4e15efb4a6$export$3902c91d8b98a753 = '#313D52';
const $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5 = '#283447';
const $5e0c0d4e15efb4a6$export$33ff357f6620b39 = '#202B3D';
const $5e0c0d4e15efb4a6$export$633847cf062b69e0 = '#1B2638';
const $5e0c0d4e15efb4a6$export$9776a6e503bdbf76 = '#121A29';
const $5e0c0d4e15efb4a6$export$6c813d5160dff5db = '#0E1624';
const $5e0c0d4e15efb4a6$export$3d4f271a500072a = '#0D1424';
const $5e0c0d4e15efb4a6$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5e0c0d4e15efb4a6$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5e0c0d4e15efb4a6$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5e0c0d4e15efb4a6$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5e0c0d4e15efb4a6$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5e0c0d4e15efb4a6$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5e0c0d4e15efb4a6$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5e0c0d4e15efb4a6$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5e0c0d4e15efb4a6$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5e0c0d4e15efb4a6$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5e0c0d4e15efb4a6$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5e0c0d4e15efb4a6$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5e0c0d4e15efb4a6$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5e0c0d4e15efb4a6$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5e0c0d4e15efb4a6$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5e0c0d4e15efb4a6$export$d2adc5dedf09fced = '#292A2E';
const $5e0c0d4e15efb4a6$export$f51762073d2bb381 = '#94C748';
const $5e0c0d4e15efb4a6$export$95e26d54def96891 = '#B3DF72';

parcelRegister("bHMD8", function(module, exports) {

$parcel$export(module.exports, "TYPE_TIME", () => $2c24ef97c7f09ac1$export$65ca97a2a68797a8);
$parcel$export(module.exports, "TYPE_STAR", () => $2c24ef97c7f09ac1$export$cd717bf7d618e43a);
$parcel$export(module.exports, "TYPE_PERCENTAGE", () => $2c24ef97c7f09ac1$export$ddba3ac5dec72a9);
$parcel$export(module.exports, "TYPE_TIME_DECIMAL_PLACES", () => $2c24ef97c7f09ac1$export$ffd1712c506d054d);
$parcel$export(module.exports, "TYPE_STAR_DECIMAL_PLACES", () => $2c24ef97c7f09ac1$export$2ce8e14b52da595f);
$parcel$export(module.exports, "TYPE_PERCENTAGE_DECIMAL_PLACES", () => $2c24ef97c7f09ac1$export$1c3fcfa5fdf9d3c1);
$parcel$export(module.exports, "VALUE_TYPES", () => $2c24ef97c7f09ac1$export$b58fc909dae49e21);
$parcel$export(module.exports, "PERCENTAGE_TYPE", () => $2c24ef97c7f09ac1$export$ed6b492cc720ae5d);
const $2c24ef97c7f09ac1$export$8b6962479fda3507 = 'count';
const $2c24ef97c7f09ac1$export$65ca97a2a68797a8 = 'time';
const $2c24ef97c7f09ac1$export$cd717bf7d618e43a = 'star';
const $2c24ef97c7f09ac1$export$ddba3ac5dec72a9 = 'percentage';
const $2c24ef97c7f09ac1$export$ffd1712c506d054d = 2;
const $2c24ef97c7f09ac1$export$2ce8e14b52da595f = 2;
const $2c24ef97c7f09ac1$export$1c3fcfa5fdf9d3c1 = 1;
const $2c24ef97c7f09ac1$export$b58fc909dae49e21 = {
    months: 'months',
    days: 'days',
    hours: 'hours',
    minutes: 'minutes',
    percentage: 'percentage'
};
const $2c24ef97c7f09ac1$export$ed6b492cc720ae5d = 'sd.report.axis.type.percentage';

});

parcelRegister("dRNTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $08ee6c450b14c24c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $08ee6c450b14c24c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    months: {
        "id": "servicedesk-reports-common.common.summary.utils.months",
        "defaultMessage": "mths"
    },
    days: {
        "id": "servicedesk-reports-common.common.summary.utils.days",
        "defaultMessage": "days"
    },
    hours: {
        "id": "servicedesk-reports-common.common.summary.utils.hours",
        "defaultMessage": "hrs"
    },
    minutes: {
        "id": "servicedesk-reports-common.common.summary.utils.minutes",
        "defaultMessage": "mins"
    },
    percentage: {
        "id": "servicedesk-reports-common.common.summary.utils.percentage",
        "defaultMessage": "%"
    }
});

});



parcelRegister("88d59", function(module, exports) {

$parcel$export(module.exports, "REPORT_DEFAULTS", () => $744e80a5920da16a$export$27f8e5cdbed7aefe);

var $9nenm = parcelRequire("9nenm");
const $744e80a5920da16a$export$27f8e5cdbed7aefe = {
    searchByPastSevenDays: (0, $9nenm.TIME_SCALES).past7Days,
    timeBreakdown: (0, $9nenm.SEARCH_BY).daily
};

});


parcelRegister("39vSm", function(module, exports) {

$parcel$export(module.exports, "updateDateFilterQuery", () => (parcelRequire("lx5Ct")).updateDateFilterQuery);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $lx5Ct = parcelRequire("lx5Ct");

});
parcelRegister("lx5Ct", function(module, exports) {

$parcel$export(module.exports, "updateDateFilterQuery", () => $7e08aeb11b8142dd$export$5c7c5a53ea53e72);
const $7e08aeb11b8142dd$export$5c7c5a53ea53e72 = (data)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            dateFilterQuery: data
        });
    };

});



parcelRegister("4Kc9u", function(module, exports) {

$parcel$export(module.exports, "KbRequestsReportsMain", () => $77287e1a038c2402$export$45bad0bbfe683de8);

var $5uXOq = parcelRequire("5uXOq");

var $4cWVb = parcelRequire("4cWVb");

var $9nTS2 = parcelRequire("9nTS2");
const $77287e1a038c2402$export$45bad0bbfe683de8 = (props)=>{
    const resources = (0, $4cWVb.default)(props);
    // @ts-expect-error - TS2322 - Type '{ summaryResource: Provider<ChartData>; drilldownResource: Provider<RequestsResponse>; baseUrl: string; projectKey: string; routerProps: RouterProps; intl: IntlShapeV2; }' is not assignable to type 'CommonProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nTS2.default), {
        ...props,
        ...resources
    });
};

});
parcelRegister("4cWVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $48770cfc9ecf9606$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $f3VcY = parcelRequire("f3VcY");

var $b6q3N = parcelRequire("b6q3N");

var $9nenm = parcelRequire("9nenm");

var $bvS9p = parcelRequire("bvS9p");

var $aiZK8 = parcelRequire("aiZK8");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48770cfc9ecf9606$var$onSummaryError = (error)=>{
    (0, $jcw0u.trackFetchErrors)({
        error: error,
        id: 'fetchKbRequestsSummary',
        packageName: 'jiraServicedeskKbRequestsReports',
        sendToPrivacyUnsafeSplunk: true
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48770cfc9ecf9606$var$onDrillDownError = (error)=>{
    (0, $jcw0u.trackFetchErrors)({
        error: error,
        id: 'fetchKbRequestsDrilldown',
        packageName: 'jiraServicedeskKbRequestsReports',
        sendToPrivacyUnsafeSplunk: true
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48770cfc9ecf9606$export$2e2bcd8739ae039 = ({ baseUrl: baseUrl, routerProps: routerProps, projectKey: projectKey, onFetchDrillDown: // @ts-expect-error - TS2339 - Property 'onFetchDrillDown' does not exist on type 'ReportAppProps'.
onFetchDrillDown = (0, $aiZK8.get), onFetchSummary: // @ts-expect-error - TS2339 - Property 'onFetchSummary' does not exist on type 'ReportAppProps'.
onFetchSummary = (0, $b6q3N.default), transformSummarySource: // @ts-expect-error - TS2339 - Property 'transformSummarySource' does not exist on type 'ReportAppProps'.
transformSummarySource = (0, $bvS9p.transformSummarySource) })=>{
    const { reportId: reportId } = routerProps;
    const intl = (0, $koVbs.default)();
    const transformKbSource = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'source' implicitly has an 'any' type.
    (source)=>transformSummarySource(source, {
            timescaleId: Number(routerProps.timescaleId !== undefined ? routerProps.timescaleId : (0, $9nenm.TIME_SCALES).past7Days),
            timeBreakdown: routerProps.timeBreakdown
        }, intl), // Can include `intl` in dependency after https://jdog.jira-dev.com/browse/JFP-3184
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        routerProps.timeBreakdown,
        routerProps.timescaleId,
        transformSummarySource
    ]);
    const summaryResource = (0, $f3VcY.default)({
        baseUrl: baseUrl,
        projectKey: projectKey,
        onFetch: onFetchSummary,
        initialLoadingState: true,
        // @ts-expect-error - TS2322 - Type '(error: any) => void' is not assignable to type '(arg1?: any) => Promise<undefined> | undefined'.
        onError: $48770cfc9ecf9606$var$onSummaryError,
        onTransformSource: transformKbSource
    });
    const drilldownResource = (0, $f3VcY.default)({
        baseUrl: baseUrl,
        projectKey: projectKey,
        onFetch: onFetchDrillDown,
        initialLoadingState: false,
        // @ts-expect-error - TS2322 - Type '(error: any) => void' is not assignable to type '(arg1?: any) => Promise<undefined> | undefined'.
        onError: $48770cfc9ecf9606$var$onDrillDownError
    });
    const { resetProvider: resetSummaryProvider } = summaryResource;
    const { resetProvider: resetDrillDownProvider } = drilldownResource;
    (0, $5uXOq.useEffect)(()=>{
        resetSummaryProvider();
        resetDrillDownProvider();
    }, [
        reportId,
        resetSummaryProvider,
        resetDrillDownProvider
    ]);
    return {
        summaryResource: summaryResource,
        drilldownResource: drilldownResource
    };
};

});
parcelRegister("f3VcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f86d55196972d87$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $disyi = parcelRequire("disyi");

var $32TkL = parcelRequire("32TkL");
/**
 * PaginationProvider maintains pagination state
 * onQuery change this provider verifies whether any data present in state
 * if relevant data exist in state this hook will pass down page Data to child components
 * if data doesn't exist it will make a fetch request to pull down relevant values and then update state
 * pageData - holds current page data
 * pageCache - maintains state/cache
 */ const $6f86d55196972d87$var$usePaginationProvider = ({ baseUrl: baseUrl, projectKey: projectKey, onFetch: onFetch, cache: cache, onError: onError, onTransformSource: onTransformSource, initialLoadingState: // In case the resource is not included in SSR, this should be true so that the ssr paint includes the spinner
initialLoadingState = false })=>{
    const { colorMode: colorMode } = (0, $disyi.default)();
    const [loading, setLoading] = (0, $5uXOq.useState)(initialLoadingState);
    const [error, setError] = (0, $5uXOq.useState)();
    // current page data
    const [pageData, setPageData] = (0, $5uXOq.useState)();
    // source/collection of all previous pages data
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [pageCache, updatePageCache] = (0, $5uXOq.useState)(cache || new Map());
    // ref to abort stale fetch request's
    const abortController = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getCacheKey = (request)=>{
        const queryString = (0, $ebyGx.stringify)({
            ...request
        });
        return queryString;
    };
    const transformPageData = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (response)=>{
        const transformedPageData = onTransformSource ? onTransformSource(response) : response;
        setPageData(transformedPageData);
        setLoading(false);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onTransformSource,
        colorMode
    ]);
    const getPageDataFromCache = (0, $5uXOq.useCallback)((key)=>pageCache.get(key), [
        pageCache
    ]);
    // compare state and fetch / update if necessary
    const compareStateAndFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (request)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (abortController.current?.abort) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        abortController.current.abort();
        if (!request) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        const queryKey = getCacheKey(request);
        const cachedData = getPageDataFromCache(queryKey);
        if (cachedData) transformPageData(cachedData);
        else try {
            abortController.current = new AbortController();
            const response = await onFetch({
                ...request,
                baseUrl: baseUrl,
                projectKey: projectKey,
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                signal: abortController.current.signal
            });
            // @ts-expect-error - TS7006 - Parameter 'prev' implicitly has an 'any' type.
            updatePageCache((prev)=>prev.set(queryKey, response));
            transformPageData(response);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // The previous request is aborted. We don't need to send error.
            if (err?.code === (0, $32TkL.ABORT_ERR)) return;
            // To prevent error logging for users running very old versions of Chrome
            const isAbortControllerReferenceError = err?.name === 'ReferenceError' && err?.message?.includes('AbortController');
            if (!isAbortControllerReferenceError) onError(err);
            setError(err.message);
            setPageData(undefined);
            setLoading(false);
        }
    }, [
        baseUrl,
        getPageDataFromCache,
        onError,
        onFetch,
        projectKey,
        transformPageData
    ]);
    // on user action - query/page-number change
    const fetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (requestQuery)=>{
        compareStateAndFetch(requestQuery);
    }, [
        compareStateAndFetch
    ]);
    const clearCache = (0, $5uXOq.useCallback)(()=>{
        // @ts-expect-error - TS7006 - Parameter 'prev' implicitly has an 'any' type.
        updatePageCache((prev)=>{
            prev.clear();
            return prev;
        });
    }, []);
    const resetProvider = (0, $5uXOq.useCallback)(()=>{
        setLoading(true);
        setError(undefined);
        setPageData(undefined);
        clearCache();
    }, [
        clearCache
    ]);
    // clear Cache on un-mount
    (0, $5uXOq.useEffect)(()=>()=>{
            clearCache();
        }, [
        clearCache,
        updatePageCache
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string | undefined'.
        error,
        // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'T | undefined'.
        data: pageData,
        fetch: fetch,
        resetProvider: resetProvider
    };
};
var $6f86d55196972d87$export$2e2bcd8739ae039 = $6f86d55196972d87$var$usePaginationProvider;

});

parcelRegister("b6q3N", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f270205a1a437e$export$2e2bcd8739ae039);

var $aBmRh = parcelRequire("aBmRh");

var $hPK1h = parcelRequire("hPK1h");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80f270205a1a437e$export$2e2bcd8739ae039 = (request)=>(0, $hPK1h.default)(request).then((response)=>(0, $aBmRh.default)(response.taskId, request).then((result)=>Promise.resolve({
                ...result,
                taskId: response.taskId
            })));

});
parcelRegister("aBmRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ad0eb873d85c0f$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");

var $32TkL = parcelRequire("32TkL");
const $f3ad0eb873d85c0f$var$INITIAL_POLLING_INTERVAL = 1000; // 1s
const $f3ad0eb873d85c0f$export$8201d195ec654b2c = 5 * $f3ad0eb873d85c0f$var$INITIAL_POLLING_INTERVAL; // 5s max
const $f3ad0eb873d85c0f$export$4fd465ca4b3a7a02 = (taskId, { baseUrl: baseUrl, projectKey: projectKey, reportId: reportId })=>{
    const queryParam = (0, $ebyGx.stringify)({
        jobID: taskId
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions));
    return `${baseUrl}/rest/servicedesk/reports/1/reports/async/${projectKey}/${reportId}/poll?${queryParam}`;
};
const $f3ad0eb873d85c0f$var$getNextInterval = (interval)=>{
    if (interval === 0) return $f3ad0eb873d85c0f$var$INITIAL_POLLING_INTERVAL;
    const nextInterval = interval * 1.1;
    return Math.min($f3ad0eb873d85c0f$export$8201d195ec654b2c, nextInterval);
};
const $f3ad0eb873d85c0f$var$fetchData = (taskId, summaryRequest)=>{
    const url = $f3ad0eb873d85c0f$export$4fd465ca4b3a7a02(taskId, summaryRequest);
    return (0, $7f4tk.default)(url, {
        method: 'GET',
        signal: summaryRequest.signal
    });
};
const $f3ad0eb873d85c0f$var$shouldKeepPolling = (pollData)=>{
    switch(pollData.status){
        case 'RUNNING':
        case 'ENQUEUED':
            return true;
        default:
            return false;
    }
};
const $f3ad0eb873d85c0f$var$pollWithInterval = (taskId, summaryRequest, interval)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Promise((resolve, reject)=>{
        const poll = ()=>$f3ad0eb873d85c0f$var$fetchData(taskId, summaryRequest).then((pollData)=>{
                if ($f3ad0eb873d85c0f$var$shouldKeepPolling(pollData)) $f3ad0eb873d85c0f$var$pollWithInterval(taskId, summaryRequest, $f3ad0eb873d85c0f$var$getNextInterval(interval)).then(resolve, reject);
                else if (pollData.status === 'COMPLETE' && pollData.reportDataResponse) resolve(pollData.reportDataResponse);
                else reject(new Error(`Unable to fetch the report data due to unknown error. The task status was ${pollData.status}.`));
            }).catch(reject);
        setTimeout(poll, interval);
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f3ad0eb873d85c0f$export$2e2bcd8739ae039 = async (taskId, summaryRequest)=>$f3ad0eb873d85c0f$var$pollWithInterval(taskId, summaryRequest, 0);

});

parcelRegister("hPK1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $98dfac32cbb1f7d0$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");

var $32TkL = parcelRequire("32TkL");

var $bvS9p = parcelRequire("bvS9p");
const $98dfac32cbb1f7d0$export$a74292244f995bcd = ({ baseUrl: baseUrl, projectKey: projectKey, reportId: reportId, startDate: startDate, endDate: endDate, timeBreakdown: timeBreakdown })=>`${baseUrl}/rest/servicedesk/reports/1/reports/async/${projectKey}/${reportId}/date-range?${(0, $ebyGx.stringify)({
        startDate: startDate,
        endDate: endDate,
        timeBreakdown: timeBreakdown
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions))}`;
const $98dfac32cbb1f7d0$export$4fd465ca4b3a7a02 = ({ baseUrl: baseUrl, projectKey: projectKey, reportId: reportId, timescaleId: timescaleId })=>`${baseUrl}/rest/servicedesk/reports/1/reports/async/${projectKey}/${reportId}?${(0, $ebyGx.stringify)({
        timescaleId: timescaleId
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions))}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$98dfac32cbb1f7d0$export$2e2bcd8739ae039 = (request)=>{
    const url = (0, $bvS9p.isCustomTimeScale)(request.timescaleId) ? $98dfac32cbb1f7d0$export$a74292244f995bcd(request) : $98dfac32cbb1f7d0$export$4fd465ca4b3a7a02(request);
    return (0, $7f4tk.default)(url, {
        method: 'GET',
        signal: request.signal
    });
};

});


parcelRegister("aiZK8", function(module, exports) {

$parcel$export(module.exports, "get", () => $23a99540494e825b$export$3988ae62b71be9a3);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");

var $32TkL = parcelRequire("32TkL");

var $bvS9p = parcelRequire("bvS9p");

var $6CLRS = parcelRequire("6CLRS");
const $23a99540494e825b$export$990567e21daaa358 = ({ baseUrl: baseUrl, projectKey: projectKey, seriesId: seriesId, timescaleId: timescaleId, date: date, timeBreakdown: timeBreakdown, start: start, limit: limit })=>`${baseUrl}/rest/servicedesk/reports/1/servicedesk/${projectKey}/series/${seriesId}/drilldown/predefined?${(0, $ebyGx.stringify)({
        date: date,
        timeBreakdown: timeBreakdown,
        timescaleId: timescaleId,
        start: start,
        limit: limit,
        _: Date.now()
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions))}`;
const $23a99540494e825b$export$19abf5776d2293f0 = ({ baseUrl: baseUrl, projectKey: projectKey, seriesId: seriesId, date: date, timeBreakdown: timeBreakdown, timescaleId: timescaleId, start: start, limit: limit })=>`${baseUrl}/rest/servicedesk/reports/1/servicedesk/${projectKey}/series/${seriesId}/drilldown/predefined/date-range?${(0, $ebyGx.stringify)({
        date: date,
        timeBreakdown: timeBreakdown,
        timescaleId: timescaleId,
        start: start,
        limit: limit,
        _: Date.now()
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions))}`;
const $23a99540494e825b$export$3988ae62b71be9a3 = async (request)=>{
    const url = (0, $bvS9p.isCustomTimeScale)(request.timescaleId) ? $23a99540494e825b$export$19abf5776d2293f0(request) : $23a99540494e825b$export$990567e21daaa358(request);
    const response = await (0, $7f4tk.default)(url, {
        method: 'GET',
        signal: request.signal
    });
    return (0, $6CLRS.transformSource)(request, response);
};

});
parcelRegister("6CLRS", function(module, exports) {

$parcel$export(module.exports, "transformSource", () => $f399311972a3ad3a$export$258739ac4e431f7e);
const $f399311972a3ad3a$export$258739ac4e431f7e = ({ start: start, limit: limit }, response)=>{
    const page = start / limit + 1;
    return {
        ...response,
        page: page,
        pageSize: limit
    };
};

});



parcelRegister("9nTS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0d50845b1b23273$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dp7nU = parcelRequire("dp7nU");

var $cht8b = parcelRequire("cht8b");

var $8Fmle = parcelRequire("8Fmle");

var $dAFqR = parcelRequire("dAFqR");

var $5WvTQ = parcelRequire("5WvTQ");

var $5ZLpF = parcelRequire("5ZLpF");

var $4w0k3 = parcelRequire("4w0k3");

var $fySF6 = parcelRequire("fySF6");
const $f0d50845b1b23273$var$KbRequestsReports = ({ routerProps: routerProps, baseUrl: baseUrl, projectKey: projectKey, projectName: projectName, summaryResource: summaryResource, drilldownResource: drilldownResource })=>{
    const { modifyPageUrl: modifyPageUrl } = (0, $fySF6.useUrlActions)({
        baseUrl: baseUrl,
        projectKey: projectKey,
        routerProps: routerProps,
        projectName: projectName
    });
    const [selectedDrillDownPoint, setDrillDownPoint] = (0, $5uXOq.useState)();
    const [{ dateFilterQuery: dateFilterQuery }] = (0, $dp7nU.useUIStateStore)();
    const { reportId: reportId } = routerProps;
    const { data: summaryData, error: summaryError, loading: summaryLoading, fetch: onFetchSummary } = summaryResource;
    (0, $5uXOq.useEffect)(()=>{
        const fetchData = async ()=>{
            await onFetchSummary(dateFilterQuery);
        };
        fetchData();
        setDrillDownPoint(undefined);
    }, [
        dateFilterQuery,
        onFetchSummary
    ]);
    const sourceName = (0, $5uXOq.useMemo)(()=>{
        switch(reportId){
            case 'kb-requests-deflected':
                return 'viewRequestsDeflectedReport';
            case 'kb-requests-resolved':
                return 'viewRequestsResolvedReport';
            default:
                throw new Error(`${reportId} is an invalid reportId`);
        }
    }, [
        reportId
    ]);
    if (summaryError !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAFqR.default), null);
    if (summaryData === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    let csvUrl;
    if (!summaryLoading) csvUrl = (0, $fySF6.getCsvForGeneratedReport)(baseUrl, projectKey, dateFilterQuery, // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'SeriesData | undefined'.
    selectedDrillDownPoint, summaryData.taskId);
    else // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'SeriesData | undefined'.
    csvUrl = (0, $fySF6.getCsvUrl)(baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Fmle.default), {
        title: summaryData.label,
        projectKey: projectKey,
        projectName: projectName,
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZLpF.default), {
        href: csvUrl
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5WvTQ.Banner), {
        baseUrl: baseUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cht8b.default), {
        loading: summaryLoading,
        routerProps: routerProps,
        lastSearchQuery: {
            startDate: summaryData.startDate,
            endDate: summaryData.endDate
        },
        onSelect: modifyPageUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4w0k3.default), {
        summaryResource: summaryResource,
        reportId: reportId,
        drilldownResource: drilldownResource,
        dateFilterQuery: dateFilterQuery,
        // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'SeriesData | undefined'.
        selectedDrillDownPoint: selectedDrillDownPoint,
        onSetDrillDownPoint: setDrillDownPoint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        key: reportId
    }));
};
var $f0d50845b1b23273$export$2e2bcd8739ae039 = $f0d50845b1b23273$var$KbRequestsReports;

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("cht8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e75ac5dd18a567$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dyC2h = parcelRequire("dyC2h");

var $j6ZuL = parcelRequire("j6ZuL");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $8TqM4 = parcelRequire("8TqM4");

var $dp7nU = parcelRequire("dp7nU");

var $k74Ot = parcelRequire("k74Ot");

var $1d28l = parcelRequire("1d28l");

var $35hYY = parcelRequire("35hYY");

var $2XnCQ = parcelRequire("2XnCQ");
const $a0e75ac5dd18a567$var$itemClickedEvent = {
    eventType: 'UI',
    eventName: 'item clicked',
    action: 'clicked',
    actionSubject: 'dropdownItem'
};
const $a0e75ac5dd18a567$var$DateFilter = ({ loading: loading, routerProps: routerProps, lastSearchQuery: lastSearchQuery, onSelect: onSelect, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $95EVP.useAnalyticsEvents) })=>{
    const [{ dateFilterQuery: savedDateFilterQuery }] = (0, $dp7nU.useUIStateStore)();
    const intl = (0, $koVbs.default)();
    const savedTimescaleId = (0, $5uXOq.useMemo)(()=>savedDateFilterQuery ? savedDateFilterQuery.timescaleId : undefined, [
        savedDateFilterQuery
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const onDropdownSelect = (0, $5uXOq.useCallback)(({ id: id })=>{
        onSelect((0, $2XnCQ.mapToDateQuery)({
            reportId: routerProps.reportId,
            timescaleId: id
        }, lastSearchQuery));
        const timescaleOption = (0, $k74Ot.TIMESCALE_OPTIONS).find((option)=>option.id === id);
        fireUIAnalytics(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), 'dateFilter', {
            periodViewed: timescaleOption ? timescaleOption.analyticsKey : 'unknown'
        });
    }, [
        fireUIAnalytics,
        lastSearchQuery,
        onSelect,
        routerProps.reportId,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $5uXOq.useCallback)((option)=>{
        if (option) onDropdownSelect(option);
    }, [
        onDropdownSelect
    ]);
    const onCustomDateRangeUpdate = (0, $5uXOq.useCallback)((args)=>{
        const analyticsEvent = createAnalyticsEvent($a0e75ac5dd18a567$var$itemClickedEvent);
        const dateQuery = (0, $2XnCQ.mapToDateQuery)({
            ...routerProps,
            ...args
        }, lastSearchQuery);
        onSelect(dateQuery);
        const timescaleOption = (0, $k74Ot.TIMESCALE_OPTIONS).find((option)=>option.id === (0, $k74Ot.CUSTOM_TIMESCALE_ID));
        fireUIAnalytics(analyticsEvent, 'dateFilter', {
            periodViewed: timescaleOption ? timescaleOption.analyticsKey : 'unknown'
        });
    }, [
        createAnalyticsEvent,
        fireUIAnalytics,
        lastSearchQuery,
        onSelect,
        routerProps
    ]);
    const dropdownOptions = (0, $5uXOq.useMemo)(()=>(0, $k74Ot.TIMESCALE_OPTIONS).map(({ id: id, message: message })=>({
                id: id,
                value: `${id}`,
                label: intl.formatMessage(message)
            })), [
        intl
    ]);
    const selectedOption = (0, $5uXOq.useMemo)(()=>(0, $2XnCQ.getSelectedOptionByRouterProps)(dropdownOptions, routerProps, savedTimescaleId), [
        savedTimescaleId,
        dropdownOptions,
        routerProps
    ]);
    const showLabel = (0, $5uXOq.useMemo)(()=>intl.formatMessage((0, $35hYY.default).dropdownLabel), [
        intl
    ]);
    const dateTimeBreakdown = (0, $5uXOq.useMemo)(()=>{
        let source = routerProps; // If it's a transition use the saved value
        // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'RouterProps' and 'number' have no overlap.
        if (routerProps !== (0, $k74Ot.CUSTOM_TIMESCALE_ID) && savedDateFilterQuery) source = savedDateFilterQuery;
        return {
            startDate: source.startDate,
            endDate: source.endDate,
            timeBreakdown: source.timeBreakdown
        };
    }, [
        savedDateFilterQuery,
        routerProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0e75ac5dd18a567$var$DateFilterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "servicedesk-reports-common.ui.date-filter.timescale-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TqM4.LabelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dyC2h.default), {
        name: "showLabel",
        label: showLabel,
        id: "date-filter-dropdown"
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6ZuL.default), {
            inputId: "date-filter-dropdown",
            "aria-labelledby": "date-filter-dropdown-label",
            value: selectedOption,
            options: dropdownOptions,
            spacing: "compact",
            hideSelectedOptions: true,
            onChange: handleChange,
            controlShouldRenderValue: true,
            styles: {
                menu: (base)=>({
                        ...base,
                        minWidth: '160px'
                    })
            }
        }))))), selectedOption.id === (0, $k74Ot.CUSTOM_TIMESCALE_ID) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1d28l.default), {
        loading: loading,
        onUpdate: onCustomDateRangeUpdate,
        dateTimeBreakdown: dateTimeBreakdown
    }));
};
var $a0e75ac5dd18a567$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a0e75ac5dd18a567$var$DateFilter;
const $a0e75ac5dd18a567$var$DateFilterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18s81bvd",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dyC2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $85a69545334cdd8d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("3joPi");

var $3QrEQ = parcelRequire("3QrEQ");

var $dfjsA = parcelRequire("dfjsA");

var $3OPmw = parcelRequire("3OPmw");

var $6OQJH = parcelRequire("6OQJH");

var $8XpyK = parcelRequire("8XpyK");

var $6cAn5 = parcelRequire("6cAn5");
function $85a69545334cdd8d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $85a69545334cdd8d$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $85a69545334cdd8d$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $85a69545334cdd8d$var$isFunction(x) {
    return typeof x === 'function';
}
function $85a69545334cdd8d$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $85a69545334cdd8d$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $85a69545334cdd8d$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $3OPmw.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $3OPmw.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $85a69545334cdd8d$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $85a69545334cdd8d$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$85a69545334cdd8d$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $85a69545334cdd8d$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $85a69545334cdd8d$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($85a69545334cdd8d$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $3QrEQ.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $85a69545334cdd8d$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6OQJH.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8XpyK.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfjsA.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("dfjsA", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $586a02cb9f4a5e18$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $586a02cb9f4a5e18$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("3OPmw", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $4cb75c340862aba5$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $4cb75c340862aba5$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $4cb75c340862aba5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $4cb75c340862aba5$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $4cb75c340862aba5$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $4cb75c340862aba5$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb75c340862aba5$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb75c340862aba5$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("6OQJH", function(module, exports) {

$parcel$export(module.exports, "Label", () => $9890f8b50c0bb079$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $9890f8b50c0bb079$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $9890f8b50c0bb079$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9890f8b50c0bb079$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $9890f8b50c0bb079$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        css: $9890f8b50c0bb079$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $9890f8b50c0bb079$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("legend", {
        css: $9890f8b50c0bb079$var$fieldsetLabelStyles
    }, children);
};
var $9890f8b50c0bb079$export$2e2bcd8739ae039 = $9890f8b50c0bb079$export$b04be29aa201d4f5;

});

parcelRegister("8XpyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d6956dd24f17b08$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $4d6956dd24f17b08$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $4d6956dd24f17b08$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $4d6956dd24f17b08$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("j6ZuL", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $8a4ed93e09c7e2cd$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $8a4ed93e09c7e2cd$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2JyZq = parcelRequire("2JyZq");
var $g6zRF = parcelRequire("g6zRF");
var $fpTxz = parcelRequire("fpTxz");

var $1DGxv = parcelRequire("1DGxv");

var $8QBfu = parcelRequire("8QBfu");
const $8a4ed93e09c7e2cd$var$packageName = "platform-pkg";
const $8a4ed93e09c7e2cd$var$packageVersion = "0.0.0-use.local";
const $8a4ed93e09c7e2cd$export$d1de3b251ccaa8a3 = (0, $8QBfu.default)((0, $1DGxv.default));
const $8a4ed93e09c7e2cd$var$createAndFireEventOnAtlaskit = (0, $2JyZq.default)('atlaskit');
const $8a4ed93e09c7e2cd$var$Select = (0, $g6zRF.default)({
    componentName: 'select',
    packageName: $8a4ed93e09c7e2cd$var$packageName,
    packageVersion: $8a4ed93e09c7e2cd$var$packageVersion
})((0, $fpTxz.default)({
    onChange: $8a4ed93e09c7e2cd$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $8a4ed93e09c7e2cd$var$packageName,
            packageVersion: $8a4ed93e09c7e2cd$var$packageVersion
        }
    })
})($8a4ed93e09c7e2cd$export$d1de3b251ccaa8a3));
var $8a4ed93e09c7e2cd$export$2e2bcd8739ae039 = $8a4ed93e09c7e2cd$var$Select;

});
parcelRegister("1DGxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c8a0440cd263e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1vboO = parcelRequire("1vboO");

var $3y3Bw = parcelRequire("3y3Bw");
const $c5c8a0440cd263e7$var$StateManagedSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const baseSelectProps = (0, $3y3Bw.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vboO.default), {
        ref: ref,
        ...baseSelectProps
    });
});
var $c5c8a0440cd263e7$export$2e2bcd8739ae039 = $c5c8a0440cd263e7$var$StateManagedSelect;

});
parcelRegister("1vboO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bbd2b206e48247$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Ca0Y = parcelRequire("8Ca0Y");

var $4Ov3p = parcelRequire("4Ov3p");

var $32eUr = parcelRequire("32eUr");

var $83Qqt = parcelRequire("83Qqt");
var $7Nyq8 = parcelRequire("7Nyq8");
var $ogJTl = parcelRequire("ogJTl");

var $6l9x6 = parcelRequire("6l9x6");

var $gG9Gj = parcelRequire("gG9Gj");

var $eB7nO = parcelRequire("eB7nO");

var $8dMtY = parcelRequire("8dMtY");

var $7eDU2 = parcelRequire("7eDU2");

var $8X8Oy = parcelRequire("8X8Oy");
const $a4bbd2b206e48247$export$9c21a3269931e1e6 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $8X8Oy.isTouchCapable)(),
    captureMenuScroll: !(0, $8X8Oy.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $eB7nO.createFilter)(),
    formatGroupLabel: (0, $4Ov3p.formatGroupLabel),
    getOptionLabel: (0, $4Ov3p.getOptionLabel),
    getOptionValue: (0, $4Ov3p.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $4Ov3p.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $8X8Oy.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $a4bbd2b206e48247$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $a4bbd2b206e48247$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $a4bbd2b206e48247$var$isOptionSelected(props, option, selectValue);
    const label = $a4bbd2b206e48247$var$getOptionLabel(props, option);
    const value = $a4bbd2b206e48247$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $a4bbd2b206e48247$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$a4bbd2b206e48247$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$a4bbd2b206e48247$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $a4bbd2b206e48247$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $a4bbd2b206e48247$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $8X8Oy.notNullish));
}
function $a4bbd2b206e48247$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $a4bbd2b206e48247$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $a4bbd2b206e48247$var$buildFocusableOptions(props, selectValue) {
    return $a4bbd2b206e48247$var$buildFocusableOptionsFromCategorizedOptions($a4bbd2b206e48247$var$buildCategorizedOptions(props, selectValue));
}
function $a4bbd2b206e48247$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$a4bbd2b206e48247$var$shouldHideSelectedOptions(props) || !isSelected) && $a4bbd2b206e48247$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $a4bbd2b206e48247$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $a4bbd2b206e48247$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $a4bbd2b206e48247$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $a4bbd2b206e48247$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $a4bbd2b206e48247$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $a4bbd2b206e48247$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $a4bbd2b206e48247$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $a4bbd2b206e48247$var$getOptionValue(props, option);
    return selectValue.some((i)=>$a4bbd2b206e48247$var$getOptionValue(props, i) === candidate);
}
function $a4bbd2b206e48247$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $a4bbd2b206e48247$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $a4bbd2b206e48247$var$instanceId = 1;
class $a4bbd2b206e48247$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $a4bbd2b206e48247$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.isAppleDevice = (0, $8Ca0Y.isAppleDevice)();
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $8X8Oy.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $8X8Oy.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $8X8Oy.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $8X8Oy.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $8X8Oy.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $8X8Oy.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $8X8Oy.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        this.getFocusedOptionId = (focusedOption)=>{
            return $a4bbd2b206e48247$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $a4bbd2b206e48247$var$buildFocusableOptionsWithIds($a4bbd2b206e48247$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $8X8Oy.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $a4bbd2b206e48247$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $a4bbd2b206e48247$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const { unstyled: unstyled } = this.props;
            const base = (0, $8dMtY.defaultStyles)[key](props, unstyled);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $32eUr.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$a4bbd2b206e48247$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$a4bbd2b206e48247$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $8X8Oy.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $a4bbd2b206e48247$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$a4bbd2b206e48247$var$instanceId);
        //@ts-ignore
        this.state.selectValue = (0, $8X8Oy.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen && this.state.selectValue.length) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $a4bbd2b206e48247$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        //@ts-ignore
        const selectValue = (0, $8X8Oy.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $a4bbd2b206e48247$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $a4bbd2b206e48247$var$buildFocusableOptionsWithIds($a4bbd2b206e48247$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $a4bbd2b206e48247$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $a4bbd2b206e48247$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $a4bbd2b206e48247$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $8X8Oy.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $8X8Oy.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $8X8Oy.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus]
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    // ==============================
    // Getters
    // ==============================
    getTheme() {
        // Use the default theme if there are no customisations.
        if (!this.props.theme) return 0, $7eDU2.defaultTheme;
        // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.
        if (typeof this.props.theme === 'function') return this.props.theme((0, $7eDU2.defaultTheme));
        // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.
        return {
            ...(0, $7eDU2.defaultTheme),
            ...this.props.theme
        };
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue,
            theme: this.getTheme()
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $a4bbd2b206e48247$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $a4bbd2b206e48247$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $a4bbd2b206e48247$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const description = this.props['aria-describedby'] || descriptionId;
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'list',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            'aria-haspopup': 'listbox',
            'aria-describedby': description,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('live-region')
                ].join(' ') : this.getElementId('live-region')
            } : {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('placeholder')
                ].join(' ') : this.getElementId('placeholder')
            }
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return(//@ts-ignore
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83Qqt.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $8X8Oy.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            ...ariaAttributes
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder')
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                },
                data: opt
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled
        }, this.formatOptionLabel(singleValue, 'value'));
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderIndicatorSeparator() {
        const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
        // separator doesn't make sense without the dropdown indicator
        if (!DropdownIndicator || !IndicatorSeparator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
            ...commonProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: 'option',
                'aria-selected': this.isAppleDevice ? undefined : isSelected
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) menuUI = this.getCategorizedOptions().map((item)=>{
            if (item.type === 'group') {
                const { data: data, options: options, index: groupIndex } = item;
                const groupId = `${this.getElementId('group')}-${groupIndex}`;
                const headingId = `${groupId}-heading`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, {
                    ...commonProps,
                    key: groupId,
                    data: data,
                    options: options,
                    Heading: GroupHeading,
                    headingProps: {
                        id: headingId,
                        data: item.data
                    },
                    label: this.formatGroupLabel(item.data)
                }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`)));
            } else if (item.type === 'option') return render(item, `${item.index}`);
        });
        else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gG9Gj.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps
        }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
                ...commonProps,
                ...menuPlacementProps,
                innerRef: ref,
                innerProps: {
                    onMouseDown: this.onMenuMouseDown,
                    onMouseMove: this.onMenuMouseMove,
                    id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                },
                isLoading: isLoading,
                placement: placement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ogJTl.default), {
                captureEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom,
                lockEnabled: menuShouldBlockScroll
            }, (scrollTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuList, {
                    ...commonProps,
                    innerRef: (instance)=>{
                        this.getMenuListRef(instance);
                        scrollTargetRef(instance);
                    },
                    innerProps: {
                        role: 'listbox',
                        'aria-multiselectable': commonProps.isMulti,
                        id: this.getElementId('listbox')
                    },
                    isLoading: isLoading,
                    maxHeight: maxHeight,
                    focusedOption: focusedOption
                }, menuUI))));
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition
        }, menuElement) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nyq8.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                        key: `i-${i}`,
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, input);
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6l9x6.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isAppleDevice
        });
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown
            },
            isDisabled: isDisabled,
            isFocused: isFocused
        }, this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Control, {
            ...commonProps,
            innerRef: this.getControlRef,
            innerProps: {
                onMouseDown: this.onControlMouseDown,
                onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            menuIsOpen: menuIsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
}

});
parcelRegister("8Ca0Y", function(module, exports) {

$parcel$export(module.exports, "isAppleDevice", () => $5b4f1b27f0a81990$export$e1865c3bedcd822b);
function $5b4f1b27f0a81990$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $5b4f1b27f0a81990$export$186c6964ca17d99() {
    return $5b4f1b27f0a81990$var$testPlatform(/^iPhone/i);
}
function $5b4f1b27f0a81990$export$9ac100e40613ea10() {
    return $5b4f1b27f0a81990$var$testPlatform(/^Mac/i);
}
function $5b4f1b27f0a81990$export$7bef049ce92e4224() {
    return $5b4f1b27f0a81990$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $5b4f1b27f0a81990$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $5b4f1b27f0a81990$export$fedb369cb70207f1() {
    return $5b4f1b27f0a81990$export$186c6964ca17d99() || $5b4f1b27f0a81990$export$7bef049ce92e4224();
}
function $5b4f1b27f0a81990$export$e1865c3bedcd822b() {
    return $5b4f1b27f0a81990$export$9ac100e40613ea10() || $5b4f1b27f0a81990$export$fedb369cb70207f1();
}

});

parcelRegister("4Ov3p", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $f87a73dff4e4d6a9$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $f87a73dff4e4d6a9$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $f87a73dff4e4d6a9$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $f87a73dff4e4d6a9$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $f87a73dff4e4d6a9$export$f4da216a6ca54656 = (group)=>group.label;
const $f87a73dff4e4d6a9$export$dac6ace3020563ca = (option)=>option.label;
const $f87a73dff4e4d6a9$export$40be908210c5a79c = (option)=>option.value;
const $f87a73dff4e4d6a9$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("32eUr", function(module, exports) {

$parcel$export(module.exports, "components", () => $dbf96e1ea5b73ca1$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $dbf96e1ea5b73ca1$export$71abc632aa29e6fe);

var $eYvcR = parcelRequire("eYvcR");

var $6PDm2 = parcelRequire("6PDm2");

var $fAKLF = parcelRequire("fAKLF");

var $amcTK = parcelRequire("amcTK");

var $gXTA4 = parcelRequire("gXTA4");

var $gG9Gj = parcelRequire("gG9Gj");

var $fIxnT = parcelRequire("fIxnT");

var $2HYPe = parcelRequire("2HYPe");

var $aAmAU = parcelRequire("aAmAU");

var $5mFvf = parcelRequire("5mFvf");
const $dbf96e1ea5b73ca1$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $amcTK.ClearIndicator),
    Control: (0, $6PDm2.default),
    DropdownIndicator: (0, $amcTK.DropdownIndicator),
    DownChevron: (0, $amcTK.DownChevron),
    CrossIcon: (0, $amcTK.CrossIcon),
    Group: (0, $fAKLF.default),
    GroupHeading: (0, $fAKLF.GroupHeading),
    IndicatorsContainer: (0, $eYvcR.IndicatorsContainer),
    IndicatorSeparator: (0, $amcTK.IndicatorSeparator),
    Input: (0, $gXTA4.default),
    LoadingIndicator: (0, $amcTK.LoadingIndicator),
    Menu: (0, $gG9Gj.default),
    MenuList: (0, $gG9Gj.MenuList),
    MenuPortal: (0, $gG9Gj.MenuPortal),
    LoadingMessage: (0, $gG9Gj.LoadingMessage),
    NoOptionsMessage: (0, $gG9Gj.NoOptionsMessage),
    MultiValue: (0, $fIxnT.default),
    MultiValueContainer: (0, $fIxnT.MultiValueContainer),
    MultiValueLabel: (0, $fIxnT.MultiValueLabel),
    MultiValueRemove: (0, $fIxnT.MultiValueRemove),
    Option: (0, $2HYPe.default),
    Placeholder: (0, $aAmAU.default),
    SelectContainer: (0, $eYvcR.SelectContainer),
    SingleValue: (0, $5mFvf.default),
    ValueContainer: (0, $eYvcR.ValueContainer)
};
const $dbf96e1ea5b73ca1$export$71abc632aa29e6fe = (props)=>({
        ...$dbf96e1ea5b73ca1$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("eYvcR", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $b6dff7f2cc3f8428$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $b6dff7f2cc3f8428$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $b6dff7f2cc3f8428$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $b6dff7f2cc3f8428$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $b6dff7f2cc3f8428$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $b6dff7f2cc3f8428$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $b6dff7f2cc3f8428$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    });
const $b6dff7f2cc3f8428$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $b6dff7f2cc3f8428$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        ...unstyled ? {} : {
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        }
    });
const $b6dff7f2cc3f8428$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $8X8Oy.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $b6dff7f2cc3f8428$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    });
const $b6dff7f2cc3f8428$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("8X8Oy", function(module, exports) {

$parcel$export(module.exports, "noop", () => $5badd6cb6d07d680$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $5badd6cb6d07d680$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $5badd6cb6d07d680$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $5badd6cb6d07d680$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $5badd6cb6d07d680$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $5badd6cb6d07d680$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $5badd6cb6d07d680$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $5badd6cb6d07d680$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $5badd6cb6d07d680$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $5badd6cb6d07d680$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $5badd6cb6d07d680$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $5badd6cb6d07d680$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $5badd6cb6d07d680$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $5badd6cb6d07d680$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $5badd6cb6d07d680$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $5badd6cb6d07d680$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $5badd6cb6d07d680$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $5badd6cb6d07d680$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $5badd6cb6d07d680$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $5badd6cb6d07d680$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $5badd6cb6d07d680$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $5badd6cb6d07d680$export$4213b25a1c4e877);
const $5badd6cb6d07d680$export$8793edee2d425525 = ()=>{};
const $5badd6cb6d07d680$export$1643ccb46f49255c = ()=>'';
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $5badd6cb6d07d680$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $5badd6cb6d07d680$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$5badd6cb6d07d680$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $5badd6cb6d07d680$export$33f062f47f21a01 = (value)=>{
    if ($5badd6cb6d07d680$export$43bee75e5e14138e(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $5badd6cb6d07d680$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $5badd6cb6d07d680$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $5badd6cb6d07d680$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $5badd6cb6d07d680$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $5badd6cb6d07d680$export$2e0654fad740d2e4(el) {
    if ($5badd6cb6d07d680$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $5badd6cb6d07d680$export$c4a223a8ba9e4ea5(el) {
    if ($5badd6cb6d07d680$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $5badd6cb6d07d680$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($5badd6cb6d07d680$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $5badd6cb6d07d680$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $5badd6cb6d07d680$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $5badd6cb6d07d680$export$858c30343199f3af(element, to, duration = 200, callback = $5badd6cb6d07d680$export$8793edee2d425525) {
    const start = $5badd6cb6d07d680$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $5badd6cb6d07d680$var$easeOutCubic(currentTime, start, change, duration);
        $5badd6cb6d07d680$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $5badd6cb6d07d680$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $5badd6cb6d07d680$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $5badd6cb6d07d680$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $5badd6cb6d07d680$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $5badd6cb6d07d680$export$c0d0115e766e14c3(str) {
    return str.replace(/\W/g, '-');
}
function $5badd6cb6d07d680$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $5badd6cb6d07d680$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $5badd6cb6d07d680$var$passiveOptionAccessed = false;
const $5badd6cb6d07d680$var$options = {
    get passive () {
        return $5badd6cb6d07d680$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $5badd6cb6d07d680$var$w = typeof window !== 'undefined' ? window : {};
if ($5badd6cb6d07d680$var$w.addEventListener && $5badd6cb6d07d680$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $5badd6cb6d07d680$var$w.addEventListener('p', $5badd6cb6d07d680$export$8793edee2d425525, $5badd6cb6d07d680$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $5badd6cb6d07d680$var$w.removeEventListener('p', $5badd6cb6d07d680$export$8793edee2d425525, false);
}
const $5badd6cb6d07d680$export$b0622a6911dbeaf5 = $5badd6cb6d07d680$var$passiveOptionAccessed;
function $5badd6cb6d07d680$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $5badd6cb6d07d680$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $5badd6cb6d07d680$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $5badd6cb6d07d680$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $5badd6cb6d07d680$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $5badd6cb6d07d680$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("6PDm2", function(module, exports) {

$parcel$export(module.exports, "css", () => $277eb029e90c40a5$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $277eb029e90c40a5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $277eb029e90c40a5$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        }
    });
const $277eb029e90c40a5$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $8X8Oy.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$277eb029e90c40a5$export$2e2bcd8739ae039 = $277eb029e90c40a5$var$Control;

});

parcelRegister("fAKLF", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $1607f6fc8c4ecdaf$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $1607f6fc8c4ecdaf$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $1607f6fc8c4ecdaf$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $1607f6fc8c4ecdaf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $1607f6fc8c4ecdaf$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
const $1607f6fc8c4ecdaf$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $1607f6fc8c4ecdaf$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        ...unstyled ? {} : {
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        }
    });
const $1607f6fc8c4ecdaf$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $8X8Oy.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1607f6fc8c4ecdaf$export$2e2bcd8739ae039 = $1607f6fc8c4ecdaf$var$Group;

});

parcelRegister("amcTK", function(module, exports) {

$parcel$export(module.exports, "CrossIcon", () => $bb7f88a72976b3e0$export$3b621d86b1566b2);
$parcel$export(module.exports, "DownChevron", () => $bb7f88a72976b3e0$export$c5cbe1656ba71e6c);
$parcel$export(module.exports, "dropdownIndicatorCSS", () => $bb7f88a72976b3e0$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $bb7f88a72976b3e0$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $bb7f88a72976b3e0$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $bb7f88a72976b3e0$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "indicatorSeparatorCSS", () => $bb7f88a72976b3e0$export$ec39646155d07fdd);
$parcel$export(module.exports, "IndicatorSeparator", () => $bb7f88a72976b3e0$export$bd638c2ba7915668);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $bb7f88a72976b3e0$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $bb7f88a72976b3e0$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
function $bb7f88a72976b3e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
const $bb7f88a72976b3e0$var$styles = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
const $bb7f88a72976b3e0$var$Svg = ({ size: size, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $bb7f88a72976b3e0$var$styles,
        ...props
    });
const $bb7f88a72976b3e0$export$3b621d86b1566b2 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
const $bb7f88a72976b3e0$export$c5cbe1656ba71e6c = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
const $bb7f88a72976b3e0$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        }
    });
const $bb7f88a72976b3e0$export$e1687335805e1230 = $bb7f88a72976b3e0$var$baseCSS;
const $bb7f88a72976b3e0$export$ec98719d3db7f2e4 = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$export$c5cbe1656ba71e6c, null));
};
const $bb7f88a72976b3e0$export$9c0419fd944c1def = $bb7f88a72976b3e0$var$baseCSS;
const $bb7f88a72976b3e0$export$ecf9cf59142dd54a = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$export$3b621d86b1566b2, null));
};
const $bb7f88a72976b3e0$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1,
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        }
    });
const $bb7f88a72976b3e0$export$bd638c2ba7915668 = (props)=>{
    const { innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...innerProps,
        ...(0, $8X8Oy.getStyleProps)(props, 'indicatorSeparator', {
            'indicator-separator': true
        })
    });
};
// ==============================
// Loading
// ==============================
const $bb7f88a72976b3e0$var$loadingDotAnimations = (0, $f8Sb3.keyframes)({
    '0%, 80%, 100%': {
        opacity: 0
    },
    '40%': {
        opacity: 1
    }
});
const $bb7f88a72976b3e0$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        }
    });
const $bb7f88a72976b3e0$var$LoadingDot = ({ delay: delay, offset: offset })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $f8Sb3.css)({
            animation: `${$bb7f88a72976b3e0$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        })
    });
const $bb7f88a72976b3e0$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$LoadingDot, {
        delay: 160,
        offset: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};

});

parcelRegister("gXTA4", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $36de8f31aa0ca4d0$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $36de8f31aa0ca4d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $36de8f31aa0ca4d0$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$36de8f31aa0ca4d0$var$containerStyle,
        ...unstyled ? {} : {
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        }
    });
const $36de8f31aa0ca4d0$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $36de8f31aa0ca4d0$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$36de8f31aa0ca4d0$var$spacingStyle
    }
};
const $36de8f31aa0ca4d0$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$36de8f31aa0ca4d0$var$spacingStyle
    });
const $36de8f31aa0ca4d0$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, $8X8Oy.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || ''
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $36de8f31aa0ca4d0$var$inputStyle(isHidden),
        disabled: isDisabled,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$36de8f31aa0ca4d0$export$2e2bcd8739ae039 = $36de8f31aa0ca4d0$var$Input;

});

parcelRegister("gG9Gj", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $ce0772d67728ab16$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $ce0772d67728ab16$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $ce0772d67728ab16$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $ce0772d67728ab16$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $ce0772d67728ab16$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $ce0772d67728ab16$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $ce0772d67728ab16$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $ce0772d67728ab16$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $ce0772d67728ab16$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $ce0772d67728ab16$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $ce0772d67728ab16$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ktgnN = parcelRequire("ktgnN");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $8X8Oy = parcelRequire("8X8Oy");
function $ce0772d67728ab16$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $8X8Oy.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $8X8Oy.normalizedHeight)(scrollParent);
    const scrollTop = (0, $8X8Oy.getScrollTop)(scrollParent);
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTop;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $8X8Oy.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $8X8Oy.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $8X8Oy.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $8X8Oy.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $8X8Oy.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $ce0772d67728ab16$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $ce0772d67728ab16$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $ce0772d67728ab16$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'menu',
        [$ce0772d67728ab16$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        ...unstyled ? {} : {
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        }
    });
const $ce0772d67728ab16$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $ce0772d67728ab16$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($ce0772d67728ab16$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    const { controlHeight: controlHeight } = theme.spacing;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $ce0772d67728ab16$export$bd649b913ec78e4a({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $ce0772d67728ab16$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $ce0772d67728ab16$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ce0772d67728ab16$export$2e2bcd8739ae039 = $ce0772d67728ab16$var$Menu;
const $ce0772d67728ab16$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        ...unstyled ? {} : {
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        }
    });
const $ce0772d67728ab16$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        //@ts-ignore
        ref: innerRef,
        ...innerProps
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $ce0772d67728ab16$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        textAlign: 'center',
        ...unstyled ? {} : {
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        }
    });
const $ce0772d67728ab16$export$cf0e22534d8b0074 = $ce0772d67728ab16$var$noticeCSS;
const $ce0772d67728ab16$export$98ec46397a8cb3cd = $ce0772d67728ab16$var$noticeCSS;
const $ce0772d67728ab16$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return(//@ts-ignore
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, children));
};
const $ce0772d67728ab16$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, children);
};
const $ce0772d67728ab16$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $ce0772d67728ab16$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($ce0772d67728ab16$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $8X8Oy.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $ktgnN.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $8X8Oy.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($ce0772d67728ab16$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("ktgnN", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $ee7339595cce6cb1$export$deee3a793edee05f);

var $62nHC = parcelRequire("62nHC");
function $ee7339595cce6cb1$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $ee7339595cce6cb1$var$o(t) {
    return $ee7339595cce6cb1$var$n(t).getComputedStyle(t);
}
function $ee7339595cce6cb1$var$i(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).Node;
}
function $ee7339595cce6cb1$var$r(t) {
    return $ee7339595cce6cb1$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $ee7339595cce6cb1$var$l;
function $ee7339595cce6cb1$var$c() {
    if ($ee7339595cce6cb1$var$l) return $ee7339595cce6cb1$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($ee7339595cce6cb1$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $ee7339595cce6cb1$var$l) : navigator.userAgent;
}
function $ee7339595cce6cb1$var$s(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).HTMLElement;
}
function $ee7339595cce6cb1$var$f(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).Element;
}
function $ee7339595cce6cb1$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $ee7339595cce6cb1$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $ee7339595cce6cb1$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $ee7339595cce6cb1$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $ee7339595cce6cb1$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($ee7339595cce6cb1$var$r(t));
}
function $ee7339595cce6cb1$var$h(t) {
    const e = /firefox/i.test($ee7339595cce6cb1$var$c()), n = $ee7339595cce6cb1$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $ee7339595cce6cb1$var$p() {
    return /^((?!chrome|android).)*safari/i.test($ee7339595cce6cb1$var$c());
}
function $ee7339595cce6cb1$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($ee7339595cce6cb1$var$r(t));
}
const $ee7339595cce6cb1$var$m = Math.min, $ee7339595cce6cb1$var$y = Math.max, $ee7339595cce6cb1$var$x = Math.round;
function $ee7339595cce6cb1$var$w(t) {
    const e = $ee7339595cce6cb1$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $ee7339595cce6cb1$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $ee7339595cce6cb1$var$x(n) !== l || $ee7339595cce6cb1$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $ee7339595cce6cb1$var$v(t) {
    return $ee7339595cce6cb1$var$f(t) ? t : t.contextElement;
}
const $ee7339595cce6cb1$var$b = {
    x: 1,
    y: 1
};
function $ee7339595cce6cb1$var$L(t) {
    const e = $ee7339595cce6cb1$var$v(t);
    if (!$ee7339595cce6cb1$var$s(e)) return $ee7339595cce6cb1$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $ee7339595cce6cb1$var$w(e);
    let l = (r ? $ee7339595cce6cb1$var$x(n.width) : n.width) / o, c = (r ? $ee7339595cce6cb1$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $ee7339595cce6cb1$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $ee7339595cce6cb1$var$v(e);
    let a = $ee7339595cce6cb1$var$b;
    o && (r ? $ee7339595cce6cb1$var$f(r) && (a = $ee7339595cce6cb1$var$L(r)) : a = $ee7339595cce6cb1$var$L(e));
    const d = u ? $ee7339595cce6cb1$var$n(u) : window, h = $ee7339595cce6cb1$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $ee7339595cce6cb1$var$n(u), e = r && $ee7339595cce6cb1$var$f(r) ? $ee7339595cce6cb1$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $ee7339595cce6cb1$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $ee7339595cce6cb1$var$n(o).frameElement;
        }
    }
    return (0, $62nHC.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $ee7339595cce6cb1$var$T(t) {
    return (($ee7339595cce6cb1$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $ee7339595cce6cb1$var$R(t) {
    return $ee7339595cce6cb1$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $ee7339595cce6cb1$var$C(t) {
    return $ee7339595cce6cb1$var$E($ee7339595cce6cb1$var$T(t)).left + $ee7339595cce6cb1$var$R(t).scrollLeft;
}
function $ee7339595cce6cb1$var$F(t) {
    if ("html" === $ee7339595cce6cb1$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $ee7339595cce6cb1$var$u(t) && t.host || $ee7339595cce6cb1$var$T(t);
    return $ee7339595cce6cb1$var$u(e) ? e.host : e;
}
function $ee7339595cce6cb1$var$W(t) {
    const e = $ee7339595cce6cb1$var$F(t);
    return $ee7339595cce6cb1$var$g(e) ? e.ownerDocument.body : $ee7339595cce6cb1$var$s(e) && $ee7339595cce6cb1$var$a(e) ? e : $ee7339595cce6cb1$var$W(e);
}
function $ee7339595cce6cb1$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $ee7339595cce6cb1$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $ee7339595cce6cb1$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $ee7339595cce6cb1$var$a(i) ? i : []) : e.concat(i, $ee7339595cce6cb1$export$3b57c1601291186b(i));
}
function $ee7339595cce6cb1$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $ee7339595cce6cb1$var$n(t), i = $ee7339595cce6cb1$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $ee7339595cce6cb1$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $ee7339595cce6cb1$var$T(t), n = $ee7339595cce6cb1$var$R(t), i = t.ownerDocument.body, r = $ee7339595cce6cb1$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $ee7339595cce6cb1$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $ee7339595cce6cb1$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $ee7339595cce6cb1$var$o(i).direction && (c += $ee7339595cce6cb1$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($ee7339595cce6cb1$var$T(e));
    else if ($ee7339595cce6cb1$var$f(i)) l = function(t, e) {
        const n = $ee7339595cce6cb1$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $ee7339595cce6cb1$var$s(t) ? $ee7339595cce6cb1$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($ee7339595cce6cb1$var$p()) {
            var c, u;
            const o = $ee7339595cce6cb1$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $62nHC.rectToClientRect)(l);
}
function $ee7339595cce6cb1$var$A(t, e) {
    return $ee7339595cce6cb1$var$s(t) && "fixed" !== $ee7339595cce6cb1$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $ee7339595cce6cb1$var$H(t, e) {
    const i = $ee7339595cce6cb1$var$n(t);
    if (!$ee7339595cce6cb1$var$s(t)) return i;
    let l = $ee7339595cce6cb1$var$A(t, e);
    for(; l && $ee7339595cce6cb1$var$d(l) && "static" === $ee7339595cce6cb1$var$o(l).position;)l = $ee7339595cce6cb1$var$A(l, e);
    return l && ("html" === $ee7339595cce6cb1$var$r(l) || "body" === $ee7339595cce6cb1$var$r(l) && "static" === $ee7339595cce6cb1$var$o(l).position && !$ee7339595cce6cb1$var$h(l)) ? i : l || function(t) {
        let e = $ee7339595cce6cb1$var$F(t);
        for(; $ee7339595cce6cb1$var$s(e) && !$ee7339595cce6cb1$var$g(e);){
            if ($ee7339595cce6cb1$var$h(e)) return e;
            e = $ee7339595cce6cb1$var$F(e);
        }
        return null;
    }(t) || i;
}
function $ee7339595cce6cb1$var$V(t, e, n) {
    const o = $ee7339595cce6cb1$var$s(e), i = $ee7339595cce6cb1$var$T(e), l = $ee7339595cce6cb1$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $ee7339595cce6cb1$var$r(e) || $ee7339595cce6cb1$var$a(i)) && (c = $ee7339595cce6cb1$var$R(e)), $ee7339595cce6cb1$var$s(e)) {
            const t = $ee7339595cce6cb1$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $ee7339595cce6cb1$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $ee7339595cce6cb1$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $ee7339595cce6cb1$export$3b57c1601291186b(t).filter((t)=>$ee7339595cce6cb1$var$f(t) && "body" !== $ee7339595cce6cb1$var$r(t)), l = null;
            const c = "fixed" === $ee7339595cce6cb1$var$o(t).position;
            let s = c ? $ee7339595cce6cb1$var$F(t) : t;
            for(; $ee7339595cce6cb1$var$f(s) && !$ee7339595cce6cb1$var$g(s);){
                const t = $ee7339595cce6cb1$var$o(s), e = $ee7339595cce6cb1$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $ee7339595cce6cb1$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $ee7339595cce6cb1$var$S(e, n, l);
            return t.top = $ee7339595cce6cb1$var$y(o.top, t.top), t.right = $ee7339595cce6cb1$var$m(o.right, t.right), t.bottom = $ee7339595cce6cb1$var$m(o.bottom, t.bottom), t.left = $ee7339595cce6cb1$var$y(o.left, t.left), t;
        }, $ee7339595cce6cb1$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $ee7339595cce6cb1$var$s(n), l = $ee7339595cce6cb1$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $ee7339595cce6cb1$var$r(n) || $ee7339595cce6cb1$var$a(l)) && (c = $ee7339595cce6cb1$var$R(n)), $ee7339595cce6cb1$var$s(n))) {
            const t = $ee7339595cce6cb1$var$E(n);
            f = $ee7339595cce6cb1$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $ee7339595cce6cb1$var$f,
    getDimensions: function(t) {
        return $ee7339595cce6cb1$var$w(t);
    },
    getOffsetParent: $ee7339595cce6cb1$var$H,
    getDocumentElement: $ee7339595cce6cb1$var$T,
    getScale: $ee7339595cce6cb1$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $ee7339595cce6cb1$var$H, r = this.getDimensions;
        return {
            reference: $ee7339595cce6cb1$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $ee7339595cce6cb1$var$o(t).direction
};
function $ee7339595cce6cb1$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$ee7339595cce6cb1$var$f(t) ? $ee7339595cce6cb1$export$3b57c1601291186b(t) : t.contextElement ? $ee7339595cce6cb1$export$3b57c1601291186b(t.contextElement) : [],
        ...$ee7339595cce6cb1$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $ee7339595cce6cb1$var$f(t) && !c && d.observe(t), $ee7339595cce6cb1$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $ee7339595cce6cb1$var$E(t) : null;
    return c && function e() {
        const o = $ee7339595cce6cb1$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $ee7339595cce6cb1$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $ee7339595cce6cb1$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $62nHC.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("62nHC", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $465550d5da2db0f1$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $465550d5da2db0f1$export$ee05aea0aeecbad4);
function $465550d5da2db0f1$var$t(t) {
    return t.split("-")[1];
}
function $465550d5da2db0f1$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $465550d5da2db0f1$var$n(t) {
    return t.split("-")[0];
}
function $465550d5da2db0f1$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($465550d5da2db0f1$var$n(t)) ? "x" : "y";
}
function $465550d5da2db0f1$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $465550d5da2db0f1$var$o(r), u = $465550d5da2db0f1$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($465550d5da2db0f1$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($465550d5da2db0f1$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $465550d5da2db0f1$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $465550d5da2db0f1$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $465550d5da2db0f1$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $465550d5da2db0f1$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $465550d5da2db0f1$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $465550d5da2db0f1$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $465550d5da2db0f1$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $465550d5da2db0f1$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $465550d5da2db0f1$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $465550d5da2db0f1$var$c = Math.min, $465550d5da2db0f1$var$f = Math.max;
function $465550d5da2db0f1$var$m(t, e, n) {
    return $465550d5da2db0f1$var$f(t, $465550d5da2db0f1$var$c(e, n));
}
const $465550d5da2db0f1$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $465550d5da2db0f1$var$a(l), h = {
                x: s,
                y: c
            }, y = $465550d5da2db0f1$var$o(f), x = $465550d5da2db0f1$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $465550d5da2db0f1$var$m(k, B, O), H = null != $465550d5da2db0f1$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $465550d5da2db0f1$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $465550d5da2db0f1$var$d = $465550d5da2db0f1$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $465550d5da2db0f1$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $465550d5da2db0f1$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$465550d5da2db0f1$var$p[t]);
}
function $465550d5da2db0f1$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $465550d5da2db0f1$var$t(n), l = $465550d5da2db0f1$var$o(n), s = $465550d5da2db0f1$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $465550d5da2db0f1$var$h(c)), {
        main: c,
        cross: $465550d5da2db0f1$var$h(c)
    };
}
const $465550d5da2db0f1$var$x = {
    start: "end",
    end: "start"
};
function $465550d5da2db0f1$var$w(t) {
    return t.replace(/start|end/g, (t)=>$465550d5da2db0f1$var$x[t]);
}
const $465550d5da2db0f1$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $465550d5da2db0f1$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $465550d5da2db0f1$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$465550d5da2db0f1$var$t(n) === e),
                    ...i.filter((n)=>$465550d5da2db0f1$var$t(n) !== e)
                ] : i.filter((t)=>$465550d5da2db0f1$var$n(t) === t)).filter((n)=>!e || $465550d5da2db0f1$var$t(n) === e || !!o && $465550d5da2db0f1$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $465550d5da2db0f1$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $465550d5da2db0f1$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$465550d5da2db0f1$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $465550d5da2db0f1$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $465550d5da2db0f1$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $465550d5da2db0f1$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $465550d5da2db0f1$var$n(r), R = $465550d5da2db0f1$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $465550d5da2db0f1$var$h(c)
            ] : function(t) {
                const e = $465550d5da2db0f1$var$h(t);
                return [
                    $465550d5da2db0f1$var$w(t),
                    e,
                    $465550d5da2db0f1$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $465550d5da2db0f1$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($465550d5da2db0f1$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($465550d5da2db0f1$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $465550d5da2db0f1$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $465550d5da2db0f1$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $465550d5da2db0f1$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $465550d5da2db0f1$var$R(t) {
    return $465550d5da2db0f1$var$g.some((e)=>t[e] >= 0);
}
const $465550d5da2db0f1$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $465550d5da2db0f1$var$A(await $465550d5da2db0f1$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $465550d5da2db0f1$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $465550d5da2db0f1$var$A(await $465550d5da2db0f1$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $465550d5da2db0f1$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $465550d5da2db0f1$var$E(t) {
    const e = $465550d5da2db0f1$var$c(...t.map((t)=>t.left)), n = $465550d5da2db0f1$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $465550d5da2db0f1$var$f(...t.map((t)=>t.right)) - e,
        height: $465550d5da2db0f1$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $465550d5da2db0f1$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$465550d5da2db0f1$export$ee05aea0aeecbad4($465550d5da2db0f1$var$E(t)));
            }(h), x = $465550d5da2db0f1$export$ee05aea0aeecbad4($465550d5da2db0f1$var$E(h)), w = $465550d5da2db0f1$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $465550d5da2db0f1$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $465550d5da2db0f1$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $465550d5da2db0f1$var$n(i), e = $465550d5da2db0f1$var$f(...y.map((t)=>t.right)), r = $465550d5da2db0f1$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $465550d5da2db0f1$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $465550d5da2db0f1$var$n(r), f = $465550d5da2db0f1$var$t(r), m = "x" === $465550d5da2db0f1$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $465550d5da2db0f1$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $465550d5da2db0f1$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $465550d5da2db0f1$export$37b6bde19b108ecc(e, u), p = $465550d5da2db0f1$var$o($465550d5da2db0f1$var$n(a)), h = $465550d5da2db0f1$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $465550d5da2db0f1$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $465550d5da2db0f1$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $465550d5da2db0f1$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $465550d5da2db0f1$var$o(a), d = $465550d5da2db0f1$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($465550d5da2db0f1$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $465550d5da2db0f1$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $465550d5da2db0f1$export$37b6bde19b108ecc(i, g), p = $465550d5da2db0f1$var$n(r), h = $465550d5da2db0f1$var$t(r), y = "x" === $465550d5da2db0f1$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $465550d5da2db0f1$var$c(x - d.right - d.left, R) : P = $465550d5da2db0f1$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $465550d5da2db0f1$var$f(d.left, 0), e = $465550d5da2db0f1$var$f(d.right, 0), n = $465550d5da2db0f1$var$f(d.top, 0), o = $465550d5da2db0f1$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $465550d5da2db0f1$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $465550d5da2db0f1$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;

});


parcelRegister("fIxnT", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $7a3c005dfa92d2c8$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $7a3c005dfa92d2c8$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $7a3c005dfa92d2c8$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $7a3c005dfa92d2c8$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $7a3c005dfa92d2c8$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $7a3c005dfa92d2c8$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $7a3c005dfa92d2c8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");

var $amcTK = parcelRequire("amcTK");
const $7a3c005dfa92d2c8$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        ...unstyled ? {} : {
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        }
    });
const $7a3c005dfa92d2c8$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        }
    });
const $7a3c005dfa92d2c8$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
        alignItems: 'center',
        display: 'flex',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        }
    });
const $7a3c005dfa92d2c8$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $7a3c005dfa92d2c8$export$cf9cf2a30a59265c = $7a3c005dfa92d2c8$export$e1de505c1242dc1a;
const $7a3c005dfa92d2c8$export$544aeea2a5ce08ee = $7a3c005dfa92d2c8$export$e1de505c1242dc1a;
function $7a3c005dfa92d2c8$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "button",
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $amcTK.CrossIcon), {
        size: 14
    }));
}
const $7a3c005dfa92d2c8$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $8X8Oy.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $8X8Oy.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $8X8Oy.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            'aria-label': `Remove ${children || 'option'}`,
            ...removeProps
        },
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a3c005dfa92d2c8$export$2e2bcd8739ae039 = $7a3c005dfa92d2c8$var$MultiValue;

});

parcelRegister("2HYPe", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $b7cbb2597aec3d7c$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $b7cbb2597aec3d7c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $b7cbb2597aec3d7c$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        ...unstyled ? {} : {
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            // provide some affordance on touch devices
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        }
    });
const $b7cbb2597aec3d7c$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        //@ts-ignore
        ref: innerRef,
        "aria-disabled": isDisabled,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b7cbb2597aec3d7c$export$2e2bcd8739ae039 = $b7cbb2597aec3d7c$var$Option;

});

parcelRegister("aAmAU", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $b3bce4aa0db58477$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $b3bce4aa0db58477$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $b3bce4aa0db58477$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        ...unstyled ? {} : {
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $b3bce4aa0db58477$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b3bce4aa0db58477$export$2e2bcd8739ae039 = $b3bce4aa0db58477$var$Placeholder;

});

parcelRegister("5mFvf", function(module, exports) {

$parcel$export(module.exports, "css", () => $15b2e67a571b7b71$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $15b2e67a571b7b71$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $15b2e67a571b7b71$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $15b2e67a571b7b71$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$15b2e67a571b7b71$export$2e2bcd8739ae039 = $15b2e67a571b7b71$var$SingleValue;

});


parcelRegister("83Qqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $279f17c834f20bd7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $279f17c834f20bd7$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $279f17c834f20bd7$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $8X8Oy.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $279f17c834f20bd7$var$dummyInputStyles
    });
}

});

parcelRegister("7Nyq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b117f389d2d1f0ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $ePBXU = parcelRequire("ePBXU");
function $b117f389d2d1f0ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b117f389d2d1f0ea$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $b117f389d2d1f0ea$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $b117f389d2d1f0ea$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $ePBXU.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b117f389d2d1f0ea$export$2e2bcd8739ae039 = $b117f389d2d1f0ea$var$RequiredInput;

});

parcelRegister("ogJTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $529162e91ee687b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1UMhw = parcelRequire("1UMhw");

var $eyEhQ = parcelRequire("eyEhQ");
function $529162e91ee687b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $529162e91ee687b9$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $529162e91ee687b9$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $529162e91ee687b9$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $1UMhw.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $eyEhQ.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onClick: $529162e91ee687b9$var$blurSelectInput,
        css: $529162e91ee687b9$var$styles
    }), children(targetRef));
}

});
parcelRegister("1UMhw", function(module, exports) {

$parcel$export(module.exports, "default", () => $80662ca60abf2046$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8X8Oy = parcelRequire("8X8Oy");
const $80662ca60abf2046$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $80662ca60abf2046$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $80662ca60abf2046$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $8X8Oy.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("eyEhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5be83c0b4e57860$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $f5be83c0b4e57860$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $f5be83c0b4e57860$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $f5be83c0b4e57860$var$preventTouchMove(e) {
    e.preventDefault();
}
function $f5be83c0b4e57860$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $f5be83c0b4e57860$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $f5be83c0b4e57860$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $f5be83c0b4e57860$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $f5be83c0b4e57860$var$activeScrollLocks = 0;
const $f5be83c0b4e57860$var$listenerOptions = {
    capture: false,
    passive: false
};
function $f5be83c0b4e57860$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$f5be83c0b4e57860$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $f5be83c0b4e57860$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $f5be83c0b4e57860$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($f5be83c0b4e57860$var$LOCK_STYLES).forEach((key)=>{
                const val = $f5be83c0b4e57860$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $f5be83c0b4e57860$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $f5be83c0b4e57860$var$preventTouchMove, $f5be83c0b4e57860$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $f5be83c0b4e57860$var$preventInertiaScroll, $f5be83c0b4e57860$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $f5be83c0b4e57860$var$allowTouchMove, $f5be83c0b4e57860$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $f5be83c0b4e57860$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$f5be83c0b4e57860$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $f5be83c0b4e57860$var$activeScrollLocks = Math.max($f5be83c0b4e57860$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $f5be83c0b4e57860$var$activeScrollLocks < 1) $f5be83c0b4e57860$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $f5be83c0b4e57860$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $f5be83c0b4e57860$var$preventTouchMove, $f5be83c0b4e57860$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $f5be83c0b4e57860$var$preventInertiaScroll, $f5be83c0b4e57860$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $f5be83c0b4e57860$var$allowTouchMove, $f5be83c0b4e57860$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("6l9x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe20070fa417846c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9kIMy = parcelRequire("9kIMy");

var $jJN0q = parcelRequire("jJN0q");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $fe20070fa417846c$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $9kIMy.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jJN0q.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jJN0q.default), {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fe20070fa417846c$export$2e2bcd8739ae039 = $fe20070fa417846c$var$LiveRegion;

});
parcelRegister("9kIMy", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $8c694a6db1787d72$export$a7265767c78f9bae);
const $8c694a6db1787d72$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return `option ${label}, deselected.`;
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected, isAppleDevice: isAppleDevice } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `${arr.indexOf(item) + 1} of ${arr.length}` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        if (context === 'menu' && isAppleDevice) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ''}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}.`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("jJN0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $370fb6e87137021b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $370fb6e87137021b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $370fb6e87137021b$var$styles = {
    name: "1j8j4w4-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
};
const $370fb6e87137021b$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $370fb6e87137021b$var$styles,
        ...props
    });
var $370fb6e87137021b$export$2e2bcd8739ae039 = $370fb6e87137021b$var$A11yText;

});


parcelRegister("eB7nO", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $8cb91475fe098e16$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $6L0Jj = parcelRequire("6L0Jj");
const $8cb91475fe098e16$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $6L0Jj.stripDiacritics));
const $8cb91475fe098e16$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $8cb91475fe098e16$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $8cb91475fe098e16$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $8cb91475fe098e16$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $8cb91475fe098e16$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $8cb91475fe098e16$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $8cb91475fe098e16$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $6L0Jj.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("6L0Jj", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $21a9f59d8b4d431c$export$b5bee4b27048330b);
const $21a9f59d8b4d431c$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $21a9f59d8b4d431c$var$anyDiacritic = new RegExp('[' + $21a9f59d8b4d431c$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $21a9f59d8b4d431c$var$diacriticToBase = {};
for(let i = 0; i < $21a9f59d8b4d431c$var$diacritics.length; i++){
    let diacritic = $21a9f59d8b4d431c$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$21a9f59d8b4d431c$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $21a9f59d8b4d431c$export$b5bee4b27048330b = (str)=>{
    return str.replace($21a9f59d8b4d431c$var$anyDiacritic, (match)=>$21a9f59d8b4d431c$var$diacriticToBase[match]);
};

});


parcelRegister("8dMtY", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $d801b3e95f64128a$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $d801b3e95f64128a$export$e618dc39ac9ad607);

var $eYvcR = parcelRequire("eYvcR");

var $6PDm2 = parcelRequire("6PDm2");

var $fAKLF = parcelRequire("fAKLF");

var $amcTK = parcelRequire("amcTK");

var $gXTA4 = parcelRequire("gXTA4");

var $gG9Gj = parcelRequire("gG9Gj");

var $fIxnT = parcelRequire("fIxnT");

var $2HYPe = parcelRequire("2HYPe");

var $aAmAU = parcelRequire("aAmAU");

var $5mFvf = parcelRequire("5mFvf");
const $d801b3e95f64128a$export$214b055320e0bf32 = {
    clearIndicator: (0, $amcTK.clearIndicatorCSS),
    container: (0, $eYvcR.containerCSS),
    control: (0, $6PDm2.css),
    dropdownIndicator: (0, $amcTK.dropdownIndicatorCSS),
    group: (0, $fAKLF.groupCSS),
    groupHeading: (0, $fAKLF.groupHeadingCSS),
    indicatorsContainer: (0, $eYvcR.indicatorsContainerCSS),
    indicatorSeparator: (0, $amcTK.indicatorSeparatorCSS),
    input: (0, $gXTA4.inputCSS),
    loadingIndicator: (0, $amcTK.loadingIndicatorCSS),
    loadingMessage: (0, $gG9Gj.loadingMessageCSS),
    menu: (0, $gG9Gj.menuCSS),
    menuList: (0, $gG9Gj.menuListCSS),
    menuPortal: (0, $gG9Gj.menuPortalCSS),
    multiValue: (0, $fIxnT.multiValueCSS),
    multiValueLabel: (0, $fIxnT.multiValueLabelCSS),
    multiValueRemove: (0, $fIxnT.multiValueRemoveCSS),
    noOptionsMessage: (0, $gG9Gj.noOptionsMessageCSS),
    option: (0, $2HYPe.optionCSS),
    placeholder: (0, $aAmAU.placeholderCSS),
    singleValue: (0, $5mFvf.css),
    valueContainer: (0, $eYvcR.valueContainerCSS)
};
function $d801b3e95f64128a$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("7eDU2", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $b146b759e2f32e72$export$164de7ab8df77ef0);
const $b146b759e2f32e72$export$8f45430ccf837300 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
const $b146b759e2f32e72$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
const $b146b759e2f32e72$var$baseUnit = 4;
// The minimum height of the control
const $b146b759e2f32e72$var$controlHeight = 38;
// The amount of space between the control and menu */
const $b146b759e2f32e72$var$menuGutter = $b146b759e2f32e72$var$baseUnit * 2;
const $b146b759e2f32e72$export$5458b64234d1333c = {
    baseUnit: $b146b759e2f32e72$var$baseUnit,
    controlHeight: $b146b759e2f32e72$var$controlHeight,
    menuGutter: $b146b759e2f32e72$var$menuGutter
};
const $b146b759e2f32e72$export$164de7ab8df77ef0 = {
    borderRadius: $b146b759e2f32e72$var$borderRadius,
    colors: $b146b759e2f32e72$export$8f45430ccf837300,
    spacing: $b146b759e2f32e72$export$5458b64234d1333c
};

});


parcelRegister("3y3Bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7af71877eb418622$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $7af71877eb418622$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("8QBfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $898f4e606177aa8e$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $5uXOq = parcelRequire("5uXOq");

var $8dMtY = parcelRequire("8dMtY");

var $8gxSq = parcelRequire("8gxSq");
var $4JSbr = parcelRequire("4JSbr");

var $hUvN1 = parcelRequire("hUvN1");

var $7SD1Y = parcelRequire("7SD1Y");

var $i4Azc = parcelRequire("i4Azc");

var $fw6Sj = parcelRequire("fw6Sj");
function $898f4e606177aa8e$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        const components = (0, $5uXOq.useMemo)(()=>({
                ClearIndicator: $8gxSq.ClearIndicator,
                DropdownIndicator: $8gxSq.DropdownIndicator,
                LoadingIndicator: $8gxSq.LoadingIndicator,
                MultiValueRemove: $4JSbr.MultiValueRemove,
                IndicatorSeparator: $4JSbr.IndicatorSeparator,
                Input: $hUvN1.Input,
                NoOptionsMessage: $7SD1Y.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $5uXOq.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $fw6Sj.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $fw6Sj.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $8dMtY.mergeStyles)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $i4Azc.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("8gxSq", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $1cb2ad07eac9a6a4$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $1cb2ad07eac9a6a4$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $1cb2ad07eac9a6a4$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eSI7k = parcelRequire("eSI7k");

var $2S8Eh = parcelRequire("2S8Eh");

var $dsFR3 = parcelRequire("dsFR3");
var $9nD7C = parcelRequire("9nD7C");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $32eUr = parcelRequire("32eUr");

var $9MjbF = parcelRequire("9MjbF");
const $1cb2ad07eac9a6a4$var$iconContainerStyles = (0, $jJ1Sb.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $1cb2ad07eac9a6a4$var$dropdownWrapperStyles = (0, $jJ1Sb.xcss)({
    padding: 'space.075'
});
const $1cb2ad07eac9a6a4$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9nD7C.default), {
        xcss: $1cb2ad07eac9a6a4$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2S8Eh))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $1cb2ad07eac9a6a4$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).DropdownIndicator, props, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsFR3.default), {
        as: "span",
        xcss: $1cb2ad07eac9a6a4$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eSI7k))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $1cb2ad07eac9a6a4$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $f8Sb3.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9MjbF.default), {
        size: "small"
    })));
};

});
parcelRegister("2S8Eh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21775561ba689a9d$var$_react = $21775561ba689a9d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21775561ba689a9d$var$_crossCircle = $21775561ba689a9d$var$_interopRequireDefault((parcelRequire("5y49s")));

var $21775561ba689a9d$var$_selectClear = $21775561ba689a9d$var$_interopRequireDefault((parcelRequire("0q6NC")));
function $21775561ba689a9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21775561ba689a9d$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $21775561ba689a9d$var$_react.default.createElement($21775561ba689a9d$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $21775561ba689a9d$var$_selectClear.default
    }, props));
$21775561ba689a9d$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $21775561ba689a9d$var$_default = module.exports.default = $21775561ba689a9d$var$CrossCircleIcon;

});
parcelRegister("5y49s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40a35920732ae269$var$_react = $40a35920732ae269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $40a35920732ae269$var$_UNSAFE_baseNew = $40a35920732ae269$var$_interopRequireDefault((parcelRequire("huIZN")));
function $40a35920732ae269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40a35920732ae269$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $40a35920732ae269$var$_react.default.createElement($40a35920732ae269$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$40a35920732ae269$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $40a35920732ae269$var$_default = module.exports.default = $40a35920732ae269$var$CrossCircleIcon;

});

parcelRegister("0q6NC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $001440d6cab67792$var$_react = $001440d6cab67792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $001440d6cab67792$var$_crossCircle = $001440d6cab67792$var$_interopRequireDefault((parcelRequire("1YMh4")));
function $001440d6cab67792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $001440d6cab67792$var$SelectClearIcon = (props)=>/*#__PURE__*/ $001440d6cab67792$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $001440d6cab67792$var$_crossCircle.default
    }));
$001440d6cab67792$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $001440d6cab67792$var$_default = module.exports.default = $001440d6cab67792$var$SelectClearIcon;

});
parcelRegister("1YMh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1710d74ae21b1552$var$_react = $1710d74ae21b1552$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1710d74ae21b1552$var$_UNSAFE_baseNew = $1710d74ae21b1552$var$_interopRequireDefault((parcelRequire("huIZN")));
function $1710d74ae21b1552$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1710d74ae21b1552$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $1710d74ae21b1552$var$_react.default.createElement($1710d74ae21b1552$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$1710d74ae21b1552$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $1710d74ae21b1552$var$_default = module.exports.default = $1710d74ae21b1552$var$CrossCircleIcon;

});




parcelRegister("4JSbr", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $0153da45dac65b9d$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $0153da45dac65b9d$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $0q6NC = parcelRequire("0q6NC");

var $8zEy7 = parcelRequire("8zEy7");

var $294ns = parcelRequire("294ns");

var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $32eUr = parcelRequire("32eUr");

var $8gxSq = parcelRequire("8gxSq");
function $0153da45dac65b9d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0153da45dac65b9d$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $0153da45dac65b9d$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $0153da45dac65b9d$var$iconWrapperStyles = (0, $jJ1Sb.xcss)({
    padding: 'space.025'
});
const $0153da45dac65b9d$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $294ns.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8zEy7))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $294ns.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsFR3.default), {
            xcss: $0153da45dac65b9d$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8zEy7))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0q6NC))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).MultiValueRemove, props, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $0153da45dac65b9d$var$disabledStyles : $0153da45dac65b9d$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $0153da45dac65b9d$export$bd638c2ba7915668 = null;

});
parcelRegister("8zEy7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63e10bd7abfd6fa8$var$_react = $63e10bd7abfd6fa8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63e10bd7abfd6fa8$var$_UNSAFE_baseNew = $63e10bd7abfd6fa8$var$_interopRequireDefault((parcelRequire("huIZN")));
function $63e10bd7abfd6fa8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63e10bd7abfd6fa8$var$CrossIcon = (props)=>/*#__PURE__*/ $63e10bd7abfd6fa8$var$_react.default.createElement($63e10bd7abfd6fa8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$63e10bd7abfd6fa8$var$CrossIcon.displayName = 'CrossIcon';
var $63e10bd7abfd6fa8$var$_default = module.exports.default = $63e10bd7abfd6fa8$var$CrossIcon;

});


parcelRegister("hUvN1", function(module, exports) {

$parcel$export(module.exports, "Input", () => $9750d8536a9a9c8e$export$f5b8910cec6cf069);

var $5uXOq = parcelRequire("5uXOq");

var $32eUr = parcelRequire("32eUr");
function $9750d8536a9a9c8e$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute = props['aria-describedby'];
    const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
    if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("7SD1Y", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $437e31a7ed0fe2ce$export$d58b72b7d3c4072c);

var $5uXOq = parcelRequire("5uXOq");

var $1m92z = parcelRequire("1m92z");

var $32eUr = parcelRequire("32eUr");
const $437e31a7ed0fe2ce$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("i4Azc", function(module, exports) {

$parcel$export(module.exports, "default", () => $420fec5a5b07fd33$export$2e2bcd8739ae039);

var $294ns = parcelRequire("294ns");

function $420fec5a5b07fd33$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $5e0c0d4e15efb4a6$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $5e0c0d4e15efb4a6$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $5e0c0d4e15efb4a6$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $5e0c0d4e15efb4a6$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $5e0c0d4e15efb4a6$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $5e0c0d4e15efb4a6$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $5e0c0d4e15efb4a6$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $294ns.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $294ns.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $294ns.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $5e0c0d4e15efb4a6$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $5e0c0d4e15efb4a6$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $5e0c0d4e15efb4a6$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $294ns.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`,
                fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                textTransform: 'none'
            })
    };
}

});

parcelRegister("fw6Sj", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $3e8e0fe1c9158c20$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $3e8e0fe1c9158c20$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $3e8e0fe1c9158c20$export$8ee33f304118fce4);
function $3e8e0fe1c9158c20$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $3e8e0fe1c9158c20$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $3e8e0fe1c9158c20$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("8TqM4", function(module, exports) {

$parcel$export(module.exports, "LabelWrapper", () => $5a29205b0dd1dcfc$export$147422f7450ccfac);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $5a29205b0dd1dcfc$export$147422f7450ccfac = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qutpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("k74Ot", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_TIMESCALE_ID", () => $fb3ed106a3659591$export$edb46b113b5df303);
$parcel$export(module.exports, "TIMESCALE_OPTIONS", () => $fb3ed106a3659591$export$2265585593f3283c);
$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $fb3ed106a3659591$export$93ca5d3f8675ae4c);

var $arzTB = parcelRequire("arzTB");

var $35hYY = parcelRequire("35hYY");
const $fb3ed106a3659591$export$930ada39a040821e = 1;
const $fb3ed106a3659591$export$f8447a3b6bdf76b0 = 2;
const $fb3ed106a3659591$export$5b9b786e9cb1188 = 3;
const $fb3ed106a3659591$export$55501131f0e0fa74 = 4;
const $fb3ed106a3659591$export$da30c0bc3e078809 = 5;
const $fb3ed106a3659591$export$1fd26187b35d98d9 = 6;
const $fb3ed106a3659591$export$abf95687cd6d45a7 = 7;
const $fb3ed106a3659591$export$8afcf4edee140deb = 8;
const $fb3ed106a3659591$export$edb46b113b5df303 = 9;
const $fb3ed106a3659591$export$2265585593f3283c = [
    {
        id: $fb3ed106a3659591$export$930ada39a040821e,
        analyticsKey: 'past48hours',
        message: (0, $35hYY.default).past48Hours
    },
    {
        id: $fb3ed106a3659591$export$f8447a3b6bdf76b0,
        analyticsKey: 'past7',
        message: (0, $35hYY.default).past7Days
    },
    {
        id: $fb3ed106a3659591$export$5b9b786e9cb1188,
        analyticsKey: 'past14',
        message: (0, $35hYY.default).past14Days
    },
    {
        id: $fb3ed106a3659591$export$55501131f0e0fa74,
        analyticsKey: 'past30',
        message: (0, $35hYY.default).past30Days
    },
    {
        id: $fb3ed106a3659591$export$da30c0bc3e078809,
        analyticsKey: 'pastquarter',
        message: (0, $35hYY.default).pastQuarterByDay
    },
    {
        id: $fb3ed106a3659591$export$1fd26187b35d98d9,
        analyticsKey: 'pastquarterbyweek',
        message: (0, $35hYY.default).pastQuarterByWeek
    },
    {
        id: $fb3ed106a3659591$export$abf95687cd6d45a7,
        analyticsKey: 'pastyearbyweek',
        message: (0, $35hYY.default).pastYearByWeek
    },
    {
        id: $fb3ed106a3659591$export$8afcf4edee140deb,
        analyticsKey: 'pastquarterbymonth',
        message: (0, $35hYY.default).pastYearByMonth
    },
    {
        id: $fb3ed106a3659591$export$edb46b113b5df303,
        analyticsKey: 'custom',
        message: (0, $35hYY.default).customDates
    }
];
const $fb3ed106a3659591$export$93ca5d3f8675ae4c = {
    timescaleId: $fb3ed106a3659591$export$f8447a3b6bdf76b0,
    timeBreakdown: (0, $arzTB.TIME_BREAKDOWN_OPTIONS).monthly
};

});
parcelRegister("arzTB", function(module, exports) {

$parcel$export(module.exports, "TIME_BREAKDOWN_OPTIONS", () => $bb80c15a18ab744d$export$88710739a99d72c);
$parcel$export(module.exports, "DROPDOWN_OPTIONS", () => $bb80c15a18ab744d$export$93f40b2c0434cd46);

var $38EUq = parcelRequire("38EUq");
const $bb80c15a18ab744d$export$88710739a99d72c = {
    hourly: 'h',
    daily: 'd',
    weekly: 'w',
    monthly: 'm'
};
const $bb80c15a18ab744d$export$93f40b2c0434cd46 = [
    {
        id: $bb80c15a18ab744d$export$88710739a99d72c.hourly,
        message: (0, $38EUq.default).hourly
    },
    {
        id: $bb80c15a18ab744d$export$88710739a99d72c.daily,
        message: (0, $38EUq.default).daily
    },
    {
        id: $bb80c15a18ab744d$export$88710739a99d72c.weekly,
        message: (0, $38EUq.default).weekly
    },
    {
        id: $bb80c15a18ab744d$export$88710739a99d72c.monthly,
        message: (0, $38EUq.default).monthly
    }
];
const $bb80c15a18ab744d$export$45c85543ba71221d = 'YYYY-MM-DD';

});
parcelRegister("38EUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b862d65058b7215f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b862d65058b7215f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    period: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.period",
        "defaultMessage": "period"
    },
    hourly: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.hourly",
        "defaultMessage": "hourly"
    },
    daily: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.daily",
        "defaultMessage": "daily"
    },
    weekly: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.weekly",
        "defaultMessage": "weekly"
    },
    monthly: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.monthly",
        "defaultMessage": "monthly"
    }
});

});


parcelRegister("35hYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e81d4f3d744c68e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e81d4f3d744c68e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    past48Hours: {
        "id": "servicedesk-reports-common.date-filter.past-48-hours",
        "defaultMessage": "Past 48 hours"
    },
    past7Days: {
        "id": "servicedesk-reports-common.date-filter.past-7-days",
        "defaultMessage": "Past 7 days"
    },
    past14Days: {
        "id": "servicedesk-reports-common.date-filter.past-14-days",
        "defaultMessage": "Past 14 days"
    },
    past30Days: {
        "id": "servicedesk-reports-common.date-filter.past-30-days",
        "defaultMessage": "Past 30 days"
    },
    pastQuarterByDay: {
        "id": "servicedesk-reports-common.date-filter.past-quarter-by-day",
        "defaultMessage": "Past quarter by day"
    },
    pastQuarterByWeek: {
        "id": "servicedesk-reports-common.date-filter.past-quarter-by-week",
        "defaultMessage": "Past quarter by week"
    },
    pastYearByWeek: {
        "id": "servicedesk-reports-common.date-filter.past-year-by-week",
        "defaultMessage": "Past year by week"
    },
    pastYearByMonth: {
        "id": "servicedesk-reports-common.date-filter.past-year-by-month",
        "defaultMessage": "Past year by month"
    },
    customDates: {
        "id": "servicedesk-reports-common.date-filter.custom-dates",
        "defaultMessage": "Custom range"
    },
    dropdownLabel: {
        "id": "servicedesk-reports-common.date-filter.dropdown-label",
        "defaultMessage": "Show"
    }
});

});


parcelRegister("1d28l", function(module, exports) {

$parcel$export(module.exports, "default", () => $23ae1de0a669ff08$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h5xtL = parcelRequire("h5xtL");

var $8RXs9 = parcelRequire("8RXs9");

var $esQIR = parcelRequire("esQIR");

var $8eIEK = parcelRequire("8eIEK");

var $kOyYV = parcelRequire("kOyYV");

var $a0Usa = parcelRequire("a0Usa");

var $gENXG = parcelRequire("gENXG");
const $23ae1de0a669ff08$var$DatePickerGroup = ({ intl: intl, loading: loading, dateTimeBreakdown: dateTimeBreakdown, onUpdate: onUpdate, allowedDateRange: allowedDateRange = (0, $gENXG.getAllowedDateRange)() })=>{
    const [selectedStart, setStart] = (0, $5uXOq.useState)({
        date: dateTimeBreakdown.startDate,
        invalidMessages: []
    });
    const [selectedEnd, setEnd] = (0, $5uXOq.useState)({
        date: dateTimeBreakdown.endDate,
        invalidMessages: []
    });
    const [timeBreakdown, setTimeBreakdown] = (0, $5uXOq.useState)(dateTimeBreakdown.timeBreakdown);
    const updateBtnDisabled = (0, $5uXOq.useMemo)(()=>{
        const isDatePickerInvalid = selectedStart.invalidMessages.length > 0 || selectedEnd.invalidMessages.length > 0;
        if (isDatePickerInvalid) return isDatePickerInvalid;
        return selectedStart.date === dateTimeBreakdown.startDate && selectedEnd.date === dateTimeBreakdown.endDate && timeBreakdown === dateTimeBreakdown.timeBreakdown;
    }, [
        dateTimeBreakdown.endDate,
        dateTimeBreakdown.startDate,
        dateTimeBreakdown.timeBreakdown,
        selectedEnd.date,
        selectedEnd.invalidMessages.length,
        selectedStart.date,
        selectedStart.invalidMessages.length,
        timeBreakdown
    ]);
    const availableTimeBreakdownOptions = (0, $5uXOq.useMemo)(()=>(0, $gENXG.getAvailableOptionsByDateRange)({
            startDate: selectedStart.date,
            endDate: selectedEnd.date
        }), [
        selectedEnd.date,
        selectedStart.date
    ]);
    const selectedTimeBreakdownId = (0, $5uXOq.useMemo)(()=>(0, $gENXG.getTimeBreakdownByDateRange)(availableTimeBreakdownOptions, {
            timeBreakdown: timeBreakdown
        }), [
        availableTimeBreakdownOptions,
        timeBreakdown
    ]);
    const onUpdateButtonClick = (0, $5uXOq.useCallback)(()=>{
        onUpdate({
            startDate: selectedStart.date,
            endDate: selectedEnd.date,
            timeBreakdown: selectedTimeBreakdownId
        });
    }, [
        onUpdate,
        selectedEnd.date,
        selectedStart.date,
        selectedTimeBreakdownId
    ]);
    const onSelectedDateRangeUpdate = ({ type: // @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type.
    type, date: // @ts-expect-error - TS7031 - Binding element 'date' implicitly has an 'any' type.
    date, // @ts-expect-error - TS7031 - Binding element 'startDateErrorMessages' implicitly has an 'any' type. | TS7031 - Binding element 'endDateErrorMessages' implicitly has an 'any' type.
    invalidMessages: { startDateErrorMessages: startDateErrorMessages, endDateErrorMessages: endDateErrorMessages } })=>{
        const isStartDate = type === (0, $esQIR.DATE_PICKER_TYPES).START;
        setStart((prev)=>({
                date: isStartDate ? date : prev.date,
                invalidMessages: startDateErrorMessages
            }));
        setEnd((prev)=>({
                date: isStartDate ? prev.date : date,
                invalidMessages: endDateErrorMessages
            }));
    };
    (0, $5uXOq.useEffect)(()=>{
        setStart({
            date: dateTimeBreakdown.startDate,
            invalidMessages: []
        });
        setEnd({
            date: dateTimeBreakdown.endDate,
            invalidMessages: []
        });
        setTimeBreakdown(dateTimeBreakdown.timeBreakdown);
    }, [
        dateTimeBreakdown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23ae1de0a669ff08$var$GroupedDatePickerWrapper, {
        "data-test-id": "servicedesk-reports-common.ui.date-filter.date-picker-group.grouped-date-picker-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23ae1de0a669ff08$var$Spaced, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8eIEK.default), {
        loading: loading,
        allowedDateRange: allowedDateRange,
        selectedStart: selectedStart,
        selectedEnd: selectedEnd,
        onUpdate: onSelectedDateRangeUpdate
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23ae1de0a669ff08$var$Spaced, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0Usa.default), {
        loading: loading,
        selectedTimeBreakdownId: selectedTimeBreakdownId,
        availableTimeBreakdownOptions: availableTimeBreakdownOptions,
        onTimeBreakdownSelect: (breakdown)=>setTimeBreakdown(breakdown)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23ae1de0a669ff08$var$UpdateButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5xtL.default), {
        isDisabled: !loading && updateBtnDisabled,
        isLoading: loading,
        onClick: onUpdateButtonClick,
        appearance: "primary"
    }, intl.formatMessage((0, $kOyYV.default).update))));
};
var $23ae1de0a669ff08$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($23ae1de0a669ff08$var$DatePickerGroup);
const $23ae1de0a669ff08$var$GroupedDatePickerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23ae1de0a669ff08$var$Spaced = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23ae1de0a669ff08$var$UpdateButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8yhun",
            __cmplp.className
        ])
    });
});

});
parcelRegister("esQIR", function(module, exports) {

$parcel$export(module.exports, "DATE_PICKER_TYPES", () => $cf5b77909bbdc6b3$export$145569f7aadfe842);
const $cf5b77909bbdc6b3$export$145569f7aadfe842 = {
    START: 'start',
    END: 'end'
};

});

parcelRegister("8eIEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $35dd6abae6d5f2cb$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iMZET = parcelRequire("iMZET");

var $8bXez = parcelRequire("8bXez");
var $dyC2h = parcelRequire("dyC2h");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");

var $8TqM4 = parcelRequire("8TqM4");

var $esQIR = parcelRequire("esQIR");

var $g9eUw = parcelRequire("g9eUw");

var $394jw = parcelRequire("394jw");
const $35dd6abae6d5f2cb$var$DatePickerGroup = ({ loading: loading, allowedDateRange: allowedDateRange, selectedStart: selectedStart, selectedEnd: selectedEnd, onUpdate: onUpdate, useLocale: useLocale = (0, $DVljb.useLocale) })=>{
    const locale = useLocale();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getMessages = (startDate, endDate)=>(0, $394jw.dateRangeValidator)(allowedDateRange, {
            startDate: startDate,
            endDate: endDate
        }, formatMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35dd6abae6d5f2cb$var$GroupedDatePickerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35dd6abae6d5f2cb$var$Spaced, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TqM4.LabelWrapper), {
        "data-test-id": "servicedesk-reports-common.ui.date-filter.date-picker-group.connected-date-pickers-with-validator.from-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dyC2h.default), {
        name: "fromDate",
        label: formatMessage((0, $g9eUw.default).from)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMZET.default), {
            testId: "servicedesk-reports-common.ui.date-filter.date-picker-group.connected-date-pickers-with-validator.data-picker-from",
            spacing: "compact",
            value: (0, $1p96B.formatDateStringToISO)(selectedStart.date),
            onChange: (date)=>{
                onUpdate({
                    type: (0, $esQIR.DATE_PICKER_TYPES).START,
                    date: date,
                    invalidMessages: getMessages(date, selectedEnd.date)
                });
            },
            innerProps: {
                style: {
                    width: (0, $gwIPs.gridSize) * 20
                }
            },
            isDisabled: loading,
            locale: locale,
            isInvalid: Boolean(selectedStart.invalidMessages.length)
        }))), selectedStart.invalidMessages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bXez.ErrorMessage), {
            key: message
        }, message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35dd6abae6d5f2cb$var$Spaced, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TqM4.LabelWrapper), {
        "data-test-id": "servicedesk-reports-common.ui.date-filter.date-picker-group.connected-date-pickers-with-validator.to-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dyC2h.default), {
        name: "toDate",
        label: formatMessage((0, $g9eUw.default).to)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMZET.default), {
            testId: "servicedesk-reports-common.ui.date-filter.date-picker-group.connected-date-pickers-with-validator.date-picker-to",
            spacing: "compact",
            value: (0, $1p96B.formatDateStringToISO)(selectedEnd.date),
            onChange: (date)=>{
                onUpdate({
                    type: (0, $esQIR.DATE_PICKER_TYPES).END,
                    date: date,
                    invalidMessages: getMessages(selectedStart.date, date)
                });
            },
            innerProps: {
                style: {
                    width: (0, $gwIPs.gridSize) * 20
                }
            },
            isDisabled: loading,
            locale: locale,
            isInvalid: Boolean(selectedEnd.invalidMessages.length)
        }))), selectedEnd.invalidMessages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bXez.ErrorMessage), {
            key: message
        }, message))));
};
var $35dd6abae6d5f2cb$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $35dd6abae6d5f2cb$var$DatePickerGroup;
const $35dd6abae6d5f2cb$var$GroupedDatePickerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35dd6abae6d5f2cb$var$Spaced = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMZET", function(module, exports) {

$parcel$export(module.exports, "default", () => $194263fe0b434966$export$2e2bcd8739ae039);

var $294ns = parcelRequire("294ns");

var $fDR7v = parcelRequire("fDR7v");

var $f35Dl = parcelRequire("f35Dl");
const $194263fe0b434966$var$DatePicker = (0, $294ns.fg)('dst-date-picker-use-functional-component') ? (0, $f35Dl.default) : (0, $fDR7v.default);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$194263fe0b434966$export$2e2bcd8739ae039 = $194263fe0b434966$var$DatePicker;

});
parcelRegister("fDR7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $51adb654e4b66ee1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $3r9ww = parcelRequire("3r9ww");

var $2JyZq = parcelRequire("2JyZq");
var $g6zRF = parcelRequire("g6zRF");
var $fpTxz = parcelRequire("fpTxz");

var $fhrez = parcelRequire("fhrez");

var $eHVk5 = parcelRequire("eHVk5");

var $9nD7C = parcelRequire("9nD7C");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $j6ZuL = parcelRequire("j6ZuL");
var $8dMtY = parcelRequire("8dMtY");


var $8tUJa = parcelRequire("8tUJa");

var $dsE9W = parcelRequire("dsE9W");

var $lsECc = parcelRequire("lsECc");

var $jIWlP = parcelRequire("jIWlP");

var $cJdyc = parcelRequire("cJdyc");

var $cBg59 = parcelRequire("cBg59");
function $51adb654e4b66ee1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $51adb654e4b66ee1$var$packageName = "platform-pkg";
const $51adb654e4b66ee1$var$packageVersion = "0.0.0-use.local";
const $51adb654e4b66ee1$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
const $51adb654e4b66ee1$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $51adb654e4b66ee1$var$iconContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de)})`,
    insetBlockStart: 0,
    insetInlineEnd: 0,
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`
    }
});
const $51adb654e4b66ee1$var$iconSpacingWithClearButtonStyles = {
    name: "jd0mtf",
    styles: "margin-inline-end:var(--ds-space-400, 2rem)"
};
const $51adb654e4b66ee1$var$iconSpacingWithoutClearButtonStyles = {
    name: "sz3drw",
    styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
};
const $51adb654e4b66ee1$var$calendarButtonStyles = (0, $jJ1Sb.xcss)({
    borderRadius: 'border.radius',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $51adb654e4b66ee1$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $51adb654e4b66ee1$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props);
        this.containerRef = null;
        this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value;
        this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
        this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $lsECc.getParsedISO)({
                    iso: iso
                })
            });
        };
        this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso);
            // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        };
        this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        };
        this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        };
        this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        };
        this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        };
        this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        };
        this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $lsECc.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $cJdyc.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        };
        this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $lsECc.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $cJdyc.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        };
        this.onCalendarButtonKeyDown = (e)=>{
            // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        };
        // This event handler is triggered from both keydown and click. It's weird.
        this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                });
                // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        };
        this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $cJdyc.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        };
        // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        };
        this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        };
        this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $cJdyc.getShortISOString)(new Date()),
            l10n: (0, $eHVk5.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $eHVk5.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: icon = (0, (/*@__PURE__*/$parcel$interopDefault($fhrez))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
        const SingleValue = (0, $cBg59.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $dsE9W.EmptyComponent) : dropDownIcon,
            Menu: $jIWlP.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $dsE9W.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $cJdyc.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $8dMtY.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $lsECc.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ...innerProps,
            css: $51adb654e4b66ee1$var$pickerContainerStyles,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $j6ZuL.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            closeMenuOnSelect: true,
            // FOr some reason, this and the below `styles` type error _only_ show
            // up when you alter some of the properties in the `selectComponents`
            // object. These errors are still present, and I suspect have always
            // been present, without changing the unrelated code. Ignoring as the
            // component still works as expected despite this error. And also
            // because the select refresh team may solve it later.
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $lsECc.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3r9ww.UID), {
            name: (id)=>`open-calendar-label--${id}`
        }, (openCalendarLabelId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: [
                    $51adb654e4b66ee1$var$iconContainerStyles,
                    value && !hideIcon ? $51adb654e4b66ee1$var$iconSpacingWithClearButtonStyles : $51adb654e4b66ee1$var$iconSpacingWithoutClearButtonStyles
                ]
            }, inputLabelId && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8tUJa.default), {
                id: openCalendarLabelId
            }, ", ", openCalendarLabel), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9nD7C.default), {
                ...inputLabelId ? {
                    'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                } : {
                    'aria-label': fullopenCalendarLabel
                },
                onClick: this.onCalendarButtonClick,
                onKeyDown: this.onCalendarButtonKeyDown,
                ref: this.calendarButtonRef,
                testId: testId && `${testId}--open-calendar-button`,
                type: "button",
                backgroundColor: "color.background.neutral.subtle",
                padding: "space.050",
                xcss: $51adb654e4b66ee1$var$calendarButtonStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fhrez))), {
                label: "",
                primaryColor: "var(--ds-icon, #44546F)"
            })))) : null));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $51adb654e4b66ee1$var$DatePicker = (0, $g6zRF.default)({
    componentName: 'datePicker',
    packageName: $51adb654e4b66ee1$var$packageName,
    packageVersion: $51adb654e4b66ee1$var$packageVersion
})((0, $fpTxz.default)({
    onChange: (0, $2JyZq.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $51adb654e4b66ee1$var$packageName,
            packageVersion: $51adb654e4b66ee1$var$packageVersion
        }
    })
})($51adb654e4b66ee1$export$df43d21f5faca9f7));
var $51adb654e4b66ee1$export$2e2bcd8739ae039 = $51adb654e4b66ee1$var$DatePicker;

});
parcelRegister("3r9ww", function(module, exports) {

$parcel$export(module.exports, "UID", () => $280b47e13191fcdf$export$c8b4a4d253b84ce0);

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $7aHWJ = parcelRequire("7aHWJ");
// --------------------------------------------
var $280b47e13191fcdf$var$prefixId = function(id, prefix, name) {
    var uid = prefix + id;
    return String(name ? name(uid) : uid);
};
/**
 * @deprecated
 * UID in form of renderProps (not SSR friendly)
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UID>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UID>
 *
 * // get uid to generate uid for a keys in a list
 * <UID>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UID>
 */ var $280b47e13191fcdf$export$c8b4a4d253b84ce0 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(UID, _super);
    function UID() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            quartz: _this.props.idSource || (0, $7aHWJ.counter),
            prefix: (0, $7aHWJ.getPrefix)(_this.props.idSource),
            id: (0, $7aHWJ.getId)(_this.props.idSource || (0, $7aHWJ.counter))
        };
        _this.uid = function(item) {
            return $280b47e13191fcdf$var$prefixId(_this.state.id + '-' + _this.state.quartz.uid(item), _this.state.prefix, _this.props.name);
        };
        return _this;
    }
    UID.prototype.render = function() {
        var _a = this.props, children = _a.children, name = _a.name;
        var _b = this.state, id = _b.id, prefix = _b.prefix;
        return children($280b47e13191fcdf$var$prefixId(id, prefix, name), this.uid);
    };
    return UID;
}($5uXOq.Component);

});

parcelRegister("fhrez", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1fd91ab0cfe3a15$var$_react = $b1fd91ab0cfe3a15$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $b1fd91ab0cfe3a15$var$_calendar = $b1fd91ab0cfe3a15$var$_interopRequireDefault((parcelRequire("8T1Nu")));
function $b1fd91ab0cfe3a15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b1fd91ab0cfe3a15$var$CalendarIcon = (props)=>/*#__PURE__*/ $b1fd91ab0cfe3a15$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $b1fd91ab0cfe3a15$var$_calendar.default
    }));
$b1fd91ab0cfe3a15$var$CalendarIcon.displayName = 'CalendarIcon';
var $b1fd91ab0cfe3a15$var$_default = module.exports.default = $b1fd91ab0cfe3a15$var$CalendarIcon;

});
parcelRegister("8T1Nu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6784dab29bdae81b$var$_react = $6784dab29bdae81b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6784dab29bdae81b$var$_UNSAFE_baseNew = $6784dab29bdae81b$var$_interopRequireDefault((parcelRequire("huIZN")));
function $6784dab29bdae81b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6784dab29bdae81b$var$CalendarIcon = (props)=>/*#__PURE__*/ $6784dab29bdae81b$var$_react.default.createElement($6784dab29bdae81b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$6784dab29bdae81b$var$CalendarIcon.displayName = 'CalendarIcon';
var $6784dab29bdae81b$var$_default = module.exports.default = $6784dab29bdae81b$var$CalendarIcon;

});


parcelRegister("eHVk5", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $beca549d9ca32888$export$ea56ca58f08ffa52);

var $2godA = parcelRequire("2godA");

var $bVtJk = parcelRequire("bVtJk");

var $6sYdQ = parcelRequire("6sYdQ");
const $beca549d9ca32888$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $2godA.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $bVtJk.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $6sYdQ.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $6sYdQ.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("2godA", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $0ee8170ced636ac4$export$dca0327c9b9c6498);
const $0ee8170ced636ac4$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("bVtJk", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $24e7a006fc814bb9$export$cfa2ef2687faeda2);

var $20BGd = parcelRequire("20BGd");

var $2godA = parcelRequire("2godA");
const $24e7a006fc814bb9$var$INVALID_DATE = new Date(NaN);
const $24e7a006fc814bb9$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $24e7a006fc814bb9$var$INVARIANT_DATE = (0, $20BGd.toDate)($24e7a006fc814bb9$var$INVARIANT);
const $24e7a006fc814bb9$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $24e7a006fc814bb9$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $24e7a006fc814bb9$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $24e7a006fc814bb9$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $24e7a006fc814bb9$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $2godA.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($24e7a006fc814bb9$var$INVARIANT_DATE);
    const shortDate = $24e7a006fc814bb9$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($24e7a006fc814bb9$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $24e7a006fc814bb9$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($24e7a006fc814bb9$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($24e7a006fc814bb9$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($24e7a006fc814bb9$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $24e7a006fc814bb9$var$stripExtras(date).match($24e7a006fc814bb9$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $24e7a006fc814bb9$var$INVALID_DATE;
        const dateParts = $24e7a006fc814bb9$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $20BGd.normalizeDate)(extractedDate);
        if (!(0, $20BGd.isValid)(normalizedDate)) return $24e7a006fc814bb9$var$INVALID_DATE;
        return (0, $20BGd.toDate)(normalizedDate);
    };
};

});
parcelRegister("20BGd", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $8403fe3900105e5d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $8403fe3900105e5d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $8403fe3900105e5d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $8403fe3900105e5d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $8403fe3900105e5d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $8403fe3900105e5d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $8403fe3900105e5d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $8403fe3900105e5d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $8403fe3900105e5d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $8403fe3900105e5d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $8403fe3900105e5d$export$fcc71269590ba0a8 = (date)=>{
    const now = $8403fe3900105e5d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("6sYdQ", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $b149d2dc6cc6d95a$export$9b7ca29af37c192);
const $b149d2dc6cc6d95a$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("dsE9W", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $5fa5866b74db21cc$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $5fa5866b74db21cc$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $5fa5866b74db21cc$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $5fa5866b74db21cc$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $5fa5866b74db21cc$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $5fa5866b74db21cc$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $5fa5866b74db21cc$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $5fa5866b74db21cc$export$5e30e9a24d6c1203 = ()=>null;
const $5fa5866b74db21cc$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $5fa5866b74db21cc$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $5fa5866b74db21cc$export$9e6d8fcf62256b85 = 'h:mma';
const $5fa5866b74db21cc$export$75032c84f56650eb = 'YYYY/MM/DD';
function $5fa5866b74db21cc$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $5fa5866b74db21cc$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("lsECc", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $d08d07b430ac6ddc$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $d08d07b430ac6ddc$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $d08d07b430ac6ddc$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $d08d07b430ac6ddc$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $d08d07b430ac6ddc$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $hpDFZ = parcelRequire("hpDFZ");

var $dsE9W = parcelRequire("dsE9W");
const $d08d07b430ac6ddc$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $d08d07b430ac6ddc$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $dsE9W.padToTwo)(parsedMonth)}-${(0, $dsE9W.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $dsE9W.padToTwo)(parsedMonth)}-${(0, $dsE9W.padToTwo)(parsedDate)}`;
    return newIso;
};
const $d08d07b430ac6ddc$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $dsE9W.defaultDateFormat));
    return l10n.parseDate(date);
};
const $d08d07b430ac6ddc$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $dsE9W.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $hpDFZ.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $d08d07b430ac6ddc$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $dsE9W.placeholderDatetime));
};

});
parcelRegister("hpDFZ", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $abca850af1cf1a04$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $abca850af1cf1a04$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $abca850af1cf1a04$var$v1tokens = Object.keys($abca850af1cf1a04$var$tokensMap).sort().reverse();
const $abca850af1cf1a04$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$abca850af1cf1a04$var$v1tokens.join('|') + '|.)', 'g');
function $abca850af1cf1a04$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($abca850af1cf1a04$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $abca850af1cf1a04$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("jIWlP", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $bd62e889f1a9b5dd$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $fZUVX = parcelRequire("fZUVX");

var $8KWHP = parcelRequire("8KWHP");


var $dtXUS = parcelRequire("dtXUS");

var $eJGlN = parcelRequire("eJGlN");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $bd62e889f1a9b5dd$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $bd62e889f1a9b5dd$var$menuStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: (0, $dtXUS.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $bd62e889f1a9b5dd$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $bd62e889f1a9b5dd$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8KWHP.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eJGlN.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $bd62e889f1a9b5dd$var$menuStyles,
            ...innerProps
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZUVX.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            ref: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("fZUVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a10aba78d841190$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3tZix = parcelRequire("3tZix");

var $ePBXU = parcelRequire("ePBXU");

var $3QrEQ = parcelRequire("3QrEQ");

var $6T4rd = parcelRequire("6T4rd");
var $iaTnv = parcelRequire("iaTnv");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $e2H4F = parcelRequire("e2H4F");

var $lNBvn = parcelRequire("lNBvn");

var $dxCSl = parcelRequire("dxCSl");

var $l2bdC = parcelRequire("l2bdC");

var $dhtom = parcelRequire("dhtom");

var $7drkq = parcelRequire("7drkq");

var $9NzDd = parcelRequire("9NzDd");

var $g0mnA = parcelRequire("g0mnA");

var $8e6SU = parcelRequire("8e6SU");

var $8PdYs = parcelRequire("8PdYs");
const $3a10aba78d841190$var$boxStyles = (0, $jJ1Sb.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $3a10aba78d841190$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3a10aba78d841190$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $l2bdC.blankStringArray), defaultSelected: defaultSelected = (0, $l2bdC.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $ePBXU.default), onChange: onChange = (0, $ePBXU.default), onFocus: onFocus = (0, $ePBXU.default), onSelect: onSelect = (0, $ePBXU.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $dhtom.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$3a10aba78d841190$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $g0mnA.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$3a10aba78d841190$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $8e6SU.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $7drkq.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $8PdYs.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $9NzDd.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $3QrEQ.useId)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        xcss: $3a10aba78d841190$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaTnv.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e2H4F.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dxCSl.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lNBvn.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $3a10aba78d841190$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($3a10aba78d841190$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$3a10aba78d841190$var$Calendar.displayName = 'Calendar';
var $3a10aba78d841190$export$2e2bcd8739ae039 = $3a10aba78d841190$var$Calendar;

});
parcelRegister("e2H4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $0daa17a0d5bc5b46$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $e0OK7 = parcelRequire("e0OK7");

var $3QrEQ = parcelRequire("3QrEQ");

var $53KbV = parcelRequire("53KbV");

var $8IaEt = parcelRequire("8IaEt");

var $kerag = parcelRequire("kerag");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
const $0daa17a0d5bc5b46$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $3QrEQ.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsFR3.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e0OK7.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8IaEt))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $53KbV.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e0OK7.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kerag))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$0daa17a0d5bc5b46$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0daa17a0d5bc5b46$export$2e2bcd8739ae039 = $0daa17a0d5bc5b46$var$Header;

});
parcelRegister("8IaEt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $657ab203f947a458$var$_react = $657ab203f947a458$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $657ab203f947a458$var$_chevronLeft = $657ab203f947a458$var$_interopRequireDefault((parcelRequire("afR4G")));
function $657ab203f947a458$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $657ab203f947a458$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $657ab203f947a458$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $657ab203f947a458$var$_chevronLeft.default,
        iconType: "utility"
    }));
$657ab203f947a458$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $657ab203f947a458$var$_default = module.exports.default = $657ab203f947a458$var$ChevronLeftLargeIcon;

});
parcelRegister("afR4G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7774799861463016$var$_react = $7774799861463016$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7774799861463016$var$_UNSAFE_baseNew = $7774799861463016$var$_interopRequireDefault((parcelRequire("huIZN")));
function $7774799861463016$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7774799861463016$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $7774799861463016$var$_react.default.createElement($7774799861463016$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$7774799861463016$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $7774799861463016$var$_default = module.exports.default = $7774799861463016$var$ChevronLeftIcon;

});


parcelRegister("kerag", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebaa2fc30df9d900$var$_react = $ebaa2fc30df9d900$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $ebaa2fc30df9d900$var$_chevronRight = $ebaa2fc30df9d900$var$_interopRequireDefault((parcelRequire("cSFUi")));
function $ebaa2fc30df9d900$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ebaa2fc30df9d900$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $ebaa2fc30df9d900$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $ebaa2fc30df9d900$var$_chevronRight.default,
        iconType: "utility"
    }));
$ebaa2fc30df9d900$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $ebaa2fc30df9d900$var$_default = module.exports.default = $ebaa2fc30df9d900$var$ChevronRightLargeIcon;

});


parcelRegister("lNBvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $56433f20ede2a194$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6T4rd = parcelRequire("6T4rd");

var $49WxS = parcelRequire("49WxS");

var $c0Opl = parcelRequire("c0Opl");
const $56433f20ede2a194$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $c0Opl.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $49WxS.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$56433f20ede2a194$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$56433f20ede2a194$export$2e2bcd8739ae039 = $56433f20ede2a194$var$WeekDays;

});
parcelRegister("49WxS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73dc067193e150$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ePBXU = parcelRequire("ePBXU");

var $c9Fym = parcelRequire("c9Fym");

var $77sxg = parcelRequire("77sxg");
const $5f73dc067193e150$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $ePBXU.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $77sxg.dateCellStyles)());
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $c9Fym.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$5f73dc067193e150$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5f73dc067193e150$export$2e2bcd8739ae039 = $5f73dc067193e150$var$Date;

});
parcelRegister("77sxg", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $074dee9326c0d7e2$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

const $074dee9326c0d7e2$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$fbda843f0a27fe96})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $5e0c0d4e15efb4a6$export$226de0355ed012f8})`,
            color: `var(--ds-text-subtle, ${0, $5e0c0d4e15efb4a6$export$7090862dc3038a9f})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
            color: `var(--ds-text-selected, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$215b7063051591f1})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`,
            color: `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$fbda843f0a27fe96})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $5e0c0d4e15efb4a6$export$226de0355ed012f8})`,
            color: `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$fbda843f0a27fe96})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $5e0c0d4e15efb4a6$export$226de0355ed012f8})`,
            color: `var(--ds-text-selected, ${0, $5e0c0d4e15efb4a6$export$7090862dc3038a9f})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $5e0c0d4e15efb4a6$export$7090862dc3038a9f})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`
        }
    });

});


parcelRegister("c0Opl", function(module, exports) {

$parcel$export(module.exports, "default", () => $892445821ceea5d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $c9Fym = parcelRequire("c9Fym");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $892445821ceea5d0$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $c9Fym.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $892445821ceea5d0$export$2e2bcd8739ae039 = $892445821ceea5d0$var$WeekDayGrid;

});


parcelRegister("dxCSl", function(module, exports) {

$parcel$export(module.exports, "default", () => $641dbc16bad96c90$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6T4rd = parcelRequire("6T4rd");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $c0Opl = parcelRequire("c0Opl");
const $641dbc16bad96c90$var$columnHeaderStyles = (0, $jJ1Sb.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $641dbc16bad96c90$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $c0Opl.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
            padding: "space.100",
            xcss: $641dbc16bad96c90$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1m92z.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$641dbc16bad96c90$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$641dbc16bad96c90$export$2e2bcd8739ae039 = $641dbc16bad96c90$var$WeekHeader;

});

parcelRegister("l2bdC", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $51dab726948f3f64$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $51dab726948f3f64$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $51dab726948f3f64$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $51dab726948f3f64$export$8fa20d70624f8b9d);
const $51dab726948f3f64$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $51dab726948f3f64$export$3ae905d9742bef55 = 7;
const $51dab726948f3f64$export$c9b7c010035d60c6 = 12;
const $51dab726948f3f64$export$8fa20d70624f8b9d = [];

});

parcelRegister("dhtom", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fce51027aca689a$export$2e2bcd8739ae039);

var $hpEeR = parcelRequire("hpEeR");

var $5c4Nn = parcelRequire("5c4Nn");

var $7oimc = parcelRequire("7oimc");
function $7fce51027aca689a$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $5c4Nn.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $hpEeR.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $hpEeR.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $hpEeR.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $hpEeR.default)(today, ()=>today || `${thisYear}-${(0, $7oimc.default)(thisMonth)}-${(0, $7oimc.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $hpEeR.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $hpEeR.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("7oimc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c5d108b6cf0d51a$export$2e2bcd8739ae039);
function $9c5d108b6cf0d51a$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("7drkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1614a6ec3d0fe0c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $1614a6ec3d0fe0c3$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("9NzDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc50e103646c0514$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $l2bdC = parcelRequire("l2bdC");

var $d5wvi = parcelRequire("d5wvi");

var $kwGX8 = parcelRequire("kwGX8");
function $dc50e103646c0514$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $l2bdC.daysPerWeek) : 0;
            return (0, $kwGX8.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $l2bdC.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $dc50e103646c0514$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $kwGX8.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $dc50e103646c0514$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $d5wvi.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("d5wvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e8121e87eaab5f$export$2e2bcd8739ae039);

var $7oimc = parcelRequire("7oimc");
function $b5e8121e87eaab5f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $7oimc.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $7oimc.default)(date.day)}`;
}

});

parcelRegister("kwGX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e4bd2d06ec0ba5$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $l2bdC = parcelRequire("l2bdC");

var $a1AqW = parcelRequire("a1AqW");
function $a9e4bd2d06ec0ba5$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $l2bdC.daysPerWeek) - weekStartDay + firstDay) % (0, $l2bdC.daysPerWeek));
    const lastDate = (0, $a1AqW.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $l2bdC.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $a1AqW.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $l2bdC.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $l2bdC.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $l2bdC.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $l2bdC.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $l2bdC.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("a1AqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $890481769aa6c8df$export$2e2bcd8739ae039);
function $890481769aa6c8df$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("g0mnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f20decb63cb215$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l2bdC = parcelRequire("l2bdC");

var $d5wvi = parcelRequire("d5wvi");

var $a1AqW = parcelRequire("a1AqW");
const $72f20decb63cb215$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $l2bdC.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $72f20decb63cb215$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $l2bdC.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $72f20decb63cb215$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $d5wvi.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $l2bdC.daysPerWeek);
            const daysInMonth = (0, $a1AqW.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $72f20decb63cb215$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $72f20decb63cb215$var$getPrevMonth(month, year);
                const prevDay = (0, $a1AqW.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $a1AqW.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $72f20decb63cb215$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $l2bdC.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $72f20decb63cb215$var$getPrevMonth(month, year);
                const prevDay = (0, $a1AqW.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$72f20decb63cb215$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$72f20decb63cb215$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("8e6SU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d99a4f412fd0590$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l2bdC = parcelRequire("l2bdC");

var $d5wvi = parcelRequire("d5wvi");
function $2d99a4f412fd0590$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $d5wvi.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $l2bdC.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("8PdYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ffcfba11c61dd24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eHVk5 = parcelRequire("eHVk5");
function $8ffcfba11c61dd24$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $eHVk5.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("eJGlN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4b64271ac61665b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ePBXU = parcelRequire("ePBXU");

var $8k1fW = parcelRequire("8k1fW");

var $jDJCA = parcelRequire("jDJCA");
var $3IXTh = parcelRequire("3IXTh");
var $2Semz = parcelRequire("2Semz");

var $dtXUS = parcelRequire("dtXUS");
class $e4b64271ac61665b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $8k1fW.sizes).small.slice(0, -2)) - (0, $dtXUS.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDJCA.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Semz.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IXTh.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $dtXUS.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        this.update = (0, $ePBXU.default);
    }
}

});


parcelRegister("cJdyc", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $8329be04119670f7$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $8329be04119670f7$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $hpDFZ = parcelRequire("hpDFZ");
function $8329be04119670f7$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $hpDFZ.convertTokens)('YYYY-MM-DD'));
}
function $8329be04119670f7$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $8329be04119670f7$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("cBg59", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $bb066c57970f011c$export$6e30bf8cb1347b56);

var $5uXOq = parcelRequire("5uXOq");

var $32eUr = parcelRequire("32eUr");
const $bb066c57970f011c$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
            theme: theme
        }, children);
    };

});


parcelRegister("f35Dl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2555fccca29841a5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $22Gxp = parcelRequire("22Gxp");

var $3tZix = parcelRequire("3tZix");

var $fhrez = parcelRequire("fhrez");

var $eHVk5 = parcelRequire("eHVk5");

var $9nD7C = parcelRequire("9nD7C");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $j6ZuL = parcelRequire("j6ZuL");
var $8dMtY = parcelRequire("8dMtY");


var $8tUJa = parcelRequire("8tUJa");

var $dsE9W = parcelRequire("dsE9W");

var $lsECc = parcelRequire("lsECc");

var $jIWlP = parcelRequire("jIWlP");

var $cJdyc = parcelRequire("cJdyc");

var $cBg59 = parcelRequire("cBg59");
function $2555fccca29841a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2555fccca29841a5$var$packageName = "platform-pkg";
const $2555fccca29841a5$var$packageVersion = "0.0.0-use.local";
const $2555fccca29841a5$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $2555fccca29841a5$var$packageName,
    packageVersion: $2555fccca29841a5$var$packageVersion
};
const $2555fccca29841a5$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $2555fccca29841a5$var$iconContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de)})`,
    insetBlockStart: 0,
    insetInlineEnd: 0,
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`
    }
});
const $2555fccca29841a5$var$iconSpacingWithClearButtonStyles = {
    name: "jd0mtf",
    styles: "margin-inline-end:var(--ds-space-400, 2rem)"
};
const $2555fccca29841a5$var$iconSpacingWithoutClearButtonStyles = {
    name: "sz3drw",
    styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
};
const $2555fccca29841a5$var$calendarButtonStyles = (0, $jJ1Sb.xcss)({
    borderRadius: 'border.radius',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $2555fccca29841a5$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: icon = (0, (/*@__PURE__*/$parcel$interopDefault($fhrez))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $cJdyc.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $eHVk5.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$2555fccca29841a5$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $eHVk5.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false);
            // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $lsECc.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso);
        // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $lsECc.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            });
            // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $cJdyc.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase();
        // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $lsECc.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $cJdyc.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (isOpen && !shouldSetFocusOnCurrentDay) setShouldSetFocusOnCurrentDay(true);
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    };
    // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $cJdyc.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    };
    // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref;
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
    const SingleValue = (0, $cBg59.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        DropdownIndicator: shouldShowCalendarButton ? (0, $dsE9W.EmptyComponent) : dropDownIcon,
        Menu: $jIWlP.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $dsE9W.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $cJdyc.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
    };
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $8dMtY.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $lsECc.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null;
    // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $22Gxp.useUID)()}`;
    return(// These event handlers must be on this element because the events come
    // from different child elements.
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...innerProps,
        css: $2555fccca29841a5$var$pickerContainerStyles,
        role: "presentation",
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        "data-testid": testId && `${testId}--container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        name: name,
        type: "hidden",
        value: getterValue,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $j6ZuL.default), {
        appearance: appearance,
        "aria-describedby": ariaDescribedBy,
        "aria-label": label || undefined,
        autoFocus: autoFocus,
        closeMenuOnSelect: true,
        // For some reason, this and the below `styles` type error _only_ show
        // up when you alter some of the properties in the `selectComponents`
        // object. These errors are still present, and I suspect have always
        // been present, without changing the unrelated code. Ignoring as the
        // component still works as expected despite this error. And also
        // because the select refresh team may solve it later.
        components: selectComponents,
        enableAnimation: false,
        inputId: id,
        inputValue: actualSelectInputValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: menuIsOpen,
        onBlur: onSelectBlur,
        onChange: onSelectChange,
        onFocus: onSelectFocus,
        onInputChange: handleSelectInputChange,
        placeholder: (0, $lsECc.getPlaceholder)({
            placeholder: placeholder,
            l10n: l10n
        }),
        styles: mergedStyles,
        value: initialValue,
        ...selectProps,
        // These are below the spread because I don't know what is in
        // selectProps or not and what wil be overwritten
        isClearable: true,
        isInvalid: isInvalid,
        spacing: spacing,
        testId: testId,
        // These aren't part of `Select`'s API, but we're using them here.
        // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
        calendarContainerRef: calendarProps.calendarContainerRef,
        calendarDisabled: calendarProps.calendarDisabled,
        calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
        calendarLocale: calendarProps.calendarLocale,
        calendarMaxDate: calendarProps.calendarMaxDate,
        calendarMinDate: calendarProps.calendarMinDate,
        calendarRef: calendarProps.calendarRef,
        calendarValue: calendarProps.calendarValue,
        calendarView: calendarProps.calendarView,
        calendarWeekStartDay: calendarProps.calendarWeekStartDay,
        nextMonthLabel: nextMonthLabel,
        onCalendarChange: calendarProps.onCalendarChange,
        onCalendarSelect: calendarProps.onCalendarSelect,
        previousMonthLabel: previousMonthLabel,
        shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
    }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $2555fccca29841a5$var$iconContainerStyles,
            value && !hideIcon ? $2555fccca29841a5$var$iconSpacingWithClearButtonStyles : $2555fccca29841a5$var$iconSpacingWithoutClearButtonStyles
        ]
    }, inputLabelId && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8tUJa.default), {
        id: openCalendarLabelId
    }, ", ", openCalendarLabel), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9nD7C.default), {
        ...inputLabelId ? {
            'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
        } : {
            'aria-label': fullopenCalendarLabel
        },
        onClick: onCalendarButtonClick,
        onKeyDown: onCalendarButtonKeyDown,
        ref: calendarButtonRef,
        testId: testId && `${testId}--open-calendar-button`,
        type: "button",
        backgroundColor: "color.background.neutral.subtle",
        padding: "space.050",
        xcss: $2555fccca29841a5$var$calendarButtonStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fhrez))), {
        label: "",
        primaryColor: "var(--ds-icon, #44546F)"
    }))) : null));
});
var $2555fccca29841a5$export$2e2bcd8739ae039 = $2555fccca29841a5$var$DatePicker;

});


parcelRegister("8bXez", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $4e3d8c01d2a81fb6$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $4e3d8c01d2a81fb6$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $4e3d8c01d2a81fb6$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $4e3d8c01d2a81fb6$export$ec445f12f63100a5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jCvxE = parcelRequire("jCvxE");

var $2RHN3 = parcelRequire("2RHN3");


var $dfjsA = parcelRequire("dfjsA");
function $4e3d8c01d2a81fb6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4e3d8c01d2a81fb6$var$messageStyles = {
    name: "drnq1s",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $4e3d8c01d2a81fb6$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $f8Sb3.css)({
        color: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $4e3d8c01d2a81fb6$var$iconWrapperStyles = {
    name: "x5c876",
    styles: "display:flex;height:16px;align-items:center"
};
const $4e3d8c01d2a81fb6$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $4e3d8c01d2a81fb6$var$iconWrapperStyles
    }, children);
};
const $4e3d8c01d2a81fb6$var$messageIcons = {
    error: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jCvxE))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2RHN3))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $4e3d8c01d2a81fb6$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $4e3d8c01d2a81fb6$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($4e3d8c01d2a81fb6$export$579aef2c392a54d4);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $4e3d8c01d2a81fb6$var$messageStyles,
            $4e3d8c01d2a81fb6$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$var$IconWrapper, null, icon), content);
};
const $4e3d8c01d2a81fb6$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfjsA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $4e3d8c01d2a81fb6$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfjsA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $4e3d8c01d2a81fb6$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfjsA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $4e3d8c01d2a81fb6$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $4e3d8c01d2a81fb6$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("jCvxE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0499610e65a8e7f9250a345ef46c32f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e48a08784a3e0842$var$_react = $e48a08784a3e0842$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e48a08784a3e0842$var$_error = $e48a08784a3e0842$var$_interopRequireDefault((parcelRequire("cNpa3")));

var $e48a08784a3e0842$var$_error2 = $e48a08784a3e0842$var$_interopRequireDefault((parcelRequire("2OiHg")));
function $e48a08784a3e0842$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e48a08784a3e0842$var$ErrorIcon = (props)=>/*#__PURE__*/ $e48a08784a3e0842$var$_react.default.createElement($e48a08784a3e0842$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $e48a08784a3e0842$var$_error2.default
    }, props));
$e48a08784a3e0842$var$ErrorIcon.Name = 'ErrorIconMigration';
var $e48a08784a3e0842$var$_default = module.exports.default = $e48a08784a3e0842$var$ErrorIcon;

});
parcelRegister("cNpa3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbdb3f80d4bcdf634ad3eb6ad4125bf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $950d941f0f78ad03$var$_react = $950d941f0f78ad03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $950d941f0f78ad03$var$_UNSAFE_baseNew = $950d941f0f78ad03$var$_interopRequireDefault((parcelRequire("huIZN")));
function $950d941f0f78ad03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $950d941f0f78ad03$var$ErrorIcon = (props)=>/*#__PURE__*/ $950d941f0f78ad03$var$_react.default.createElement($950d941f0f78ad03$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$950d941f0f78ad03$var$ErrorIcon.displayName = 'ErrorIcon';
var $950d941f0f78ad03$var$_default = module.exports.default = $950d941f0f78ad03$var$ErrorIcon;

});


parcelRegister("2RHN3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c91b2071a3b78298cdb1ab35dcf13197>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21627fd92ef76332$var$_react = $21627fd92ef76332$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21627fd92ef76332$var$_success = $21627fd92ef76332$var$_interopRequireDefault((parcelRequire("kRI53")));

var $21627fd92ef76332$var$_success2 = $21627fd92ef76332$var$_interopRequireDefault((parcelRequire("gwvLf")));
function $21627fd92ef76332$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21627fd92ef76332$var$SuccessIcon = (props)=>/*#__PURE__*/ $21627fd92ef76332$var$_react.default.createElement($21627fd92ef76332$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $21627fd92ef76332$var$_success2.default
    }, props));
$21627fd92ef76332$var$SuccessIcon.Name = 'SuccessIconMigration';
var $21627fd92ef76332$var$_default = module.exports.default = $21627fd92ef76332$var$SuccessIcon;

});
parcelRegister("kRI53", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f46e0408994ee0eebe07fdde2651636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f30af3557ea4f8de$var$_react = $f30af3557ea4f8de$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f30af3557ea4f8de$var$_UNSAFE_baseNew = $f30af3557ea4f8de$var$_interopRequireDefault((parcelRequire("huIZN")));
function $f30af3557ea4f8de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f30af3557ea4f8de$var$SuccessIcon = (props)=>/*#__PURE__*/ $f30af3557ea4f8de$var$_react.default.createElement($f30af3557ea4f8de$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$f30af3557ea4f8de$var$SuccessIcon.displayName = 'SuccessIcon';
var $f30af3557ea4f8de$var$_default = module.exports.default = $f30af3557ea4f8de$var$SuccessIcon;

});

parcelRegister("gwvLf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c078459a20aa5362$var$_react = $c078459a20aa5362$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $c078459a20aa5362$var$_success = $c078459a20aa5362$var$_interopRequireDefault((parcelRequire("6K6ZN")));
function $c078459a20aa5362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c078459a20aa5362$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $c078459a20aa5362$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $c078459a20aa5362$var$_success.default
    }));
$c078459a20aa5362$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $c078459a20aa5362$var$_default = module.exports.default = $c078459a20aa5362$var$EditorSuccessIcon;

});
parcelRegister("6K6ZN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e8c772aea92ac0c$var$_react = $4e8c772aea92ac0c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4e8c772aea92ac0c$var$_UNSAFE_baseNew = $4e8c772aea92ac0c$var$_interopRequireDefault((parcelRequire("huIZN")));
function $4e8c772aea92ac0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e8c772aea92ac0c$var$SuccessIcon = (props)=>/*#__PURE__*/ $4e8c772aea92ac0c$var$_react.default.createElement($4e8c772aea92ac0c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$4e8c772aea92ac0c$var$SuccessIcon.displayName = 'SuccessIcon';
var $4e8c772aea92ac0c$var$_default = module.exports.default = $4e8c772aea92ac0c$var$SuccessIcon;

});




parcelRegister("g9eUw", function(module, exports) {

$parcel$export(module.exports, "default", () => $458221e87e426e9b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $458221e87e426e9b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    from: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.from",
        "defaultMessage": "From"
    },
    to: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.to",
        "defaultMessage": "To"
    }
});

});

parcelRegister("394jw", function(module, exports) {

$parcel$export(module.exports, "dateRangeValidator", () => $b56e714a18050279$export$4b1ad2ad4172d1e7);

var $kQZsR = parcelRequire("kQZsR");

var $gwejS = parcelRequire("gwejS");

var $g7reD = parcelRequire("g7reD");

var $k7m40 = parcelRequire("k7m40");

var $jovBr = parcelRequire("jovBr");

var $el0er = parcelRequire("el0er");

var $bJgtF = parcelRequire("bJgtF");
const $b56e714a18050279$export$45c85543ba71221d = 'yyyy/MM/dd';
const $b56e714a18050279$export$aa350b96d91cd94 = (dateString)=>// @ts-expect-error - TS2769 - No overload matches this call.
    (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(dateString) ? new Date() : new Date(dateString);
const $b56e714a18050279$export$4b1ad2ad4172d1e7 = (allowedDateRange, selectedDateRange, formatMessage)=>{
    const { min: min, max: max } = allowedDateRange;
    const start = (0, $el0er.default)($b56e714a18050279$export$aa350b96d91cd94(selectedDateRange.startDate));
    const end = (0, $el0er.default)($b56e714a18050279$export$aa350b96d91cd94(selectedDateRange.endDate));
    const startDateErrorMessages = [];
    const endDateErrorMessages = [];
    if (!(0, $jovBr.default)(start)) startDateErrorMessages.push(formatMessage((0, $bJgtF.default).invalidFrom));
    if (!(0, $jovBr.default)(end)) endDateErrorMessages.push(formatMessage((0, $bJgtF.default).invalidTo));
    if (startDateErrorMessages.length || endDateErrorMessages.length) return {
        startDateErrorMessages: startDateErrorMessages,
        endDateErrorMessages: endDateErrorMessages
    };
    if ((0, $g7reD.default)(start, max) > 0) startDateErrorMessages.push(formatMessage((0, $bJgtF.default).futureStartDateValidationMessage, {
        date: (0, $k7m40.default)(max, $b56e714a18050279$export$45c85543ba71221d)
    }));
    if ((0, $g7reD.default)(min, start) > 0) startDateErrorMessages.push(formatMessage((0, $bJgtF.default).maxFromDateExceededMessage, {
        date: (0, $k7m40.default)((0, $gwejS.default)(min, 1), $b56e714a18050279$export$45c85543ba71221d)
    }));
    if ((0, $g7reD.default)(start, end) > 0) startDateErrorMessages.push(formatMessage((0, $bJgtF.default).fromDateExceededMessage));
    if ((0, $g7reD.default)(end, max) > 0) endDateErrorMessages.push(formatMessage((0, $bJgtF.default).futureEndDateValidationMessage, {
        date: (0, $k7m40.default)(max, $b56e714a18050279$export$45c85543ba71221d)
    }));
    return {
        startDateErrorMessages: startDateErrorMessages,
        endDateErrorMessages: endDateErrorMessages
    };
};

});
parcelRegister("kQZsR", function(module, exports) {
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function $f2e8578be8331871$var$isNull(value) {
    return value === null;
}
module.exports = $f2e8578be8331871$var$isNull;

});

parcelRegister("bJgtF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fedcddbde8f6684d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fedcddbde8f6684d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    invalidFrom: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.invalid-from",
        "defaultMessage": "From date must be valid date"
    },
    invalidTo: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.invalid-to",
        "defaultMessage": "To date must be valid date"
    },
    futureStartDateValidationMessage: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.future-start-date-validation-message",
        "defaultMessage": "From date must not be after {date}"
    },
    futureEndDateValidationMessage: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.future-end-date-validation-message",
        "defaultMessage": "To date must not be after {date}"
    },
    maxFromDateExceededMessage: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.max-from-date-exceeded-message",
        "defaultMessage": "From date range cannot be longer than {date}"
    },
    fromDateExceededMessage: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.from-date-exceeded-message",
        "defaultMessage": "From date must be before To date"
    }
});

});



parcelRegister("kOyYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f31077416b2729a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f31077416b2729a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    from: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.from",
        "defaultMessage": "From"
    },
    to: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.to",
        "defaultMessage": "To"
    },
    update: {
        "id": "servicedesk-reports-common.date-filter.date-picker-group.update",
        "defaultMessage": "Update"
    }
});

});

parcelRegister("a0Usa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0341d20458b8f2a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Agsd = parcelRequire("8Agsd");
var $feGGA = parcelRequire("feGGA");
var $iDxSW = parcelRequire("iDxSW");

var $dyC2h = parcelRequire("dyC2h");

var $8RXs9 = parcelRequire("8RXs9");

var $8TqM4 = parcelRequire("8TqM4");

var $arzTB = parcelRequire("arzTB");

var $38EUq = parcelRequire("38EUq");

var $1YZdF = parcelRequire("1YZdF");
const $a0341d20458b8f2a$var$TimeBreakdownDropdown = ({ intl: intl, loading: loading, selectedTimeBreakdownId: selectedTimeBreakdownId, availableTimeBreakdownOptions: availableTimeBreakdownOptions, onTimeBreakdownSelect: onTimeBreakdownSelect })=>{
    const [open, setOpen] = (0, $5uXOq.useState)(false);
    const onDropdownSelect = (0, $5uXOq.useCallback)(({ id: id })=>{
        onTimeBreakdownSelect(id);
    }, [
        onTimeBreakdownSelect
    ]);
    const toggleDropdown = ()=>setOpen((isOpen)=>!isOpen);
    const dropdownOptions = (0, $5uXOq.useMemo)(()=>(0, $arzTB.DROPDOWN_OPTIONS).map(({ id: id, message: message })=>({
                id: id,
                message: intl.formatMessage(message)
            })), [
        intl
    ]);
    const selectedOption = (0, $5uXOq.useMemo)(()=>(0, $1YZdF.getSelectedOptionByTimeBreakdown)(dropdownOptions, selectedTimeBreakdownId), [
        dropdownOptions,
        selectedTimeBreakdownId
    ]);
    const dropdownItems = (0, $5uXOq.useMemo)(()=>{
        const { validOptions: validOptions } = availableTimeBreakdownOptions;
        return dropdownOptions.map((item)=>item.id !== selectedOption.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feGGA.default), {
                key: item.id,
                onClick: ()=>onDropdownSelect(item),
                isDisabled: loading || !validOptions.includes(item.id)
            }, item.message) : null);
    }, [
        availableTimeBreakdownOptions,
        dropdownOptions,
        loading,
        onDropdownSelect,
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "servicedesk-reports-common.ui.date-filter.date-picker-group.time-breakdown.time-breakdown-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TqM4.LabelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dyC2h.default), {
        name: "period",
        label: intl.formatMessage((0, $38EUq.default).period)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Agsd.default), {
            trigger: selectedOption.message,
            isOpen: open,
            onOpenChange: toggleDropdown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDxSW.default), null, dropdownItems))))));
};
var $a0341d20458b8f2a$export$2e2bcd8739ae039 = (0, $8RXs9.default)($a0341d20458b8f2a$var$TimeBreakdownDropdown);

});
parcelRegister("feGGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3706e29c1e2d34bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $oUGyo = parcelRequire("oUGyo");

var $6PItG = parcelRequire("6PItG");

var $eIm7r = parcelRequire("eIm7r");

var $jJ62p = parcelRequire("jJ62p");

var $294ns = parcelRequire("294ns");

var $7jhTK = parcelRequire("7jhTK");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $3706e29c1e2d34bd$var$DropdownMenuItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
    const itemRef = (0, $7jhTK.default)();
    const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIm7r.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJ62p.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
});
var $3706e29c1e2d34bd$export$2e2bcd8739ae039 = $3706e29c1e2d34bd$var$DropdownMenuItem;

});

parcelRegister("iDxSW", function(module, exports) {

$parcel$export(module.exports, "default", () => $451ae845e5759506$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3QrEQ = parcelRequire("3QrEQ");

var $Hi7fY = parcelRequire("Hi7fY");

var $7SSAv = parcelRequire("7SSAv");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $451ae845e5759506$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $3QrEQ.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7SSAv.default), {
        id: titleId,
        title: title
    }), children);
});
var $451ae845e5759506$export$2e2bcd8739ae039 = $451ae845e5759506$var$DropdownMenuItemGroup;

});

parcelRegister("1YZdF", function(module, exports) {

$parcel$export(module.exports, "getSelectedOptionByTimeBreakdown", () => $0f6cf846a9cb5b5b$export$48f5cf1e86210a8e);
const $0f6cf846a9cb5b5b$export$48f5cf1e86210a8e = (options, timeBreakdown)=>{
    const idx = options.findIndex((option)=>option.id === timeBreakdown);
    return options[idx];
};

});


parcelRegister("gENXG", function(module, exports) {

$parcel$export(module.exports, "getAvailableOptionsByDateRange", () => $84b191b07506f571$export$de7d264907d0bed2);
$parcel$export(module.exports, "getTimeBreakdownByDateRange", () => $84b191b07506f571$export$f33126db3bb7a7d2);
$parcel$export(module.exports, "getAllowedDateRange", () => $84b191b07506f571$export$9b1b1e3f65b0efed);

var $hGgHi = parcelRequire("hGgHi");

var $kQZsR = parcelRequire("kQZsR");

var $4mBKK = parcelRequire("4mBKK");

var $70Rr2 = parcelRequire("70Rr2");

var $it1wb = parcelRequire("it1wb");

var $1WDNN = parcelRequire("1WDNN");

var $arzTB = parcelRequire("arzTB");
const $84b191b07506f571$var$getDate = (dateString)=>// @ts-expect-error - TS2769 - No overload matches this call.
    (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(dateString) ? new Date() : new Date(dateString);
const $84b191b07506f571$export$de7d264907d0bed2 = (dateTimeBreakdown)=>{
    const result = {
        validOptions: [],
        defaultOption: (0, $arzTB.TIME_BREAKDOWN_OPTIONS).monthly
    };
    const startDate = $84b191b07506f571$var$getDate(dateTimeBreakdown.startDate);
    const endDate = $84b191b07506f571$var$getDate(dateTimeBreakdown.endDate);
    const daysInBetween = (0, $4mBKK.default)(endDate, startDate);
    if (daysInBetween < 3) {
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).hourly);
        result.defaultOption = (0, $arzTB.TIME_BREAKDOWN_OPTIONS).hourly;
    } else if (daysInBetween < 5) {
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).hourly);
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).daily);
        result.defaultOption = (0, $arzTB.TIME_BREAKDOWN_OPTIONS).hourly;
    } else if (daysInBetween < 14) {
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).daily);
        result.defaultOption = (0, $arzTB.TIME_BREAKDOWN_OPTIONS).daily;
    } else if (daysInBetween < 28) {
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).daily);
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).weekly);
        result.defaultOption = (0, $arzTB.TIME_BREAKDOWN_OPTIONS).daily;
    } else if (daysInBetween < 60) {
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).daily);
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).weekly);
        result.defaultOption = (0, $arzTB.TIME_BREAKDOWN_OPTIONS).weekly;
    } else if (daysInBetween < 92) {
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).daily);
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).weekly);
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).monthly);
        result.defaultOption = (0, $arzTB.TIME_BREAKDOWN_OPTIONS).weekly;
    } else if (daysInBetween < 180) {
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).weekly);
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).monthly);
        result.defaultOption = (0, $arzTB.TIME_BREAKDOWN_OPTIONS).weekly;
    } else if (daysInBetween < 366) {
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).weekly);
        result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).monthly);
        result.defaultOption = (0, $arzTB.TIME_BREAKDOWN_OPTIONS).monthly;
    } else result.validOptions.push((0, $arzTB.TIME_BREAKDOWN_OPTIONS).monthly);
    return result;
};
const $84b191b07506f571$export$f33126db3bb7a7d2 = (availableOptions, dateQuery)=>{
    const { validOptions: validOptions, defaultOption: defaultOption } = availableOptions;
    return dateQuery.timeBreakdown && validOptions.includes(dateQuery.timeBreakdown) ? dateQuery.timeBreakdown : defaultOption;
};
const $84b191b07506f571$export$9b1b1e3f65b0efed = (dateStr)=>{
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(dateStr) ? new Date() : new Date(dateStr);
    const endDate = (0, $70Rr2.default)(date);
    const startDate = new Date((0, $1WDNN.default)((0, $it1wb.default)(date), 1));
    return {
        min: startDate,
        max: endDate
    };
};

});


parcelRegister("2XnCQ", function(module, exports) {

$parcel$export(module.exports, "mapToDateQuery", () => $5b7b62e058c17691$export$34b1bc5528be50fe);
$parcel$export(module.exports, "getSelectedOptionByRouterProps", () => $5b7b62e058c17691$export$7f7630742786ff6a);

var $k74Ot = parcelRequire("k74Ot");

var $gENXG = parcelRequire("gENXG");
const $5b7b62e058c17691$export$a0c0a3d47691e36a = ({ timescaleId: timescaleId }, defaultTimescaleId)=>Number(timescaleId) || Number(defaultTimescaleId) || (0, $k74Ot.DEFAULT_OPTIONS).timescaleId;
const $5b7b62e058c17691$export$34b1bc5528be50fe = (routerProps, lastSearchQuery)=>{
    if (Number(routerProps.timescaleId) === (0, $k74Ot.CUSTOM_TIMESCALE_ID) && lastSearchQuery) {
        const startDate = routerProps.startDate !== undefined && routerProps.startDate !== '' ? routerProps.startDate : lastSearchQuery.startDate;
        const endDate = routerProps.endDate !== undefined && routerProps.endDate !== '' ? routerProps.endDate : lastSearchQuery.endDate;
        let { timeBreakdown: timeBreakdown } = routerProps;
        if (!timeBreakdown) timeBreakdown = (0, $gENXG.getAvailableOptionsByDateRange)({
            startDate: startDate,
            endDate: endDate
        }).defaultOption;
        return {
            timescaleId: (0, $k74Ot.CUSTOM_TIMESCALE_ID),
            startDate: startDate,
            endDate: endDate,
            timeBreakdown: timeBreakdown
        };
    }
    return {
        timescaleId: $5b7b62e058c17691$export$a0c0a3d47691e36a(routerProps)
    };
};
const $5b7b62e058c17691$export$7f7630742786ff6a = (options, routerProps, defaultTimescaleId)=>{
    const timescaleId = $5b7b62e058c17691$export$a0c0a3d47691e36a(routerProps, defaultTimescaleId);
    const idx = options.findIndex((option)=>option.id === timescaleId);
    return options[idx];
};

});


parcelRegister("8Fmle", function(module, exports) {

$parcel$export(module.exports, "default", () => $6928b190f194107f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $53KbV = parcelRequire("53KbV");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $81ps3 = parcelRequire("81ps3");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8ubVf = parcelRequire("8ubVf");

var $hVAug = parcelRequire("hVAug");
var $6928b190f194107f$export$2e2bcd8739ae039 = ({ title: title, children: children, baseUrl: baseUrl, projectKey: projectKey, projectName: projectName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const breadcrumbs = [
        {
            href: '/jira/projects',
            text: formatMessage((0, $hVAug.default).projectsBreadcrumb)
        },
        {
            href: (0, $81ps3.createProjectUrl)(projectKey || ''),
            text: projectName || ''
        },
        {
            href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
            text: formatMessage((0, $hVAug.default).reportsBreadcrumb)
        }
    ];
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $6928b190f194107f$var$commonNav4HeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $6928b190f194107f$var$nav4HeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ubVf.Header), {
        title: title,
        breadcrumbs: breadcrumbs,
        actions: children
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6928b190f194107f$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6928b190f194107f$var$StyledTitle, {
        "data-test-id": "servicedesk-reports-common.ui.header.title"
    }, title)), children);
};
const $6928b190f194107f$var$commonNav4HeaderWrapper = (0, $jJ1Sb.xcss)({
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100'
});
const $6928b190f194107f$var$nav4HeaderWrapper = (0, $jJ1Sb.xcss)({
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400'
});
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6928b190f194107f$var$StyledTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4xy5q _19pkidpf",
            __cmplp.className
        ])
    });
});
const $6928b190f194107f$var$TitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pkmgjw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hVAug", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ec4baeeb8fec86$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $30ec4baeeb8fec86$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsBreadcrumb: {
        "id": "servicedesk-reports-common.header.projects-breadcrumb",
        "defaultMessage": "Projects"
    },
    reportsBreadcrumb: {
        "id": "servicedesk-reports-common.header.reports-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("dAFqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $67cba9b9374b5799$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4hGw3 = parcelRequire("4hGw3");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $fBF8a = parcelRequire("fBF8a");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $5GhjE = parcelRequire("5GhjE");

var $kPIJk = parcelRequire("kPIJk");
const $67cba9b9374b5799$var$Error = ()=>{
    (0, $5GhjE.GlobalPageLoadExperience).failure({
        force: true
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        header: formatMessage((0, $kPIJk.default).errorHeader),
        description: formatMessage((0, $kPIJk.default).errorDescription),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($67cba9b9374b5799$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fBF8a.default), {
                alt: "error-image",
                fill: true
            })))
    });
};
const $67cba9b9374b5799$var$ImageWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $67cba9b9374b5799$var$wrapperStyles
    }, children);
const $67cba9b9374b5799$var$wrapperStyles = (0, $jJ1Sb.xcss)({
    height: '160px',
    position: 'relative'
});
var $67cba9b9374b5799$export$2e2bcd8739ae039 = $67cba9b9374b5799$var$Error;

});
parcelRegister("fBF8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b29d503461142d$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $6ntiT = parcelRequire("6ntiT");
const $58b29d503461142d$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6ntiT)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6ntiT))
});
var $58b29d503461142d$export$2e2bcd8739ae039 = $58b29d503461142d$var$Illustration;
// for advanced use only
const $58b29d503461142d$export$a179c88182cb9d56 = [
    0,
    0,
    163,
    218
];

});
parcelRegister("6ntiT", function(module, exports) {
module.exports = new URL("exclamation-triangle-yellow.a39d9b20.svg", import.meta.url).toString();

});


parcelRegister("kPIJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a517a82336cbd5a2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a517a82336cbd5a2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeader: {
        "id": "servicedesk-reports-common.table.error.error-header",
        "defaultMessage": "Couldn't fetch results"
    },
    errorDescription: {
        "id": "servicedesk-reports-common.table.error.error-description",
        "defaultMessage": "There was a problem while communicating with the server. Please try again later."
    }
});

});


parcelRegister("5WvTQ", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $03eb1a987fb3bf09$export$3b4e64e77073e307);

var $5uXOq = parcelRequire("5uXOq");

var $6FTcZ = parcelRequire("6FTcZ");

var $gq0sA = parcelRequire("gq0sA");

var $fQW4s = parcelRequire("fQW4s");

var $e952N = parcelRequire("e952N");
const $03eb1a987fb3bf09$export$3b4e64e77073e307 = ({ baseUrl: baseUrl, usePageContext: usePageContext = (0, $gq0sA.usePageContext), useKbConfluenceContext: useKbConfluenceContext = (0, $6FTcZ.useKbConfluenceContext) })=>{
    const [{ data: pageContextData }] = usePageContext();
    const { projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, isAdmin: isAdmin } = projectContext || {};
    const [{ data: confluenceLink, error: confluenceLinkError, loading: loading }] = useKbConfluenceContext(projectKey);
    if (loading) return null;
    const noConfMsgProps = {
        settingMessage: (0, $fQW4s.default).linkToConfluenceSetting,
        warningIconLabel: (0, $fQW4s.default).warningIconLabel,
        isAdmin: isAdmin,
        baseUrl: baseUrl,
        projectKey: projectKey
    };
    if (confluenceLinkError) return(// @ts-expect-error - TS2322 - Type '{ errorMessage: MessageDescriptorV2; settingMessage: MessageDescriptorV2; warningIconLabel: MessageDescriptorV2; isAdmin: boolean | undefined; useIntl: () => IntlShapeV2; baseUrl: string; projectKey: string | undefined; }' is not assignable to type 'Props'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e952N.NotLinkConfluenceMessage), {
        ...noConfMsgProps,
        errorMessage: (0, $fQW4s.default).linkNotSupportedJsm
    }));
    if (!confluenceLink) return(// @ts-expect-error - TS2322 - Type '{ errorMessage: MessageDescriptorV2; settingMessage: MessageDescriptorV2; warningIconLabel: MessageDescriptorV2; isAdmin: boolean | undefined; useIntl: () => IntlShapeV2; baseUrl: string; projectKey: string | undefined; }' is not assignable to type 'Props'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e952N.NotLinkConfluenceMessage), {
        ...noConfMsgProps,
        errorMessage: (0, $fQW4s.default).linkNotAvailableJsm
    }));
    return null;
};

});
parcelRegister("6FTcZ", function(module, exports) {

$parcel$export(module.exports, "useKbConfluenceContext", () => $5955acba1bcddf7a$export$a8450b4f39918e6d);

var $5uXOq = parcelRequire("5uXOq");

var $bjZiV = parcelRequire("bjZiV");

var $dIdda = parcelRequire("dIdda");
const $5955acba1bcddf7a$var$getKbConfluenceContextResource = ()=>(0, $bjZiV.kbConfluenceContextResource);
const $5955acba1bcddf7a$export$a8450b4f39918e6d = (projectKey)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $dIdda.useResource)($5955acba1bcddf7a$var$getKbConfluenceContextResource());
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};
var $5955acba1bcddf7a$export$2e2bcd8739ae039 = $5955acba1bcddf7a$export$a8450b4f39918e6d;

});

parcelRegister("fQW4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3f3e962dd09f811$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e3f3e962dd09f811$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    linkNotSupportedJsm: {
        "id": "servicedesk-kb-requests-reports.banner.link-not-supported-jsm",
        "defaultMessage": "This service project is {tagStart}currently does not linked to a same domain Confluence space.{tagEnd} Your customers can not see knowledge base articles and help themselves."
    },
    linkNotAvailableJsm: {
        "id": "servicedesk-kb-requests-reports.banner.link-not-available-jsm",
        "defaultMessage": "This service project is {tagStart}currently not linked to a Confluence space.{tagEnd} Your customers can not see knowledge base articles and help themselves."
    },
    linkToConfluenceSetting: {
        "id": "servicedesk-kb-requests-reports.banner.link-to-confluence-setting",
        "defaultMessage": "Configure your knowledge base settings"
    },
    warningIconLabel: {
        "id": "servicedesk-kb-requests-reports.banner.warning-icon-label",
        "defaultMessage": "Not Supported Confluence Space"
    }
});

});

parcelRegister("e952N", function(module, exports) {

$parcel$export(module.exports, "NotLinkConfluenceMessage", () => $d5fb99130033a2af$export$c8d76945603e7c7f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iz6Nv = parcelRequire("iz6Nv");


var $koVbs = parcelRequire("koVbs");

var $cqCFF = parcelRequire("cqCFF");

var $og0kl = parcelRequire("og0kl");
const $d5fb99130033a2af$export$c8d76945603e7c7f = ({ warningIconLabel: warningIconLabel, errorMessage: errorMessage, isAdmin: isAdmin, ...rest })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d5fb99130033a2af$var$BannerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d5fb99130033a2af$var$StyledWarningIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iz6Nv))), {
        label: intl.formatMessage(warningIconLabel),
        primaryColor: `var(--ds-icon-warning, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cqCFF.ErrorMessage), {
        errorMessage: errorMessage
    }), isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $og0kl.LinkToConfluenceSetting), rest)));
};
// by considering the gridSize is 8 then result should be => 20px 40px 20px 0
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5fb99130033a2af$var$BannerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt46ucv _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $d5fb99130033a2af$var$StyledWarningIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4ie5z",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cqCFF", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $a2865fd89b7c8236$export$915e9e7bd4f0f96d);

var $5uXOq = parcelRequire("5uXOq");

var $1m92z = parcelRequire("1m92z");

var $koVbs = parcelRequire("koVbs");

var $hZF5L = parcelRequire("hZF5L");
const $a2865fd89b7c8236$export$915e9e7bd4f0f96d = ({ errorMessage: errorMessage })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZF5L.FormattedReactMessage), {
        message: intl.formatMessage(errorMessage, {
            tagStart: '{tagStart}',
            tagEnd: '{tagEnd}'
        }),
        openingTag: "{tagStart}",
        closingTag: "{tagEnd}",
        Component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
                as: "strong"
            }, children)
    }));
};

});
parcelRegister("hZF5L", function(module, exports) {

$parcel$export(module.exports, "FormattedReactMessage", () => $b9b519d540c2bd1e$export$20942ce5ea74ad18);

var $5uXOq = parcelRequire("5uXOq");

var $3XO6n = parcelRequire("3XO6n");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");
const $b9b519d540c2bd1e$export$20942ce5ea74ad18 = (props)=>{
    const { message: message, openingTag: openingTag, closingTag: closingTag, Component: Component } = props;
    const startIndex = message.indexOf(openingTag);
    const endIndex = message.indexOf(closingTag);
    if (startIndex === -1 || endIndex === -1 || startIndex > endIndex) {
        (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('formatReactMessage'), (0, $gl0PU.toErrorMessage)(`Malformed message: "${message}"`));
        // message is malformed, so let's return original message stripped off any tags
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, message.replace(openingTag, '').replace(closingTag, ''));
    }
    const parts = message.split(openingTag);
    if (parts.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, message.replace(closingTag, ''));
    const before = parts[0];
    const [children, after] = parts[1].split(closingTag);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, before, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null, children), after);
};

});


parcelRegister("og0kl", function(module, exports) {

$parcel$export(module.exports, "LinkToConfluenceSetting", () => $9c9a9a235872d053$export$b2c1ee6fa7fc211e);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $koVbs = parcelRequire("koVbs");
const $9c9a9a235872d053$export$b2c1ee6fa7fc211e = ({ baseUrl: baseUrl, projectKey: projectKey, settingMessage: settingMessage })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "link",
        href: `${baseUrl}/${projectKey}/confluence-kb`,
        spacing: "none"
    }, intl.formatMessage(settingMessage)));
};

});



parcelRegister("5ZLpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f23c3e4b0f79cdc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $89thI = parcelRequire("89thI");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $gSNDu = parcelRequire("gSNDu");
const $8f23c3e4b0f79cdc$var$ExportCsvButton = ({ href: href })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    const handleClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'exportCsvButton');
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f23c3e4b0f79cdc$var$CsvButtonContainer, {
        "data-test-id": "servicedesk-kb-requests-reports.ui.export-csv.export-csv"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "default",
        href: href,
        onClick: handleClick
    }, formatMessage((0, $gSNDu.default).exportCsvButtonLabel)));
};
var $8f23c3e4b0f79cdc$export$2e2bcd8739ae039 = $8f23c3e4b0f79cdc$var$ExportCsvButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f23c3e4b0f79cdc$var$CsvButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug _u5f3xy5q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gSNDu", function(module, exports) {

$parcel$export(module.exports, "default", () => $639e3e104990770b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $639e3e104990770b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    exportCsvButtonLabel: {
        "id": "servicedesk-kb-requests-reports.export-csv.export-csv-button-label",
        "defaultMessage": "Export CSV"
    }
});

});


parcelRegister("4w0k3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4238f033ae1b1fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $8PRuf = parcelRequire("8PRuf");

var $3TpKp = parcelRequire("3TpKp");

var $cVReG = parcelRequire("cVReG");

var $aVOcX = parcelRequire("aVOcX");

var $dZIz9 = parcelRequire("dZIz9");

var $dAFqR = parcelRequire("dAFqR");

var $kuEHb = parcelRequire("kuEHb");

var $8u51m = parcelRequire("8u51m");
const $d4238f033ae1b1fc$var$ChartWithSummaryDetails = ({ summaryResource: summaryResource, drilldownResource: drilldownResource, reportId: reportId, dateFilterQuery: dateFilterQuery, selectedDrillDownPoint: selectedDrillDownPoint, onSetDrillDownPoint: onSetDrillDownPoint })=>{
    const { data: data, loading: loading, error: error } = summaryResource;
    const { fetch: fetchDrillDown } = drilldownResource;
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (selectedDrillDownPoint) {
            ref.current && ref.current.highlightPoint({
                seriesIndex: selectedDrillDownPoint.seriesIndex,
                dataIndex: selectedDrillDownPoint.dataIndex,
                data: selectedDrillDownPoint
            });
            const fetch = async ()=>{
                await fetchDrillDown({
                    reportId: // @ts-expect-error - TS2783 - 'reportId' is specified more than once, so this usage will be overwritten.
                    reportId,
                    date: selectedDrillDownPoint.id,
                    seriesId: selectedDrillDownPoint.seriesId,
                    ...dateFilterQuery,
                    start: (0, $8u51m.APP_PAGINATION_DEFAULTS).start,
                    limit: (0, $8u51m.APP_PAGINATION_DEFAULTS).limit
                });
            };
            fetch();
        } else ref.current && ref.current.downplayPoint();
    }, [
        fetchDrillDown,
        dateFilterQuery,
        reportId,
        selectedDrillDownPoint
    ]);
    const onDrilldownPageChange = (0, $5uXOq.useCallback)((page)=>{
        if (selectedDrillDownPoint) fetchDrillDown({
            reportId: // @ts-expect-error - TS2783 - 'reportId' is specified more than once, so this usage will be overwritten.
            reportId,
            date: selectedDrillDownPoint.id,
            seriesId: selectedDrillDownPoint.seriesId,
            ...dateFilterQuery,
            start: (page - 1) * (0, $8u51m.APP_PAGINATION_DEFAULTS).limit,
            limit: (0, $8u51m.APP_PAGINATION_DEFAULTS).limit
        });
    }, [
        fetchDrillDown,
        dateFilterQuery,
        reportId,
        selectedDrillDownPoint
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (error !== undefined || data === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAFqR.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVOcX.default), {
        chartSeries: data.chartSeries
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cVReG.default), {
        source: data,
        ref: ref,
        onPointSelect: (pointEvent)=>{
            onSetDrillDownPoint(pointEvent.data);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZIz9.default), {
        summaryResource: summaryResource,
        drilldownResource: drilldownResource,
        selectedDrillDownPoint: selectedDrillDownPoint,
        onSetDrillDownPoint: onSetDrillDownPoint,
        onDrilldownPageChange: onDrilldownPageChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TpKp.JsmPageInteractiveEvent), {
        key: reportId,
        metricKey: "servicedesk.kb-requests-reports-v2",
        withMarks: [
            (0, $8PRuf.appBundleReadyMark)
        ],
        appName: "servicedesk.kb-requests-reports-v2",
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: (0, $kuEHb.kbRequestsReportsPageLoad)
    }));
};
var $d4238f033ae1b1fc$export$2e2bcd8739ae039 = $d4238f033ae1b1fc$var$ChartWithSummaryDetails;

});
parcelRegister("3TpKp", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $bbb7386cf97044f2$export$c4ba40c380ee9a11);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");
const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), args);
$bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");

var $gshwr = parcelRequire("gshwr");

var $14hPy = parcelRequire("14hPy");

var $6InPJ = parcelRequire("6InPJ");

var $5GhjE = parcelRequire("5GhjE");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $co1wz.ff)('uip.ufo') && (0, $5GhjE.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gshwr.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $14hPy.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $6InPJ.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("14hPy", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $aa4ac710ea08d6d6$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $aa4ac710ea08d6d6$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $aa4ac710ea08d6d6$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $fwf6E = parcelRequire("fwf6E");

var $6InPJ = parcelRequire("6InPJ");

var $bBkFW = parcelRequire("bBkFW");
function $aa4ac710ea08d6d6$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $aa4ac710ea08d6d6$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $fwf6E.default));
    const interactionId = (0, $6InPJ.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bBkFW.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $aa4ac710ea08d6d6$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $aa4ac710ea08d6d6$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $6InPJ.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bBkFW.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $aa4ac710ea08d6d6$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bBkFW.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $19hl5 = parcelRequire("19hl5");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $co1wz = parcelRequire("co1wz");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

var $fwf6E = parcelRequire("fwf6E");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $co1wz.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $co1wz.ff)('bm3.wait-for-long-task') ? (0, $19hl5.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $co1wz.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                }
                if ((0, $co1wz.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $fwf6E.default);
    }
    render() {
        return null;
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $fwf6E = parcelRequire("fwf6E");

var $5GhjE = parcelRequire("5GhjE");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $5GhjE.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $5GhjE.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $fwf6E.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $6InPJ = parcelRequire("6InPJ");

var $bBkFW = parcelRequire("bBkFW");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $6InPJ.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bBkFW.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $6InPJ = parcelRequire("6InPJ");

var $bBkFW = parcelRequire("bBkFW");

var $5GhjE = parcelRequire("5GhjE");
var $epSI1 = parcelRequire("epSI1");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $6InPJ.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $5GhjE.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $epSI1.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bBkFW.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $y7eb2 = parcelRequire("y7eb2");

var $6InPJ = parcelRequire("6InPJ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $6InPJ.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("cVReG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d990bbba331c671$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lXVui = parcelRequire("lXVui");

var $47isN = parcelRequire("47isN");

var $6OGL8 = parcelRequire("6OGL8");
var $48mDj = parcelRequire("48mDj");
var $gLj36 = parcelRequire("gLj36");

var $ixV1I = parcelRequire("ixV1I");

var $koMvQ = parcelRequire("koMvQ");

var $6T4rd = parcelRequire("6T4rd");
var $iaTnv = parcelRequire("iaTnv");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $disyi = parcelRequire("disyi");

var $koVbs = parcelRequire("koVbs");

var $cnldZ = parcelRequire("cnldZ");

var $2HWES = parcelRequire("2HWES");

var $aMUni = parcelRequire("aMUni");

var $61iTG = parcelRequire("61iTG");
// Register the required components
$ixV1I.use([
    (0, $gLj36.install),
    (0, $48mDj.install),
    (0, $6OGL8.install),
    (0, $47isN.install),
    (0, $koMvQ.install)
]);
// setting this in css does not work with echarts-for-react v3, as it sets `height` to 300px if it is not provided in `style` prop
const $3d990bbba331c671$var$echartsForReactStyle = {
    width: '100%',
    height: '100%'
};
var $3d990bbba331c671$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ source: source, onPointSelect: onPointSelect }, ref)=>{
    const { colorMode: colorMode } = (0, $disyi.default)();
    const { searchBy: searchBy, axisLabels: axisLabels, chartSeries: chartSeries, yAxisMinMax: yAxisMinMax } = source;
    const intl = (0, $koVbs.default)();
    const formatter = (0, $5uXOq.useCallback)((points)=>(0, $61iTG.formatTooltip)(intl, points, searchBy), [
        intl,
        searchBy
    ]);
    const yAxisFormatterType = (0, $5uXOq.useMemo)(()=>chartSeries.length && chartSeries[0].data.length && chartSeries[0].data[0].valueType, [
        chartSeries
    ]);
    const yAxisFormatter = (0, $5uXOq.useCallback)((axisValue)=>{
        if (yAxisFormatterType) return (0, $cnldZ.getFormattedLabel)(yAxisFormatterType, axisValue, intl.formatMessage);
        return axisValue;
    }, [
        intl.formatMessage,
        yAxisFormatterType
    ]);
    const option = (0, $5uXOq.useMemo)(()=>({
            animation: true,
            animationDuration: 300,
            xAxis: (0, $2HWES.getXAxisConfiguration)(axisLabels),
            yAxis: (0, $2HWES.getYAxisConfiguration)({
                yAxisFormatter: yAxisFormatter,
                minMaxConfig: yAxisMinMax
            }),
            grid: (0, $2HWES.getGridConfiguration)(),
            tooltip: (0, $2HWES.getTooltipConfiguration)(formatter),
            series: chartSeries
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        axisLabels,
        chartSeries,
        formatter,
        yAxisFormatter,
        yAxisMinMax,
        colorMode
    ]);
    const { initChartEventsOnMount: initChartEventsOnMount, highlightPoint: highlightPoint, downplayPoint: downplayPoint, refreshOptions: refreshOptions } = (0, $aMUni.useChartEvents)({
        onPointSelect: onPointSelect,
        source: source
    });
    (0, $5uXOq.useImperativeHandle)(ref, ()=>({
            highlightPoint: highlightPoint,
            downplayPoint: downplayPoint
        }));
    (0, $5uXOq.useEffect)(()=>{
        refreshOptions(option);
    }, [
        option,
        refreshOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d990bbba331c671$var$JsmReportsEcharts, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lXVui))), {
        echarts: $ixV1I,
        onChartReady: initChartEventsOnMount,
        option: option,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $3d990bbba331c671$var$echartsForReactStyle
    }));
});
const $3d990bbba331c671$var$AspectRatioFallback = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "div",
        xcss: $3d990bbba331c671$var$aspectRatioFallbackStyles
    }, children);
const $3d990bbba331c671$var$JsmReportsEcharts = ({ children: children })=>{
    const [supportsAspectRatio, setSupportsAspectRatio] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (typeof window !== 'undefined' && 'CSS' in window && 'supports' in CSS) setSupportsAspectRatio(CSS.supports('aspect-ratio', '1 / 1'));
    }, []);
    const jsmReportsEchartsFallbackStyles = (0, $jJ1Sb.xcss)({
        position: 'relative'
    });
    const combinedStyles = supportsAspectRatio ? $3d990bbba331c671$var$jsmReportsEchartsBaseStyles : {
        ...$3d990bbba331c671$var$jsmReportsEchartsBaseStyles,
        ...jsmReportsEchartsFallbackStyles
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: combinedStyles
    }, !supportsAspectRatio ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d990bbba331c671$var$AspectRatioFallback, null, children)) : children));
};
const $3d990bbba331c671$var$aspectRatioFallbackStyles = (0, $jJ1Sb.xcss)({
    height: '100%',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    bottom: 'space.0',
    left: 'space.0'
});
const $3d990bbba331c671$var$jsmReportsEchartsBaseStyles = (0, $jJ1Sb.xcss)({
    width: '100%',
    aspectRatio: '3 / 1'
});

});
parcelRegister("lXVui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $ffdbb37eea52750b$var$react_1 = (0, $3VFsf.__importStar)((parcelRequire("5uXOq")));

var $grS0X = parcelRequire("grS0X");

var $6gLUT = parcelRequire("6gLUT");

var $eBzeD = parcelRequire("eBzeD");

var $lj6jE = parcelRequire("lj6jE");

var $1pywT = parcelRequire("1pywT");
/**
 * core component for echarts binding
 */ var $ffdbb37eea52750b$var$EChartsReactCore = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(EChartsReactCore, _super);
    function EChartsReactCore(props) {
        var _this = _super.call(this, props) || this;
        _this.echarts = props.echarts;
        _this.ele = null;
        _this.isInitialResize = true;
        return _this;
    }
    EChartsReactCore.prototype.componentDidMount = function() {
        this.renderNewEcharts();
    };
    // update
    EChartsReactCore.prototype.componentDidUpdate = function(prevProps) {
        /**
         * if shouldSetOption return false, then return, not update echarts options
         * default is true
         */ var shouldSetOption = this.props.shouldSetOption;
        if ((0, $eBzeD.isFunction)(shouldSetOption) && !shouldSetOption(prevProps, this.props)) return;
        // 以下属性修改的时候，需要 dispose 之后再新建
        // 1. 切换 theme 的时候
        // 2. 修改 opts 的时候
        // 3. 修改 onEvents 的时候，这样可以取消所有之前绑定的事件 issue #151
        if (!(0, $1pywT.isEqual)(prevProps.theme, this.props.theme) || !(0, $1pywT.isEqual)(prevProps.opts, this.props.opts) || !(0, $1pywT.isEqual)(prevProps.onEvents, this.props.onEvents)) {
            this.dispose();
            this.renderNewEcharts(); // 重建
            return;
        }
        // when these props are not isEqual, update echarts
        var pickKeys = [
            'option',
            'notMerge',
            'lazyUpdate',
            'showLoading',
            'loadingOption'
        ];
        if (!(0, $1pywT.isEqual)((0, $6gLUT.pick)(this.props, pickKeys), (0, $6gLUT.pick)(prevProps, pickKeys))) this.updateEChartsOption();
        /**
         * when style or class name updated, change size.
         */ if (!(0, $1pywT.isEqual)(prevProps.style, this.props.style) || !(0, $1pywT.isEqual)(prevProps.className, this.props.className)) this.resize();
    };
    EChartsReactCore.prototype.componentWillUnmount = function() {
        this.dispose();
    };
    /**
     * return the echart object
     * 1. if exist, return the existed instance
     * 2. or new one instance
     */ EChartsReactCore.prototype.getEchartsInstance = function() {
        return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
    };
    /**
     * dispose echarts and clear size-sensor
     */ EChartsReactCore.prototype.dispose = function() {
        if (this.ele) {
            try {
                (0, $grS0X.clear)(this.ele);
            } catch (e) {
                console.warn(e);
            }
            // dispose echarts instance
            this.echarts.dispose(this.ele);
        }
    };
    /**
     * render a new echarts instance
     */ EChartsReactCore.prototype.renderNewEcharts = function() {
        var _this = this;
        var _a = this.props, onEvents = _a.onEvents, onChartReady = _a.onChartReady;
        // 1. new echarts instance
        var echartsInstance = this.updateEChartsOption();
        // 2. bind events
        this.bindEvents(echartsInstance, onEvents || {});
        // 3. on chart ready
        if ((0, $eBzeD.isFunction)(onChartReady)) onChartReady(echartsInstance);
        // 4. on resize
        if (this.ele) (0, $grS0X.bind)(this.ele, function() {
            _this.resize();
        });
    };
    // bind the events
    EChartsReactCore.prototype.bindEvents = function(instance, events) {
        function _bindEvent(eventName, func) {
            // ignore the event config which not satisfy
            if ((0, $lj6jE.isString)(eventName) && (0, $eBzeD.isFunction)(func)) // binding event
            instance.on(eventName, function(param) {
                func(param, instance);
            });
        }
        // loop and bind
        for(var eventName in events)if (Object.prototype.hasOwnProperty.call(events, eventName)) _bindEvent(eventName, events[eventName]);
    };
    /**
     * render the echarts
     */ EChartsReactCore.prototype.updateEChartsOption = function() {
        var _a = this.props, option = _a.option, _b = _a.notMerge, notMerge = _b === void 0 ? false : _b, _c = _a.lazyUpdate, lazyUpdate = _c === void 0 ? false : _c, showLoading = _a.showLoading, _d = _a.loadingOption, loadingOption = _d === void 0 ? null : _d;
        // 1. get or initial the echarts object
        var echartInstance = this.getEchartsInstance();
        // 2. set the echarts option
        echartInstance.setOption(option, notMerge, lazyUpdate);
        // 3. set loading mask
        if (showLoading) echartInstance.showLoading(loadingOption);
        else echartInstance.hideLoading();
        return echartInstance;
    };
    /**
     * resize wrapper
     */ EChartsReactCore.prototype.resize = function() {
        // 1. get the echarts object
        var echartsInstance = this.getEchartsInstance();
        // 2. call echarts instance resize if not the initial resize
        // resize should not happen on first render as it will cancel initial echarts animations
        if (!this.isInitialResize) try {
            echartsInstance.resize();
        } catch (e) {
            console.warn(e);
        }
        // 3. update variable for future calls
        this.isInitialResize = false;
    };
    EChartsReactCore.prototype.render = function() {
        var _this = this;
        var _a = this.props, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
        // default height = 300
        var newStyle = (0, $3VFsf.__assign)({
            height: 300
        }, style);
        return $ffdbb37eea52750b$var$react_1.default.createElement("div", {
            ref: function(e) {
                _this.ele = e;
            },
            style: newStyle,
            className: "echarts-for-react " + className
        });
    };
    return EChartsReactCore;
}($ffdbb37eea52750b$var$react_1.PureComponent);
module.exports.default = $ffdbb37eea52750b$var$EChartsReactCore;

});
parcelRegister("grS0X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ver = module.exports.clear = module.exports.bind = void 0;

var $8x2zG = parcelRequire("8x2zG");
/**
 * Created by hustcc on 18/6/9.[高考时间]
 * Contract: i@hust.cc
 */ /**
 * bind an element with resize callback function
 * @param {*} element
 * @param {*} cb
 */ var $bf9911179e98088f$var$bind = function bind(element, cb) {
    var sensor = (0, $8x2zG.getSensor)(element); // listen with callback
    sensor.bind(cb); // return unbind function
    return function() {
        sensor.unbind(cb);
    };
};
/**
 * clear all the listener and sensor of an element
 * @param element
 */ module.exports.bind = $bf9911179e98088f$var$bind;
var $bf9911179e98088f$var$clear = function clear(element) {
    var sensor = (0, $8x2zG.getSensor)(element);
    (0, $8x2zG.removeSensor)(sensor);
};
module.exports.clear = $bf9911179e98088f$var$clear;
var $bf9911179e98088f$var$ver = "1.0.1";
module.exports.ver = $bf9911179e98088f$var$ver;

});
parcelRegister("8x2zG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeSensor = module.exports.getSensor = void 0;

var $6363670a61880ddf$var$_id = $6363670a61880ddf$var$_interopRequireDefault((parcelRequire("fiP6o")));

var $gWzBv = parcelRequire("gWzBv");

var $cdrHo = parcelRequire("cdrHo");
function $6363670a61880ddf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ /**
 * all the sensor objects.
 * sensor pool
 */ var $6363670a61880ddf$var$Sensors = {};
/**
 * get one sensor
 * @param element
 * @returns {*}
 */ var $6363670a61880ddf$var$getSensor = function getSensor(element) {
    var sensorId = element.getAttribute($cdrHo.SizeSensorId); // 1. if the sensor exists, then use it
    if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) return $6363670a61880ddf$var$Sensors[sensorId];
     // 2. not exist, then create one
    var newId = (0, $6363670a61880ddf$var$_id["default"])();
    element.setAttribute($cdrHo.SizeSensorId, newId);
    var sensor = (0, $gWzBv.createSensor)(element); // add sensor into pool
    $6363670a61880ddf$var$Sensors[newId] = sensor;
    return sensor;
};
/**
 * 移除 sensor
 * @param sensor
 */ module.exports.getSensor = $6363670a61880ddf$var$getSensor;
var $6363670a61880ddf$var$removeSensor = function removeSensor(sensor) {
    var sensorId = sensor.element.getAttribute($cdrHo.SizeSensorId); // remove attribute
    sensor.element.removeAttribute($cdrHo.SizeSensorId); // remove event, dom of the sensor used
    sensor.destroy(); // exist, then remove from pool
    if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) delete $6363670a61880ddf$var$Sensors[sensorId];
};
module.exports.removeSensor = $6363670a61880ddf$var$removeSensor;

});
parcelRegister("fiP6o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $b2402d3f57c74659$var$id = 1;
/**
 * generate unique id in application
 * @return {string}
 */ var $b2402d3f57c74659$var$_default = function _default() {
    return "".concat($b2402d3f57c74659$var$id++);
};
module.exports["default"] = $b2402d3f57c74659$var$_default;

});

parcelRegister("gWzBv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $1oYX1 = parcelRequire("1oYX1");

var $gxB4H = parcelRequire("gxB4H");
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ /**
 * sensor strategies
 */ // export const createSensor = createObjectSensor;
var $c55dae5359197dfc$var$createSensor = typeof ResizeObserver !== 'undefined' ? $gxB4H.createSensor : $1oYX1.createSensor;
module.exports.createSensor = $c55dae5359197dfc$var$createSensor;

});
parcelRegister("1oYX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $10574fe90a26a00a$var$_debounce = $10574fe90a26a00a$var$_interopRequireDefault((parcelRequire("hwNQ2")));

var $cdrHo = parcelRequire("cdrHo");
function $10574fe90a26a00a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $10574fe90a26a00a$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * create object DOM of sensor
   * @returns {HTMLObjectElement}
   */ var newSensor = function newSensor() {
        // adjust style
        if (getComputedStyle(element).position === 'static') element.style.position = 'relative';
        var obj = document.createElement('object');
        obj.onload = function() {
            obj.contentDocument.defaultView.addEventListener('resize', resizeListener); // 直接触发一次 resize
            resizeListener();
        };
        obj.style.display = 'block';
        obj.style.position = 'absolute';
        obj.style.top = '0';
        obj.style.left = '0';
        obj.style.height = '100%';
        obj.style.width = '100%';
        obj.style.overflow = 'hidden';
        obj.style.pointerEvents = 'none';
        obj.style.zIndex = '-1';
        obj.style.opacity = '0';
        obj.setAttribute('class', $cdrHo.SensorClassName);
        obj.setAttribute('tabindex', $cdrHo.SensorTabIndex);
        obj.type = 'text/html'; // append into dom
        element.appendChild(obj); // for ie, should set data attribute delay, or will be white screen
        obj.data = 'about:blank';
        return obj;
    };
    /**
   * trigger listeners
   */ var resizeListener = (0, $10574fe90a26a00a$var$_debounce["default"])(function() {
        // trigger all listener
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * listen with one callback function
   * @param cb
   */ var bind = function bind(cb) {
        // if not exist sensor, then create one
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy all
   */ var destroy = function destroy() {
        if (sensor && sensor.parentNode) {
            if (sensor.contentDocument) // remote event
            sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
             // remove dom
            sensor.parentNode.removeChild(sensor); // initial variable
            sensor = undefined;
            listeners = [];
        }
    };
    /**
   * cancel listener bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
module.exports.createSensor = $10574fe90a26a00a$var$createSensor;

});
parcelRegister("hwNQ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $cc2c15b4a43e3633$var$_default = function _default(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
    var timer = null;
    return function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(_this, args);
        }, delay);
    };
};
module.exports["default"] = $cc2c15b4a43e3633$var$_default;

});

parcelRegister("cdrHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SensorTabIndex = module.exports.SensorClassName = module.exports.SizeSensorId = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $8e4c2f559be5b9b7$var$SizeSensorId = 'size-sensor-id';
module.exports.SizeSensorId = $8e4c2f559be5b9b7$var$SizeSensorId;
var $8e4c2f559be5b9b7$var$SensorClassName = 'size-sensor-object';
module.exports.SensorClassName = $8e4c2f559be5b9b7$var$SensorClassName;
var $8e4c2f559be5b9b7$var$SensorTabIndex = '-1';
module.exports.SensorTabIndex = $8e4c2f559be5b9b7$var$SensorTabIndex;

});


parcelRegister("gxB4H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $c0ac7cab0e8dcc43$var$_debounce = $c0ac7cab0e8dcc43$var$_interopRequireDefault((parcelRequire("hwNQ2")));
function $c0ac7cab0e8dcc43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ var $c0ac7cab0e8dcc43$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * trigger listeners
   */ var resizeListener = (0, $c0ac7cab0e8dcc43$var$_debounce["default"])(function() {
        // trigger all
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * create ResizeObserver sensor
   * @returns
   */ var newSensor = function newSensor() {
        var s = new ResizeObserver(resizeListener); // listen element
        s.observe(element); // trigger once
        resizeListener();
        return s;
    };
    /**
   * listen with callback
   * @param cb
   */ var bind = function bind(cb) {
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy
   */ var destroy = function destroy() {
        sensor.disconnect();
        listeners = [];
        sensor = undefined;
    };
    /**
   * cancel bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
module.exports.createSensor = $c0ac7cab0e8dcc43$var$createSensor;

});




parcelRegister("6gLUT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pick = void 0;
/**
 * 保留 object 中的部分内容
 * @param obj
 * @param keys
 */ function $490967eff7da5641$var$pick(obj, keys) {
    var r = {};
    keys.forEach(function(key) {
        r[key] = obj[key];
    });
    return r;
}
module.exports.pick = $490967eff7da5641$var$pick;

});

parcelRegister("eBzeD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFunction = void 0;
function $aa1fda532dd852be$var$isFunction(v) {
    return typeof v === 'function';
}
module.exports.isFunction = $aa1fda532dd852be$var$isFunction;

});

parcelRegister("lj6jE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isString = void 0;
function $f83045889662a498$var$isString(v) {
    return typeof v === 'string';
}
module.exports.isString = $f83045889662a498$var$isString;

});

parcelRegister("1pywT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEqual = void 0;

var $3VFsf = parcelRequire("3VFsf");

var $1072e91c08f205e9$var$fast_deep_equal_1 = (0, $3VFsf.__importDefault)((parcelRequire("1SBaA")));
module.exports.isEqual = $1072e91c08f205e9$var$fast_deep_equal_1.default;

});
parcelRegister("1SBaA", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});



parcelRegister("47isN", function(module, exports) {

$parcel$export(module.exports, "install", () => $2ff6234e7db26f51$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jvYs5 = parcelRequire("jvYs5");

var $cDBtZ = parcelRequire("cDBtZ");

var $5xgWc = parcelRequire("5xgWc");

var $7jcIW = parcelRequire("7jcIW");
function $2ff6234e7db26f51$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $cDBtZ.default));
    registers.registerSeriesModel((0, $jvYs5.default));
    registers.registerLayout((0, $5xgWc.default)('line', true));
    registers.registerVisual({
        seriesType: 'line',
        reset: function(seriesModel) {
            var data = seriesModel.getData(); // Visual coding for legend
            var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual('style').fill;
            data.setVisual('legendLineStyle', lineStyle);
        }
    }); // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $7jcIW.default)('line'));
}

});
parcelRegister("jvYs5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e34fce1556fedd5e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bAY5l = parcelRequire("bAY5l");

var $1O7Ua = parcelRequire("1O7Ua");

var $7yklO = parcelRequire("7yklO");

var $4KVOr = parcelRequire("4KVOr");
var $e34fce1556fedd5e$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $bAY5l.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $4KVOr.default)();
        var line = (0, $7yklO.createSymbol)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual('symbol');
        var visualRotate = this.getData().getVisual('symbolRotate');
        var symbolType = visualType === 'none' ? 'circle' : visualType; // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $7yklO.createSymbol)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf('empty') > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = '#fff';
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = 'series.line';
    LineSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    LineSeriesModel.defaultOption = {
        zlevel: 0,
        z: 3,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        clip: true,
        label: {
            position: 'top'
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: 'solid'
        },
        emphasis: {
            scale: true,
            lineStyle: {
                width: 'bolder'
            }
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: 'emptyCircle',
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: 'auto',
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: 'none',
        animationEasing: 'linear',
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: 'clone'
        }
    };
    return LineSeriesModel;
}((0, $1O7Ua.default));
var $e34fce1556fedd5e$export$2e2bcd8739ae039 = $e34fce1556fedd5e$var$LineSeriesModel;

});
parcelRegister("bAY5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $8711aa3240a9c687$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $liBXN = parcelRequire("liBXN");

var $h9jiS = parcelRequire("h9jiS");

var $bnVGB = parcelRequire("bnVGB");

var $eaKsF = parcelRequire("eaKsF");

var $gyhNQ = parcelRequire("gyhNQ");

var $lhMGv = parcelRequire("lhMGv");

var $20liu = parcelRequire("20liu");

var $5R8Hi = parcelRequire("5R8Hi");

var $cNGs8 = parcelRequire("cNGs8");

var $2Rbm1 = parcelRequire("2Rbm1");
function $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $gyhNQ.default).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $bahqM.map(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $bnVGB.getDimensionTypeByAxis)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $8711aa3240a9c687$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $bahqM.each(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $8711aa3240a9c687$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $20liu.createSourceFromSeriesDataOption)(sourceRaw);
    } else {
        source = sourceManager.getSource(); // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL);
    }
    var coordSysInfo = (0, $lhMGv.getCoordSysInfoBySeries)(seriesModel);
    var coordSysDimDefs = $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $bahqM.isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $bahqM.curry((0, $cNGs8.makeSeriesEncodeForAxisCoordSys), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $h9jiS.default)(source, createDimensionOptions);
    var firstCategoryDimIndex = $8711aa3240a9c687$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $5R8Hi.enableDataStack)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $liBXN.default)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)) {
        var sampleItem = $8711aa3240a9c687$var$firstDataNotNull(source.data || []);
        return sampleItem != null && !$bahqM.isArray((0, $eaKsF.getDataItemValue)(sampleItem));
    }
}
function $8711aa3240a9c687$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $8711aa3240a9c687$export$2e2bcd8739ae039 = $8711aa3240a9c687$var$createSeriesData;

});
parcelRegister("bahqM", function(module, exports) {

$parcel$export(module.exports, "$override", () => $820e264882d7264f$export$d35a04b83ea6803e);
$parcel$export(module.exports, "guid", () => $820e264882d7264f$export$46e8f25c7328f77e);
$parcel$export(module.exports, "logError", () => $820e264882d7264f$export$58da9968c3170cb1);
$parcel$export(module.exports, "clone", () => $820e264882d7264f$export$9cd59f9826255e47);
$parcel$export(module.exports, "isPrimitive", () => $820e264882d7264f$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isDom", () => $820e264882d7264f$export$9f57505b7bd8dae);
$parcel$export(module.exports, "merge", () => $820e264882d7264f$export$4950aa0f605343fb);
$parcel$export(module.exports, "isObject", () => $820e264882d7264f$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isArray", () => $820e264882d7264f$export$43bee75e5e14138e);
$parcel$export(module.exports, "isBuiltInObject", () => $820e264882d7264f$export$fa523b2c4941fd4f);
$parcel$export(module.exports, "mergeAll", () => $820e264882d7264f$export$18aef43295bbe906);
$parcel$export(module.exports, "extend", () => $820e264882d7264f$export$8b58be045bf06082);
$parcel$export(module.exports, "defaults", () => $820e264882d7264f$export$ebe90cb607ad99e);
$parcel$export(module.exports, "keys", () => $820e264882d7264f$export$ed97f33186d4b816);
$parcel$export(module.exports, "createCanvas", () => $820e264882d7264f$export$cd3d1f114b139967);
$parcel$export(module.exports, "indexOf", () => $820e264882d7264f$export$305f7d4e9d4624f2);
$parcel$export(module.exports, "inherits", () => $820e264882d7264f$export$69f1b2dcda23c5f8);
$parcel$export(module.exports, "mixin", () => $820e264882d7264f$export$e36fc9d62a853069);
$parcel$export(module.exports, "isArrayLike", () => $820e264882d7264f$export$1e2f57719e155213);
$parcel$export(module.exports, "each", () => $820e264882d7264f$export$79b2f7037acddd43);
$parcel$export(module.exports, "map", () => $820e264882d7264f$export$871de8747c9eaa88);
$parcel$export(module.exports, "slice", () => $820e264882d7264f$export$58adb3bec8346d0f);
$parcel$export(module.exports, "reduce", () => $820e264882d7264f$export$533b26079ad0b4b);
$parcel$export(module.exports, "filter", () => $820e264882d7264f$export$3dea766d36a8935f);
$parcel$export(module.exports, "find", () => $820e264882d7264f$export$71aa6c912b956294);
$parcel$export(module.exports, "bind", () => $820e264882d7264f$export$2385a24977818dd0);
$parcel$export(module.exports, "isFunction", () => $820e264882d7264f$export$f6e2535fb5126e54);
$parcel$export(module.exports, "curry", () => $820e264882d7264f$export$c3095a23b368d1f2);
$parcel$export(module.exports, "isString", () => $820e264882d7264f$export$844ec244b1367d54);
$parcel$export(module.exports, "isStringSafe", () => $820e264882d7264f$export$29d0bb2a4e07b252);
$parcel$export(module.exports, "isNumber", () => $820e264882d7264f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isTypedArray", () => $820e264882d7264f$export$b119cc7e1840e59c);
$parcel$export(module.exports, "isGradientObject", () => $820e264882d7264f$export$fa2c283003ed971c);
$parcel$export(module.exports, "isImagePatternObject", () => $820e264882d7264f$export$a49bbf3a55dcef7b);
$parcel$export(module.exports, "isRegExp", () => $820e264882d7264f$export$49841c62b9eff15);
$parcel$export(module.exports, "eqNaN", () => $820e264882d7264f$export$7d667b9a0c48c975);
$parcel$export(module.exports, "retrieve", () => $820e264882d7264f$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "retrieve2", () => $820e264882d7264f$export$995e01f2f5c9d030);
$parcel$export(module.exports, "retrieve3", () => $820e264882d7264f$export$2e94551289abb95b);
$parcel$export(module.exports, "normalizeCssArray", () => $820e264882d7264f$export$f3a38102c49f4268);
$parcel$export(module.exports, "assert", () => $820e264882d7264f$export$a7a9523472993e97);
$parcel$export(module.exports, "trim", () => $820e264882d7264f$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "setAsPrimitive", () => $820e264882d7264f$export$112e66431016387b);
$parcel$export(module.exports, "HashMap", () => $820e264882d7264f$export$60ef0b43d585640a);
$parcel$export(module.exports, "createHashMap", () => $820e264882d7264f$export$55f8aa7ef875b0a4);
$parcel$export(module.exports, "concatArray", () => $820e264882d7264f$export$4fd8af2c48c43416);
$parcel$export(module.exports, "createObject", () => $820e264882d7264f$export$79c7e160a7743efd);
$parcel$export(module.exports, "hasOwn", () => $820e264882d7264f$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "noop", () => $820e264882d7264f$export$8793edee2d425525);
var $820e264882d7264f$var$BUILTIN_OBJECT = {
    '[object Function]': true,
    '[object RegExp]': true,
    '[object Date]': true,
    '[object Error]': true,
    '[object CanvasGradient]': true,
    '[object CanvasPattern]': true,
    '[object Image]': true,
    '[object Canvas]': true
};
var $820e264882d7264f$var$TYPED_ARRAY = {
    '[object Int8Array]': true,
    '[object Uint8Array]': true,
    '[object Uint8ClampedArray]': true,
    '[object Int16Array]': true,
    '[object Uint16Array]': true,
    '[object Int32Array]': true,
    '[object Uint32Array]': true,
    '[object Float32Array]': true,
    '[object Float64Array]': true
};
var $820e264882d7264f$var$objToString = Object.prototype.toString;
var $820e264882d7264f$var$arrayProto = Array.prototype;
var $820e264882d7264f$var$nativeForEach = $820e264882d7264f$var$arrayProto.forEach;
var $820e264882d7264f$var$nativeFilter = $820e264882d7264f$var$arrayProto.filter;
var $820e264882d7264f$var$nativeSlice = $820e264882d7264f$var$arrayProto.slice;
var $820e264882d7264f$var$nativeMap = $820e264882d7264f$var$arrayProto.map;
var $820e264882d7264f$var$ctorFunction = (function() {}).constructor;
var $820e264882d7264f$var$protoFunction = $820e264882d7264f$var$ctorFunction ? $820e264882d7264f$var$ctorFunction.prototype : null;
var $820e264882d7264f$var$protoKey = '__proto__';
var $820e264882d7264f$var$methods = {};
function $820e264882d7264f$export$d35a04b83ea6803e(name, fn) {
    $820e264882d7264f$var$methods[name] = fn;
}
var $820e264882d7264f$var$idStart = 0x0907;
function $820e264882d7264f$export$46e8f25c7328f77e() {
    return $820e264882d7264f$var$idStart++;
}
function $820e264882d7264f$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $820e264882d7264f$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== 'object') return source;
    var result = source;
    var typeStr = $820e264882d7264f$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
        }
    } else if ($820e264882d7264f$var$TYPED_ARRAY[typeStr]) {
        if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
            }
        }
    } else if (!$820e264882d7264f$var$BUILTIN_OBJECT[typeStr] && !$820e264882d7264f$export$c3825b437cbdea5c(source) && !$820e264882d7264f$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) result[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $820e264882d7264f$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$820e264882d7264f$export$a6cdc56e425d0d0a(source) || !$820e264882d7264f$export$a6cdc56e425d0d0a(target)) return overwrite ? $820e264882d7264f$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($820e264882d7264f$export$a6cdc56e425d0d0a(sourceProp) && $820e264882d7264f$export$a6cdc56e425d0d0a(targetProp) && !$820e264882d7264f$export$43bee75e5e14138e(sourceProp) && !$820e264882d7264f$export$43bee75e5e14138e(targetProp) && !$820e264882d7264f$export$9f57505b7bd8dae(sourceProp) && !$820e264882d7264f$export$9f57505b7bd8dae(targetProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(sourceProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(targetProp) && !$820e264882d7264f$export$c3825b437cbdea5c(sourceProp) && !$820e264882d7264f$export$c3825b437cbdea5c(targetProp)) $820e264882d7264f$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $820e264882d7264f$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $820e264882d7264f$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $820e264882d7264f$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $820e264882d7264f$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $820e264882d7264f$export$ed97f33186d4b816(source);
    for(var i = 0; i < keysArr.length; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $820e264882d7264f$export$cd3d1f114b139967 = function() {
    return $820e264882d7264f$var$methods.createCanvas();
};
$820e264882d7264f$var$methods.createCanvas = function() {
    return document.createElement('canvas');
};
function $820e264882d7264f$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $820e264882d7264f$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $820e264882d7264f$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $820e264882d7264f$export$ebe90cb607ad99e(target, source, override);
}
function $820e264882d7264f$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $820e264882d7264f$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $820e264882d7264f$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $820e264882d7264f$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $820e264882d7264f$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $820e264882d7264f$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $820e264882d7264f$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $820e264882d7264f$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $820e264882d7264f$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $820e264882d7264f$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $820e264882d7264f$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
    };
}
var $820e264882d7264f$export$2385a24977818dd0 = $820e264882d7264f$var$protoFunction && $820e264882d7264f$export$f6e2535fb5126e54($820e264882d7264f$var$protoFunction.bind) ? $820e264882d7264f$var$protoFunction.call.bind($820e264882d7264f$var$protoFunction.bind) : $820e264882d7264f$var$bindPolyfill;
function $820e264882d7264f$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
    };
}
function $820e264882d7264f$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $820e264882d7264f$var$objToString.call(value) === '[object Array]';
}
function $820e264882d7264f$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $820e264882d7264f$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $820e264882d7264f$export$29d0bb2a4e07b252(value) {
    return $820e264882d7264f$var$objToString.call(value) === '[object String]';
}
function $820e264882d7264f$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $820e264882d7264f$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === 'function' || !!value && type === 'object';
}
function $820e264882d7264f$export$fa523b2c4941fd4f(value) {
    return !!$820e264882d7264f$var$BUILTIN_OBJECT[$820e264882d7264f$var$objToString.call(value)];
}
function $820e264882d7264f$export$b119cc7e1840e59c(value) {
    return !!$820e264882d7264f$var$TYPED_ARRAY[$820e264882d7264f$var$objToString.call(value)];
}
function $820e264882d7264f$export$9f57505b7bd8dae(value) {
    return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
function $820e264882d7264f$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $820e264882d7264f$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $820e264882d7264f$export$49841c62b9eff15(value) {
    return $820e264882d7264f$var$objToString.call(value) === '[object RegExp]';
}
function $820e264882d7264f$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $820e264882d7264f$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $820e264882d7264f$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $820e264882d7264f$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $820e264882d7264f$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $820e264882d7264f$var$nativeSlice.apply(arr, args);
}
function $820e264882d7264f$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $820e264882d7264f$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $820e264882d7264f$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $820e264882d7264f$var$primitiveKey = '__ec_primitive__';
function $820e264882d7264f$export$112e66431016387b(obj) {
    obj[$820e264882d7264f$var$primitiveKey] = true;
}
function $820e264882d7264f$export$c3825b437cbdea5c(obj) {
    return obj[$820e264882d7264f$var$primitiveKey];
}
var $820e264882d7264f$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        this.data = {};
        var isArr = $820e264882d7264f$export$43bee75e5e14138e(obj);
        this.data = {};
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $820e264882d7264f$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.get = function(key) {
        return this.data.hasOwnProperty(key) ? this.data[key] : null;
    };
    HashMap.prototype.set = function(key, value) {
        return this.data[key] = value;
    };
    HashMap.prototype.each = function(cb, context) {
        for(var key in this.data)if (this.data.hasOwnProperty(key)) cb.call(context, this.data[key], key);
    };
    HashMap.prototype.keys = function() {
        return $820e264882d7264f$export$ed97f33186d4b816(this.data);
    };
    HashMap.prototype.removeKey = function(key) {
        delete this.data[key];
    };
    return HashMap;
}();
function $820e264882d7264f$export$55f8aa7ef875b0a4(obj) {
    return new $820e264882d7264f$export$60ef0b43d585640a(obj);
}
function $820e264882d7264f$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $820e264882d7264f$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $820e264882d7264f$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $820e264882d7264f$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $820e264882d7264f$export$8793edee2d425525() {}

});

parcelRegister("liBXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f818ba28c897a2f2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 
var $bahqM = parcelRequire("bahqM");

var $gaMkj = parcelRequire("gaMkj");

var $4wWkb = parcelRequire("4wWkb");

var $9OHWG = parcelRequire("9OHWG");

var $bnVGB = parcelRequire("bnVGB");

var $dhxbO = parcelRequire("dhxbO");

var $2Rbm1 = parcelRequire("2Rbm1");

var $eaKsF = parcelRequire("eaKsF");

var $7QjoM = parcelRequire("7QjoM");

var $20liu = parcelRequire("20liu");

var $8c3gC = parcelRequire("8c3gC");

var $2Om11 = parcelRequire("2Om11");
var $f818ba28c897a2f2$var$isObject = $bahqM.isObject;
var $f818ba28c897a2f2$var$map = $bahqM.map;
var $f818ba28c897a2f2$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.
var $f818ba28c897a2f2$var$ID_PREFIX = 'e\0\0';
var $f818ba28c897a2f2$var$INDEX_NOT_FOUND = -1; // type SeriesDimensionIndex = DimensionIndex;
var $f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $f818ba28c897a2f2$var$CLONE_PROPERTIES = [
    '_approximateExtent'
]; // -----------------------------
// Internal method declarations:
// -----------------------------
var $f818ba28c897a2f2$var$prepareInvertedIndex;
var $f818ba28c897a2f2$var$getId;
var $f818ba28c897a2f2$var$getIdNameFromStore;
var $f818ba28c897a2f2$var$normalizeDimensions;
var $f818ba28c897a2f2$var$transferProperties;
var $f818ba28c897a2f2$var$cloneListForMapAndSample;
var $f818ba28c897a2f2$var$makeIdFromName;
var $f818ba28c897a2f2$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = []; // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {}; // Globel layout properties.
        this._layout = {}; // Item visual properties after visual coding
        this._itemVisuals = []; // Item layout properties after layout
        this._itemLayouts = []; // Graphic elemnents
        this._graphicEls = []; // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {}; // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false; // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'lttbDownSample',
            'map'
        ]; // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $2Om11.isSeriesDataSchema)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $bahqM.isString(dimInfoInput) ? new (0, $dhxbO.default)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $dhxbO.default)) ? new (0, $dhxbO.default)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (otherDims.itemName === 0) this._nameDimIdx = i;
            if (otherDims.itemId === 0) this._idDimIdx = i;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $bahqM.createHashMap();
            $bahqM.each(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Becuause of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
         // Retrieve from series dimension definition becuase it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatbility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recogonized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if (typeof dim === 'number' // If being a number-like string but not being defined as a dimension name.
         || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $8c3gC.default)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $20liu.isSourceInstance)(data) || $bahqM.isArrayLike(data) ? new (0, $9OHWG.DefaultDataProvider)(data, dimensions.length) : data;
            store = new (0, $8c3gC.default)();
            var dimensionInfos = $f818ba28c897a2f2$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store; // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count()); // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $bnVGB.summarizeDimensions)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exaclty cooresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $f818ba28c897a2f2$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL); // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $eaKsF.isDataItemOption)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $eaKsF.convertOptionIdName)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $eaKsF.convertOptionIdName)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$f818ba28c897a2f2$var$makeIdFromName(this, idx);
        $f818ba28c897a2f2$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculte extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $f818ba28c897a2f2$var$isObject(key) ? $bahqM.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Becuase:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $f818ba28c897a2f2$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Becuase:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $f818ba28c897a2f2$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $bahqM.isArray(dimensions) ? store.getValues($f818ba28c897a2f2$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Inlcuding '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retreive the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $bahqM.bind(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $bahqM.bind(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $bahqM.keys(range);
        var dimIndices = [];
        $bahqM.each(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict'; // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $bahqM.bind(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this; // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this); // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, becuase `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each sereis
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $bahqM.bind(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $gaMkj.default)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $4wWkb.default)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $f818ba28c897a2f2$var$getId(otherList, idx);
        }, function(idx) {
            return $f818ba28c897a2f2$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($f818ba28c897a2f2$var$isObject(kvObj)) $bahqM.extend(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key); // TODO Performance?
            if ($bahqM.isArray(val)) val = val.slice();
            else if ($f818ba28c897a2f2$var$isObject(val)) val = $bahqM.extend({}, val);
            itemVisual[key] = val;
        }
        return val;
    }; // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($f818ba28c897a2f2$var$isObject(key)) $bahqM.extend(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        if ($f818ba28c897a2f2$var$isObject(key)) {
            for(var name_1 in key)if (key.hasOwnProperty(name_1)) this.setLayout(name_1, key[name_1]);
            return;
        }
        this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $bahqM.extend(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $7QjoM.setCommonECData)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $bahqM.each(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $f818ba28c897a2f2$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $f818ba28c897a2f2$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (typeof originalMethod !== 'function') return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($bahqM.slice(arguments)));
        };
    }; // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $f818ba28c897a2f2$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $bahqM.each(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $f818ba28c897a2f2$var$CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $f818ba28c897a2f2$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $eaKsF.convertOptionIdName)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $f818ba28c897a2f2$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $f818ba28c897a2f2$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $f818ba28c897a2f2$var$ID_PREFIX + rawIndex;
            return id;
        };
        $f818ba28c897a2f2$var$normalizeDimensions = function(dimensions) {
            if (!$bahqM.isArray(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transfered.
     */ $f818ba28c897a2f2$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $f818ba28c897a2f2$var$map(original.dimensions, original._getDimInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
            $f818ba28c897a2f2$var$transferProperties(list, original);
            return list;
        };
        $f818ba28c897a2f2$var$transferProperties = function(target, source) {
            $bahqM.each($f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $bahqM.each($f818ba28c897a2f2$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $bahqM.clone(source[propName]);
            });
            target._calculationInfo = $bahqM.extend({}, source._calculationInfo);
        };
        $f818ba28c897a2f2$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $f818ba28c897a2f2$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $f818ba28c897a2f2$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $f818ba28c897a2f2$export$2e2bcd8739ae039 = $f818ba28c897a2f2$var$SeriesData;

});
parcelRegister("gaMkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc63113067804ddc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hZfwb = parcelRequire("hZfwb");

var $aLwh0 = parcelRequire("aLwh0");

var $8P3Or = parcelRequire("8P3Or");

var $hyGik = parcelRequire("hyGik");

var $46U6E = parcelRequire("46U6E");

var $4rldO = parcelRequire("4rldO");

var $bahqM = parcelRequire("bahqM");
var $bc63113067804ddc$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option; // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $bahqM.merge)(this.option, option, true);
    }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'xxx.yyy.zzz' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * Squash option stack into one.
   * parentModel will be removed after squashed.
   *
   * NOTE: resolveParentPath will not be applied here for simplicity. DON'T use this function
   * if resolveParentPath is modified.
   *
   * @param deepMerge If do deep merge. Default to be false.
   */ // squash(
    //     deepMerge?: boolean,
    //     handleCallback?: (func: () => object) => object
    // ) {
    //     const optionStack = [];
    //     let model: Model = this;
    //     while (model) {
    //         if (model.option) {
    //             optionStack.push(model.option);
    //         }
    //         model = model.parentModel;
    //     }
    //     const newOption = {} as Opt;
    //     let option;
    //     while (option = optionStack.pop()) {    // Top down merge
    //         if (isFunction(option) && handleCallback) {
    //             option = handleCallback(option);
    //         }
    //         if (deepMerge) {
    //             merge(newOption, option);
    //         }
    //         else {
    //             extend(newOption, option);
    //         }
    //     }
    //     // Remove parentModel
    //     this.option = newOption;
    //     this.parentModel = null;
    // }
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {}; // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $bahqM.clone)(this.option));
    }; // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    }; // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    }; // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $hZfwb.default).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
             // obj could be number/string/... (like 0)
            obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
(0, $aLwh0.enableClassExtend)($bc63113067804ddc$var$Model);
(0, $aLwh0.enableClassCheck)($bc63113067804ddc$var$Model);
(0, $bahqM.mixin)($bc63113067804ddc$var$Model, (0, $46U6E.LineStyleMixin));
(0, $bahqM.mixin)($bc63113067804ddc$var$Model, (0, $4rldO.ItemStyleMixin));
(0, $bahqM.mixin)($bc63113067804ddc$var$Model, (0, $8P3Or.AreaStyleMixin));
(0, $bahqM.mixin)($bc63113067804ddc$var$Model, (0, $hyGik.default));
var $bc63113067804ddc$export$2e2bcd8739ae039 = $bc63113067804ddc$var$Model;

});
parcelRegister("hZfwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1842bbf4a5e2f15$export$2e2bcd8739ae039);
var $d1842bbf4a5e2f15$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $d1842bbf4a5e2f15$var$Env = function() {
    function Env() {
        this.browser = new $d1842bbf4a5e2f15$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.canvasSupported = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
    }
    return Env;
}();
var $d1842bbf4a5e2f15$var$env = new $d1842bbf4a5e2f15$var$Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $d1842bbf4a5e2f15$var$env.wxa = true;
    $d1842bbf4a5e2f15$var$env.canvasSupported = true;
    $d1842bbf4a5e2f15$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
    $d1842bbf4a5e2f15$var$env.worker = true;
    $d1842bbf4a5e2f15$var$env.canvasSupported = true;
} else if (typeof navigator === 'undefined') {
    $d1842bbf4a5e2f15$var$env.node = true;
    $d1842bbf4a5e2f15$var$env.canvasSupported = true;
    $d1842bbf4a5e2f15$var$env.svgSupported = true;
} else $d1842bbf4a5e2f15$var$detect(navigator.userAgent, $d1842bbf4a5e2f15$var$env);
function $d1842bbf4a5e2f15$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.canvasSupported = !!document.createElement('canvas').getContext;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    env.domSupported = typeof document !== 'undefined';
    var style = document.documentElement.style;
    env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
    env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
}
var $d1842bbf4a5e2f15$export$2e2bcd8739ae039 = $d1842bbf4a5e2f15$var$env;

});

parcelRegister("aLwh0", function(module, exports) {

$parcel$export(module.exports, "parseClassType", () => $7d6753f3a830ddbc$export$fbe18865d303bf01);
$parcel$export(module.exports, "isExtendedClass", () => $7d6753f3a830ddbc$export$4f3b818f3dd2d182);
$parcel$export(module.exports, "enableClassExtend", () => $7d6753f3a830ddbc$export$cd4c3a4dca301c70);
$parcel$export(module.exports, "mountExtend", () => $7d6753f3a830ddbc$export$c9c2d87774f1275d);
$parcel$export(module.exports, "enableClassCheck", () => $7d6753f3a830ddbc$export$e1aac4552ae82081);
$parcel$export(module.exports, "enableClassManagement", () => $7d6753f3a830ddbc$export$241315e45585454d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");
var $7d6753f3a830ddbc$var$TYPE_DELIMITER = '.';
var $7d6753f3a830ddbc$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $7d6753f3a830ddbc$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($7d6753f3a830ddbc$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $7d6753f3a830ddbc$var$checkClassType(componentType) {
    $bahqM.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $7d6753f3a830ddbc$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS]);
}
function $7d6753f3a830ddbc$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this; // For backward compat, we both support ts class inheritance and this
        // "extend" approach.
        // The constructor should keep the same behavior as ts class inheritance:
        // If this constructor/$constructor is not declared, auto invoke the super
        // constructor.
        // If this constructor/$constructor is declared, it is responsible for
        // calling the super constructor.
        function ExtendedClass() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (!proto.$constructor) {
                if (!$7d6753f3a830ddbc$var$isESClass(superClass)) // Will throw error if superClass is an es6 native class.
                superClass.apply(this, arguments);
                else {
                    var ins = $bahqM.createObject(ExtendedClass.prototype, new (superClass.bind.apply(superClass, (0, $3VFsf.__spreadArray)([
                        void 0
                    ], args)))());
                    return ins;
                }
            } else proto.$constructor.apply(this, arguments);
        }
        ExtendedClass[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS] = true;
        $bahqM.extend(ExtendedClass.prototype, proto);
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $7d6753f3a830ddbc$var$superCall;
        ExtendedClass.superApply = $7d6753f3a830ddbc$var$superApply;
        $bahqM.inherits(ExtendedClass, this);
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $7d6753f3a830ddbc$var$isESClass(fn) {
    return typeof fn === 'function' && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $7d6753f3a830ddbc$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
} // A random offset.
var $7d6753f3a830ddbc$var$classBase = Math.round(Math.random() * 10);
function $7d6753f3a830ddbc$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $7d6753f3a830ddbc$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.
function $7d6753f3a830ddbc$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $7d6753f3a830ddbc$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $7d6753f3a830ddbc$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance memeber".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we stil support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $7d6753f3a830ddbc$var$checkClassType(componentFullType); // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $7d6753f3a830ddbc$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$7d6753f3a830ddbc$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER]) $bahqM.each(obj, function(o, type) {
            type !== $7d6753f3a830ddbc$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $bahqM.each(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$7d6753f3a830ddbc$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$7d6753f3a830ddbc$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }

});

parcelRegister("8P3Or", function(module, exports) {

$parcel$export(module.exports, "AreaStyleMixin", () => $66c60b4522f41760$export$a3a0ed7e2dd84c9e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1BJbl = parcelRequire("1BJbl");
var $66c60b4522f41760$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $66c60b4522f41760$var$getAreaStyle = (0, $1BJbl.default)($66c60b4522f41760$export$52de6e304d934d85);
var $66c60b4522f41760$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $66c60b4522f41760$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();

});
parcelRegister("1BJbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bc4b5222290b4b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

var $bahqM = parcelRequire("bahqM");
function $12bc4b5222290b4b$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $bahqM.indexOf(excludes, propName) >= 0 || includes && $bahqM.indexOf(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        } // TODO Text or image?
        return style;
    };
}

});


parcelRegister("hyGik", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc866b770f3f8e08$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gvLUt = parcelRequire("gvLUt");

var $4gEFv = parcelRequire("4gEFv");
var $cc866b770f3f8e08$var$PATH_COLOR = [
    'textStyle',
    'color'
]; // TODO Performance improvement?
var $cc866b770f3f8e08$var$tmpRichText = new (0, $4gEFv.default)();
var $cc866b770f3f8e08$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($cc866b770f3f8e08$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $gvLUt.getFont)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        $cc866b770f3f8e08$var$tmpRichText.useStyle({
            text: text,
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily'),
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline'),
            padding: this.getShallow('padding'),
            lineHeight: this.getShallow('lineHeight'),
            rich: this.getShallow('rich')
        });
        $cc866b770f3f8e08$var$tmpRichText.update();
        return $cc866b770f3f8e08$var$tmpRichText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $cc866b770f3f8e08$export$2e2bcd8739ae039 = $cc866b770f3f8e08$var$TextStyleMixin;

});
parcelRegister("gvLUt", function(module, exports) {

$parcel$export(module.exports, "setLabelStyle", () => $c054b479467e8395$export$9a13992917966657);
$parcel$export(module.exports, "createTextStyle", () => $c054b479467e8395$export$f8998c3d0a13de59);
$parcel$export(module.exports, "createTextConfig", () => $c054b479467e8395$export$e149afab8df6e053);
$parcel$export(module.exports, "labelInner", () => $c054b479467e8395$export$f62786d3261ab0f4);
$parcel$export(module.exports, "getLabelStatesModels", () => $c054b479467e8395$export$9739a32674be5893);
$parcel$export(module.exports, "getFont", () => $c054b479467e8395$export$155316a870a9d61e);
$parcel$export(module.exports, "setLabelValueAnimation", () => $c054b479467e8395$export$7bdbceaf9ab378f2);
$parcel$export(module.exports, "animateLabelValue", () => $c054b479467e8395$export$dd6101605f5c186);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4gEFv = parcelRequire("4gEFv");

var $bahqM = parcelRequire("bahqM");

var $fIXXx = parcelRequire("fIXXx");


var $eaKsF = parcelRequire("eaKsF");

var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");
var $c054b479467e8395$var$EMPTY_OBJ = {};
function $c054b479467e8395$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $c054b479467e8395$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $bahqM.isFunction)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $bahqM.retrieve2)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $c054b479467e8395$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified // TODO specified position?
) {
    opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $4gEFv.default);
    var needsCreateText = false;
    for(var i = 0; i < (0, $fIXXx.DISPLAY_STATES).length; i++){
        var stateModel = labelStatesModels[(0, $fIXXx.DISPLAY_STATES)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $4gEFv.default)();
                targetEl.setTextContent(textContent);
            } // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $c054b479467e8395$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($c054b479467e8395$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
            var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $bahqM.retrieve2)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $c054b479467e8395$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $c054b479467e8395$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        } // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto slient is those cases.
        textContent.silent = !!normalModel.getShallow('silent'); // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal; // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $c054b479467e8395$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $c054b479467e8395$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $c054b479467e8395$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $c054b479467e8395$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $bahqM.extend)(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $c054b479467e8395$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $bahqM.retrieve2)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
     // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $c054b479467e8395$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]); // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $c054b479467e8395$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var margin = textStyleModel.get('minMargin');
    if (margin != null) textStyle.margin = margin;
    $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $c054b479467e8395$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $c054b479467e8395$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $bahqM.keys)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $c054b479467e8395$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign'
];
var $c054b479467e8395$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $c054b479467e8395$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $bahqM.retrieve2)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $bahqM.retrieve2)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $bahqM.retrieve2)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $bahqM.retrieve2)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
     // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    } // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL[i];
        var val = (0, $bahqM.retrieve2)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_SELF.length; i++){
        var key = $c054b479467e8395$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_BOX.length; i++){
            var key = $c054b479467e8395$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $c054b479467e8395$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $bahqM.trim)([
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $c054b479467e8395$export$f62786d3261ab0f4 = (0, $eaKsF.makeInner)();
function $c054b479467e8395$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $c054b479467e8395$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $c054b479467e8395$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $c054b479467e8395$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation) return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText; // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $bahqM.retrieve2)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $eaKsF.interpolateRawValues)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $c054b479467e8395$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $c054b479467e8395$export$b533918394a58529(textEl, labelText);
    }
    (labelInnerStore.prevValue == null ? (0, $eYgMC.initProps) : (0, $eYgMC.updateProps))(textEl, {}, animatableModel, dataIndex, null, during);
}

});
parcelRegister("4gEFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b833f429060f54$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $h6fMM = parcelRequire("h6fMM");

var $45jlh = parcelRequire("45jlh");

var $bahqM = parcelRequire("bahqM");

var $b7ZX8 = parcelRequire("b7ZX8");

var $gcbBH = parcelRequire("gcbBH");

var $7Tw7u = parcelRequire("7Tw7u");

var $1E3E8 = parcelRequire("1E3E8");

var $lBQ88 = parcelRequire("lBQ88");
var $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $31b833f429060f54$export$21aaaa0607ee0e2b = {
    style: (0, $bahqM.defaults)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $lBQ88.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $31b833f429060f54$var$ZRText = function(_super) {
    (0, $3VFsf.__extends)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $31b833f429060f54$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $1E3E8.default)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {
        throw new Error('Can\'t attach text on another text');
    };
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $bahqM.extend)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $bahqM.keys)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $bahqM.extend)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $31b833f429060f54$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $b7ZX8.DEFAULT_FONT);
        var textPadding = style.padding;
        var text = $31b833f429060f54$var$getStyleText(style);
        var contentBlock = (0, $h6fMM.parsePlainText)(text, style);
        var needDrawBg = $31b833f429060f54$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        var textX = baseX;
        var textY = (0, $b7ZX8.adjustTextY)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var outerWidth_1 = contentBlock.width;
            textPadding && (outerWidth_1 += textPadding[1] + textPadding[3]);
            var boxX = (0, $b7ZX8.adjustTextX)(baseX, outerWidth_1, textAlign);
            var boxY = (0, $b7ZX8.adjustTextY)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth_1, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $31b833f429060f54$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = $31b833f429060f54$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $31b833f429060f54$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $45jlh.default));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            if (textStroke) {
                subElStyle.stroke = textStroke;
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            if (textFill) subElStyle.fill = textFill;
            subElStyle.font = textFont;
            textY += lineHeight;
            if (fixedBoundingRect) el.setBoundingRect(new (0, $1E3E8.default)((0, $b7ZX8.adjustTextX)(subElStyle.x, style.width, subElStyle.textAlign), (0, $b7ZX8.adjustTextY)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), style.width, calculatedLineHeight));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var text = $31b833f429060f54$var$getStyleText(style);
        var contentBlock = (0, $h6fMM.parseRichText)(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var boxX = (0, $b7ZX8.adjustTextX)(baseX, outerWidth, textAlign);
        var boxY = (0, $b7ZX8.adjustTextY)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($31b833f429060f54$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $31b833f429060f54$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $45jlh.default));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = $31b833f429060f54$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $31b833f429060f54$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $b7ZX8.DEFAULT_FONT);
        subElStyle.opacity = (0, $bahqM.retrieve3)(tokenStyle.opacity, style.opacity, 1);
        if (textStroke) {
            subElStyle.lineWidth = (0, $bahqM.retrieve3)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $bahqM.retrieve2)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new (0, $1E3E8.default)((0, $b7ZX8.adjustTextX)(subElStyle.x, textWidth, subElStyle.textAlign), (0, $b7ZX8.adjustTextY)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $7Tw7u.default));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $bahqM.retrieve2)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $gcbBH.default));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $bahqM.retrieve2)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $bahqM.retrieve3)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if (style.fontSize || style.fontFamily || style.fontWeight) {
            var fontSize = '';
            if (typeof style.fontSize === 'string' && (style.fontSize.indexOf('px') !== -1 || style.fontSize.indexOf('rem') !== -1 || style.fontSize.indexOf('em') !== -1)) fontSize = style.fontSize;
            else if (!isNaN(+style.fontSize)) fontSize = style.fontSize + 'px';
            else fontSize = '12px';
            font = [
                style.fontStyle,
                style.fontWeight,
                fontSize,
                style.fontFamily || 'sans-serif'
            ].join(' ');
        }
        return font && (0, $bahqM.trim)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $lBQ88.default));
var $31b833f429060f54$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
function $31b833f429060f54$export$176336068cc5371f(style) {
    $31b833f429060f54$var$normalizeStyle(style);
    (0, $bahqM.each)(style.rich, $31b833f429060f54$var$normalizeStyle);
    return style;
}
function $31b833f429060f54$var$normalizeStyle(style) {
    if (style) {
        style.font = $31b833f429060f54$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $31b833f429060f54$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $bahqM.normalizeCssArray)(style.padding);
    }
}
function $31b833f429060f54$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $31b833f429060f54$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $31b833f429060f54$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $31b833f429060f54$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $31b833f429060f54$export$2e2bcd8739ae039 = $31b833f429060f54$var$ZRText;

});
parcelRegister("h6fMM", function(module, exports) {

$parcel$export(module.exports, "truncateText", () => $c72f3dec0993863b$export$59a943b34a82e690);
$parcel$export(module.exports, "parsePlainText", () => $c72f3dec0993863b$export$5772575e34ef80f9);
$parcel$export(module.exports, "parseRichText", () => $c72f3dec0993863b$export$15ec9472ff2d721);

var $63nvx = parcelRequire("63nvx");

var $bahqM = parcelRequire("bahqM");

var $b7ZX8 = parcelRequire("b7ZX8");
var $c72f3dec0993863b$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $c72f3dec0993863b$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) return '';
    var textLines = (text + '').split('\n');
    options = $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $c72f3dec0993863b$var$truncateSingleLine(textLines[i], options);
    return textLines.join('\n');
}
function $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $bahqM.extend)({}, options);
    preparedOpts.font = font;
    ellipsis = (0, $bahqM.retrieve2)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $bahqM.retrieve2)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $bahqM.retrieve2)(options.minChar, 0);
    preparedOpts.cnCharWidth = (0, $b7ZX8.getWidth)("\u56FD", font);
    var ascCharWidth = preparedOpts.ascCharWidth = (0, $b7ZX8.getWidth)('a', font);
    preparedOpts.placeholder = (0, $bahqM.retrieve2)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $b7ZX8.getWidth)(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $c72f3dec0993863b$var$truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) return '';
    var lineWidth = (0, $b7ZX8.getWidth)(textLine, font);
    if (lineWidth <= containerWidth) return textLine;
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $c72f3dec0993863b$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $b7ZX8.getWidth)(textLine, font);
    }
    if (textLine === '') textLine = options.placeholder;
    return textLine;
}
function $c72f3dec0993863b$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function $c72f3dec0993863b$export$5772575e34ef80f9(text, style) {
    text != null && (text += '');
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $b7ZX8.getLineHeight)(font);
    var lineHeight = (0, $bahqM.retrieve2)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var width = style.width;
    var lines;
    if (width != null && overflow === 'break' || overflow === 'breakAll') lines = text ? $c72f3dec0993863b$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    var height = (0, $bahqM.retrieve2)(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        lines = lines.slice(0, lineCount);
    }
    var outerHeight = height;
    var outerWidth = width;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        if (outerWidth != null) outerWidth += padding[1] + padding[3];
    }
    if (text && truncate && outerWidth != null) {
        var options = $c72f3dec0993863b$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        for(var i = 0; i < lines.length; i++)lines[i] = $c72f3dec0993863b$var$truncateSingleLine(lines[i], options);
    }
    if (width == null) {
        var maxWidth = 0;
        for(var i = 0; i < lines.length; i++)maxWidth = Math.max((0, $b7ZX8.getWidth)(lines[i], font), maxWidth);
        width = maxWidth;
    }
    return {
        lines: lines,
        height: height,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentHeight: contentHeight,
        width: width
    };
}
var $c72f3dec0993863b$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $c72f3dec0993863b$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $c72f3dec0993863b$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
    }
    return RichTextContentBlock;
}();
function $c72f3dec0993863b$export$15ec9472ff2d721(text, style) {
    var contentBlock = new $c72f3dec0993863b$export$ca607d3c98caaf7e();
    text != null && (text += '');
    if (!text) return contentBlock;
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $c72f3dec0993863b$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $c72f3dec0993863b$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $b7ZX8.getLineHeight)(font);
            var tokenHeight = (0, $bahqM.retrieve2)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $bahqM.retrieve3)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $b7ZX8.getWidth)(token.text, font);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $63nvx.findExistImage(bgImg);
                        if ($63nvx.isImageReady(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        token.text = $c72f3dec0993863b$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.width = token.contentWidth = (0, $b7ZX8.getWidth)(token.text, font);
                    }
                } else token.contentWidth = (0, $b7ZX8.getWidth)(token.text, font);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $bahqM.retrieve2)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $bahqM.retrieve2)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $c72f3dec0993863b$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $b7ZX8.parsePercent)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $c72f3dec0993863b$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    } else strLines = str.split('\n');
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $c72f3dec0993863b$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $b7ZX8.getWidth)(text, font);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $c72f3dec0993863b$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $c72f3dec0993863b$var$RichTextLine([
            token
        ]));
    }
}
function $c72f3dec0993863b$var$isLatin(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x21 && code <= 0xFF;
}
var $c72f3dec0993863b$var$breakCharMap = (0, $bahqM.reduce)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $c72f3dec0993863b$var$isWordBreakChar(ch) {
    if ($c72f3dec0993863b$var$isLatin(ch)) {
        if ($c72f3dec0993863b$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $c72f3dec0993863b$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $b7ZX8.getWidth)(ch, font);
        var inWord = isBreakAll ? false : !$c72f3dec0993863b$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        accumWidth += currentWordWidth;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = '';
        currentWordWidth = 0;
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}

});
parcelRegister("63nvx", function(module, exports) {

$parcel$export(module.exports, "findExistImage", () => $468542031e7bbc2a$export$1b614f30ac2c8867);
$parcel$export(module.exports, "createOrUpdateImage", () => $468542031e7bbc2a$export$46c791b69ff9a0f);
$parcel$export(module.exports, "isImageReady", () => $468542031e7bbc2a$export$37ca7dd901d0236d);

var $h4RuA = parcelRequire("h4RuA");
var $468542031e7bbc2a$var$globalImageCache = new (0, $h4RuA.default)(50);
function $468542031e7bbc2a$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $468542031e7bbc2a$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$468542031e7bbc2a$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = new Image();
            image.onload = image.onerror = $468542031e7bbc2a$var$imageOnLoad;
            $468542031e7bbc2a$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
            image.src = image.__zrImageSrc = newImageOrSrc;
        }
        return image;
    } else return newImageOrSrc;
}
function $468542031e7bbc2a$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $468542031e7bbc2a$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}

});
parcelRegister("h4RuA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ec4ddc95ccc3f1$export$2e2bcd8739ae039);
var $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $c6ec4ddc95ccc3f1$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $c6ec4ddc95ccc3f1$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $c6ec4ddc95ccc3f1$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $c6ec4ddc95ccc3f1$export$2e2bcd8739ae039 = $c6ec4ddc95ccc3f1$var$LRU;

});


parcelRegister("b7ZX8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FONT", () => $81a067b5a1d9459c$export$7d7a232b6d2cc80c);
$parcel$export(module.exports, "getWidth", () => $81a067b5a1d9459c$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getLineHeight", () => $81a067b5a1d9459c$export$56204a27a2958a55);
$parcel$export(module.exports, "adjustTextX", () => $81a067b5a1d9459c$export$eb5a525ef00ef9a4);
$parcel$export(module.exports, "adjustTextY", () => $81a067b5a1d9459c$export$bf7d6802d2badd9);
$parcel$export(module.exports, "getBoundingRect", () => $81a067b5a1d9459c$export$c381147bfed79d9f);
$parcel$export(module.exports, "parsePercent", () => $81a067b5a1d9459c$export$e8514cb5a5e2b40f);
$parcel$export(module.exports, "calculateTextPosition", () => $81a067b5a1d9459c$export$eee3603b512feab7);

var $1E3E8 = parcelRequire("1E3E8");

var $bahqM = parcelRequire("bahqM");

var $h4RuA = parcelRequire("h4RuA");
var $81a067b5a1d9459c$var$textWidthCache = {};
var $81a067b5a1d9459c$export$7d7a232b6d2cc80c = '12px sans-serif';
var $81a067b5a1d9459c$var$_ctx;
var $81a067b5a1d9459c$var$_cachedFont;
function $81a067b5a1d9459c$var$defaultMeasureText(text, font) {
    if (!$81a067b5a1d9459c$var$_ctx) $81a067b5a1d9459c$var$_ctx = (0, $bahqM.createCanvas)().getContext('2d');
    if ($81a067b5a1d9459c$var$_cachedFont !== font) $81a067b5a1d9459c$var$_cachedFont = $81a067b5a1d9459c$var$_ctx.font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
    return $81a067b5a1d9459c$var$_ctx.measureText(text);
}
var $81a067b5a1d9459c$var$methods = {
    measureText: $81a067b5a1d9459c$var$defaultMeasureText
};
function $81a067b5a1d9459c$export$d35a04b83ea6803e(name, fn) {
    $81a067b5a1d9459c$var$methods[name] = fn;
}
function $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font) {
    font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
    var cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font];
    if (!cacheOfFont) cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font] = new (0, $h4RuA.default)(500);
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = $81a067b5a1d9459c$var$methods.measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function $81a067b5a1d9459c$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font);
    var height = $81a067b5a1d9459c$export$56204a27a2958a55(font);
    var x = $81a067b5a1d9459c$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $81a067b5a1d9459c$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $1E3E8.default)(x, y, width, height);
    return rect;
}
function $81a067b5a1d9459c$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $1E3E8.default)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $81a067b5a1d9459c$export$eb5a525ef00ef9a4(x, width, textAlign) {
    if (textAlign === 'right') x -= width;
    else if (textAlign === 'center') x -= width / 2;
    return x;
}
function $81a067b5a1d9459c$export$bf7d6802d2badd9(y, height, verticalAlign) {
    if (verticalAlign === 'middle') y -= height / 2;
    else if (verticalAlign === 'bottom') y -= height;
    return y;
}
function $81a067b5a1d9459c$export$56204a27a2958a55(font) {
    return $81a067b5a1d9459c$export$3c49c185de0c2bfc("\u56FD", font);
}
function $81a067b5a1d9459c$export$866cc30a33805630(text, font) {
    return $81a067b5a1d9459c$var$methods.measureText(text, font);
}
function $81a067b5a1d9459c$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $81a067b5a1d9459c$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}

});
parcelRegister("1E3E8", function(module, exports) {

$parcel$export(module.exports, "default", () => $132c5af5562dffd4$export$2e2bcd8739ae039);

var $izqgC = parcelRequire("izqgC");

var $bMDnR = parcelRequire("bMDnR");
var $132c5af5562dffd4$var$mathMin = Math.min;
var $132c5af5562dffd4$var$mathMax = Math.max;
var $132c5af5562dffd4$var$lt = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$rb = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$lb = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$rt = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$minTv = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$maxTv = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function(other) {
        var x = $132c5af5562dffd4$var$mathMin(other.x, this.x);
        var y = $132c5af5562dffd4$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $132c5af5562dffd4$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $132c5af5562dffd4$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $izqgC.create();
        $izqgC.translate(m, m, [
            -a.x,
            -a.y
        ]);
        $izqgC.scale(m, m, [
            sx,
            sy
        ]);
        $izqgC.translate(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv) {
        if (!b) return false;
        if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) (0, $bMDnR.default).set($132c5af5562dffd4$var$maxTv, -d0, 0);
                    else (0, $bMDnR.default).set($132c5af5562dffd4$var$maxTv, d1, 0);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d0 < d1) (0, $bMDnR.default).set($132c5af5562dffd4$var$minTv, d0, 0);
                else (0, $bMDnR.default).set($132c5af5562dffd4$var$minTv, -d1, 0);
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) (0, $bMDnR.default).set($132c5af5562dffd4$var$maxTv, 0, -d2);
                    else (0, $bMDnR.default).set($132c5af5562dffd4$var$maxTv, 0, d3);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d2 < d3) (0, $bMDnR.default).set($132c5af5562dffd4$var$minTv, 0, d2);
                else (0, $bMDnR.default).set($132c5af5562dffd4$var$minTv, 0, -d3);
            }
        }
        if (mtv) (0, $bMDnR.default).copy(mtv, overlap ? $132c5af5562dffd4$var$minTv : $132c5af5562dffd4$var$maxTv);
        return overlap;
    };
    BoundingRect.prototype.contain = function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $132c5af5562dffd4$var$lt.x = $132c5af5562dffd4$var$lb.x = source.x;
        $132c5af5562dffd4$var$lt.y = $132c5af5562dffd4$var$rt.y = source.y;
        $132c5af5562dffd4$var$rb.x = $132c5af5562dffd4$var$rt.x = source.x + source.width;
        $132c5af5562dffd4$var$rb.y = $132c5af5562dffd4$var$lb.y = source.y + source.height;
        $132c5af5562dffd4$var$lt.transform(m);
        $132c5af5562dffd4$var$rt.transform(m);
        $132c5af5562dffd4$var$rb.transform(m);
        $132c5af5562dffd4$var$lb.transform(m);
        target.x = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
        target.y = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
        var maxX = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
        var maxY = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $132c5af5562dffd4$export$2e2bcd8739ae039 = $132c5af5562dffd4$var$BoundingRect;

});
parcelRegister("izqgC", function(module, exports) {

$parcel$export(module.exports, "create", () => $d84fdef7d2e904e1$export$185802fd694ee1f5);
$parcel$export(module.exports, "identity", () => $d84fdef7d2e904e1$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $d84fdef7d2e904e1$export$784d13d8ee351f07);
$parcel$export(module.exports, "mul", () => $d84fdef7d2e904e1$export$6e3a27864ab166fe);
$parcel$export(module.exports, "translate", () => $d84fdef7d2e904e1$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "rotate", () => $d84fdef7d2e904e1$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $d84fdef7d2e904e1$export$dcdf75081b88279d);
$parcel$export(module.exports, "invert", () => $d84fdef7d2e904e1$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "clone", () => $d84fdef7d2e904e1$export$9cd59f9826255e47);
function $d84fdef7d2e904e1$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $d84fdef7d2e904e1$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $d84fdef7d2e904e1$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $d84fdef7d2e904e1$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $d84fdef7d2e904e1$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $d84fdef7d2e904e1$export$bb628a54ab399bc9(out, a, rad) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * atx + st * aty;
    out[5] = ct * aty - st * atx;
    return out;
}
function $d84fdef7d2e904e1$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $d84fdef7d2e904e1$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $d84fdef7d2e904e1$export$9cd59f9826255e47(a) {
    var b = $d84fdef7d2e904e1$export$185802fd694ee1f5();
    $d84fdef7d2e904e1$export$784d13d8ee351f07(b, a);
    return b;
}

});

parcelRegister("bMDnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8942ba3a66d599f1$export$2e2bcd8739ae039);
var $8942ba3a66d599f1$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $8942ba3a66d599f1$export$2e2bcd8739ae039 = $8942ba3a66d599f1$var$Point;

});




parcelRegister("45jlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f96a200e6d0cf38$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $lBQ88 = parcelRequire("lBQ88");

var $b7ZX8 = parcelRequire("b7ZX8");

var $ghQ8v = parcelRequire("ghQ8v");

var $bahqM = parcelRequire("bahqM");
var $2f96a200e6d0cf38$export$5fbb6d98091bcb56 = (0, $bahqM.defaults)({
    strokeFirst: true,
    font: (0, $b7ZX8.DEFAULT_FONT),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $ghQ8v.DEFAULT_PATH_STYLE));
var $2f96a200e6d0cf38$var$TSpan = function(_super) {
    (0, $3VFsf.__extends)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== 'none' && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $bahqM.createObject)($2f96a200e6d0cf38$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? text += '' : text = '';
            var rect = (0, $b7ZX8.getBoundingRect)(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $lBQ88.default));
$2f96a200e6d0cf38$var$TSpan.prototype.type = 'tspan';
var $2f96a200e6d0cf38$export$2e2bcd8739ae039 = $2f96a200e6d0cf38$var$TSpan;

});
parcelRegister("lBQ88", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COMMON_STYLE", () => $fbb57da3b649c75e$export$737672163db00fe3);
$parcel$export(module.exports, "DEFAULT_COMMON_ANIMATION_PROPS", () => $fbb57da3b649c75e$export$9908943fb57fbe51);
$parcel$export(module.exports, "default", () => $fbb57da3b649c75e$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $7KVc5 = parcelRequire("7KVc5");

var $1E3E8 = parcelRequire("1E3E8");

var $bahqM = parcelRequire("bahqM");

var $aVawM = parcelRequire("aVawM");
var $fbb57da3b649c75e$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $fbb57da3b649c75e$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $fbb57da3b649c75e$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$fbb57da3b649c75e$export$737672163db00fe3[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY] = true;
var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $fbb57da3b649c75e$var$Displayable = function(_super) {
    (0, $3VFsf.__extends)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $bahqM.keys)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $fbb57da3b649c75e$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $1E3E8.default)(0, 0, 0, 0));
            if (transform) (0, $1E3E8.default).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $1E3E8.default)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $bahqM.extend)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $aVawM.STYLE_CHANGED_BIT);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $aVawM.STYLE_CHANGED_BIT));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $aVawM.STYLE_CHANGED_BIT);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $bahqM.createObject)($fbb57da3b649c75e$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $bahqM.keys)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $bahqM.keys)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $bahqM.extend)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $fbb57da3b649c75e$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $aVawM.REDRAW_BIT) | (0, $aVawM.STYLE_CHANGED_BIT);
    }();
    return Displayable;
}((0, $7KVc5.default));
var $fbb57da3b649c75e$var$tmpRect = new (0, $1E3E8.default)(0, 0, 0, 0);
var $fbb57da3b649c75e$var$viewRect = new (0, $1E3E8.default)(0, 0, 0, 0);
function $fbb57da3b649c75e$var$isDisplayableCulled(el, width, height) {
    $fbb57da3b649c75e$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $fbb57da3b649c75e$var$tmpRect.applyTransform(el.transform);
    $fbb57da3b649c75e$var$viewRect.width = width;
    $fbb57da3b649c75e$var$viewRect.height = height;
    return !$fbb57da3b649c75e$var$tmpRect.intersect($fbb57da3b649c75e$var$viewRect);
}
var $fbb57da3b649c75e$export$2e2bcd8739ae039 = $fbb57da3b649c75e$var$Displayable;

});
parcelRegister("7KVc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a5931cff6ff005a$export$2e2bcd8739ae039);

var $e6gef = parcelRequire("e6gef");

var $hb2y5 = parcelRequire("hb2y5");

var $1E3E8 = parcelRequire("1E3E8");

var $bRKv5 = parcelRequire("bRKv5");

var $b7ZX8 = parcelRequire("b7ZX8");

var $bahqM = parcelRequire("bahqM");

var $7y1my = parcelRequire("7y1my");

var $d6udH = parcelRequire("d6udH");

var $hZfwb = parcelRequire("hZfwb");

var $aVawM = parcelRequire("aVawM");
var $5a5931cff6ff005a$export$97b5e845c7286801 = '__zr_normal__';
var $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS = [
    'x',
    'y',
    'scaleX',
    'scaleY',
    'originX',
    'originY',
    'rotation',
    'ignore'
];
var $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP = {
    x: true,
    y: true,
    scaleX: true,
    scaleY: true,
    originX: true,
    originY: true,
    rotation: true,
    ignore: false
};
var $5a5931cff6ff005a$var$tmpTextPosCalcRes = {};
var $5a5931cff6ff005a$var$tmpBoundingRect = new (0, $1E3E8.default)(0, 0, 0, 0);
var $5a5931cff6ff005a$var$Element = function() {
    function Element(props) {
        this.id = (0, $bahqM.guid)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = $5a5931cff6ff005a$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
                if (this.calculateTextPosition) this.calculateTextPosition($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $b7ZX8.calculateTextPosition)($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $5a5931cff6ff005a$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $5a5931cff6ff005a$var$tmpTextPosCalcRes.y;
                textAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $b7ZX8.parsePercent)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $b7ZX8.parsePercent)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $aVawM.REDRAW_BIT);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $7y1my.LIGHT_LABEL_COLOR) : (0, $7y1my.DARK_LABEL_COLOR);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $d6udH.parse)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $d6udH.stringify)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $bahqM.extend)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $bahqM.isObject)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $bahqM.keys)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (fromStateTransition && fromStateTransition !== $5a5931cff6ff005a$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveFinalToTarget(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($5a5931cff6ff005a$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $5a5931cff6ff005a$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $bahqM.indexOf)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $bahqM.logError)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $aVawM.REDRAW_BIT);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $aVawM.REDRAW_BIT);
            }
        }
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $bahqM.indexOf)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $bahqM.indexOf)(currentStates, oldState);
        var newStateExists = (0, $bahqM.indexOf)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $bahqM.extend)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $bahqM.extend)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $bahqM.extend)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $bahqM.extend)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) throw new Error('Text element has been added to zrender.');
        if (componentEl === this) throw new Error('Recursive component attachment.');
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        if (textEl.__zr && !textEl.__hostTarget) throw new Error('Text element has been added to zrender.');
        textEl.innerTransformable = new (0, $e6gef.default)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $bahqM.extend)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $aVawM.REDRAW_BIT);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop) {
        var target = key ? this[key] : this;
        if (!target) {
            (0, $bahqM.logError)('Property "' + key + '" is not existed in element ' + this.id);
            return;
        }
        var animator = new (0, $hb2y5.default)(target, loop);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $bahqM.indexOf)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = false;
        elProto.silent = false;
        elProto.isGroup = false;
        elProto.draggable = false;
        elProto.dragging = false;
        elProto.ignoreClip = false;
        elProto.__inHover = false;
        elProto.__dirty = (0, $aVawM.REDRAW_BIT);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    logDeprecatedError(key, xKey, yKey);
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    logDeprecatedError(key, xKey, yKey);
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty && (!(0, $hZfwb.default).browser.ie || (0, $hZfwb.default).browser.version > 8)) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $bahqM.mixin)($5a5931cff6ff005a$var$Element, (0, $bRKv5.default));
(0, $bahqM.mixin)($5a5931cff6ff005a$var$Element, (0, $e6gef.default));
function $5a5931cff6ff005a$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $5a5931cff6ff005a$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        animator.start(cfg.easing, cfg.force);
    }
    return animators;
}
function $5a5931cff6ff005a$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $5a5931cff6ff005a$var$is2DArray(value) {
    return (0, $bahqM.isArrayLike)(value[0]);
}
function $5a5931cff6ff005a$var$copyValue(target, source, key) {
    if ((0, $bahqM.isArrayLike)(source[key])) {
        if (!(0, $bahqM.isArrayLike)(target[key])) target[key] = [];
        if ((0, $bahqM.isTypedArray)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $5a5931cff6ff005a$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($5a5931cff6ff005a$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $5a5931cff6ff005a$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $5a5931cff6ff005a$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $5a5931cff6ff005a$var$animateToShallow(animatable, topKey, source, target, cfg, animationProps, animators, reverse) {
    var animatableKeys = [];
    var changedKeys = [];
    var targetKeys = (0, $bahqM.keys)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $bahqM.isObject)(animationProps);
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        if (source[innerKey] != null && target[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $bahqM.isObject)(target[innerKey]) && !(0, $bahqM.isArrayLike)(target[innerKey])) {
                if (topKey) {
                    if (!reverse) {
                        source[innerKey] = target[innerKey];
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $5a5931cff6ff005a$var$animateToShallow(animatable, innerKey, source[innerKey], target[innerKey], cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else {
                animatableKeys.push(innerKey);
                changedKeys.push(innerKey);
            }
        } else if (!reverse) {
            source[innerKey] = target[innerKey];
            animatable.updateDuringAnimation(topKey);
            changedKeys.push(innerKey);
        }
    }
    var keyLen = animatableKeys.length;
    if (keyLen > 0 || cfg.force && !animators.length) {
        var existsAnimators = animatable.animators;
        var existsAnimatorsOnSameTarget = [];
        for(var i = 0; i < existsAnimators.length; i++)if (existsAnimators[i].targetName === topKey) existsAnimatorsOnSameTarget.push(existsAnimators[i]);
        if (!additive && existsAnimatorsOnSameTarget.length) for(var i = 0; i < existsAnimatorsOnSameTarget.length; i++){
            var allAborted = existsAnimatorsOnSameTarget[i].stopTracks(changedKeys);
            if (allAborted) {
                var idx = (0, $bahqM.indexOf)(existsAnimators, existsAnimatorsOnSameTarget[i]);
                existsAnimators.splice(idx, 1);
            }
        }
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animatableKeys[i];
                reversedTarget[innerKey] = source[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else source[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animatableKeys[i];
                sourceClone[innerKey] = (0, $hb2y5.cloneValue)(source[innerKey]);
                $5a5931cff6ff005a$var$copyValue(source, target, innerKey);
            }
        }
        var animator = new (0, $hb2y5.default)(source, false, additive ? existsAnimatorsOnSameTarget : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animatableKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animatableKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animatableKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $5a5931cff6ff005a$export$2e2bcd8739ae039 = $5a5931cff6ff005a$var$Element;

});
parcelRegister("e6gef", function(module, exports) {

$parcel$export(module.exports, "default", () => $a43e36ee3f294c25$export$2e2bcd8739ae039);

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");
var $a43e36ee3f294c25$var$mIdentity = $izqgC.identity;
var $a43e36ee3f294c25$var$EPSILON = 5e-5;
function $a43e36ee3f294c25$var$isNotAroundZero(val) {
    return val > $a43e36ee3f294c25$var$EPSILON || val < -$a43e36ee3f294c25$var$EPSILON;
}
var $a43e36ee3f294c25$var$scaleTmp = [];
var $a43e36ee3f294c25$var$tmpTransform = [];
var $a43e36ee3f294c25$var$originTransform = $izqgC.create();
var $a43e36ee3f294c25$var$abs = Math.abs;
var $a43e36ee3f294c25$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $a43e36ee3f294c25$var$isNotAroundZero(this.rotation) || $a43e36ee3f294c25$var$isNotAroundZero(this.x) || $a43e36ee3f294c25$var$isNotAroundZero(this.y) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleX - 1) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleY - 1);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            m && $a43e36ee3f294c25$var$mIdentity(m);
            return;
        }
        m = m || $izqgC.create();
        if (needLocalTransform) this.getLocalTransform(m);
        else $a43e36ee3f294c25$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $izqgC.mul(m, parentTransform, m);
            else $izqgC.copy(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($a43e36ee3f294c25$var$scaleTmp);
            var relX = $a43e36ee3f294c25$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $a43e36ee3f294c25$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($a43e36ee3f294c25$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $a43e36ee3f294c25$var$scaleTmp[0] || 0;
            var sy = (($a43e36ee3f294c25$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $a43e36ee3f294c25$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $izqgC.create();
        $izqgC.invert(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            $izqgC.mul($a43e36ee3f294c25$var$tmpTransform, parent.invTransform, m);
            m = $a43e36ee3f294c25$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $a43e36ee3f294c25$var$originTransform[4] = ox;
            $a43e36ee3f294c25$var$originTransform[5] = oy;
            $izqgC.mul($a43e36ee3f294c25$var$tmpTransform, m, $a43e36ee3f294c25$var$originTransform);
            $a43e36ee3f294c25$var$tmpTransform[4] -= ox;
            $a43e36ee3f294c25$var$tmpTransform[5] -= oy;
            m = $a43e36ee3f294c25$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $eLEew.applyTransform(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $eLEew.applyTransform(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $a43e36ee3f294c25$var$abs(m[0] - 1) > 1e-10 && $a43e36ee3f294c25$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($a43e36ee3f294c25$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        var target = this;
        for(var i = 0; i < $a43e36ee3f294c25$export$98ab6203ec3396e2.length; i++){
            var propName = $a43e36ee3f294c25$export$98ab6203ec3396e2[i];
            target[propName] = source[propName];
        }
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy) {
            m[4] = -ox * sx - skewX * oy * sy;
            m[5] = -oy * sy - skewY * ox * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $izqgC.rotate(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.x = 0;
        proto.y = 0;
        proto.scaleX = 1;
        proto.scaleY = 1;
        proto.originX = 0;
        proto.originY = 0;
        proto.skewX = 0;
        proto.skewY = 0;
        proto.rotation = 0;
        proto.globalScaleRatio = 1;
    }();
    return Transformable;
}();
var $a43e36ee3f294c25$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
var $a43e36ee3f294c25$export$2e2bcd8739ae039 = $a43e36ee3f294c25$var$Transformable;

});
parcelRegister("eLEew", function(module, exports) {

$parcel$export(module.exports, "create", () => $ac04a9f644701697$export$185802fd694ee1f5);
$parcel$export(module.exports, "copy", () => $ac04a9f644701697$export$784d13d8ee351f07);
$parcel$export(module.exports, "clone", () => $ac04a9f644701697$export$9cd59f9826255e47);
$parcel$export(module.exports, "set", () => $ac04a9f644701697$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $ac04a9f644701697$export$e16d8520af44a096);
$parcel$export(module.exports, "scaleAndAdd", () => $ac04a9f644701697$export$19cedf1da84ba854);
$parcel$export(module.exports, "sub", () => $ac04a9f644701697$export$f93b5905241a7cca);
$parcel$export(module.exports, "len", () => $ac04a9f644701697$export$fc1400facf92c78);
$parcel$export(module.exports, "lenSquare", () => $ac04a9f644701697$export$48e33bc611e4c25a);
$parcel$export(module.exports, "length", () => $ac04a9f644701697$export$f24224f1c91d8156);
$parcel$export(module.exports, "lengthSquare", () => $ac04a9f644701697$export$2f106540dd9a5136);
$parcel$export(module.exports, "mul", () => $ac04a9f644701697$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $ac04a9f644701697$export$159d9494db57879b);
$parcel$export(module.exports, "dot", () => $ac04a9f644701697$export$94132a0e348806d4);
$parcel$export(module.exports, "scale", () => $ac04a9f644701697$export$dcdf75081b88279d);
$parcel$export(module.exports, "normalize", () => $ac04a9f644701697$export$a3295358bff77e);
$parcel$export(module.exports, "distance", () => $ac04a9f644701697$export$9f17032d917177de);
$parcel$export(module.exports, "dist", () => $ac04a9f644701697$export$6c4a311cc157c764);
$parcel$export(module.exports, "distanceSquare", () => $ac04a9f644701697$export$137c0a69d1ff4a79);
$parcel$export(module.exports, "distSquare", () => $ac04a9f644701697$export$c68db45a034c13b0);
$parcel$export(module.exports, "negate", () => $ac04a9f644701697$export$aef51622e549b8b0);
$parcel$export(module.exports, "lerp", () => $ac04a9f644701697$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "applyTransform", () => $ac04a9f644701697$export$9f9dcb98c894b623);
$parcel$export(module.exports, "min", () => $ac04a9f644701697$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $ac04a9f644701697$export$8960430cfd85939f);
function $ac04a9f644701697$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $ac04a9f644701697$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $ac04a9f644701697$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $ac04a9f644701697$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $ac04a9f644701697$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $ac04a9f644701697$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $ac04a9f644701697$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $ac04a9f644701697$export$fc1400facf92c78(v) {
    return Math.sqrt($ac04a9f644701697$export$48e33bc611e4c25a(v));
}
var $ac04a9f644701697$export$f24224f1c91d8156 = $ac04a9f644701697$export$fc1400facf92c78;
function $ac04a9f644701697$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $ac04a9f644701697$export$2f106540dd9a5136 = $ac04a9f644701697$export$48e33bc611e4c25a;
function $ac04a9f644701697$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $ac04a9f644701697$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $ac04a9f644701697$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $ac04a9f644701697$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $ac04a9f644701697$export$a3295358bff77e(out, v) {
    var d = $ac04a9f644701697$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $ac04a9f644701697$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $ac04a9f644701697$export$6c4a311cc157c764 = $ac04a9f644701697$export$9f17032d917177de;
function $ac04a9f644701697$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $ac04a9f644701697$export$c68db45a034c13b0 = $ac04a9f644701697$export$137c0a69d1ff4a79;
function $ac04a9f644701697$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $ac04a9f644701697$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $ac04a9f644701697$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $ac04a9f644701697$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $ac04a9f644701697$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}

});


parcelRegister("hb2y5", function(module, exports) {

$parcel$export(module.exports, "interpolateNumber", () => $c81570e1f313cc39$export$d871d53bd7eeb390);
$parcel$export(module.exports, "cloneValue", () => $c81570e1f313cc39$export$c5e92b7f105af84e);
$parcel$export(module.exports, "default", () => $c81570e1f313cc39$export$2e2bcd8739ae039);

var $kj9w6 = parcelRequire("kj9w6");

var $d6udH = parcelRequire("d6udH");

var $bahqM = parcelRequire("bahqM");
var $c81570e1f313cc39$var$arraySlice = Array.prototype.slice;
function $c81570e1f313cc39$export$d871d53bd7eeb390(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $c81570e1f313cc39$export$35d34bc0ed591a92(p0, p1, percent) {
    return percent > 0.5 ? p1 : p0;
}
function $c81570e1f313cc39$export$f8938d924b05a6eb(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i], p1[i], percent);
}
function $c81570e1f313cc39$export$3297a85eaaa37024(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i][j], p1[i][j], percent);
    }
}
function $c81570e1f313cc39$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $c81570e1f313cc39$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $c81570e1f313cc39$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $c81570e1f313cc39$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $c81570e1f313cc39$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $c81570e1f313cc39$var$catmullRomInterpolate1DArray(out, p0, p1, p2, p3, t, t2, t3) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
}
function $c81570e1f313cc39$var$catmullRomInterpolate2DArray(out, p0, p1, p2, p3, t, t2, t3) {
    var len = p0.length;
    var len2 = p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[1] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
    }
}
function $c81570e1f313cc39$export$c5e92b7f105af84e(value) {
    if ((0, $bahqM.isArrayLike)(value)) {
        var len = value.length;
        if ((0, $bahqM.isArrayLike)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($c81570e1f313cc39$var$arraySlice.call(value[i]));
            return ret;
        }
        return $c81570e1f313cc39$var$arraySlice.call(value);
    }
    return value;
}
function $c81570e1f313cc39$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]);
    rgba[1] = Math.floor(rgba[1]);
    rgba[2] = Math.floor(rgba[2]);
    return 'rgba(' + rgba.join(',') + ')';
}
function $c81570e1f313cc39$var$guessArrayDim(value) {
    return (0, $bahqM.isArrayLike)(value && value[0]) ? 2 : 1;
}
var $c81570e1f313cc39$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $c81570e1f313cc39$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.maxTime = 0;
        this.arrDim = 0;
        this.interpolable = true;
        this._needsSort = false;
        this._isAllValueEqual = true;
        this._lastFrame = 0;
        this._lastFramePercent = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return !this._isAllValueEqual && this.keyframes.length >= 2 && this.interpolable && this.maxTime > 0;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, value) {
        if (time >= this.maxTime) this.maxTime = time;
        else this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        if (this.interpolable) {
            if ((0, $bahqM.isArrayLike)(value)) {
                var arrayDim = $c81570e1f313cc39$var$guessArrayDim(value);
                if (len > 0 && this.arrDim !== arrayDim) {
                    this.interpolable = false;
                    return;
                }
                if (arrayDim === 1 && typeof value[0] !== 'number' || arrayDim === 2 && typeof value[0][0] !== 'number') {
                    this.interpolable = false;
                    return;
                }
                if (len > 0) {
                    var lastFrame = keyframes[len - 1];
                    if (this._isAllValueEqual) {
                        if (arrayDim === 1) {
                            if (!$c81570e1f313cc39$var$is1DArraySame(value, lastFrame.value)) this._isAllValueEqual = false;
                        } else this._isAllValueEqual = false;
                    }
                }
                this.arrDim = arrayDim;
            } else {
                if (this.arrDim > 0) {
                    this.interpolable = false;
                    return;
                }
                if (typeof value === 'string') {
                    var colorArray = $d6udH.parse(value);
                    if (colorArray) {
                        value = colorArray;
                        this.isValueColor = true;
                    } else this.interpolable = false;
                } else if (typeof value !== 'number' || isNaN(value)) {
                    this.interpolable = false;
                    return;
                }
                if (this._isAllValueEqual && len > 0) {
                    var lastFrame = keyframes[len - 1];
                    if (this.isValueColor && !$c81570e1f313cc39$var$is1DArraySame(lastFrame.value, value)) this._isAllValueEqual = false;
                    else if (lastFrame.value !== value) this._isAllValueEqual = false;
                }
            }
        }
        var kf = {
            time: time,
            value: value,
            percent: 0
        };
        this.keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var arrDim = this.arrDim;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        for(var i = 0; i < kfsLen; i++){
            kfs[i].percent = kfs[i].time / this.maxTime;
            if (arrDim > 0 && i !== kfsLen - 1) $c81570e1f313cc39$var$fillArray(kfs[i].value, lastKf.value, arrDim);
        }
        if (additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && arrDim === additiveTrack.arrDim && this.isValueColor === additiveTrack.isValueColor && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (arrDim === 0) {
                    if (this.isValueColor) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                    else kfs[i].additiveValue = kfs[i].value - startValue;
                } else if (arrDim === 1) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                else if (arrDim === 2) kfs[i].additiveValue = $c81570e1f313cc39$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var keyframes = this.keyframes;
        var kfsNum = this.keyframes.length;
        var propName = this.propName;
        var arrDim = this.arrDim;
        var isValueColor = this.isValueColor;
        var frameIdx;
        if (percent < 0) frameIdx = 0;
        else if (percent < this._lastFramePercent) {
            var start = Math.min(this._lastFrame + 1, kfsNum - 1);
            for(frameIdx = start; frameIdx >= 0; frameIdx--){
                if (keyframes[frameIdx].percent <= percent) break;
            }
            frameIdx = Math.min(frameIdx, kfsNum - 2);
        } else {
            for(frameIdx = this._lastFrame; frameIdx < kfsNum; frameIdx++){
                if (keyframes[frameIdx].percent > percent) break;
            }
            frameIdx = Math.min(frameIdx - 1, kfsNum - 2);
        }
        var nextFrame = keyframes[frameIdx + 1];
        var frame = keyframes[frameIdx];
        if (!(frame && nextFrame)) return;
        this._lastFrame = frameIdx;
        this._lastFramePercent = percent;
        var range = nextFrame.percent - frame.percent;
        if (range === 0) return;
        var w = (percent - frame.percent) / range;
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $c81570e1f313cc39$var$tmpRgba : target[propName];
        if ((arrDim > 0 || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.useSpline) {
            var p1 = keyframes[frameIdx][valueKey];
            var p0 = keyframes[frameIdx === 0 ? frameIdx : frameIdx - 1][valueKey];
            var p2 = keyframes[frameIdx > kfsNum - 2 ? kfsNum - 1 : frameIdx + 1][valueKey];
            var p3 = keyframes[frameIdx > kfsNum - 3 ? kfsNum - 1 : frameIdx + 2][valueKey];
            if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w) : $c81570e1f313cc39$var$catmullRomInterpolate2DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
            else if (isValueColor) {
                $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
            } else {
                var value = void 0;
                if (!this.interpolable) value = p2;
                else value = $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
                if (isAdditive) this._additiveValue = value;
                else target[propName] = value;
            }
        } else {
            if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w) : $c81570e1f313cc39$export$3297a85eaaa37024(targetArr, frame[valueKey], nextFrame[valueKey], w);
            else if (isValueColor) {
                $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w);
                if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
            } else {
                var value = void 0;
                if (!this.interpolable) value = $c81570e1f313cc39$export$35d34bc0ed591a92(frame[valueKey], nextFrame[valueKey], w);
                else value = $c81570e1f313cc39$export$d871d53bd7eeb390(frame[valueKey], nextFrame[valueKey], w);
                if (isAdditive) this._additiveValue = value;
                else target[propName] = value;
            }
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var arrDim = this.arrDim;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (arrDim === 0) {
            if (this.isValueColor) {
                $d6udH.parse(target[propName], $c81570e1f313cc39$var$tmpRgba);
                $c81570e1f313cc39$var$add1DArray($c81570e1f313cc39$var$tmpRgba, $c81570e1f313cc39$var$tmpRgba, additiveValue, 1);
                target[propName] = $c81570e1f313cc39$var$rgba2String($c81570e1f313cc39$var$tmpRgba);
            } else target[propName] = target[propName] + additiveValue;
        } else if (arrDim === 1) $c81570e1f313cc39$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (arrDim === 2) $c81570e1f313cc39$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $c81570e1f313cc39$var$Animator = function() {
    function Animator(target, loop, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._delay = 0;
        this._maxTime = 0;
        this._paused = false;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $bahqM.logError)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
    }
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props) {
        return this.whenWithKeys(time, props, (0, $bahqM.keys)(props));
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $c81570e1f313cc39$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var lastFinalKf = additiveTrack.keyframes[additiveTrack.keyframes.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.isValueColor && initialValue) initialValue = $c81570e1f313cc39$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time !== 0) track.addKeyframe(0, $c81570e1f313cc39$export$c5e92b7f105af84e(initialValue));
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $c81570e1f313cc39$export$c5e92b7f105af84e(props[propName]));
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing, forceAnimate) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            track.prepare(additiveTrack);
            if (track.needsAnimate()) tracks.push(track);
            else if (!track.interpolable) {
                var lastKf = kfs[kfs.length - 1];
                if (lastKf) self._target[track.propName] = lastKf.value;
            }
        }
        if (tracks.length || forceAnimate) {
            var clip = new (0, $kj9w6.default)({
                life: this._maxTime,
                loop: this._loop,
                delay: this._delay,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing && easing !== 'spline') clip.easing = easing;
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveFinalToTarget = function(target, trackKeys) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var lastKf = kfs[kfs.length - 1];
            if (lastKf) {
                var val = $c81570e1f313cc39$export$c5e92b7f105af84e(lastKf.value);
                if (track.isValueColor) val = $c81570e1f313cc39$var$rgba2String(val);
                target[propName] = val;
            }
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $bahqM.keys)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $c81570e1f313cc39$export$2e2bcd8739ae039 = $c81570e1f313cc39$var$Animator;

});
parcelRegister("kj9w6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec8cf6d19967f888$export$2e2bcd8739ae039);

var $2yJbE = parcelRequire("2yJbE");
var $ec8cf6d19967f888$var$Clip = function() {
    function Clip(opts) {
        this._initialized = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop == null ? false : opts.loop;
        this.gap = opts.gap || 0;
        this.easing = opts.easing || 'linear';
        this.onframe = opts.onframe;
        this.ondestroy = opts.ondestroy;
        this.onrestart = opts.onrestart;
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._initialized) {
            this._startTime = globalTime + this._delay;
            this._initialized = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var percent = (globalTime - this._startTime - this._pausedTime) / this._life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easing = this.easing;
        var easingFunc = typeof easing === 'string' ? (0, $2yJbE.default)[easing] : easing;
        var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
        this.onframe && this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                this._restart(globalTime);
                this.onrestart && this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype._restart = function(globalTime) {
        var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
        this._startTime = globalTime - remainder + this.gap;
        this._pausedTime = 0;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    return Clip;
}();
var $ec8cf6d19967f888$export$2e2bcd8739ae039 = $ec8cf6d19967f888$var$Clip;

});
parcelRegister("2yJbE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd1cef375de2720$export$2e2bcd8739ae039);
var $1dd1cef375de2720$var$easing = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $1dd1cef375de2720$var$easing.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $1dd1cef375de2720$var$easing.bounceIn(k * 2) * 0.5;
        return $1dd1cef375de2720$var$easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $1dd1cef375de2720$export$2e2bcd8739ae039 = $1dd1cef375de2720$var$easing;

});


parcelRegister("d6udH", function(module, exports) {

$parcel$export(module.exports, "parse", () => $98a346fa71cc3009$export$98e6a39c04603d36);
$parcel$export(module.exports, "lift", () => $98a346fa71cc3009$export$590e8b2c435046d9);
$parcel$export(module.exports, "stringify", () => $98a346fa71cc3009$export$fac44ee5b035f737);
$parcel$export(module.exports, "toHex", () => $98a346fa71cc3009$export$7ea66e3774a60b67);
$parcel$export(module.exports, "fastLerp", () => $98a346fa71cc3009$export$66cb3c0e9efc61c8);
$parcel$export(module.exports, "fastMapToColor", () => $98a346fa71cc3009$export$daa5a65daad5df58);
$parcel$export(module.exports, "lerp", () => $98a346fa71cc3009$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "mapToColor", () => $98a346fa71cc3009$export$296e08242b78a3ec);
$parcel$export(module.exports, "modifyHSL", () => $98a346fa71cc3009$export$d898ae866e27bf18);
$parcel$export(module.exports, "modifyAlpha", () => $98a346fa71cc3009$export$ab4754bf42583a26);
$parcel$export(module.exports, "lum", () => $98a346fa71cc3009$export$16c0ec21a6f9ef95);
$parcel$export(module.exports, "random", () => $98a346fa71cc3009$export$4385e60b38654f68);

var $h4RuA = parcelRequire("h4RuA");
var $98a346fa71cc3009$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $98a346fa71cc3009$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $98a346fa71cc3009$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $98a346fa71cc3009$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $98a346fa71cc3009$var$parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $98a346fa71cc3009$var$clampCssByte(parseInt(str, 10));
}
function $98a346fa71cc3009$var$parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str) / 100);
    return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str));
}
function $98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $98a346fa71cc3009$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $98a346fa71cc3009$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $98a346fa71cc3009$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $98a346fa71cc3009$var$colorCache = new (0, $h4RuA.default)(20);
var $98a346fa71cc3009$var$lastRemovedArr = null;
function $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr) {
    if ($98a346fa71cc3009$var$lastRemovedArr) $98a346fa71cc3009$var$copyRgba($98a346fa71cc3009$var$lastRemovedArr, rgbaArr);
    $98a346fa71cc3009$var$lastRemovedArr = $98a346fa71cc3009$var$colorCache.put(colorStr, $98a346fa71cc3009$var$lastRemovedArr || rgbaArr.slice());
}
function $98a346fa71cc3009$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $98a346fa71cc3009$var$colorCache.get(colorStr);
    if (cached) return $98a346fa71cc3009$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $98a346fa71cc3009$var$kCSSColorTable) {
        $98a346fa71cc3009$var$copyRgba(rgbaArr, $98a346fa71cc3009$var$kCSSColorTable[str]);
        $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $98a346fa71cc3009$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $98a346fa71cc3009$var$parseCssFloat(params.pop());
            case 'rgb':
                if (params.length !== 3) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$setRgba(rgbaArr, $98a346fa71cc3009$var$parseCssInt(params[0]), $98a346fa71cc3009$var$parseCssInt(params[1]), $98a346fa71cc3009$var$parseCssInt(params[2]), alpha);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsla':
                if (params.length !== 4) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $98a346fa71cc3009$var$parseCssFloat(params[3]);
                $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $98a346fa71cc3009$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $98a346fa71cc3009$var$parseCssFloat(hsla[1]);
    var l = $98a346fa71cc3009$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $98a346fa71cc3009$var$setRgba(rgba, $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $98a346fa71cc3009$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $98a346fa71cc3009$export$590e8b2c435046d9(color, level) {
    var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $98a346fa71cc3009$export$7ea66e3774a60b67(color) {
    var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $98a346fa71cc3009$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $98a346fa71cc3009$export$daa5a65daad5df58 = $98a346fa71cc3009$export$66cb3c0e9efc61c8;
function $98a346fa71cc3009$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $98a346fa71cc3009$export$fac44ee5b035f737([
        $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $98a346fa71cc3009$export$296e08242b78a3ec = $98a346fa71cc3009$export$3a89f8d6f6bf6c9f;
function $98a346fa71cc3009$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $98a346fa71cc3009$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $98a346fa71cc3009$var$clampCssAngle(h));
        s != null && (colorArr[1] = $98a346fa71cc3009$var$parseCssFloat(s));
        l != null && (colorArr[2] = $98a346fa71cc3009$var$parseCssFloat(l));
        return $98a346fa71cc3009$export$fac44ee5b035f737($98a346fa71cc3009$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $98a346fa71cc3009$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $98a346fa71cc3009$var$clampCssFloat(alpha);
        return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $98a346fa71cc3009$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $98a346fa71cc3009$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $98a346fa71cc3009$export$4385e60b38654f68() {
    var r = Math.round(Math.random() * 255);
    var g = Math.round(Math.random() * 255);
    var b = Math.round(Math.random() * 255);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
}

});


parcelRegister("bRKv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a38b6f95cbd6cc6$export$2e2bcd8739ae039);
var $8a38b6f95cbd6cc6$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $8a38b6f95cbd6cc6$export$2e2bcd8739ae039 = $8a38b6f95cbd6cc6$var$Eventful;

});

parcelRegister("7y1my", function(module, exports) {

$parcel$export(module.exports, "devicePixelRatio", () => $57ecc3ffeb61d50b$export$508f096bfcdaac40);
$parcel$export(module.exports, "DARK_MODE_THRESHOLD", () => $57ecc3ffeb61d50b$export$fd81e7ebc7dae256);
$parcel$export(module.exports, "DARK_LABEL_COLOR", () => $57ecc3ffeb61d50b$export$f8ce94761f39398d);
$parcel$export(module.exports, "LIGHT_LABEL_COLOR", () => $57ecc3ffeb61d50b$export$3c6e95f318c8369b);
$parcel$export(module.exports, "LIGHTER_LABEL_COLOR", () => $57ecc3ffeb61d50b$export$27682248795c3c6b);
var $57ecc3ffeb61d50b$var$dpr = 1;
if (typeof window !== 'undefined') $57ecc3ffeb61d50b$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $57ecc3ffeb61d50b$export$7cdcde344c85339c = 0;
var $57ecc3ffeb61d50b$export$508f096bfcdaac40 = $57ecc3ffeb61d50b$var$dpr;
var $57ecc3ffeb61d50b$export$fd81e7ebc7dae256 = 0.4;
var $57ecc3ffeb61d50b$export$f8ce94761f39398d = '#333';
var $57ecc3ffeb61d50b$export$3c6e95f318c8369b = '#ccc';
var $57ecc3ffeb61d50b$export$27682248795c3c6b = '#eee';

});

parcelRegister("aVawM", function(module, exports) {

$parcel$export(module.exports, "REDRAW_BIT", () => $7f3764d4456adf3b$export$a7b6db622c6c7dbd);
$parcel$export(module.exports, "STYLE_CHANGED_BIT", () => $7f3764d4456adf3b$export$ada8b2beb3d76671);
$parcel$export(module.exports, "SHAPE_CHANGED_BIT", () => $7f3764d4456adf3b$export$f75fe89a33ebe115);
var $7f3764d4456adf3b$export$a7b6db622c6c7dbd = 1;
var $7f3764d4456adf3b$export$ada8b2beb3d76671 = 2;
var $7f3764d4456adf3b$export$f75fe89a33ebe115 = 4;

});



parcelRegister("ghQ8v", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PATH_STYLE", () => $bdb6ad049d5f8c6b$export$deade517576e293a);
$parcel$export(module.exports, "default", () => $bdb6ad049d5f8c6b$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $lBQ88 = parcelRequire("lBQ88");

var $aA4Ws = parcelRequire("aA4Ws");

var $k3yEY = parcelRequire("k3yEY");

var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");

var $7y1my = parcelRequire("7y1my");

var $aVawM = parcelRequire("aVawM");
var $bdb6ad049d5f8c6b$export$deade517576e293a = (0, $bahqM.defaults)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $lBQ88.DEFAULT_COMMON_STYLE));
var $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5 = {
    style: (0, $bahqM.defaults)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $lBQ88.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $bdb6ad049d5f8c6b$var$pathCopyParams = [
    'x',
    'y',
    'rotation',
    'scaleX',
    'scaleY',
    'originX',
    'originY',
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
];
var $bdb6ad049d5f8c6b$var$Path = function(_super) {
    (0, $3VFsf.__extends)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $bdb6ad049d5f8c6b$var$pathCopyParams.length; ++i)decalEl[$bdb6ad049d5f8c6b$var$pathCopyParams[i]] = this[$bdb6ad049d5f8c6b$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $aVawM.REDRAW_BIT);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $bahqM.keys)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $bahqM.extend)(this.style, value);
            } else if (key === 'shape') (0, $bahqM.extend)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $bahqM.isString)(pathFill)) {
                var fillLum = (0, $d6udH.lum)(pathFill, 0);
                if (fillLum > 0.5) return 0, $7y1my.DARK_LABEL_COLOR;
                else if (fillLum > 0.2) return 0, $7y1my.LIGHTER_LABEL_COLOR;
                return 0, $7y1my.LIGHT_LABEL_COLOR;
            } else if (pathFill) return 0, $7y1my.LIGHT_LABEL_COLOR;
        }
        return 0, $7y1my.DARK_LABEL_COLOR;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $bahqM.isString)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $d6udH.lum)(textFill, 0) < (0, $7y1my.DARK_MODE_THRESHOLD);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $aVawM.SHAPE_CHANGED_BIT);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $aA4Ws.default)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $aVawM.SHAPE_CHANGED_BIT)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectWithStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectWithStroke.width += w / lineScale;
                    rectWithStroke.height += w / lineScale;
                    rectWithStroke.x -= w / lineScale / 2;
                    rectWithStroke.y -= w / lineScale / 2;
                }
            }
            return rectWithStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($k3yEY.containStroke(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $k3yEY.contain(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $aVawM.SHAPE_CHANGED_BIT);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $bahqM.extend)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $aVawM.SHAPE_CHANGED_BIT));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $bahqM.createObject)($bdb6ad049d5f8c6b$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $bahqM.extend)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $bahqM.extend)({}, normalState.shape);
                    (0, $bahqM.extend)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $bahqM.extend)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $bahqM.extend)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $bahqM.extend)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $bahqM.keys)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $3VFsf.__extends)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $bahqM.clone)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $bahqM.clone)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $aVawM.REDRAW_BIT) | (0, $aVawM.STYLE_CHANGED_BIT) | (0, $aVawM.SHAPE_CHANGED_BIT);
    }();
    return Path;
}((0, $lBQ88.default));
var $bdb6ad049d5f8c6b$export$2e2bcd8739ae039 = $bdb6ad049d5f8c6b$var$Path;

});
parcelRegister("aA4Ws", function(module, exports) {

$parcel$export(module.exports, "normalizeArcAngles", () => $7b4119855d2b5b91$export$bc668021e937022a);
$parcel$export(module.exports, "default", () => $7b4119855d2b5b91$export$2e2bcd8739ae039);

var $eLEew = parcelRequire("eLEew");

var $1E3E8 = parcelRequire("1E3E8");

var $7y1my = parcelRequire("7y1my");

var $13I82 = parcelRequire("13I82");

var $dr1jo = parcelRequire("dr1jo");
var $7b4119855d2b5b91$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $7b4119855d2b5b91$var$tmpOutX = [];
var $7b4119855d2b5b91$var$tmpOutY = [];
var $7b4119855d2b5b91$var$min = [];
var $7b4119855d2b5b91$var$max = [];
var $7b4119855d2b5b91$var$min2 = [];
var $7b4119855d2b5b91$var$max2 = [];
var $7b4119855d2b5b91$var$mathMin = Math.min;
var $7b4119855d2b5b91$var$mathMax = Math.max;
var $7b4119855d2b5b91$var$mathCos = Math.cos;
var $7b4119855d2b5b91$var$mathSin = Math.sin;
var $7b4119855d2b5b91$var$mathSqrt = Math.sqrt;
var $7b4119855d2b5b91$var$mathAbs = Math.abs;
var $7b4119855d2b5b91$var$PI = Math.PI;
var $7b4119855d2b5b91$var$PI2 = $7b4119855d2b5b91$var$PI * 2;
var $7b4119855d2b5b91$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $7b4119855d2b5b91$var$tmpAngles = [];
function $7b4119855d2b5b91$var$modPI2(radian) {
    var n = Math.round(radian / $7b4119855d2b5b91$var$PI * 1e8) / 1e8;
    return n % 2 * $7b4119855d2b5b91$var$PI;
}
function $7b4119855d2b5b91$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $7b4119855d2b5b91$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $7b4119855d2b5b91$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle + $7b4119855d2b5b91$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle - $7b4119855d2b5b91$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $7b4119855d2b5b91$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, $7y1my.devicePixelRatio) / sx) || 0;
            this._uy = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, $7y1my.devicePixelRatio) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._lineDash) {
            this._lineDash = null;
            this._dashOffset = 0;
        }
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($7b4119855d2b5b91$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $7b4119855d2b5b91$var$mathAbs(x - this._xi);
        var dy = $7b4119855d2b5b91$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($7b4119855d2b5b91$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._needsDash ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($7b4119855d2b5b91$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._needsDash ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($7b4119855d2b5b91$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._needsDash ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $7b4119855d2b5b91$var$tmpAngles[0] = startAngle;
        $7b4119855d2b5b91$var$tmpAngles[1] = endAngle;
        $7b4119855d2b5b91$export$bc668021e937022a($7b4119855d2b5b91$var$tmpAngles, anticlockwise);
        startAngle = $7b4119855d2b5b91$var$tmpAngles[0];
        endAngle = $7b4119855d2b5b91$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($7b4119855d2b5b91$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $7b4119855d2b5b91$var$mathCos(endAngle) * r + cx;
        this._yi = $7b4119855d2b5b91$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($7b4119855d2b5b91$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($7b4119855d2b5b91$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) {
            this._needsDash && this._dashedLineTo(x0, y0);
            ctx.closePath();
        }
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.setLineDash = function(lineDash) {
        if (lineDash instanceof Array) {
            this._lineDash = lineDash;
            this._dashIdx = 0;
            var lineDashSum = 0;
            for(var i = 0; i < lineDash.length; i++)lineDashSum += lineDash[i];
            this._dashSum = lineDashSum;
            this._needsDash = true;
        } else {
            this._lineDash = null;
            this._needsDash = false;
        }
        return this;
    };
    PathProxy.prototype.setLineDashOffset = function(offset) {
        this._dashOffset = offset;
        return this;
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $7b4119855d2b5b91$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($7b4119855d2b5b91$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype._dashedLineTo = function(x1, y1) {
        var dashSum = this._dashSum;
        var lineDash = this._lineDash;
        var ctx = this._ctx;
        var offset = this._dashOffset;
        var x0 = this._xi;
        var y0 = this._yi;
        var dx = x1 - x0;
        var dy = y1 - y0;
        var dist = $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        var x = x0;
        var y = y0;
        var nDash = lineDash.length;
        var dash;
        var idx;
        dx /= dist;
        dy /= dist;
        if (offset < 0) offset = dashSum + offset;
        offset %= dashSum;
        x -= offset * dx;
        y -= offset * dy;
        while(dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)){
            idx = this._dashIdx;
            dash = lineDash[idx];
            x += dx * dash;
            y += dy * dash;
            this._dashIdx = (idx + 1) % nDash;
            if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) continue;
            ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? $7b4119855d2b5b91$var$mathMin(x, x1) : $7b4119855d2b5b91$var$mathMax(x, x1), dy >= 0 ? $7b4119855d2b5b91$var$mathMin(y, y1) : $7b4119855d2b5b91$var$mathMax(y, y1));
        }
        dx = x - x1;
        dy = y - y1;
        this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
    };
    PathProxy.prototype._dashedBezierTo = function(x1, y1, x2, y2, x3, y3) {
        var ctx = this._ctx;
        var dashSum = this._dashSum;
        var offset = this._dashOffset;
        var lineDash = this._lineDash;
        var x0 = this._xi;
        var y0 = this._yi;
        var bezierLen = 0;
        var idx = this._dashIdx;
        var nDash = lineDash.length;
        var t;
        var dx;
        var dy;
        var x;
        var y;
        var tmpLen = 0;
        if (offset < 0) offset = dashSum + offset;
        offset %= dashSum;
        for(t = 0; t < 1; t += 0.1){
            dx = (0, $dr1jo.cubicAt)(x0, x1, x2, x3, t + 0.1) - (0, $dr1jo.cubicAt)(x0, x1, x2, x3, t);
            dy = (0, $dr1jo.cubicAt)(y0, y1, y2, y3, t + 0.1) - (0, $dr1jo.cubicAt)(y0, y1, y2, y3, t);
            bezierLen += $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        }
        for(; idx < nDash; idx++){
            tmpLen += lineDash[idx];
            if (tmpLen > offset) break;
        }
        t = (tmpLen - offset) / bezierLen;
        while(t <= 1){
            x = (0, $dr1jo.cubicAt)(x0, x1, x2, x3, t);
            y = (0, $dr1jo.cubicAt)(y0, y1, y2, y3, t);
            idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
            t += lineDash[idx] / bezierLen;
            idx = (idx + 1) % nDash;
        }
        idx % 2 !== 0 && ctx.lineTo(x3, y3);
        dx = x3 - x;
        dy = y3 - y;
        this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
    };
    PathProxy.prototype._dashedQuadraticTo = function(x1, y1, x2, y2) {
        var x3 = x2;
        var y3 = y2;
        x2 = (x2 + 2 * x1) / 3;
        y2 = (y2 + 2 * y1) / 3;
        x1 = (this._xi + 2 * x1) / 3;
        y1 = (this._yi + 2 * y1) / 3;
        this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($7b4119855d2b5b91$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$min2[0] = $7b4119855d2b5b91$var$min2[1] = Number.MAX_VALUE;
        $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = $7b4119855d2b5b91$var$max2[0] = $7b4119855d2b5b91$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $7b4119855d2b5b91$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $7b4119855d2b5b91$var$min2[0] = x0;
                    $7b4119855d2b5b91$var$min2[1] = y0;
                    $7b4119855d2b5b91$var$max2[0] = x0;
                    $7b4119855d2b5b91$var$max2[1] = y0;
                    break;
                case $7b4119855d2b5b91$var$CMD.L:
                    (0, $13I82.fromLine)(xi, yi, data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $7b4119855d2b5b91$var$CMD.C:
                    (0, $13I82.fromCubic)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $7b4119855d2b5b91$var$CMD.Q:
                    (0, $13I82.fromQuadratic)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $7b4119855d2b5b91$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                        y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $13I82.fromArc)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                    yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                    break;
                case $7b4119855d2b5b91$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $13I82.fromLine)(x0, y0, x0 + width, y0 + height, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    break;
                case $7b4119855d2b5b91$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $eLEew.min($7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min2);
            $eLEew.max($7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max2);
        }
        if (i === 0) $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = 0;
        return new (0, $1E3E8.default)($7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$min[1], $7b4119855d2b5b91$var$max[0] - $7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$max[1] - $7b4119855d2b5b91$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $7b4119855d2b5b91$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $7b4119855d2b5b91$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($7b4119855d2b5b91$var$mathAbs(dx) > ux || $7b4119855d2b5b91$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $7b4119855d2b5b91$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $dr1jo.cubicLength)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $7b4119855d2b5b91$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $dr1jo.quadraticLength)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $7b4119855d2b5b91$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                        y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $7b4119855d2b5b91$var$mathMax(rx, ry) * $7b4119855d2b5b91$var$mathMin($7b4119855d2b5b91$var$PI2, Math.abs(delta));
                    xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                    yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                    break;
                case $7b4119855d2b5b91$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $7b4119855d2b5b91$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $7b4119855d2b5b91$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $7b4119855d2b5b91$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $7b4119855d2b5b91$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $7b4119855d2b5b91$var$mathAbs(x - xi);
                    var dy = $7b4119855d2b5b91$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $7b4119855d2b5b91$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $dr1jo.cubicSubdivide)(xi, x1, x2, x3, t, $7b4119855d2b5b91$var$tmpOutX);
                            (0, $dr1jo.cubicSubdivide)(yi, y1, y2, y3, t, $7b4119855d2b5b91$var$tmpOutY);
                            ctx.bezierCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2], $7b4119855d2b5b91$var$tmpOutX[3], $7b4119855d2b5b91$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $7b4119855d2b5b91$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $dr1jo.quadraticSubdivide)(xi, x1, x2, t, $7b4119855d2b5b91$var$tmpOutX);
                            (0, $dr1jo.quadraticSubdivide)(yi, y1, y2, t, $7b4119855d2b5b91$var$tmpOutY);
                            ctx.quadraticCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $7b4119855d2b5b91$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $7b4119855d2b5b91$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                        y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                    yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                    break;
                case $7b4119855d2b5b91$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $7b4119855d2b5b91$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $7b4119855d2b5b91$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $7b4119855d2b5b91$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $7b4119855d2b5b91$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $7b4119855d2b5b91$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = $7b4119855d2b5b91$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._needsDash = false;
        proto._dashOffset = 0;
        proto._dashIdx = 0;
        proto._dashSum = 0;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $7b4119855d2b5b91$export$2e2bcd8739ae039 = $7b4119855d2b5b91$var$PathProxy;

});
parcelRegister("13I82", function(module, exports) {

$parcel$export(module.exports, "fromPoints", () => $0c584d4e3f9e2fa0$export$188c3cd07b4129dd);
$parcel$export(module.exports, "fromLine", () => $0c584d4e3f9e2fa0$export$d2b1491e4450bf2c);
$parcel$export(module.exports, "fromCubic", () => $0c584d4e3f9e2fa0$export$c1bc6be456bb6609);
$parcel$export(module.exports, "fromQuadratic", () => $0c584d4e3f9e2fa0$export$16fbe795323a1f4c);
$parcel$export(module.exports, "fromArc", () => $0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49);

var $eLEew = parcelRequire("eLEew");

var $dr1jo = parcelRequire("dr1jo");
var $0c584d4e3f9e2fa0$var$mathMin = Math.min;
var $0c584d4e3f9e2fa0$var$mathMax = Math.max;
var $0c584d4e3f9e2fa0$var$mathSin = Math.sin;
var $0c584d4e3f9e2fa0$var$mathCos = Math.cos;
var $0c584d4e3f9e2fa0$var$PI2 = Math.PI * 2;
var $0c584d4e3f9e2fa0$var$start = $eLEew.create();
var $0c584d4e3f9e2fa0$var$end = $eLEew.create();
var $0c584d4e3f9e2fa0$var$extremity = $eLEew.create();
function $0c584d4e3f9e2fa0$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $0c584d4e3f9e2fa0$var$mathMin(left, p[0]);
        right = $0c584d4e3f9e2fa0$var$mathMax(right, p[0]);
        top = $0c584d4e3f9e2fa0$var$mathMin(top, p[1]);
        bottom = $0c584d4e3f9e2fa0$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $0c584d4e3f9e2fa0$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x1);
    min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y1);
    max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x1);
    max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y1);
}
var $0c584d4e3f9e2fa0$var$xDim = [];
var $0c584d4e3f9e2fa0$var$yDim = [];
function $0c584d4e3f9e2fa0$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $dr1jo.cubicExtrema;
    var cubicAt = $dr1jo.cubicAt;
    var n = cubicExtrema(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim[i]);
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x, min[0]);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim[i]);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y, min[1]);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y, max[1]);
    }
    min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, min[0]);
    max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, max[0]);
    min[0] = $0c584d4e3f9e2fa0$var$mathMin(x3, min[0]);
    max[0] = $0c584d4e3f9e2fa0$var$mathMax(x3, max[0]);
    min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, min[1]);
    max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, max[1]);
    min[1] = $0c584d4e3f9e2fa0$var$mathMin(y3, min[1]);
    max[1] = $0c584d4e3f9e2fa0$var$mathMax(y3, max[1]);
}
function $0c584d4e3f9e2fa0$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $dr1jo.quadraticExtremum;
    var quadraticAt = $dr1jo.quadraticAt;
    var tx = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x2, x);
    min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y2, y);
    max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x2, x);
    max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y2, y);
}
function $0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $eLEew.min;
    var vec2Max = $eLEew.max;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $0c584d4e3f9e2fa0$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $0c584d4e3f9e2fa0$var$start[0] = $0c584d4e3f9e2fa0$var$mathCos(startAngle) * rx + x;
    $0c584d4e3f9e2fa0$var$start[1] = $0c584d4e3f9e2fa0$var$mathSin(startAngle) * ry + y;
    $0c584d4e3f9e2fa0$var$end[0] = $0c584d4e3f9e2fa0$var$mathCos(endAngle) * rx + x;
    $0c584d4e3f9e2fa0$var$end[1] = $0c584d4e3f9e2fa0$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
    vec2Max(max, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
    startAngle = startAngle % $0c584d4e3f9e2fa0$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $0c584d4e3f9e2fa0$var$PI2;
    endAngle = endAngle % $0c584d4e3f9e2fa0$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $0c584d4e3f9e2fa0$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $0c584d4e3f9e2fa0$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $0c584d4e3f9e2fa0$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $0c584d4e3f9e2fa0$var$extremity[0] = $0c584d4e3f9e2fa0$var$mathCos(angle) * rx + x;
        $0c584d4e3f9e2fa0$var$extremity[1] = $0c584d4e3f9e2fa0$var$mathSin(angle) * ry + y;
        vec2Min(min, $0c584d4e3f9e2fa0$var$extremity, min);
        vec2Max(max, $0c584d4e3f9e2fa0$var$extremity, max);
    }
}

});
parcelRegister("dr1jo", function(module, exports) {

$parcel$export(module.exports, "cubicAt", () => $9c7ed07589dafe64$export$547c21de482bbcb2);
$parcel$export(module.exports, "cubicDerivativeAt", () => $9c7ed07589dafe64$export$55fce925c60b6271);
$parcel$export(module.exports, "cubicRootAt", () => $9c7ed07589dafe64$export$ca5d13faa10b167e);
$parcel$export(module.exports, "cubicExtrema", () => $9c7ed07589dafe64$export$df1a172f100d0457);
$parcel$export(module.exports, "cubicSubdivide", () => $9c7ed07589dafe64$export$a2ee23a0567039da);
$parcel$export(module.exports, "cubicProjectPoint", () => $9c7ed07589dafe64$export$dbaa3801d1284367);
$parcel$export(module.exports, "cubicLength", () => $9c7ed07589dafe64$export$af1875d576f60d7c);
$parcel$export(module.exports, "quadraticAt", () => $9c7ed07589dafe64$export$af17094a950f5073);
$parcel$export(module.exports, "quadraticDerivativeAt", () => $9c7ed07589dafe64$export$7e161e77e6fff8cb);
$parcel$export(module.exports, "quadraticRootAt", () => $9c7ed07589dafe64$export$fd895ac7ee764967);
$parcel$export(module.exports, "quadraticExtremum", () => $9c7ed07589dafe64$export$752e1f8c6e7f7e11);
$parcel$export(module.exports, "quadraticSubdivide", () => $9c7ed07589dafe64$export$117c659e21a7a060);
$parcel$export(module.exports, "quadraticProjectPoint", () => $9c7ed07589dafe64$export$81915a594fe10dee);
$parcel$export(module.exports, "quadraticLength", () => $9c7ed07589dafe64$export$8a68adee46f3cf55);

var $eLEew = parcelRequire("eLEew");
var $9c7ed07589dafe64$var$mathPow = Math.pow;
var $9c7ed07589dafe64$var$mathSqrt = Math.sqrt;
var $9c7ed07589dafe64$var$EPSILON = 1e-8;
var $9c7ed07589dafe64$var$EPSILON_NUMERIC = 1e-4;
var $9c7ed07589dafe64$var$THREE_SQRT = $9c7ed07589dafe64$var$mathSqrt(3);
var $9c7ed07589dafe64$var$ONE_THIRD = 1 / 3;
var $9c7ed07589dafe64$var$_v0 = (0, $eLEew.create)();
var $9c7ed07589dafe64$var$_v1 = (0, $eLEew.create)();
var $9c7ed07589dafe64$var$_v2 = (0, $eLEew.create)();
function $9c7ed07589dafe64$var$isAroundZero(val) {
    return val > -$9c7ed07589dafe64$var$EPSILON && val < $9c7ed07589dafe64$var$EPSILON;
}
function $9c7ed07589dafe64$var$isNotAroundZero(val) {
    return val > $9c7ed07589dafe64$var$EPSILON || val < -$9c7ed07589dafe64$var$EPSILON;
}
function $9c7ed07589dafe64$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $9c7ed07589dafe64$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $9c7ed07589dafe64$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($9c7ed07589dafe64$var$isAroundZero(A) && $9c7ed07589dafe64$var$isAroundZero(B)) {
        if ($9c7ed07589dafe64$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$9c7ed07589dafe64$var$mathPow(-Y1, $9c7ed07589dafe64$var$ONE_THIRD);
            else Y1 = $9c7ed07589dafe64$var$mathPow(Y1, $9c7ed07589dafe64$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$9c7ed07589dafe64$var$mathPow(-Y2, $9c7ed07589dafe64$var$ONE_THIRD);
            else Y2 = $9c7ed07589dafe64$var$mathPow(Y2, $9c7ed07589dafe64$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $9c7ed07589dafe64$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $9c7ed07589dafe64$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $9c7ed07589dafe64$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($9c7ed07589dafe64$var$isAroundZero(a)) {
        if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($9c7ed07589dafe64$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $9c7ed07589dafe64$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $9c7ed07589dafe64$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $9c7ed07589dafe64$var$_v0[0] = x;
    $9c7ed07589dafe64$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $9c7ed07589dafe64$var$mathSqrt(d);
}
function $9c7ed07589dafe64$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $9c7ed07589dafe64$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $9c7ed07589dafe64$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $9c7ed07589dafe64$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($9c7ed07589dafe64$var$isAroundZero(a)) {
        if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $9c7ed07589dafe64$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $9c7ed07589dafe64$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $9c7ed07589dafe64$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $9c7ed07589dafe64$var$_v0[0] = x;
    $9c7ed07589dafe64$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, _t);
        $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, prev);
        $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, next);
            $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $9c7ed07589dafe64$var$mathSqrt(d);
}
function $9c7ed07589dafe64$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
        var y = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}

});



parcelRegister("k3yEY", function(module, exports) {

$parcel$export(module.exports, "contain", () => $e99ef93372091697$export$8893e2b90ba10d92);
$parcel$export(module.exports, "containStroke", () => $e99ef93372091697$export$8d36b1b5d19157c5);

var $aA4Ws = parcelRequire("aA4Ws");

var $1oALq = parcelRequire("1oALq");

var $bTFCK = parcelRequire("bTFCK");

var $1nzVA = parcelRequire("1nzVA");

var $69jpm = parcelRequire("69jpm");

var $dr1jo = parcelRequire("dr1jo");

var $3Ytji = parcelRequire("3Ytji");
var $e99ef93372091697$var$CMD = (0, $aA4Ws.default).CMD;
var $e99ef93372091697$var$PI2 = Math.PI * 2;
var $e99ef93372091697$var$EPSILON = 1e-4;
function $e99ef93372091697$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $e99ef93372091697$var$EPSILON;
}
var $e99ef93372091697$var$roots = [
    -1,
    -1,
    -1
];
var $e99ef93372091697$var$extrema = [
    -1,
    -1
];
function $e99ef93372091697$var$swapExtrema() {
    var tmp = $e99ef93372091697$var$extrema[0];
    $e99ef93372091697$var$extrema[0] = $e99ef93372091697$var$extrema[1];
    $e99ef93372091697$var$extrema[1] = tmp;
}
function $e99ef93372091697$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $dr1jo.cubicRootAt(y0, y1, y2, y3, y, $e99ef93372091697$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $e99ef93372091697$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $dr1jo.cubicAt(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $dr1jo.cubicExtrema(y0, y1, y2, y3, $e99ef93372091697$var$extrema);
                if ($e99ef93372091697$var$extrema[1] < $e99ef93372091697$var$extrema[0] && nExtrema > 1) $e99ef93372091697$var$swapExtrema();
                y0_ = $dr1jo.cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[0]);
                if (nExtrema > 1) y1_ = $dr1jo.cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $e99ef93372091697$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $e99ef93372091697$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $dr1jo.quadraticRootAt(y0, y1, y2, y, $e99ef93372091697$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $dr1jo.quadraticExtremum(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $dr1jo.quadraticAt(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $e99ef93372091697$var$roots[i] === 0 || $e99ef93372091697$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $dr1jo.quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[i]);
                if (x_ < x) continue;
                if ($e99ef93372091697$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $e99ef93372091697$var$roots[0] === 0 || $e99ef93372091697$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $dr1jo.quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $e99ef93372091697$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $e99ef93372091697$var$roots[0] = -tmp;
    $e99ef93372091697$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $e99ef93372091697$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $e99ef93372091697$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $e99ef93372091697$var$roots[0] + cx && x <= $e99ef93372091697$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $e99ef93372091697$var$PI2;
        endAngle += $e99ef93372091697$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $e99ef93372091697$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $e99ef93372091697$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $e99ef93372091697$var$PI2 >= startAngle && angle + $e99ef93372091697$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $e99ef93372091697$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $e99ef93372091697$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $3Ytji.default)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $e99ef93372091697$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $e99ef93372091697$var$CMD.L:
                if (isStroke) {
                    if ($1oALq.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $3Ytji.default)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e99ef93372091697$var$CMD.C:
                if (isStroke) {
                    if ($bTFCK.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $e99ef93372091697$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e99ef93372091697$var$CMD.Q:
                if (isStroke) {
                    if ($1nzVA.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $e99ef93372091697$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e99ef93372091697$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $3Ytji.default)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($69jpm.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $e99ef93372091697$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $e99ef93372091697$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($1oALq.containStroke(x0, y0, x1, y0, lineWidth, x, y) || $1oALq.containStroke(x1, y0, x1, y1, lineWidth, x, y) || $1oALq.containStroke(x1, y1, x0, y1, lineWidth, x, y) || $1oALq.containStroke(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $3Ytji.default)(x1, y0, x1, y1, x, y);
                    w += (0, $3Ytji.default)(x0, y1, x0, y0, x, y);
                }
                break;
            case $e99ef93372091697$var$CMD.Z:
                if (isStroke) {
                    if ($1oALq.containStroke(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $3Ytji.default)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$e99ef93372091697$var$isAroundEqual(yi, y0)) w += (0, $3Ytji.default)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $e99ef93372091697$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $e99ef93372091697$var$containPath(pathProxy, 0, false, x, y);
}
function $e99ef93372091697$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $e99ef93372091697$var$containPath(pathProxy, lineWidth, true, x, y);
}

});
parcelRegister("1oALq", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $10448ce251a929f8$export$8d36b1b5d19157c5);
function $10448ce251a929f8$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}

});

parcelRegister("bTFCK", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $8a951e6f66d6987a$export$8d36b1b5d19157c5);

var $dr1jo = parcelRequire("dr1jo");
function $8a951e6f66d6987a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $dr1jo.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("1nzVA", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $1013ceeba79e2375$export$8d36b1b5d19157c5);

var $dr1jo = parcelRequire("dr1jo");
function $1013ceeba79e2375$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $dr1jo.quadraticProjectPoint)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("69jpm", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $47a2a3596d9bac74$export$8d36b1b5d19157c5);

var $kvt3T = parcelRequire("kvt3T");
var $47a2a3596d9bac74$var$PI2 = Math.PI * 2;
function $47a2a3596d9bac74$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $47a2a3596d9bac74$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $kvt3T.normalizeRadian)(endAngle);
        endAngle = (0, $kvt3T.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $kvt3T.normalizeRadian)(startAngle);
        endAngle = (0, $kvt3T.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $47a2a3596d9bac74$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $47a2a3596d9bac74$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $47a2a3596d9bac74$var$PI2 >= startAngle && angle + $47a2a3596d9bac74$var$PI2 <= endAngle;
}

});
parcelRegister("kvt3T", function(module, exports) {

$parcel$export(module.exports, "normalizeRadian", () => $eedd3ef967ea7890$export$d44861331f213635);
var $eedd3ef967ea7890$var$PI2 = Math.PI * 2;
function $eedd3ef967ea7890$export$d44861331f213635(angle) {
    angle %= $eedd3ef967ea7890$var$PI2;
    if (angle < 0) angle += $eedd3ef967ea7890$var$PI2;
    return angle;
}

});


parcelRegister("3Ytji", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4db612d32f7532$export$2e2bcd8739ae039);
function $2e4db612d32f7532$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}

});




parcelRegister("gcbBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca6c53e2dabf533$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $lBQ88 = parcelRequire("lBQ88");

var $1E3E8 = parcelRequire("1E3E8");

var $bahqM = parcelRequire("bahqM");
var $bca6c53e2dabf533$export$8993f922aeeac642 = (0, $bahqM.defaults)({
    x: 0,
    y: 0
}, (0, $lBQ88.DEFAULT_COMMON_STYLE));
var $bca6c53e2dabf533$export$4aba8ad70847a488 = {
    style: (0, $bahqM.defaults)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $lBQ88.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
function $bca6c53e2dabf533$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $bca6c53e2dabf533$var$ZRImage = function(_super) {
    (0, $3VFsf.__extends)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $bahqM.createObject)($bca6c53e2dabf533$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $bca6c53e2dabf533$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $bca6c53e2dabf533$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $1E3E8.default)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $lBQ88.default));
$bca6c53e2dabf533$var$ZRImage.prototype.type = 'image';
var $bca6c53e2dabf533$export$2e2bcd8739ae039 = $bca6c53e2dabf533$var$ZRImage;

});

parcelRegister("7Tw7u", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bf695c646bd738a$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $7AySl = parcelRequire("7AySl");

var $2az2p = parcelRequire("2az2p");
var $5bf695c646bd738a$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $5bf695c646bd738a$var$subPixelOptimizeOutputShape = {};
var $5bf695c646bd738a$var$Rect = function(_super) {
    (0, $3VFsf.__extends)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $5bf695c646bd738a$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $2az2p.subPixelOptimizeRect)($5bf695c646bd738a$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $7AySl.buildPath(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $ghQ8v.default));
$5bf695c646bd738a$var$Rect.prototype.type = 'rect';
var $5bf695c646bd738a$export$2e2bcd8739ae039 = $5bf695c646bd738a$var$Rect;

});
parcelRegister("7AySl", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $5866f2ba314594b2$export$5cc7f731b5937e99);
function $5866f2ba314594b2$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}

});

parcelRegister("2az2p", function(module, exports) {

$parcel$export(module.exports, "subPixelOptimizeLine", () => $1947b1c1b6b500f1$export$8b4b620d7f4aad1b);
$parcel$export(module.exports, "subPixelOptimize", () => $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10);
$parcel$export(module.exports, "subPixelOptimizeRect", () => $1947b1c1b6b500f1$export$60e2aa74957d0b9d);
var $1947b1c1b6b500f1$var$round = Math.round;
function $1947b1c1b6b500f1$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($1947b1c1b6b500f1$var$round(x1 * 2) === $1947b1c1b6b500f1$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($1947b1c1b6b500f1$var$round(y1 * 2) === $1947b1c1b6b500f1$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $1947b1c1b6b500f1$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $1947b1c1b6b500f1$var$round(position * 2);
    return (doubledPosition + $1947b1c1b6b500f1$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

});



parcelRegister("fIXXx", function(module, exports) {

$parcel$export(module.exports, "HOVER_STATE_BLUR", () => $b72979b7cd946cce$export$1307d6a87d56baa);
$parcel$export(module.exports, "HOVER_STATE_EMPHASIS", () => $b72979b7cd946cce$export$f0f2bee145debb31);
$parcel$export(module.exports, "SPECIAL_STATES", () => $b72979b7cd946cce$export$151308dceb52d5b);
$parcel$export(module.exports, "DISPLAY_STATES", () => $b72979b7cd946cce$export$57ee5306b85ad7d5);
$parcel$export(module.exports, "Z2_EMPHASIS_LIFT", () => $b72979b7cd946cce$export$1cb9fc6ed5b9836c);
$parcel$export(module.exports, "HIGHLIGHT_ACTION_TYPE", () => $b72979b7cd946cce$export$df035d873a9de64f);
$parcel$export(module.exports, "DOWNPLAY_ACTION_TYPE", () => $b72979b7cd946cce$export$f8a2f7807cc185ea);
$parcel$export(module.exports, "SELECT_ACTION_TYPE", () => $b72979b7cd946cce$export$89616263e7d38fe9);
$parcel$export(module.exports, "UNSELECT_ACTION_TYPE", () => $b72979b7cd946cce$export$7636ad95c0f68a79);
$parcel$export(module.exports, "TOGGLE_SELECT_ACTION_TYPE", () => $b72979b7cd946cce$export$1e90ed8a25542516);
$parcel$export(module.exports, "setStatesFlag", () => $b72979b7cd946cce$export$868ba38adffa9e39);
$parcel$export(module.exports, "setDefaultStateProxy", () => $b72979b7cd946cce$export$20f39bbe322fb9ab);
$parcel$export(module.exports, "enterEmphasis", () => $b72979b7cd946cce$export$b2d02638cc34c042);
$parcel$export(module.exports, "leaveEmphasis", () => $b72979b7cd946cce$export$11be6f716239ac55);
$parcel$export(module.exports, "enterBlur", () => $b72979b7cd946cce$export$207f9cb3e1099375);
$parcel$export(module.exports, "leaveBlur", () => $b72979b7cd946cce$export$fd4a9ec75456d3c1);
$parcel$export(module.exports, "enterSelect", () => $b72979b7cd946cce$export$252d028dda8ef765);
$parcel$export(module.exports, "leaveSelect", () => $b72979b7cd946cce$export$ea9a904bd6e32bd3);
$parcel$export(module.exports, "allLeaveBlur", () => $b72979b7cd946cce$export$b2a593c7b5243584);
$parcel$export(module.exports, "blurComponent", () => $b72979b7cd946cce$export$569da03256c8a55f);
$parcel$export(module.exports, "blurSeriesFromHighlightPayload", () => $b72979b7cd946cce$export$64f1fd4daefef21b);
$parcel$export(module.exports, "findComponentHighDownDispatchers", () => $b72979b7cd946cce$export$f31a644ccca0ef23);
$parcel$export(module.exports, "handleGlobalMouseOverForHighDown", () => $b72979b7cd946cce$export$416765b6198234ff);
$parcel$export(module.exports, "handleGlboalMouseOutForHighDown", () => $b72979b7cd946cce$export$2cbc9e6f4b583c84);
$parcel$export(module.exports, "toggleSelectionFromPayload", () => $b72979b7cd946cce$export$1c7d489f62372d73);
$parcel$export(module.exports, "isSelectChangePayload", () => $b72979b7cd946cce$export$72aea10e60e45351);
$parcel$export(module.exports, "updateSeriesElementSelection", () => $b72979b7cd946cce$export$e4ea08ef52e0a73);
$parcel$export(module.exports, "getAllSelectedIndices", () => $b72979b7cd946cce$export$c529643b619af6b3);
$parcel$export(module.exports, "enableHoverEmphasis", () => $b72979b7cd946cce$export$5f393df0b5aee2e7);
$parcel$export(module.exports, "setAsHighDownDispatcher", () => $b72979b7cd946cce$export$9ba15aea1e048d48);
$parcel$export(module.exports, "enableHoverFocus", () => $b72979b7cd946cce$export$24972466b2b62ac2);
$parcel$export(module.exports, "setStatesStylesFromModel", () => $b72979b7cd946cce$export$48b68047d330bbc9);
$parcel$export(module.exports, "isHighDownDispatcher", () => $b72979b7cd946cce$export$77d1445f699c58b5);
$parcel$export(module.exports, "enableComponentHighDownFeatures", () => $b72979b7cd946cce$export$4da05a9639f01954);
$parcel$export(module.exports, "getHighlightDigit", () => $b72979b7cd946cce$export$824af40eb714530d);
$parcel$export(module.exports, "isHighDownPayload", () => $b72979b7cd946cce$export$aebe71265c1b77bf);
$parcel$export(module.exports, "savePathStates", () => $b72979b7cd946cce$export$9fe78019e6f395b6);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $h4RuA = parcelRequire("h4RuA");

var $bahqM = parcelRequire("bahqM");

var $7QjoM = parcelRequire("7QjoM");

var $d6udH = parcelRequire("d6udH");

var $eaKsF = parcelRequire("eaKsF");

var $ghQ8v = parcelRequire("ghQ8v");

var $b72979b7cd946cce$var$_highlightNextDigit = 1;
var $b72979b7cd946cce$var$_highlightKeyMap = {};
var $b72979b7cd946cce$var$getSavedStates = (0, $eaKsF.makeInner)();
var $b72979b7cd946cce$export$5542daa30722333e = 0;
var $b72979b7cd946cce$export$1307d6a87d56baa = 1;
var $b72979b7cd946cce$export$f0f2bee145debb31 = 2;
var $b72979b7cd946cce$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $b72979b7cd946cce$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $b72979b7cd946cce$export$1cb9fc6ed5b9836c = 10;
var $b72979b7cd946cce$export$3a2f97d39514bbc = 9;
var $b72979b7cd946cce$export$df035d873a9de64f = 'highlight';
var $b72979b7cd946cce$export$f8a2f7807cc185ea = 'downplay';
var $b72979b7cd946cce$export$89616263e7d38fe9 = 'select';
var $b72979b7cd946cce$export$7636ad95c0f68a79 = 'unselect';
var $b72979b7cd946cce$export$1e90ed8a25542516 = 'toggleSelect';
function $b72979b7cd946cce$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
} // Most lifted color are duplicated.
var $b72979b7cd946cce$var$liftedColorCache = new (0, $h4RuA.default)(100);
function $b72979b7cd946cce$var$liftColor(color) {
    if (typeof color !== 'string') return color;
    var liftedColor = $b72979b7cd946cce$var$liftedColorCache.get(color);
    if (!liftedColor) {
        liftedColor = $d6udH.lift(color, -0.1);
        $b72979b7cd946cce$var$liftedColorCache.put(color, liftedColor);
    }
    return liftedColor;
}
function $b72979b7cd946cce$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $b72979b7cd946cce$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $b72979b7cd946cce$var$doChangeHoverState(el, 'emphasis', $b72979b7cd946cce$export$f0f2bee145debb31);
}
function $b72979b7cd946cce$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $b72979b7cd946cce$export$f0f2bee145debb31) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
}
function $b72979b7cd946cce$var$singleEnterBlur(el) {
    $b72979b7cd946cce$var$doChangeHoverState(el, 'blur', $b72979b7cd946cce$export$1307d6a87d56baa);
}
function $b72979b7cd946cce$var$singleLeaveBlur(el) {
    if (el.hoverState === $b72979b7cd946cce$export$1307d6a87d56baa) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
}
function $b72979b7cd946cce$var$singleEnterSelect(el) {
    el.selected = true;
}
function $b72979b7cd946cce$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $b72979b7cd946cce$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $b72979b7cd946cce$var$traverseUpdateState(el, updater, commonParam) {
    $b72979b7cd946cce$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $b72979b7cd946cce$var$updateElementState(child, updater, commonParam);
    });
}
function $b72979b7cd946cce$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $b72979b7cd946cce$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $b72979b7cd946cce$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $b72979b7cd946cce$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $b72979b7cd946cce$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $b72979b7cd946cce$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition // Dont consider the animation to emphasis state.
         && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveFinalToTarget(fromState, props);
    }
    return fromState;
}
function $b72979b7cd946cce$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $bahqM.indexOf)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $ghQ8v.default)) {
        var store = $b72979b7cd946cce$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($b72979b7cd946cce$var$hasFillOrStroke(fromFill) || $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {}; // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $bahqM.extend)({}, state);
                emphasisStyle = (0, $bahqM.extend)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.fill) && $b72979b7cd946cce$var$hasFillOrStroke(fromFill)) {
                cloned = true; // Not modify the original value.
                state = (0, $bahqM.extend)({}, state);
                emphasisStyle = (0, $bahqM.extend)({}, emphasisStyle); // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = $b72979b7cd946cce$var$liftColor(fromFill);
            } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.stroke) && $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $bahqM.extend)({}, state);
                    emphasisStyle = (0, $bahqM.extend)({}, emphasisStyle);
                }
                emphasisStyle.stroke = $b72979b7cd946cce$var$liftColor(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $bahqM.extend)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $b72979b7cd946cce$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $b72979b7cd946cce$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $bahqM.extend)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $b72979b7cd946cce$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $b72979b7cd946cce$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $bahqM.indexOf)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $b72979b7cd946cce$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $bahqM.extend)({}, state);
        blurStyle = (0, $bahqM.extend)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $b72979b7cd946cce$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $b72979b7cd946cce$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $b72979b7cd946cce$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $b72979b7cd946cce$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $b72979b7cd946cce$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
}
function $b72979b7cd946cce$export$d899507e2598e4ae(el, e) {
    !$b72979b7cd946cce$var$shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
}
function $b72979b7cd946cce$export$784cba1f7fe58cca(el, e) {
    !$b72979b7cd946cce$var$shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
}
function $b72979b7cd946cce$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
}
function $b72979b7cd946cce$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
}
function $b72979b7cd946cce$export$207f9cb3e1099375(el) {
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterBlur);
}
function $b72979b7cd946cce$export$fd4a9ec75456d3c1(el) {
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveBlur);
}
function $b72979b7cd946cce$export$252d028dda8ef765(el) {
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterSelect);
}
function $b72979b7cd946cce$export$ea9a904bd6e32bd3(el) {
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveSelect);
}
function $b72979b7cd946cce$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $b72979b7cd946cce$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    model.eachComponent(function(componentType, componentModel) {
        var view = componentType === 'series' ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel); // Leave blur anyway
        view.group.traverse(function(child) {
            $b72979b7cd946cce$var$singleLeaveBlur(child);
        });
    });
}
function $b72979b7cd946cce$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $b72979b7cd946cce$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!(blurScope === 'series' && !sameSeries // Not blur other coordinate system if blurScope is coordinateSystem
         || blurScope === 'coordinateSystem' && !sameCoordSys // Not blur self series if focus is series.
         || focus === 'series' && sameSeries // TODO blurScope: coordinate system
        )) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                $b72979b7cd946cce$var$singleEnterBlur(child);
            });
            if ((0, $bahqM.isArrayLike)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $bahqM.isObject)(focus)) {
                var dataTypes = (0, $bahqM.keys)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.blurSeries) view.blurSeries(blurredSeries, ecModel);
    });
}
function $b72979b7cd946cce$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $b72979b7cd946cce$var$singleEnterBlur(child);
    });
}
function $b72979b7cd946cce$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    var dataIndex = (0, $eaKsF.queryDataIndex)(data, payload); // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $bahqM.isArray)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0; // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $7QjoM.getECData)(el);
        $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $b72979b7cd946cce$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name); // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $7QjoM.getECData)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $b72979b7cd946cce$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $7QjoM.getECData)(dispatcher);
    var _a = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf; // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $bahqM.each)(dispatchers, function(dispatcher) {
            return $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $b72979b7cd946cce$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
         // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $b72979b7cd946cce$export$2cbc9e6f4b583c84(dispatcher, e, api) {
    $b72979b7cd946cce$export$b2a593c7b5243584(api);
    var ecData = (0, $7QjoM.getECData)(dispatcher);
    var dispatchers = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $bahqM.each)(dispatchers, function(dispatcher) {
        return $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
}
function $b72979b7cd946cce$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$b72979b7cd946cce$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $eaKsF.queryDataIndex)(data, payload);
    if (!(0, $bahqM.isArray)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $b72979b7cd946cce$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $b72979b7cd946cce$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $b72979b7cd946cce$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $bahqM.each)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $b72979b7cd946cce$export$252d028dda8ef765(el) : $b72979b7cd946cce$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $b72979b7cd946cce$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $bahqM.each)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $b72979b7cd946cce$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $b72979b7cd946cce$export$9ba15aea1e048d48(el, true);
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$export$20f39bbe322fb9ab);
    $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope);
}
function $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $7QjoM.getECData)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope; // }
    } else if (ecData.focus) ecData.focus = null;
}
var $b72979b7cd946cce$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $b72979b7cd946cce$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $b72979b7cd946cce$export$48b68047d330bbc9(el, itemModel, styleType, getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $b72979b7cd946cce$var$OTHER_STATES.length; i++){
        var stateName = $b72979b7cd946cce$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName); // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$b72979b7cd946cce$var$defaultStyleGetterMap[styleType]]();
    }
}
function $b72979b7cd946cce$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el; // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
     // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $b72979b7cd946cce$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $b72979b7cd946cce$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $7QjoM.getECData)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $b72979b7cd946cce$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $b72979b7cd946cce$var$_highlightNextDigit <= 32) highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey] = $b72979b7cd946cce$var$_highlightNextDigit++;
    return highlightDigit;
}
function $b72979b7cd946cce$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $b72979b7cd946cce$export$89616263e7d38fe9 || payloadType === $b72979b7cd946cce$export$7636ad95c0f68a79 || payloadType === $b72979b7cd946cce$export$1e90ed8a25542516;
}
function $b72979b7cd946cce$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $b72979b7cd946cce$export$df035d873a9de64f || payloadType === $b72979b7cd946cce$export$f8a2f7807cc185ea;
}
function $b72979b7cd946cce$export$9fe78019e6f395b6(el) {
    var store = $b72979b7cd946cce$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}

});
parcelRegister("7QjoM", function(module, exports) {

$parcel$export(module.exports, "getECData", () => $5b5c6fe297852166$export$b1c39b2bacd1ddc2);
$parcel$export(module.exports, "setCommonECData", () => $5b5c6fe297852166$export$30d6736ebb8e18d5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");
var $5b5c6fe297852166$export$b1c39b2bacd1ddc2 = (0, $eaKsF.makeInner)();
var $5b5c6fe297852166$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(el); // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex; // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
        });
    }
};

});
parcelRegister("eaKsF", function(module, exports) {

$parcel$export(module.exports, "normalizeToArray", () => $a5160a25a687d9b6$export$4f07b212a02c8051);
$parcel$export(module.exports, "defaultEmphasis", () => $a5160a25a687d9b6$export$abdcc6a26372f94b);
$parcel$export(module.exports, "TEXT_STYLE_OPTIONS", () => $a5160a25a687d9b6$export$df45610347a602ad);
$parcel$export(module.exports, "getDataItemValue", () => $a5160a25a687d9b6$export$2c944e12edb48d4b);
$parcel$export(module.exports, "isDataItemOption", () => $a5160a25a687d9b6$export$3e1a543f33ef6883);
$parcel$export(module.exports, "mappingToExists", () => $a5160a25a687d9b6$export$574f818966e4da87);
$parcel$export(module.exports, "isComponentIdInternal", () => $a5160a25a687d9b6$export$feece3e7d52a102b);
$parcel$export(module.exports, "convertOptionIdName", () => $a5160a25a687d9b6$export$fb1a222ba5dd6e51);
$parcel$export(module.exports, "isNameSpecified", () => $a5160a25a687d9b6$export$beae19a2652b3368);
$parcel$export(module.exports, "makeInternalComponentId", () => $a5160a25a687d9b6$export$1753133c42e665e8);
$parcel$export(module.exports, "setComponentTypeToKeyInfo", () => $a5160a25a687d9b6$export$5ac61aca2ba0282d);
$parcel$export(module.exports, "compressBatches", () => $a5160a25a687d9b6$export$6d12cabb0c9bf8e3);
$parcel$export(module.exports, "queryDataIndex", () => $a5160a25a687d9b6$export$42b26cae8b8d10);
$parcel$export(module.exports, "makeInner", () => $a5160a25a687d9b6$export$64df9f8d92ae083f);
$parcel$export(module.exports, "parseFinder", () => $a5160a25a687d9b6$export$95de80076abac814);
$parcel$export(module.exports, "preParseFinder", () => $a5160a25a687d9b6$export$fe600815775d9400);
$parcel$export(module.exports, "queryReferringComponents", () => $a5160a25a687d9b6$export$dc741340f7e5f186);
$parcel$export(module.exports, "SINGLE_REFERRING", () => $a5160a25a687d9b6$export$f076738ec84e693c);
$parcel$export(module.exports, "MULTIPLE_REFERRING", () => $a5160a25a687d9b6$export$48d598924ce4892c);
$parcel$export(module.exports, "setAttribute", () => $a5160a25a687d9b6$export$9fec4d97f1922e0b);
$parcel$export(module.exports, "getAttribute", () => $a5160a25a687d9b6$export$735ee1799fd02602);
$parcel$export(module.exports, "getTooltipRenderMode", () => $a5160a25a687d9b6$export$cc0a17a5d27b4e17);
$parcel$export(module.exports, "groupData", () => $a5160a25a687d9b6$export$7ab5bda43e13168f);
$parcel$export(module.exports, "interpolateRawValues", () => $a5160a25a687d9b6$export$bd0439821a1869f3);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $jmSNG = parcelRequire("jmSNG");

var $hb2y5 = parcelRequire("hb2y5");

/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $a5160a25a687d9b6$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $a5160a25a687d9b6$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $a5160a25a687d9b6$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
]; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
function $a5160a25a687d9b6$export$2c944e12edb48d4b(dataItem) {
    return (0, $bahqM.isObject)(dataItem) && !(0, $bahqM.isArray)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $a5160a25a687d9b6$export$3e1a543f33ef6883(dataItem) {
    return (0, $bahqM.isObject)(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $a5160a25a687d9b6$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $bahqM.createHashMap)(); // Validate id and name on user input option.
    (0, $bahqM.each)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $bahqM.isObject)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions);
    $a5160a25a687d9b6$var$makeIdAndName(result); // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will ommit those items and result in incorrect result.
    return result;
}
function $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
     // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be ommited.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index]; // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
         // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $a5160a25a687d9b6$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $bahqM.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $bahqM.assert)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption; // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $bahqM.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) && !$a5160a25a687d9b6$export$feece3e7d52a102b(existing) && $a5160a25a687d9b6$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $bahqM.each)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
         // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while((resultItem = result[nextIdx]) && // after mapping performed, model will always be assigned with an id if user not given.
        // After that all models have id.
        // (2) If new option has id, it can only set to a hole or append to the last. It should
        // not be merged to the existings with different id. Because id should not be overwritten.
        // (3) Name can be overwritten, because axis use name as 'show label text'.
        (resultItem.newOption || $a5160a25a687d9b6$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$a5160a25a687d9b6$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $bahqM.each)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that compoennt index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $a5160a25a687d9b6$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $bahqM.createHashMap)();
    (0, $bahqM.each)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $bahqM.each)(mapResult, function(item) {
        var opt = item.newOption; // Force ensure id not duplicated.
        (0, $bahqM.assert)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    }); // Make name and id.
    (0, $bahqM.each)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $bahqM.isObject)(opt)) return;
         // name can be overwitten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $a5160a25a687d9b6$var$makeComparableKey(opt.name) : existing ? existing.name // Avoid diffferent series has the same name,
         : $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $a5160a25a687d9b6$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj2[attr], null); // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $a5160a25a687d9b6$var$makeComparableKey(val) {
    return $a5160a25a687d9b6$export$fb1a222ba5dd6e51(val, '');
}
function $a5160a25a687d9b6$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    var type = typeof idOrName;
    return type === 'string' ? idOrName : type === 'number' || (0, $bahqM.isStringSafe)(idOrName) ? idOrName + '' : defaultValue;
}
function $a5160a25a687d9b6$var$warnInvalidateIdOrName(idOrName) {}
function $a5160a25a687d9b6$var$isValidIdOrName(idOrName) {
    return (0, $bahqM.isStringSafe)(idOrName) || (0, $jmSNG.isNumeric)(idOrName);
}
function $a5160a25a687d9b6$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id).indexOf($a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $a5160a25a687d9b6$export$1753133c42e665e8(idSuffix) {
    return $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $a5160a25a687d9b6$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $bahqM.each)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $bahqM.isObject)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $a5160a25a687d9b6$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $a5160a25a687d9b6$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
     : componentModelCtor.determineSubType(mainType, newCmptOption); // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $a5160a25a687d9b6$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $a5160a25a687d9b6$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $a5160a25a687d9b6$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $bahqM.isArray)(payload.dataIndex) ? (0, $bahqM.map)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $bahqM.isArray)(payload.name) ? (0, $bahqM.map)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $a5160a25a687d9b6$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $a5160a25a687d9b6$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $a5160a25a687d9b6$var$innerUniqueIndex = (0, $jmSNG.getRandomIdBase)();
function $a5160a25a687d9b6$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $bahqM.isString)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $bahqM.createHashMap)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $bahqM.each)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illgal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $bahqM.indexOf)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $a5160a25a687d9b6$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $a5160a25a687d9b6$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $a5160a25a687d9b6$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        (0, $bahqM.assert)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
        result.models = [];
        return result;
    } // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        (0, $bahqM.assert)(opt.enableAll, '`"all"` is not a valid value on index option.');
        indexOption = idOption = nameOption = null;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $a5160a25a687d9b6$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $a5160a25a687d9b6$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $a5160a25a687d9b6$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $hZfwb.default).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $a5160a25a687d9b6$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $bahqM.createHashMap)();
    var keys = [];
    (0, $bahqM.each)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $a5160a25a687d9b6$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if (typeof targetValue === 'number') {
        var value = (0, $hb2y5.interpolateNumber)(sourceValue || 0, targetValue, percent);
        return (0, $jmSNG.round)(value, isAutoPrecision ? Math.max((0, $jmSNG.getPrecision)(sourceValue || 0), (0, $jmSNG.getPrecision)(targetValue)) : precision);
    } else if (typeof targetValue === 'string') return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i); // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = (0, $hb2y5.interpolateNumber)(leftVal, rightVal, percent);
                interpolated[i] = (0, $jmSNG.round)(value, isAutoPrecision ? Math.max((0, $jmSNG.getPrecision)(leftVal), (0, $jmSNG.getPrecision)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}

});
parcelRegister("jmSNG", function(module, exports) {

$parcel$export(module.exports, "linearMap", () => $e19a9495965944b5$export$d3f68fbaa670562);
$parcel$export(module.exports, "parsePercent", () => $e19a9495965944b5$export$e8514cb5a5e2b40f);
$parcel$export(module.exports, "round", () => $e19a9495965944b5$export$2077e0241d6afd3c);
$parcel$export(module.exports, "asc", () => $e19a9495965944b5$export$debe6e778e0a6d32);
$parcel$export(module.exports, "getPrecision", () => $e19a9495965944b5$export$e0c74b50bbd10f68);
$parcel$export(module.exports, "getPrecisionSafe", () => $e19a9495965944b5$export$6d86ba4ca4984d31);
$parcel$export(module.exports, "getPixelPrecision", () => $e19a9495965944b5$export$666260d9a2dda8a7);
$parcel$export(module.exports, "getPercentWithPrecision", () => $e19a9495965944b5$export$70cc11b075afeb90);
$parcel$export(module.exports, "addSafe", () => $e19a9495965944b5$export$d3389a301c3a5706);
$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => $e19a9495965944b5$export$18510406f204a1b9);
$parcel$export(module.exports, "remRadian", () => $e19a9495965944b5$export$2ca6dd70a288b1c3);
$parcel$export(module.exports, "isRadianAroundZero", () => $e19a9495965944b5$export$d1df570aea2868f);
$parcel$export(module.exports, "parseDate", () => $e19a9495965944b5$export$6b862160d295c8e);
$parcel$export(module.exports, "quantity", () => $e19a9495965944b5$export$82dd68b83a44b253);
$parcel$export(module.exports, "quantityExponent", () => $e19a9495965944b5$export$97256a17b20a0c24);
$parcel$export(module.exports, "nice", () => $e19a9495965944b5$export$7a695fe44258210b);
$parcel$export(module.exports, "quantile", () => $e19a9495965944b5$export$651fb4afdb6caa4b);
$parcel$export(module.exports, "reformIntervals", () => $e19a9495965944b5$export$12f7386070bc380a);
$parcel$export(module.exports, "numericToNumber", () => $e19a9495965944b5$export$8b4007b942b45a96);
$parcel$export(module.exports, "isNumeric", () => $e19a9495965944b5$export$e90fb89750dba83f);
$parcel$export(module.exports, "getRandomIdBase", () => $e19a9495965944b5$export$474d2ec9aa44a22);
$parcel$export(module.exports, "getLeastCommonMultiple", () => $e19a9495965944b5$export$680a45b749323f49);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $bahqM = parcelRequire("bahqM");
var $e19a9495965944b5$var$RADIAN_EPSILON = 1e-4; // Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $e19a9495965944b5$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
function $e19a9495965944b5$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
     // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
function $e19a9495965944b5$export$e8514cb5a5e2b40f(percent, all) {
    switch(percent){
        case 'center':
        case 'middle':
            percent = '50%';
            break;
        case 'left':
        case 'top':
            percent = '0%';
            break;
        case 'right':
        case 'bottom':
            percent = '100%';
            break;
    }
    if (typeof percent === 'string') {
        if ($e19a9495965944b5$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
function $e19a9495965944b5$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) precision = 10;
     // Avoid range error
    precision = Math.min(Math.max(0, precision), $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX); // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $e19a9495965944b5$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $e19a9495965944b5$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
     // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $e19a9495965944b5$export$6d86ba4ca4984d31(val);
}
function $e19a9495965944b5$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase(); // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $e19a9495965944b5$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $e19a9495965944b5$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var sum = $bahqM.reduce(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return 0;
    var digits = Math.pow(10, precision);
    var votesPerQuota = $bahqM.map(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $bahqM.map(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $bahqM.reduce(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $bahqM.map(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    }); // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
         // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return seats[idx] / digits;
}
function $e19a9495965944b5$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($e19a9495965944b5$export$e0c74b50bbd10f68(val0), $e19a9495965944b5$export$e0c74b50bbd10f68(val1)); // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1; // // PENDING: support more?
    return maxPrecision > $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $e19a9495965944b5$export$2077e0241d6afd3c(sum, maxPrecision);
} // Number.MAX_SAFE_INTEGER, ie do not support.
var $e19a9495965944b5$export$18510406f204a1b9 = 9007199254740991;
function $e19a9495965944b5$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $e19a9495965944b5$export$d1df570aea2868f(val) {
    return val > -$e19a9495965944b5$var$RADIAN_EPSILON && val < $e19a9495965944b5$var$RADIAN_EPSILON;
} // eslint-disable-next-line
var $e19a9495965944b5$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $e19a9495965944b5$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if (typeof value === 'string') {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $e19a9495965944b5$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
         // Use local time when no timezone offset specifed.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $e19a9495965944b5$export$82dd68b83a44b253(val) {
    return Math.pow(10, $e19a9495965944b5$export$97256a17b20a0c24(val));
}
function $e19a9495965944b5$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $e19a9495965944b5$export$7a695fe44258210b(val, round) {
    var exponent = $e19a9495965944b5$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $e19a9495965944b5$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $e19a9495965944b5$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $e19a9495965944b5$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || typeof val !== 'string' || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $e19a9495965944b5$export$e90fb89750dba83f(val) {
    return !isNaN($e19a9495965944b5$export$8b4007b942b45a96(val));
}
function $e19a9495965944b5$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $e19a9495965944b5$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $e19a9495965944b5$export$a368fd580c0d0fe4(b, a % b);
}
function $e19a9495965944b5$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $e19a9495965944b5$export$a368fd580c0d0fe4(a, b);
}

});




parcelRegister("eYgMC", function(module, exports) {

$parcel$export(module.exports, "getAnimationConfig", () => $ae63b016ce1bd907$export$5cc7add7ab591d0a);
$parcel$export(module.exports, "updateProps", () => $ae63b016ce1bd907$export$c8dce3c08436e91e);
$parcel$export(module.exports, "initProps", () => $ae63b016ce1bd907$export$a121566aadcfe021);
$parcel$export(module.exports, "isElementRemoved", () => $ae63b016ce1bd907$export$5b89d4b643713034);
$parcel$export(module.exports, "removeElement", () => $ae63b016ce1bd907$export$f883456a56996078);
$parcel$export(module.exports, "removeElementWithFadeOut", () => $ae63b016ce1bd907$export$6d0fd725cb4aee8a);
$parcel$export(module.exports, "saveOldStyle", () => $ae63b016ce1bd907$export$bca7290a9faf0ec9);
$parcel$export(module.exports, "getOldStyle", () => $ae63b016ce1bd907$export$ccb1f1e4d2fa86ac);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");
var $ae63b016ce1bd907$export$ae7433df314f6ec3 = (0, $eaKsF.makeInner)();
function $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, extraOpts, extraDelayParams) {
    var animationPayload; // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $bahqM.retrieve2)(extraOpts.duration, 200);
            easing = (0, $bahqM.retrieve2)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        } // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if (typeof delay === 'function') delay = delay(dataIndex, extraDelayParams);
        if (typeof duration === 'function') duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $ae63b016ce1bd907$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if (typeof dataIndex === 'function') {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $bahqM.isObject)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'remove';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('remove');
    var animationConfig = $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation(); // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props); // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $ae63b016ce1bd907$export$c8dce3c08436e91e(el, props, animatableModel, dataIndex, cb, during) {
    $ae63b016ce1bd907$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $ae63b016ce1bd907$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $ae63b016ce1bd907$var$animateOrSetProps('init', el, props, animatableModel, dataIndex, cb, during);
}
function $ae63b016ce1bd907$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'remove') return true;
    }
    return false;
}
function $ae63b016ce1bd907$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($ae63b016ce1bd907$export$5b89d4b643713034(el)) return;
    $ae63b016ce1bd907$var$animateOrSetProps('remove', el, props, animatableModel, dataIndex, cb, during);
}
function $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $ae63b016ce1bd907$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $ae63b016ce1bd907$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    } // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $ae63b016ce1bd907$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $ae63b016ce1bd907$export$bca7290a9faf0ec9(el) {
    $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $ae63b016ce1bd907$export$ccb1f1e4d2fa86ac(el) {
    return $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle;
}

});

parcelRegister("fHITF", function(module, exports) {

$parcel$export(module.exports, "extendShape", () => $b6edb2bb66445620$export$d0d5398c9d612037);
$parcel$export(module.exports, "extendPath", () => $b6edb2bb66445620$export$53b54a3137026af0);
$parcel$export(module.exports, "registerShape", () => $b6edb2bb66445620$export$2b95b62e3aaf6fdd);
$parcel$export(module.exports, "getShapeClass", () => $b6edb2bb66445620$export$51df4b5565a58189);
$parcel$export(module.exports, "makePath", () => $b6edb2bb66445620$export$aa9bab72412f5613);
$parcel$export(module.exports, "resizePath", () => $b6edb2bb66445620$export$566dbf1c62b04fc7);
$parcel$export(module.exports, "makeImage", () => $b6edb2bb66445620$export$7a2bdede98851ac5);
$parcel$export(module.exports, "mergePath", () => $b6edb2bb66445620$export$7b1dd269fbc4e903);
$parcel$export(module.exports, "subPixelOptimizeLine", () => $b6edb2bb66445620$export$8b4b620d7f4aad1b);
$parcel$export(module.exports, "subPixelOptimizeRect", () => $b6edb2bb66445620$export$60e2aa74957d0b9d);
$parcel$export(module.exports, "subPixelOptimize", () => $b6edb2bb66445620$export$72c4fd4c1b8fcb10);
$parcel$export(module.exports, "getTransform", () => $b6edb2bb66445620$export$fce0c6cfca85ed96);
$parcel$export(module.exports, "applyTransform", () => $b6edb2bb66445620$export$9f9dcb98c894b623);
$parcel$export(module.exports, "transformDirection", () => $b6edb2bb66445620$export$fff94e9792354cfa);
$parcel$export(module.exports, "groupTransition", () => $b6edb2bb66445620$export$64fcab7860c216ae);
$parcel$export(module.exports, "clipPointsByRect", () => $b6edb2bb66445620$export$e2f409471bbbc1dc);
$parcel$export(module.exports, "clipRectByRect", () => $b6edb2bb66445620$export$d0d3709202b8b2a);
$parcel$export(module.exports, "createIcon", () => $b6edb2bb66445620$export$274edc73af1ae9c8);
$parcel$export(module.exports, "linePolygonIntersect", () => $b6edb2bb66445620$export$4f47c855a5e9ae9);
$parcel$export(module.exports, "lineLineIntersect", () => $b6edb2bb66445620$export$6c0a70ea1d8d158b);
$parcel$export(module.exports, "setTooltipConfig", () => $b6edb2bb66445620$export$fc6410d97fab306c);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("eYgMC")).updateProps);
$parcel$export(module.exports, "initProps", () => (parcelRequire("eYgMC")).initProps);
$parcel$export(module.exports, "removeElement", () => (parcelRequire("eYgMC")).removeElement);
$parcel$export(module.exports, "removeElementWithFadeOut", () => (parcelRequire("eYgMC")).removeElementWithFadeOut);
$parcel$export(module.exports, "isElementRemoved", () => (parcelRequire("eYgMC")).isElementRemoved);
$parcel$export(module.exports, "Group", () => (parcelRequire("4KVOr")).default);
$parcel$export(module.exports, "Image", () => (parcelRequire("gcbBH")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("4gEFv")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("jjfok")).default);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("kVeV8")).default);
$parcel$export(module.exports, "Sector", () => (parcelRequire("elGBV")).default);
$parcel$export(module.exports, "Ring", () => (parcelRequire("LCHOw")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("lQwBc")).default);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("32bXc")).default);
$parcel$export(module.exports, "Rect", () => (parcelRequire("7Tw7u")).default);
$parcel$export(module.exports, "Line", () => (parcelRequire("cZb1F")).default);
$parcel$export(module.exports, "BezierCurve", () => (parcelRequire("04gw0")).default);
$parcel$export(module.exports, "Arc", () => (parcelRequire("ixXaU")).default);
$parcel$export(module.exports, "IncrementalDisplayable", () => (parcelRequire("6sllV")).default);
$parcel$export(module.exports, "CompoundPath", () => (parcelRequire("eGltS")).default);
$parcel$export(module.exports, "LinearGradient", () => (parcelRequire("9J7f8")).default);
$parcel$export(module.exports, "RadialGradient", () => (parcelRequire("faICo")).default);
$parcel$export(module.exports, "BoundingRect", () => (parcelRequire("1E3E8")).default);
$parcel$export(module.exports, "OrientedBoundingRect", () => (parcelRequire("lM5Gp")).default);
$parcel$export(module.exports, "Point", () => (parcelRequire("bMDnR")).default);
$parcel$export(module.exports, "Path", () => (parcelRequire("ghQ8v")).default);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $id1Rd = parcelRequire("id1Rd");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");

var $ghQ8v = parcelRequire("ghQ8v");

var $e6gef = parcelRequire("e6gef");

var $gcbBH = parcelRequire("gcbBH");

var $4KVOr = parcelRequire("4KVOr");

var $4gEFv = parcelRequire("4gEFv");

var $jjfok = parcelRequire("jjfok");

var $kVeV8 = parcelRequire("kVeV8");

var $elGBV = parcelRequire("elGBV");

var $LCHOw = parcelRequire("LCHOw");

var $lQwBc = parcelRequire("lQwBc");

var $32bXc = parcelRequire("32bXc");

var $7Tw7u = parcelRequire("7Tw7u");

var $cZb1F = parcelRequire("cZb1F");

var $04gw0 = parcelRequire("04gw0");

var $ixXaU = parcelRequire("ixXaU");

var $eGltS = parcelRequire("eGltS");

var $9J7f8 = parcelRequire("9J7f8");

var $faICo = parcelRequire("faICo");

var $1E3E8 = parcelRequire("1E3E8");

var $lM5Gp = parcelRequire("lM5Gp");

var $bMDnR = parcelRequire("bMDnR");

var $6sllV = parcelRequire("6sllV");

var $2az2p = parcelRequire("2az2p");

var $bahqM = parcelRequire("bahqM");

var $7QjoM = parcelRequire("7QjoM");

var $eYgMC = parcelRequire("eYgMC");
var $b6edb2bb66445620$var$mathMax = Math.max;
var $b6edb2bb66445620$var$mathMin = Math.min;
var $b6edb2bb66445620$var$_customShapeMap = {};
function $b6edb2bb66445620$export$d0d5398c9d612037(opts) {
    return (0, $ghQ8v.default).extend(opts);
}
var $b6edb2bb66445620$var$extendPathFromString = $id1Rd.extendFromString;
function $b6edb2bb66445620$export$53b54a3137026af0(pathData, opts) {
    return $b6edb2bb66445620$var$extendPathFromString(pathData, opts);
}
function $b6edb2bb66445620$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $b6edb2bb66445620$var$_customShapeMap[name] = ShapeClass;
}
function $b6edb2bb66445620$export$51df4b5565a58189(name) {
    if ($b6edb2bb66445620$var$_customShapeMap.hasOwnProperty(name)) return $b6edb2bb66445620$var$_customShapeMap[name];
}
function $b6edb2bb66445620$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $id1Rd.createFromString(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $b6edb2bb66445620$var$centerGraphic(rect, path.getBoundingRect());
        $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $b6edb2bb66445620$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $gcbBH.default)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($b6edb2bb66445620$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $b6edb2bb66445620$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $b6edb2bb66445620$export$7b1dd269fbc4e903 = $id1Rd.mergePath;
function $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $b6edb2bb66445620$export$8b4b620d7f4aad1b(param) {
    $2az2p.subPixelOptimizeLine(param.shape, param.shape, param.style);
    return param;
}
function $b6edb2bb66445620$export$60e2aa74957d0b9d(param) {
    $2az2p.subPixelOptimizeRect(param.shape, param.shape, param.style);
    return param;
}
var $b6edb2bb66445620$export$72c4fd4c1b8fcb10 = $2az2p.subPixelOptimize;
function $b6edb2bb66445620$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $izqgC.identity([]);
    while(target && target !== ancestor){
        $izqgC.mul(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $b6edb2bb66445620$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $bahqM.isArrayLike)(transform)) transform = (0, $e6gef.default).getLocalTransform(transform);
    if (invert) transform = $izqgC.invert([], transform);
    return $eLEew.applyTransform([], target, transform);
}
function $b6edb2bb66445620$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $b6edb2bb66445620$export$9f9dcb98c894b623(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $b6edb2bb66445620$var$isNotGroup(el) {
    return !el.isGroup;
}
function $b6edb2bb66445620$var$isPath(el) {
    return el.shape != null;
}
function $b6edb2bb66445620$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($b6edb2bb66445620$var$isPath(el)) obj.shape = (0, $bahqM.extend)({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $eYgMC.updateProps)(el, newProp, animatableModel, (0, $7QjoM.getECData)(el).dataIndex);
            }
        }
    });
}
function $b6edb2bb66445620$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: this way migth be incorrect when grpahic clipped by a corner.
    // and when element have border.
    return (0, $bahqM.map)(points, function(point) {
        var x = point[0];
        x = $b6edb2bb66445620$var$mathMax(x, rect.x);
        x = $b6edb2bb66445620$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $b6edb2bb66445620$var$mathMax(y, rect.y);
        y = $b6edb2bb66445620$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $b6edb2bb66445620$export$d0d3709202b8b2a(targetRect, rect) {
    var x = $b6edb2bb66445620$var$mathMax(targetRect.x, rect.x);
    var x2 = $b6edb2bb66445620$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $b6edb2bb66445620$var$mathMax(targetRect.y, rect.y);
    var y2 = $b6edb2bb66445620$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $b6edb2bb66445620$export$274edc73af1ae9c8(iconStr, opt, rect) {
    var innerOpts = (0, $bahqM.extend)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $bahqM.defaults)(style, rect), new (0, $gcbBH.default)(innerOpts)) : $b6edb2bb66445620$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $b6edb2bb66445620$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
    //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $b6edb2bb66445620$var$crossProduct2d(nx, ny, mx, my);
    if ($b6edb2bb66445620$var$nearZero(nmCrossProduct)) return false;
     // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $b6edb2bb66445620$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $b6edb2bb66445620$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $b6edb2bb66445620$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $bahqM.isString)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $bahqM.each)((0, $bahqM.keys)(formatterParamsExtra), function(key) {
        if (!(0, $bahqM.hasOwn)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $7QjoM.getECData)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $bahqM.defaults)({
            content: itemName,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
} // Register built-in shapes. These shapes might be overwirtten
// by users, although we do not recommend that.
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('circle', (0, $jjfok.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('ellipse', (0, $kVeV8.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('sector', (0, $elGBV.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('ring', (0, $LCHOw.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('polygon', (0, $lQwBc.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('polyline', (0, $32bXc.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('rect', (0, $7Tw7u.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('line', (0, $cZb1F.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('bezierCurve', (0, $04gw0.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('arc', (0, $ixXaU.default));

});
parcelRegister("id1Rd", function(module, exports) {

$parcel$export(module.exports, "createFromString", () => $d41ae1bdee61ce18$export$ae5b259626f00aeb);
$parcel$export(module.exports, "extendFromString", () => $d41ae1bdee61ce18$export$68e3a51ba2ed417c);
$parcel$export(module.exports, "mergePath", () => $d41ae1bdee61ce18$export$7b1dd269fbc4e903);
$parcel$export(module.exports, "clonePath", () => $d41ae1bdee61ce18$export$18711d956bf1c3eb);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $aA4Ws = parcelRequire("aA4Ws");

var $cTDbe = parcelRequire("cTDbe");

var $bahqM = parcelRequire("bahqM");
var $d41ae1bdee61ce18$var$mathSqrt = Math.sqrt;
var $d41ae1bdee61ce18$var$mathSin = Math.sin;
var $d41ae1bdee61ce18$var$mathCos = Math.cos;
var $d41ae1bdee61ce18$var$PI = Math.PI;
function $d41ae1bdee61ce18$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $d41ae1bdee61ce18$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($d41ae1bdee61ce18$var$vMag(u) * $d41ae1bdee61ce18$var$vMag(v));
}
function $d41ae1bdee61ce18$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($d41ae1bdee61ce18$var$vRatio(u, v));
}
function $d41ae1bdee61ce18$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($d41ae1bdee61ce18$var$PI / 180.0);
    var xp = $d41ae1bdee61ce18$var$mathCos(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $d41ae1bdee61ce18$var$mathSin(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
        ry *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $d41ae1bdee61ce18$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * cxp - $d41ae1bdee61ce18$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * cxp + $d41ae1bdee61ce18$var$mathCos(psi) * cyp;
    var theta = $d41ae1bdee61ce18$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $d41ae1bdee61ce18$var$vAngle(u, v);
    if ($d41ae1bdee61ce18$var$vRatio(u, v) <= -1) dTheta = $d41ae1bdee61ce18$var$PI;
    if ($d41ae1bdee61ce18$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $d41ae1bdee61ce18$var$PI * 1e6) / 1e6;
        dTheta = $d41ae1bdee61ce18$var$PI * 2 + n % 2 * $d41ae1bdee61ce18$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $d41ae1bdee61ce18$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $d41ae1bdee61ce18$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $d41ae1bdee61ce18$var$createPathProxyFromString(data) {
    var path = new (0, $aA4Ws.default)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $aA4Ws.default).CMD;
    var cmdList = data.match($d41ae1bdee61ce18$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($d41ae1bdee61ce18$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $d41ae1bdee61ce18$var$SVGPath = function(_super) {
    (0, $3VFsf.__extends)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $ghQ8v.default));
function $d41ae1bdee61ce18$var$isPathProxy(path) {
    return path.setData != null;
}
function $d41ae1bdee61ce18$var$createPathOptions(str, opts) {
    var pathProxy = $d41ae1bdee61ce18$var$createPathProxyFromString(str);
    var innerOpts = (0, $bahqM.extend)({}, opts);
    innerOpts.buildPath = function(path) {
        if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $cTDbe.default)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $d41ae1bdee61ce18$export$ae5b259626f00aeb(str, opts) {
    return new $d41ae1bdee61ce18$var$SVGPath($d41ae1bdee61ce18$var$createPathOptions(str, opts));
}
function $d41ae1bdee61ce18$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $d41ae1bdee61ce18$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $3VFsf.__extends)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($d41ae1bdee61ce18$var$SVGPath);
    return Sub;
}
function $d41ae1bdee61ce18$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $ghQ8v.default)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $d41ae1bdee61ce18$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $ghQ8v.default)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $cTDbe.default)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}

});
parcelRegister("cTDbe", function(module, exports) {

$parcel$export(module.exports, "default", () => $96390378868b6806$export$2e2bcd8739ae039);

var $aA4Ws = parcelRequire("aA4Ws");

var $eLEew = parcelRequire("eLEew");
var $96390378868b6806$var$CMD = (0, $aA4Ws.default).CMD;
var $96390378868b6806$var$points = [
    [],
    [],
    []
];
var $96390378868b6806$var$mathSqrt = Math.sqrt;
var $96390378868b6806$var$mathAtan2 = Math.atan2;
function $96390378868b6806$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $96390378868b6806$var$CMD.M;
    var C = $96390378868b6806$var$CMD.C;
    var L = $96390378868b6806$var$CMD.L;
    var R = $96390378868b6806$var$CMD.R;
    var A = $96390378868b6806$var$CMD.A;
    var Q = $96390378868b6806$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $96390378868b6806$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $96390378868b6806$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $96390378868b6806$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $eLEew.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $eLEew.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $96390378868b6806$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $eLEew.applyTransform)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}

});


parcelRegister("4KVOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $37684daaaf15bf3f$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $7KVc5 = parcelRequire("7KVc5");

var $1E3E8 = parcelRequire("1E3E8");
var $37684daaaf15bf3f$var$Group = function(_super) {
    (0, $3VFsf.__extends)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
            if (child.__hostTarget) throw 'This elemenet has been used as an attachment';
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $bahqM.indexOf(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $bahqM.indexOf(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $1E3E8.default)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $1E3E8.default).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $7KVc5.default));
$37684daaaf15bf3f$var$Group.prototype.type = 'group';
var $37684daaaf15bf3f$export$2e2bcd8739ae039 = $37684daaaf15bf3f$var$Group;

});

parcelRegister("jjfok", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ebbb12e4687e45$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $e0ebbb12e4687e45$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $e0ebbb12e4687e45$var$Circle = function(_super) {
    (0, $3VFsf.__extends)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $e0ebbb12e4687e45$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape, inBundle) {
        if (inBundle) ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $ghQ8v.default));
$e0ebbb12e4687e45$var$Circle.prototype.type = 'circle';
var $e0ebbb12e4687e45$export$2e2bcd8739ae039 = $e0ebbb12e4687e45$var$Circle;

});

parcelRegister("kVeV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b4b46f050115c8$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $f3b4b46f050115c8$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $f3b4b46f050115c8$var$Ellipse = function(_super) {
    (0, $3VFsf.__extends)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $f3b4b46f050115c8$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $ghQ8v.default));
$f3b4b46f050115c8$var$Ellipse.prototype.type = 'ellipse';
var $f3b4b46f050115c8$export$2e2bcd8739ae039 = $f3b4b46f050115c8$var$Ellipse;

});

parcelRegister("elGBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a724147a13426864$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $3kXtf = parcelRequire("3kXtf");
var $a724147a13426864$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
        this.innerCornerRadius = 0;
    }
    return SectorShape;
}();
var $a724147a13426864$var$Sector = function(_super) {
    (0, $3VFsf.__extends)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $a724147a13426864$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $3kXtf.buildPath(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $ghQ8v.default));
$a724147a13426864$var$Sector.prototype.type = 'sector';
var $a724147a13426864$export$2e2bcd8739ae039 = $a724147a13426864$var$Sector;

});
parcelRegister("3kXtf", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $26e15f024d5166f6$export$5cc7f731b5937e99);

var $aA4Ws = parcelRequire("aA4Ws");
var $26e15f024d5166f6$var$PI = Math.PI;
var $26e15f024d5166f6$var$PI2 = $26e15f024d5166f6$var$PI * 2;
var $26e15f024d5166f6$var$mathSin = Math.sin;
var $26e15f024d5166f6$var$mathCos = Math.cos;
var $26e15f024d5166f6$var$mathACos = Math.acos;
var $26e15f024d5166f6$var$mathATan2 = Math.atan2;
var $26e15f024d5166f6$var$mathAbs = Math.abs;
var $26e15f024d5166f6$var$mathSqrt = Math.sqrt;
var $26e15f024d5166f6$var$mathMax = Math.max;
var $26e15f024d5166f6$var$mathMin = Math.min;
var $26e15f024d5166f6$var$e = 1e-4;
function $26e15f024d5166f6$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0;
    var y10 = y1 - y0;
    var x32 = x3 - x2;
    var y32 = y3 - y2;
    var t = y32 * x10 - x32 * y10;
    if (t * t < $26e15f024d5166f6$var$e) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
function $26e15f024d5166f6$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $26e15f024d5166f6$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $26e15f024d5166f6$var$mathSqrt($26e15f024d5166f6$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (radius / r - 1),
        y11: cy0 * (radius / r - 1)
    };
}
function $26e15f024d5166f6$export$5cc7f731b5937e99(ctx, shape) {
    var radius = $26e15f024d5166f6$var$mathMax(shape.r, 0);
    var innerRadius = $26e15f024d5166f6$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var clockwise = !!shape.clockwise;
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var arc;
    if (startAngle === endAngle) arc = 0;
    else {
        var tmpAngles = [
            startAngle,
            endAngle
        ];
        (0, $aA4Ws.normalizeArcAngles)(tmpAngles, !clockwise);
        arc = $26e15f024d5166f6$var$mathAbs(tmpAngles[0] - tmpAngles[1]);
    }
    var x = shape.cx;
    var y = shape.cy;
    var cornerRadius = shape.cornerRadius || 0;
    var innerCornerRadius = shape.innerCornerRadius || 0;
    if (!(radius > $26e15f024d5166f6$var$e)) ctx.moveTo(x, y);
    else if (arc > $26e15f024d5166f6$var$PI2 - $26e15f024d5166f6$var$e) {
        ctx.moveTo(x + radius * $26e15f024d5166f6$var$mathCos(startAngle), y + radius * $26e15f024d5166f6$var$mathSin(startAngle));
        ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $26e15f024d5166f6$var$e) {
            ctx.moveTo(x + innerRadius * $26e15f024d5166f6$var$mathCos(endAngle), y + innerRadius * $26e15f024d5166f6$var$mathSin(endAngle));
            ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var halfRd = $26e15f024d5166f6$var$mathAbs(radius - innerRadius) / 2;
        var cr = $26e15f024d5166f6$var$mathMin(halfRd, cornerRadius);
        var icr = $26e15f024d5166f6$var$mathMin(halfRd, innerCornerRadius);
        var cr0 = icr;
        var cr1 = cr;
        var xrs = radius * $26e15f024d5166f6$var$mathCos(startAngle);
        var yrs = radius * $26e15f024d5166f6$var$mathSin(startAngle);
        var xire = innerRadius * $26e15f024d5166f6$var$mathCos(endAngle);
        var yire = innerRadius * $26e15f024d5166f6$var$mathSin(endAngle);
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        if (cr > $26e15f024d5166f6$var$e || icr > $26e15f024d5166f6$var$e) {
            xre = radius * $26e15f024d5166f6$var$mathCos(endAngle);
            yre = radius * $26e15f024d5166f6$var$mathSin(endAngle);
            xirs = innerRadius * $26e15f024d5166f6$var$mathCos(startAngle);
            yirs = innerRadius * $26e15f024d5166f6$var$mathSin(startAngle);
            if (arc < $26e15f024d5166f6$var$PI) {
                var it_1 = $26e15f024d5166f6$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                if (it_1) {
                    var x0 = xrs - it_1[0];
                    var y0 = yrs - it_1[1];
                    var x1 = xre - it_1[0];
                    var y1 = yre - it_1[1];
                    var a = 1 / $26e15f024d5166f6$var$mathSin($26e15f024d5166f6$var$mathACos((x0 * x1 + y0 * y1) / ($26e15f024d5166f6$var$mathSqrt(x0 * x0 + y0 * y0) * $26e15f024d5166f6$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                    var b = $26e15f024d5166f6$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                    cr0 = $26e15f024d5166f6$var$mathMin(icr, (innerRadius - b) / (a - 1));
                    cr1 = $26e15f024d5166f6$var$mathMin(cr, (radius - b) / (a + 1));
                }
            }
        }
        if (!(arc > $26e15f024d5166f6$var$e)) ctx.moveTo(x + xrs, y + yrs);
        else if (cr1 > $26e15f024d5166f6$var$e) {
            var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, cr1, clockwise);
            var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xre, yre, xire, yire, radius, cr1, clockwise);
            ctx.moveTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
            if (cr1 < cr) ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            else {
                ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                ctx.arc(x, y, radius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), !clockwise);
                ctx.arc(x + ct1.cx, y + ct1.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            }
        } else {
            ctx.moveTo(x + xrs, y + yrs);
            ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $26e15f024d5166f6$var$e) || !(arc > $26e15f024d5166f6$var$e)) ctx.lineTo(x + xire, y + yire);
        else if (cr0 > $26e15f024d5166f6$var$e) {
            var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -cr0, clockwise);
            var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -cr0, clockwise);
            ctx.lineTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
            if (cr0 < icr) ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            else {
                ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                ctx.arc(x, y, innerRadius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), clockwise);
                ctx.arc(x + ct1.cx, y + ct1.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            }
        } else {
            ctx.lineTo(x + xire, y + yire);
            ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}

});


parcelRegister("LCHOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $08f26a0aa2f0a2fd$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $08f26a0aa2f0a2fd$var$Ring = function(_super) {
    (0, $3VFsf.__extends)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $ghQ8v.default));
$08f26a0aa2f0a2fd$var$Ring.prototype.type = 'ring';
var $08f26a0aa2f0a2fd$export$2e2bcd8739ae039 = $08f26a0aa2f0a2fd$var$Ring;

});

parcelRegister("lQwBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe77bdccf816487a$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $gLMXf = parcelRequire("gLMXf");
var $fe77bdccf816487a$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $fe77bdccf816487a$var$Polygon = function(_super) {
    (0, $3VFsf.__extends)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $fe77bdccf816487a$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $gLMXf.buildPath(ctx, shape, true);
    };
    return Polygon;
}((0, $ghQ8v.default));
$fe77bdccf816487a$var$Polygon.prototype.type = 'polygon';
var $fe77bdccf816487a$export$2e2bcd8739ae039 = $fe77bdccf816487a$var$Polygon;

});
parcelRegister("gLMXf", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $c357027dbb0e6a00$export$5cc7f731b5937e99);

var $bEkQR = parcelRequire("bEkQR");

var $4Fmqi = parcelRequire("4Fmqi");
function $c357027dbb0e6a00$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth && smooth !== 'spline') {
            var controlPoints = (0, $4Fmqi.default)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            if (smooth === 'spline') points = (0, $bEkQR.default)(points, closePath);
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}

});
parcelRegister("bEkQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b39ad613612da7$export$2e2bcd8739ae039);

var $eLEew = parcelRequire("eLEew");
function $87b39ad613612da7$var$interpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $87b39ad613612da7$export$2e2bcd8739ae039(points, isLoop) {
    var len = points.length;
    var ret = [];
    var distance = 0;
    for(var i = 1; i < len; i++)distance += (0, $eLEew.distance)(points[i - 1], points[i]);
    var segs = distance / 2;
    segs = segs < len ? len : segs;
    for(var i = 0; i < segs; i++){
        var pos = i / (segs - 1) * (isLoop ? len : len - 1);
        var idx = Math.floor(pos);
        var w = pos - idx;
        var p0 = void 0;
        var p1 = points[idx % len];
        var p2 = void 0;
        var p3 = void 0;
        if (!isLoop) {
            p0 = points[idx === 0 ? idx : idx - 1];
            p2 = points[idx > len - 2 ? len - 1 : idx + 1];
            p3 = points[idx > len - 3 ? len - 1 : idx + 2];
        } else {
            p0 = points[(idx - 1 + len) % len];
            p2 = points[(idx + 1) % len];
            p3 = points[(idx + 2) % len];
        }
        var w2 = w * w;
        var w3 = w * w2;
        ret.push([
            $87b39ad613612da7$var$interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3),
            $87b39ad613612da7$var$interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)
        ]);
    }
    return ret;
}

});

parcelRegister("4Fmqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $365c6287f8cf6aea$export$2e2bcd8739ae039);

var $eLEew = parcelRequire("eLEew");
function $365c6287f8cf6aea$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $eLEew.min)(min, min, points[i]);
            (0, $eLEew.max)(max, max, points[i]);
        }
        (0, $eLEew.min)(min, min, constraint[0]);
        (0, $eLEew.max)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $eLEew.clone)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $eLEew.sub)(v, nextPoint, prevPoint);
        (0, $eLEew.scale)(v, v, smooth);
        var d0 = (0, $eLEew.distance)(point, prevPoint);
        var d1 = (0, $eLEew.distance)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $eLEew.scale)(v1, v, -d0);
        (0, $eLEew.scale)(v2, v, d1);
        var cp0 = (0, $eLEew.add)([], point, v1);
        var cp1 = (0, $eLEew.add)([], point, v2);
        if (constraint) {
            (0, $eLEew.max)(cp0, cp0, min);
            (0, $eLEew.min)(cp0, cp0, max);
            (0, $eLEew.max)(cp1, cp1, min);
            (0, $eLEew.min)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}

});



parcelRegister("32bXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $235ad4ce0d26a4ed$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $gLMXf = parcelRequire("gLMXf");
var $235ad4ce0d26a4ed$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $235ad4ce0d26a4ed$var$Polyline = function(_super) {
    (0, $3VFsf.__extends)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $235ad4ce0d26a4ed$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $gLMXf.buildPath(ctx, shape, false);
    };
    return Polyline;
}((0, $ghQ8v.default));
$235ad4ce0d26a4ed$var$Polyline.prototype.type = 'polyline';
var $235ad4ce0d26a4ed$export$2e2bcd8739ae039 = $235ad4ce0d26a4ed$var$Polyline;

});

parcelRegister("cZb1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9743bc0ad02b6789$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $2az2p = parcelRequire("2az2p");
var $9743bc0ad02b6789$var$subPixelOptimizeOutputShape = {};
var $9743bc0ad02b6789$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $9743bc0ad02b6789$var$Line = function(_super) {
    (0, $3VFsf.__extends)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $9743bc0ad02b6789$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $2az2p.subPixelOptimizeLine)($9743bc0ad02b6789$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $ghQ8v.default));
$9743bc0ad02b6789$var$Line.prototype.type = 'line';
var $9743bc0ad02b6789$export$2e2bcd8739ae039 = $9743bc0ad02b6789$var$Line;

});

parcelRegister("04gw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $00cd2f675f351e5a$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $eLEew = parcelRequire("eLEew");

var $dr1jo = parcelRequire("dr1jo");
var $00cd2f675f351e5a$var$out = [];
var $00cd2f675f351e5a$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $00cd2f675f351e5a$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 === null || cpy2 === null) return [
        (isTangent ? (0, $dr1jo.cubicDerivativeAt) : (0, $dr1jo.cubicAt))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $dr1jo.cubicDerivativeAt) : (0, $dr1jo.cubicAt))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $dr1jo.quadraticDerivativeAt) : (0, $dr1jo.quadraticAt))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $dr1jo.quadraticDerivativeAt) : (0, $dr1jo.quadraticAt))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $00cd2f675f351e5a$var$BezierCurve = function(_super) {
    (0, $3VFsf.__extends)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $00cd2f675f351e5a$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $dr1jo.quadraticSubdivide)(x1, cpx1, x2, percent, $00cd2f675f351e5a$var$out);
                cpx1 = $00cd2f675f351e5a$var$out[1];
                x2 = $00cd2f675f351e5a$var$out[2];
                (0, $dr1jo.quadraticSubdivide)(y1, cpy1, y2, percent, $00cd2f675f351e5a$var$out);
                cpy1 = $00cd2f675f351e5a$var$out[1];
                y2 = $00cd2f675f351e5a$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $dr1jo.cubicSubdivide)(x1, cpx1, cpx2, x2, percent, $00cd2f675f351e5a$var$out);
                cpx1 = $00cd2f675f351e5a$var$out[1];
                cpx2 = $00cd2f675f351e5a$var$out[2];
                x2 = $00cd2f675f351e5a$var$out[3];
                (0, $dr1jo.cubicSubdivide)(y1, cpy1, cpy2, y2, percent, $00cd2f675f351e5a$var$out);
                cpy1 = $00cd2f675f351e5a$var$out[1];
                cpy2 = $00cd2f675f351e5a$var$out[2];
                y2 = $00cd2f675f351e5a$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $00cd2f675f351e5a$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $00cd2f675f351e5a$var$someVectorAt(this.shape, t, true);
        return $eLEew.normalize(p, p);
    };
    return BezierCurve;
}((0, $ghQ8v.default));
$00cd2f675f351e5a$var$BezierCurve.prototype.type = 'bezier-curve';
var $00cd2f675f351e5a$export$2e2bcd8739ae039 = $00cd2f675f351e5a$var$BezierCurve;

});

parcelRegister("ixXaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80935fda1e22f1c$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $d80935fda1e22f1c$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $d80935fda1e22f1c$var$Arc = function(_super) {
    (0, $3VFsf.__extends)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $d80935fda1e22f1c$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $ghQ8v.default));
$d80935fda1e22f1c$var$Arc.prototype.type = 'arc';
var $d80935fda1e22f1c$export$2e2bcd8739ae039 = $d80935fda1e22f1c$var$Arc;

});

parcelRegister("eGltS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab05a69c83088c4b$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $ab05a69c83088c4b$var$CompoundPath = function(_super) {
    (0, $3VFsf.__extends)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $ghQ8v.default).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $ghQ8v.default));
var $ab05a69c83088c4b$export$2e2bcd8739ae039 = $ab05a69c83088c4b$var$CompoundPath;

});

parcelRegister("9J7f8", function(module, exports) {

$parcel$export(module.exports, "default", () => $714def5c08e9d5ff$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $jnhEE = parcelRequire("jnhEE");
var $714def5c08e9d5ff$var$LinearGradient = function(_super) {
    (0, $3VFsf.__extends)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $jnhEE.default));
var $714def5c08e9d5ff$export$2e2bcd8739ae039 = $714def5c08e9d5ff$var$LinearGradient;

});
parcelRegister("jnhEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1addc27dbc63739$export$2e2bcd8739ae039);
var $e1addc27dbc63739$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $e1addc27dbc63739$export$2e2bcd8739ae039 = $e1addc27dbc63739$var$Gradient;

});


parcelRegister("faICo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ba666d3a488180$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $jnhEE = parcelRequire("jnhEE");
var $b0ba666d3a488180$var$RadialGradient = function(_super) {
    (0, $3VFsf.__extends)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $jnhEE.default));
var $b0ba666d3a488180$export$2e2bcd8739ae039 = $b0ba666d3a488180$var$RadialGradient;

});

parcelRegister("lM5Gp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda27d30e90880c7$export$2e2bcd8739ae039);

var $bMDnR = parcelRequire("bMDnR");
var $fda27d30e90880c7$var$extent = [
    0,
    0
];
var $fda27d30e90880c7$var$extent2 = [
    0,
    0
];
var $fda27d30e90880c7$var$minTv = new (0, $bMDnR.default)();
var $fda27d30e90880c7$var$maxTv = new (0, $bMDnR.default)();
var $fda27d30e90880c7$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $bMDnR.default)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $bMDnR.default)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $bMDnR.default).sub(axes[0], corners[1], corners[0]);
        (0, $bMDnR.default).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        $fda27d30e90880c7$var$minTv.set(Infinity, Infinity);
        $fda27d30e90880c7$var$maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv) (0, $bMDnR.default).copy(mtv, overlapped ? $fda27d30e90880c7$var$minTv : $fda27d30e90880c7$var$maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, $fda27d30e90880c7$var$extent);
            this._getProjMinMaxOnAxis(i, other._corners, $fda27d30e90880c7$var$extent2);
            if ($fda27d30e90880c7$var$extent[1] < $fda27d30e90880c7$var$extent2[0] || $fda27d30e90880c7$var$extent[0] > $fda27d30e90880c7$var$extent2[1]) {
                overlapped = false;
                if (noMtv) return overlapped;
                var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) (0, $bMDnR.default).scale(maxTv, axis, -dist0 * inverse);
                    else (0, $bMDnR.default).scale(maxTv, axis, dist1 * inverse);
                }
            } else if (minTv) {
                var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) (0, $bMDnR.default).scale(minTv, axis, dist0 * inverse);
                    else (0, $bMDnR.default).scale(minTv, axis, -dist1 * inverse);
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}();
var $fda27d30e90880c7$export$2e2bcd8739ae039 = $fda27d30e90880c7$var$OrientedBoundingRect;

});

parcelRegister("6sllV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b35ebcb0b796fce$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $lBQ88 = parcelRequire("lBQ88");

var $1E3E8 = parcelRequire("1E3E8");
var $4b35ebcb0b796fce$var$m = [];
var $4b35ebcb0b796fce$var$IncrementalDisplayable = function(_super) {
    (0, $3VFsf.__extends)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $1E3E8.default)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($4b35ebcb0b796fce$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $lBQ88.default));
var $4b35ebcb0b796fce$export$2e2bcd8739ae039 = $4b35ebcb0b796fce$var$IncrementalDisplayable;

});




parcelRegister("46U6E", function(module, exports) {

$parcel$export(module.exports, "LINE_STYLE_KEY_MAP", () => $2fe33e7a8dd518cd$export$9f34de5b59222949);
$parcel$export(module.exports, "LineStyleMixin", () => $2fe33e7a8dd518cd$export$91eeeeed4a69a7e7);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1BJbl = parcelRequire("1BJbl");
var $2fe33e7a8dd518cd$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $2fe33e7a8dd518cd$var$getLineStyle = (0, $1BJbl.default)($2fe33e7a8dd518cd$export$9f34de5b59222949);
var $2fe33e7a8dd518cd$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $2fe33e7a8dd518cd$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();

});

parcelRegister("4rldO", function(module, exports) {

$parcel$export(module.exports, "ITEM_STYLE_KEY_MAP", () => $33ba2539bbc4d618$export$ffb0bba5dde0130b);
$parcel$export(module.exports, "ItemStyleMixin", () => $33ba2539bbc4d618$export$e4f01e48d6fda412);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1BJbl = parcelRequire("1BJbl");
var $33ba2539bbc4d618$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $33ba2539bbc4d618$var$getItemStyle = (0, $1BJbl.default)($33ba2539bbc4d618$export$ffb0bba5dde0130b);
var $33ba2539bbc4d618$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $33ba2539bbc4d618$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();

});


parcelRegister("4wWkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c7649bb9fc460b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $34c7649bb9fc460b$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $34c7649bb9fc460b$var$defaultKeyGetter(item) {
    return item;
}
var $34c7649bb9fc460b$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter; // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal); // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
             // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, map, // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $34c7649bb9fc460b$export$2e2bcd8739ae039 = $34c7649bb9fc460b$var$DataDiffer;

});

parcelRegister("9OHWG", function(module, exports) {

$parcel$export(module.exports, "DefaultDataProvider", () => $725adf3ea01375e6$export$b900d7c4c3952a40);
$parcel$export(module.exports, "getRawSourceItemGetter", () => $725adf3ea01375e6$export$92c8ea8642b3957d);
$parcel$export(module.exports, "getRawSourceDataCounter", () => $725adf3ea01375e6$export$803742e832f4b52c);
$parcel$export(module.exports, "getRawSourceValueGetter", () => $725adf3ea01375e6$export$1752de8084789a14);
$parcel$export(module.exports, "retrieveRawValue", () => $725adf3ea01375e6$export$cde9373da9aad801);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $20liu = parcelRequire("20liu");

var $2Rbm1 = parcelRequire("2Rbm1");
var $725adf3ea01375e6$var$_a, $725adf3ea01375e6$var$_b, $725adf3ea01375e6$var$_c; // TODO
var $725adf3ea01375e6$var$providerMethods;
var $725adf3ea01375e6$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $725adf3ea01375e6$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $20liu.isSourceInstance)(sourceParam) ? (0, $20liu.createSourceFromSeriesDataOption)(sourceParam) : sourceParam; // declare source is Source;
        this._source = source;
        var data = this._data = source.data; // Typed array. TODO IE10+?
        if (source.sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        $725adf3ea01375e6$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $725adf3ea01375e6$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $725adf3ea01375e6$var$providerMethods[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $bahqM.extend)(provider, methods);
            if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $bahqM.bind)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $bahqM.bind)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $725adf3ea01375e6$var$providerMethods = (_a = {}, _a[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $bahqM.each)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $2Rbm1.SOURCE_FORMAT_ORIGINAL] = {
            appendData: appendDataSimply
        }, _a[0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $725adf3ea01375e6$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $725adf3ea01375e6$var$rawSourceItemGetterMap = ($725adf3ea01375e6$var$_a = {}, $725adf3ea01375e6$var$_a[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $725adf3ea01375e6$var$_a[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $725adf3ea01375e6$var$_a[0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a[0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = rawData[dimName];
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $725adf3ea01375e6$var$_a[0, $2Rbm1.SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a);
function $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $725adf3ea01375e6$var$rawSourceItemGetterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $725adf3ea01375e6$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $725adf3ea01375e6$var$rawSourceDataCounterMap = ($725adf3ea01375e6$var$_b = {}, $725adf3ea01375e6$var$_b[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $725adf3ea01375e6$var$_b[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $725adf3ea01375e6$var$_b[0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b[0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = rawData[dimName];
    return col ? col.length : 0;
}, $725adf3ea01375e6$var$_b[0, $2Rbm1.SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b);
function $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $725adf3ea01375e6$var$rawSourceDataCounterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $725adf3ea01375e6$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $725adf3ea01375e6$var$rawSourceValueGetterMap = ($725adf3ea01375e6$var$_c = {}, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_ORIGINAL] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $eaKsF.getDataItemValue)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c);
function $725adf3ea01375e6$export$1752de8084789a14(sourceFormat) {
    var method = $725adf3ea01375e6$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
function $725adf3ea01375e6$export$cde9373da9aad801(data, dataIndex, // Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
     // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $725adf3ea01375e6$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)) result = (0, $eaKsF.getDataItemValue)(dataItem);
        return result;
    }
}
function $725adf3ea01375e6$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL) && sourceFormat !== (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL) && !(0, $bahqM.isObject)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}

});
parcelRegister("20liu", function(module, exports) {

$parcel$export(module.exports, "isSourceInstance", () => $175c1a118c738be0$export$22b808bc02a60488);
$parcel$export(module.exports, "createSource", () => $175c1a118c738be0$export$1921362e86c73c88);
$parcel$export(module.exports, "detectSourceFormat", () => $175c1a118c738be0$export$52a469afa4653e57);
$parcel$export(module.exports, "createSourceFromSeriesDataOption", () => $175c1a118c738be0$export$75aef3f97c0a5edf);
$parcel$export(module.exports, "cloneSourceShallow", () => $175c1a118c738be0$export$e0365e7e3555ddd4);
$parcel$export(module.exports, "shouldRetrieveDataByName", () => $175c1a118c738be0$export$8911336b527f8517);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $2Rbm1 = parcelRequire("2Rbm1");

var $eaKsF = parcelRequire("eaKsF");

var $cNGs8 = parcelRequire("cNGs8");
var $175c1a118c738be0$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $2Rbm1.SOURCE_FORMAT_UNKNOWN); // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $cNGs8.guessOrdinal)(this, i) === (0, $cNGs8.BE_ORDINAL).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $175c1a118c738be0$export$22b808bc02a60488(val) {
    return val instanceof $175c1a118c738be0$var$SourceImpl;
}
function $175c1a118c738be0$export$1921362e86c73c88(sourceData, thisMetaRawOption, sourceFormat) {
    sourceFormat = sourceFormat || $175c1a118c738be0$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $175c1a118c738be0$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $175c1a118c738be0$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $bahqM.clone)(thisMetaRawOption)
    });
    return source;
}
function $175c1a118c738be0$export$75aef3f97c0a5edf(data) {
    return new $175c1a118c738be0$var$SourceImpl({
        data: data,
        sourceFormat: (0, $bahqM.isTypedArray)(data) ? (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY) : (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)
    });
}
function $175c1a118c738be0$export$e0365e7e3555ddd4(source) {
    return new $175c1a118c738be0$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $bahqM.clone)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $175c1a118c738be0$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_UNKNOWN);
    if ((0, $bahqM.isTypedArray)(data)) sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY);
    else if ((0, $bahqM.isArray)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $bahqM.isArray)(item)) {
                sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS);
                break;
            } else if ((0, $bahqM.isObject)(item)) {
                sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS);
                break;
            }
        }
    } else if ((0, $bahqM.isObject)(data)) {
        for(var key in data)if ((0, $bahqM.hasOwn)(data, key) && (0, $bahqM.isArrayLike)(data[key])) {
            sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $175c1a118c738be0$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex; // PEDING: could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data; // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $175c1a118c738be0$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $bahqM.isString)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            } // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $bahqM.isNumber)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $175c1a118c738be0$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $2Rbm1.SERIES_LAYOUT_BY_ROW) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS)) {
        if (!dimensionsDefine) dimensionsDefine = $175c1a118c738be0$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $bahqM.each)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)) {
        var value0 = (0, $eaKsF.getDataItemValue)(data[0]);
        dimensionsDetectedCount = (0, $bahqM.isArray)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $175c1a118c738be0$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) {
        var dimensions_1 = [];
        (0, $bahqM.each)(obj, function(value, key) {
            dimensions_1.push(key);
        });
        return dimensions_1;
    }
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.
function $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $bahqM.createHashMap)();
    return (0, $bahqM.map)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $bahqM.isObject)(rawItem) ? rawItem : {
            name: rawItem
        }; // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        }; // User can set null in dimensions.
        // We dont auto specify name, othewise a given name may
        // cause it be refered unexpectedly.
        if (item.name == null) return item;
         // Also consider number form like 2012.
        item.name += ''; // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $175c1a118c738be0$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $175c1a118c738be0$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS);
}

});
parcelRegister("2Rbm1", function(module, exports) {

$parcel$export(module.exports, "VISUAL_DIMENSIONS", () => $214956bc17bbe3d3$export$cd51b5ca77f6f0e4);
$parcel$export(module.exports, "SOURCE_FORMAT_ORIGINAL", () => $214956bc17bbe3d3$export$2823037fb9d8f0c6);
$parcel$export(module.exports, "SOURCE_FORMAT_ARRAY_ROWS", () => $214956bc17bbe3d3$export$fcd62ebf51387903);
$parcel$export(module.exports, "SOURCE_FORMAT_OBJECT_ROWS", () => $214956bc17bbe3d3$export$703ae8a2d83f441);
$parcel$export(module.exports, "SOURCE_FORMAT_KEYED_COLUMNS", () => $214956bc17bbe3d3$export$6a32b42c754a3cb8);
$parcel$export(module.exports, "SOURCE_FORMAT_TYPED_ARRAY", () => $214956bc17bbe3d3$export$a918cb016a382d45);
$parcel$export(module.exports, "SOURCE_FORMAT_UNKNOWN", () => $214956bc17bbe3d3$export$c78f1330778d30d);
$parcel$export(module.exports, "SERIES_LAYOUT_BY_COLUMN", () => $214956bc17bbe3d3$export$7b3f3c6551b4949b);
$parcel$export(module.exports, "SERIES_LAYOUT_BY_ROW", () => $214956bc17bbe3d3$export$d55da1467cdf7804);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $214956bc17bbe3d3$export$cd51b5ca77f6f0e4 = (0, $bahqM.createHashMap)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'seriesName'
]);
var $214956bc17bbe3d3$export$2823037fb9d8f0c6 = 'original';
var $214956bc17bbe3d3$export$fcd62ebf51387903 = 'arrayRows';
var $214956bc17bbe3d3$export$703ae8a2d83f441 = 'objectRows';
var $214956bc17bbe3d3$export$6a32b42c754a3cb8 = 'keyedColumns';
var $214956bc17bbe3d3$export$a918cb016a382d45 = 'typedArray';
var $214956bc17bbe3d3$export$c78f1330778d30d = 'unknown';
var $214956bc17bbe3d3$export$7b3f3c6551b4949b = 'column';
var $214956bc17bbe3d3$export$d55da1467cdf7804 = 'row';

});

parcelRegister("cNGs8", function(module, exports) {

$parcel$export(module.exports, "BE_ORDINAL", () => $951afdda7935b9af$export$328749e9c5b40760);
$parcel$export(module.exports, "resetSourceDefaulter", () => $951afdda7935b9af$export$b30cdea50aa00e6);
$parcel$export(module.exports, "makeSeriesEncodeForAxisCoordSys", () => $951afdda7935b9af$export$37682b8fdd2e83d);
$parcel$export(module.exports, "querySeriesUpstreamDatasetModel", () => $951afdda7935b9af$export$8da66f73a1eda454);
$parcel$export(module.exports, "makeSeriesEncodeForNameBased", () => $951afdda7935b9af$export$60b8a57d1f2fed26);
$parcel$export(module.exports, "queryDatasetUpstreamDatasetModels", () => $951afdda7935b9af$export$397ba553479711e7);
$parcel$export(module.exports, "guessOrdinal", () => $951afdda7935b9af$export$c51adf1a2be01b9c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");

var $bahqM = parcelRequire("bahqM");

var $2Rbm1 = parcelRequire("2Rbm1");
var $951afdda7935b9af$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $951afdda7935b9af$var$innerGlobalModel = (0, $eaKsF.makeInner)();
function $951afdda7935b9af$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap = (0, $bahqM.createHashMap)();
}
function $951afdda7935b9af$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $bahqM.each)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $bahqM.isObject)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    }); // TODO
    // Auto detect first time axis and do arrangement.
    (0, $bahqM.each)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when mutiple series share one dimension
        // category axis, series name should better use
        // the other dimsion name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $951afdda7935b9af$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS)) (0, $bahqM.each)(dimensionsDefine, function(dim, idx) {
        if (((0, $bahqM.isObject)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = []; // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $951afdda7935b9af$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $951afdda7935b9af$export$328749e9c5b40760.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $951afdda7935b9af$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $951afdda7935b9af$export$328749e9c5b40760.Not) return idxRes0;
             // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $951afdda7935b9af$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ]; // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
        // So we dont set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $951afdda7935b9af$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $eaKsF.queryReferringComponents)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $eaKsF.SINGLE_REFERRING)).models[0];
}
function $951afdda7935b9af$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by defualt reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $eaKsF.queryReferringComponents)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $eaKsF.SINGLE_REFERRING)).models;
}
function $951afdda7935b9af$export$c51adf1a2be01b9c(source, dimIndex) {
    return $951afdda7935b9af$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $951afdda7935b9af$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result; // Experience value.
    var maxLoop = 5;
    if ((0, $bahqM.isTypedArray)(data)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
     // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $bahqM.isObject)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $bahqM.isString)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $951afdda7935b9af$export$328749e9c5b40760.Must : $951afdda7935b9af$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS)) {
        var dataObjectRows = data;
        if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS)) {
        var dataKeyedColumns = data;
        if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $bahqM.isTypedArray)(sample)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $eaKsF.getDataItemValue)(item);
            if (!(0, $bahqM.isArray)(val)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $bahqM.isString)(val); // Consider usage convenience, '1', '2' will be treated as "number".
        // `isFinit('')` get `true`.
        if (val != null && isFinite(val) && val !== '') return beStr ? $951afdda7935b9af$export$328749e9c5b40760.Might : $951afdda7935b9af$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $951afdda7935b9af$export$328749e9c5b40760.Must;
    }
    return $951afdda7935b9af$export$328749e9c5b40760.Not;
}

});



parcelRegister("bnVGB", function(module, exports) {

$parcel$export(module.exports, "summarizeDimensions", () => $849e96f8af2f129f$export$505a22c3734846f1);
$parcel$export(module.exports, "getDimensionTypeByAxis", () => $849e96f8af2f129f$export$af1622903e71278e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $2Rbm1 = parcelRequire("2Rbm1");
var $849e96f8af2f129f$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $849e96f8af2f129f$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $bahqM.createHashMap)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $bahqM.each)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($849e96f8af2f129f$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                 // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $849e96f8af2f129f$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $2Rbm1.VISUAL_DIMENSIONS).each(function(v, otherDim) {
            var encodeArr = $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $bahqM.map)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
    // in this way. Use label.formatter instead. May be remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $849e96f8af2f129f$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
} // FIXME:TS should be type `AxisType`
function $849e96f8af2f129f$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $849e96f8af2f129f$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }

});

parcelRegister("dhxbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ab69ba7880d9dc2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $9ab69ba7880d9dc2$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $bahqM.extend(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $9ab69ba7880d9dc2$export$2e2bcd8739ae039 = $9ab69ba7880d9dc2$var$SeriesDimensionDefine;

});

parcelRegister("8c3gC", function(module, exports) {

$parcel$export(module.exports, "CtorInt32Array", () => $5f71fa7e68f8e2cf$export$b60d945128546f53);
$parcel$export(module.exports, "default", () => $5f71fa7e68f8e2cf$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $2G90t = parcelRequire("2G90t");

var $20liu = parcelRequire("20liu");
var $5f71fa7e68f8e2cf$var$UNDEFINED = 'undefined';
var $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 = typeof Uint32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint32Array;
var $5f71fa7e68f8e2cf$export$78cf73566f32c185 = typeof Uint16Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint16Array;
var $5f71fa7e68f8e2cf$export$b60d945128546f53 = typeof Int32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Int32Array;
var $5f71fa7e68f8e2cf$export$365b104db51a490a = typeof Float64Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $5f71fa7e68f8e2cf$var$dataCtors = {
    'float': $5f71fa7e68f8e2cf$export$365b104db51a490a,
    'int': $5f71fa7e68f8e2cf$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $5f71fa7e68f8e2cf$export$365b104db51a490a
};
var $5f71fa7e68f8e2cf$var$defaultDimValueGetters;
function $5f71fa7e68f8e2cf$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 : $5f71fa7e68f8e2cf$export$78cf73566f32c185;
}
function $5f71fa7e68f8e2cf$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $5f71fa7e68f8e2cf$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $5f71fa7e68f8e2cf$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $5f71fa7e68f8e2cf$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end); // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $5f71fa7e68f8e2cf$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = []; // It will not be calculated util needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $bahqM.createHashMap)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider; // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $5f71fa7e68f8e2cf$var$defaultDimValueGetters[source.sourceFormat]; // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter; // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $20liu.shouldRetrieveDataByName)(source);
        this._dimensions = (0, $bahqM.map)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $5f71fa7e68f8e2cf$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx]; // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
            dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start; // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $5f71fa7e68f8e2cf$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $bahqM.map)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem); // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx]; // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end; // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions; // TODO get all from store?
            dimensions = []; // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = []; // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        }); // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count(); // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retreive the index with given raw data index
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
         // Indices are ascending
        var indices = this._indices; // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        var chunks = this._chunks;
        var dimData = chunks[dim];
        var nearestIndices = [];
        if (!dimData) return nearestIndices;
        if (maxDistance == null) maxDistance = Infinity;
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/SeriesData.js`.
        for(var i = 0, len = this.count(); i < len; i++){
            var dataIndex = this.getRawIndex(i);
            var diff = value - dimData[dataIndex];
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we chose the one that `diff >= 0` in this csae.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i); // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        } // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset; // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $bahqM.keys)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i]; // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex]; // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex]; // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        } // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset; // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    }; // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $5f71fa7e68f8e2cf$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) + 2); // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart; // Find a point from current frame that construct a triangel with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                 // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        } // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $5f71fa7e68f8e2cf$var$getInitialExtent();
        var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1)); // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i); // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                     // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $5f71fa7e68f8e2cf$var$getInitialExtent();
        if (!dimData) return initialExtent;
         // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count(); // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $bahqM.reduce)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $5f71fa7e68f8e2cf$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $bahqM.clone)(this._extent);
        target._rawExtent = (0, $bahqM.clone)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $2G90t.parseDataValue)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $5f71fa7e68f8e2cf$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $2G90t.parseDataValue)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $2G90t.parseDataValue)(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
                 : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $5f71fa7e68f8e2cf$export$2e2bcd8739ae039 = $5f71fa7e68f8e2cf$var$DataStore;

});
parcelRegister("2G90t", function(module, exports) {

$parcel$export(module.exports, "parseDataValue", () => $1f367d921e7af2c3$export$cc7175145baad076);
$parcel$export(module.exports, "getRawValueParser", () => $1f367d921e7af2c3$export$c88237b7c265b36b);
$parcel$export(module.exports, "SortOrderComparator", () => $1f367d921e7af2c3$export$ed75a5d7b0144167);
$parcel$export(module.exports, "createFilterComparator", () => $1f367d921e7af2c3$export$f2644c3485f94c4e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");

var $bahqM = parcelRequire("bahqM");

var $2cFRc = parcelRequire("2cFRc");
function $1f367d921e7af2c3$export$cc7175145baad076(value, opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' // spead up when using timestamp
     && typeof value !== 'number' && value != null && value !== '-') value = +(0, $jmSNG.parseDate)(value);
     // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
     : +value;
}
var $1f367d921e7af2c3$var$valueParserMap = (0, $bahqM.createHashMap)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have by defualt `numericToNumber`.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $jmSNG.parseDate)(val);
    },
    'trim': function(val) {
        return typeof val === 'string' ? (0, $bahqM.trim)(val) : val;
    }
});
function $1f367d921e7af2c3$export$c88237b7c265b36b(type) {
    return $1f367d921e7af2c3$var$valueParserMap.get(type);
}
var $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $1f367d921e7af2c3$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (typeof rval !== 'number') {
            var errMsg = '';
            (0, $2cFRc.throwError)(errMsg);
        }
        this._opFn = $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $jmSNG.numericToNumber)(rval);
    } // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return typeof lval === 'number' ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $jmSNG.numericToNumber)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $1f367d921e7af2c3$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by defualt: 'asc'
   * @param incomparable by defualt: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE]
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    } // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalTypeof = typeof lval;
        var rvalTypeof = typeof rval;
        var lvalFloat = lvalTypeof === 'number' ? lval : (0, $jmSNG.numericToNumber)(lval);
        var rvalFloat = rvalTypeof === 'number' ? rval : (0, $jmSNG.numericToNumber)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = lvalTypeof === 'string';
            var rvalIsStr = rvalTypeof === 'string';
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $1f367d921e7af2c3$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $jmSNG.numericToNumber)(rval);
    } // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $jmSNG.numericToNumber)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $1f367d921e7af2c3$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $1f367d921e7af2c3$var$FilterEqualityComparator(op === 'eq', rval) : (0, $bahqM.hasOwn)($1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP, op) ? new $1f367d921e7af2c3$var$FilterOrderComparator(op, rval) : null;
}

});
parcelRegister("2cFRc", function(module, exports) {

$parcel$export(module.exports, "warn", () => $19ad2baf23da1928$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $19ad2baf23da1928$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "deprecateLog", () => $19ad2baf23da1928$export$4a9c0b74eb885aa1);
$parcel$export(module.exports, "throwError", () => $19ad2baf23da1928$export$8bf7aba4a9e09055);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $19ad2baf23da1928$var$ECHARTS_PREFIX = '[ECharts] ';
var $19ad2baf23da1928$var$storedLogs = {};
var $19ad2baf23da1928$var$hasConsole = typeof console !== 'undefined' // eslint-disable-next-line
 && console.warn && console.log;
function $19ad2baf23da1928$export$bef1f36f5486a6a3(str) {
    if ($19ad2baf23da1928$var$hasConsole) // eslint-disable-next-line
    console.log($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
}
function $19ad2baf23da1928$export$c106dd0671a0fc2d(str) {
    if ($19ad2baf23da1928$var$hasConsole) console.warn($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
}
function $19ad2baf23da1928$export$a3bc9b8ed74fc(str) {
    if ($19ad2baf23da1928$var$hasConsole) console.error($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
}
function $19ad2baf23da1928$export$4a9c0b74eb885aa1(str) {}
function $19ad2baf23da1928$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $19ad2baf23da1928$export$c3747c611a35af25() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
}
function $19ad2baf23da1928$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $19ad2baf23da1928$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}

});



parcelRegister("2Om11", function(module, exports) {

$parcel$export(module.exports, "SeriesDataSchema", () => $20c1541ff90227ce$export$a1ef064685775f3e);
$parcel$export(module.exports, "ensureSourceDimNameMap", () => $20c1541ff90227ce$export$be39ae17310c33f7);
$parcel$export(module.exports, "shouldOmitUnusedDimensions", () => $20c1541ff90227ce$export$238b87930d825d87);
$parcel$export(module.exports, "isSeriesDataSchema", () => $20c1541ff90227ce$export$fafbc856132a3a0e);
$parcel$export(module.exports, "createDimNameMap", () => $20c1541ff90227ce$export$a477f5bebfd07944);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $20liu = parcelRequire("20liu");
var $20c1541ff90227ce$var$inner = (0, $eaKsF.makeInner)();
var $20c1541ff90227ce$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $20c1541ff90227ce$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $20c1541ff90227ce$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $bahqM.retrieve2)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $20liu.shouldRetrieveDataByName)(this.source);
        var makeHashStrict = !$20c1541ff90227ce$export$238b87930d825d87(dimCount); // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            }); // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Becuase in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null // For data stack, we have make sure each series has its own dim on this store.
             && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict // Use escape character '`' in case that property name contains '$'.
             ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') // For better performance, when there are large dimensions, tolerant this defects that hardly meet.
             : property;
            dimHash += '$';
            dimHash += $20c1541ff90227ce$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        } // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++; // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $20c1541ff90227ce$export$fafbc856132a3a0e(schema) {
    return schema instanceof $20c1541ff90227ce$export$a1ef064685775f3e;
}
function $20c1541ff90227ce$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $bahqM.createHashMap)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $bahqM.isObject)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $20c1541ff90227ce$export$be39ae17310c33f7(source) {
    var innerSource = $20c1541ff90227ce$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $20c1541ff90227ce$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $20c1541ff90227ce$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}

});


parcelRegister("h9jiS", function(module, exports) {

$parcel$export(module.exports, "createDimensions", () => $c7c240344387234c$export$8066c1b52b2e9504);
$parcel$export(module.exports, "default", () => $c7c240344387234c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2Rbm1 = parcelRequire("2Rbm1");

var $dhxbO = parcelRequire("dhxbO");

var $bahqM = parcelRequire("bahqM");

var $20liu = parcelRequire("20liu");

var $8c3gC = parcelRequire("8c3gC");

var $eaKsF = parcelRequire("eaKsF");

var $cNGs8 = parcelRequire("cNGs8");

var $2Om11 = parcelRequire("2Om11");
function $c7c240344387234c$export$8066c1b52b2e9504(source, opt) {
    return $c7c240344387234c$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $c7c240344387234c$export$2e2bcd8739ae039(source, opt) {
    if (!(0, $20liu.isSourceInstance)(source)) source = (0, $20liu.createSourceFromSeriesDataOption)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $bahqM.createHashMap)();
    var resultList = [];
    var dimCount = $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount); // Try to ignore unsed dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $2Om11.shouldOmitUnusedDimensions)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $2Om11.ensureSourceDimNameMap)(source) : (0, $2Om11.createDimNameMap)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $bahqM.createHashMap)(encodeDef);
    var indicesMap = new (0, $8c3gC.CtorInt32Array)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $bahqM.isObject)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $dhxbO.default)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be diplayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
     // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $eaKsF.normalizeToArray)(dataDimsRaw).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $bahqM.isString)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $bahqM.each)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $bahqM.isString)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    }); // Apply templetes and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $bahqM.each)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $bahqM.isString)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $bahqM.extend)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim); // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $eaKsF.normalizeToArray)(dataDims); // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
         // Apply templates.
        (0, $bahqM.each)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx); // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $bahqM.defaults)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $bahqM.isObject)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $bahqM.defaults)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $2Rbm1.VISUAL_DIMENSIONS).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    } // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    } // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $c7c240344387234c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0; // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $cNGs8.guessOrdinal)(source, resultDimIdx) === (0, $cNGs8.BE_ORDINAL).Must // Consider the case:
         || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $bahqM.each)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        }); // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $c7c240344387234c$var$removeDuplication(resultList);
    return new (0, $2Om11.SeriesDataSchema)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $c7c240344387234c$var$removeDuplication(result) {
    var duplicationMap = (0, $bahqM.createHashMap)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $bahqM.each)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $bahqM.isObject)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $c7c240344387234c$var$genCoordDimName(name, map, fromZero) {
    var mapData = map.data;
    if (fromZero || mapData.hasOwnProperty(name)) {
        var i = 0;
        while(mapData.hasOwnProperty(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}

});

parcelRegister("gyhNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0cda1a15c9ef40a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $c0cda1a15c9ef40a$var$coordinateSystemCreators = {};
var $c0cda1a15c9ef40a$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._coordinateSystems = [];
    }
    CoordinateSystemManager.prototype.create = function(ecModel, api) {
        var coordinateSystems = [];
        $bahqM.each($c0cda1a15c9ef40a$var$coordinateSystemCreators, function(creater, type) {
            var list = creater.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    };
    CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $bahqM.each(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._coordinateSystems.slice();
    };
    CoordinateSystemManager.register = function(type, creator) {
        $c0cda1a15c9ef40a$var$coordinateSystemCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $c0cda1a15c9ef40a$var$coordinateSystemCreators[type];
    };
    return CoordinateSystemManager;
}();
var $c0cda1a15c9ef40a$export$2e2bcd8739ae039 = $c0cda1a15c9ef40a$var$CoordinateSystemManager;

});

parcelRegister("lhMGv", function(module, exports) {

$parcel$export(module.exports, "getCoordSysInfoBySeries", () => $f7f0f3461c4b4907$export$f2befeb2f4933656);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".

var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");
/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $f7f0f3461c4b4907$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $bahqM.createHashMap)();
        this.categoryAxisMap = (0, $bahqM.createHashMap)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $f7f0f3461c4b4907$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $f7f0f3461c4b4907$var$CoordSysInfo(coordSysName);
    var fetch = $f7f0f3461c4b4907$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $f7f0f3461c4b4907$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($f7f0f3461c4b4907$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($f7f0f3461c4b4907$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($f7f0f3461c4b4907$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($f7f0f3461c4b4907$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($f7f0f3461c4b4907$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $bahqM.each)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($f7f0f3461c4b4907$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $f7f0f3461c4b4907$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}

});

parcelRegister("5R8Hi", function(module, exports) {

$parcel$export(module.exports, "enableDataStack", () => $4438a61210f14409$export$f2165f9e8499b278);
$parcel$export(module.exports, "isDimensionStacked", () => $4438a61210f14409$export$1dedc39359ae35c);
$parcel$export(module.exports, "getStackedDimension", () => $4438a61210f14409$export$909db2be4938fbdf);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $2Om11 = parcelRequire("2Om11");
function $4438a61210f14409$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    } // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $bahqM.each)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $bahqM.isString)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
             // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
     // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id; // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $bahqM.each)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $2Om11.isSeriesDataSchema)(dimensionsInput.schema);
}
function $4438a61210f14409$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $4438a61210f14409$export$909db2be4938fbdf(data, targetDim) {
    return $4438a61210f14409$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

});


parcelRegister("1O7Ua", function(module, exports) {

$parcel$export(module.exports, "SERIES_UNIVERSAL_TRANSITION_PROP", () => $151097b3612ce5ca$export$e960441116ae2799);
$parcel$export(module.exports, "default", () => $151097b3612ce5ca$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $eaKsF = parcelRequire("eaKsF");

var $h4UlH = parcelRequire("h4UlH");

var $aCu4v = parcelRequire("aCu4v");

var $guzSc = parcelRequire("guzSc");

var $65MS1 = parcelRequire("65MS1");

var $92IK1 = parcelRequire("92IK1");

var $aLwh0 = parcelRequire("aLwh0");

var $jTNWo = parcelRequire("jTNWo");

var $d88IV = parcelRequire("d88IV");
var $151097b3612ce5ca$var$inner = $eaKsF.makeInner();
function $151097b3612ce5ca$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $151097b3612ce5ca$export$e960441116ae2799 = '__universalTransitionEnabled';
var $151097b3612ce5ca$var$SeriesModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Becuase this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this; // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $92IK1.createTask)({
            count: $151097b3612ce5ca$var$dataTaskCount,
            reset: $151097b3612ce5ca$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager = new (0, $jTNWo.SourceManager)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $151097b3612ce5ca$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $151097b3612ce5ca$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $65MS1.fetchLayoutMode)(this);
        var inputPositionParams = layoutMode ? (0, $65MS1.getLayoutParams)(option) : {}; // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $h4UlH.default).hasClass(themeSubType)) themeSubType += 'Series';
        $bahqM.merge(option, ecModel.getTheme().get(this.subType));
        $bahqM.merge(option, this.getDefaultOption()); // Default label emphasis `show`
        $eaKsF.defaultEmphasis(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $65MS1.mergeLayoutParam)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $bahqM.merge(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $65MS1.fetchLayoutMode)(this);
        if (layoutMode) (0, $65MS1.mergeLayoutParam)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $151097b3612ce5ca$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data;
        $151097b3612ce5ca$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$bahqM.isTypedArray(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $eaKsF.defaultEmphasis(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overriden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $151097b3612ce5ca$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $151097b3612ce5ca$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $151097b3612ce5ca$var$getCurrentTask(this);
        if (task) {
            var context = task.context; // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data; // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $151097b3612ce5ca$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $bahqM.createHashMap(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $151097b3612ce5ca$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $151097b3612ce5ca$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem; // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $d88IV.defaultSeriesFormatTooltip)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        if ((0, $hZfwb.default).node) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel; // PENDING
        var color = (0, $aCu4v.PaletteMixin).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    }; // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var data = this.getData(dataType);
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $bahqM.keys(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
        return selectedMap[nameOrId] || false;
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$151097b3612ce5ca$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition; // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
         // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var selectedMode = this.option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'multiple') {
            var selectedMap = this.option.selectedMap || (this.option.selectedMap = {});
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i]; // TODO diffrent types of data share same object.
                var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, lastDataIndex);
            this.option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    }; // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $h4UlH.default).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle'; // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $h4UlH.default));
$bahqM.mixin($151097b3612ce5ca$var$SeriesModel, (0, $guzSc.DataFormatMixin));
$bahqM.mixin($151097b3612ce5ca$var$SeriesModel, (0, $aCu4v.PaletteMixin));
(0, $aLwh0.mountExtend)($151097b3612ce5ca$var$SeriesModel, (0, $h4UlH.default));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $151097b3612ce5ca$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$eaKsF.isNameSpecified(seriesModel)) seriesModel.name = $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) || name;
}
function $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $bahqM.each(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $151097b3612ce5ca$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $151097b3612ce5ca$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $151097b3612ce5ca$var$dataTaskProgress;
}
function $151097b3612ce5ca$var$dataTaskProgress(param, context) {
    // Avoid repead cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
} // TODO refactor
function $151097b3612ce5ca$var$wrapData(data, seriesModel) {
    $bahqM.each($bahqM.concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $bahqM.curry($151097b3612ce5ca$var$onDataChange, seriesModel));
    });
}
function $151097b3612ce5ca$var$onDataChange(seriesModel, newList) {
    var task = $151097b3612ce5ca$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $151097b3612ce5ca$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $151097b3612ce5ca$export$2e2bcd8739ae039 = $151097b3612ce5ca$var$SeriesModel;

});
parcelRegister("h4UlH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ee8520f4778ed8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $gaMkj = parcelRequire("gaMkj");

var $jvo6O = parcelRequire("jvo6O");

var $aLwh0 = parcelRequire("aLwh0");

var $eaKsF = parcelRequire("eaKsF");

var $65MS1 = parcelRequire("65MS1");
var $c6ee8520f4778ed8$var$inner = (0, $eaKsF.makeInner)();
var $c6ee8520f4778ed8$var$ComponentModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $jvo6O.getUID('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $65MS1.fetchLayoutMode(this);
        var inputPositionParams = layoutMode ? $65MS1.getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        $bahqM.merge(option, themeModel.get(this.mainType));
        $bahqM.merge(option, this.getDefaultOption());
        if (layoutMode) $65MS1.mergeLayoutParam(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $bahqM.merge(this.option, option, true);
        var layoutMode = $65MS1.fetchLayoutMode(this);
        if (layoutMode) $65MS1.mergeLayoutParam(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component';
   * import {XxxModel, XxxOption} from './XxxModel';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor; // If using class declaration, it is different to travel super class
        // in legacy env and auto merge defaultOption. So if using class
        // declaration, defaultOption should be merged manually.
        if (!(0, $aLwh0.isExtendedClass)(ctor)) // When using ts class, defaultOption must be declared as static.
        return ctor.defaultOption;
         // FIXME: remove this approach?
        var fields = $c6ee8520f4778ed8$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $bahqM.merge(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $eaKsF.queryReferringComponents)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        var boxLayoutModel = this;
        return {
            left: boxLayoutModel.get('left'),
            top: boxLayoutModel.get('top'),
            right: boxLayoutModel.get('right'),
            bottom: boxLayoutModel.get('bottom'),
            width: boxLayoutModel.get('width'),
            height: boxLayoutModel.get('height')
        };
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $gaMkj.default));
(0, $aLwh0.mountExtend)($c6ee8520f4778ed8$var$ComponentModel, (0, $gaMkj.default));
(0, $aLwh0.enableClassManagement)($c6ee8520f4778ed8$var$ComponentModel);
$jvo6O.enableSubTypeDefaulter($c6ee8520f4778ed8$var$ComponentModel);
$jvo6O.enableTopologicalTravel($c6ee8520f4778ed8$var$ComponentModel, $c6ee8520f4778ed8$var$getDependencies);
function $c6ee8520f4778ed8$var$getDependencies(componentType) {
    var deps = [];
    $bahqM.each($c6ee8520f4778ed8$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    }); // Ensure main type.
    deps = $bahqM.map(deps, function(type) {
        return (0, $aLwh0.parseClassType)(type).main;
    }); // Hack dataset for convenience.
    if (componentType !== 'dataset' && $bahqM.indexOf(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $c6ee8520f4778ed8$export$2e2bcd8739ae039 = $c6ee8520f4778ed8$var$ComponentModel;

});
parcelRegister("jvo6O", function(module, exports) {

$parcel$export(module.exports, "getUID", () => $e3339d183aa6ce79$export$6d2b3473b0986646);
$parcel$export(module.exports, "enableSubTypeDefaulter", () => $e3339d183aa6ce79$export$b9faf30b7d655a6f);
$parcel$export(module.exports, "enableTopologicalTravel", () => $e3339d183aa6ce79$export$ce592d345a3ec040);
$parcel$export(module.exports, "inheritDefaultOption", () => $e3339d183aa6ce79$export$68acc510e46fef2);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $aLwh0 = parcelRequire("aLwh0");

var $e3339d183aa6ce79$var$base = Math.round(Math.random() * 10);
function $e3339d183aa6ce79$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $e3339d183aa6ce79$var$base++
    ].join('_');
}
function $e3339d183aa6ce79$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $aLwh0.parseClassType)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $aLwh0.parseClassType)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $e3339d183aa6ce79$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $bahqM.each(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $bahqM.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $bahqM.each(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        } // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $bahqM.each(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $bahqM.each(availableDeps, function(dependentName) {
                if ($bahqM.indexOf(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($bahqM.indexOf(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $bahqM.each(originalDeps, function(dep) {
            $bahqM.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $e3339d183aa6ce79$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $bahqM.merge($bahqM.merge({}, superOption, true), subOption, true);
}

});

parcelRegister("65MS1", function(module, exports) {

$parcel$export(module.exports, "LOCATION_PARAMS", () => $46f91e567ea0ce35$export$a9aa2cc018afbed);
$parcel$export(module.exports, "box", () => $46f91e567ea0ce35$export$827f4ee28efc37);
$parcel$export(module.exports, "getAvailableSize", () => $46f91e567ea0ce35$export$145a8938a85a22b1);
$parcel$export(module.exports, "getLayoutRect", () => $46f91e567ea0ce35$export$4517a5ca639a7293);
$parcel$export(module.exports, "positionElement", () => $46f91e567ea0ce35$export$74054bd96b5eeef1);
$parcel$export(module.exports, "sizeCalculable", () => $46f91e567ea0ce35$export$7ede609e8ebc9650);
$parcel$export(module.exports, "fetchLayoutMode", () => $46f91e567ea0ce35$export$3968a28a7cbd6063);
$parcel$export(module.exports, "mergeLayoutParam", () => $46f91e567ea0ce35$export$1754cb91f16ca028);
$parcel$export(module.exports, "getLayoutParams", () => $46f91e567ea0ce35$export$4b0d20af19c9875e);
$parcel$export(module.exports, "copyLayoutParams", () => $46f91e567ea0ce35$export$7438999faea9b6cc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning

var $bahqM = parcelRequire("bahqM");

var $1E3E8 = parcelRequire("1E3E8");

var $jmSNG = parcelRequire("jmSNG");

var $dCJrM = parcelRequire("dCJrM");
var $46f91e567ea0ce35$var$each = $bahqM.each;
var $46f91e567ea0ce35$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $46f91e567ea0ce35$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $46f91e567ea0ce35$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $46f91e567ea0ce35$export$827f4ee28efc37 = $46f91e567ea0ce35$var$boxLayout;
var $46f91e567ea0ce35$export$be20d9158c17374c = $bahqM.curry($46f91e567ea0ce35$var$boxLayout, 'vertical');
var $46f91e567ea0ce35$export$ae65a483d943e7a7 = $bahqM.curry($46f91e567ea0ce35$var$boxLayout, 'horizontal');
function $46f91e567ea0ce35$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = (0, $jmSNG.parsePercent)(positionInfo.left, containerWidth);
    var y = (0, $jmSNG.parsePercent)(positionInfo.top, containerHeight);
    var x2 = (0, $jmSNG.parsePercent)(positionInfo.right, containerWidth);
    var y2 = (0, $jmSNG.parsePercent)(positionInfo.bottom, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
    margin = $dCJrM.normalizeCssArray(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
function $46f91e567ea0ce35$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
    margin = $dCJrM.normalizeCssArray(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $jmSNG.parsePercent)(positionInfo.left, containerWidth);
    var top = (0, $jmSNG.parsePercent)(positionInfo.top, containerHeight);
    var right = (0, $jmSNG.parsePercent)(positionInfo.right, containerWidth);
    var bottom = (0, $jmSNG.parsePercent)(positionInfo.bottom, containerHeight);
    var width = (0, $jmSNG.parsePercent)(positionInfo.width, containerWidth);
    var height = (0, $jmSNG.parsePercent)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        } // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    } // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
     // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    } // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $1E3E8.default)(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $46f91e567ea0ce35$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    if (!h && !v) return;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $1E3E8.default)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    } // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $46f91e567ea0ce35$export$4517a5ca639a7293($bahqM.defaults({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        el.x = dx;
        el.y = dy;
    } else {
        el.x += dx;
        el.y += dy;
    }
    el.markRedraw();
}
function $46f91e567ea0ce35$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $46f91e567ea0ce35$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $bahqM.isObject(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $46f91e567ea0ce35$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$bahqM.isArray(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[1], 1);
    copy($46f91e567ea0ce35$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($46f91e567ea0ce35$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $46f91e567ea0ce35$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $46f91e567ea0ce35$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        } // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $46f91e567ea0ce35$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $46f91e567ea0ce35$export$4b0d20af19c9875e(source) {
    return $46f91e567ea0ce35$export$7438999faea9b6cc({}, source);
}
function $46f91e567ea0ce35$export$7438999faea9b6cc(target, source) {
    source && target && $46f91e567ea0ce35$var$each($46f91e567ea0ce35$export$a9aa2cc018afbed, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}

});
parcelRegister("dCJrM", function(module, exports) {

$parcel$export(module.exports, "addCommas", () => $9eb213cc0c822e32$export$b6fe44657ce35c42);
$parcel$export(module.exports, "toCamelCase", () => $9eb213cc0c822e32$export$86f54f62aa7a7514);
$parcel$export(module.exports, "normalizeCssArray", () => $9eb213cc0c822e32$export$f3a38102c49f4268);
$parcel$export(module.exports, "encodeHTML", () => $9eb213cc0c822e32$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "makeValueReadable", () => $9eb213cc0c822e32$export$3cd8db88714decfc);
$parcel$export(module.exports, "formatTpl", () => $9eb213cc0c822e32$export$2028496a35766e41);
$parcel$export(module.exports, "formatTplSimple", () => $9eb213cc0c822e32$export$2fa08233ee42f8e1);
$parcel$export(module.exports, "getTooltipMarker", () => $9eb213cc0c822e32$export$1987a3dbdf3c45ca);
$parcel$export(module.exports, "formatTime", () => $9eb213cc0c822e32$export$3203edd9e5edd663);
$parcel$export(module.exports, "capitalFirst", () => $9eb213cc0c822e32$export$38a1e7552f497c0e);
$parcel$export(module.exports, "convertToColorString", () => $9eb213cc0c822e32$export$cda04d03233e5555);
$parcel$export(module.exports, "windowOpen", () => $9eb213cc0c822e32$export$13e13f9b96dbe8fa);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $bc1Ad = parcelRequire("bc1Ad");


var $h6fMM = parcelRequire("h6fMM");

var $2emZ2 = parcelRequire("2emZ2");
function $9eb213cc0c822e32$export$b6fe44657ce35c42(x) {
    if (!(0, $jmSNG.isNumeric)(x)) return $bahqM.isString(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $9eb213cc0c822e32$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $9eb213cc0c822e32$export$f3a38102c49f4268 = $bahqM.normalizeCssArray;
var $9eb213cc0c822e32$var$replaceReg = /([&<>"'])/g;
var $9eb213cc0c822e32$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $9eb213cc0c822e32$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($9eb213cc0c822e32$var$replaceReg, function(str, c) {
        return $9eb213cc0c822e32$var$replaceMap[c];
    });
}
function $9eb213cc0c822e32$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $bahqM.trim(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $jmSNG.parseDate)(value) : value;
        if (!isNaN(+date)) return (0, $bc1Ad.format)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
         // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $bahqM.isStringSafe(value) ? stringToUserReadable(value) : $bahqM.isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
     // By default.
    var numericResult = (0, $jmSNG.numericToNumber)(value);
    return isNumberUserReadable(numericResult) ? $9eb213cc0c822e32$export$b6fe44657ce35c42(numericResult) : $bahqM.isStringSafe(value) ? stringToUserReadable(value) : '-';
}
var $9eb213cc0c822e32$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $9eb213cc0c822e32$var$wrapVar = function(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $9eb213cc0c822e32$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$bahqM.isArray(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $9eb213cc0c822e32$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar(alias), $9eb213cc0c822e32$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar($9eb213cc0c822e32$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(val) : val);
    }
    return tpl;
}
function $9eb213cc0c822e32$export$2fa08233ee42f8e1(tpl, param, encode) {
    $bahqM.each(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(value) : value);
    });
    return tpl;
}
function $9eb213cc0c822e32$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $bahqM.isString(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' // Only support string
     + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $9eb213cc0c822e32$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $jmSNG.parseDate)(value);
    var utc = isUTC ? 'UTC' : '';
    var y = date['get' + utc + 'FullYear']();
    var M = date['get' + utc + 'Month']() + 1;
    var d = date['get' + utc + 'Date']();
    var h = date['get' + utc + 'Hours']();
    var m = date['get' + utc + 'Minutes']();
    var s = date['get' + utc + 'Seconds']();
    var S = date['get' + utc + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $bc1Ad.pad)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100 + '').replace('dd', (0, $bc1Ad.pad)(d, 2)).replace('d', d).replace('hh', (0, $bc1Ad.pad)(h, 2)).replace('h', h).replace('mm', (0, $bc1Ad.pad)(m, 2)).replace('m', m).replace('ss', (0, $bc1Ad.pad)(s, 2)).replace('s', s).replace('SSS', (0, $bc1Ad.pad)(S, 3));
    return tpl;
}
function $9eb213cc0c822e32$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $9eb213cc0c822e32$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $bahqM.isString(color) ? color : $bahqM.isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $9eb213cc0c822e32$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}

});
parcelRegister("bc1Ad", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", () => $82620b17ee17a85a$export$32c0454ceff7f92d);
$parcel$export(module.exports, "ONE_MINUTE", () => $82620b17ee17a85a$export$35acaebf644db34e);
$parcel$export(module.exports, "ONE_HOUR", () => $82620b17ee17a85a$export$82541edf19e5e3b0);
$parcel$export(module.exports, "ONE_DAY", () => $82620b17ee17a85a$export$a97a1358cbb650ab);
$parcel$export(module.exports, "ONE_YEAR", () => $82620b17ee17a85a$export$99cafda57477293d);
$parcel$export(module.exports, "fullLeveledFormatter", () => $82620b17ee17a85a$export$445bdbd8d2334e40);
$parcel$export(module.exports, "timeUnits", () => $82620b17ee17a85a$export$833c398a55654bb7);
$parcel$export(module.exports, "pad", () => $82620b17ee17a85a$export$5d04458e2a6c373e);
$parcel$export(module.exports, "getPrimaryTimeUnit", () => $82620b17ee17a85a$export$1da4b91a25d7e1c8);
$parcel$export(module.exports, "isPrimaryTimeUnit", () => $82620b17ee17a85a$export$beb5920b69c13da);
$parcel$export(module.exports, "getDefaultFormatPrecisionOfInterval", () => $82620b17ee17a85a$export$124c820721c4f66b);
$parcel$export(module.exports, "format", () => $82620b17ee17a85a$export$d9468344d3651243);
$parcel$export(module.exports, "fullYearGetterName", () => $82620b17ee17a85a$export$8d046fefed9a548e);
$parcel$export(module.exports, "monthGetterName", () => $82620b17ee17a85a$export$5c242a801a23eec7);
$parcel$export(module.exports, "dateGetterName", () => $82620b17ee17a85a$export$4189e6cbc9753260);
$parcel$export(module.exports, "hoursGetterName", () => $82620b17ee17a85a$export$8b40b55b3c06cbe2);
$parcel$export(module.exports, "minutesGetterName", () => $82620b17ee17a85a$export$8807847c5c71eded);
$parcel$export(module.exports, "secondsGetterName", () => $82620b17ee17a85a$export$8f49e73e2eebd168);
$parcel$export(module.exports, "millisecondsGetterName", () => $82620b17ee17a85a$export$312207a92d041116);
$parcel$export(module.exports, "leveledFormat", () => $82620b17ee17a85a$export$fe777b6293828b5d);
$parcel$export(module.exports, "getUnitValue", () => $82620b17ee17a85a$export$e04e41a1e24ffd3f);
$parcel$export(module.exports, "fullYearSetterName", () => $82620b17ee17a85a$export$43fbeac90913b151);
$parcel$export(module.exports, "monthSetterName", () => $82620b17ee17a85a$export$233f59998ed71c09);
$parcel$export(module.exports, "dateSetterName", () => $82620b17ee17a85a$export$82fd379a67f37fa0);
$parcel$export(module.exports, "hoursSetterName", () => $82620b17ee17a85a$export$b6f943e8d23c15bb);
$parcel$export(module.exports, "minutesSetterName", () => $82620b17ee17a85a$export$50303078793fc7d);
$parcel$export(module.exports, "secondsSetterName", () => $82620b17ee17a85a$export$a4a908acda9c3118);
$parcel$export(module.exports, "millisecondsSetterName", () => $82620b17ee17a85a$export$c047afab75f6d84);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $3OMoQ = parcelRequire("3OMoQ");

var $gaMkj = parcelRequire("gaMkj");
var $82620b17ee17a85a$export$32c0454ceff7f92d = 1000;
var $82620b17ee17a85a$export$35acaebf644db34e = $82620b17ee17a85a$export$32c0454ceff7f92d * 60;
var $82620b17ee17a85a$export$82541edf19e5e3b0 = $82620b17ee17a85a$export$35acaebf644db34e * 60;
var $82620b17ee17a85a$export$a97a1358cbb650ab = $82620b17ee17a85a$export$82541edf19e5e3b0 * 24;
var $82620b17ee17a85a$export$99cafda57477293d = $82620b17ee17a85a$export$a97a1358cbb650ab * 365;
var $82620b17ee17a85a$export$f7854271ddbda64e = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}',
    none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
};
var $82620b17ee17a85a$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $82620b17ee17a85a$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $82620b17ee17a85a$var$fullDayFormatter,
    hour: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.hour,
    minute: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.minute,
    second: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.second,
    millisecond: $82620b17ee17a85a$export$f7854271ddbda64e.none
};
var $82620b17ee17a85a$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $82620b17ee17a85a$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $82620b17ee17a85a$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $82620b17ee17a85a$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit);
}
function $82620b17ee17a85a$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $82620b17ee17a85a$export$d9468344d3651243(// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $jmSNG.parseDate(time);
    var y = date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
    var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 4) + 1;
    var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
    var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
    var localeModel = lang instanceof (0, $gaMkj.default) ? lang : (0, $3OMoQ.getLocaleModel)(lang || (0, $3OMoQ.SYSTEM_LANG)) || (0, $3OMoQ.getDefaultLocaleModel)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $82620b17ee17a85a$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if (typeof formatter === 'string') // Single formatter for all units at all levels
    template = formatter;
    else if (typeof formatter === 'function') // Callback formatter
    template = formatter(tick.value, idx, {
        level: tick.level
    });
    else {
        var defaults = $bahqM.extend({}, $82620b17ee17a85a$export$f7854271ddbda64e);
        if (tick.level > 0) for(var i = 0; i < $82620b17ee17a85a$export$87100da04d711986.length; ++i)defaults[$82620b17ee17a85a$export$87100da04d711986[i]] = "{primary|" + defaults[$82620b17ee17a85a$export$87100da04d711986[i]] + "}";
        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
         : $bahqM.defaults(formatter, defaults) : defaults;
        var unit = $82620b17ee17a85a$export$4dfb0417ad6555b7(tick.value, isUTC);
        if (mergedFormatter[unit]) template = mergedFormatter[unit];
        else if (mergedFormatter.inherit) {
            // Unit formatter is not defined and should inherit from bigger units
            var targetId = $82620b17ee17a85a$export$833c398a55654bb7.indexOf(unit);
            for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                template = mergedFormatter[unit];
                break;
            }
            template = template || defaults.none;
        }
        if ($bahqM.isArray(template)) {
            var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
            levelId = Math.min(levelId, template.length - 1);
            template = template[levelId];
        }
    }
    return $82620b17ee17a85a$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $jmSNG.parseDate(value);
    var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
    var h = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
    var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $82620b17ee17a85a$export$e04e41a1e24ffd3f(value, unit, isUTC) {
    var date = typeof value === 'number' ? $jmSNG.parseDate(value) : value;
    unit = unit || $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC);
    switch(unit){
        case 'year':
            return date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
        case 'half-year':
            return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
        case 'quarter':
            return Math.floor((date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
        case 'month':
            return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]();
        case 'day':
            return date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
        case 'half-day':
            return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]() / 24;
        case 'hour':
            return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
        case 'minute':
            return date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
        case 'second':
            return date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
        case 'millisecond':
            return date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
    }
}
function $82620b17ee17a85a$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $82620b17ee17a85a$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $82620b17ee17a85a$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $82620b17ee17a85a$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $82620b17ee17a85a$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $82620b17ee17a85a$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $82620b17ee17a85a$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $82620b17ee17a85a$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $82620b17ee17a85a$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $82620b17ee17a85a$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $82620b17ee17a85a$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $82620b17ee17a85a$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $82620b17ee17a85a$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}

});
parcelRegister("3OMoQ", function(module, exports) {

$parcel$export(module.exports, "SYSTEM_LANG", () => $2c7b95ca3b098ed0$export$9a2147b3808d4c6b);
$parcel$export(module.exports, "registerLocale", () => $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd);
$parcel$export(module.exports, "createLocaleObject", () => $2c7b95ca3b098ed0$export$ddc371781a6af754);
$parcel$export(module.exports, "getLocaleModel", () => $2c7b95ca3b098ed0$export$37cc638e0e11865f);
$parcel$export(module.exports, "getDefaultLocaleModel", () => $2c7b95ca3b098ed0$export$1188f179b2597821);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gaMkj = parcelRequire("gaMkj");

var $hZfwb = parcelRequire("hZfwb");

var $dHSx1 = parcelRequire("dHSx1");

var $1VLoR = parcelRequire("1VLoR");

var $bahqM = parcelRequire("bahqM");
var $2c7b95ca3b098ed0$var$LOCALE_ZH = 'ZH';
var $2c7b95ca3b098ed0$var$LOCALE_EN = 'EN';
var $2c7b95ca3b098ed0$var$DEFAULT_LOCALE = $2c7b95ca3b098ed0$var$LOCALE_EN;
var $2c7b95ca3b098ed0$var$localeStorage = {};
var $2c7b95ca3b098ed0$var$localeModels = {};
var $2c7b95ca3b098ed0$export$9a2147b3808d4c6b = !(0, $hZfwb.default).domSupported ? $2c7b95ca3b098ed0$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
    return langStr.indexOf($2c7b95ca3b098ed0$var$LOCALE_ZH) > -1 ? $2c7b95ca3b098ed0$var$LOCALE_ZH : $2c7b95ca3b098ed0$var$DEFAULT_LOCALE;
}();
function $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $2c7b95ca3b098ed0$var$localeModels[locale] = new (0, $gaMkj.default)(localeObj);
    $2c7b95ca3b098ed0$var$localeStorage[locale] = localeObj;
} // export function getLocale(locale: string) {
function $2c7b95ca3b098ed0$export$ddc371781a6af754(locale) {
    if ((0, $bahqM.isString)(locale)) {
        var localeObj = $2c7b95ca3b098ed0$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $2c7b95ca3b098ed0$var$LOCALE_ZH || locale === $2c7b95ca3b098ed0$var$LOCALE_EN) return (0, $bahqM.clone)(localeObj);
        else return (0, $bahqM.merge)((0, $bahqM.clone)(localeObj), (0, $bahqM.clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
    } else return (0, $bahqM.merge)((0, $bahqM.clone)(locale), (0, $bahqM.clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
}
function $2c7b95ca3b098ed0$export$37cc638e0e11865f(lang) {
    return $2c7b95ca3b098ed0$var$localeModels[lang];
}
function $2c7b95ca3b098ed0$export$1188f179b2597821() {
    return $2c7b95ca3b098ed0$var$localeModels[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE];
} // Default locale
$2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_EN, (0, $dHSx1.default));
$2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_ZH, (0, $1VLoR.default));

});
parcelRegister("dHSx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa9975bdbfffeb9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Language: English.
 */ var $9fa9975bdbfffeb9$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};

});

parcelRegister("1VLoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $167fe1fc3be0ec4c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $167fe1fc3be0ec4c$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};

});



parcelRegister("2emZ2", function(module, exports) {

$parcel$export(module.exports, "getTextRect", () => $19feb79b579d02ba$export$372ffda650a6e70d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4gEFv = parcelRequire("4gEFv");

var $2cFRc = parcelRequire("2cFRc");
function $19feb79b579d02ba$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
    (0, $2cFRc.deprecateLog)('getTextRect is deprecated.');
    var textEl = new (0, $4gEFv.default)({
        style: {
            text: text,
            font: font,
            align: align,
            verticalAlign: verticalAlign,
            padding: padding,
            rich: rich,
            overflow: truncate ? 'truncate' : null,
            lineHeight: lineHeight
        }
    });
    return textEl.getBoundingRect();
}

});




parcelRegister("aCu4v", function(module, exports) {

$parcel$export(module.exports, "PaletteMixin", () => $7bb4c79f78d718b0$export$55a3c39e852b90f4);
$parcel$export(module.exports, "getDecalFromPalette", () => $7bb4c79f78d718b0$export$e4d892222945a227);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");
var $7bb4c79f78d718b0$var$innerColor = (0, $eaKsF.makeInner)();
var $7bb4c79f78d718b0$var$innerDecal = (0, $eaKsF.makeInner)();
var $7bb4c79f78d718b0$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $eaKsF.normalizeToArray)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $7bb4c79f78d718b0$var$getFromPalette(this, $7bb4c79f78d718b0$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $7bb4c79f78d718b0$var$clearPalette(this, $7bb4c79f78d718b0$var$innerColor);
    };
    return PaletteMixin;
}();
function $7bb4c79f78d718b0$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $eaKsF.normalizeToArray)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $7bb4c79f78d718b0$var$getFromPalette(ecModel, $7bb4c79f78d718b0$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $7bb4c79f78d718b0$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length; // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $7bb4c79f78d718b0$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $7bb4c79f78d718b0$var$getNearestPalette(layeredPalette, requestNum); // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $7bb4c79f78d718b0$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}

});

parcelRegister("guzSc", function(module, exports) {

$parcel$export(module.exports, "DataFormatMixin", () => $c01b465ef25e12c0$export$f23396ae04ea95a7);
$parcel$export(module.exports, "normalizeTooltipFormatResult", () => $c01b465ef25e12c0$export$2d16fa82a50c4741);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $9OHWG = parcelRequire("9OHWG");

var $dCJrM = parcelRequire("dCJrM");

var $c01b465ef25e12c0$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $c01b465ef25e12c0$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $bahqM.isArray(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex); // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if (typeof formatter === 'function') {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if (typeof formatter === 'string') {
            var str = (0, $dCJrM.formatTpl)(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($c01b465ef25e12c0$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $9OHWG.retrieveRawValue)(data, dataIndex, dimLoose);
                if (extendParams && $bahqM.isArray(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $9OHWG.retrieveRawValue)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $c01b465ef25e12c0$export$2d16fa82a50c4741(result // markersExisting: Dictionary<ColorString>
) {
    var markupText; // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($bahqM.isObject(result)) {
        if (result.type) markupFragment = result;
         // else {
    } else markupText = result;
    return {
        markupText: markupText,
        // markers: markers || markersExisting,
        markupFragment: markupFragment
    };
}

});

parcelRegister("92IK1", function(module, exports) {

$parcel$export(module.exports, "createTask", () => $6957019fc0d13ee5$export$f7292ab7796be73c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
function $6957019fc0d13ee5$export$f7292ab7796be73c(define) {
    return new $6957019fc0d13ee5$export$2dea7024bcdd7731(define);
}
var $6957019fc0d13ee5$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip; // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
         // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
         // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $bahqM.isArray)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $6957019fc0d13ee5$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $6957019fc0d13ee5$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            } // To simplify no progress checking, array must has item.
            if ((0, $bahqM.isArray)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happend in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the setted end, in case
        // that the stub of dataZoom perform again and earse the
        // setted end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $6957019fc0d13ee5$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
         : current;
        current++;
        return result;
    }
}(); ///////////////////////////////////////////////////////////
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };

});

parcelRegister("jTNWo", function(module, exports) {

$parcel$export(module.exports, "SourceManager", () => $e7c9e4985e212cda$export$af4db9ec7e200ea2);
$parcel$export(module.exports, "disableTransformOptionMerge", () => $e7c9e4985e212cda$export$9451f4e9047441ec);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $20liu = parcelRequire("20liu");

var $2Rbm1 = parcelRequire("2Rbm1");

var $cNGs8 = parcelRequire("cNGs8");

var $05ab4 = parcelRequire("05ab4");

var $8c3gC = parcelRequire("8c3gC");

var $9OHWG = parcelRequire("9OHWG");
/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transfroms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $e7c9e4985e212cda$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = []; // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0; // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $bahqM.isTypedArray)(data) ? (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY) : (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL);
                upstreamSignList = [];
            } // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $bahqM.retrieve2)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $bahqM.retrieve2)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader) || null; // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $bahqM.retrieve2)(newMetaRawOption.dimensions, upMetaRawOption.dimensions); // We share source with dataset as much as possible
            // to avoid extra memroy cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $20liu.createSource)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost; // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $20liu.createSource)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $e7c9e4985e212cda$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $bahqM.each)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $e7c9e4985e212cda$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $05ab4.applyDataTransform)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $20liu.cloneSourceShallow)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
         // All sourceList is from the some upsteam.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By defualt 0, means "main source".
   *                    Most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($e7c9e4985e212cda$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $8c3gC.default)(); // Always create store from source of series.
                cachedStore.initData(new (0, $9OHWG.DefaultDataProvider)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PEDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // no need to update them when change happen.
        var sourceHost = this._sourceHost;
        if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
            var datasetModel = (0, $cNGs8.querySeriesUpstreamDatasetModel)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $bahqM.map)((0, $cNGs8.queryDatasetUpstreamDatasetModels)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $e7c9e4985e212cda$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $bahqM.setAsPrimitive)(datasetModel.option.transform);
}
function $e7c9e4985e212cda$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $e7c9e4985e212cda$var$doThrow(errMsg) {
    throw new Error(errMsg);
}

});
parcelRegister("05ab4", function(module, exports) {

$parcel$export(module.exports, "registerExternalTransform", () => $00f85ccb3288f539$export$92c96c6d8b255b7d);
$parcel$export(module.exports, "applyDataTransform", () => $00f85ccb3288f539$export$42a68f09db16803f);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2Rbm1 = parcelRequire("2Rbm1");

var $eaKsF = parcelRequire("eaKsF");

var $bahqM = parcelRequire("bahqM");

var $9OHWG = parcelRequire("9OHWG");

var $2G90t = parcelRequire("2G90t");

var $2cFRc = parcelRequire("2cFRc");

var $20liu = parcelRequire("20liu");
/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $00f85ccb3288f539$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * becuase transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $2G90t.parseDataValue)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $00f85ccb3288f539$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $00f85ccb3288f539$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN)) (0, $2cFRc.throwError)(errMsg);
     // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Becuase the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is relialbe and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $bahqM.each)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt); // Users probably not sepcify dimension name. For simplicity, data transform
        // do not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbid name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $bahqM.hasOwn)(dimsByName, name)) (0, $2cFRc.throwError)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
     // Implement public methods:
    var rawItemGetter = (0, $9OHWG.getRawSourceItemGetter)(sourceFormat, (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $bahqM.bind)($00f85ccb3288f539$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $bahqM.bind)($00f85ccb3288f539$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $9OHWG.getRawSourceDataCounter)(sourceFormat, (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN));
    extSource.count = (0, $bahqM.bind)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $9OHWG.getRawSourceValueGetter)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex]; // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $bahqM.bind)($00f85ccb3288f539$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $bahqM.bind)($00f85ccb3288f539$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $00f85ccb3288f539$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $2cFRc.throwError)(errMsg);
    }
    return upstream.data;
}
function $00f85ccb3288f539$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $2cFRc.throwError)(errMsg);
    }
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $bahqM.extend)({}, data[i]));
        return result;
    }
}
function $00f85ccb3288f539$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
     // Keep the same logic as `List::getDimension` did.
    if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
     || !isNaN(dim) && !(0, $bahqM.hasOwn)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $bahqM.hasOwn)(dimsByName, dim)) return dimsByName[dim];
}
function $00f85ccb3288f539$var$cloneAllDimensionInfo(dimensions) {
    return (0, $bahqM.clone)(dimensions);
}
var $00f85ccb3288f539$var$externalTransformMap = (0, $bahqM.createHashMap)();
function $00f85ccb3288f539$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $bahqM.clone)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $2cFRc.throwError)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $2cFRc.throwError)(errMsg);
     // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $00f85ccb3288f539$var$externalTransformMap.set(type, externalTransform);
}
function $00f85ccb3288f539$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $eaKsF.normalizeToArray)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $2cFRc.throwError)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $00f85ccb3288f539$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i); // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $00f85ccb3288f539$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $2cFRc.throwError)(errMsg);
    if (!(0, $bahqM.isObject)(transOption)) (0, $2cFRc.throwError)(errMsg);
    var transType = transOption.type;
    var externalTransform = $00f85ccb3288f539$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $2cFRc.throwError)(errMsg);
     // Prepare source
    var extUpSourceList = (0, $bahqM.map)(upSourceList, function(upSource) {
        return $00f85ccb3288f539$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $eaKsF.normalizeToArray)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $bahqM.clone)(transOption.config)
    }));
    var printStrArr;
    return (0, $bahqM.map)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $bahqM.isObject)(result)) (0, $2cFRc.throwError)(errMsg);
        if (!result.data) (0, $2cFRc.throwError)(errMsg);
        var sourceFormat = (0, $20liu.detectSourceFormat)(result.data);
        if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) (0, $2cFRc.throwError)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 // If transformer returns `dimensions`, it means that the transformer has different
         && !result.dimensions) {
            var startIndex = firstUpSource.startIndex; // We copy the header of upstream to the result becuase:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $20liu.createSource)(result.data, resultMetaRawOption, null);
    });
}
function $00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) || sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS);
}

});


parcelRegister("d88IV", function(module, exports) {

$parcel$export(module.exports, "defaultSeriesFormatTooltip", () => $98f2ca07d9209b02$export$3a110b9fb5c88b34);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $j5lKL = parcelRequire("j5lKL");

var $9OHWG = parcelRequire("9OHWG");

var $eaKsF = parcelRequire("eaKsF");
function $98f2ca07d9209b02$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $bahqM.isArray)(value);
    var markerColor = (0, $j5lKL.retrieveVisualColorForTooltipMarker)(series, dataIndex); // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks; // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $9OHWG.retrieveRawValue)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
     // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $eaKsF.isNameSpecified)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $j5lKL.createTooltipMarkup)('section', {
        header: seriesName,
        // When series name not specified, do not show a header line with only '-'.
        // This case alway happen in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $j5lKL.createTooltipMarkup)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $bahqM.trim)(inlineName),
                value: inlineValue,
                valueType: inlineValueType
            })
        ].concat(subBlocks || [])
    });
}
function $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $bahqM.reduce)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $bahqM.each)(tooltipDims, function(dim) {
        setEachItem((0, $9OHWG.retrieveRawValue)(data, dataIndex, dim), dim);
    }) // By default, all dims is used on tooltip.
     : (0, $bahqM.each)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $j5lKL.createTooltipMarkup)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}

});
parcelRegister("j5lKL", function(module, exports) {

$parcel$export(module.exports, "createTooltipMarkup", () => $de4f5bb7bbbcf45e$export$cf63b23ce77d1921);
$parcel$export(module.exports, "buildTooltipMarkup", () => $de4f5bb7bbbcf45e$export$6969ffb02c1cb49a);
$parcel$export(module.exports, "retrieveVisualColorForTooltipMarker", () => $de4f5bb7bbbcf45e$export$ea15628039c0fa93);
$parcel$export(module.exports, "getPaddingFromTooltipModel", () => $de4f5bb7bbbcf45e$export$3048212c802df496);
$parcel$export(module.exports, "TooltipMarkupStyleCreator", () => $de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dCJrM = parcelRequire("dCJrM");

var $bahqM = parcelRequire("bahqM");

var $2G90t = parcelRequire("2G90t");

var $jmSNG = parcelRequire("jmSNG");
var $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1'; // TODO: more textStyle option
function $de4f5bb7bbbcf45e$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || '#6e7079';
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || '#464646';
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $dCJrM.encodeHTML)(nameFontSize + '') + "px;color:" + (0, $dCJrM.encodeHTML)(nameFontColor) + ";font-weight:" + (0, $dCJrM.encodeHTML)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $dCJrM.encodeHTML)(valueFontSize + '') + "px;color:" + (0, $dCJrM.encodeHTML)(valueFontColor) + ";font-weight:" + (0, $dCJrM.encodeHTML)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
} // See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $de4f5bb7bbbcf45e$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
]; // eslint-disable-next-line max-len
function $de4f5bb7bbbcf45e$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $de4f5bb7bbbcf45e$var$getBuilder(fragment) {
    return (0, $bahqM.hasOwn)($de4f5bb7bbbcf45e$var$builderMap, fragment.type) && $de4f5bb7bbbcf45e$var$builderMap[fragment.type];
}
var $de4f5bb7bbbcf45e$var$builderMap = {
    /**
   * A `section` block is like:
   * ```
   * header
   * subBlock
   * subBlock
   * ...
   * ```
   */ section: {
        planLayout: function(fragment) {
            var subBlockLen = fragment.blocks.length;
            var thisBlockHasInnerGap = subBlockLen > 1 || subBlockLen > 0 && !fragment.noHeader;
            var thisGapLevelBetweenSubBlocks = 0;
            (0, $bahqM.each)(fragment.blocks, function(subBlock) {
                $de4f5bb7bbbcf45e$var$getBuilder(subBlock).planLayout(subBlock);
                var subGapLevel = subBlock.__gapLevelBetweenSubBlocks; // If the some of the sub-blocks have some gaps (like 10px) inside, this block
                // should use a larger gap (like 20px) to distinguish those sub-blocks.
                if (subGapLevel >= thisGapLevelBetweenSubBlocks) thisGapLevelBetweenSubBlocks = subGapLevel + (thisBlockHasInnerGap && (!subGapLevel // If no header, always keep the sub gap level. Otherwise
                 || subBlock.type === 'section' && !subBlock.noHeader) ? 1 : 0);
            });
            fragment.__gapLevelBetweenSubBlocks = thisGapLevelBetweenSubBlocks;
        },
        build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
            var noHeader = fragment.noHeader;
            var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
            var subMarkupText = $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, noHeader ? topMarginForOuterGap : gaps.html, toolTipTextStyle);
            if (noHeader) return subMarkupText;
            var displayableHeader = (0, $dCJrM.makeValueReadable)(fragment.header, 'ordinal', ctx.useUTC);
            var nameStyle = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
            if (ctx.renderMode === 'richText') return $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
            else return $de4f5bb7bbbcf45e$var$wrapBlockHTML("<div style=\"" + nameStyle + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + (0, $dCJrM.encodeHTML)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
        }
    },
    /**
   * A `nameValue` block is like:
   * ```
   * marker  name  value
   * ```
   */ nameValue: {
        planLayout: function(fragment) {
            fragment.__gapLevelBetweenSubBlocks = 0;
        },
        build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
            var renderMode = ctx.renderMode;
            var noName = fragment.noName;
            var noValue = fragment.noValue;
            var noMarker = !fragment.markerType;
            var name = fragment.name;
            var value = fragment.value;
            var useUTC = ctx.useUTC;
            if (noName && noValue) return;
            var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
            var readableName = noName ? '' : (0, $dCJrM.makeValueReadable)(name, 'ordinal', useUTC);
            var valueTypeOption = fragment.valueType;
            var readableValueList = noValue ? [] : (0, $bahqM.isArray)(value) ? (0, $bahqM.map)(value, function(val, idx) {
                return (0, $dCJrM.makeValueReadable)(val, (0, $bahqM.isArray)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
            }) : [
                (0, $dCJrM.makeValueReadable)(value, (0, $bahqM.isArray)(valueTypeOption) ? valueTypeOption[0] : valueTypeOption, useUTC)
            ];
            var valueAlignRight = !noMarker || !noName; // It little weird if only value next to marker but far from marker.
            var valueCloseToMarker = !noMarker && noName;
            var _a = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
            return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, readableName, nameStyle) // Value has commas inside, so use ' ' as delimiter for multiple values.
            ) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $de4f5bb7bbbcf45e$var$wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
        }
    }
};
function $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, topMarginForOuterGap, tooltipTextStyle) {
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $bahqM.assert)(!subBlocks || (0, $bahqM.isArray)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $bahqM.hasOwn)(orderMap, orderMode)) {
            var comparator_1 = new (0, $2G90t.SortOrderComparator)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
    (0, $bahqM.each)(subBlocks, function(subBlock, idx) {
        var subMarkupText = $de4f5bb7bbbcf45e$var$getBuilder(subBlock).build(ctx, subBlock, idx > 0 ? gaps.html : 0, tooltipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    if (!subMarkupTextList.length) return;
    return ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $de4f5bb7bbbcf45e$var$wrapBlockHTML(subMarkupTextList.join(''), topMarginForOuterGap);
}
function $de4f5bb7bbbcf45e$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $de4f5bb7bbbcf45e$var$getBuilder(fragment);
    builder.planLayout(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator
    };
    return builder.build(ctx, fragment, 0, toolTipTextStyle);
}
function $de4f5bb7bbbcf45e$var$getGap(fragment) {
    var gapLevelBetweenSubBlocks = fragment.__gapLevelBetweenSubBlocks;
    return {
        html: $de4f5bb7bbbcf45e$var$HTML_GAPS[gapLevelBetweenSubBlocks],
        richText: $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS[gapLevelBetweenSubBlocks]
    };
}
function $de4f5bb7bbbcf45e$var$wrapBlockHTML(encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    return "<div style=\"" + marginCSS + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
}
function $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $dCJrM.encodeHTML)(name) + '</span>';
}
function $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    return "<span style=\"" + alignCSS + ";" + style + "\">" // Value has commas inside, so use '  ' as delimiter for multiple values.
     + (0, $bahqM.map)(valueList, function(value) {
        return (0, $dCJrM.encodeHTML)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, valueList, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    }); // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle(valueList.join('  '), styles);
}
function $de4f5bb7bbbcf45e$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $dCJrM.convertToColorString)(color);
}
function $de4f5bb7bbbcf45e$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding // We give slightly different to look pretty.
     : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {}; // Notice that "generate a style name" usuall happens repeatly when mouse moving and
        // displaying a tooltip. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $jmSNG.getRandomIdBase)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $dCJrM.getTooltipMarker)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $bahqM.isString)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $bahqM.isArray)(styles)) (0, $bahqM.each)(styles, function(stl) {
            return (0, $bahqM.extend)(finalStl, stl);
        });
        else (0, $bahqM.extend)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();

});



parcelRegister("7yklO", function(module, exports) {

$parcel$export(module.exports, "symbolBuildProxies", () => $57fb7e9c020cd915$export$33fc3b478d332725);
$parcel$export(module.exports, "createSymbol", () => $57fb7e9c020cd915$export$af050e04da3a02e8);
$parcel$export(module.exports, "normalizeSymbolSize", () => $57fb7e9c020cd915$export$a84524f03e8e8dfb);
$parcel$export(module.exports, "normalizeSymbolOffset", () => $57fb7e9c020cd915$export$e3e292895c033f6d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory

var $bahqM = parcelRequire("bahqM");
parcelRequire("fHITF");
var $jjfok = parcelRequire("jjfok");
var $cZb1F = parcelRequire("cZb1F");
var $fHITF = parcelRequire("fHITF");
var $ghQ8v = parcelRequire("ghQ8v");
var $7Tw7u = parcelRequire("7Tw7u");

var $1E3E8 = parcelRequire("1E3E8");

var $b7ZX8 = parcelRequire("b7ZX8");

var $jmSNG = parcelRequire("jmSNG");
/**
 * Triangle shape
 * @inner
 */ var $57fb7e9c020cd915$var$Triangle = $ghQ8v.default.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $57fb7e9c020cd915$var$Diamond = $ghQ8v.default.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $57fb7e9c020cd915$var$Pin = $ghQ8v.default.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3; // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2; // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $57fb7e9c020cd915$var$Arrow = $ghQ8v.default.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path contructors
 */ // TODO Use function to build symbol path.
var $57fb7e9c020cd915$var$symbolCtors = {
    line: $cZb1F.default,
    rect: $7Tw7u.default,
    roundRect: $7Tw7u.default,
    square: $7Tw7u.default,
    circle: $jjfok.default,
    diamond: $57fb7e9c020cd915$var$Diamond,
    pin: $57fb7e9c020cd915$var$Pin,
    arrow: $57fb7e9c020cd915$var$Arrow,
    triangle: $57fb7e9c020cd915$var$Triangle
};
var $57fb7e9c020cd915$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $57fb7e9c020cd915$export$33fc3b478d332725 = {};
(0, $bahqM.each)($57fb7e9c020cd915$var$symbolCtors, function(Ctor, name) {
    $57fb7e9c020cd915$export$33fc3b478d332725[name] = new Ctor();
});
var $57fb7e9c020cd915$var$SymbolClz = $ghQ8v.default.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $b7ZX8.calculateTextPosition)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
            }
            $57fb7e9c020cd915$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
function $57fb7e9c020cd915$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || '#fff'; // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $57fb7e9c020cd915$export$af050e04da3a02e8(symbolType, x, y, w, h, color, keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $fHITF.makeImage(symbolType.slice(8), new (0, $1E3E8.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $fHITF.makePath(symbolType.slice(7), {}, new (0, $1E3E8.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $57fb7e9c020cd915$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty; // TODO Should deprecate setColor
    symbolPath.setColor = $57fb7e9c020cd915$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $57fb7e9c020cd915$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $bahqM.isArray)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $57fb7e9c020cd915$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $bahqM.isArray)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $jmSNG.parsePercent)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $jmSNG.parsePercent)((0, $bahqM.retrieve2)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}

});


parcelRegister("cDBtZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $933633d411d7f701$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $5DXGq = parcelRequire("5DXGq");

var $lUzII = parcelRequire("lUzII");

var $7HTYE = parcelRequire("7HTYE");

var $4KVOr = parcelRequire("4KVOr");
var $eYgMC = parcelRequire("eYgMC");
var $9J7f8 = parcelRequire("9J7f8");
var $4gEFv = parcelRequire("4gEFv");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $eaKsF = parcelRequire("eaKsF");

var $jconq = parcelRequire("jconq");

var $loerw = parcelRequire("loerw");

var $JBb7Y = parcelRequire("JBb7Y");

var $5fMzf = parcelRequire("5fMzf");

var $40dMe = parcelRequire("40dMe");

var $fIXXx = parcelRequire("fIXXx");

var $gvLUt = parcelRequire("gvLUt");

var $5MLZz = parcelRequire("5MLZz");

var $7QjoM = parcelRequire("7QjoM");

var $8fK8Y = parcelRequire("8fK8Y");

var $dCJrM = parcelRequire("dCJrM");

var $d6udH = parcelRequire("d6udH");
function $933633d411d7f701$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $933633d411d7f701$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $933633d411d7f701$var$getBoundingDiff(points1, points2) {
    var _a = $933633d411d7f701$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $933633d411d7f701$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1]; // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $933633d411d7f701$var$getSmooth(smooth) {
    return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
}
function $933633d411d7f701$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $8fK8Y.createFloat32Array)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $JBb7Y.getStackedOnPoint)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
function $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, stepTurnAt) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    for(; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case 'end':
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case 'middle':
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    } // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $933633d411d7f701$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length; // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $d6udH.lerp)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
             // All following stop will be out of range. So just ignore them.
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0)); // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $933633d411d7f701$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual('visualMeta');
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== 'cartesian2d') return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
        if (coordDim === 'x' || coordDim === 'y') {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
     // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim); // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $bahqM.map(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $933633d411d7f701$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 0; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return 'transparent';
    $bahqM.each(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || 'transparent'
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || 'transparent'
    });
    var gradient = new $9J7f8.default(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + '2'] = maxCoord;
    return gradient;
}
function $933633d411d7f701$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get('showAllSymbol');
    var isAuto = showAllSymbol === 'auto';
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
    if (!categoryAxis) return;
     // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto // Simplify the logic, do not determine label overlap here.
     && $933633d411d7f701$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
     // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $bahqM.each(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $933633d411d7f701$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In mose cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $lUzII.default).getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
        )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
         * 1.5 > availSize) return false;
    }
    return true;
}
function $933633d411d7f701$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $933633d411d7f701$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$933633d411d7f701$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $933633d411d7f701$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $933633d411d7f701$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === 'x' ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $933633d411d7f701$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        'endLabel',
        'show'
    ])) return true;
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        if (seriesModel.get([
            (0, $fIXXx.SPECIAL_STATES)[i],
            'endLabel',
            'show'
        ])) return true;
    }
    return false;
}
function $933633d411d7f701$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $40dMe.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
        var endLabelModel_1 = seriesModel.getModel('endLabel');
        var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $933633d411d7f701$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $5fMzf.createGridClipPath)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during); // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get('clip', true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        } // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $5fMzf.createPolarClipPath)(coordSys, hasAnimation, seriesModel);
}
function $933633d411d7f701$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
    var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
    return {
        normal: {
            align: endLabelModel.get('align') || align,
            verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
        }
    };
}
var $933633d411d7f701$var$LineView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $4KVOr.default();
        var symbolDraw = new (0, $5DXGq.default)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel('lineStyle');
        var areaStyleModel = seriesModel.getModel('areaStyle');
        var points = data.getLayout('points') || [];
        var isCoordSysPolar = coordSys.type === 'polar';
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = seriesModel.get('animation');
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get('origin');
        var dataCoordInfo = (0, $JBb7Y.prepareDataCoordInfo)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $933633d411d7f701$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get('showSymbol');
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $933633d411d7f701$var$getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        }); // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup); // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get('step') : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
            clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $933633d411d7f701$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')]; // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                // TODO If stacked series is not step
                points = $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, step);
                if (stackedOnPoints) stackedOnPoints = $933633d411d7f701$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
             // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $dCJrM.convertToColorString)(visualColor));
            lineGroup.setClipPath($933633d411d7f701$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            } // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $dCJrM.convertToColorString)(visualColor));
             // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $933633d411d7f701$var$createLineClipPath(this, coordSys, false, seriesModel);
                $eYgMC.initProps(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($933633d411d7f701$var$createLineClipPath(this, coordSys, true, seriesModel));
             // Always update, or it is wrong in the case turning on legend
            // because points are not changed
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            }); // In the case data zoom triggerred refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing
            if (!$933633d411d7f701$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$933633d411d7f701$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
                else {
                    // Not do it in update with animation
                    if (step) {
                        // TODO If stacked series is not step
                        points = $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, step);
                        if (stackedOnPoints) stackedOnPoints = $933633d411d7f701$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var focus = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        polyline.useStyle($bahqM.defaults(lineStyleModel.getLineStyle(), {
            fill: 'none',
            stroke: visualColor,
            lineJoin: 'bevel'
        }));
        (0, $fIXXx.setStatesStylesFromModel)(polyline, seriesModel, 'lineStyle');
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            'emphasis',
            'lineStyle',
            'width'
        ]) === 'bolder') {
            var emphasisLineStyle = polyline.getState('emphasis').style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        } // Needs seriesIndex for focus
        (0, $7QjoM.getECData)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $fIXXx.enableHoverEmphasis)(polyline, focus, blurScope);
        var smooth = $933633d411d7f701$var$getSmooth(seriesModel.get('smooth'));
        var smoothMonotone = seriesModel.get('smoothMonotone');
        var connectNulls = seriesModel.get('connectNulls');
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
            var stackedOnSmooth = 0;
            polygon.useStyle($bahqM.defaults(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: 'bevel',
                decal: data.getVisual('style').decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $933633d411d7f701$var$getSmooth(stackedOnSeries.get('smooth'));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $fIXXx.setStatesStylesFromModel)(polygon, seriesModel, 'areaStyle'); // Needs seriesIndex for focus
            (0, $7QjoM.getECData)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $fIXXx.enableHoverEmphasis)(polygon, focus, blurScope);
        }
        var changePolyState = function(toState) {
            _this._changePolyState(toState);
        };
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data; // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
    };
    LineView.prototype.dispose = function() {};
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $eaKsF.queryDataIndex(data, payload);
        this._changePolyState('emphasis');
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout('points');
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                 // fix #11360: should't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get('zlevel');
                var z = seriesModel.get('z');
                symbol = new (0, $lUzII.default)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z); // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $loerw.default).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $eaKsF.queryDataIndex(data, payload);
        this._changePolyState('normal');
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $loerw.default).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $fIXXx.setStatesFlag)(this._polyline, toState);
        polygon && (0, $fIXXx.setStatesFlag)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline; // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $jconq.ECPolyline)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon; // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $jconq.ECPolygon)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === 'cartesian2d') {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === 'polar') {
            isHorizontalOrRadial = baseAxis.dim === 'angle';
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get('animationDuration');
        if (typeof seriesDuration === 'function') seriesDuration = seriesDuration(null);
        var seriesDalay = seriesModel.get('animationDelay') || 0;
        var seriesDalayValue = typeof seriesDalay === 'function' ? seriesDalay(null) : seriesDalay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = typeof seriesDalay === 'function' ? seriesDalay(idx) : seriesDuration * ratio + seriesDalayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel('endLabel');
        if ($933633d411d7f701$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $4gEFv.default({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            } // Find last non-NaN data to display data
            var dataIndex = $933633d411d7f701$var$getLastIndexNotNull(data_2.getLayout('points'));
            if (dataIndex >= 0) {
                (0, $gvLUt.setLabelStyle)(polyline, (0, $gvLUt.getLabelStatesModels)(seriesModel, 'endLabel'), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $5MLZz.getDefaultInterpolatedLabel)(data_2, interpolatedValue) : (0, $5MLZz.getDefaultLabel)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $933633d411d7f701$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout('points');
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get('connectNulls');
            var precision = endLabelModel.get('precision');
            var distance = endLabelModel.get('distance') || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? 'x' : 'y';
            var dataIndexRange = $933633d411d7f701$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $933633d411d7f701$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $eaKsF.interpolateRawValues(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $933633d411d7f701$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) (0, $gvLUt.labelInner)(endLabel).setLabelText(value);
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $7HTYE.default)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            current = $933633d411d7f701$var$turnPointsIntoStep(diff.current, coordSys, step);
            stackedOnCurrent = $933633d411d7f701$var$turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
            next = $933633d411d7f701$var$turnPointsIntoStep(diff.next, coordSys, step);
            stackedOnNext = $933633d411d7f701$var$turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
        } // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($933633d411d7f701$var$getBoundingDiff(current, next) > 3000 || polygon && $933633d411d7f701$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        }; // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
         // Stop previous animation.
        polyline.stopAnimation();
        $eYgMC.updateProps(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $eYgMC.updateProps(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel); // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === '=') {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = 'line';
    return LineView;
}((0, $loerw.default));
var $933633d411d7f701$export$2e2bcd8739ae039 = $933633d411d7f701$var$LineView;

});
parcelRegister("5DXGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $41bee41b01adf88e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4KVOr = parcelRequire("4KVOr");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $lUzII = parcelRequire("lUzII");

var $bahqM = parcelRequire("bahqM");

var $gvLUt = parcelRequire("gvLUt");
function $41bee41b01adf88e$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx) // We do not set clipShape on group, because it will cut part of
    ) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
function $41bee41b01adf88e$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $bahqM.isObject)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $41bee41b01adf88e$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel('emphasis');
    return {
        emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle(),
        focus: emphasisModel.get('focus'),
        blurScope: emphasisModel.get('blurScope'),
        hoverScale: emphasisModel.get('scale'),
        labelStatesModels: (0, $gvLUt.getLabelStatesModels)(seriesModel),
        cursorStyle: seriesModel.get('cursor')
    };
}
var $41bee41b01adf88e$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $4KVOr.default();
        this._SymbolCtor = SymbolCtor || (0, $lUzII.default);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        opt = $41bee41b01adf88e$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $41bee41b01adf88e$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        }; // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($41bee41b01adf88e$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$41bee41b01adf88e$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl // Create a new if symbol type changed.
             || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $eYgMC.updateProps(symbolEl, target, seriesModel);
            } // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            });
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.isPersistent = function() {
        return true;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $41bee41b01adf88e$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        opt = $41bee41b01adf88e$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($41bee41b01adf88e$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
            }
        }
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data; // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            });
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $41bee41b01adf88e$export$2e2bcd8739ae039 = $41bee41b01adf88e$var$SymbolDraw;

});
parcelRegister("lUzII", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff3a893c22158f47$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $7yklO = parcelRequire("7yklO");

var $4KVOr = parcelRequire("4KVOr");
var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $7QjoM = parcelRequire("7QjoM");

var $fIXXx = parcelRequire("fIXXx");

var $5MLZz = parcelRequire("5MLZz");

var $bahqM = parcelRequire("bahqM");

var $gvLUt = parcelRequire("gvLUt");

var $gcbBH = parcelRequire("gcbBH");

var $eYgMC = parcelRequire("eYgMC");
var $ff3a893c22158f47$var$Symbol = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
        // Remove paths created before
        this.removeAll(); // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $7yklO.createSymbol)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: 100,
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        }); // Rewrite drift method
        symbolPath.drift = $ff3a893c22158f47$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $fIXXx.enterEmphasis)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $fIXXx.leaveEmphasis)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
            this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $eYgMC.updateProps(symbolPath, target, seriesModel, idx);
            (0, $eYgMC.saveOldStyle)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $eYgMC.initProps(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop remove animation manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation('remove');
        this._seriesModel = seriesModel;
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            selectItemStyle = itemModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            labelStatesModels = (0, $gvLUt.getLabelStatesModels)(itemModel);
            hoverScale = emphasisModel.getShallow('scale');
            cursorStyle = itemModel.getShallow('cursor');
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $7yklO.normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr('cursor', cursorStyle);
        var symbolStyle = data.getItemVisual(idx, 'style');
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $gcbBH.default)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $bahqM.extend)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $bahqM.extend)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
             // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, 'liftZ');
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $gvLUt.setLabelStyle)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        }); // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $5MLZz.getDefaultLabel)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState('emphasis');
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState('select').style = selectItemStyle;
        symbolPath.ensureState('blur').style = blurItemStyle;
        if (hoverScale) {
            var scaleRatio = Math.max(1.1, 3 / this._sizeY);
            emphasisState.scaleX = this._sizeX * scaleRatio;
            emphasisState.scaleY = this._sizeY * scaleRatio;
        }
        this.setSymbolScale(1);
        (0, $fIXXx.enableHoverEmphasis)(this, focus, blurScope);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, opt) {
        var symbolPath = this.childAt(0);
        var seriesModel = this._seriesModel;
        var dataIndex = (0, $7QjoM.getECData)(this).dataIndex;
        var animationOpt = opt && opt.animation; // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true; // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $eYgMC.removeElement(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $eYgMC.removeElement(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $7yklO.normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
    };
    return Symbol;
}($4KVOr.default);
function $ff3a893c22158f47$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $ff3a893c22158f47$export$2e2bcd8739ae039 = $ff3a893c22158f47$var$Symbol;

});
parcelRegister("5MLZz", function(module, exports) {

$parcel$export(module.exports, "getDefaultLabel", () => $4366a9b1a430c1e7$export$5ff20667590927ed);
$parcel$export(module.exports, "getDefaultInterpolatedLabel", () => $4366a9b1a430c1e7$export$5f84815e91ca6775);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9OHWG = parcelRequire("9OHWG");

var $bahqM = parcelRequire("bahqM");
function $4366a9b1a430c1e7$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $9OHWG.retrieveRawValue)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $9OHWG.retrieveRawValue)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $4366a9b1a430c1e7$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $bahqM.isArray)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}

});



parcelRegister("7HTYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c7f87717a036e4$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $JBb7Y = parcelRequire("JBb7Y");

var $8fK8Y = parcelRequire("8fK8Y");
function $59c7f87717a036e4$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: '+',
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: '=',
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: '-',
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $59c7f87717a036e4$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $59c7f87717a036e4$var$diffData(oldData, newData); // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = []; // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $JBb7Y.prepareDataCoordInfo)(oldCoordSys, newData, oldValueOrigin); // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout('points') || [];
    var newPoints = newData.getLayout('points') || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0; // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case '=':
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1]; // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case '+':
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $JBb7Y.getStackedOnPoint)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case '-':
                pointAdded = false;
        } // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    } // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $8fK8Y.createFloat32Array)(len);
    var sortedNextPoints = (0, $8fK8Y.createFloat32Array)(len);
    var sortedCurrStackedPoints = (0, $8fK8Y.createFloat32Array)(len);
    var sortedNextStackedPoints = (0, $8fK8Y.createFloat32Array)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}

});
parcelRegister("JBb7Y", function(module, exports) {

$parcel$export(module.exports, "prepareDataCoordInfo", () => $08910af48116f194$export$b488a529581b37e);
$parcel$export(module.exports, "getStackedOnPoint", () => $08910af48116f194$export$c1601aa630e7b5f8);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5R8Hi = parcelRequire("5R8Hi");

var $bahqM = parcelRequire("bahqM");
function $08910af48116f194$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $08910af48116f194$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
    var dims = (0, $bahqM.map)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo('stackResultDimension');
    if ((0, $5R8Hi.isDimensionStacked)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $5R8Hi.isDimensionStacked)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
    };
}
function $08910af48116f194$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === 'start') valueStart = extent[0];
    else if (valueOrigin === 'end') valueStart = extent[1];
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
         // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $08910af48116f194$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}

});

parcelRegister("8fK8Y", function(module, exports) {

$parcel$export(module.exports, "createFloat32Array", () => $602384a5ad582433$export$21d2298f3f56bbaf);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
/* global Float32Array */ var $602384a5ad582433$var$supportFloat32Array = typeof Float32Array !== 'undefined';
var $602384a5ad582433$var$Float32ArrayCtor = !$602384a5ad582433$var$supportFloat32Array ? Array : Float32Array;
function $602384a5ad582433$export$21d2298f3f56bbaf(arg) {
    if ((0, $bahqM.isArray)(arg)) // Return self directly if don't support TypedArray.
    return $602384a5ad582433$var$supportFloat32Array ? new Float32Array(arg) : arg;
     // Else is number
    return new $602384a5ad582433$var$Float32ArrayCtor(arg);
}

});


parcelRegister("jconq", function(module, exports) {

$parcel$export(module.exports, "ECPolyline", () => $dfa20c0939f7b781$export$bf7c0585b8f7d00f);
$parcel$export(module.exports, "ECPolygon", () => $dfa20c0939f7b781$export$6042a400d113f2bd);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $aA4Ws = parcelRequire("aA4Ws");

var $dr1jo = parcelRequire("dr1jo");
var $dfa20c0939f7b781$var$mathMin = Math.min;
var $dfa20c0939f7b781$var$mathMax = Math.max;
function $dfa20c0939f7b781$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $dfa20c0939f7b781$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($dfa20c0939f7b781$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY; // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($dfa20c0939f7b781$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0; // Is last point
                if (tmpK >= segLen || $dfa20c0939f7b781$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === 'x') {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        cpx1 = x - lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + lenPrevSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === 'y') {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        cpx1 = x;
                        cpy1 = y - lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + lenPrevSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1); // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg); // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg; // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $dfa20c0939f7b781$var$mathMin(nextCpx0, $dfa20c0939f7b781$var$mathMax(nextX, x));
                        nextCpy0 = $dfa20c0939f7b781$var$mathMin(nextCpy0, $dfa20c0939f7b781$var$mathMax(nextY, y));
                        nextCpx0 = $dfa20c0939f7b781$var$mathMax(nextCpx0, $dfa20c0939f7b781$var$mathMin(nextX, x));
                        nextCpy0 = $dfa20c0939f7b781$var$mathMax(nextCpy0, $dfa20c0939f7b781$var$mathMin(nextY, y)); // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg; // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $dfa20c0939f7b781$var$mathMin(cpx1, $dfa20c0939f7b781$var$mathMax(prevX, x));
                        cpy1 = $dfa20c0939f7b781$var$mathMin(cpy1, $dfa20c0939f7b781$var$mathMax(prevY, y));
                        cpx1 = $dfa20c0939f7b781$var$mathMax(cpx1, $dfa20c0939f7b781$var$mathMin(prevX, x));
                        cpy1 = $dfa20c0939f7b781$var$mathMax(cpy1, $dfa20c0939f7b781$var$mathMin(prevY, y)); // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $dfa20c0939f7b781$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $dfa20c0939f7b781$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polyline';
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $dfa20c0939f7b781$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2; // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$dfa20c0939f7b781$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$dfa20c0939f7b781$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $dfa20c0939f7b781$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $aA4Ws.default).CMD;
        var x0;
        var y0;
        var isDimX = dim === 'x';
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $dr1jo.cubicRootAt)(x0, x, x2, x3, xOrY, roots) : (0, $dr1jo.cubicRootAt)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $dr1jo.cubicAt)(y0, y, y2, y3, t_1) : (0, $dr1jo.cubicAt)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $ghQ8v.default));
var $dfa20c0939f7b781$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($dfa20c0939f7b781$var$ECPolylineShape);
var $dfa20c0939f7b781$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polygon';
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $dfa20c0939f7b781$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$dfa20c0939f7b781$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$dfa20c0939f7b781$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $dfa20c0939f7b781$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $dfa20c0939f7b781$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $ghQ8v.default));

});

parcelRegister("loerw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9270aeb44680e6f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $4KVOr = parcelRequire("4KVOr");

var $jvo6O = parcelRequire("jvo6O");

var $aLwh0 = parcelRequire("aLwh0");

var $eaKsF = parcelRequire("eaKsF");

var $fIXXx = parcelRequire("fIXXx");

var $92IK1 = parcelRequire("92IK1");

var $9irlK = parcelRequire("9irlK");
var $f9270aeb44680e6f$var$inner = $eaKsF.makeInner();
var $f9270aeb44680e6f$var$renderPlanner = (0, $9irlK.default)();
var $f9270aeb44680e6f$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $4KVOr.default)();
        this.uid = $jvo6O.getUID('viewChart');
        this.renderTask = (0, $92IK1.createTask)({
            plan: $f9270aeb44680e6f$var$renderTaskPlan,
            reset: $f9270aeb44680e6f$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'normal');
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    }; // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    }; // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $f9270aeb44680e6f$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit) {
    if (el) (state === 'emphasis' ? (0, $fIXXx.enterEmphasis) : (0, $fIXXx.leaveEmphasis))(el, highlightDigit);
}
function $f9270aeb44680e6f$var$toggleHighlight(data, payload, state) {
    var dataIndex = $eaKsF.queryDataIndex(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $fIXXx.getHighlightDigit)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $bahqM.each)($eaKsF.normalizeToArray(dataIndex), function(dataIdx) {
        $f9270aeb44680e6f$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit);
    });
}
$aLwh0.enableClassExtend($f9270aeb44680e6f$var$ChartView, [
    'dispose'
]);
$aLwh0.enableClassManagement($f9270aeb44680e6f$var$ChartView);
function $f9270aeb44680e6f$var$renderTaskPlan(context) {
    return $f9270aeb44680e6f$var$renderPlanner(context.model);
}
function $f9270aeb44680e6f$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload; // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $f9270aeb44680e6f$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
     : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $f9270aeb44680e6f$var$progressMethodMap[methodName];
}
var $f9270aeb44680e6f$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $f9270aeb44680e6f$export$2e2bcd8739ae039 = $f9270aeb44680e6f$var$ChartView;

});
parcelRegister("9irlK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c4b0292c57cf773$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");
function $6c4b0292c57cf773$export$2e2bcd8739ae039() {
    var inner = (0, $eaKsF.makeInner)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}

});


parcelRegister("5fMzf", function(module, exports) {

$parcel$export(module.exports, "createGridClipPath", () => $3d3406f7f3673e0b$export$83958787eb658d14);
$parcel$export(module.exports, "createPolarClipPath", () => $3d3406f7f3673e0b$export$13dc2b2230df3cb5);
$parcel$export(module.exports, "createClipPath", () => $3d3406f7f3673e0b$export$e0fe5081209d01c9);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");
var $elGBV = parcelRequire("elGBV");

var $jmSNG = parcelRequire("jmSNG");
function $3d3406f7f3673e0b$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
    x = Math.floor(x);
    width = Math.round(width);
    var clipPath = new $7Tw7u.default({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = typeof during === 'function' ? function(percent) {
            during(percent, clipPath);
        } : null;
        $eYgMC.initProps(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $3d3406f7f3673e0b$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $jmSNG.round)(sectorArea.r0, 1);
    var r = (0, $jmSNG.round)(sectorArea.r, 1);
    var clipPath = new $elGBV.default({
        shape: {
            cx: (0, $jmSNG.round)(polar.cx, 1),
            cy: (0, $jmSNG.round)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $eYgMC.initProps(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $3d3406f7f3673e0b$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $3d3406f7f3673e0b$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $3d3406f7f3673e0b$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}

});

parcelRegister("40dMe", function(module, exports) {

$parcel$export(module.exports, "isCoordinateSystemType", () => $2ea1d953c3a29c60$export$8567506e6336616);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $2ea1d953c3a29c60$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}

});


parcelRegister("5xgWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $407d2c4ef7fb34bc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $9irlK = parcelRequire("9irlK");

var $5R8Hi = parcelRequire("5R8Hi");

var $8fK8Y = parcelRequire("8fK8Y");
function $407d2c4ef7fb34bc$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $9irlK.default)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $bahqM.map)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            if ((0, $5R8Hi.isDimensionStacked)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $5R8Hi.isDimensionStacked)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $8fK8Y.createFloat32Array)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i); // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i); // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout('points', points);
                }
            };
        }
    };
}

});

parcelRegister("7jcIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $55242d779d1fe9b5$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $55242d779d1fe9b5$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
         // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $55242d779d1fe9b5$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $55242d779d1fe9b5$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count(); // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio(); // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if (typeof sampling === 'string') sampler = $55242d779d1fe9b5$var$samplers[sampling];
                    else if (typeof sampling === 'function') sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $55242d779d1fe9b5$var$indexSampler));
                }
            }
        }
    };
}

});


parcelRegister("6OGL8", function(module, exports) {

$parcel$export(module.exports, "install", () => $4f6894ac64afab25$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iWOYl = parcelRequire("iWOYl");

var $hi3Y7 = parcelRequire("hi3Y7");

var $alpND = parcelRequire("alpND");
function $4f6894ac64afab25$export$4b3e715f166fdd78(registers) {
    (0, $alpND.use)((0, $iWOYl.install));
    (0, $alpND.use)((0, $hi3Y7.install));
}

});
parcelRegister("iWOYl", function(module, exports) {

$parcel$export(module.exports, "install", () => $dcb52eca8f57248f$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $fkskt = parcelRequire("fkskt");

var $9sf2Q = parcelRequire("9sf2Q");
parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");

var $bahqM = parcelRequire("bahqM");

var $1UrP6 = parcelRequire("1UrP6");

var $aLiaH = parcelRequire("aLiaH");

var $1xCHp = parcelRequire("1xCHp");

var $2rHnA = parcelRequire("2rHnA");
var $dcb52eca8f57248f$var$GridView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $7Tw7u.default)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $bahqM.defaults)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $fkskt.default));
var $dcb52eca8f57248f$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $dcb52eca8f57248f$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($dcb52eca8f57248f$var$GridView);
    registers.registerComponentModel((0, $9sf2Q.default));
    registers.registerCoordinateSystem('cartesian2d', (0, $1xCHp.default));
    (0, $aLiaH.default)(registers, 'x', (0, $1UrP6.CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
    (0, $aLiaH.default)(registers, 'y', (0, $1UrP6.CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
    registers.registerComponentView((0, $2rHnA.CartesianXAxisView));
    registers.registerComponentView((0, $2rHnA.CartesianYAxisView));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}

});
parcelRegister("fkskt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28eb2e2a247a7d9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4KVOr = parcelRequire("4KVOr");

var $jvo6O = parcelRequire("jvo6O");

var $aLwh0 = parcelRequire("aLwh0");
var $b28eb2e2a247a7d9$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $4KVOr.default)();
        this.uid = $jvo6O.getUID('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {};
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {};
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {};
    /**
   * Hook for blur target series.
   * Can be used in marker for blur the markers
   */ ComponentView.prototype.blurSeries = function(seriesModels, ecModel) {};
    return ComponentView;
}();
$aLwh0.enableClassExtend($b28eb2e2a247a7d9$var$ComponentView);
$aLwh0.enableClassManagement($b28eb2e2a247a7d9$var$ComponentView);
var $b28eb2e2a247a7d9$export$2e2bcd8739ae039 = $b28eb2e2a247a7d9$var$ComponentView;

});

parcelRegister("9sf2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e226630804759b0$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h4UlH = parcelRequire("h4UlH");
var $6e226630804759b0$var$GridModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        zlevel: 0,
        z: 0,
        left: '10%',
        top: 60,
        right: '10%',
        bottom: 70,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: 'rgba(0,0,0,0)',
        borderWidth: 1,
        borderColor: '#ccc'
    };
    return GridModel;
}((0, $h4UlH.default));
var $6e226630804759b0$export$2e2bcd8739ae039 = $6e226630804759b0$var$GridModel;

});

parcelRegister("1UrP6", function(module, exports) {

$parcel$export(module.exports, "CartesianAxisModel", () => $16409a80acd4e1a4$export$483dc37e6ad83a3c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $h4UlH = parcelRequire("h4UlH");

var $5pBRm = parcelRequire("5pBRm");

var $eaKsF = parcelRequire("eaKsF");
var $16409a80acd4e1a4$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $eaKsF.SINGLE_REFERRING)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $h4UlH.default));
$bahqM.mixin($16409a80acd4e1a4$export$483dc37e6ad83a3c, (0, $5pBRm.AxisModelCommonMixin));
var $16409a80acd4e1a4$export$2e2bcd8739ae039 = $16409a80acd4e1a4$export$483dc37e6ad83a3c;

});
parcelRegister("5pBRm", function(module, exports) {

$parcel$export(module.exports, "AxisModelCommonMixin", () => $3f0ca7b2a67ba541$export$5c54b224726edb5a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $3f0ca7b2a67ba541$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();

});


parcelRegister("aLiaH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d5c63a9e257cb04$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $erX9x = parcelRequire("erX9x");

var $65MS1 = parcelRequire("65MS1");

var $6Vrdy = parcelRequire("6Vrdy");

var $7vTvv = parcelRequire("7vTvv");

var $bahqM = parcelRequire("bahqM");
function $7d5c63a9e257cb04$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $bahqM.each)((0, $7vTvv.AXIS_TYPES), function(v, axisType) {
        var defaultOption = (0, $bahqM.merge)((0, $bahqM.merge)({}, (0, $erX9x.default)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $3VFsf.__extends)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $65MS1.fetchLayoutMode)(this);
                var inputPositionParams = layoutMode ? (0, $65MS1.getLayoutParams)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $bahqM.merge)(option, themeModel.get(axisType + 'Axis'));
                (0, $bahqM.merge)(option, this.getDefaultOption());
                option.type = $7d5c63a9e257cb04$var$getAxisType(option);
                if (layoutMode) (0, $65MS1.mergeLayoutParam)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $6Vrdy.default).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option; // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $7d5c63a9e257cb04$var$getAxisType);
}
function $7d5c63a9e257cb04$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}

});
parcelRegister("erX9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85178cf0b0fc4bc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $a85178cf0b0fc4bc$var$defaultOption = {
    show: true,
    zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: '#6E7079',
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        lineStyle: {
            color: [
                '#E0E6F1'
            ],
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                'rgba(250,250,250,0.2)',
                'rgba(210,219,238,0.2)'
            ]
        }
    }
};
var $a85178cf0b0fc4bc$var$categoryAxis = $bahqM.merge({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $a85178cf0b0fc4bc$var$defaultOption);
var $a85178cf0b0fc4bc$var$valueAxis = $bahqM.merge({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Lenght of minor tick
        length: 3,
        // Line style
        lineStyle: {}
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: '#F4F7FD',
            width: 1
        }
    }
}, $a85178cf0b0fc4bc$var$defaultOption);
var $a85178cf0b0fc4bc$var$timeAxis = $bahqM.merge({
    scale: true,
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $a85178cf0b0fc4bc$var$valueAxis);
var $a85178cf0b0fc4bc$var$logAxis = $bahqM.defaults({
    scale: true,
    logBase: 10
}, $a85178cf0b0fc4bc$var$valueAxis);
var $a85178cf0b0fc4bc$export$2e2bcd8739ae039 = {
    category: $a85178cf0b0fc4bc$var$categoryAxis,
    value: $a85178cf0b0fc4bc$var$valueAxis,
    time: $a85178cf0b0fc4bc$var$timeAxis,
    log: $a85178cf0b0fc4bc$var$logAxis
};

});

parcelRegister("6Vrdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ad2dcdb048637a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $50ad2dcdb048637a$var$uidBase = 0;
var $50ad2dcdb048637a$var$OrdinalMeta = /** @class */ function() {
    function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$50ad2dcdb048637a$var$uidBase;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $bahqM.map)(data, $50ad2dcdb048637a$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        // @ts-ignore
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (typeof category !== 'string' && !needCollect) return category;
         // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            return index;
        }
        var map = this._getOrCreateMap(); // @ts-ignore
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category; // @ts-ignore
                map.set(category, index);
            } else index = NaN;
        }
        return index;
    }; // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $bahqM.createHashMap)(this.categories));
    };
    return OrdinalMeta;
}();
function $50ad2dcdb048637a$var$getName(obj) {
    if ((0, $bahqM.isObject)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $50ad2dcdb048637a$export$2e2bcd8739ae039 = $50ad2dcdb048637a$var$OrdinalMeta;

});

parcelRegister("7vTvv", function(module, exports) {

$parcel$export(module.exports, "AXIS_TYPES", () => $57867c39181fdac2$export$2e0057d176d6f690);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $57867c39181fdac2$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};

});


parcelRegister("1xCHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f6e45ff2a10529$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 
var $bahqM = parcelRequire("bahqM");

var $65MS1 = parcelRequire("65MS1");

var $3GIoT = parcelRequire("3GIoT");

var $SsPct = parcelRequire("SsPct");

var $kBKMx = parcelRequire("kBKMx");

var $eaKsF = parcelRequire("eaKsF");

var $dBIJY = parcelRequire("dBIJY");
var $11f6e45ff2a10529$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $SsPct.cartesian2DDimensions);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        (0, $bahqM.each)(axesMap.x, function(xAxis) {
            (0, $3GIoT.niceScaleExtent)(xAxis.scale, xAxis.model);
        });
        (0, $bahqM.each)(axesMap.y, function(yAxis) {
            (0, $3GIoT.niceScaleExtent)(yAxis.scale, yAxis.model);
        }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $bahqM.each)(axesMap.x, function(xAxis) {
            $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $bahqM.each)(axesMap.y, function(yAxis) {
            $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        }); // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid
   */ Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
        var boxLayoutParams = gridModel.getBoxLayoutParams();
        var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
        var gridRect = (0, $65MS1.getLayoutRect)(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._rect = gridRect;
        var axesList = this._axesList;
        adjustAxes(); // Minus label size
        if (isContainLabel) {
            (0, $bahqM.each)(axesList, function(axis) {
                if (!axis.model.get([
                    'axisLabel',
                    'inside'
                ])) {
                    var labelUnionRect = (0, $3GIoT.estimateLabelUnionRect)(axis);
                    if (labelUnionRect) {
                        var dim = axis.isHorizontal() ? 'height' : 'width';
                        var margin = axis.model.get([
                            'axisLabel',
                            'margin'
                        ]);
                        gridRect[dim] -= labelUnionRect[dim] + margin;
                        if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                        else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                    }
                }
            });
            adjustAxes();
        }
        (0, $bahqM.each)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
        function adjustAxes() {
            (0, $bahqM.each)(axesList, function(axis) {
                var isHorizontal = axis.isHorizontal();
                var extent = isHorizontal ? [
                    0,
                    gridRect.width
                ] : [
                    0,
                    gridRect.height
                ];
                var idx = axis.inverse ? 1 : 0;
                axis.setExtent(extent[idx], extent[1 - idx]);
                $11f6e45ff2a10529$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
            });
        }
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0]; // if (axisIndex == null) {
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $bahqM.isObject)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $bahqM.indexOf)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        }; /// Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap; /// Create cartesian2d
        (0, $bahqM.each)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $bahqM.each)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $SsPct.default)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $kBKMx.default)(dimName, (0, $3GIoT.createScaleByModel)(axisModel), [
                    0,
                    0
                ], axisModel.get('type'), axisPosition);
                var isCategory = axis.type === 'category';
                axis.onBand = isCategory && axisModel.get('boundaryGap');
                axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
                axisModel.axis = axis; // Inject axisModel into axis
                axis.model = axisModel; // Inject grid info axis
                axis.grid = grid; // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $bahqM.each)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === 'category') {
                var categorySortInfo = axis.model.get('categorySortInfo');
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if ((0, $dBIJY.isCartesian2DSeries)(seriesModel)) {
                var axesModelMap = (0, $dBIJY.findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$11f6e45ff2a10529$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis('x');
                var yAxis = cartesian.getAxis('y');
                if (data.type === 'list') {
                    unionExtent(data, xAxis);
                    unionExtent(data, yAxis);
                }
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $bahqM.each)((0, $3GIoT.getDataDimensionsOnAxis)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $bahqM.each)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $bahqM.indexOf)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $bahqM.indexOf)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        }); // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            if (!(0, $dBIJY.isCartesian2DSeries)(seriesModel)) return;
            var axesModelMap = (0, $dBIJY.findAxisModels)(seriesModel);
            var xAxisModel = axesModelMap.xAxisModel;
            var yAxisModel = axesModelMap.yAxisModel;
            var gridModel = xAxisModel.getCoordSysModel();
            var grid = gridModel.coordinateSystem;
            seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        });
        return grids;
    }; // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $SsPct.cartesian2DDimensions);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    }; // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    if (!onZero) return;
     // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
         && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
function $11f6e45ff2a10529$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== 'category' && axis.type !== 'time' && (0, $3GIoT.ifAxisCrossZero)(axis);
}
function $11f6e45ff2a10529$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $11f6e45ff2a10529$export$2e2bcd8739ae039 = $11f6e45ff2a10529$var$Grid;

});
parcelRegister("3GIoT", function(module, exports) {

$parcel$export(module.exports, "getScaleExtent", () => $2af7bc5b57211b12$export$9c0ba8df7eb7b328);
$parcel$export(module.exports, "niceScaleExtent", () => $2af7bc5b57211b12$export$51f3e70a54405d5a);
$parcel$export(module.exports, "createScaleByModel", () => $2af7bc5b57211b12$export$8941c4cacdc8f5a5);
$parcel$export(module.exports, "ifAxisCrossZero", () => $2af7bc5b57211b12$export$3eac36a69f37d52);
$parcel$export(module.exports, "makeLabelFormatter", () => $2af7bc5b57211b12$export$742f19a75415b2ae);
$parcel$export(module.exports, "getAxisRawValue", () => $2af7bc5b57211b12$export$a5a32f324c1fa457);
$parcel$export(module.exports, "estimateLabelUnionRect", () => $2af7bc5b57211b12$export$fef1c7f0af0b48d);
$parcel$export(module.exports, "getOptionCategoryInterval", () => $2af7bc5b57211b12$export$6d0bc2429155c088);
$parcel$export(module.exports, "shouldShowAllLabels", () => $2af7bc5b57211b12$export$c2911c025243d6a6);
$parcel$export(module.exports, "getDataDimensionsOnAxis", () => $2af7bc5b57211b12$export$e4cf30b1e74cd69d);
$parcel$export(module.exports, "unionAxisExtentFromData", () => $2af7bc5b57211b12$export$635fe7f20d0f4c70);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $acOy6 = parcelRequire("acOy6");

var $6kObD = parcelRequire("6kObD");

var $fEgWg = parcelRequire("fEgWg");

var $eL4bi = parcelRequire("eL4bi");

var $1E3E8 = parcelRequire("1E3E8");

var $1MU9l = parcelRequire("1MU9l");

var $73kgw = parcelRequire("73kgw");

var $5R8Hi = parcelRequire("5R8Hi");

var $lo2Vo = parcelRequire("lo2Vo");
function $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $lo2Vo.ensureScaleRawExtentInfo)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max; // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === 'time') {
        var barSeriesModels = (0, $eL4bi.prepareLayoutBarSeries)('bar', ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $bahqM.each(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $eL4bi.makeColumnLayout)(barSeriesModels); // Adjust axis min and max to account for overflow
            var adjustedScale = $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $eL4bi.retrieveColumnLayout)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $bahqM.each(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $bahqM.each(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow; // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
} // Precondition of calling this method:
function $2af7bc5b57211b12$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get('splitNumber');
    if (scale instanceof (0, $73kgw.default)) scale.base = model.get('logBase');
    var scaleType = scale.type;
    scale.setExtent(extent[0], extent[1]);
    scale.niceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
        maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
    }); // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    var interval = model.get('interval');
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $2af7bc5b57211b12$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $acOy6.default)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $1MU9l.default)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $fEgWg.default).getClass(axisType) || (0, $6kObD.default))();
    }
}
function $2af7bc5b57211b12$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $2af7bc5b57211b12$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
    if (axis.scale.type === 'time') return function(tpl) {
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, tpl);
        };
    }(labelFormatter);
    else if (typeof labelFormatter === 'string') return function(tpl) {
        return function(tick) {
            // For category axis, get raw value; for numeric axis,
            // get formatted label like '1,333,444'.
            var label = axis.scale.getLabel(tick);
            var text = tpl.replace('{value}', label != null ? label : '');
            return text;
        };
    }(labelFormatter);
    else if (typeof labelFormatter === 'function') return function(cb) {
        return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            if (categoryTickStart != null) idx = tick.value - categoryTickStart;
            return cb($2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                level: tick.level
            } : null);
        };
    }(labelFormatter);
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
function $2af7bc5b57211b12$export$fef1c7f0af0b48d(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        'axisLabel',
        'show'
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $acOy6.default)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $2af7bc5b57211b12$export$742f19a75415b2ae(axis);
    var rect;
    var step = 1; // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $2af7bc5b57211b12$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $2af7bc5b57211b12$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var beforeWidth = textRect.width;
    var beforeHeight = textRect.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new (0, $1E3E8.default)(textRect.x, textRect.y, afterWidth, afterHeight);
    return rotatedRect;
}
function $2af7bc5b57211b12$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $2af7bc5b57211b12$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $2af7bc5b57211b12$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {}; // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $bahqM.each(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $5R8Hi.getStackedDimension)(data, dataDim)] = true;
    });
    return $bahqM.keys(dataDimMap);
}
function $2af7bc5b57211b12$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $bahqM.each($2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}

});
parcelRegister("acOy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e23c609ca21282$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $fEgWg = parcelRequire("fEgWg");

var $6Vrdy = parcelRequire("6Vrdy");

var $32MHg = parcelRequire("32MHg");

var $bahqM = parcelRequire("bahqM");
var $76e23c609ca21282$var$OrdinalScale = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = 'ordinal';
        var ordinalMeta = _this.getSetting('ordinalMeta'); // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $6Vrdy.default)({});
        if ((0, $bahqM.isArray)(ordinalMeta)) ordinalMeta = new (0, $6Vrdy.default)({
            categories: (0, $bahqM.map)(ordinalMeta, function(item) {
                return (0, $bahqM.isObject)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting('extent') || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
         : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(rank) {
        rank = this.parse(rank);
        return $32MHg.contain(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(this.parse(val));
        return $32MHg.normalize(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round($32MHg.scale(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = []; // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        } // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber; // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick; // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber]; // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? '' : cateogry + '';
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.niceTicks = function() {};
    OrdinalScale.prototype.niceExtent = function() {};
    OrdinalScale.type = 'ordinal';
    return OrdinalScale;
}((0, $fEgWg.default));
(0, $fEgWg.default).registerClass($76e23c609ca21282$var$OrdinalScale);
var $76e23c609ca21282$export$2e2bcd8739ae039 = $76e23c609ca21282$var$OrdinalScale;

});
parcelRegister("fEgWg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b647bb1e30834d31$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $aLwh0 = parcelRequire("aLwh0");
var $b647bb1e30834d31$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get extent
   *
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set extent
   */ Scale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$aLwh0.enableClassManagement($b647bb1e30834d31$var$Scale);
var $b647bb1e30834d31$export$2e2bcd8739ae039 = $b647bb1e30834d31$var$Scale;

});

parcelRegister("32MHg", function(module, exports) {

$parcel$export(module.exports, "intervalScaleNiceTicks", () => $2377552e030bbd2b$export$eeea879a611eb991);
$parcel$export(module.exports, "getIntervalPrecision", () => $2377552e030bbd2b$export$86a060b060d3d31a);
$parcel$export(module.exports, "contain", () => $2377552e030bbd2b$export$8893e2b90ba10d92);
$parcel$export(module.exports, "normalize", () => $2377552e030bbd2b$export$a3295358bff77e);
$parcel$export(module.exports, "scale", () => $2377552e030bbd2b$export$dcdf75081b88279d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");
var $2377552e030bbd2b$var$roundNumber = $jmSNG.round;
function $2377552e030bbd2b$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = $jmSNG.nice(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
     // Tow more digital for tick.
    var precision = result.intervalPrecision = $2377552e030bbd2b$export$86a060b060d3d31a(interval); // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        $2377552e030bbd2b$var$roundNumber(Math.ceil(extent[0] / interval) * interval, precision),
        $2377552e030bbd2b$var$roundNumber(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $2377552e030bbd2b$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return $jmSNG.getPrecision(interval) + 2;
}
function $2377552e030bbd2b$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
function $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $2377552e030bbd2b$var$clamp(niceTickExtent, 0, extent);
    $2377552e030bbd2b$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $2377552e030bbd2b$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
function $2377552e030bbd2b$export$a3295358bff77e(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $2377552e030bbd2b$export$dcdf75081b88279d(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}

});


parcelRegister("6kObD", function(module, exports) {

$parcel$export(module.exports, "default", () => $49cb8a61b3174199$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $jmSNG = parcelRequire("jmSNG");

var $dCJrM = parcelRequire("dCJrM");

var $fEgWg = parcelRequire("fEgWg");

var $32MHg = parcelRequire("32MHg");
var $49cb8a61b3174199$var$roundNumber = $jmSNG.round;
var $49cb8a61b3174199$var$IntervalScale = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'interval'; // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        return val;
    };
    IntervalScale.prototype.contain = function(val) {
        return $32MHg.contain(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return $32MHg.normalize(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return $32MHg.scale(val, this._extent);
    };
    IntervalScale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent; // start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    };
    IntervalScale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
        this.setExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
        // We assume user wan't to set both interval, min, max to get a better result
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $32MHg.getIntervalPrecision(interval);
    };
    /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
         // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push({
                value: $49cb8a61b3174199$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            }); // Avoid rounding error
            tick = $49cb8a61b3174199$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        } // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push({
                value: $49cb8a61b3174199$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $49cb8a61b3174199$var$roundNumber(prevTick.value + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = $jmSNG.getPrecision(data.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._intervalPrecision;
         // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $49cb8a61b3174199$var$roundNumber(data.value, precision, true);
        return $dCJrM.addCommas(dataNum);
    };
    /**
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.niceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
         // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $32MHg.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.niceExtent = function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                var expandSize = extent[0]; // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // let extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $49cb8a61b3174199$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $49cb8a61b3174199$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $fEgWg.default));
(0, $fEgWg.default).registerClass($49cb8a61b3174199$var$IntervalScale);
var $49cb8a61b3174199$export$2e2bcd8739ae039 = $49cb8a61b3174199$var$IntervalScale;

});

parcelRegister("eL4bi", function(module, exports) {

$parcel$export(module.exports, "getLayoutOnAxis", () => $abe8b2c5f70c8df4$export$658df087977b9e84);
$parcel$export(module.exports, "prepareLayoutBarSeries", () => $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4);
$parcel$export(module.exports, "makeColumnLayout", () => $abe8b2c5f70c8df4$export$20769dafc84e0299);
$parcel$export(module.exports, "retrieveColumnLayout", () => $abe8b2c5f70c8df4$export$35920bb6556da1c2);
$parcel$export(module.exports, "layout", () => $abe8b2c5f70c8df4$export$b3219800bda33a1f);
$parcel$export(module.exports, "largeLayout", () => $abe8b2c5f70c8df4$export$1fcd87ee6628f095);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $5R8Hi = parcelRequire("5R8Hi");

var $9irlK = parcelRequire("9irlK");
var $abe8b2c5f70c8df4$var$STACK_PREFIX = '__ec_stack_';
var $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH = 0.5;
var $abe8b2c5f70c8df4$var$LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
function $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $abe8b2c5f70c8df4$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $abe8b2c5f70c8df4$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $abe8b2c5f70c8df4$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = 'axis0';
    if (baseAxis.type !== 'category') return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push($bahqM.defaults({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $abe8b2c5f70c8df4$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$abe8b2c5f70c8df4$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) && !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    $bahqM.each(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + '_' + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
             // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            } // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $abe8b2c5f70c8df4$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    $bahqM.each(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
            var key = baseAxis.dim + '_' + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $jmSNG.parsePercent)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $jmSNG.parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
        var barMinWidth = (0, $jmSNG.parsePercent)(// the auto-calculated bar width might be less than 1.
        seriesModel.get('barMinWidth') || 1, bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $abe8b2c5f70c8df4$var$getAxisKey(baseAxis),
            stackId: $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)
        });
    });
    return $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    $bahqM.each(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: '20%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        }; // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $bahqM.each(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = $bahqM.keys(stacks).length; // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
        }
        var categoryGap = (0, $jmSNG.parsePercent)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $jmSNG.parsePercent)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
        $bahqM.each(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                 // `minWidth` has higher priority. `minWidth` decide that wheter the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Becuase barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                 // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        }); // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $bahqM.each(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $bahqM.each(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $abe8b2c5f70c8df4$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $abe8b2c5f70c8df4$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $abe8b2c5f70c8df4$export$20769dafc84e0299(seriesModels);
    var lastStackCoords = {};
    $bahqM.each(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var barMinHeight = seriesModel.get('barMinHeight') || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $5R8Hi.isDimensionStacked)(data, valueDim);
        var isValueAxisH = valueAxis.isHorizontal();
        var valueAxisStart = $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked);
        var store = data.getStore();
        var valueDimIdx = data.getDimensionIndex(valueDim);
        var baseDimIdx = data.getDimensionIndex(baseDim);
        for(var idx = 0, len = store.count(); idx < len; idx++){
            var value = store.get(valueDimIdx, idx);
            var baseValue = store.get(baseDimIdx, idx);
            var sign = value >= 0 ? 'p' : 'n';
            var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            if (stacked) {
                // Only ordinal axis can be stacked.
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                 // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;
            if (isValueAxisH) {
                var coord = cartesian.dataToPoint([
                    value,
                    baseValue
                ]);
                x = baseCoord;
                y = coord[1] + columnOffset;
                width = coord[0] - valueAxisStart;
                height = columnWidth;
                if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(width)) stacked && (lastStackCoords[stackId][baseValue][sign] += width);
            } else {
                var coord = cartesian.dataToPoint([
                    baseValue,
                    value
                ]);
                x = coord[0] + columnOffset;
                y = baseCoord;
                width = columnWidth;
                height = coord[1] - valueAxisStart;
                if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                height = (height <= 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(height)) stacked && (lastStackCoords[stackId][baseValue][sign] += height);
            }
            data.setItemLayout(idx, {
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
    });
} // TODO: Do not support stack in large mode yet.
var $abe8b2c5f70c8df4$export$1fcd87ee6628f095 = {
    seriesType: 'bar',
    plan: (0, $9irlK.default)(),
    reset: function(seriesModel) {
        if (!$abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) || !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) return;
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var coordLayout = cartesian.master.getRect();
        var baseAxis = cartesian.getBaseAxis();
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var valueDimI = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
        var baseDimI = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var valueAxisHorizontal = valueAxis.isHorizontal();
        var valueDimIdx = valueAxisHorizontal ? 0 : 1;
        var barWidth = $abe8b2c5f70c8df4$export$35920bb6556da1c2($abe8b2c5f70c8df4$export$20769dafc84e0299([
            seriesModel
        ]), baseAxis, seriesModel).width;
        if (!(barWidth > $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH)) // jshint ignore:line
        barWidth = $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH;
        return {
            progress: function(params, data) {
                var count = params.count;
                var largePoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                var largeBackgroundPoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                var largeDataIndices = new $abe8b2c5f70c8df4$var$LargeArr(count);
                var dataIndex;
                var coord = [];
                var valuePair = [];
                var pointsOffset = 0;
                var idxOffset = 0;
                var store = data.getStore();
                while((dataIndex = params.next()) != null){
                    valuePair[valueDimIdx] = store.get(valueDimI, dataIndex);
                    valuePair[1 - valueDimIdx] = store.get(baseDimI, dataIndex);
                    coord = cartesian.dataToPoint(valuePair, null); // Data index might not be in order, depends on `progressiveChunkMode`.
                    largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
                    largePoints[pointsOffset++] = coord[0];
                    largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
                    largePoints[pointsOffset++] = coord[1];
                    largeDataIndices[idxOffset++] = dataIndex;
                }
                data.setLayout({
                    largePoints: largePoints,
                    largeDataIndices: largeDataIndices,
                    largeBackgroundPoints: largeBackgroundPoints,
                    barWidth: barWidth,
                    valueAxisStart: $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, false),
                    backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
                    valueAxisHorizontal: valueAxisHorizontal
                });
            }
        };
    }
};
function $abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $abe8b2c5f70c8df4$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked) {
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
}

});

parcelRegister("1MU9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d5d447dd592e99$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $jmSNG = parcelRequire("jmSNG");

var $bc1Ad = parcelRequire("bc1Ad");

var $32MHg = parcelRequire("32MHg");

var $6kObD = parcelRequire("6kObD");

var $fEgWg = parcelRequire("fEgWg");


var $bahqM = parcelRequire("bahqM");
var $14d5d447dd592e99$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $14d5d447dd592e99$var$TimeScale = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = 'time';
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting('useUTC');
        return (0, $bc1Ad.format)(tick.value, (0, $bc1Ad.fullLeveledFormatter)[(0, $bc1Ad.getDefaultFormatPrecisionOfInterval)((0, $bc1Ad.getPrimaryTimeUnit)(this._minLevelUnit))] || (0, $bc1Ad.fullLeveledFormatter).second, useUTC, this.getSetting('locale'));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting('useUTC');
        var lang = this.getSetting('locale');
        return (0, $bc1Ad.leveledFormat)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ TimeScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
        ticks.push({
            value: extent[0],
            level: 0
        });
        var useUTC = this.getSetting('useUTC');
        var innerTicks = $14d5d447dd592e99$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
        ticks = ticks.concat(innerTicks);
        ticks.push({
            value: extent[1],
            level: 0
        });
        return ticks;
    };
    TimeScale.prototype.niceExtent = function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $bc1Ad.ONE_DAY);
            extent[1] += (0, $bc1Ad.ONE_DAY);
        } // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $bc1Ad.ONE_DAY);
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.niceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $14d5d447dd592e99$var$scaleIntervals.length;
        var idx = Math.min($14d5d447dd592e99$var$bisect($14d5d447dd592e99$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1); // Interval that can be used to calculate ticks
        this._interval = $14d5d447dd592e99$var$scaleIntervals[idx][1]; // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $14d5d447dd592e99$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return typeof val === 'number' ? val : +$jmSNG.parseDate(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $32MHg.contain(this.parse(val), this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return $32MHg.normalize(this.parse(val), this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return $32MHg.scale(val, this._extent);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $6kObD.default));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $14d5d447dd592e99$var$scaleIntervals = [
    [
        'second',
        (0, $bc1Ad.ONE_SECOND)
    ],
    [
        'minute',
        (0, $bc1Ad.ONE_MINUTE)
    ],
    [
        'hour',
        (0, $bc1Ad.ONE_HOUR)
    ],
    [
        'quarter-day',
        (0, $bc1Ad.ONE_HOUR) * 6
    ],
    [
        'half-day',
        (0, $bc1Ad.ONE_HOUR) * 12
    ],
    [
        'day',
        (0, $bc1Ad.ONE_DAY) * 1.2
    ],
    [
        'half-week',
        (0, $bc1Ad.ONE_DAY) * 3.5
    ],
    [
        'week',
        (0, $bc1Ad.ONE_DAY) * 7
    ],
    [
        'month',
        (0, $bc1Ad.ONE_DAY) * 31
    ],
    [
        'quarter',
        (0, $bc1Ad.ONE_DAY) * 95
    ],
    [
        'half-year',
        (0, $bc1Ad.ONE_YEAR) / 2
    ],
    [
        'year',
        (0, $bc1Ad.ONE_YEAR)
    ] // 1Y
];
function $14d5d447dd592e99$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
    var dateA = $jmSNG.parseDate(valueA);
    var dateB = $jmSNG.parseDate(valueB);
    var isSame = function(unit) {
        return (0, $bc1Ad.getUnitValue)(dateA, unit, isUTC) === (0, $bc1Ad.getUnitValue)(dateB, unit, isUTC);
    };
    var isSameYear = function() {
        return isSame('year');
    }; // const isSameHalfYear = () => isSameYear() && isSame('half-year');
    // const isSameQuater = () => isSameYear() && isSame('quarter');
    var isSameMonth = function() {
        return isSameYear() && isSame('month');
    };
    var isSameDay = function() {
        return isSameMonth() && isSame('day');
    }; // const isSameHalfDay = () => isSameDay() && isSame('half-day');
    var isSameHour = function() {
        return isSameDay() && isSame('hour');
    };
    var isSameMinute = function() {
        return isSameHour() && isSame('minute');
    };
    var isSameSecond = function() {
        return isSameMinute() && isSame('second');
    };
    var isSameMilliSecond = function() {
        return isSameSecond() && isSame('millisecond');
    };
    switch(unit){
        case 'year':
            return isSameYear();
        case 'month':
            return isSameMonth();
        case 'day':
            return isSameDay();
        case 'hour':
            return isSameHour();
        case 'minute':
            return isSameMinute();
        case 'second':
            return isSameSecond();
        case 'millisecond':
            return isSameMilliSecond();
    }
} // const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $14d5d447dd592e99$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $bc1Ad.ONE_DAY);
    return approxInterval > 16 ? 16 // Math.floor(daysInMonth / 2) + 1  // In this case we only want one tick betwen two month.
     : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $14d5d447dd592e99$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $bc1Ad.ONE_DAY);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $14d5d447dd592e99$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $bc1Ad.ONE_HOUR);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $bc1Ad.ONE_MINUTE) : (0, $bc1Ad.ONE_SECOND);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval) {
    return $jmSNG.nice(approxInterval, true);
}
function $14d5d447dd592e99$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
    var outDate = new Date(date);
    switch((0, $bc1Ad.getPrimaryTimeUnit)(unitName)){
        case 'year':
        case 'month':
            outDate[(0, $bc1Ad.monthSetterName)(isUTC)](0);
        case 'day':
            outDate[(0, $bc1Ad.dateSetterName)(isUTC)](1);
        case 'hour':
            outDate[(0, $bc1Ad.hoursSetterName)(isUTC)](0);
        case 'minute':
            outDate[(0, $bc1Ad.minutesSetterName)(isUTC)](0);
        case 'second':
            outDate[(0, $bc1Ad.secondsSetterName)(isUTC)](0);
            outDate[(0, $bc1Ad.millisecondsSetterName)(isUTC)](0);
    }
    return outDate.getTime();
}
function $14d5d447dd592e99$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
    var safeLimit = 10000;
    var unitNames = (0, $bc1Ad.timeUnits);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var date = new Date(minTimestamp);
        var dateTime = minTimestamp;
        var d = date[getMethodName](); // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            d += interval;
            date[setMethodName](d);
            dateTime = date.getTime();
        } // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($14d5d447dd592e99$var$isUnitValueSame((0, $bc1Ad.getPrimaryTimeUnit)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                // TODO Optimize. Not include so may ticks.
                value: $14d5d447dd592e99$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $bc1Ad.ONE_DAY) / 365));
                    getterName = (0, $bc1Ad.fullYearGetterName)(isUTC);
                    setterName = (0, $bc1Ad.fullYearSetterName)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $14d5d447dd592e99$var$getMonthInterval(approxInterval);
                    getterName = (0, $bc1Ad.monthGetterName)(isUTC);
                    setterName = (0, $bc1Ad.monthSetterName)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $14d5d447dd592e99$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $bc1Ad.dateGetterName)(isUTC);
                    setterName = (0, $bc1Ad.dateSetterName)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $14d5d447dd592e99$var$getHourInterval(approxInterval);
                    getterName = (0, $bc1Ad.hoursGetterName)(isUTC);
                    setterName = (0, $bc1Ad.hoursSetterName)(isUTC);
                    break;
                case 'minute':
                    interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $bc1Ad.minutesGetterName)(isUTC);
                    setterName = (0, $bc1Ad.minutesSetterName)(isUTC);
                    break;
                case 'second':
                    interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $bc1Ad.secondsGetterName)(isUTC);
                    setterName = (0, $bc1Ad.secondsSetterName)(isUTC);
                    break;
                case 'millisecond':
                    interval = $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $bc1Ad.millisecondsGetterName)(isUTC);
                    setterName = (0, $bc1Ad.millisecondsSetterName)(isUTC);
                    break;
            }
            addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
         // newAddedTicks.length && console.log(unitName, newAddedTicks);
        return newAddedTicks;
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
        var primaryTimeUnit = (0, $bc1Ad.getPrimaryTimeUnit)(unitNames[i]);
        if (!(0, $bc1Ad.isPrimaryTimeUnit)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $bc1Ad.getPrimaryTimeUnit)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount; // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = (extent[1] - extent[0]) / approxInterval; // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                 // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            } // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $bahqM.filter)((0, $bahqM.map)(levelsTicks, function(levelTicks) {
        return (0, $bahqM.filter)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k)ticks.push({
            value: levelTicks[k].value,
            level: maxLevel - i
        });
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    }); // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $fEgWg.default).registerClass($14d5d447dd592e99$var$TimeScale);
var $14d5d447dd592e99$export$2e2bcd8739ae039 = $14d5d447dd592e99$var$TimeScale;

});

parcelRegister("73kgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5228888966b0d10c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $fEgWg = parcelRequire("fEgWg");

var $jmSNG = parcelRequire("jmSNG");

var $32MHg = parcelRequire("32MHg");

var $6kObD = parcelRequire("6kObD");
var $5228888966b0d10c$var$scaleProto = (0, $fEgWg.default).prototype; // FIXME:TS refactor: not good to call it directly with `this`?
var $5228888966b0d10c$var$intervalScaleProto = (0, $6kObD.default).prototype;
var $5228888966b0d10c$var$roundingErrorFix = $jmSNG.round;
var $5228888966b0d10c$var$mathFloor = Math.floor;
var $5228888966b0d10c$var$mathCeil = Math.ceil;
var $5228888966b0d10c$var$mathPow = Math.pow;
var $5228888966b0d10c$var$mathLog = Math.log;
var $5228888966b0d10c$var$LogScale = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        _this.base = 10;
        _this._originalScale = new (0, $6kObD.default)(); // FIXME:TS actually used by `IntervalScale`
        _this._interval = 0;
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        var ticks = $5228888966b0d10c$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
        return $bahqM.map(ticks, function(tick) {
            var val = tick.value;
            var powVal = $jmSNG.round($5228888966b0d10c$var$mathPow(this.base, val)); // Fix #4158
            powVal = val === extent[0] && this._fixMin ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && this._fixMax ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return {
                value: powVal
            };
        }, this);
    };
    LogScale.prototype.setExtent = function(start, end) {
        var base = this.base;
        start = $5228888966b0d10c$var$mathLog(start) / $5228888966b0d10c$var$mathLog(base);
        end = $5228888966b0d10c$var$mathLog(end) / $5228888966b0d10c$var$mathLog(base);
        $5228888966b0d10c$var$intervalScaleProto.setExtent.call(this, start, end);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = $5228888966b0d10c$var$scaleProto.getExtent.call(this);
        extent[0] = $5228888966b0d10c$var$mathPow(base, extent[0]);
        extent[1] = $5228888966b0d10c$var$mathPow(base, extent[1]); // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        this._fixMin && (extent[0] = $5228888966b0d10c$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $5228888966b0d10c$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtent = function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $5228888966b0d10c$var$mathLog(extent[0]) / $5228888966b0d10c$var$mathLog(base);
        extent[1] = $5228888966b0d10c$var$mathLog(extent[1]) / $5228888966b0d10c$var$mathLog(base);
        $5228888966b0d10c$var$scaleProto.unionExtent.call(this, extent);
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.niceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $jmSNG.quantity(span);
        var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
         // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $jmSNG.round($5228888966b0d10c$var$mathCeil(extent[0] / interval) * interval),
            $jmSNG.round($5228888966b0d10c$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.niceExtent = function(opt) {
        $5228888966b0d10c$var$intervalScaleProto.niceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.parse = function(val) {
        return val;
    };
    LogScale.prototype.contain = function(val) {
        val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
        return $32MHg.contain(val, this._extent);
    };
    LogScale.prototype.normalize = function(val) {
        val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
        return $32MHg.normalize(val, this._extent);
    };
    LogScale.prototype.scale = function(val) {
        val = $32MHg.scale(val, this._extent);
        return $5228888966b0d10c$var$mathPow(this.base, val);
    };
    LogScale.type = 'log';
    return LogScale;
}((0, $fEgWg.default));
var $5228888966b0d10c$var$proto = $5228888966b0d10c$var$LogScale.prototype;
$5228888966b0d10c$var$proto.getMinorTicks = $5228888966b0d10c$var$intervalScaleProto.getMinorTicks;
$5228888966b0d10c$var$proto.getLabel = $5228888966b0d10c$var$intervalScaleProto.getLabel;
function $5228888966b0d10c$var$fixRoundingError(val, originalVal) {
    return $5228888966b0d10c$var$roundingErrorFix(val, $jmSNG.getPrecision(originalVal));
}
(0, $fEgWg.default).registerClass($5228888966b0d10c$var$LogScale);
var $5228888966b0d10c$export$2e2bcd8739ae039 = $5228888966b0d10c$var$LogScale;

});

parcelRegister("lo2Vo", function(module, exports) {

$parcel$export(module.exports, "parseAxisModelMinMax", () => $f91e1bac53937426$export$d02f2e65dfc3c2b);
$parcel$export(module.exports, "ensureScaleRawExtentInfo", () => $f91e1bac53937426$export$5c3dbcbeb9ce7f5a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $b7ZX8 = parcelRequire("b7ZX8");
var $f91e1bac53937426$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on ouside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
        this._needCrossZero = model.getNeedCrossZero && model.getNeedCrossZero();
        var modelMinRaw = this._modelMinRaw = model.get('min', true);
        if ((0, $bahqM.isFunction)(modelMinRaw)) // This callback alway provide users the full data extent (before data filtered).
        this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== 'dataMin') this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
        if ((0, $bahqM.isFunction)(modelMaxRaw)) // This callback alway provide users the full data extent (before data filtered).
        this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get('boundaryGap');
            var boundaryGapArr = (0, $bahqM.isArray)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $b7ZX8.parsePercent)(boundaryGapArr[0], 1),
                (0, $b7ZX8.parsePercent)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null; // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum; // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        if (min > max) {
            min = NaN;
            max = NaN;
        }
        var isBlank = (0, $bahqM.eqNaN)(min) || (0, $bahqM.eqNaN)(max) || isOrdinal && !axisDataLen; // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0; // minFixed = true;
             // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0; // maxFixed = true;
             // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        } // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$f91e1bac53937426$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR = {
    min: '_determinedMin',
    max: '_determinedMax'
};
var $f91e1bac53937426$var$DATA_MIN_MAX_ATTR = {
    min: '_dataMin',
    max: '_dataMax'
};
function $f91e1bac53937426$export$5c3dbcbeb9ce7f5a(scale, model, originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $f91e1bac53937426$export$c35454f678e99c82(scale, model, originalExtent); // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $bahqM.eqNaN)(minMax) ? NaN : scale.parse(minMax);
}

});


parcelRegister("SsPct", function(module, exports) {

$parcel$export(module.exports, "cartesian2DDimensions", () => $0a3b6744500b73ac$export$988a008d2b9120f4);
$parcel$export(module.exports, "default", () => $0a3b6744500b73ac$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $1E3E8 = parcelRequire("1E3E8");

var $7j9L9 = parcelRequire("7j9L9");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");
var $0a3b6744500b73ac$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $0a3b6744500b73ac$var$canCalculateAffineTransform(scale) {
    return scale.type === 'interval' || scale.type === 'time';
}
var $0a3b6744500b73ac$var$Cartesian2D = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cartesian2d';
        _this.dimensions = $0a3b6744500b73ac$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$0a3b6744500b73ac$var$canCalculateAffineTransform(xAxisScale) || !$0a3b6744500b73ac$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
         // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $izqgC.invert)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1]; // Fast path
        if (this._transform // It's supported that if data is like `[Inifity, 123]`, where only Y pixel calculated.
         && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $eLEew.applyTransform)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp) {
        var out = [];
        if (this._invTransform) return (0, $eLEew.applyTransform)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function() {
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]);
        var y = Math.min(yExtent[0], yExtent[1]);
        var width = Math.max(xExtent[0], xExtent[1]) - x;
        var height = Math.max(yExtent[0], yExtent[1]) - y;
        return new (0, $1E3E8.default)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $7j9L9.default));
var $0a3b6744500b73ac$export$2e2bcd8739ae039 = $0a3b6744500b73ac$var$Cartesian2D;

});
parcelRegister("7j9L9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5521e0c9b22643f8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $5521e0c9b22643f8$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $bahqM.map(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $bahqM.filter(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $5521e0c9b22643f8$export$2e2bcd8739ae039 = $5521e0c9b22643f8$var$Cartesian;

});


parcelRegister("kBKMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f00b8d3b69958a3f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $g6Gq1 = parcelRequire("g6Gq1");
var $f00b8d3b69958a3f$var$Axis2D = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $g6Gq1.default));
var $f00b8d3b69958a3f$export$2e2bcd8739ae039 = $f00b8d3b69958a3f$var$Axis2D;

});
parcelRegister("g6Gq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb9e1c59fe00c8ac$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $ftAX6 = parcelRequire("ftAX6");
var $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 */ var $bb9e1c59fe00c8ac$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(data);
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $jmSNG.getPixelPrecision)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $jmSNG.linearMap)(data, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $jmSNG.linearMap)(coord, extent, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $ftAX6.createAxisTicks)(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = (0, $bahqM.map)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === 'ordinal') // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber'); // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $bahqM.map)(minorTicks, function(minorTicksGroup) {
            return (0, $bahqM.map)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function() {
        return (0, $ftAX6.createAxisLabels)(this).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function() {
        return (0, $ftAX6.calculateCategoryInterval)(this);
    };
    return Axis;
}();
function $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[0]
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $bahqM.each)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unecessary tick added.
        a = (0, $jmSNG.round)(a);
        b = (0, $jmSNG.round)(b);
        return inverse ? a > b : a < b;
    }
}
var $bb9e1c59fe00c8ac$export$2e2bcd8739ae039 = $bb9e1c59fe00c8ac$var$Axis;

});
parcelRegister("ftAX6", function(module, exports) {

$parcel$export(module.exports, "createAxisLabels", () => $b4463a620840f7ae$export$10216ebd3e3e485e);
$parcel$export(module.exports, "createAxisTicks", () => $b4463a620840f7ae$export$7cccf6836ae8323c);
$parcel$export(module.exports, "calculateCategoryInterval", () => $b4463a620840f7ae$export$9ea1d3f146a5a65f);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $b7ZX8 = parcelRequire("b7ZX8");

var $eaKsF = parcelRequire("eaKsF");

var $3GIoT = parcelRequire("3GIoT");
var $b4463a620840f7ae$var$inner = (0, $eaKsF.makeInner)();
function $b4463a620840f7ae$export$10216ebd3e3e485e(axis) {
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryLabels(axis) : $b4463a620840f7ae$var$makeRealNumberLabels(axis);
}
function $b4463a620840f7ae$export$7cccf6836ae8323c(axis, tickModel) {
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $bahqM.map(axis.scale.getTicks(), function(tick) {
            return tick.value;
        })
    };
}
function $b4463a620840f7ae$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $b4463a620840f7ae$var$getListCache(axis, 'labels');
    var optionLabelInterval = (0, $3GIoT.getOptionCategoryInterval)(labelModel);
    var result = $b4463a620840f7ae$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($bahqM.isFunction(optionLabelInterval)) labels = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    } // Cache to avoid calling interval function repeatly.
    return $b4463a620840f7ae$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $b4463a620840f7ae$var$getListCache(axis, 'ticks');
    var optionTickInterval = (0, $3GIoT.getOptionCategoryInterval)(tickModel);
    var result = $b4463a620840f7ae$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($bahqM.isFunction(optionTickInterval)) ticks = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $bahqM.map(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatly.
    return $b4463a620840f7ae$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $b4463a620840f7ae$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $3GIoT.makeLabelFormatter)(axis);
    return {
        labels: $bahqM.map(ticks, function(tick, idx) {
            return {
                level: tick.level,
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value
            };
        })
    };
}
function $b4463a620840f7ae$var$getListCache(axis, prop) {
    // Because key can be funciton, and cache size always be small, we use array cache.
    return $b4463a620840f7ae$var$inner(axis)[prop] || ($b4463a620840f7ae$var$inner(axis)[prop] = []);
}
function $b4463a620840f7ae$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $b4463a620840f7ae$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) {
    var result = $b4463a620840f7ae$var$inner(axis).autoInterval;
    return result != null ? result : $b4463a620840f7ae$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
function $b4463a620840f7ae$export$9ea1d3f146a5a65f(axis) {
    var params = $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $3GIoT.makeLabelFormatter)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0; // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0; // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $b7ZX8.getBoundingRect(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top'); // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3; // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $b4463a620840f7ae$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
     && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
     && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
    return interval;
}
function $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $3GIoT.makeLabelFormatter)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
     // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $3GIoT.shouldShowAllLabels)(axis);
    var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
    var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
     // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue
        });
    }
    return result;
}
function $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $3GIoT.makeLabelFormatter)(axis);
    var result = [];
    $bahqM.each(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}

});



parcelRegister("dBIJY", function(module, exports) {

$parcel$export(module.exports, "layout", () => $9e816f987642cbea$export$b3219800bda33a1f);
$parcel$export(module.exports, "isCartesian2DSeries", () => $9e816f987642cbea$export$c2a0b77974c5e35d);
$parcel$export(module.exports, "findAxisModels", () => $9e816f987642cbea$export$8220131ac1d61d28);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");
function $9e816f987642cbea$export$b3219800bda33a1f(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    } // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ]; // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($bahqM.retrieve(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
     // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $9e816f987642cbea$export$c2a0b77974c5e35d(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $9e816f987642cbea$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $bahqM.each(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $eaKsF.SINGLE_REFERRING)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}

});


parcelRegister("2rHnA", function(module, exports) {

$parcel$export(module.exports, "CartesianXAxisView", () => $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8);
$parcel$export(module.exports, "CartesianYAxisView", () => $1c7fc0a7283d68cb$export$417e1bdd0616e0dc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $4KVOr = parcelRequire("4KVOr");
var $fHITF = parcelRequire("fHITF");
var $cZb1F = parcelRequire("cZb1F");

var $asa08 = parcelRequire("asa08");

var $atJL7 = parcelRequire("atJL7");

var $dBIJY = parcelRequire("dBIJY");

var $6dLRi = parcelRequire("6dLRi");
var $1c7fc0a7283d68cb$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $1c7fc0a7283d68cb$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine'
];
var $1c7fc0a7283d68cb$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $4KVOr.default();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $dBIJY.layout(gridModel, axisModel);
        var axisBuilder = new (0, $asa08.default)(axisModel, $bahqM.extend({
            handleAutoShown: function(elementType) {
                var cartesians = gridModel.coordinateSystem.getCartesians();
                for(var i = 0; i < cartesians.length; i++){
                    var otherAxisType = cartesians[i].getOtherAxis(axisModel.axis).type;
                    if (otherAxisType === 'value' || otherAxisType === 'log') // Still show axis tick or axisLine if other axis is value / log
                    return true;
                } // Not show axisTick or axisLine if other axis is category / time
                return false;
            }
        }, layout));
        $bahqM.each($1c7fc0a7283d68cb$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $bahqM.each($1c7fc0a7283d68cb$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $1c7fc0a7283d68cb$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
        }, this); // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $fHITF.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $6dLRi.rectCoordAxisHandleRemove)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $atJL7.default));
var $1c7fc0a7283d68cb$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        lineColors = $bahqM.isArray(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var tickValue = ticksCoords[i].tickValue;
            axisGroup.add(new $cZb1F.default({
                anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
                subPixelOptimize: true,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $bahqM.defaults({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            }));
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            axisGroup.add(new $cZb1F.default({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                subPixelOptimize: true,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            }));
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel) {
        (0, $6dLRi.rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, gridModel);
    }
};
var $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($1c7fc0a7283d68cb$var$CartesianAxisView);
var $1c7fc0a7283d68cb$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($1c7fc0a7283d68cb$var$CartesianAxisView);
var $1c7fc0a7283d68cb$export$2e2bcd8739ae039 = $1c7fc0a7283d68cb$var$CartesianAxisView;

});
parcelRegister("asa08", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c446f32aef3809$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $4KVOr = parcelRequire("4KVOr");parcelRequire("fHITF");
var $cZb1F = parcelRequire("cZb1F");
var $fHITF = parcelRequire("fHITF");
var $4gEFv = parcelRequire("4gEFv");

var $7QjoM = parcelRequire("7QjoM");

var $gvLUt = parcelRequire("gvLUt");

var $gaMkj = parcelRequire("gaMkj");

var $jmSNG = parcelRequire("jmSNG");

var $7yklO = parcelRequire("7yklO");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");

var $3GIoT = parcelRequire("3GIoT");

var $3LB2b = parcelRequire("3LB2b");
var $79c446f32aef3809$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */ var $79c446f32aef3809$var$AxisBuilder = /** @class */ function() {
    function AxisBuilder(axisModel, opt) {
        this.group = new $4KVOr.default();
        this.opt = opt;
        this.axisModel = axisModel; // Default value
        (0, $bahqM.defaults)(opt, {
            labelOffset: 0,
            nameDirection: 1,
            tickDirection: 1,
            labelDirection: 1,
            silent: true,
            handleAutoShown: function() {
                return true;
            }
        }); // FIXME Not use a seperate text group?
        var transformGroup = new $4KVOr.default({
            x: opt.position[0],
            y: opt.position[1],
            rotation: opt.rotation
        }); // this.group.add(transformGroup);
        // this._transformGroup = transformGroup;
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
    }
    AxisBuilder.prototype.hasBuilder = function(name) {
        return !!$79c446f32aef3809$var$builders[name];
    };
    AxisBuilder.prototype.add = function(name) {
        $79c446f32aef3809$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
    };
    AxisBuilder.prototype.getGroup = function() {
        return this.group;
    };
    AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $jmSNG.remRadian)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $jmSNG.isRadianAroundZero)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $jmSNG.isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $79c446f32aef3809$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
         || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
var $79c446f32aef3809$var$builders = {
    axisLine: function(opt, axisModel, group, transformGroup) {
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        if (matrix) {
            (0, $eLEew.applyTransform)(pt1, pt1, matrix);
            (0, $eLEew.applyTransform)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $bahqM.extend)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var line = new $cZb1F.default({
            // Id for animation
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        });
        line.anid = 'line';
        group.add(line);
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if (typeof arrows === 'string') // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if (typeof arrowSize === 'string' || typeof arrowSize === 'number') // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $7yklO.normalizeSymbolOffset)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $bahqM.each)([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $7yklO.createSymbol)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true); // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt1[0] + r * Math.cos(opt.rotation),
                        y: pt1[1] - r * Math.sin(opt.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    axisTickLabel: function(opt, axisModel, group, transformGroup) {
        var ticksEls = $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
        var labelEls = $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt);
        $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection); // This bit fixes the label overlap issue for the time chart.
        // See https://github.com/apache/echarts/issues/14266 for more.
        if (axisModel.get([
            'axisLabel',
            'hideOverlap'
        ])) {
            var labelList = (0, $3LB2b.prepareLayoutList)((0, $bahqM.map)(labelEls, function(label) {
                return {
                    label: label,
                    priority: label.z2,
                    defaultAttr: {
                        ignore: label.ignore
                    }
                };
            }));
            (0, $3LB2b.hideOverlap)(labelList);
        }
    },
    axisName: function(opt, axisModel, group, transformGroup) {
        var name = (0, $bahqM.retrieve)(opt.axisName, axisModel.get('name'));
        if (!name) return;
        var nameLocation = axisModel.get('nameLocation');
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            $79c446f32aef3809$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $79c446f32aef3809$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($79c446f32aef3809$var$isNameLocationCenter(nameLocation)) labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, nameDirection);
        else {
            labelLayout = $79c446f32aef3809$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $bahqM.retrieve)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var textEl = new $4gEFv.default({
            x: pos[0],
            y: pos[1],
            rotation: labelLayout.rotation,
            silent: $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $gvLUt.createTextStyle)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $fHITF.setTooltipConfig({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name; // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $7QjoM.getECData)(textEl).eventData = eventData;
        } // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        group.add(textEl);
        textEl.decomposeTransform();
    }
};
function $79c446f32aef3809$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $jmSNG.remRadian)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $jmSNG.isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $jmSNG.isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $79c446f32aef3809$var$PI * 1.5 && rotationDiff > $79c446f32aef3809$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
function $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ((0, $3GIoT.shouldShowAllLabels)(axisModel.axis)) return;
     // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabel = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]); // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $79c446f32aef3809$var$ignoreEl(firstLabel);
        $79c446f32aef3809$var$ignoreEl(firstTick);
    } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $79c446f32aef3809$var$ignoreEl(nextLabel);
            $79c446f32aef3809$var$ignoreEl(nextTick);
        } else {
            $79c446f32aef3809$var$ignoreEl(firstLabel);
            $79c446f32aef3809$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $79c446f32aef3809$var$ignoreEl(lastLabel);
        $79c446f32aef3809$var$ignoreEl(lastTick);
    } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $79c446f32aef3809$var$ignoreEl(prevLabel);
            $79c446f32aef3809$var$ignoreEl(prevTick);
        } else {
            $79c446f32aef3809$var$ignoreEl(lastLabel);
            $79c446f32aef3809$var$ignoreEl(lastTick);
        }
    }
}
function $79c446f32aef3809$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $79c446f32aef3809$var$isTwoLabelOverlapped(current, next) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
     // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $izqgC.identity([]);
    $izqgC.rotate(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($izqgC.mul([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($izqgC.mul([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $79c446f32aef3809$var$isNameLocationCenter(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $79c446f32aef3809$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $eLEew.applyTransform)(pt1, pt1, tickTransform);
            (0, $eLEew.applyTransform)(pt2, pt2, tickTransform);
        } // Tick line, Not use group transform to have better line draw
        var tickEl = new $cZb1F.default({
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
    if (!shown || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = opt.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $79c446f32aef3809$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $bahqM.defaults)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $bahqM.defaults)(lineStyleModel.getLineStyle(), (0, $bahqM.defaults)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $79c446f32aef3809$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
function $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var show = (0, $bahqM.retrieve)(opt.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel('axisLabel');
    var labelMargin = labelModel.get('margin');
    var labels = axis.getViewLabels(); // Special label rotate.
    var labelRotation = ((0, $bahqM.retrieve)(opt.labelRotate, labelModel.get('rotate')) || 0) * $79c446f32aef3809$var$PI / 180;
    var labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel);
    var triggerEvent = axisModel.get('triggerEvent');
    (0, $bahqM.each)(labels, function(labelItem, index) {
        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $bahqM.isObject)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $gaMkj.default)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var tickCoord = axis.dataToCoord(tickValue);
        var textEl = new $4gEFv.default({
            x: tickCoord,
            y: opt.labelOffset + opt.labelDirection * labelMargin,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10 + (labelItem.level || 0),
            style: (0, $gvLUt.createTextStyle)(itemLabelModel, {
                text: formattedLabel,
                align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
                verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
                fill: typeof textColor === 'function' ? textColor(// index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user repalce ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue; // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            (0, $7QjoM.getECData)(textEl).eventData = eventData;
        } // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $79c446f32aef3809$export$2e2bcd8739ae039 = $79c446f32aef3809$var$AxisBuilder;

});
parcelRegister("3LB2b", function(module, exports) {

$parcel$export(module.exports, "prepareLayoutList", () => $2be27d213439fed1$export$6c403cad1ae3e239);
$parcel$export(module.exports, "shiftLayoutOnX", () => $2be27d213439fed1$export$b6b2b07f8ed32bd6);
$parcel$export(module.exports, "shiftLayoutOnY", () => $2be27d213439fed1$export$118c25e0932528e4);
$parcel$export(module.exports, "hideOverlap", () => $2be27d213439fed1$export$8ce774e164a49410);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1E3E8 = parcelRequire("1E3E8");
var $lM5Gp = parcelRequire("lM5Gp");
function $2be27d213439fed1$export$6c403cad1ae3e239(input) {
    var list = [];
    for(var i = 0; i < input.length; i++){
        var rawItem = input[i];
        if (rawItem.defaultAttr.ignore) continue;
        var label = rawItem.label;
        var transform = label.getComputedTransform(); // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
        var localRect = label.getBoundingRect();
        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
        var minMargin = label.style.margin || 0;
        var globalRect = localRect.clone();
        globalRect.applyTransform(transform);
        globalRect.x -= minMargin / 2;
        globalRect.y -= minMargin / 2;
        globalRect.width += minMargin;
        globalRect.height += minMargin;
        var obb = isAxisAligned ? new (0, $lM5Gp.default)(localRect, transform) : null;
        list.push({
            label: label,
            labelLine: rawItem.labelLine,
            rect: globalRect,
            localRect: localRect,
            obb: obb,
            priority: rawItem.priority,
            defaultAttr: rawItem.defaultAttr,
            layoutOption: rawItem.computedLayoutOption,
            axisAligned: isAxisAligned,
            transform: transform
        });
    }
    return list;
}
function $2be27d213439fed1$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
    var len = list.length;
    if (len < 2) return;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    var shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
     // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap(); // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1); // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    } // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent; // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $2be27d213439fed1$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, // TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    return $2be27d213439fed1$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
}
function $2be27d213439fed1$export$118c25e0932528e4(list, topBound, bottomBound, balanceShift) {
    return $2be27d213439fed1$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
}
function $2be27d213439fed1$export$8ce774e164a49410(labelList) {
    var displayedLabels = []; // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return b.priority - a.priority;
    });
    var globalRect = new (0, $1E3E8.default)(0, 0, 0, 0);
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var isAxisAligned = labelItem.axisAligned;
        var localRect = labelItem.localRect;
        var transform = labelItem.transform;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        globalRect.copy(labelItem.rect); // Add a threshold because layout may be aligned precisely.
        globalRect.width -= 0.1;
        globalRect.height -= 0.1;
        globalRect.x += 0.05;
        globalRect.y += 0.05;
        var obb = labelItem.obb;
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++){
            var existsTextCfg = displayedLabels[j]; // Fast rejection.
            if (!globalRect.intersect(existsTextCfg.rect)) continue;
            if (isAxisAligned && existsTextCfg.axisAligned) {
                // Is overlapped
                overlapped = true;
                break;
            }
            if (!existsTextCfg.obb) // If self is not axis aligned. But other is.
            existsTextCfg.obb = new (0, $lM5Gp.default)(existsTextCfg.localRect, existsTextCfg.transform);
            if (!obb) // If self is axis aligned. But other is not.
            obb = new (0, $lM5Gp.default)(localRect, transform);
            if (obb.intersect(existsTextCfg.obb)) {
                overlapped = true;
                break;
            }
        } // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else {
            label.attr('ignore', labelItem.defaultAttr.ignore);
            labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
            displayedLabels.push(labelItem);
        }
    }
}

});


parcelRegister("atJL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a101b97b7710a5f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $8QSpd = parcelRequire("8QSpd");

var $fkskt = parcelRequire("fkskt");
var $7a101b97b7710a5f$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $7a101b97b7710a5f$var$AxisView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $8QSpd.fixValue(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $8QSpd.getAxisPointerModel(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $7a101b97b7710a5f$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $7a101b97b7710a5f$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $fkskt.default));
var $7a101b97b7710a5f$export$2e2bcd8739ae039 = $7a101b97b7710a5f$var$AxisView;

});
parcelRegister("8QSpd", function(module, exports) {

$parcel$export(module.exports, "collect", () => $671d61e645e8595c$export$bb44f104e3c54dae);
$parcel$export(module.exports, "makeKey", () => $671d61e645e8595c$export$d01b444bafb1a792);
$parcel$export(module.exports, "fixValue", () => $671d61e645e8595c$export$f5ea32e3629d8043);
$parcel$export(module.exports, "getAxisInfo", () => $671d61e645e8595c$export$bd39458db76002ab);
$parcel$export(module.exports, "getAxisPointerModel", () => $671d61e645e8595c$export$3b06fce3f68b734);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gaMkj = parcelRequire("gaMkj");

var $bahqM = parcelRequire("bahqM");
function $671d61e645e8595c$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $671d61e645e8595c$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = []; // Collect axes info.
    (0, $bahqM.each)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $671d61e645e8595c$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
        // for user. So we enable seting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $bahqM.each)(coordSys.getAxes(), (0, $bahqM.curry)(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
         && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $bahqM.each)(tooltipAxes.baseAxes, (0, $bahqM.curry)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $bahqM.each)(tooltipAxes.otherAxes, (0, $bahqM.curry)(saveTooltipAxisInfo, 'cross', false));
        } // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$671d61e645e8595c$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var axisKey = $671d61e645e8595c$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $671d61e645e8595c$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $bahqM.each)(fields, function(field) {
        volatileOption[field] = (0, $bahqM.clone)(tooltipAxisPointerModel.get(field));
    }); // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
    // Only these properties can be overrided from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $bahqM.defaults)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $gaMkj.default)(volatileOption, globalAxisPointerModel, ecModel));
}
function $671d61e645e8595c$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $bahqM.each)(result.coordSysAxesInfo[$671d61e645e8595c$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $671d61e645e8595c$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $bahqM.isArray)(linkPropValue) && (0, $bahqM.indexOf)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $671d61e645e8595c$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $671d61e645e8595c$var$isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
     || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $671d61e645e8595c$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$671d61e645e8595c$export$d01b444bafb1a792(axisModel)];
}
function $671d61e645e8595c$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $671d61e645e8595c$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $671d61e645e8595c$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}

});


parcelRegister("6dLRi", function(module, exports) {

$parcel$export(module.exports, "rectCoordAxisBuildSplitArea", () => $487914b46b0b3c46$export$c80b7ef1527ec8c9);
$parcel$export(module.exports, "rectCoordAxisHandleRemove", () => $487914b46b0b3c46$export$48ebf2d6ce8ad076);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");

var $eaKsF = parcelRequire("eaKsF");
var $487914b46b0b3c46$var$inner = (0, $eaKsF.makeInner)();
function $487914b46b0b3c46$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
     // TODO: TYPE
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
     // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $487914b46b0b3c46$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $bahqM.createHashMap();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $bahqM.isArray(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $7Tw7u.default({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $bahqM.defaults({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $487914b46b0b3c46$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $487914b46b0b3c46$export$48ebf2d6ce8ad076(axisView) {
    $487914b46b0b3c46$var$inner(axisView).splitAreaColors = null;
}

});



parcelRegister("hi3Y7", function(module, exports) {

$parcel$export(module.exports, "install", () => $c9673230869c3336$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $atJL7 = parcelRequire("atJL7");

var $4SGoL = parcelRequire("4SGoL");

var $5UrR7 = parcelRequire("5UrR7");

var $gPvBV = parcelRequire("gPvBV");

var $bahqM = parcelRequire("bahqM");

var $8QSpd = parcelRequire("8QSpd");

var $5TxwA = parcelRequire("5TxwA");
function $c9673230869c3336$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $atJL7.default).registerAxisPointerClass('CartesianAxisPointer', (0, $4SGoL.default));
    registers.registerComponentModel((0, $5UrR7.default));
    registers.registerComponentView((0, $gPvBV.default));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $bahqM.isArray)(link)) option.axisPointer.link = [
                link
            ];
        }
    }); // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $8QSpd.collect)(ecModel, api);
    }); // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $5TxwA.default));
}

});
parcelRegister("4SGoL", function(module, exports) {

$parcel$export(module.exports, "default", () => $38dd17fca85a901b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $fOZs6 = parcelRequire("fOZs6");

var $eSE0c = parcelRequire("eSE0c");

var $dBIJY = parcelRequire("dBIJY");
var $38dd17fca85a901b$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $eSE0c.buildElStyle(axisPointerModel);
            var pointerOption = $38dd17fca85a901b$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $dBIJY.layout(grid.model, axisModel);
        $eSE0c.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $dBIJY.layout(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        }); // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $eSE0c.getTransformedPosition(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $fOZs6.default));
function $38dd17fca85a901b$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $38dd17fca85a901b$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $eSE0c.makeLineShape([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $38dd17fca85a901b$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $eSE0c.makeRectShape([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $38dd17fca85a901b$var$getAxisDimIndex(axis))
        };
    }
};
function $38dd17fca85a901b$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $38dd17fca85a901b$export$2e2bcd8739ae039 = $38dd17fca85a901b$var$CartesianAxisPointer;

});
parcelRegister("fOZs6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b84b31aa9defeeb8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $fHITF = parcelRequire("fHITF");

var $8QSpd = parcelRequire("8QSpd");

var $65X4x = parcelRequire("65X4x");

var $ljaBy = parcelRequire("ljaBy");

var $eaKsF = parcelRequire("eaKsF");
var $b84b31aa9defeeb8$var$inner = (0, $eaKsF.makeInner)();
var $b84b31aa9defeeb8$var$clone = $bahqM.clone;
var $b84b31aa9defeeb8$var$bind = $bahqM.bind;
/**
 * Base axis pointer class in 2D.
 */ var $b84b31aa9defeeb8$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api; // Optimize: `render` will be called repeatly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show(); // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $fHITF.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $bahqM.curry($b84b31aa9defeeb8$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
             // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $8QSpd.getAxisInfo(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent(); // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {};
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl = new $fHITF[pointerOption.type]($b84b31aa9defeeb8$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl = new $fHITF.Text($b84b31aa9defeeb8$var$clone(elOption.label));
            group.add(labelEl);
            $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $fHITF.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function(e) {
                    // Fot mobile devicem, prevent screen slider on the button.
                    $65X4x.stop(e.event);
                },
                onmousedown: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this),
                ondragend: $b84b31aa9defeeb8$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $b84b31aa9defeeb8$var$updateMandatoryProps(handle, axisPointerModel, false); // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ])); // update position
        var handleSize = handleModel.get('size');
        if (!$bahqM.isArray(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $ljaBy.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $b84b31aa9defeeb8$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $b84b31aa9defeeb8$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true; // Persistent for throttle.
        var trans = this.updateHandleTransform($b84b31aa9defeeb8$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($b84b31aa9defeeb8$var$getHandleTransProps(trans));
        $b84b31aa9defeeb8$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {};
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $b84b31aa9defeeb8$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$b84b31aa9defeeb8$var$propsEqual($b84b31aa9defeeb8$var$inner(el).lastProp, props)) {
        $b84b31aa9defeeb8$var$inner(el).lastProp = props;
        moveAnimation ? $fHITF.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $b84b31aa9defeeb8$var$propsEqual(lastProps, newProps) {
    if ($bahqM.isObject(lastProps) && $bahqM.isObject(newProps)) {
        var equals_1 = true;
        $bahqM.each(newProps, function(item, key) {
            equals_1 = equals_1 && $b84b31aa9defeeb8$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $b84b31aa9defeeb8$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $b84b31aa9defeeb8$export$2e2bcd8739ae039 = $b84b31aa9defeeb8$var$BaseAxisPointer;

});
parcelRegister("65X4x", function(module, exports) {

$parcel$export(module.exports, "clientToLocal", () => $47010835ddffd941$export$7d5fecde839eee88);
$parcel$export(module.exports, "getNativeEvent", () => $47010835ddffd941$export$4abe0e945399ac1d);
$parcel$export(module.exports, "normalizeEvent", () => $47010835ddffd941$export$40fadb093aebad71);
$parcel$export(module.exports, "addEventListener", () => $47010835ddffd941$export$3f65cefe8380dbea);
$parcel$export(module.exports, "removeEventListener", () => $47010835ddffd941$export$8ff9f68337b520c0);
$parcel$export(module.exports, "stop", () => $47010835ddffd941$export$fa6813432f753b0d);
$parcel$export(module.exports, "isMiddleOrRightButtonOnMouseUpDown", () => $47010835ddffd941$export$b7ae4cded3e71bd2);


var $hZfwb = parcelRequire("hZfwb");

var $6AZf6 = parcelRequire("6AZf6");
var $47010835ddffd941$var$isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
var $47010835ddffd941$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $47010835ddffd941$var$_calcOut = [];
function $47010835ddffd941$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate || !(0, $hZfwb.default).canvasSupported) $47010835ddffd941$var$calculateZrXY(el, e, out);
    else if ((0, $hZfwb.default).browser.firefox && (0, $hZfwb.default).browser.version < '39' && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $47010835ddffd941$var$calculateZrXY(el, e, out);
    return out;
}
function $47010835ddffd941$var$calculateZrXY(el, e, out) {
    if ((0, $hZfwb.default).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $6AZf6.isCanvasEl)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $6AZf6.transformCoordWithViewport)($47010835ddffd941$var$_calcOut, el, ex, ey)) {
            out.zrX = $47010835ddffd941$var$_calcOut[0];
            out.zrY = $47010835ddffd941$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $47010835ddffd941$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $47010835ddffd941$export$40fadb093aebad71(el, e, calculate) {
    e = $47010835ddffd941$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $47010835ddffd941$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $47010835ddffd941$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $47010835ddffd941$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $47010835ddffd941$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $47010835ddffd941$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $47010835ddffd941$export$3f65cefe8380dbea(el, name, handler, opt) {
    if ($47010835ddffd941$var$isDomLevel2) el.addEventListener(name, handler, opt);
    else el.attachEvent('on' + name, handler);
}
function $47010835ddffd941$export$8ff9f68337b520c0(el, name, handler, opt) {
    if ($47010835ddffd941$var$isDomLevel2) el.removeEventListener(name, handler, opt);
    else el.detachEvent('on' + name, handler);
}
var $47010835ddffd941$export$fa6813432f753b0d = $47010835ddffd941$var$isDomLevel2 ? function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
} : function(e) {
    e.returnValue = false;
    e.cancelBubble = true;
};
function $47010835ddffd941$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}
function $47010835ddffd941$export$a564e1c0090572c3(e) {
    return e.which > 1;
}

});
parcelRegister("6AZf6", function(module, exports) {

$parcel$export(module.exports, "transformLocalCoord", () => $4cd59c60322a6a09$export$8c5c02e118307e20);
$parcel$export(module.exports, "transformCoordWithViewport", () => $4cd59c60322a6a09$export$1219648acc517df4);
$parcel$export(module.exports, "isCanvasEl", () => $4cd59c60322a6a09$export$1b92e4fe606eff6d);

var $hZfwb = parcelRequire("hZfwb");

var $8QVDM = parcelRequire("8QVDM");
var $4cd59c60322a6a09$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $4cd59c60322a6a09$var$_calcOut = [];
function $4cd59c60322a6a09$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $4cd59c60322a6a09$export$1219648acc517df4($4cd59c60322a6a09$var$_calcOut, elFrom, inX, inY, true) && $4cd59c60322a6a09$export$1219648acc517df4(out, elTarget, $4cd59c60322a6a09$var$_calcOut[0], $4cd59c60322a6a09$var$_calcOut[1]);
}
function $4cd59c60322a6a09$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $hZfwb.default).domSupported && !$4cd59c60322a6a09$export$1b92e4fe606eff6d(el)) {
        var saved = el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] || (el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] = {});
        var markers = $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved);
        var transformer = $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $8QVDM.buildTransformer)(destCoords, srcCoords) : (0, $8QVDM.buildTransformer)(srcCoords, destCoords));
}
function $4cd59c60322a6a09$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}

});
parcelRegister("8QVDM", function(module, exports) {

$parcel$export(module.exports, "buildTransformer", () => $671fe44ca8a82f31$export$fbdb2748a8171a7e);
var $671fe44ca8a82f31$var$LN2 = Math.log(2);
function $671fe44ca8a82f31$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $671fe44ca8a82f31$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $671fe44ca8a82f31$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $671fe44ca8a82f31$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $671fe44ca8a82f31$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $671fe44ca8a82f31$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}

});



parcelRegister("ljaBy", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $f833992c62ea3b89$export$de363e709c412c8a);
$parcel$export(module.exports, "createOrUpdate", () => $f833992c62ea3b89$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "clear", () => $f833992c62ea3b89$export$42ffd38884aecdac);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f833992c62ea3b89$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $f833992c62ea3b89$var$RATE = '\0__throttleRate';
var $f833992c62ea3b89$var$THROTTLE_TYPE = '\0__throttleType';
function $f833992c62ea3b89$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $f833992c62ea3b89$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$f833992c62ea3b89$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$f833992c62ea3b89$var$THROTTLE_TYPE];
    var lastRate = fn[$f833992c62ea3b89$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $f833992c62ea3b89$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$f833992c62ea3b89$var$ORIGIN_METHOD] = originFn;
        fn[$f833992c62ea3b89$var$THROTTLE_TYPE] = throttleType;
        fn[$f833992c62ea3b89$var$RATE] = rate;
    }
    return fn;
}
function $f833992c62ea3b89$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$f833992c62ea3b89$var$ORIGIN_METHOD]) obj[fnAttr] = fn[$f833992c62ea3b89$var$ORIGIN_METHOD];
}

});


parcelRegister("eSE0c", function(module, exports) {

$parcel$export(module.exports, "buildElStyle", () => $ad552373bbd775da$export$b7fe459c7cc50060);
$parcel$export(module.exports, "buildLabelElOption", () => $ad552373bbd775da$export$8206a9937c45910f);
$parcel$export(module.exports, "getValueLabel", () => $ad552373bbd775da$export$7cffee0f9aed39d0);
$parcel$export(module.exports, "getTransformedPosition", () => $ad552373bbd775da$export$4bb66440324c3a3d);
$parcel$export(module.exports, "buildCartesianSingleLabelElOption", () => $ad552373bbd775da$export$fd3eb3812211a173);
$parcel$export(module.exports, "makeLineShape", () => $ad552373bbd775da$export$885fa0ad5a826207);
$parcel$export(module.exports, "makeRectShape", () => $ad552373bbd775da$export$a8b35248bcc02756);
$parcel$export(module.exports, "makeSectorShape", () => $ad552373bbd775da$export$b0cf82e7ebc0d7d0);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $fHITF = parcelRequire("fHITF");

var $b7ZX8 = parcelRequire("b7ZX8");

var $dCJrM = parcelRequire("dCJrM");

var $izqgC = parcelRequire("izqgC");

var $3GIoT = parcelRequire("3GIoT");

var $asa08 = parcelRequire("asa08");

var $gvLUt = parcelRequire("gvLUt");
function $ad552373bbd775da$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $ad552373bbd775da$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $dCJrM.normalizeCssArray(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $b7ZX8.getBoundingRect(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
    $ad552373bbd775da$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $gvLUt.createTextStyle)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Lable should be over axisPointer.
        z2: 10
    };
} // Do not overflow ec container
function $ad552373bbd775da$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $ad552373bbd775da$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $3GIoT.getAxisRawValue(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $bahqM.each(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($bahqM.isString(formatter)) text = formatter.replace('{value}', text);
        else if ($bahqM.isFunction(formatter)) text = formatter(params_1);
    }
    return text;
}
function $ad552373bbd775da$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $izqgC.create();
    $izqgC.rotate(transform, transform, layoutInfo.rotation);
    $izqgC.translate(transform, transform, layoutInfo.position);
    return $fHITF.applyTransform([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $ad552373bbd775da$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    // @ts-ignore
    var textLayout = (0, $asa08.default).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $ad552373bbd775da$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $ad552373bbd775da$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $ad552373bbd775da$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $ad552373bbd775da$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}

});


parcelRegister("5UrR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d7ca4f96167e1d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h4UlH = parcelRequire("h4UlH");
var $44d7ca4f96167e1d$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: '#B9BEC9',
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: 'rgba(210,219,238,0.2)'
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: '#fff',
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: 'auto',
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: '#333',
            shadowBlur: 3,
            shadowColor: '#aaa',
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $h4UlH.default));
var $44d7ca4f96167e1d$export$2e2bcd8739ae039 = $44d7ca4f96167e1d$var$AxisPointerModel;

});

parcelRegister("gPvBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c409edfe4aa8d133$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $iNebh = parcelRequire("iNebh");

var $fkskt = parcelRequire("fkskt");
var $c409edfe4aa8d133$var$AxisPointerView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $iNebh.register('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $iNebh.unregister('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $iNebh.unregister('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $fkskt.default));
var $c409edfe4aa8d133$export$2e2bcd8739ae039 = $c409edfe4aa8d133$var$AxisPointerView;

});
parcelRegister("iNebh", function(module, exports) {

$parcel$export(module.exports, "register", () => $dae7cd9e0e79e4d2$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "unregister", () => $dae7cd9e0e79e4d2$export$d07f55d4c15c0440);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $eaKsF = parcelRequire("eaKsF");
var $dae7cd9e0e79e4d2$var$inner = (0, $eaKsF.makeInner)();
var $dae7cd9e0e79e4d2$var$each = $bahqM.each;
function $dae7cd9e0e79e4d2$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $hZfwb.default).node) return;
    var zr = api.getZr();
    $dae7cd9e0e79e4d2$var$inner(zr).records || ($dae7cd9e0e79e4d2$var$inner(zr).records = {});
    $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api);
    var record = $dae7cd9e0e79e4d2$var$inner(zr).records[key] || ($dae7cd9e0e79e4d2$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api) {
    if ($dae7cd9e0e79e4d2$var$inner(zr).initialized) return;
    $dae7cd9e0e79e4d2$var$inner(zr).initialized = true;
    useHandler('click', $bahqM.curry($dae7cd9e0e79e4d2$var$doEnter, 'click'));
    useHandler('mousemove', $bahqM.curry($dae7cd9e0e79e4d2$var$doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
    useHandler('globalout', $dae7cd9e0e79e4d2$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $dae7cd9e0e79e4d2$var$makeDispatchAction(api);
            $dae7cd9e0e79e4d2$var$each($dae7cd9e0e79e4d2$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $dae7cd9e0e79e4d2$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $dae7cd9e0e79e4d2$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $dae7cd9e0e79e4d2$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    }; // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $dae7cd9e0e79e4d2$export$d07f55d4c15c0440(key, api) {
    if ((0, $hZfwb.default).node) return;
    var zr = api.getZr();
    var record = ($dae7cd9e0e79e4d2$var$inner(zr).records || {})[key];
    if (record) $dae7cd9e0e79e4d2$var$inner(zr).records[key] = null;
}

});


parcelRegister("5TxwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $44ac1811f8c8020d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");

var $8QSpd = parcelRequire("8QSpd");

var $4LkI5 = parcelRequire("4LkI5");

var $bahqM = parcelRequire("bahqM");
var $44ac1811f8c8020d$var$inner = (0, $eaKsF.makeInner)();
function $44ac1811f8c8020d$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $bahqM.bind)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($44ac1811f8c8020d$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $4LkI5.default)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $44ac1811f8c8020d$var$illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $44ac1811f8c8020d$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $bahqM.curry)($44ac1811f8c8020d$var$showPointer, showValueMap),
        showTooltip: (0, $bahqM.curry)($44ac1811f8c8020d$var$showTooltip, dataByCoordSys)
    }; // Process for triggered axes.
    (0, $bahqM.each)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $bahqM.each)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $44ac1811f8c8020d$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    }); // Process for linked axes.
    var linkTriggers = {};
    (0, $bahqM.each)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $bahqM.each)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $44ac1811f8c8020d$var$makeMapperParam(srcAxisInfo), $44ac1811f8c8020d$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $bahqM.each)(linkTriggers, function(val, tarKey) {
        $44ac1811f8c8020d$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $44ac1811f8c8020d$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    } // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $44ac1811f8c8020d$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $bahqM.extend)(outputFinder, payloadBatch[0]);
     // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch); // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $44ac1811f8c8020d$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $bahqM.each)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff); // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $bahqM.each)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $44ac1811f8c8020d$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $44ac1811f8c8020d$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $8QSpd.makeKey(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $bahqM.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value; // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
         // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($44ac1811f8c8020d$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    } // In most case only one axis (or event one series is used). It is
    // convinient to fetch payload.seriesIndex and payload.dataIndex
    // dirtectly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification shoule be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] || {};
    var newHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $bahqM.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && (0, $bahqM.each)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    }); // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $bahqM.each)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $bahqM.each)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $44ac1811f8c8020d$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $44ac1811f8c8020d$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

});
parcelRegister("4LkI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $377b9dcb49ed57dc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");
function $377b9dcb49ed57dc$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $eaKsF.queryDataIndex(data, finder);
    if (dataIndex == null || dataIndex < 0 || $bahqM.isArray(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($bahqM.map(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}

});



parcelRegister("alpND", function(module, exports) {

$parcel$export(module.exports, "use", () => $787fe0d1b8504a01$export$1f96ae73734a86cc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8pqpA = parcelRequire("8pqpA");

var $fkskt = parcelRequire("fkskt");

var $loerw = parcelRequire("loerw");

var $h4UlH = parcelRequire("h4UlH");

var $1O7Ua = parcelRequire("1O7Ua");

var $bahqM = parcelRequire("bahqM");

var $9Y5KT = parcelRequire("9Y5KT");
var $787fe0d1b8504a01$var$extensions = [];
var $787fe0d1b8504a01$var$extensionRegisters = {
    registerPreprocessor: (0, $8pqpA.registerPreprocessor),
    registerProcessor: (0, $8pqpA.registerProcessor),
    registerPostInit: (0, $8pqpA.registerPostInit),
    registerPostUpdate: (0, $8pqpA.registerPostUpdate),
    registerUpdateLifecycle: (0, $8pqpA.registerUpdateLifecycle),
    registerAction: (0, $8pqpA.registerAction),
    registerCoordinateSystem: (0, $8pqpA.registerCoordinateSystem),
    registerLayout: (0, $8pqpA.registerLayout),
    registerVisual: (0, $8pqpA.registerVisual),
    registerTransform: (0, $8pqpA.registerTransform),
    registerLoading: (0, $8pqpA.registerLoading),
    registerMap: (0, $8pqpA.registerMap),
    PRIORITY: (0, $8pqpA.PRIORITY),
    ComponentModel: (0, $h4UlH.default),
    ComponentView: (0, $fkskt.default),
    SeriesModel: (0, $1O7Ua.default),
    ChartView: (0, $loerw.default),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $h4UlH.default).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $fkskt.default).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $1O7Ua.default).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $loerw.default).registerClass(ChartViewClass);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $h4UlH.default).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $9Y5KT.registerPainter)(painterType, PainterCtor);
    }
};
function $787fe0d1b8504a01$export$1f96ae73734a86cc(ext) {
    if ((0, $bahqM.isArray)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $bahqM.each)(ext, function(singleExt) {
            $787fe0d1b8504a01$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $bahqM.indexOf)($787fe0d1b8504a01$var$extensions, ext) >= 0) return;
    $787fe0d1b8504a01$var$extensions.push(ext);
    if ((0, $bahqM.isFunction)(ext)) ext = {
        install: ext
    };
    ext.install($787fe0d1b8504a01$var$extensionRegisters);
}

});
parcelRegister("8pqpA", function(module, exports) {

$parcel$export(module.exports, "version", () => $61f525521022d020$export$83d89fbfd8236492);
$parcel$export(module.exports, "dependencies", () => $61f525521022d020$export$b74ff737e0e298b5);
$parcel$export(module.exports, "PRIORITY", () => $61f525521022d020$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "init", () => $61f525521022d020$export$2cd8252107eb640b);
$parcel$export(module.exports, "getInstanceByDom", () => $61f525521022d020$export$33b6fbccd4f643f8);
$parcel$export(module.exports, "connect", () => $61f525521022d020$export$64605811ab45167f);
$parcel$export(module.exports, "disConnect", () => $61f525521022d020$export$87cd6834112ecb52);
$parcel$export(module.exports, "disconnect", () => $61f525521022d020$export$37dfea93db2e14ed);
$parcel$export(module.exports, "dispose", () => $61f525521022d020$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "getInstanceById", () => $61f525521022d020$export$89b4be35062c4a3f);
$parcel$export(module.exports, "registerTheme", () => $61f525521022d020$export$f9c59eed5de5ff80);
$parcel$export(module.exports, "registerPreprocessor", () => $61f525521022d020$export$77095792a057b768);
$parcel$export(module.exports, "registerProcessor", () => $61f525521022d020$export$d575e6557ac1729f);
$parcel$export(module.exports, "registerPostInit", () => $61f525521022d020$export$c8c249911ee8c1ed);
$parcel$export(module.exports, "registerUpdateLifecycle", () => $61f525521022d020$export$c9ec4b5faef04865);
$parcel$export(module.exports, "registerPostUpdate", () => $61f525521022d020$export$99560909c18c76bb);
$parcel$export(module.exports, "registerAction", () => $61f525521022d020$export$408c24786cd729c6);
$parcel$export(module.exports, "registerCoordinateSystem", () => $61f525521022d020$export$1dd5e025a8a37dd);
$parcel$export(module.exports, "getCoordinateSystemDimensions", () => $61f525521022d020$export$fc2638719e4159b9);
$parcel$export(module.exports, "registerLayout", () => $61f525521022d020$export$d768f97700ca6bea);
$parcel$export(module.exports, "registerVisual", () => $61f525521022d020$export$5f32c1eb94c381bb);
$parcel$export(module.exports, "registerLoading", () => $61f525521022d020$export$e06b68a82007c015);
$parcel$export(module.exports, "setCanvasCreator", () => $61f525521022d020$export$10425ea7a243b114);
$parcel$export(module.exports, "registerMap", () => $61f525521022d020$export$d456de060be2dba1);
$parcel$export(module.exports, "getMap", () => $61f525521022d020$export$b8586192aead8a7e);
$parcel$export(module.exports, "registerTransform", () => $61f525521022d020$export$f01d71dd0389d7e4);
$parcel$export(module.exports, "dataTool", () => $61f525521022d020$export$73cae5e090579589);
$parcel$export(module.exports, "registerLocale", () => (parcelRequire("3OMoQ")).registerLocale);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $3VFsf = parcelRequire("3VFsf");

var $9Y5KT = parcelRequire("9Y5KT");

var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");

var $hZfwb = parcelRequire("hZfwb");

var $aVBu2 = parcelRequire("aVBu2");

var $bRKv5 = parcelRequire("bRKv5");

var $74g78 = parcelRequire("74g78");

var $iEvqc = parcelRequire("iEvqc");

var $gyhNQ = parcelRequire("gyhNQ");

var $6LzFt = parcelRequire("6LzFt");

var $driCQ = parcelRequire("driCQ");

var $iMppY = parcelRequire("iMppY");

var $1O7Ua = parcelRequire("1O7Ua");

var $fkskt = parcelRequire("fkskt");

var $loerw = parcelRequire("loerw");
parcelRequire("fHITF");
var $gcbBH = parcelRequire("gcbBH");
var $ghQ8v = parcelRequire("ghQ8v");
var $7Tw7u = parcelRequire("7Tw7u");
var $eYgMC = parcelRequire("eYgMC");

var $7QjoM = parcelRequire("7QjoM");

var $fIXXx = parcelRequire("fIXXx");

var $eaKsF = parcelRequire("eaKsF");

var $ljaBy = parcelRequire("ljaBy");

var $cvEVp = parcelRequire("cvEVp");

var $4G956 = parcelRequire("4G956");

var $14WFd = parcelRequire("14WFd");

var $31FQc = parcelRequire("31FQc");

var $dMJCs = parcelRequire("dMJCs");

var $aLwh0 = parcelRequire("aLwh0");

var $cbv5T = parcelRequire("cbv5T");

var $7wiHx = parcelRequire("7wiHx");

var $fk5Gm = parcelRequire("fk5Gm");

var $2cFRc = parcelRequire("2cFRc");

var $1nKsD = parcelRequire("1nKsD");

var $05ab4 = parcelRequire("05ab4");

var $3OMoQ = parcelRequire("3OMoQ");

var $6IsbX = parcelRequire("6IsbX");

var $g2DhS = parcelRequire("g2DhS");

var $fEzwg = parcelRequire("fEzwg");

var $8cCW2 = parcelRequire("8cCW2");
var $61f525521022d020$var$hasWindow = typeof window !== 'undefined';
var $61f525521022d020$export$83d89fbfd8236492 = '5.2.1';
var $61f525521022d020$export$b74ff737e0e298b5 = {
    zrender: '5.2.1'
};
var $61f525521022d020$var$TEST_FRAME_REMAIN_TIME = 1;
var $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800; // Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK = 900; // "Data filter" will block the stream, so it should be
// put at the begining of data processing.
var $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $61f525521022d020$var$PRIORITY_VISUAL_CHART = 3000;
var $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT = 4000; // Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500; // Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $61f525521022d020$var$PRIORITY_VISUAL_BRUSH = 5000;
var $61f525521022d020$var$PRIORITY_VISUAL_ARIA = 6000;
var $61f525521022d020$var$PRIORITY_VISUAL_DECAL = 7000;
var $61f525521022d020$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $61f525521022d020$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $61f525521022d020$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $61f525521022d020$var$PRIORITY_VISUAL_ARIA,
        DECAL: $61f525521022d020$var$PRIORITY_VISUAL_DECAL
    }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $61f525521022d020$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
var $61f525521022d020$var$PENDING_UPDATE = '__pendingUpdate';
var $61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $61f525521022d020$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $61f525521022d020$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $61f525521022d020$var$CONNECT_STATUS_PENDING = 0;
var $61f525521022d020$var$CONNECT_STATUS_UPDATING = 1;
var $61f525521022d020$var$CONNECT_STATUS_UPDATED = 2;
function $61f525521022d020$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $61f525521022d020$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $bRKv5.default).prototype[method].apply(host, args);
}
var $61f525521022d020$var$MessageCenter = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $bRKv5.default));
var $61f525521022d020$var$messageCenterProto = $61f525521022d020$var$MessageCenter.prototype;
$61f525521022d020$var$messageCenterProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('on');
$61f525521022d020$var$messageCenterProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('off'); // ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $61f525521022d020$var$prepare;
var $61f525521022d020$var$prepareView;
var $61f525521022d020$var$updateDirectly;
var $61f525521022d020$var$updateMethods;
var $61f525521022d020$var$doConvertPixel;
var $61f525521022d020$var$updateStreamModes;
var $61f525521022d020$var$doDispatchAction;
var $61f525521022d020$var$flushPendingActions;
var $61f525521022d020$var$triggerUpdatedEvent;
var $61f525521022d020$var$bindRenderedEvent;
var $61f525521022d020$var$bindMouseEvent;
var $61f525521022d020$var$clearColorPalette;
var $61f525521022d020$var$render;
var $61f525521022d020$var$renderComponents;
var $61f525521022d020$var$renderSeries;
var $61f525521022d020$var$createExtensionAPI;
var $61f525521022d020$var$enableConnect;
var $61f525521022d020$var$markStatusToUpdate;
var $61f525521022d020$var$applyChangedStates;
var $61f525521022d020$var$ECharts = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECharts, _super);
    function ECharts(dom, theme, opts) {
        var _this = _super.call(this, new (0, $cbv5T.ECEventProcessor)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {}; // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {}; // Get theme by name
        if (typeof theme === 'string') theme = $61f525521022d020$var$themeStorage[theme];
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultUseDirtyRect = false;
        var root, devUseDirtyRect;
        var zr = _this._zr = $9Y5KT.init(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            useDirtyRect: opts.useDirtyRect == null ? defaultUseDirtyRect : opts.useDirtyRect
        }); // Expect 60 fps.
        _this._throttledZrFlush = (0, $ljaBy.throttle)((0, $bahqM.bind)(zr.flush, zr), 17);
        theme = (0, $bahqM.clone)(theme);
        theme && (0, $driCQ.default)(theme, true);
        _this._theme = theme;
        _this._locale = (0, $3OMoQ.createLocaleObject)(opts.locale || (0, $3OMoQ.SYSTEM_LANG));
        _this._coordSysMgr = new (0, $gyhNQ.default)();
        var api = _this._api = $61f525521022d020$var$createExtensionAPI(_this); // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $aVBu2.default)($61f525521022d020$var$visualFuncs, prioritySortFunc);
        (0, $aVBu2.default)($61f525521022d020$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $14WFd.default)(_this, api, $61f525521022d020$var$dataProcessorFuncs, $61f525521022d020$var$visualFuncs);
        _this._messageCenter = new $61f525521022d020$var$MessageCenter(); // Init mouse events
        _this._initEvents(); // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $bahqM.bind)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $61f525521022d020$var$bindRenderedEvent(zr, _this);
        $61f525521022d020$var$bindMouseEvent(zr, _this); // ECharts instance can be used as value.
        (0, $bahqM.setAsPrimitive)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $61f525521022d020$var$applyChangedStates(this);
        var scheduler = this._scheduler; // Lazy update
        if (this[$61f525521022d020$var$PENDING_UPDATE]) {
            var silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            $61f525521022d020$var$prepare(this);
            $61f525521022d020$var$updateMethods.update.call(this, null, this[$61f525521022d020$var$PENDING_UPDATE].updateParams); // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            this[$61f525521022d020$var$PENDING_UPDATE] = null;
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $61f525521022d020$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $61f525521022d020$var$updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determin in the first frame (the
                // frame is executed immedietely after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $61f525521022d020$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
             // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $bahqM.isObject)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
        if (!this._model || notMerge) {
            var optionManager = new (0, $6LzFt.default)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $74g78.default)();
            ecModel.scheduler = this._scheduler;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $61f525521022d020$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$61f525521022d020$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false; // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            $61f525521022d020$var$prepare(this);
            $61f525521022d020$var$updateMethods.update.call(this, null, updateParams); // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            this._zr.flush();
            this[$61f525521022d020$var$PENDING_UPDATE] = null;
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * @DEPRECATED
   */ ECharts.prototype.setTheme = function() {
        console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
    }; // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || $61f525521022d020$var$hasWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        if (!(0, $hZfwb.default).canvasSupported) return;
        opts = opts || {};
        return this._zr.painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        if (!(0, $hZfwb.default).svgSupported) return;
        var zr = this._zr;
        var list = zr.storage.getDisplayList(); // Stop animations
        (0, $bahqM.each)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $bahqM.each)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $bahqM.each)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $hZfwb.default).canvasSupported) return;
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($61f525521022d020$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $bahqM.each)($61f525521022d020$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas((0, $bahqM.clone)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $bahqM.createCanvas)();
            var zr_1 = $9Y5KT.init(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $bahqM.each)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $7Tw7u.default({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $bahqM.each)(canvasList_1, function(item) {
                    var img = new $gcbBH.default({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value) {
        return $61f525521022d020$var$doConvertPixel(this, 'convertToPixel', finder, value);
    };
    ECharts.prototype.convertFromPixel = function(finder, value) {
        return $61f525521022d020$var$doConvertPixel(this, 'convertFromPixel', finder, value);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $eaKsF.parseFinder(ecModel, finder);
        (0, $bahqM.each)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $bahqM.each)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $eaKsF.parseFinder(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $fk5Gm.getItemVisualFromData)(data, dataIndexInside, visualType) : (0, $fk5Gm.getVisualFromData)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $bahqM.each)($61f525521022d020$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $6IsbX.findEventDispatcher)(el, function(parent) {
                    var ecData = (0, $7QjoM.getECData)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $bahqM.extend)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                 // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            }; // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        (0, $bahqM.each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        }); // Extra events
        // TODO register?
        (0, $bahqM.each)([
            'selectchanged'
        ], function(eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        (0, $1nKsD.handleLegacySelectEvents)(this._messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        $eaKsF.setAttribute(this.getDom(), $61f525521022d020$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $bahqM.each)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $bahqM.each)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        }); // Dispose after all views disposed
        chart._zr.dispose(); // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $61f525521022d020$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model; // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent; // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$61f525521022d020$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$61f525521022d020$var$PENDING_UPDATE] = null;
        }
        this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
        needPrepare && $61f525521022d020$var$prepare(this);
        $61f525521022d020$var$updateMethods.update.call(this, {
            type: 'resize',
            animation: (0, $bahqM.extend)({
                // Disable animation
                duration: 0
            }, opts && opts.animation)
        });
        this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
        $61f525521022d020$var$flushPendingActions.call(this, silent);
        $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        if ((0, $bahqM.isObject)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$61f525521022d020$var$loadingEffects[name]) return;
        var el = $61f525521022d020$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $bahqM.extend)({}, eventObj);
        payload.type = $61f525521022d020$var$eventActionMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $bahqM.isObject)(opt)) opt = {
            silent: !!opt
        };
        if (!$61f525521022d020$var$actions[payload.type]) return;
         // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
         // May dispatchAction in rendering procedure
        if (this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $hZfwb.default).browser.weChat) // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh util user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $61f525521022d020$var$flushPendingActions.call(this, silent);
        $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $8cCW2.default).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    }; // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $61f525521022d020$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $61f525521022d020$var$prepareView(ecIns, true);
            $61f525521022d020$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $61f525521022d020$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By defaut view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView; // This command should not work twice.
                model.__requireNewView = false; // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $aLwh0.parseClassType)(model.type);
                    var Clazz = isComponent ? (0, $fkskt.default).getClass(classType.main, classType.sub) : // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $loerw.default).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $61f525521022d020$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload); // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $bahqM.each)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + 'Id'] = payload[mainType + 'Id'];
            query[mainType + 'Index'] = payload[mainType + 'Index'];
            query[mainType + 'Name'] = payload[mainType + 'Name'];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $bahqM.createHashMap)();
                (0, $bahqM.each)($eaKsF.normalizeToArray(excludeSeriesId), function(id) {
                    var modelId = $eaKsF.convertOptionIdName(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            if ((0, $fIXXx.isHighDownPayload)(payload)) (0, $fIXXx.allLeaveBlur)(ecIns._api);
             // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                if (isExcluded) return;
                if ((0, $fIXXx.isHighDownPayload)(payload)) {
                    if (model instanceof (0, $1O7Ua.default)) {
                        if (payload.type === (0, $fIXXx.HIGHLIGHT_ACTION_TYPE) && !payload.notBlur) (0, $fIXXx.blurSeriesFromHighlightPayload)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $fIXXx.findComponentHighDownDispatchers)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $fIXXx.HIGHLIGHT_ACTION_TYPE) && focusSelf && !payload.notBlur) (0, $fIXXx.blurComponent)(model.mainType, model.componentIndex, ecIns._api);
                         // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $bahqM.each)(dispatchers, function(dispatcher) {
                            payload.type === (0, $fIXXx.HIGHLIGHT_ACTION_TYPE) ? (0, $fIXXx.enterEmphasis)(dispatcher) : (0, $fIXXx.leaveEmphasis)(dispatcher);
                        });
                    }
                } else if ((0, $fIXXx.isSelectChangePayload)(payload)) // TODO geo
                {
                    if (model instanceof (0, $1O7Ua.default)) {
                        (0, $fIXXx.toggleSelectionFromPayload)(model, payload, ecIns._api);
                        (0, $fIXXx.updateSeriesElementSelection)(model);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $61f525521022d020$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $61f525521022d020$var$prepare(this);
                $61f525521022d020$var$updateMethods.update.call(this, payload, {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel); // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the orignal point
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // deteming whether use progressive rendering.
                $61f525521022d020$var$updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not requied in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                $61f525521022d020$var$clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                $61f525521022d020$var$render(this, ecModel, api, payload, updateParams); // Set background
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                var darkMode = ecModel.get('darkMode'); // In IE8
                if (!(0, $hZfwb.default).canvasSupported) {
                    var colorArr = $d6udH.parse(backgroundColor);
                    backgroundColor = $d6udH.stringify(colorArr, 'rgb');
                    if (colorArr[3] === 0) backgroundColor = 'transparent';
                } else {
                    zr.setBackgroundColor(backgroundColor); // Force set dark mode.
                    if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                }
                (0, $8cCW2.default).trigger('afterupdate', ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload); // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === 'series') return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $bahqM.createHashMap)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                $61f525521022d020$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                }); // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $61f525521022d020$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $8cCW2.default).trigger('afterupdate', ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $loerw.default).markUpdateMethod(payload, 'updateView');
                $61f525521022d020$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $61f525521022d020$var$render(this, ecModel, this._api, payload, {});
                (0, $8cCW2.default).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload); // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                }); // Perform visual
                (0, $loerw.default).markUpdateMethod(payload, 'updateVisual');
                $61f525521022d020$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $8cCW2.default).trigger('afterupdate', ecModel, this._api);
            },
            updateLayout: function(payload) {
                $61f525521022d020$var$updateMethods.update.call(this, payload);
            }
        };
        $61f525521022d020$var$doConvertPixel = function(ecIns, methodName, finder, value) {
            if (ecIns._disposed) {
                $61f525521022d020$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $eaKsF.parseFinder(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
            }
        };
        $61f525521022d020$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $61f525521022d020$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionWrap = $61f525521022d020$var$actions[payloadType];
            var actionInfo = actionWrap.actionInfo;
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $aLwh0.parseClassType)(cptTypeTmp[0]);
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            var payloads = [
                payload
            ];
            var batched = false; // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $bahqM.map)(payload.batch, function(item) {
                    item = (0, $bahqM.defaults)((0, $bahqM.extend)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var isSelectChange = (0, $fIXXx.isSelectChangePayload)(payload);
            var isHighDown = (0, $fIXXx.isHighDownPayload)(payload);
            (0, $bahqM.each)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                eventObj = actionWrap.action(batchItem, _this._model, _this._api); // Emit event outside
                eventObj = eventObj || (0, $bahqM.extend)({}, batchItem); // Convert type to eventType
                eventObj.type = actionInfo.event || eventObj.type;
                eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $eaKsF.preParseFinder(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $61f525521022d020$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $61f525521022d020$var$markStatusToUpdate(_this);
                } else if (cptType) $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
                // Still dirty
                if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                    $61f525521022d020$var$prepare(this);
                    $61f525521022d020$var$updateMethods.update.call(this, payload);
                    this[$61f525521022d020$var$PENDING_UPDATE] = null;
                } else $61f525521022d020$var$updateMethods[updateMethod].call(this, payload);
            } // Follow the rule of action batch
            if (batched) eventObj = {
                type: actionInfo.event || payloadType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var messageCenter = this._messageCenter;
                messageCenter.trigger(eventObj.type, eventObj); // Extra triggered 'selectchanged' event
                if (isSelectChange) {
                    var newObj = {
                        type: 'selectchanged',
                        escapeConnect: escapeConnect,
                        selected: (0, $fIXXx.getAllSelectedIndices)(ecModel),
                        isFromClick: payload.isFromClick || false,
                        fromAction: payload.type,
                        fromActionPayload: payload
                    };
                    messageCenter.trigger(newObj.type, newObj);
                }
            }
        };
        $61f525521022d020$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $61f525521022d020$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $61f525521022d020$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params); // The `finished` event should not be triggered repeatly,
                // so it should only be triggered when rendering indeed happend
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$61f525521022d020$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
            });
        };
        $61f525521022d020$var$bindMouseEvent = function(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $6IsbX.findEventDispatcher)(el, (0, $fIXXx.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $fIXXx.handleGlobalMouseOverForHighDown)(dispatcher, e, ecIns._api);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $6IsbX.findEventDispatcher)(el, (0, $fIXXx.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $fIXXx.handleGlboalMouseOutForHighDown)(dispatcher, e, ecIns._api);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $6IsbX.findEventDispatcher)(el, function(target) {
                    return (0, $7QjoM.getECData)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $7QjoM.getECData)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        $61f525521022d020$var$clearColorPalette = function(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        };
        $61f525521022d020$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            $61f525521022d020$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $bahqM.each)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $61f525521022d020$var$renderSeries(ecIns, ecModel, api, payload, updateParams); // Remove groups of unrendered charts
            (0, $bahqM.each)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $61f525521022d020$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $bahqM.each)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $61f525521022d020$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $bahqM.extend)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            }); // TODO progressive?
            (0, $8cCW2.default).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload); // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent'); // Should not call markRedraw on group, because it will disable zrender
                // increamental render (alway render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $fIXXx.updateSeriesElementSelection)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $8cCW2.default).trigger('series:layoutlabels', ecModel, api, updateParams); // transition after label is layouted.
            (0, $8cCW2.default).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId]; // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView); // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            }); // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $8cCW2.default).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $61f525521022d020$var$markStatusToUpdate = function(ecIns) {
            ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = true; // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $61f525521022d020$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($eYgMC.isElementRemoved(el)) return;
                applyElementStates(el);
            });
            ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates; // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            } // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $fIXXx.HOVER_STATE_EMPHASIS) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $fIXXx.HOVER_STATE_BLUR) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get('hoverLayerThreshold') && !(0, $hZfwb.default).node && !(0, $hZfwb.default).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.group.traverse(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.group.traverse(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DONT mark the element dirty. In case element is incremental and don't wan't to rerender.
                el.style.blend = blendMode;
                if (el.eachPendingDisplayable) el.eachPendingDisplayable(function(displayable) {
                    displayable.style.blend = blendMode;
                });
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
             // Set z and zlevel
            _updateZ(view.group, model.get('z') || 0, model.get('zlevel') || 0, -Infinity);
        }
        function _updateZ(el, z, zlevel, maxZ2) {
            // Group may also have textContent
            var label = el.getTextContent();
            var labelLine = el.getTextGuideLine();
            var isGroup = el.isGroup;
            if (isGroup) {
                // set z & zlevel of children elements of Group
                // el.traverse((childEl: Element) => _updateZ(childEl, z, zlevel));
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++)maxZ2 = Math.max(_updateZ(children[i], z, zlevel, maxZ2), maxZ2);
            } else {
                // not Group
                el.z = z;
                el.zlevel = zlevel;
                maxZ2 = Math.max(el.z2, maxZ2);
            } // always set z and zlevel if label/labelLine exists
            if (label) {
                label.z = z;
                label.zlevel = zlevel; // lift z2 of text content
                // TODO if el.emphasis.z2 is spcefied, what about textContent.
                isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
            }
            if (labelLine) {
                var textGuideLineConfig = el.textGuideLineConfig;
                labelLine.z = z;
                labelLine.zlevel = zlevel;
                isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
            }
            return maxZ2;
        } // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.group.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($eYgMC.isElementRemoved(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                 // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing') // additive: stateAnimationModel.get('additive')
            } : null;
            view.group.traverse(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($eYgMC.isElementRemoved(el)) return;
                    if (el instanceof $ghQ8v.default) (0, $fIXXx.savePathStates)(el);
                     // Only updated on changed element. In case element is incremental and don't wan't to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates; // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    } // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine(); // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    } // The use higlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $61f525521022d020$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $3VFsf.__extends)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $fIXXx.enterEmphasis)(el, highlightDigit);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $fIXXx.leaveEmphasis)(el, highlightDigit);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $fIXXx.enterBlur)(el);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $fIXXx.leaveBlur)(el);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $fIXXx.enterSelect)(el);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $fIXXx.leaveSelect)(el);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                return class_1;
            }((0, $iEvqc.default)))(ecIns);
        };
        $61f525521022d020$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $bahqM.each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($61f525521022d020$var$connectedGroups[chart.group] && chart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $bahqM.each)($61f525521022d020$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_PENDING);
                        (0, $bahqM.each)(otherCharts_1, function(otherChart) {
                            if (otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $bRKv5.default));
var $61f525521022d020$var$echartsProto = $61f525521022d020$var$ECharts.prototype;
$61f525521022d020$var$echartsProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('on');
$61f525521022d020$var$echartsProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$61f525521022d020$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $2cFRc.deprecateLog)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2); // @ts-ignore
        self.off(eventName, wrapped);
    }
    this.on.call(this, eventName, wrapped, ctx);
}; // /**
//  * Encode visual infomation from data after data processing
//  *
//  * @param {module:echarts/model/Global} ecModel
//  * @param {object} layout
//  * @param {boolean} [layoutFilter] `true`: only layout,
//  *                                 `false`: only not layout,
//  *                                 `null`/`undefined`: all.
//  * @param {string} taskBaseTag
//  * @private
//  */
// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
//     each(visualFuncs, function (visual, index) {
//         let isLayout = visual.isLayout;
//         if (layoutFilter == null
//             || (layoutFilter === false && !isLayout)
//             || (layoutFilter === true && isLayout)
//         ) {
//             visual.func(ecModel, api, payload);
//         }
//     });
// }
var $61f525521022d020$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $61f525521022d020$var$disposedWarning(id) {}
var $61f525521022d020$var$actions = {};
/**
 * Map eventType to actionType
 */ var $61f525521022d020$var$eventActionMap = {};
var $61f525521022d020$var$dataProcessorFuncs = [];
var $61f525521022d020$var$optionPreprocessorFuncs = [];
var $61f525521022d020$var$visualFuncs = [];
var $61f525521022d020$var$themeStorage = {};
var $61f525521022d020$var$loadingEffects = {};
var $61f525521022d020$var$instances = {};
var $61f525521022d020$var$connectedGroups = {};
var $61f525521022d020$var$idBase = +new Date() - 0;
var $61f525521022d020$var$groupIdBase = +new Date() - 0;
var $61f525521022d020$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $61f525521022d020$export$2cd8252107eb640b(dom, theme, opts) {
    var existInstance = $61f525521022d020$export$33b6fbccd4f643f8(dom);
    if (existInstance) return existInstance;
    var chart = new $61f525521022d020$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $61f525521022d020$var$idBase++;
    $61f525521022d020$var$instances[chart.id] = chart;
    $eaKsF.setAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY, chart.id);
    $61f525521022d020$var$enableConnect(chart);
    (0, $8cCW2.default).trigger('afterinit', chart);
    return chart;
}
function $61f525521022d020$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $bahqM.isArray)(groupId)) {
        var charts = groupId;
        groupId = null; // If any chart has group
        (0, $bahqM.each)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $61f525521022d020$var$groupIdBase++;
        (0, $bahqM.each)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $61f525521022d020$var$connectedGroups[groupId] = true;
    return groupId;
}
function $61f525521022d020$export$87cd6834112ecb52(groupId) {
    $61f525521022d020$var$connectedGroups[groupId] = false;
}
var $61f525521022d020$export$37dfea93db2e14ed = $61f525521022d020$export$87cd6834112ecb52;
function $61f525521022d020$export$fcfbbcec2cb820d5(chart) {
    if (typeof chart === 'string') chart = $61f525521022d020$var$instances[chart];
    else if (!(chart instanceof $61f525521022d020$var$ECharts)) // Try to treat as dom
    chart = $61f525521022d020$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $61f525521022d020$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $61f525521022d020$export$33b6fbccd4f643f8(dom) {
    return $61f525521022d020$var$instances[$eaKsF.getAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY)];
}
function $61f525521022d020$export$89b4be35062c4a3f(key) {
    return $61f525521022d020$var$instances[key];
}
function $61f525521022d020$export$f9c59eed5de5ff80(name, theme) {
    $61f525521022d020$var$themeStorage[name] = theme;
}
function $61f525521022d020$export$77095792a057b768(preprocessorFunc) {
    if ((0, $bahqM.indexOf)($61f525521022d020$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $61f525521022d020$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $61f525521022d020$export$d575e6557ac1729f(priority, processor) {
    $61f525521022d020$var$normalizeRegister($61f525521022d020$var$dataProcessorFuncs, priority, processor, $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $61f525521022d020$export$c8c249911ee8c1ed(postInitFunc) {
    $61f525521022d020$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $61f525521022d020$export$99560909c18c76bb(postUpdateFunc) {
    $61f525521022d020$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $61f525521022d020$export$c9ec4b5faef04865(name, cb) {
    (0, $8cCW2.default).on(name, cb);
}
function $61f525521022d020$export$408c24786cd729c6(actionInfo, eventName, action) {
    if (typeof eventName === 'function') {
        action = eventName;
        eventName = '';
    }
    var actionType = (0, $bahqM.isObject)(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0]; // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event;
    if ($61f525521022d020$var$eventActionMap[eventName]) // Already registered.
    return;
     // Validate action type and event name.
    (0, $bahqM.assert)($61f525521022d020$var$ACTION_REG.test(actionType) && $61f525521022d020$var$ACTION_REG.test(eventName));
    if (!$61f525521022d020$var$actions[actionType]) $61f525521022d020$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $61f525521022d020$var$eventActionMap[eventName] = actionType;
}
function $61f525521022d020$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $gyhNQ.default).register(type, coordSysCreator);
}
function $61f525521022d020$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $gyhNQ.default).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $61f525521022d020$export$d768f97700ca6bea(priority, layoutTask) {
    $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, layoutTask, $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT, 'layout');
}
function $61f525521022d020$export$5f32c1eb94c381bb(priority, visualTask) {
    $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, visualTask, $61f525521022d020$var$PRIORITY_VISUAL_CHART, 'visual');
}
var $61f525521022d020$var$registeredTasks = [];
function $61f525521022d020$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $bahqM.isFunction)(priority) || (0, $bahqM.isObject)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    if ((0, $bahqM.indexOf)($61f525521022d020$var$registeredTasks, fn) >= 0) return;
    $61f525521022d020$var$registeredTasks.push(fn);
    var stageHandler = (0, $14WFd.default).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $61f525521022d020$export$e06b68a82007c015(name, loadingFx) {
    $61f525521022d020$var$loadingEffects[name] = loadingFx;
}
function $61f525521022d020$export$10425ea7a243b114(creator) {
    (0, $bahqM.$override)('createCanvas', creator);
}
function $61f525521022d020$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    (0, $fEzwg.default).registerMap(mapName, geoJson, specialAreas);
}
function $61f525521022d020$export$b8586192aead8a7e(mapName) {
    return (0, $fEzwg.default).getMapForUser(mapName);
}
var $61f525521022d020$export$f01d71dd0389d7e4 = (0, $05ab4.registerExternalTransform);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Buitlin global visual
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, $cvEVp.seriesStyleTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $cvEVp.dataStyleTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $cvEVp.dataColorPaletteTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, $7wiHx.seriesSymbolTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $7wiHx.dataSymbolTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_DECAL, (0, $g2DhS.default));
$61f525521022d020$export$77095792a057b768((0, $driCQ.default));
$61f525521022d020$export$d575e6557ac1729f($61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK, (0, $iMppY.default));
$61f525521022d020$export$e06b68a82007c015('default', (0, $4G956.default)); // Default actions
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.HIGHLIGHT_ACTION_TYPE),
    event: (0, $fIXXx.HIGHLIGHT_ACTION_TYPE),
    update: (0, $fIXXx.HIGHLIGHT_ACTION_TYPE)
}, (0, $bahqM.noop));
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.DOWNPLAY_ACTION_TYPE),
    event: (0, $fIXXx.DOWNPLAY_ACTION_TYPE),
    update: (0, $fIXXx.DOWNPLAY_ACTION_TYPE)
}, (0, $bahqM.noop));
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.SELECT_ACTION_TYPE),
    event: (0, $fIXXx.SELECT_ACTION_TYPE),
    update: (0, $fIXXx.SELECT_ACTION_TYPE)
}, (0, $bahqM.noop));
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.UNSELECT_ACTION_TYPE),
    event: (0, $fIXXx.UNSELECT_ACTION_TYPE),
    update: (0, $fIXXx.UNSELECT_ACTION_TYPE)
}, (0, $bahqM.noop));
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.TOGGLE_SELECT_ACTION_TYPE),
    event: (0, $fIXXx.TOGGLE_SELECT_ACTION_TYPE),
    update: (0, $fIXXx.TOGGLE_SELECT_ACTION_TYPE)
}, (0, $bahqM.noop)); // Default theme
$61f525521022d020$export$f9c59eed5de5ff80('light', (0, $31FQc.default));
$61f525521022d020$export$f9c59eed5de5ff80('dark', (0, $dMJCs.default)); // For backward compatibility, where the namespace `dataTool` will
var $61f525521022d020$export$73cae5e090579589 = {};

});
parcelRegister("9Y5KT", function(module, exports) {

$parcel$export(module.exports, "init", () => $741e2e865750343c$export$2cd8252107eb640b);
$parcel$export(module.exports, "dispose", () => $741e2e865750343c$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "disposeAll", () => $741e2e865750343c$export$825f692fb04800ef);
$parcel$export(module.exports, "getInstance", () => $741e2e865750343c$export$8bedcca5bbd73999);
$parcel$export(module.exports, "registerPainter", () => $741e2e865750343c$export$a3e793ccb11823a5);
$parcel$export(module.exports, "version", () => $741e2e865750343c$export$83d89fbfd8236492);
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ 
var $hZfwb = parcelRequire("hZfwb");

var $bahqM = parcelRequire("bahqM");

var $jaJTK = parcelRequire("jaJTK");

var $66sfA = parcelRequire("66sfA");

var $F44Dl = parcelRequire("F44Dl");

var $bHSYT = parcelRequire("bHSYT");

var $d6udH = parcelRequire("d6udH");

var $7y1my = parcelRequire("7y1my");

var $4KVOr = parcelRequire("4KVOr");
var $741e2e865750343c$var$useVML = !(0, $hZfwb.default).canvasSupported;
var $741e2e865750343c$var$painterCtors = {};
var $741e2e865750343c$var$instances = {};
function $741e2e865750343c$var$delInstance(id) {
    delete $741e2e865750343c$var$instances[id];
}
function $741e2e865750343c$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $d6udH.lum)(backgroundColor, 1) < (0, $7y1my.DARK_MODE_THRESHOLD);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $d6udH.lum)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $7y1my.DARK_MODE_THRESHOLD);
    }
    return false;
}
var $741e2e865750343c$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $66sfA.default)();
        var rendererType = opts.renderer || 'canvas';
        if ($741e2e865750343c$var$useVML) throw new Error('IE8 support has been dropped since 5.0');
        if (!$741e2e865750343c$var$painterCtors[rendererType]) rendererType = $bahqM.keys($741e2e865750343c$var$painterCtors)[0];
        if (!$741e2e865750343c$var$painterCtors[rendererType]) throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $741e2e865750343c$var$painterCtors[rendererType](dom, storage, opts, id);
        this.storage = storage;
        this.painter = painter;
        var handerProxy = !(0, $hZfwb.default).node && !(0, $hZfwb.default).worker ? new (0, $bHSYT.default)(painter.getViewportRoot(), painter.root) : null;
        this.handler = new (0, $jaJTK.default)(storage, painter, handerProxy, painter.root);
        this.animation = new (0, $F44Dl.default)({
            stage: {
                update: function() {
                    return _this._flush(true);
                }
            }
        });
        this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (!el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (!el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $741e2e865750343c$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = new Date().getTime();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = new Date().getTime();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.addHover = function(el) {};
    ZRender.prototype.removeHover = function(el) {};
    ZRender.prototype.clearHover = function() {};
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        return this.painter.getHeight();
    };
    ZRender.prototype.pathToImage = function(e, dpr) {
        if (this.painter.pathToImage) return this.painter.pathToImage(e, dpr);
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $4KVOr.default)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        $741e2e865750343c$var$delInstance(this.id);
    };
    return ZRender;
}();
function $741e2e865750343c$export$2cd8252107eb640b(dom, opts) {
    var zr = new $741e2e865750343c$var$ZRender($bahqM.guid(), dom, opts);
    $741e2e865750343c$var$instances[zr.id] = zr;
    return zr;
}
function $741e2e865750343c$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $741e2e865750343c$export$825f692fb04800ef() {
    for(var key in $741e2e865750343c$var$instances)if ($741e2e865750343c$var$instances.hasOwnProperty(key)) $741e2e865750343c$var$instances[key].dispose();
    $741e2e865750343c$var$instances = {};
}
function $741e2e865750343c$export$8bedcca5bbd73999(id) {
    return $741e2e865750343c$var$instances[id];
}
function $741e2e865750343c$export$a3e793ccb11823a5(name, Ctor) {
    $741e2e865750343c$var$painterCtors[name] = Ctor;
}
var $741e2e865750343c$export$83d89fbfd8236492 = '5.2.1';

});
parcelRegister("jaJTK", function(module, exports) {

$parcel$export(module.exports, "default", () => $df528de50090e0a1$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $eLEew = parcelRequire("eLEew");

var $8qDpt = parcelRequire("8qDpt");

var $bRKv5 = parcelRequire("bRKv5");

var $65X4x = parcelRequire("65X4x");

var $jYjcX = parcelRequire("jYjcX");
var $df528de50090e0a1$var$SILENT = 'silent';
function $df528de50090e0a1$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $df528de50090e0a1$var$stopEvent
    };
}
function $df528de50090e0a1$var$stopEvent() {
    $65X4x.stop(this.event);
}
var $df528de50090e0a1$var$EmptyProxy = function(_super) {
    (0, $3VFsf.__extends)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $bRKv5.default));
var $df528de50090e0a1$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $df528de50090e0a1$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $df528de50090e0a1$var$Handler = function(_super) {
    (0, $3VFsf.__extends)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot) {
        var _this = _super.call(this) || this;
        _this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        proxy = proxy || new $df528de50090e0a1$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $8qDpt.default)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $bahqM.each($df528de50090e0a1$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $df528de50090e0a1$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $df528de50090e0a1$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $df528de50090e0a1$var$HoveredResult(x, y);
        for(var i = list.length - 1; i >= 0; i--){
            var hoverCheckResult = void 0;
            if (list[i] !== exclude && !list[i].ignore && (hoverCheckResult = $df528de50090e0a1$var$isHover(list[i], x, y))) {
                !out.topTarget && (out.topTarget = list[i]);
                if (hoverCheckResult !== $df528de50090e0a1$var$SILENT) {
                    out.target = list[i];
                    break;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $jYjcX.GestureMgr)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $df528de50090e0a1$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $bRKv5.default));
$bahqM.each([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $df528de50090e0a1$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $eLEew.dist(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $df528de50090e0a1$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
                if (el.silent) isSilent = true;
            }
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? $df528de50090e0a1$var$SILENT : true;
    }
    return false;
}
function $df528de50090e0a1$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $df528de50090e0a1$export$2e2bcd8739ae039 = $df528de50090e0a1$var$Handler;

});
parcelRegister("8qDpt", function(module, exports) {

$parcel$export(module.exports, "default", () => $622f526eb8ccffa3$export$2e2bcd8739ae039);
var $622f526eb8ccffa3$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $622f526eb8ccffa3$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $622f526eb8ccffa3$export$2e2bcd8739ae039 = $622f526eb8ccffa3$var$Draggable;

});

parcelRegister("jYjcX", function(module, exports) {

$parcel$export(module.exports, "GestureMgr", () => $e8a28537c27906ba$export$f7557d6f27e9503);

var $65X4x = parcelRequire("65X4x");
var $e8a28537c27906ba$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $65X4x.clientToLocal(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $e8a28537c27906ba$var$recognizers)if ($e8a28537c27906ba$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $e8a28537c27906ba$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $e8a28537c27906ba$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $e8a28537c27906ba$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $e8a28537c27906ba$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $e8a28537c27906ba$var$dist(pinchEnd) / $e8a28537c27906ba$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $e8a28537c27906ba$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};

});


parcelRegister("66sfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4719378990e09024$export$2e2bcd8739ae039);

var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $aVBu2 = parcelRequire("aVBu2");

var $aVawM = parcelRequire("aVawM");
var $4719378990e09024$var$invalidZErrorLogged = false;
function $4719378990e09024$var$logInvalidZError() {
    if ($4719378990e09024$var$invalidZErrorLogged) return;
    $4719378990e09024$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $4719378990e09024$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $4719378990e09024$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $4719378990e09024$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $hZfwb.default).canvasSupported && (0, $aVBu2.default)(displayList, $4719378990e09024$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) clipPaths = null;
        else if (userSetClipPath) {
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $aVawM.REDRAW_BIT);
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
            if (isNaN(disp.z)) {
                $4719378990e09024$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $4719378990e09024$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $4719378990e09024$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $bahqM.indexOf(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $4719378990e09024$export$2e2bcd8739ae039 = $4719378990e09024$var$Storage;

});
parcelRegister("aVBu2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f4c4daf73fbe3de$export$2e2bcd8739ae039);
var $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE = 32;
var $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING = 7;
var $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH = 256;
function $7f4c4daf73fbe3de$var$minRunLength(n) {
    var r = 0;
    while(n >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $7f4c4daf73fbe3de$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $7f4c4daf73fbe3de$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $7f4c4daf73fbe3de$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $7f4c4daf73fbe3de$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $7f4c4daf73fbe3de$var$TimSort(array, compare) {
    var minGallop = $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING;
    var length = 0;
    var tmpStorageLength = $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH;
    var stackLength = 0;
    var runStart;
    var runLength;
    var stackSize = 0;
    length = array.length;
    if (length < 2 * $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH) tmpStorageLength = length >>> 1;
    var tmp = [];
    stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $7f4c4daf73fbe3de$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $7f4c4daf73fbe3de$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $7f4c4daf73fbe3de$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $7f4c4daf73fbe3de$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $7f4c4daf73fbe3de$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $7f4c4daf73fbe3de$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $7f4c4daf73fbe3de$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE) {
        runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
        $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $7f4c4daf73fbe3de$var$TimSort(array, compare);
    var minRun = $7f4c4daf73fbe3de$var$minRunLength(remaining);
    do {
        runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}

});


parcelRegister("F44Dl", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b6fd689a4caf84$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $bRKv5 = parcelRequire("bRKv5");

var $04xko = parcelRequire("04xko");

var $hb2y5 = parcelRequire("hb2y5");
var $07b6fd689a4caf84$var$Animation = function(_super) {
    (0, $3VFsf.__extends)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        _this.onframe = opts.onframe || function() {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._clipsHead) this._clipsHead = this._clipsTail = clip;
        else {
            this._clipsTail.next = clip;
            clip.prev = this._clipsTail;
            clip.next = null;
            this._clipsTail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._clipsHead = next;
        if (next) next.prev = prev;
        else this._clipsTail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = new Date().getTime() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._clipsHead;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy && clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.onframe(delta);
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $04xko.default)(step);
                !self._paused && self.update();
            }
        }
        (0, $04xko.default)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = new Date().getTime();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = new Date().getTime();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += new Date().getTime() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._clipsHead;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._clipsHead = this._clipsTail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._clipsHead == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $hb2y5.default)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $bRKv5.default));
var $07b6fd689a4caf84$export$2e2bcd8739ae039 = $07b6fd689a4caf84$var$Animation;

});
parcelRegister("04xko", function(module, exports) {

$parcel$export(module.exports, "default", () => $00da3a149d316342$export$2e2bcd8739ae039);
var $00da3a149d316342$var$requestAnimationFrame;
$00da3a149d316342$var$requestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $00da3a149d316342$export$2e2bcd8739ae039 = $00da3a149d316342$var$requestAnimationFrame;

});


parcelRegister("bHSYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $885e5bfc09439923$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $65X4x = parcelRequire("65X4x");

var $bahqM = parcelRequire("bahqM");

var $bRKv5 = parcelRequire("bRKv5");

var $hZfwb = parcelRequire("hZfwb");
var $885e5bfc09439923$var$TOUCH_CLICK_DELAY = 300;
var $885e5bfc09439923$var$globalEventSupported = (0, $hZfwb.default).domSupported;
var $885e5bfc09439923$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $bahqM.map(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $885e5bfc09439923$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $885e5bfc09439923$var$wheelEventSupported = false;
function $885e5bfc09439923$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $885e5bfc09439923$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $885e5bfc09439923$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $885e5bfc09439923$var$normalizeGlobalEvent(instance, event) {
    return (0, $65X4x.normalizeEvent)(instance.dom, new $885e5bfc09439923$var$FakeGlobalEvent(instance, event), true);
}
function $885e5bfc09439923$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $885e5bfc09439923$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $bahqM.noop;
        this.stopImmediatePropagation = $bahqM.noop;
        this.preventDefault = $bahqM.noop;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $885e5bfc09439923$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$885e5bfc09439923$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function(event) {
        $885e5bfc09439923$var$wheelEventSupported = true;
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function(event) {
        if ($885e5bfc09439923$var$wheelEventSupported) return;
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        $885e5bfc09439923$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
        $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        $885e5bfc09439923$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        $885e5bfc09439923$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $885e5bfc09439923$var$TOUCH_CLICK_DELAY) $885e5bfc09439923$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$bahqM.each([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $885e5bfc09439923$var$localDOMHandlers[name] = function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.trigger(name, event);
    };
});
var $885e5bfc09439923$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $885e5bfc09439923$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $885e5bfc09439923$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $hZfwb.default).pointerEventsSupported) $bahqM.each($885e5bfc09439923$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $hZfwb.default).touchEventsSupported) $bahqM.each($885e5bfc09439923$var$localNativeListenerNames.touch, function(nativeEventName) {
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $885e5bfc09439923$var$setTouchTimer(scope);
            });
        });
        $bahqM.each($885e5bfc09439923$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $65X4x.getNativeEvent)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $885e5bfc09439923$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $hZfwb.default).pointerEventsSupported) $bahqM.each($885e5bfc09439923$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $hZfwb.default).touchEventsSupported) $bahqM.each($885e5bfc09439923$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $65X4x.getNativeEvent)(event);
            if (!$885e5bfc09439923$var$isLocalEl(instance, event.target)) {
                event = $885e5bfc09439923$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $65X4x.addEventListener)(scope.domTarget, nativeEventName, listener, opt);
}
function $885e5bfc09439923$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $65X4x.removeEventListener)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $885e5bfc09439923$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $885e5bfc09439923$var$HandlerDomProxy = function(_super) {
    (0, $3VFsf.__extends)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(dom, $885e5bfc09439923$var$localDOMHandlers);
        if ($885e5bfc09439923$var$globalEventSupported) _this._globalHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(document, $885e5bfc09439923$var$globalDOMHandlers);
        $885e5bfc09439923$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $885e5bfc09439923$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($885e5bfc09439923$var$globalEventSupported) $885e5bfc09439923$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($885e5bfc09439923$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $885e5bfc09439923$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $885e5bfc09439923$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $bRKv5.default));
var $885e5bfc09439923$export$2e2bcd8739ae039 = $885e5bfc09439923$var$HandlerDomProxy;

});


parcelRegister("74g78", function(module, exports) {

$parcel$export(module.exports, "default", () => $525568051e570380$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $gaMkj = parcelRequire("gaMkj");

var $h4UlH = parcelRequire("h4UlH");

var $34Vzq = parcelRequire("34Vzq");

var $cNGs8 = parcelRequire("cNGs8");

var $iSVvO = parcelRequire("iSVvO");

var $aCu4v = parcelRequire("aCu4v");

var $2cFRc = parcelRequire("2cFRc");
// Internal method names:
// -----------------------
var $525568051e570380$var$reCreateSeriesIndices;
var $525568051e570380$var$assertSeriesInitialized;
var $525568051e570380$var$initBase;
var $525568051e570380$var$OPTION_INNER_KEY = '\0_ec_inner';
var $525568051e570380$var$OPTION_INNER_VALUE = 1;
var $525568051e570380$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $525568051e570380$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $525568051e570380$var$componetsMissingLogPrinted = {};
function $525568051e570380$var$checkMissingComponents(option) {
    (0, $bahqM.each)(option, function(componentOption, mainType) {
        if (!(0, $h4UlH.default).hasClass(mainType)) {
            var componentImportName = $525568051e570380$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$525568051e570380$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $2cFRc.error)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $525568051e570380$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $525568051e570380$var$GlobalModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $gaMkj.default)(theme);
        this._locale = new (0, $gaMkj.default)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $525568051e570380$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $525568051e570380$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $525568051e570380$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
         // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Becuase either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $bahqM.each)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $bahqM.createHashMap)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $cNGs8.resetSourceDefaulter)(this); // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $bahqM.each)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $h4UlH.default).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $bahqM.clone)(componentOption) : (0, $bahqM.merge)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $h4UlH.default).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $h4UlH.default).topologicalTravel(newCmptTypes, (0, $h4UlH.default).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $iSVvO.concatInternalOptions)(this, mainType, $eaKsF.normalizeToArray(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $eaKsF.mappingToExists(oldCmptList, newCmptOptionList, mergeMode); // Set mainType and complete subType.
            $eaKsF.setComponentTypeToKeyInfo(mappingResult, mainType, (0, $h4UlH.default)); // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            (0, $bahqM.each)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    } // If no both `resultItem.exist` and `resultItem.option`,
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $h4UlH.default).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $bahqM.extend)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt); // Assign `keyInfo`
                        (0, $bahqM.extend)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this); // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType); // Backup series for filtering.
            if (mainType === 'series') $525568051e570380$var$reCreateSeriesIndices(this);
        } // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $525568051e570380$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $bahqM.clone)(this.option);
        (0, $bahqM.each)(option, function(optInMainType, mainType) {
            if ((0, $h4UlH.default).hasClass(mainType)) {
                var opts = $eaKsF.normalizeToArray(optInMainType); // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$eaKsF.isComponentIdInternal(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$525568051e570380$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $bahqM.each)($eaKsF.normalizeToArray(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $525568051e570380$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $525568051e570380$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $bahqM.filter)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $525568051e570380$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) // Retrieve all non-empty components.
         : (0, $bahqM.filter)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($525568051e570380$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $bahqM.filter)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $bahqM.isFunction)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $bahqM.isString)(mainType) ? componentsMap.get(mainType) : (0, $bahqM.isObject)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $eaKsF.convertOptionIdName(name, null);
        return (0, $bahqM.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $bahqM.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $bahqM.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * frome raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $525568051e570380$var$assertSeriesInitialized(this);
        (0, $bahqM.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $bahqM.each)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * frome raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $525568051e570380$var$assertSeriesInitialized(this);
        (0, $bahqM.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $bahqM.each)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $525568051e570380$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $525568051e570380$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $bahqM.each)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $bahqM.createHashMap)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $525568051e570380$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $h4UlH.default).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $h4UlH.default).topologicalTravel(componentTypes, (0, $h4UlH.default).getAllClassMainTypes(), function(componentType) {
            (0, $bahqM.each)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$525568051e570380$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $525568051e570380$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $bahqM.each)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $bahqM.createHashMap)(seriesIndices);
        };
        $525568051e570380$var$assertSeriesInitialized = function(ecModel) {};
        $525568051e570380$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option can not be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
            ecModel.option = {};
            ecModel.option[$525568051e570380$var$OPTION_INNER_KEY] = $525568051e570380$var$OPTION_INNER_VALUE; // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $bahqM.createHashMap)({
                series: []
            });
            ecModel._componentsCount = (0, $bahqM.createHashMap)(); // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $bahqM.isObject)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $525568051e570380$var$mergeTheme(baseOption, ecModel._theme.option); // TODO Needs clone when merging to the unexisted property
            (0, $bahqM.merge)(baseOption, (0, $34Vzq.default), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $gaMkj.default));
function $525568051e570380$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $525568051e570380$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $bahqM.each)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer) return;
         // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $h4UlH.default).hasClass(name)) {
            if (typeof themeItem === 'object') option[name] = !option[name] ? (0, $bahqM.clone)(themeItem) : (0, $bahqM.merge)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $525568051e570380$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $bahqM.isArray)(idOrName)) {
        var keyMap_1 = (0, $bahqM.createHashMap)();
        (0, $bahqM.each)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $eaKsF.convertOptionIdName(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $bahqM.filter)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $eaKsF.convertOptionIdName(idOrName, null);
        return (0, $bahqM.filter)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $525568051e570380$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $bahqM.filter)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $525568051e570380$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $bahqM.createHashMap)();
    opts && (0, $bahqM.each)($eaKsF.normalizeToArray(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $bahqM.mixin)($525568051e570380$var$GlobalModel, (0, $aCu4v.PaletteMixin));
var $525568051e570380$export$2e2bcd8739ae039 = $525568051e570380$var$GlobalModel;

});
parcelRegister("34Vzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $23de6718d94f8f53$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $23de6718d94f8f53$var$platform = ''; // Navigator not exists in node
if (typeof navigator !== 'undefined') /* global navigator */ $23de6718d94f8f53$var$platform = navigator.platform || '';
var $23de6718d94f8f53$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $23de6718d94f8f53$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: [
        '#5470c6',
        '#91cc75',
        '#fac858',
        '#ee6666',
        '#73c0de',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
    ],
    gradientColor: [
        '#f6efa6',
        '#d88273',
        '#bf444c'
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $23de6718d94f8f53$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};

});

parcelRegister("iSVvO", function(module, exports) {

$parcel$export(module.exports, "registerInternalOptionCreator", () => $dbf9e1d336044ced$export$5a90be4668898d38);
$parcel$export(module.exports, "concatInternalOptions", () => $dbf9e1d336044ced$export$c713a6a3b43f401d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $dbf9e1d336044ced$var$internalOptionCreatorMap = (0, $bahqM.createHashMap)();
function $dbf9e1d336044ced$export$5a90be4668898d38(mainType, creator) {
    (0, $bahqM.assert)($dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $dbf9e1d336044ced$var$internalOptionCreatorMap.set(mainType, creator);
}
function $dbf9e1d336044ced$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}

});


parcelRegister("iEvqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9445617d131115d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $d9445617d131115d$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    'getOption',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $d9445617d131115d$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $bahqM.each($d9445617d131115d$var$availableMethods, function(methodName) {
            this[methodName] = $bahqM.bind(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $d9445617d131115d$export$2e2bcd8739ae039 = $d9445617d131115d$var$ExtensionAPI;

});

parcelRegister("6LzFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed2ccc95e9b6d0d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");

var $bahqM = parcelRequire("bahqM");

var $4ed2ccc95e9b6d0d$var$QUERY_REG = /^(min|max)?(.+)$/; // Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $4ed2ccc95e9b6d0d$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $bahqM.each)((0, $eaKsF.normalizeToArray)(rawOption.series), function(series) {
                series && series.data && (0, $bahqM.isTypedArray)(series.data) && (0, $bahqM.setAsPrimitive)(series.data);
            });
            (0, $bahqM.each)((0, $eaKsF.normalizeToArray)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $bahqM.isTypedArray)(dataset.source) && (0, $bahqM.setAsPrimitive)(dataset.source);
            });
        } // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $bahqM.clone)(rawOption); // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, becuase in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline opitons will not be merged to the formers, but just substitude them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $bahqM.clone)(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
         ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $bahqM.clone)(timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = []; // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
         // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($4ed2ccc95e9b6d0d$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
         // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$4ed2ccc95e9b6d0d$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $bahqM.map)(indices, function(index) {
            return (0, $bahqM.clone)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
         // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption; // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption; // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $bahqM.isArray)(mediaOnRoot)) (0, $bahqM.each)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $bahqM.each)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $bahqM.each)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $bahqM.each)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $4ed2ccc95e9b6d0d$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lowser case for convenientce.
    };
    var applicatable = true;
    (0, $bahqM.each)(query, function(value, attr) {
        var matched = attr.match($4ed2ccc95e9b6d0d$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$4ed2ccc95e9b6d0d$var$compare(realMap[realAttr], value, operator)) applicatable = false;
    });
    return applicatable;
}
function $4ed2ccc95e9b6d0d$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $4ed2ccc95e9b6d0d$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$4ed2ccc95e9b6d0d$export$2e2bcd8739ae039 = $4ed2ccc95e9b6d0d$var$OptionManager;

});

parcelRegister("driCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8c3e9bb43407b9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $9rY8k = parcelRequire("9rY8k");

var $eaKsF = parcelRequire("eaKsF");

function $9c8c3e9bb43407b9$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $9c8c3e9bb43407b9$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $9c8c3e9bb43407b9$var$compatLayoutProperties(option) {
    option && (0, $bahqM.each)($9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $9c8c3e9bb43407b9$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $9c8c3e9bb43407b9$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $9c8c3e9bb43407b9$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $9c8c3e9bb43407b9$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $9c8c3e9bb43407b9$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $9c8c3e9bb43407b9$var$traverseTree(data[i].children, cb);
    }
}
function $9c8c3e9bb43407b9$export$2e2bcd8739ae039(option, isTheme) {
    (0, $9rY8k.default)(option, isTheme); // Make sure series array for model initialization.
    option.series = (0, $eaKsF.normalizeToArray)(option.series);
    (0, $bahqM.each)(option.series, function(seriesOpt) {
        if (!(0, $bahqM.isObject)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $9c8c3e9bb43407b9$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $bahqM.isTypedArray)(data)) for(var i = 0; i < data.length; i++)$9c8c3e9bb43407b9$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $9c8c3e9bb43407b9$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $9c8c3e9bb43407b9$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt);
            $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $bahqM.isTypedArray)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                    $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i]);
                    $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $9c8c3e9bb43407b9$var$compatSunburstState(seriesOpt);
            $9c8c3e9bb43407b9$var$traverseTree(seriesOpt.data, $9c8c3e9bb43407b9$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $9c8c3e9bb43407b9$var$compatGraphFocus(seriesOpt); // TODO nodes, edges?
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $bahqM.defaults)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $9c8c3e9bb43407b9$var$compatLayoutProperties(seriesOpt);
    }); // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $bahqM.each)($9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $bahqM.isArray)(options)) options = [
                options
            ];
            (0, $bahqM.each)(options, function(option) {
                $9c8c3e9bb43407b9$var$compatLayoutProperties(option);
            });
        }
    });
}

});
parcelRegister("9rY8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e1547e334933782$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $6e1547e334933782$var$each = $bahqM.each;
var $6e1547e334933782$var$isObject = $bahqM.isObject;
var $6e1547e334933782$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $6e1547e334933782$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $6e1547e334933782$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $6e1547e334933782$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $bahqM.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $bahqM.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $6e1547e334933782$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $bahqM.defaults(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt; // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $6e1547e334933782$var$removeEC3NormalStatus(opt) {
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'itemStyle');
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'lineStyle');
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'areaStyle');
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'label');
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'labelLine'); // treemap
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'upperLabel'); // graph
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $6e1547e334933782$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $6e1547e334933782$var$isObject(opt) && opt[propName];
    var textStyle = $6e1547e334933782$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $eaKsF.TEXT_STYLE_OPTIONS.length; i < len; i++){
        var textPropName = $eaKsF.TEXT_STYLE_OPTIONS[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $6e1547e334933782$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $6e1547e334933782$var$removeEC3NormalStatus(opt);
        $6e1547e334933782$var$compatTextStyle(opt, 'label');
        opt.emphasis && $6e1547e334933782$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $6e1547e334933782$var$processSeries(seriesOpt) {
    if (!$6e1547e334933782$var$isObject(seriesOpt)) return;
    $6e1547e334933782$var$compatEC2ItemStyle(seriesOpt);
    $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt);
    $6e1547e334933782$var$compatTextStyle(seriesOpt, 'label'); // treemap
    $6e1547e334933782$var$compatTextStyle(seriesOpt, 'upperLabel'); // graph
    $6e1547e334933782$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
        $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
        $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $6e1547e334933782$var$compatEC2ItemStyle(markPoint);
        $6e1547e334933782$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $6e1547e334933782$var$compatEC2ItemStyle(markLine);
        $6e1547e334933782$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $6e1547e334933782$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$bahqM.isTypedArray(edgeData)) for(var i = 0; i < edgeData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(edgeData[i]);
        $bahqM.each(seriesOpt.categories, function(opt) {
            $6e1547e334933782$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$bahqM.isTypedArray(data)) for(var i = 0; i < data.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(data[i]);
     // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(mpData[i]);
    } // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($bahqM.isArray(mlData[i])) {
            $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][0]);
            $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][1]);
        } else $6e1547e334933782$var$compatEC3CommonStyles(mlData[i]);
    } // Series
    if (seriesOpt.type === 'gauge') {
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'axisLabel');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'title');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $6e1547e334933782$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $bahqM.each(seriesOpt.levels, function(opt) {
            $6e1547e334933782$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt.leaves);
     // sunburst starts from ec4, so it does not need to compat levels.
}
function $6e1547e334933782$var$toArr(o) {
    return $bahqM.isArray(o) ? o : o ? [
        o
    ] : [];
}
function $6e1547e334933782$var$toObj(o) {
    return ($bahqM.isArray(o) ? o[0] : o) || {};
}
function $6e1547e334933782$export$2e2bcd8739ae039(option, isTheme) {
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.series), function(seriesOpt) {
        $6e1547e334933782$var$isObject(seriesOpt) && $6e1547e334933782$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $6e1547e334933782$var$each(axes, function(axisName) {
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $6e1547e334933782$var$compatTextStyle(axisOpt, 'axisLabel');
                $6e1547e334933782$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $6e1547e334933782$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $6e1547e334933782$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.calendar), function(calendarOpt) {
        $6e1547e334933782$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $6e1547e334933782$var$compatTextStyle(calendarOpt, 'dayLabel');
        $6e1547e334933782$var$compatTextStyle(calendarOpt, 'monthLabel');
        $6e1547e334933782$var$compatTextStyle(calendarOpt, 'yearLabel');
    }); // radar.name.textStyle
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.radar), function(radarOpt) {
        $6e1547e334933782$var$compatTextStyle(radarOpt, 'name'); // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.geo), function(geoOpt) {
        if ($6e1547e334933782$var$isObject(geoOpt)) {
            $6e1547e334933782$var$compatEC3CommonStyles(geoOpt);
            $6e1547e334933782$var$each($6e1547e334933782$var$toArr(geoOpt.regions), function(regionObj) {
                $6e1547e334933782$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.timeline), function(timelineOpt) {
        $6e1547e334933782$var$compatEC3CommonStyles(timelineOpt);
        $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'label');
        $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $bahqM.isArray(data) && $bahqM.each(data, function(item) {
            if ($bahqM.isObject(item)) {
                $6e1547e334933782$var$convertNormalEmphasis(item, 'label');
                $6e1547e334933782$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.toolbox), function(toolboxOpt) {
        $6e1547e334933782$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $6e1547e334933782$var$each(toolboxOpt.feature, function(featureOpt) {
            $6e1547e334933782$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.axisPointer), 'label');
    $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.tooltip).axisPointer, 'label'); // Clean logs
// storedLogs = {};
}

});


parcelRegister("iMppY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dac06d23d0856818$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");
function $dac06d23d0856818$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $bahqM.createHashMap)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            }; // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($dac06d23d0856818$var$calculateStack);
}
function $dac06d23d0856818$var$calculateStack(stackInfoList) {
    (0, $bahqM.each)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
             // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
                    if (sum >= 0 && val > 0 || // Positive stack
                    sum <= 0 && val < 0 // Negative stack
                    ) {
                        // The sum should be as less as possible to be effected
                        // by floating arithmetic problem. A wrong result probably
                        // filtered incorrectly by axis min/max.
                        sum = (0, $jmSNG.addSafe)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}

});

parcelRegister("cvEVp", function(module, exports) {

$parcel$export(module.exports, "seriesStyleTask", () => $91b820231b41a759$export$7ce4d65f9b69240);
$parcel$export(module.exports, "dataStyleTask", () => $91b820231b41a759$export$f7dcb66a065003d1);
$parcel$export(module.exports, "dataColorPaletteTask", () => $91b820231b41a759$export$cf9758b0d6dc0aa9);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $1BJbl = parcelRequire("1BJbl");

var $4rldO = parcelRequire("4rldO");

var $46U6E = parcelRequire("46U6E");

var $gaMkj = parcelRequire("gaMkj");

var $eaKsF = parcelRequire("eaKsF");
var $91b820231b41a759$var$inner = (0, $eaKsF.makeInner)();
var $91b820231b41a759$var$defaultStyleMappers = {
    itemStyle: (0, $1BJbl.default)((0, $4rldO.ITEM_STYLE_KEY_MAP), true),
    lineStyle: (0, $1BJbl.default)((0, $46U6E.LINE_STYLE_KEY_MAP), true)
};
var $91b820231b41a759$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $91b820231b41a759$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unkown style type '" + stylePath + "'.");
        return $91b820231b41a759$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $91b820231b41a759$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unkown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $91b820231b41a759$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        } // TODO
        var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey]; // TODO style callback
        var colorCallback = (0, $bahqM.isFunction)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto'; // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: if some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Bacause some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || typeof globalStyle.fill === 'function' ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || typeof globalStyle.stroke === 'function' ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey); // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $bahqM.extend)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $91b820231b41a759$var$sharedModel = new (0, $gaMkj.default)();
var $91b820231b41a759$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
        var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $91b820231b41a759$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($91b820231b41a759$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $bahqM.extend)(existsStyle, style);
                    if ($91b820231b41a759$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $91b820231b41a759$var$sharedModel.option.decal);
                        $91b820231b41a759$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
}; // Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $91b820231b41a759$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series use one scope.
        // Pie and funnel are using diferrent scopes
        var paletteScopeGroupByType = (0, $bahqM.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + '-' + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $91b820231b41a759$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $91b820231b41a759$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            }); // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette'); // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};

});

parcelRegister("4G956", function(module, exports) {

$parcel$export(module.exports, "default", () => $3682210406d5dc21$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
parcelRequire("fHITF");
var $ixXaU = parcelRequire("ixXaU");
var $7Tw7u = parcelRequire("7Tw7u");
var $4KVOr = parcelRequire("4KVOr");
var $4gEFv = parcelRequire("4gEFv");
var $3682210406d5dc21$var$PI = Math.PI;
function $3682210406d5dc21$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $bahqM.defaults(opts, {
        text: 'loading',
        textColor: '#000',
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        showSpinner: true,
        color: '#5470c6',
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $4KVOr.default();
    var mask = new $7Tw7u.default({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $4gEFv.default({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $7Tw7u.default({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $ixXaU.default({
            shape: {
                startAngle: -$3682210406d5dc21$var$PI / 2,
                endAngle: -$3682210406d5dc21$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $3682210406d5dc21$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $3682210406d5dc21$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    } // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2 // only show the text
        ) + (opts.showSpinner ? 0 : textWidth / 2 // only show the spinner
        ) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}

});

parcelRegister("14WFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c93ab8c51628eb2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $92IK1 = parcelRequire("92IK1");

var $jvo6O = parcelRequire("jvo6O");

var $74g78 = parcelRequire("74g78");

var $iEvqc = parcelRequire("iEvqc");

var $eaKsF = parcelRequire("eaKsF");
var $0c93ab8c51628eb2$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $bahqM.createHashMap)();
        this.ecInstance = ecInstance;
        this.api = api; // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    }; // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $bahqM.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $bahqM.each)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $bahqM.assert)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $bahqM.each)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
                // if intending to decalare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because is a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operaions
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap; // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $bahqM.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $92IK1.createTask)({
                plan: $0c93ab8c51628eb2$var$seriesTaskPlan,
                reset: $0c93ab8c51628eb2$var$seriesTaskReset,
                count: $0c93ab8c51628eb2$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
         || (0, $92IK1.createTask)({
            reset: $0c93ab8c51628eb2$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap; // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $bahqM.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false; // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = '';
        (0, $bahqM.assert)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $bahqM.each)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $92IK1.createTask)({
                reset: $0c93ab8c51628eb2$var$stubReset,
                onDirty: $0c93ab8c51628eb2$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress // FIXME:TS never used, so comment it
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $bahqM.isFunction)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $0c93ab8c51628eb2$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $jvo6O.getUID)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $0c93ab8c51628eb2$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $0c93ab8c51628eb2$var$stubReset(context) {
    return context.overallProgress && $0c93ab8c51628eb2$var$stubProgress;
}
function $0c93ab8c51628eb2$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $0c93ab8c51628eb2$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $0c93ab8c51628eb2$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $0c93ab8c51628eb2$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $eaKsF.normalizeToArray)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $bahqM.map)(resetDefines, function(v, idx) {
        return $0c93ab8c51628eb2$var$makeSeriesTaskProgress(idx);
    }) : $0c93ab8c51628eb2$var$singleSeriesTaskProgress;
}
var $0c93ab8c51628eb2$var$singleSeriesTaskProgress = $0c93ab8c51628eb2$var$makeSeriesTaskProgress(0);
function $0c93ab8c51628eb2$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $0c93ab8c51628eb2$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $0c93ab8c51628eb2$var$detectSeriseType(legacyFunc) {
    $0c93ab8c51628eb2$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($0c93ab8c51628eb2$var$ecModelMock, $0c93ab8c51628eb2$var$apiMock);
    } catch (e) {}
    return $0c93ab8c51628eb2$var$seriesType;
}
var $0c93ab8c51628eb2$var$ecModelMock = {};
var $0c93ab8c51628eb2$var$apiMock = {};
var $0c93ab8c51628eb2$var$seriesType;
$0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$ecModelMock, (0, $74g78.default));
$0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$apiMock, (0, $iEvqc.default));
$0c93ab8c51628eb2$var$ecModelMock.eachSeriesByType = $0c93ab8c51628eb2$var$ecModelMock.eachRawSeriesByType = function(type) {
    $0c93ab8c51628eb2$var$seriesType = type;
};
$0c93ab8c51628eb2$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $0c93ab8c51628eb2$var$seriesType = cond.subType;
};
function $0c93ab8c51628eb2$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $bahqM.noop);
/* eslint-enable */ }
var $0c93ab8c51628eb2$export$2e2bcd8739ae039 = $0c93ab8c51628eb2$var$Scheduler;

});

parcelRegister("31FQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2341ebce6d7d92ac$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2341ebce6d7d92ac$var$colorAll = [
    '#37A2DA',
    '#32C5E9',
    '#67E0E3',
    '#9FE6B8',
    '#FFDB5C',
    '#ff9f7f',
    '#fb7293',
    '#E062AE',
    '#E690D1',
    '#e7bcf3',
    '#9d96f5',
    '#8378EA',
    '#96BFFF'
];
var $2341ebce6d7d92ac$export$2e2bcd8739ae039 = {
    color: $2341ebce6d7d92ac$var$colorAll,
    colorLayer: [
        [
            '#37A2DA',
            '#ffd85c',
            '#fd7b5f'
        ],
        [
            '#37A2DA',
            '#67E0E3',
            '#FFDB5C',
            '#ff9f7f',
            '#E062AE',
            '#9d96f5'
        ],
        [
            '#37A2DA',
            '#32C5E9',
            '#9FE6B8',
            '#FFDB5C',
            '#ff9f7f',
            '#fb7293',
            '#e7bcf3',
            '#8378EA',
            '#96BFFF'
        ],
        $2341ebce6d7d92ac$var$colorAll
    ]
};

});

parcelRegister("dMJCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a093251ea09c66fc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a093251ea09c66fc$var$contrastColor = '#B9B8CE';
var $a093251ea09c66fc$var$backgroundColor = '#100C2A';
var $a093251ea09c66fc$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                color: '#484753'
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    'rgba(255,255,255,0.02)',
                    'rgba(255,255,255,0.05)'
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: '#20203B'
            }
        }
    };
};
var $a093251ea09c66fc$var$colorPalette = [
    '#4992ff',
    '#7cffb2',
    '#fddd60',
    '#ff6e76',
    '#58d9f9',
    '#05c091',
    '#ff8a45',
    '#8d48e3',
    '#dd79ff'
];
var $a093251ea09c66fc$var$theme = {
    darkMode: true,
    color: $a093251ea09c66fc$var$colorPalette,
    backgroundColor: $a093251ea09c66fc$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: '#817f91'
        },
        crossStyle: {
            color: '#817f91'
        },
        label: {
            // TODO Contrast of label backgorundColor
            color: '#fff'
        }
    },
    legend: {
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        }
    },
    textStyle: {
        color: $a093251ea09c66fc$var$contrastColor
    },
    title: {
        textStyle: {
            color: '#EEF1FA'
        },
        subtextStyle: {
            color: '#B9B8CE'
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $a093251ea09c66fc$var$contrastColor
        }
    },
    dataZoom: {
        borderColor: '#71708A',
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        brushStyle: {
            color: 'rgba(135,163,206,0.3)'
        },
        handleStyle: {
            color: '#353450',
            borderColor: '#C5CBE3'
        },
        moveHandleStyle: {
            color: '#B0B6C3',
            opacity: 0.3
        },
        fillerColor: 'rgba(135,163,206,0.2)',
        emphasis: {
            handleStyle: {
                borderColor: '#91B7F2',
                color: '#4D587D'
            },
            moveHandleStyle: {
                color: '#636D9A',
                opacity: 0.7
            }
        },
        dataBackground: {
            lineStyle: {
                color: '#71708A',
                width: 1
            },
            areaStyle: {
                color: '#71708A'
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: '#87A3CE'
            },
            areaStyle: {
                color: '#87A3CE'
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        label: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        controlStyle: {
            color: $a093251ea09c66fc$var$contrastColor,
            borderColor: $a093251ea09c66fc$var$contrastColor
        }
    },
    calendar: {
        itemStyle: {
            color: $a093251ea09c66fc$var$backgroundColor
        },
        dayLabel: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        monthLabel: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        yearLabel: {
            color: $a093251ea09c66fc$var$contrastColor
        }
    },
    timeAxis: $a093251ea09c66fc$var$axisCommon(),
    logAxis: $a093251ea09c66fc$var$axisCommon(),
    valueAxis: $a093251ea09c66fc$var$axisCommon(),
    categoryAxis: $a093251ea09c66fc$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $a093251ea09c66fc$var$colorPalette
    },
    gauge: {
        title: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        'rgba(207,212,219,0.2)'
                    ]
                ]
            }
        },
        axisLabel: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        detail: {
            color: '#EEF1FA'
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92' // borderColor: '#ca2824',
        }
    }
};
$a093251ea09c66fc$var$theme.categoryAxis.splitLine.show = false;
var $a093251ea09c66fc$export$2e2bcd8739ae039 = $a093251ea09c66fc$var$theme;

});

parcelRegister("cbv5T", function(module, exports) {

$parcel$export(module.exports, "ECEventProcessor", () => $8deea1bcfc845e61$export$d0fd09f950257b52);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $aLwh0 = parcelRequire("aLwh0");
/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $8deea1bcfc845e61$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
        if ($bahqM.isString(query)) {
            var condCptType = (0, $aLwh0.parseClassType)(query); // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $bahqM.each(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view; // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo wont be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();

});

parcelRegister("7wiHx", function(module, exports) {

$parcel$export(module.exports, "seriesSymbolTask", () => $579a0738784e30ca$export$144ac3beded415d9);
$parcel$export(module.exports, "dataSymbolTask", () => $579a0738784e30ca$export$435b956f7f1071fb);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $579a0738784e30ca$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolType = seriesModel.get('symbol');
        var symbolSize = seriesModel.get('symbolSize');
        var keepAspect = seriesModel.get('symbolKeepAspect');
        var symbolRotate = seriesModel.get('symbolRotate');
        var symbolOffset = seriesModel.get('symbolOffset');
        var hasSymbolTypeCallback = (0, $bahqM.isFunction)(symbolType);
        var hasSymbolSizeCallback = (0, $bahqM.isFunction)(symbolSize);
        var hasSymbolRotateCallback = (0, $bahqM.isFunction)(symbolRotate);
        var hasSymbolOffsetCallback = (0, $bahqM.isFunction)(symbolOffset);
        var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback || hasSymbolOffsetCallback;
        var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : seriesModel.defaultSymbol;
        var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
        var seriesSymbolRotate = !hasSymbolRotateCallback ? symbolRotate : null;
        var seriesSymbolOffset = !hasSymbolOffsetCallback ? symbolOffset : null;
        data.setVisual({
            legendIcon: seriesModel.legendIcon || seriesSymbol,
            // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
            // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
            // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
            // some cases but generally it is not recommanded.
            symbol: seriesSymbol,
            symbolSize: seriesSymbolSize,
            symbolKeepAspect: keepAspect,
            symbolRotate: seriesSymbolRotate,
            symbolOffset: seriesSymbolOffset
        }); // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
            hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
            hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
            hasSymbolOffsetCallback && data.setItemVisual(idx, 'symbolOffset', symbolOffset(rawValue, params));
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $579a0738784e30ca$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
         // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var itemSymbolType = itemModel.getShallow('symbol', true);
            var itemSymbolSize = itemModel.getShallow('symbolSize', true);
            var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
            var itemSymbolOffset = itemModel.getShallow('symbolOffset', true);
            var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
            if (itemSymbolType != null) data.setItemVisual(idx, 'symbol', itemSymbolType);
            if (itemSymbolSize != null) // PENDING Transform symbolSize ?
            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
            if (itemSymbolRotate != null) data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
            if (itemSymbolOffset != null) data.setItemVisual(idx, 'symbolOffset', itemSymbolOffset);
            if (itemSymbolKeepAspect != null) data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};

});

parcelRegister("fk5Gm", function(module, exports) {

$parcel$export(module.exports, "getItemVisualFromData", () => $b27d21a8d98c0d1c$export$91d919a86b2df624);
$parcel$export(module.exports, "getVisualFromData", () => $b27d21a8d98c0d1c$export$d76e333a86ea1a2);
$parcel$export(module.exports, "setItemVisualFromData", () => $b27d21a8d98c0d1c$export$3aab879e9d0e7c75);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $b27d21a8d98c0d1c$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $b27d21a8d98c0d1c$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $b27d21a8d98c0d1c$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value; // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}

});

parcelRegister("1nKsD", function(module, exports) {

$parcel$export(module.exports, "createLegacyDataSelectAction", () => $101bfa9c2a38d115$export$62942ba95693dbfc);
$parcel$export(module.exports, "handleLegacySelectEvents", () => $101bfa9c2a38d115$export$2575c83262e49d0c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");


var $eaKsF = parcelRequire("eaKsF");
function $101bfa9c2a38d115$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $bahqM.each)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $bahqM.extend)({}, payload);
            api.dispatchAction((0, $bahqM.extend)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $eaKsF.queryDataIndex)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $bahqM.isArray)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $bahqM.extend)({}, seriesModel.option.selectedMap)
            });
        }
    });
}
function $101bfa9c2a38d115$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}

});

parcelRegister("6IsbX", function(module, exports) {

$parcel$export(module.exports, "findEventDispatcher", () => $4e3cb87918e3df6d$export$8a4fca9e04eb4df6);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $4e3cb87918e3df6d$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}

});

parcelRegister("g2DhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $badb4ee06d190426$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9LEsz = parcelRequire("9LEsz");
function $badb4ee06d190426$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $9LEsz.createOrUpdatePatternFromDecal)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $9LEsz.createOrUpdatePatternFromDecal)(decal, api);
        }
    });
}

});
parcelRegister("9LEsz", function(module, exports) {

$parcel$export(module.exports, "createOrUpdatePatternFromDecal", () => $71c7e35019979000$export$a3ba048e1a648972);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $822uQ = parcelRequire("822uQ");

var $h4RuA = parcelRequire("h4RuA");

var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $7yklO = parcelRequire("7yklO");

var $aSzOj = parcelRequire("aSzOj");
var $71c7e35019979000$var$decalMap = new (0, $822uQ.default)();
var $71c7e35019979000$var$decalCache = new (0, $h4RuA.default)(100);
var $71c7e35019979000$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $71c7e35019979000$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $71c7e35019979000$var$decalMap["delete"](decalObject);
    var oldPattern = $71c7e35019979000$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $bahqM.defaults)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $71c7e35019979000$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $71c7e35019979000$var$decalKeys.length; ++i){
            var value = decalOpt[$71c7e35019979000$var$decalKeys[i]];
            var valueType = typeof value;
            if (value != null && !(0, $bahqM.isArray)(value) && valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $71c7e35019979000$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $71c7e35019979000$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $71c7e35019979000$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $71c7e35019979000$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $71c7e35019979000$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $71c7e35019979000$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $bahqM.createCanvas)();
        var svgRoot = isSVG && zr.painter.createSVGElement('g');
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $71c7e35019979000$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minumum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minumum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $jmSNG.getLeastCommonMultiple)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $jmSNG.getLeastCommonMultiple)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                         // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $7yklO.createSymbol)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) svgRoot.appendChild(zr.painter.paintOne(symbol));
                else // Paint to canvas for all other renderers.
                (0, $aSzOj.brushSingle)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $71c7e35019979000$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if (typeof symbol === 'string') return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] !== 'string') {
        isAllString = false;
        break;
    }
    if (isAllString) return $71c7e35019979000$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] === 'string') result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $71c7e35019979000$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if (typeof dash === 'number') {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (typeof dash[i] !== 'number') {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $71c7e35019979000$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if (typeof dash[i] === 'number') {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $bahqM.map)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $71c7e35019979000$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if (typeof dash === 'number') {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $bahqM.map)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash arrary of X or Y
 * @return {number[]} block length of each line
 */ function $71c7e35019979000$var$getLineBlockLengthX(dash) {
    return (0, $bahqM.map)(dash, function(line) {
        return $71c7e35019979000$var$getLineBlockLengthY(line);
    });
}
function $71c7e35019979000$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}

});
parcelRegister("822uQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d9072624d2c732b$export$2e2bcd8739ae039);
var $5d9072624d2c732b$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $5d9072624d2c732b$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $5d9072624d2c732b$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $5d9072624d2c732b$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($5d9072624d2c732b$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $5d9072624d2c732b$export$2e2bcd8739ae039 = $5d9072624d2c732b$var$WeakMap;

});

parcelRegister("aSzOj", function(module, exports) {

$parcel$export(module.exports, "createCanvasPattern", () => $7ebab9bfc20d8461$export$8eb5db6b7bc27903);
$parcel$export(module.exports, "brushSingle", () => $7ebab9bfc20d8461$export$567881adfc3eb7f3);
$parcel$export(module.exports, "brush", () => $7ebab9bfc20d8461$export$da5d6544e8c27bc1);

var $lBQ88 = parcelRequire("lBQ88");

var $aA4Ws = parcelRequire("aA4Ws");

var $63nvx = parcelRequire("63nvx");

var $dPYp9 = parcelRequire("dPYp9");

var $ghQ8v = parcelRequire("ghQ8v");

var $gcbBH = parcelRequire("gcbBH");

var $45jlh = parcelRequire("45jlh");

var $b7ZX8 = parcelRequire("b7ZX8");

var $bahqM = parcelRequire("bahqM");

var $cpB91 = parcelRequire("cpB91");

var $6sllV = parcelRequire("6sllV");

var $aVawM = parcelRequire("aVawM");
var $7ebab9bfc20d8461$var$pathProxyForDraw = new (0, $aA4Ws.default)(true);
function $7ebab9bfc20d8461$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $7ebab9bfc20d8461$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $7ebab9bfc20d8461$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $7ebab9bfc20d8461$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $7ebab9bfc20d8461$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $63nvx.createOrUpdateImage)(pattern.image, pattern.__image, el);
    if ((0, $63nvx.isImageReady)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) / Math.PI * 180);
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $7ebab9bfc20d8461$var$brushPath(ctx, el, style, inBatch) {
    var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
    var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $7ebab9bfc20d8461$var$pathProxyForDraw;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = el.__dirty ? (0, $dPYp9.getCanvasGradient)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = el.__dirty ? (0, $dPYp9.getCanvasGradient)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = el.__dirty || !el.__canvasFillPattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = el.__dirty || !el.__canvasStrokePattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var lineDash = style.lineDash && style.lineWidth > 0 && (0, $cpB91.normalizeLineDash)(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    var ctxLineDash = !!ctx.setLineDash;
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $bahqM.map)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    var needsRebuild = true;
    if (firstDraw || el.__dirty & (0, $aVawM.SHAPE_CHANGED_BIT) || lineDash && !ctxLineDash && hasStroke) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        if (lineDash && !ctxLineDash) {
            path.setLineDash(lineDash);
            path.setLineDashOffset(lineDashOffset);
        }
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash && ctxLineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
            if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
            if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash && ctxLineDash) ctx.setLineDash([]);
}
function $7ebab9bfc20d8461$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $63nvx.createOrUpdateImage)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $63nvx.isImageReady)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $7ebab9bfc20d8461$var$brushText(ctx, el, style) {
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $b7ZX8.DEFAULT_FONT);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var hasLineDash = void 0;
        if (ctx.setLineDash) {
            var lineDash = style.lineDash && style.lineWidth > 0 && (0, $cpB91.normalizeLineDash)(style.lineDash, style.lineWidth);
            var lineDashOffset = style.lineDashOffset;
            if (lineDash) {
                var lineScale_2 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
                if (lineScale_2 && lineScale_2 !== 1) {
                    lineDash = (0, $bahqM.map)(lineDash, function(rawVal) {
                        return rawVal / lineScale_2;
                    });
                    lineDashOffset /= lineScale_2;
                }
                ctx.setLineDash(lineDash);
                ctx.lineDashOffset = lineDashOffset;
                hasLineDash = true;
            }
        }
        if (style.strokeFirst) {
            if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (hasLineDash) ctx.setLineDash([]);
    }
}
var $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $7ebab9bfc20d8461$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $lBQ88.DEFAULT_COMMON_STYLE).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $lBQ88.DEFAULT_COMMON_STYLE).blend;
    }
    for(var i = 0; i < $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $lBQ88.DEFAULT_COMMON_STYLE).shadowColor;
    }
    return styleChanged;
}
function $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $7ebab9bfc20d8461$var$STROKE_PROPS.length; i++){
        var prop = $7ebab9bfc20d8461$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $7ebab9bfc20d8461$var$bindCommonProps(ctx, $7ebab9bfc20d8461$var$getStyle(el, scope.inHover), prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $7ebab9bfc20d8461$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $7ebab9bfc20d8461$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $7ebab9bfc20d8461$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $7ebab9bfc20d8461$var$DRAW_TYPE_PATH = 1;
var $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE = 2;
var $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT = 3;
var $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL = 4;
function $7ebab9bfc20d8461$var$canPathBatch(style) {
    var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
    var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function $7ebab9bfc20d8461$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $7ebab9bfc20d8461$export$567881adfc3eb7f3(ctx, el) {
    $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $aVawM.REDRAW_BIT);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $dPYp9.isClipPathChanged)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $ghQ8v.default) && el.autoBatch && $7ebab9bfc20d8461$var$canPathBatch(el.style);
    if (forceSetTransform || $7ebab9bfc20d8461$var$isTransformChanged(m, prevEl.transform)) {
        $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
        $7ebab9bfc20d8461$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
    var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $ghQ8v.default)) {
        if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_PATH;
        }
        $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $7ebab9bfc20d8461$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    } else {
        if (el instanceof (0, $45jlh.default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT;
            }
            $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $7ebab9bfc20d8461$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $gcbBH.default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE;
            }
            $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $7ebab9bfc20d8461$var$brushImage(ctx, el, style);
        } else if (el instanceof (0, $6sllV.default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL;
            }
            $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}

});
parcelRegister("dPYp9", function(module, exports) {

$parcel$export(module.exports, "getCanvasGradient", () => $a12ee4e4c244a026$export$3dab6afd018d48c7);
$parcel$export(module.exports, "isClipPathChanged", () => $a12ee4e4c244a026$export$beeddc5150cb2e83);
function $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = isNaN(x) ? 0 : x;
    x2 = isNaN(x2) ? 1 : x2;
    y = isNaN(y) ? 0 : y;
    y2 = isNaN(y2) ? 0 : y2;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $a12ee4e4c244a026$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) : $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $a12ee4e4c244a026$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}

});

parcelRegister("cpB91", function(module, exports) {

$parcel$export(module.exports, "normalizeLineDash", () => $9094a1fa7d97ce08$export$9efb2ae8a603855d);

var $bahqM = parcelRequire("bahqM");
function $9094a1fa7d97ce08$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    lineWidth = lineWidth || 1;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $bahqM.isNumber)(lineType) ? [
        lineType
    ] : (0, $bahqM.isArray)(lineType) ? lineType : null;
}

});




parcelRegister("fEzwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65624d7bef03239$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $fBEGW = parcelRequire("fBEGW");

var $2iWFB = parcelRequire("2iWFB");
var $b65624d7bef03239$var$storage = (0, $bahqM.createHashMap)();
var $b65624d7bef03239$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $fBEGW.GeoSVGResource)(mapName, rawDef.svg);
            $b65624d7bef03239$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $2iWFB.GeoJSONResource)(mapName, geoJSON, rawSpecialAreas);
            $b65624d7bef03239$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $b65624d7bef03239$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $b65624d7bef03239$var$storage.get(mapName); // Do not support return SVG until some real requirement come.
        return resource && resource.type === 'geoJSON' && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $b65624d7bef03239$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};

});
parcelRegister("fBEGW", function(module, exports) {

$parcel$export(module.exports, "GeoSVGResource", () => $b5c9e032bcec003b$export$be52c950efae1f84);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $KN3aA = parcelRequire("KN3aA");

var $4KVOr = parcelRequire("4KVOr");

var $7Tw7u = parcelRequire("7Tw7u");

var $bahqM = parcelRequire("bahqM");

var $1E3E8 = parcelRequire("1E3E8");

var $bsT8u = parcelRequire("bsT8u");

var $b8QyH = parcelRequire("b8QyH");
/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $bahqM.createHashMap)([
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path',
    // but still need to trigger events or tooltip.
    'text',
    'tspan',
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    'g'
]);
var $b5c9e032bcec003b$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = 'geoSVG'; // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $bahqM.createHashMap)(); // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName; // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $bsT8u.parseXML)(svg);
    }
    GeoSVGResource.prototype.load = function() /* nameMap: NameMap */ {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic; // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone(); // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $b5c9e032bcec003b$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $KN3aA.parseSVG)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $bahqM.assert)(rootFromParse != null);
        } catch (e) {
            throw new Error('Invalid svg format\n' + e.message);
        } // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $4KVOr.default)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true; // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only suport `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            } // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $1E3E8.default)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $KN3aA.makeViewBoxTransform)(viewBoxRect, boundingRect); // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        } // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $7Tw7u.default)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $bahqM.each)(result.named, function(namedItem) {
            if ($b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $b5c9e032bcec003b$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() // use the first boundingRect to avoid duplicated boundingRect calculation.
         || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic); // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $b5c9e032bcec003b$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false; // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $b5c9e032bcec003b$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $bahqM.createHashMap)(); // Create resions only for the first graphic.
    (0, $bahqM.each)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $b8QyH.GeoSVGRegion)(namedItem.name, namedItem.el); // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region); // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }

});
parcelRegister("KN3aA", function(module, exports) {

$parcel$export(module.exports, "makeViewBoxTransform", () => $08ca58536684a52b$export$3e2db4420f14f50f);
$parcel$export(module.exports, "parseSVG", () => $08ca58536684a52b$export$1919f5101c220601);

var $4KVOr = parcelRequire("4KVOr");

var $gcbBH = parcelRequire("gcbBH");

var $jjfok = parcelRequire("jjfok");

var $7Tw7u = parcelRequire("7Tw7u");

var $kVeV8 = parcelRequire("kVeV8");

var $cZb1F = parcelRequire("cZb1F");

var $lQwBc = parcelRequire("lQwBc");

var $32bXc = parcelRequire("32bXc");

var $izqgC = parcelRequire("izqgC");

var $id1Rd = parcelRequire("id1Rd");

var $bahqM = parcelRequire("bahqM");

var $9J7f8 = parcelRequire("9J7f8");

var $faICo = parcelRequire("faICo");

var $45jlh = parcelRequire("45jlh");

var $bsT8u = parcelRequire("bsT8u");
var $08ca58536684a52b$var$nodeParsers;
var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $bahqM.keys)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $bahqM.keys)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP);
var $08ca58536684a52b$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $bsT8u.parseXML)(xml);
        if (!svg) throw new Error('Illegal svg');
        this._defsUsePending = [];
        var root = new (0, $4KVOr.default)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat(svg.getAttribute('width') || opt.width);
        var height = parseFloat(svg.getAttribute('height') || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $08ca58536684a52b$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $08ca58536684a52b$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $08ca58536684a52b$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $4KVOr.default)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $7Tw7u.default)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') isInDefs = true;
        if (nodeName === 'text') isInText = true;
        if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $08ca58536684a52b$var$nodeParsers[nodeName];
                if (parser_1 && (0, $bahqM.hasOwn)($08ca58536684a52b$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $08ca58536684a52b$var$paintServerParsers[nodeName];
            if (parser && (0, $bahqM.hasOwn)($08ca58536684a52b$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $45jlh.default)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $08ca58536684a52b$var$inheritStyle(parentGroup, text);
        $08ca58536684a52b$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $08ca58536684a52b$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $08ca58536684a52b$var$nodeParsers = {
            'g': function(xmlNode, parentGroup) {
                var g = new (0, $4KVOr.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function(xmlNode, parentGroup) {
                var rect = new (0, $7Tw7u.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, rect);
                $08ca58536684a52b$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function(xmlNode, parentGroup) {
                var circle = new (0, $jjfok.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, circle);
                $08ca58536684a52b$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function(xmlNode, parentGroup) {
                var line = new (0, $cZb1F.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, line);
                $08ca58536684a52b$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function(xmlNode, parentGroup) {
                var ellipse = new (0, $kVeV8.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, ellipse);
                $08ca58536684a52b$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                var polygon = new (0, $lQwBc.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $08ca58536684a52b$var$inheritStyle(parentGroup, polygon);
                $08ca58536684a52b$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                var polyline = new (0, $32bXc.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $08ca58536684a52b$var$inheritStyle(parentGroup, polyline);
                $08ca58536684a52b$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function(xmlNode, parentGroup) {
                var img = new (0, $gcbBH.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, img);
                $08ca58536684a52b$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $4KVOr.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new (0, $4KVOr.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = (0, $id1Rd.createFromString)(d);
                $08ca58536684a52b$var$inheritStyle(parentGroup, path);
                $08ca58536684a52b$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $08ca58536684a52b$var$paintServerParsers = {
    'lineargradient': function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new (0, $9J7f8.default)(x1, y1, x2, y2);
        $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
        $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new (0, $faICo.default)(cx, cy, r);
        $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
        $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
}
function $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $08ca58536684a52b$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $08ca58536684a52b$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $bahqM.defaults)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $08ca58536684a52b$var$parsePoints(pointsString) {
    var list = $08ca58536684a52b$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $08ca58536684a52b$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $08ca58536684a52b$var$parseTransformAttribute(xmlNode, el);
        $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    (0, $bahqM.each)([
        'lineWidth',
        'opacity',
        'fillOpacity',
        'strokeOpacity',
        'miterLimit',
        'fontSize'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $bahqM.each)([
        'lineDashOffset',
        'lineCap',
        'lineJoin',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'textAlign'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $bahqM.map)($08ca58536684a52b$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
    if (inheritedStyle.display === 'none') disp.ignore = true;
}
function $08ca58536684a52b$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
        else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') zrTextAlign = 'center';
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $08ca58536684a52b$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $08ca58536684a52b$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($08ca58536684a52b$var$urlRegex);
    if (urlMatch) {
        var url = (0, $bahqM.trim)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === 'none') str = null;
    return str;
}
function $08ca58536684a52b$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $08ca58536684a52b$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $08ca58536684a52b$var$splitNumberSequence(rawStr) {
    return rawStr.match($08ca58536684a52b$var$numberReg) || [];
}
var $08ca58536684a52b$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $08ca58536684a52b$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $08ca58536684a52b$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace($08ca58536684a52b$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $08ca58536684a52b$var$splitNumberSequence(value);
            mt = mt || $izqgC.create();
            switch(type){
                case 'translate':
                    $izqgC.translate(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || '0')
                    ]);
                    break;
                case 'scale':
                    $izqgC.scale(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case 'rotate':
                    $izqgC.rotate(mt, mt, -parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                    $izqgC.mul(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                    $izqgC.mul(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $08ca58536684a52b$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) return;
    $08ca58536684a52b$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $08ca58536684a52b$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $bahqM.hasOwn)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $bahqM.hasOwn)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $08ca58536684a52b$export$1919f5101c220601(xml, opt) {
    var parser = new $08ca58536684a52b$var$SVGParser();
    return parser.parse(xml, opt);
}

});
parcelRegister("bsT8u", function(module, exports) {

$parcel$export(module.exports, "parseXML", () => $858d140ea42b55af$export$eacefc55fad2867e);

var $bahqM = parcelRequire("bahqM");
function $858d140ea42b55af$export$eacefc55fad2867e(svg) {
    if ((0, $bahqM.isString)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}

});


parcelRegister("b8QyH", function(module, exports) {

$parcel$export(module.exports, "GeoJSONRegion", () => $81c9361a69c93c5f$export$ee84fcb463f24b3d);
$parcel$export(module.exports, "GeoSVGRegion", () => $81c9361a69c93c5f$export$5f3d89e7254f3e69);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $1E3E8 = parcelRequire("1E3E8");

var $13I82 = parcelRequire("13I82");

var $eLEew = parcelRequire("eLEew");

var $hjZ9y = parcelRequire("hjZ9y");

var $izqgC = parcelRequire("izqgC");
var $81c9361a69c93c5f$var$TMP_TRANSFORM = [];
var $81c9361a69c93c5f$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        return;
    };
    return Region;
}();
var $81c9361a69c93c5f$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoJSON';
        _this.geometries = geometries;
        if (!cp) {
            var rect = _this.getBoundingRect();
            cp = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        } else cp = [
            cp[0],
            cp[1]
        ];
        _this._center = cp;
        return _this;
    }
    GeoJSONRegion.prototype.getBoundingRect = function() {
        var rect = this._rect;
        if (rect) return rect;
        var MAX_NUMBER = Number.MAX_VALUE;
        var min = [
            MAX_NUMBER,
            MAX_NUMBER
        ];
        var max = [
            -MAX_NUMBER,
            -MAX_NUMBER
        ];
        var min2 = [];
        var max2 = [];
        var geometries = this.geometries;
        var i = 0;
        for(; i < geometries.length; i++){
            // Only support polygon
            if (geometries[i].type !== 'polygon') continue;
             // Doesn't consider hole
            var exterior = geometries[i].exterior;
            $13I82.fromPoints(exterior, min2, max2);
            $eLEew.min(min, min, min2);
            $eLEew.max(max, max, max2);
        } // No data
        if (i === 0) min[0] = min[1] = max[0] = max[1] = 0;
        return this._rect = new (0, $1E3E8.default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            // Only support polygon.
            if (geometries[i].type !== 'polygon') continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            if ($hjZ9y.contain(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($hjZ9y.contain(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $1E3E8.default)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            // Only support polygon.
            if (geometries[i].type !== 'polygon') continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            for(var p = 0; p < exterior.length; p++)$eLEew.applyTransform(exterior[p], exterior[p], transform);
            for(var h = 0; h < (interiors ? interiors.length : 0); h++)for(var p = 0; p < interiors[h].length; p++)$eLEew.applyTransform(interiors[h][p], interiors[h][p], transform);
        }
        rect = this._rect;
        rect.copy(target); // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    GeoJSONRegion.prototype.getCenter = function() {
        return this._center;
    };
    GeoJSONRegion.prototype.setCenter = function(center) {
        this._center = center;
    };
    return GeoJSONRegion;
}($81c9361a69c93c5f$export$b1f97c3099fc6872);
var $81c9361a69c93c5f$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoSVG';
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this._calculateCenter();
        return center;
    };
    GeoSVGRegion.prototype._calculateCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $izqgC.identity($81c9361a69c93c5f$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $izqgC.mul(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $izqgC.invert(mat, mat);
        $eLEew.applyTransform(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($81c9361a69c93c5f$export$b1f97c3099fc6872);

});
parcelRegister("hjZ9y", function(module, exports) {

$parcel$export(module.exports, "contain", () => $c9c3a5bccc65a1b5$export$8893e2b90ba10d92);

var $3Ytji = parcelRequire("3Ytji");
var $c9c3a5bccc65a1b5$var$EPSILON = 1e-8;
function $c9c3a5bccc65a1b5$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $c9c3a5bccc65a1b5$var$EPSILON;
}
function $c9c3a5bccc65a1b5$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $3Ytji.default)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$c9c3a5bccc65a1b5$var$isAroundEqual(p[0], p0[0]) || !$c9c3a5bccc65a1b5$var$isAroundEqual(p[1], p0[1])) w += (0, $3Ytji.default)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}

});



parcelRegister("2iWFB", function(module, exports) {

$parcel$export(module.exports, "GeoJSONResource", () => $1adac5d85fe37b79$export$859cf85c67f2df51);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $gyzY7 = parcelRequire("gyzY7");

var $eEvpA = parcelRequire("eEvpA");

var $5i7yG = parcelRequire("5i7yG");

var $huNXv = parcelRequire("huNXv");

var $ducHh = parcelRequire("ducHh");

var $1E3E8 = parcelRequire("1E3E8");
var $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY = 'name';
var $1adac5d85fe37b79$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = 'geoJSON';
        this._parsedMap = (0, $bahqM.createHashMap)();
        this._mapName = mapName;
        this._specialAreas = specialAreas; // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $1adac5d85fe37b79$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $1adac5d85fe37b79$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $bahqM.createHashMap)();
        var finalRegions = [];
        (0, $bahqM.each)(parsed.regions, function(region) {
            var regionName = region.name; // Try use the alias in geoNameMap
            if (nameMap && nameMap.hasOwnProperty(regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $1E3E8.default)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions; // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $gyzY7.default)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error('Invalid geoJson format\n' + e.message);
        }
        (0, $eEvpA.default)(mapName, rawRegions);
        (0, $bahqM.each)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $5i7yG.default)(mapName, region);
            (0, $huNXv.default)(mapName, region);
            (0, $ducHh.default)(mapName, region); // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $1adac5d85fe37b79$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $1adac5d85fe37b79$var$parseInput(source) {
    return !(0, $bahqM.isString)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}

});
parcelRegister("gyzY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0dbb8f34f2c3106$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 
var $bahqM = parcelRequire("bahqM");

var $b8QyH = parcelRequire("b8QyH");
function $c0dbb8f34f2c3106$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    for(var f = 0; f < features.length; f++){
        var feature = features[f];
        var geometry = feature.geometry;
        if (geometry.type === 'Polygon') {
            var coordinates = geometry.coordinates;
            for(var c = 0; c < coordinates.length; c++)coordinates[c] = $c0dbb8f34f2c3106$var$decodePolygon(coordinates[c], geometry.encodeOffsets[c], encodeScale);
        } else if (geometry.type === 'MultiPolygon') {
            var coordinates = geometry.coordinates;
            for(var c = 0; c < coordinates.length; c++){
                var coordinate = coordinates[c];
                for(var c2 = 0; c2 < coordinate.length; c2++)coordinate[c2] = $c0dbb8f34f2c3106$var$decodePolygon(coordinate[c2], geometry.encodeOffsets[c][c2], encodeScale);
            }
        }
    } // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $c0dbb8f34f2c3106$var$decodePolygon(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1); // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y; // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $c0dbb8f34f2c3106$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $c0dbb8f34f2c3106$var$decode(geoJson);
    return $bahqM.map($bahqM.filter(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        if (geo.type === 'Polygon') {
            var coordinates = geo.coordinates;
            geometries.push({
                type: 'polygon',
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                exterior: coordinates[0],
                interiors: coordinates.slice(1)
            });
        }
        if (geo.type === 'MultiPolygon') {
            var coordinates = geo.coordinates;
            $bahqM.each(coordinates, function(item) {
                if (item[0]) geometries.push({
                    type: 'polygon',
                    exterior: item[0],
                    interiors: item.slice(1)
                });
            });
        }
        var region = new (0, $b8QyH.GeoJSONRegion)(properties[nameProperty || 'name'], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}

});

parcelRegister("eEvpA", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaad2ad12dd4ec6c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛

var $bahqM = parcelRequire("bahqM");

var $b8QyH = parcelRequire("b8QyH");
var $aaad2ad12dd4ec6c$var$geoCoord = [
    126,
    25
];
var $aaad2ad12dd4ec6c$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $aaad2ad12dd4ec6c$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $aaad2ad12dd4ec6c$var$i = 0; $aaad2ad12dd4ec6c$var$i < $aaad2ad12dd4ec6c$var$points.length; $aaad2ad12dd4ec6c$var$i++)for(var $aaad2ad12dd4ec6c$var$k = 0; $aaad2ad12dd4ec6c$var$k < $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i].length; $aaad2ad12dd4ec6c$var$k++){
    $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] /= 10.5;
    $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] /= -14;
    $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] += $aaad2ad12dd4ec6c$var$geoCoord[0];
    $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] += $aaad2ad12dd4ec6c$var$geoCoord[1];
}
function $aaad2ad12dd4ec6c$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === 'china') {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $aaad2ad12dd4ec6c$var$nanhaiName) return;
        }
        regions.push(new (0, $b8QyH.GeoJSONRegion)($aaad2ad12dd4ec6c$var$nanhaiName, $bahqM.map($aaad2ad12dd4ec6c$var$points, function(exterior) {
            return {
                type: 'polygon',
                exterior: exterior
            };
        }), $aaad2ad12dd4ec6c$var$geoCoord));
    }
}

});

parcelRegister("5i7yG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da47f1dbbeac6bc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3da47f1dbbeac6bc$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    //'北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $3da47f1dbbeac6bc$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china') {
        var coordFix = $3da47f1dbbeac6bc$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("huNXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbcbfdc69414efb9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $cbcbfdc69414efb9$var$geoCoordMap = {
    'Russia': [
        100,
        60
    ],
    'United States': [
        -99,
        38
    ],
    'United States of America': [
        -99,
        38
    ]
};
function $cbcbfdc69414efb9$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'world') {
        var geoCoord = $cbcbfdc69414efb9$var$geoCoordMap[region.name];
        if (geoCoord) {
            var cp = [
                geoCoord[0],
                geoCoord[1]
            ];
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("ducHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d17ed1a4c54aaef$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $9d17ed1a4c54aaef$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $9d17ed1a4c54aaef$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: 'polygon',
        exterior: $9d17ed1a4c54aaef$var$points[0]
    });
}

});



parcelRegister("8cCW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8da56db6246248$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bRKv5 = parcelRequire("bRKv5");
var $5f8da56db6246248$var$lifecycle = new (0, $bRKv5.default)();
var $5f8da56db6246248$export$2e2bcd8739ae039 = $5f8da56db6246248$var$lifecycle;

});




parcelRegister("48mDj", function(module, exports) {

$parcel$export(module.exports, "install", () => $3029774200831710$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $hpWan = parcelRequire("hpWan");

var $9wang = parcelRequire("9wang");

var $ce402 = parcelRequire("ce402");
function $3029774200831710$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $9wang.default));
    registers.registerComponentView((0, $ce402.default));
    registers.registerPreprocessor(function(opt) {
        if ((0, $hpWan.default)(opt.series, 'markLine')) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

});
parcelRegister("hpWan", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae1e41edf2dca89$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
function $cae1e41edf2dca89$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $bahqM.isArray)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}

});

parcelRegister("9wang", function(module, exports) {

$parcel$export(module.exports, "default", () => $6edf264d439d7d08$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h8Fle = parcelRequire("h8Fle");
var $6edf264d439d7d08$var$MarkLineModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = 'markLine';
    MarkLineModel.defaultOption = {
        zlevel: 0,
        z: 5,
        symbol: [
            'circle',
            'arrow'
        ],
        symbolSize: [
            8,
            16
        ],
        //symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'end',
            distance: 5
        },
        lineStyle: {
            type: 'dashed'
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: 'linear'
    };
    return MarkLineModel;
}((0, $h8Fle.default));
var $6edf264d439d7d08$export$2e2bcd8739ae039 = $6edf264d439d7d08$var$MarkLineModel;

});
parcelRegister("h8Fle", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7a34092fe996af9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $guzSc = parcelRequire("guzSc");

var $h4UlH = parcelRequire("h4UlH");

var $eaKsF = parcelRequire("eaKsF");

var $j5lKL = parcelRequire("j5lKL");
function $c7a34092fe996af9$var$fillLabel(opt) {
    (0, $eaKsF.defaultEmphasis)(opt, 'label', [
        'show'
    ]);
} // { [componentType]: MarkerModel }
var $c7a34092fe996af9$var$inner = (0, $eaKsF.makeInner)();
var $c7a34092fe996af9$var$MarkerModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $hZfwb.default).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $c7a34092fe996af9$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $c7a34092fe996af9$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $c7a34092fe996af9$var$fillLabel(markerOpt);
                $bahqM.each(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $c7a34092fe996af9$var$fillLabel(item[0]);
                        $c7a34092fe996af9$var$fillLabel(item[1]);
                    } else $c7a34092fe996af9$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel); // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $bahqM.extend(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $c7a34092fe996af9$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $j5lKL.createTooltipMarkup)('section', {
            header: this.name,
            blocks: [
                (0, $j5lKL.createTooltipMarkup)('nameValue', {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, componentType) {
        return $c7a34092fe996af9$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = 'marker';
    MarkerModel.dependencies = [
        'series',
        'grid',
        'polar',
        'geo'
    ];
    return MarkerModel;
}((0, $h4UlH.default));
$bahqM.mixin($c7a34092fe996af9$var$MarkerModel, (0, $guzSc.DataFormatMixin).prototype);
var $c7a34092fe996af9$export$2e2bcd8739ae039 = $c7a34092fe996af9$var$MarkerModel;

});


parcelRegister("ce402", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e69e51972a54af1$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $liBXN = parcelRequire("liBXN");

var $jmSNG = parcelRequire("jmSNG");

var $gjRnj = parcelRequire("gjRnj");

var $2JPY0 = parcelRequire("2JPY0");

var $k3pUt = parcelRequire("k3pUt");

var $5R8Hi = parcelRequire("5R8Hi");

var $40dMe = parcelRequire("40dMe");

var $7QjoM = parcelRequire("7QjoM");

var $h8Fle = parcelRequire("h8Fle");

var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $fk5Gm = parcelRequire("fk5Gm");
var $8e69e51972a54af1$var$inner = (0, $eaKsF.makeInner)();
var $8e69e51972a54af1$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $bahqM.isArray)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
         || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
                value = (0, $bahqM.retrieve)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $gjRnj.getAxisInfo(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $5R8Hi.getStackedDimension)(data, axisInfo.valueDataDim);
                value = $gjRnj.numCalculate(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
            var baseIndex = 1 - valueIndex; // Normized to 2d data with start and end point
            var mlFrom = (0, $bahqM.clone)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get('precision');
            if (precision >= 0 && typeof value === 'number') value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $gjRnj.dataTransform(seriesModel, itemArray[0]),
        $gjRnj.dataTransform(seriesModel, itemArray[1]),
        (0, $bahqM.extend)({}, itemArray[2])
    ]; // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null; // Merge from option and to option into line option
    (0, $bahqM.merge)(normalizedItem[2], normalizedItem[0]);
    (0, $bahqM.merge)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $8e69e51972a54af1$var$isInifinity(val) {
    return !isNaN(val) && !isFinite(val);
} // If a markLine has one dim
function $8e69e51972a54af1$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $8e69e51972a54af1$var$isInifinity(fromCoord[otherDimIndex]) && $8e69e51972a54af1$var$isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $8e69e51972a54af1$var$markLineFilter(coordSys, item) {
    if (coordSys.type === 'cartesian2d') {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord; // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($8e69e51972a54af1$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $8e69e51972a54af1$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $gjRnj.dataFilter(coordSys, item[0]) && $gjRnj.dataFilter(coordSys, item[1]);
}
function $8e69e51972a54af1$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $jmSNG.parsePercent(itemModel.get('x'), api.getWidth());
    var yPx = $jmSNG.parsePercent(itemModel.get('y'), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        } // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $40dMe.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var dims = coordSys.dimensions;
            if ($8e69e51972a54af1$var$isInifinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($8e69e51972a54af1$var$isInifinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        } // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $8e69e51972a54af1$var$MarkLineView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $h8Fle.default).getMarkerModelFromSeries(seriesModel, 'markLine');
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $8e69e51972a54af1$var$inner(mlModel).from;
                var toData_1 = $8e69e51972a54af1$var$inner(mlModel).to; // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $8e69e51972a54af1$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $8e69e51972a54af1$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                }); // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $2JPY0.default)());
        this.group.add(lineDraw.group);
        var mlData = $8e69e51972a54af1$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $8e69e51972a54af1$var$inner(mlModel).from = fromData;
        $8e69e51972a54af1$var$inner(mlModel).to = toData; // Line data for tooltip and formatter
        mlModel.setData(lineData); // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get('symbol');
        var symbolSize = mlModel.get('symbolSize');
        var symbolRotate = mlModel.get('symbolRotate');
        var symbolOffset = mlModel.get('symbolOffset'); // TODO: support callback function like markPoint
        if (!(0, $bahqM.isArray)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $bahqM.isArray)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $bahqM.isArray)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $bahqM.isArray)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
         // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        }); // Update visual and layout of line
        lineData.each(function(idx) {
            var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle(); // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
            lineData.setItemVisual(idx, {
                fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
                fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
                fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
                fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
                fromSymbol: fromData.getItemVisual(idx, 'symbol'),
                toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
                toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
                toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
                toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
                toSymbol: toData.getItemVisual(idx, 'symbol'),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData); // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el, idx) {
            el.traverse(function(child) {
                (0, $7QjoM.getECData)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $8e69e51972a54af1$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (style.fill == null) style.fill = (0, $fk5Gm.getVisualFromData)(seriesData, 'color');
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get('symbolKeepAspect'),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $bahqM.retrieve2)(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $bahqM.retrieve2)(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $bahqM.retrieve2)(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $bahqM.retrieve2)(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
    };
    MarkLineView.type = 'markLine';
    return MarkLineView;
}((0, $k3pUt.default));
function $8e69e51972a54af1$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $bahqM.map)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $bahqM.extend)((0, $bahqM.extend)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var fromData = new (0, $liBXN.default)(coordDimsInfos, mlModel);
    var toData = new (0, $liBXN.default)(coordDimsInfos, mlModel); // No dimensions
    var lineData = new (0, $liBXN.default)([], mlModel);
    var optData = (0, $bahqM.map)(mlModel.get('data'), (0, $bahqM.curry)($8e69e51972a54af1$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $bahqM.filter)(optData, (0, $bahqM.curry)($8e69e51972a54af1$var$markLineFilter, coordSys));
    var dimValueGetter = $gjRnj.createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
    fromData.initData((0, $bahqM.map)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $bahqM.map)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $bahqM.map)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $8e69e51972a54af1$export$2e2bcd8739ae039 = $8e69e51972a54af1$var$MarkLineView;

});
parcelRegister("gjRnj", function(module, exports) {

$parcel$export(module.exports, "numCalculate", () => $be17d2d7c679ee45$export$18ddefb55c03640b);
$parcel$export(module.exports, "dataTransform", () => $be17d2d7c679ee45$export$3eebd2d54b98c04f);
$parcel$export(module.exports, "getAxisInfo", () => $be17d2d7c679ee45$export$bd39458db76002ab);
$parcel$export(module.exports, "dataFilter", () => $be17d2d7c679ee45$export$179695f4a9040f73);
$parcel$export(module.exports, "createMarkerDimValueGetter", () => $be17d2d7c679ee45$export$a53767c3c8f69cf7);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");

var $5R8Hi = parcelRequire("5R8Hi");

var $bahqM = parcelRequire("bahqM");

var $2G90t = parcelRequire("2G90t");
function $be17d2d7c679ee45$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $be17d2d7c679ee45$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $be17d2d7c679ee45$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $5R8Hi.isDimensionStacked)(data, targetDataDim);
    var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
    var value = $be17d2d7c679ee45$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
    var precision = $jmSNG.getPrecision(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
} // TODO Specified percent
var $be17d2d7c679ee45$var$markerTypeCalculator = {
    min: (0, $bahqM.curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'min'),
    max: (0, $bahqM.curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'max'),
    average: (0, $bahqM.curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'average'),
    median: (0, $bahqM.curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'median')
};
function $be17d2d7c679ee45$export$3eebd2d54b98c04f(seriesModel, item) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (item && !$be17d2d7c679ee45$var$hasXAndY(item) && !(0, $bahqM.isArray)(item.coord) && coordSys) {
        var dims = coordSys.dimensions;
        var axisInfo = $be17d2d7c679ee45$export$bd39458db76002ab(item, data, coordSys, seriesModel); // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $bahqM.clone)(item);
        if (item.type && $be17d2d7c679ee45$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $bahqM.indexOf)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $bahqM.indexOf)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $be17d2d7c679ee45$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0]; // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else {
            // FIXME Only has one of xAxis and yAxis.
            var coord = [
                item.xAxis != null ? item.xAxis : item.radiusAxis,
                item.yAxis != null ? item.yAxis : item.angleAxis
            ]; // Each coord support max, min, average
            for(var i = 0; i < 2; i++)if ($be17d2d7c679ee45$var$markerTypeCalculator[coord[i]]) coord[i] = $be17d2d7c679ee45$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
            item.coord = coord;
        }
    }
    return item;
}
function $be17d2d7c679ee45$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($be17d2d7c679ee45$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $be17d2d7c679ee45$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $be17d2d7c679ee45$export$179695f4a9040f73(coordSys, item) {
    // Alwalys return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$be17d2d7c679ee45$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $be17d2d7c679ee45$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 // x, y, radius, angle
         ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $2G90t.parseDataValue)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $2G90t.parseDataValue)(item.value, dims[dimIndex]);
    };
}
function $be17d2d7c679ee45$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === 'average') {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === 'median') return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
}

});

parcelRegister("2JPY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe8183fc890aada$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4KVOr = parcelRequire("4KVOr");

var $hKTLM = parcelRequire("hKTLM");

var $gvLUt = parcelRequire("gvLUt");
var $1fe8183fc890aada$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $4KVOr.default();
        this._LineCtor = LineCtor || (0, $hKTLM.default);
    }
    LineDraw.prototype.isPersistent = function() {
        return true;
    };
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $1fe8183fc890aada$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData; // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $1fe8183fc890aada$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$1fe8183fc890aada$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($1fe8183fc890aada$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$1fe8183fc890aada$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$1fe8183fc890aada$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $1fe8183fc890aada$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $1fe8183fc890aada$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    return {
        lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
        emphasisLineStyle: hostModel.getModel([
            'emphasis',
            'lineStyle'
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            'blur',
            'lineStyle'
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            'select',
            'lineStyle'
        ]).getLineStyle(),
        labelStatesModels: (0, $gvLUt.getLabelStatesModels)(hostModel)
    };
}
function $1fe8183fc890aada$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $1fe8183fc890aada$var$lineNeedsDraw(pts) {
    return !$1fe8183fc890aada$var$isPointNaN(pts[0]) && !$1fe8183fc890aada$var$isPointNaN(pts[1]);
}
var $1fe8183fc890aada$export$2e2bcd8739ae039 = $1fe8183fc890aada$var$LineDraw;

});
parcelRegister("hKTLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced1fe40d771d409$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $eLEew = parcelRequire("eLEew");

var $7yklO = parcelRequire("7yklO");

var $iUQRt = parcelRequire("iUQRt");

var $4KVOr = parcelRequire("4KVOr");
var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $fIXXx = parcelRequire("fIXXx");

var $gvLUt = parcelRequire("gvLUt");

var $jmSNG = parcelRequire("jmSNG");
var $ced1fe40d771d409$var$SYMBOL_CATEGORIES = [
    'fromSymbol',
    'toSymbol'
];
function $ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory) {
    return '_' + symbolCategory + 'Type';
}
/**
 * @inner
 */ function $ced1fe40d771d409$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $7yklO.normalizeSymbolSize(symbolSize);
    var symbolOffsetArr = $7yklO.normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $7yklO.createSymbol(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $ced1fe40d771d409$var$createLine(points) {
    var line = new (0, $iUQRt.default)({
        name: 'line',
        subPixelOptimize: true
    });
    $ced1fe40d771d409$var$setLinePoints(line.shape, points);
    return line;
}
function $ced1fe40d771d409$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $ced1fe40d771d409$var$Line = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var line = $ced1fe40d771d409$var$createLine(linePoints);
        line.shape.percent = 0;
        $eYgMC.initProps(line, {
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $bahqM.each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $ced1fe40d771d409$var$createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    }; // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $ced1fe40d771d409$var$setLinePoints(target.shape, linePoints);
        $eYgMC.updateProps(line, target, seriesModel, idx);
        (0, $bahqM.each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = lineData.getItemVisual(idx, symbolCategory);
            var key = $ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory); // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $ced1fe40d771d409$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels; // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            emphasisLineStyle = itemModel.getModel([
                'emphasis',
                'lineStyle'
            ]).getLineStyle();
            blurLineStyle = itemModel.getModel([
                'blur',
                'lineStyle'
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                'select',
                'lineStyle'
            ]).getLineStyle();
            labelStatesModels = (0, $gvLUt.getLabelStatesModels)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState('emphasis').style = emphasisLineStyle;
        line.ensureState('blur').style = blurLineStyle;
        line.ensureState('select').style = selectLineStyle; // Update symbol
        (0, $bahqM.each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
                    var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $gvLUt.setLabelStyle)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || '#000',
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $jmSNG.round)(rawVal) : rawVal) + ''
        });
        var label = this.getTextContent(); // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign; // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get('position') || 'middle';
            var distance = labelNormalModel.get('distance');
            if (!(0, $bahqM.isArray)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $fIXXx.enableHoverEmphasis)(this);
    };
    Line.prototype.highlight = function() {
        (0, $fIXXx.enterEmphasis)(this);
    };
    Line.prototype.downplay = function() {
        (0, $fIXXx.leaveEmphasis)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName('line');
        $ced1fe40d771d409$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName('fromSymbol');
        var symbolTo = lineGroup.childOfName('toSymbol');
        var label = lineGroup.getTextContent(); // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName('line'); // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $eLEew.sub([], toPos, fromPos);
        $eLEew.normalize(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr('rotation', specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== 'start' && label.__position !== 'end') {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case 'insideStartTop':
                case 'insideMiddleTop':
                case 'insideEndTop':
                case 'middle':
                    dy = -distanceY;
                    textVerticalAlign = 'bottom';
                    break;
                case 'insideStartBottom':
                case 'insideMiddleBottom':
                case 'insideEndBottom':
                    dy = distanceY;
                    textVerticalAlign = 'top';
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = 'middle';
            }
            switch(label.__position){
                case 'end':
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
                    break;
                case 'start':
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
                    break;
                case 'insideStartTop':
                case 'insideStart':
                case 'insideStartBottom':
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? 'right' : 'left';
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case 'insideMiddleTop':
                case 'insideMiddle':
                case 'insideMiddleBottom':
                case 'middle':
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = 'center';
                    label.originY = -dy;
                    break;
                case 'insideEndTop':
                case 'insideEnd':
                case 'insideEndBottom':
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? 'right' : 'left';
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($4KVOr.default);
var $ced1fe40d771d409$export$2e2bcd8739ae039 = $ced1fe40d771d409$var$Line;

});
parcelRegister("iUQRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc56761fbff4269e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");
parcelRequire("fHITF");
var $04gw0 = parcelRequire("04gw0");
var $cZb1F = parcelRequire("cZb1F");
var $ghQ8v = parcelRequire("ghQ8v");

var $eLEew = parcelRequire("eLEew");
var $dc56761fbff4269e$var$straightLineProto = $cZb1F.default.prototype;
var $dc56761fbff4269e$var$bezierCurveProto = $04gw0.default.prototype;
var $dc56761fbff4269e$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0; // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $dc56761fbff4269e$var$CurveShape = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($dc56761fbff4269e$var$StraightLineShape);
function $dc56761fbff4269e$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $dc56761fbff4269e$var$ECLinePath = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-line';
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $dc56761fbff4269e$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($dc56761fbff4269e$var$isStraightLine(shape)) $dc56761fbff4269e$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $dc56761fbff4269e$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($dc56761fbff4269e$var$isStraightLine(this.shape)) return $dc56761fbff4269e$var$straightLineProto.pointAt.call(this, t);
        else return $dc56761fbff4269e$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $dc56761fbff4269e$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $dc56761fbff4269e$var$bezierCurveProto.tangentAt.call(this, t);
        return $eLEew.normalize(p, p);
    };
    return ECLinePath;
}($ghQ8v.default);
var $dc56761fbff4269e$export$2e2bcd8739ae039 = $dc56761fbff4269e$var$ECLinePath;

});



parcelRegister("k3pUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9982f98742e3477$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $fkskt = parcelRequire("fkskt");

var $bahqM = parcelRequire("bahqM");

var $h8Fle = parcelRequire("h8Fle");

var $eaKsF = parcelRequire("eaKsF");

var $fIXXx = parcelRequire("fIXXx");
var $e9982f98742e3477$var$inner = (0, $eaKsF.makeInner)();
var $e9982f98742e3477$var$MarkerView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $bahqM.createHashMap)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $e9982f98742e3477$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $h8Fle.default).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$e9982f98742e3477$var$inner(item).keep && _this.group.remove(item.group);
        });
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $e9982f98742e3477$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.blurSeries = function(seriesModelList) {
        var _this = this;
        (0, $bahqM.each)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $h8Fle.default).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) (0, $fIXXx.enterBlur)(el);
                });
            }
        });
    };
    MarkerView.type = 'marker';
    return MarkerView;
}((0, $fkskt.default));
var $e9982f98742e3477$export$2e2bcd8739ae039 = $e9982f98742e3477$var$MarkerView;

});



parcelRegister("gLj36", function(module, exports) {

$parcel$export(module.exports, "install", () => $c33fcfdcc4592871$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hi3Y7 = parcelRequire("hi3Y7");

var $alpND = parcelRequire("alpND");

var $ixwqj = parcelRequire("ixwqj");

var $kfWc4 = parcelRequire("kfWc4");
function $c33fcfdcc4592871$export$4b3e715f166fdd78(registers) {
    (0, $alpND.use)((0, $hi3Y7.install));
    registers.registerComponentModel((0, $ixwqj.default));
    registers.registerComponentView((0, $kfWc4.default));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, function() {});
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, function() {});
}

});
parcelRegister("ixwqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7f475abbf81e4fb$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h4UlH = parcelRequire("h4UlH");
var $d7f475abbf81e4fb$var$TooltipModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click',
        alwaysShowContent: false,
        displayMode: 'single',
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaut false (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        enterable: false,
        backgroundColor: '#fff',
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: '#999',
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            } // lineStyle and shadowStyle should not be specified here,
        },
        textStyle: {
            color: '#666',
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $h4UlH.default));
var $d7f475abbf81e4fb$export$2e2bcd8739ae039 = $d7f475abbf81e4fb$var$TooltipModel;

});

parcelRegister("kfWc4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf2596432d1aebb$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $lh5Tz = parcelRequire("lh5Tz");

var $bf1zw = parcelRequire("bf1zw");

var $dCJrM = parcelRequire("dCJrM");

var $jmSNG = parcelRequire("jmSNG");
parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");

var $4LkI5 = parcelRequire("4LkI5");

var $65MS1 = parcelRequire("65MS1");

var $gaMkj = parcelRequire("gaMkj");

var $iNebh = parcelRequire("iNebh");

var $3GIoT = parcelRequire("3GIoT");

var $eSE0c = parcelRequire("eSE0c");

var $eaKsF = parcelRequire("eaKsF");

var $fkskt = parcelRequire("fkskt");

var $bc1Ad = parcelRequire("bc1Ad");

var $7QjoM = parcelRequire("7QjoM");

var $l3AHA = parcelRequire("l3AHA");

var $guzSc = parcelRequire("guzSc");

var $j5lKL = parcelRequire("j5lKL");

var $6IsbX = parcelRequire("6IsbX");

var $ljaBy = parcelRequire("ljaBy");
var $ebf2596432d1aebb$var$bind = $bahqM.bind;
var $ebf2596432d1aebb$var$each = $bahqM.each;
var $ebf2596432d1aebb$var$parsePercent = $jmSNG.parsePercent;
var $ebf2596432d1aebb$var$proxyRect = new $7Tw7u.default({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $ebf2596432d1aebb$var$TooltipView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $hZfwb.default).node) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = tooltipModel.get('renderMode');
        this._renderMode = (0, $eaKsF.getTooltipRenderMode)(renderMode);
        this._tooltipContent = this._renderMode === 'richText' ? new (0, $bf1zw.default)(api) : new (0, $lh5Tz.default)(api.getDom(), api, {
            appendToBody: tooltipModel.get('appendToBody', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $hZfwb.default).node) return;
         // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        /**
     * @private
     * @type {boolean}
     */ this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow(); // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the updatePosition was also called very frequently.
        // In Chrome with devtools open and Firefox, tooltip looks lagged and shaked around. See #14695.
        // To avoid the frequent triggering,
        // consider throttling it in 50ms. (the tested result may need to validate)
        this._updatePosition = this._renderMode === 'html' ? (0, $ljaBy.throttle)($ebf2596432d1aebb$var$bind(this._doUpdatePosition, this), 50) : this._doUpdatePosition;
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $iNebh.register('itemTooltip', this._api, $ebf2596432d1aebb$var$bind(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api; // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
         && tooltipModel.get('triggerOn') !== 'none') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $hZfwb.default).node) return;
        var dispatchAction = $ebf2596432d1aebb$var$makeDispatchAction(payload, api); // Reset ticket
        this._ticket = ''; // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $ebf2596432d1aebb$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $ebf2596432d1aebb$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $7QjoM.getECData)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            }; // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $4LkI5.default)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (!this._alwaysShowContent && this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($ebf2596432d1aebb$var$makeDispatchAction(payload, api));
    }; // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex; // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $ebf2596432d1aebb$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
         // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $6IsbX.findEventDispatcher)(el, function(target) {
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $7QjoM.getECData)(target).dataIndex != null) {
                    seriesDispatcher_1 = target;
                    return true;
                } // Tooltip provided directly. Like legend.
                if ((0, $7QjoM.getECData)(target).tooltipConfig != null) {
                    cmptDispatcher_1 = target;
                    return true;
                }
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = $bahqM.bind(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $ebf2596432d1aebb$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $j5lKL.createTooltipMarkup)('section', {
            blocks: [],
            noHeader: true
        }); // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $j5lKL.TooltipMarkupStyleCreator)();
        $ebf2596432d1aebb$var$each(dataByCoordSys, function(itemCoordSys) {
            $ebf2596432d1aebb$var$each(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                var axisValueLabel = $eSE0c.getValueLabel(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $j5lKL.createTooltipMarkup)('section', {
                    header: axisValueLabel,
                    noHeader: !$bahqM.trim(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                $bahqM.each(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex); // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $3GIoT.getAxisRawValue(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel; // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', $dCJrM.convertToColorString(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $guzSc.normalizeTooltipFormatResult)(series.formatTooltip(dataIndex, true, null));
                    if (seriesTooltipResult.markupFragment) axisSectionMarkup.blocks.push(seriesTooltipResult.markupFragment);
                    if (seriesTooltipResult.markupText) markupTextArrLegacy.push(seriesTooltipResult.markupText);
                    cbParamsList.push(cbParams);
                });
            });
        }); // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $j5lKL.buildTooltipMarkup)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $7QjoM.getECData)(dispatcher); // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $ebf2596432d1aebb$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $j5lKL.TooltipMarkupStyleCreator)(); // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', $dCJrM.convertToColorString(params.color), renderMode);
        var seriesTooltipResult = (0, $guzSc.normalizeTooltipFormatResult)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var markupText = seriesTooltipResult.markupFragment ? (0, $j5lKL.buildTooltipMarkup)(seriesTooltipResult.markupFragment, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.markupText;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        }); // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var ecData = (0, $7QjoM.getECData)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        if ($bahqM.isString(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
         // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they can not share the same formatter. Since the global tooltip formatter is used for series
        // by convension, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $ebf2596432d1aebb$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + ''; // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $j5lKL.TooltipMarkupStyleCreator)(); // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = $bahqM.clone(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        }); // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ($bahqM.isString(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = $bahqM.isArray(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $bc1Ad.format)(params0.axisValue, html, useUTC);
                html = $dCJrM.formatTpl(html, params, true);
            } else if ($bahqM.isFunction(formatter)) {
                var callback = $ebf2596432d1aebb$var$bind(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
        if (trigger === 'axis' || $bahqM.isArray(tooltipDataParams)) return {
            color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
        };
        if (!$bahqM.isArray(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._doUpdatePosition = function(tooltipModel, positionExpr, x, y, content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ($bahqM.isFunction(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ($bahqM.isArray(positionExpr)) {
            x = $ebf2596432d1aebb$var$parsePercent(positionExpr[0], viewWidth);
            y = $ebf2596432d1aebb$var$parsePercent(positionExpr[1], viewHeight);
        } else if ($bahqM.isObject(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = $65MS1.getLayoutRect(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null; // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ($bahqM.isString(positionExpr) && el) {
            var pos = $ebf2596432d1aebb$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $ebf2596432d1aebb$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $ebf2596432d1aebb$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $ebf2596432d1aebb$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $l3AHA.shouldTooltipConfine)(tooltipModel)) {
            var pos = $ebf2596432d1aebb$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    }; // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && $ebf2596432d1aebb$var$each(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && $ebf2596432d1aebb$var$each(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && $ebf2596432d1aebb$var$each(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                }); // check is cbParams data value changed
                lastCbParamsList && $bahqM.each(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $hZfwb.default).node) return;
        this._tooltipContent.dispose();
        $iNebh.unregister('itemTooltip', api);
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $fkskt.default));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $ebf2596432d1aebb$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $gaMkj.default)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $gaMkj.default)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $gaMkj.default)) tooltipOpt = tooltipOpt.get('tooltip', true);
             // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ($bahqM.isString(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $gaMkj.default)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $ebf2596432d1aebb$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || $bahqM.bind(api.dispatchAction, api);
}
function $ebf2596432d1aebb$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in defaut tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $ebf2596432d1aebb$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $ebf2596432d1aebb$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $ebf2596432d1aebb$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $ebf2596432d1aebb$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $eaKsF.preParseFinder)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $eaKsF.queryReferringComponents)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $7QjoM.getECData)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $ebf2596432d1aebb$export$2e2bcd8739ae039 = $ebf2596432d1aebb$var$TooltipView;

});
parcelRegister("lh5Tz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cfc2302c12dfb3$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");

var $65X4x = parcelRequire("65X4x");

var $6AZf6 = parcelRequire("6AZf6");

var $hZfwb = parcelRequire("hZfwb");

var $dCJrM = parcelRequire("dCJrM");

var $l3AHA = parcelRequire("l3AHA");

var $j5lKL = parcelRequire("j5lKL");
/* global document, window */ var $f7cfc2302c12dfb3$var$CSS_TRANSITION_VENDOR = (0, $l3AHA.toCSSVendorPrefix)((0, $l3AHA.TRANSITION_VENDOR), 'transition');
var $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR = (0, $l3AHA.toCSSVendorPrefix)((0, $l3AHA.TRANSFORM_VENDOR), 'transform'); // eslint-disable-next-line
var $f7cfc2302c12dfb3$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $hZfwb.default).transform3dSupported ? 'will-change:transform;' : '');
function $f7cfc2302c12dfb3$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $f7cfc2302c12dfb3$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $bahqM.isString)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $dCJrM.convertToColorString)(borderColor);
    var arrowPos = $f7cfc2302c12dfb3$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $bahqM.indexOf)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $f7cfc2302c12dfb3$var$assembleTransition(duration, onlyFade) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = " " + duration / 2 + "s " + transitionCurve;
    var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    if (!onlyFade) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (0, $hZfwb.default).transformSupported ? "," + $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
    }
    return $f7cfc2302c12dfb3$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $f7cfc2302c12dfb3$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px'; // not support transform, use `left` and `top` instead.
    if (!(0, $hZfwb.default).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
     // support transform
    var is3d = (0, $hZfwb.default).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $l3AHA.TRANSFORM_VENDOR),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $f7cfc2302c12dfb3$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    fontSize // @ts-ignore, leave it to the tooltip refactor.
     && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $bahqM.each)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $f7cfc2302c12dfb3$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $j5lKL.getPaddingFromTooltipModel)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow); // Animation transition. Do not animate when transitionDuration is 0.
    enableTransition && transitionDuration && cssText.push($f7cfc2302c12dfb3$var$assembleTransition(transitionDuration, onlyFade));
    if (backgroundColor) {
        if ((0, $hZfwb.default).canvasSupported) cssText.push('background-color:' + backgroundColor);
        else {
            // for ie
            cssText.push('background-color:#' + (0, $d6udH.toHex)(backgroundColor));
            cssText.push('filter:alpha(opacity=70)');
        }
    } // Border style
    (0, $bahqM.each)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $dCJrM.toCamelCase)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    }); // Text style
    cssText.push($f7cfc2302c12dfb3$var$assembleFont(textStyleModel)); // Padding
    if (padding != null) cssText.push('padding:' + (0, $dCJrM.normalizeCssArray)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
} // If not able to make, do not modify the input `out`.
function $f7cfc2302c12dfb3$var$makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (appendToBody) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $6AZf6.transformLocalCoord)(out, zrViewportRoot, document.body, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $f7cfc2302c12dfb3$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(container, api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $hZfwb.default).wxa) return null;
        var el = document.createElement('div'); // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendToBody = this._appendToBody = opt && opt.appendToBody;
        $f7cfc2302c12dfb3$var$makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
        if (appendToBody) document.body.appendChild(el);
        else container.appendChild(el);
        this._container = container; // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $65X4x.normalizeEvent)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        var container = this._container;
        var position = (0, $l3AHA.getComputedStyle)(container, 'position');
        var domStyle = container.style;
        if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
         // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized(); // update className
        this.el.className = tooltipModel.get('className') || ''; // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $f7cfc2302c12dfb3$var$gCssText + $f7cfc2302c12dfb3$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) // initial transform
         + $f7cfc2302c12dfb3$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $dCJrM.convertToColorString)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '' // If mouse occasionally move over the tooltip, a mouseout event will be
        ) + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $bahqM.isString)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $l3AHA.shouldTooltipConfine)(tooltipModel)) arrow = $f7cfc2302c12dfb3$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $bahqM.isString)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $bahqM.isArray)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $bahqM.isDom)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
             // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return [
            el.offsetWidth,
            el.offsetHeight
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        var styleCoord = this._styleCoord;
        $f7cfc2302c12dfb3$var$makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $f7cfc2302c12dfb3$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $bahqM.each)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2]; // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        style.visibility = 'hidden';
        style.opacity = '0';
        (0, $hZfwb.default).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable)) {
            if (time) {
                this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $bahqM.bind)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        this.el.parentNode.removeChild(this.el);
    };
    return TooltipHTMLContent;
}();
var $f7cfc2302c12dfb3$export$2e2bcd8739ae039 = $f7cfc2302c12dfb3$var$TooltipHTMLContent;

});
parcelRegister("l3AHA", function(module, exports) {

$parcel$export(module.exports, "shouldTooltipConfine", () => $f54659081207367d$export$a309528050824ba4);
$parcel$export(module.exports, "TRANSFORM_VENDOR", () => $f54659081207367d$export$7b4286b1e4a23439);
$parcel$export(module.exports, "TRANSITION_VENDOR", () => $f54659081207367d$export$70a631ae991b5e76);
$parcel$export(module.exports, "toCSSVendorPrefix", () => $f54659081207367d$export$5886acafe29a08d1);
$parcel$export(module.exports, "getComputedStyle", () => $f54659081207367d$export$3735103072e4a80);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dCJrM = parcelRequire("dCJrM");

var $hZfwb = parcelRequire("hZfwb");
function $f54659081207367d$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption // In richText mode, the outside part can not be visible.
     : tooltipModel.get('renderMode') === 'richText';
}
function $f54659081207367d$var$testStyle(styleProps) {
    if (!(0, $hZfwb.default).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $f54659081207367d$export$7b4286b1e4a23439 = $f54659081207367d$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $f54659081207367d$export$70a631ae991b5e76 = $f54659081207367d$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $f54659081207367d$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $dCJrM.toCamelCase)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $f54659081207367d$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}

});


parcelRegister("bf1zw", function(module, exports) {

$parcel$export(module.exports, "default", () => $82f2508e80aaa8db$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $4gEFv = parcelRequire("4gEFv");

var $j5lKL = parcelRequire("j5lKL");

var $2cFRc = parcelRequire("2cFRc");
var $82f2508e80aaa8db$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._zr = api.getZr();
        $82f2508e80aaa8db$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        if ($bahqM.isObject(content)) (0, $2cFRc.throwError)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $4gEFv.default)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                backgroundColor: tooltipModel.get('backgroundColor'),
                borderRadius: tooltipModel.get('borderRadius'),
                borderWidth: 1,
                borderColor: borderColor,
                shadowColor: tooltipModel.get('shadowColor'),
                shadowBlur: tooltipModel.get('shadowBlur'),
                shadowOffsetX: tooltipModel.get('shadowOffsetX'),
                shadowOffsetY: tooltipModel.get('shadowOffsetY'),
                textShadowColor: textStyleModel.get('textShadowColor'),
                textShadowBlur: textStyleModel.get('textShadowBlur') || 0,
                textShadowOffsetX: textStyleModel.get('textShadowOffsetX') || 0,
                textShadowOffsetY: textStyleModel.get('textShadowOffsetY') || 0,
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $j5lKL.getPaddingFromTooltipModel)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect(); // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $82f2508e80aaa8db$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $82f2508e80aaa8db$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $82f2508e80aaa8db$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $82f2508e80aaa8db$var$calcShadowOuterSize(style); // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2]; // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable)) {
            if (time) {
                this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($bahqM.bind(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $82f2508e80aaa8db$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $82f2508e80aaa8db$var$calcShadowOuterSize(style) {
    var shadowBlur = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $82f2508e80aaa8db$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $82f2508e80aaa8db$export$2e2bcd8739ae039 = $82f2508e80aaa8db$var$TooltipRichContent;

});



parcelRegister("ixV1I", function(module, exports) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jtdCU = parcelRequire("jtdCU");
$parcel$exportWildcard(module.exports, $jtdCU);

});
parcelRegister("jtdCU", function(module, exports) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Core API from echarts/src/echarts

var $8pqpA = parcelRequire("8pqpA");

var $a7GWb = parcelRequire("a7GWb");

var $alpND = parcelRequire("alpND");

var $fKViU = parcelRequire("fKViU");
(0, $alpND.use)((0, $fKViU.installLabelLayout));
$parcel$exportWildcard(module.exports, $8pqpA);
$parcel$exportWildcard(module.exports, $a7GWb);

});
parcelRegister("a7GWb", function(module, exports) {

$parcel$export(module.exports, "extendComponentModel", () => $75ebdd55a0204a2b$export$4dd01020bb736662);
$parcel$export(module.exports, "extendComponentView", () => $75ebdd55a0204a2b$export$a4336148da8ef02);
$parcel$export(module.exports, "extendSeriesModel", () => $75ebdd55a0204a2b$export$fe6d3114e3fc260c);
$parcel$export(module.exports, "extendChartView", () => $75ebdd55a0204a2b$export$c750883d1b603e83);
$parcel$export(module.exports, "zrender", () => (parcelRequire("9Y5KT")));
$parcel$export(module.exports, "matrix", () => (parcelRequire("izqgC")));
$parcel$export(module.exports, "vector", () => (parcelRequire("eLEew")));
$parcel$export(module.exports, "zrUtil", () => (parcelRequire("bahqM")));
$parcel$export(module.exports, "color", () => (parcelRequire("d6udH")));
$parcel$export(module.exports, "throttle", () => (parcelRequire("ljaBy")).throttle);
$parcel$export(module.exports, "helper", () => (parcelRequire("anaTl")));
$parcel$export(module.exports, "use", () => (parcelRequire("alpND")).use);
$parcel$export(module.exports, "parseGeoJSON", () => (parcelRequire("gyzY7")).default);
$parcel$export(module.exports, "parseGeoJson", () => (parcelRequire("gyzY7")).default);
$parcel$export(module.exports, "number", () => (parcelRequire("hJg2M")));
$parcel$export(module.exports, "time", () => (parcelRequire("ats4w")));
$parcel$export(module.exports, "graphic", () => (parcelRequire("fwli1")));
$parcel$export(module.exports, "format", () => (parcelRequire("byxPd")));
$parcel$export(module.exports, "util", () => (parcelRequire("fvUv7")));
$parcel$export(module.exports, "env", () => (parcelRequire("hZfwb")).default);
$parcel$export(module.exports, "List", () => (parcelRequire("liBXN")).default);
$parcel$export(module.exports, "Model", () => (parcelRequire("gaMkj")).default);
$parcel$export(module.exports, "Axis", () => (parcelRequire("g6Gq1")).default);
$parcel$export(module.exports, "ComponentModel", () => (parcelRequire("h4UlH")).default);
$parcel$export(module.exports, "ComponentView", () => (parcelRequire("fkskt")).default);
$parcel$export(module.exports, "SeriesModel", () => (parcelRequire("1O7Ua")).default);
$parcel$export(module.exports, "ChartView", () => (parcelRequire("loerw")).default);
$parcel$export(module.exports, "innerDrawElementOnCanvas", () => (parcelRequire("aSzOj")).brushSingle);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // These APIs are for more advanced usages
// For example extend charts and components, creating graphic elements, formatting.

var $h4UlH = parcelRequire("h4UlH");

var $fkskt = parcelRequire("fkskt");

var $1O7Ua = parcelRequire("1O7Ua");

var $loerw = parcelRequire("loerw");

var $liBXN = parcelRequire("liBXN");

var $9Y5KT = parcelRequire("9Y5KT");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");

var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");

var $ljaBy = parcelRequire("ljaBy");

var $anaTl = parcelRequire("anaTl");

var $alpND = parcelRequire("alpND");

var $gyzY7 = parcelRequire("gyzY7");

var $hJg2M = parcelRequire("hJg2M");

var $ats4w = parcelRequire("ats4w");

var $fwli1 = parcelRequire("fwli1");

var $byxPd = parcelRequire("byxPd");

var $fvUv7 = parcelRequire("fvUv7");

var $hZfwb = parcelRequire("hZfwb");

var $gaMkj = parcelRequire("gaMkj");

var $g6Gq1 = parcelRequire("g6Gq1");

var $aSzOj = parcelRequire("aSzOj");
function $75ebdd55a0204a2b$export$4dd01020bb736662(proto) {
    var Model = (0, $h4UlH.default).extend(proto);
    (0, $h4UlH.default).registerClass(Model);
    return Model;
}
function $75ebdd55a0204a2b$export$a4336148da8ef02(proto) {
    var View = (0, $fkskt.default).extend(proto);
    (0, $fkskt.default).registerClass(View);
    return View;
}
function $75ebdd55a0204a2b$export$fe6d3114e3fc260c(proto) {
    var Model = (0, $1O7Ua.default).extend(proto);
    (0, $1O7Ua.default).registerClass(Model);
    return Model;
}
function $75ebdd55a0204a2b$export$c750883d1b603e83(proto) {
    var View = (0, $loerw.default).extend(proto);
    (0, $loerw.default).registerClass(View);
    return View;
}

});
parcelRegister("anaTl", function(module, exports) {

$parcel$export(module.exports, "createList", () => $78d480381111bb0c$export$5897d8d7c7a3d871);
$parcel$export(module.exports, "dataStack", () => $78d480381111bb0c$export$d6100971d5a3a0a7);
$parcel$export(module.exports, "createScale", () => $78d480381111bb0c$export$587d9c3c553380c6);
$parcel$export(module.exports, "mixinAxisModelCommonMethods", () => $78d480381111bb0c$export$4665cbe3470e4d57);
$parcel$export(module.exports, "createTextStyle", () => $78d480381111bb0c$export$f8998c3d0a13de59);
$parcel$export(module.exports, "getLayoutRect", () => (parcelRequire("65MS1")).getLayoutRect);
$parcel$export(module.exports, "createDimensions", () => (parcelRequire("h9jiS")).createDimensions);
$parcel$export(module.exports, "createSymbol", () => (parcelRequire("7yklO")).createSymbol);
$parcel$export(module.exports, "getECData", () => (parcelRequire("7QjoM")).getECData);
$parcel$export(module.exports, "enableHoverEmphasis", () => (parcelRequire("fIXXx")).enableHoverEmphasis);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * This module exposes helper functions for developing extensions.
 */ 
var $bahqM = parcelRequire("bahqM");

var $bAY5l = parcelRequire("bAY5l");

var $3GIoT = parcelRequire("3GIoT");

var $5pBRm = parcelRequire("5pBRm");

var $gaMkj = parcelRequire("gaMkj");

var $65MS1 = parcelRequire("65MS1");

var $5R8Hi = parcelRequire("5R8Hi");

var $7QjoM = parcelRequire("7QjoM");

var $gvLUt = parcelRequire("gvLUt");

var $h9jiS = parcelRequire("h9jiS");

var $7yklO = parcelRequire("7yklO");

var $fIXXx = parcelRequire("fIXXx");
function $78d480381111bb0c$export$5897d8d7c7a3d871(seriesModel) {
    return (0, $bAY5l.default)(null, seriesModel);
} // export function createGraph(seriesModel) {
var $78d480381111bb0c$export$d6100971d5a3a0a7 = {
    isDimensionStacked: (0, $5R8Hi.isDimensionStacked),
    enableDataStack: (0, $5R8Hi.enableDataStack),
    getStackedDimension: (0, $5R8Hi.getStackedDimension)
};
function $78d480381111bb0c$export$587d9c3c553380c6(dataExtent, option) {
    var axisModel = option;
    if (!(option instanceof (0, $gaMkj.default))) axisModel = new (0, $gaMkj.default)(option); // FIXME
    var scale = $3GIoT.createScaleByModel(axisModel);
    scale.setExtent(dataExtent[0], dataExtent[1]);
    $3GIoT.niceScaleExtent(scale, axisModel);
    return scale;
}
function $78d480381111bb0c$export$4665cbe3470e4d57(Model) {
    $bahqM.mixin(Model, (0, $5pBRm.AxisModelCommonMixin));
}
function $78d480381111bb0c$export$f8998c3d0a13de59(textStyleModel, opts) {
    opts = opts || {};
    return (0, $gvLUt.createTextStyle)(textStyleModel, null, null, opts.state !== 'normal');
}

});

parcelRegister("hJg2M", function(module, exports) {

$parcel$export(module.exports, "linearMap", () => (parcelRequire("jmSNG")).linearMap);
$parcel$export(module.exports, "round", () => (parcelRequire("jmSNG")).round);
$parcel$export(module.exports, "asc", () => (parcelRequire("jmSNG")).asc);
$parcel$export(module.exports, "getPrecision", () => (parcelRequire("jmSNG")).getPrecision);
$parcel$export(module.exports, "getPrecisionSafe", () => (parcelRequire("jmSNG")).getPrecisionSafe);
$parcel$export(module.exports, "getPixelPrecision", () => (parcelRequire("jmSNG")).getPixelPrecision);
$parcel$export(module.exports, "getPercentWithPrecision", () => (parcelRequire("jmSNG")).getPercentWithPrecision);
$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => (parcelRequire("jmSNG")).MAX_SAFE_INTEGER);
$parcel$export(module.exports, "remRadian", () => (parcelRequire("jmSNG")).remRadian);
$parcel$export(module.exports, "isRadianAroundZero", () => (parcelRequire("jmSNG")).isRadianAroundZero);
$parcel$export(module.exports, "parseDate", () => (parcelRequire("jmSNG")).parseDate);
$parcel$export(module.exports, "quantity", () => (parcelRequire("jmSNG")).quantity);
$parcel$export(module.exports, "quantityExponent", () => (parcelRequire("jmSNG")).quantityExponent);
$parcel$export(module.exports, "nice", () => (parcelRequire("jmSNG")).nice);
$parcel$export(module.exports, "quantile", () => (parcelRequire("jmSNG")).quantile);
$parcel$export(module.exports, "reformIntervals", () => (parcelRequire("jmSNG")).reformIntervals);
$parcel$export(module.exports, "isNumeric", () => (parcelRequire("jmSNG")).isNumeric);
$parcel$export(module.exports, "numericToNumber", () => (parcelRequire("jmSNG")).numericToNumber);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");

});

parcelRegister("ats4w", function(module, exports) {

$parcel$export(module.exports, "parse", () => (parcelRequire("jmSNG")).parseDate);
$parcel$export(module.exports, "format", () => (parcelRequire("bc1Ad")).format);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");

var $bc1Ad = parcelRequire("bc1Ad");

});

parcelRegister("fwli1", function(module, exports) {

$parcel$export(module.exports, "extendShape", () => (parcelRequire("fHITF")).extendShape);
$parcel$export(module.exports, "extendPath", () => (parcelRequire("fHITF")).extendPath);
$parcel$export(module.exports, "makePath", () => (parcelRequire("fHITF")).makePath);
$parcel$export(module.exports, "makeImage", () => (parcelRequire("fHITF")).makeImage);
$parcel$export(module.exports, "mergePath", () => (parcelRequire("fHITF")).mergePath);
$parcel$export(module.exports, "resizePath", () => (parcelRequire("fHITF")).resizePath);
$parcel$export(module.exports, "createIcon", () => (parcelRequire("fHITF")).createIcon);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("eYgMC")).updateProps);
$parcel$export(module.exports, "initProps", () => (parcelRequire("eYgMC")).initProps);
$parcel$export(module.exports, "getTransform", () => (parcelRequire("fHITF")).getTransform);
$parcel$export(module.exports, "clipPointsByRect", () => (parcelRequire("fHITF")).clipPointsByRect);
$parcel$export(module.exports, "clipRectByRect", () => (parcelRequire("fHITF")).clipRectByRect);
$parcel$export(module.exports, "registerShape", () => (parcelRequire("fHITF")).registerShape);
$parcel$export(module.exports, "getShapeClass", () => (parcelRequire("fHITF")).getShapeClass);
$parcel$export(module.exports, "Group", () => (parcelRequire("4KVOr")).default);
$parcel$export(module.exports, "Image", () => (parcelRequire("gcbBH")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("4gEFv")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("jjfok")).default);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("kVeV8")).default);
$parcel$export(module.exports, "Sector", () => (parcelRequire("elGBV")).default);
$parcel$export(module.exports, "Ring", () => (parcelRequire("LCHOw")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("lQwBc")).default);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("32bXc")).default);
$parcel$export(module.exports, "Rect", () => (parcelRequire("7Tw7u")).default);
$parcel$export(module.exports, "Line", () => (parcelRequire("cZb1F")).default);
$parcel$export(module.exports, "BezierCurve", () => (parcelRequire("04gw0")).default);
$parcel$export(module.exports, "Arc", () => (parcelRequire("ixXaU")).default);
$parcel$export(module.exports, "IncrementalDisplayable", () => (parcelRequire("6sllV")).default);
$parcel$export(module.exports, "CompoundPath", () => (parcelRequire("eGltS")).default);
$parcel$export(module.exports, "LinearGradient", () => (parcelRequire("9J7f8")).default);
$parcel$export(module.exports, "RadialGradient", () => (parcelRequire("faICo")).default);
$parcel$export(module.exports, "BoundingRect", () => (parcelRequire("1E3E8")).default);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("fHITF");
var $ixXaU = parcelRequire("ixXaU");
var $04gw0 = parcelRequire("04gw0");
var $jjfok = parcelRequire("jjfok");
var $fHITF = parcelRequire("fHITF");
var $kVeV8 = parcelRequire("kVeV8");
var $gcbBH = parcelRequire("gcbBH");
var $cZb1F = parcelRequire("cZb1F");
var $lQwBc = parcelRequire("lQwBc");
var $32bXc = parcelRequire("32bXc");
var $7Tw7u = parcelRequire("7Tw7u");
var $LCHOw = parcelRequire("LCHOw");
var $elGBV = parcelRequire("elGBV");
var $eYgMC = parcelRequire("eYgMC");
var $1E3E8 = parcelRequire("1E3E8");
var $eGltS = parcelRequire("eGltS");
var $4KVOr = parcelRequire("4KVOr");
var $6sllV = parcelRequire("6sllV");
var $eYgMC = parcelRequire("eYgMC");
var $9J7f8 = parcelRequire("9J7f8");
var $faICo = parcelRequire("faICo");
var $4gEFv = parcelRequire("4gEFv");

});

parcelRegister("byxPd", function(module, exports) {

$parcel$export(module.exports, "addCommas", () => (parcelRequire("dCJrM")).addCommas);
$parcel$export(module.exports, "toCamelCase", () => (parcelRequire("dCJrM")).toCamelCase);
$parcel$export(module.exports, "normalizeCssArray", () => (parcelRequire("dCJrM")).normalizeCssArray);
$parcel$export(module.exports, "encodeHTML", () => (parcelRequire("dCJrM")).encodeHTML);
$parcel$export(module.exports, "formatTpl", () => (parcelRequire("dCJrM")).formatTpl);
$parcel$export(module.exports, "getTooltipMarker", () => (parcelRequire("dCJrM")).getTooltipMarker);
$parcel$export(module.exports, "formatTime", () => (parcelRequire("dCJrM")).formatTime);
$parcel$export(module.exports, "capitalFirst", () => (parcelRequire("dCJrM")).capitalFirst);
$parcel$export(module.exports, "truncateText", () => (parcelRequire("h6fMM")).truncateText);
$parcel$export(module.exports, "getTextRect", () => (parcelRequire("2emZ2")).getTextRect);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dCJrM = parcelRequire("dCJrM");
var $2emZ2 = parcelRequire("2emZ2");
var $h6fMM = parcelRequire("h6fMM");

});

parcelRegister("fvUv7", function(module, exports) {

$parcel$export(module.exports, "map", () => (parcelRequire("bahqM")).map);
$parcel$export(module.exports, "each", () => (parcelRequire("bahqM")).each);
$parcel$export(module.exports, "indexOf", () => (parcelRequire("bahqM")).indexOf);
$parcel$export(module.exports, "inherits", () => (parcelRequire("bahqM")).inherits);
$parcel$export(module.exports, "reduce", () => (parcelRequire("bahqM")).reduce);
$parcel$export(module.exports, "filter", () => (parcelRequire("bahqM")).filter);
$parcel$export(module.exports, "bind", () => (parcelRequire("bahqM")).bind);
$parcel$export(module.exports, "curry", () => (parcelRequire("bahqM")).curry);
$parcel$export(module.exports, "isArray", () => (parcelRequire("bahqM")).isArray);
$parcel$export(module.exports, "isString", () => (parcelRequire("bahqM")).isString);
$parcel$export(module.exports, "isObject", () => (parcelRequire("bahqM")).isObject);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("bahqM")).isFunction);
$parcel$export(module.exports, "extend", () => (parcelRequire("bahqM")).extend);
$parcel$export(module.exports, "defaults", () => (parcelRequire("bahqM")).defaults);
$parcel$export(module.exports, "clone", () => (parcelRequire("bahqM")).clone);
$parcel$export(module.exports, "merge", () => (parcelRequire("bahqM")).merge);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

});


parcelRegister("fKViU", function(module, exports) {

$parcel$export(module.exports, "installLabelLayout", () => $b7879a416965ee89$export$5320d1b3745c02a5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");

var $JIQqQ = parcelRequire("JIQqQ");
var $b7879a416965ee89$var$getLabelManager = (0, $eaKsF.makeInner)();
function $b7879a416965ee89$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager = new (0, $JIQqQ.default)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
        var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}

});
parcelRegister("JIQqQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0896fd4d6c482b72$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.

var $1E3E8 = parcelRequire("1E3E8");
var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $7QjoM = parcelRequire("7QjoM");

var $jmSNG = parcelRequire("jmSNG");

var $e6gef = parcelRequire("e6gef");

var $fxCHE = parcelRequire("fxCHE");

var $eaKsF = parcelRequire("eaKsF");

var $bahqM = parcelRequire("bahqM");

var $3LB2b = parcelRequire("3LB2b");

var $gvLUt = parcelRequire("gvLUt");
function $0896fd4d6c482b72$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $0896fd4d6c482b72$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS = [
    'align',
    'verticalAlign',
    'width',
    'height',
    'fontSize'
];
var $0896fd4d6c482b72$var$dummyTransformable = new (0, $e6gef.default)();
var $0896fd4d6c482b72$var$labelLayoutInnerStore = (0, $eaKsF.makeInner)();
var $0896fd4d6c482b72$var$labelLineAnimationStore = (0, $eaKsF.makeInner)();
function $0896fd4d6c482b72$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS = [
    'x',
    'y',
    'rotation'
];
var $0896fd4d6c482b72$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {}; // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $1E3E8.default).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $0896fd4d6c482b72$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $0896fd4d6c482b72$var$dummyTransformable.x = $0896fd4d6c482b72$var$dummyTransformable.y = $0896fd4d6c482b72$var$dummyTransformable.rotation = $0896fd4d6c482b72$var$dummyTransformable.originX = $0896fd4d6c482b72$var$dummyTransformable.originY = 0;
            $0896fd4d6c482b72$var$dummyTransformable.scaleX = $0896fd4d6c482b72$var$dummyTransformable.scaleY = 1;
        }
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $1E3E8.default).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOption: layoutOption,
            computedLayoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $0896fd4d6c482b72$var$dummyTransformable.x,
                y: $0896fd4d6c482b72$var$dummyTransformable.y,
                scaleX: $0896fd4d6c482b72$var$dummyTransformable.scaleX,
                scaleY: $0896fd4d6c482b72$var$dummyTransformable.scaleY,
                rotation: $0896fd4d6c482b72$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get('labelLayout');
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $bahqM.isFunction)(layoutOption) || (0, $bahqM.keys)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
             // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $7QjoM.getECData)(child); // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $fxCHE.updateLabelLinePoints)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0; // TODO A global layout option?
            if (typeof labelItem.layoutOption === 'function') layoutOption = labelItem.layoutOption($0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOption;
            layoutOption = layoutOption || {};
            labelItem.computedLayoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180; // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $jmSNG.parsePercent)(layoutOption.x, width);
                label.setStyle('x', 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle('x', defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $jmSNG.parsePercent)(layoutOption.y, height);
                label.setStyle('y', 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle('y', defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    }); // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = 'move';
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                }
            } else {
                // TODO Other drag functions?
                label.off('drag');
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = (0, $3LB2b.prepareLayoutList)(this._labelList);
        var labelsNeedsAdjustOnX = (0, $bahqM.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftX';
        });
        var labelsNeedsAdjustOnY = (0, $bahqM.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftY';
        });
        (0, $3LB2b.shiftLayoutOnX)(labelsNeedsAdjustOnX, 0, width);
        (0, $3LB2b.shiftLayoutOnY)(labelsNeedsAdjustOnY, 0, height);
        var labelsNeedsHideOverlap = (0, $bahqM.filter)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $3LB2b.hideOverlap)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $bahqM.each)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $0896fd4d6c482b72$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent(); // Update label line style.
        var ecData = (0, $7QjoM.getECData)(el);
        var dataIndex = ecData.dataIndex; // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, 'style');
            var visualType = data.getVisual('drawType'); // Default to be same with main color
            defaultStyle.stroke = visualStyle[visualType];
            var labelLineModel = itemModel.getModel('labelLine');
            (0, $fxCHE.setLabelLineStyle)(el, (0, $fxCHE.getLabelLineStatesModels)(itemModel), defaultStyle);
            (0, $fxCHE.updateLabelLinePoints)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine(); // Animate
        if (textEl && !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $eYgMC.isElementRemoved)(el)) {
            var layoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $7QjoM.getECData)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps); // Disable fade in animation if value animation is enabled.
                if (!(0, $gvLUt.labelInner)(textEl).valueAnimation) {
                    var oldOpacity = (0, $bahqM.retrieve2)(textEl.style.opacity, 1); // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $eYgMC.initProps)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout); // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $bahqM.indexOf)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $bahqM.indexOf)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $eYgMC.updateProps)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, textEl.states.select, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
            }
            (0, $gvLUt.animateLabelValue)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $0896fd4d6c482b72$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $eYgMC.initProps)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $eYgMC.updateProps)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $0896fd4d6c482b72$export$2e2bcd8739ae039 = $0896fd4d6c482b72$var$LabelManager;

});
parcelRegister("fxCHE", function(module, exports) {

$parcel$export(module.exports, "updateLabelLinePoints", () => $02eb7bb47d256bbb$export$cc93ba643cd97d83);
$parcel$export(module.exports, "limitTurnAngle", () => $02eb7bb47d256bbb$export$ac52062003fbe6a);
$parcel$export(module.exports, "limitSurfaceAngle", () => $02eb7bb47d256bbb$export$973e1fdb2708f71b);
$parcel$export(module.exports, "setLabelLineStyle", () => $02eb7bb47d256bbb$export$c09e0b0574bdd2dc);
$parcel$export(module.exports, "getLabelLineStatesModels", () => $02eb7bb47d256bbb$export$2979fdbf5ebce521);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("fHITF");
var $ghQ8v = parcelRequire("ghQ8v");
var $32bXc = parcelRequire("32bXc");
var $bMDnR = parcelRequire("bMDnR");

var $aA4Ws = parcelRequire("aA4Ws");

var $kvt3T = parcelRequire("kvt3T");

var $dr1jo = parcelRequire("dr1jo");

var $bahqM = parcelRequire("bahqM");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");

var $fIXXx = parcelRequire("fIXXx");
var $02eb7bb47d256bbb$var$PI2 = Math.PI * 2;
var $02eb7bb47d256bbb$var$CMD = (0, $aA4Ws.default).CMD;
var $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE = [
    'top',
    'right',
    'bottom',
    'left'
];
function $02eb7bb47d256bbb$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case 'top':
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case 'bottom':
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case 'left':
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case 'right':
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d; // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $02eb7bb47d256bbb$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $kvt3T.normalizeRadian)(endAngle);
        endAngle = (0, $kvt3T.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $kvt3T.normalizeRadian)(startAngle);
        endAngle = (0, $kvt3T.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $02eb7bb47d256bbb$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $02eb7bb47d256bbb$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $02eb7bb47d256bbb$var$PI2 >= startAngle && angle + $02eb7bb47d256bbb$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $02eb7bb47d256bbb$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen; // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $02eb7bb47d256bbb$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $02eb7bb47d256bbb$var$tmpPt = [];
function $02eb7bb47d256bbb$var$nearestPointOnRect(pt, rect, out) {
    var dist = $02eb7bb47d256bbb$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $02eb7bb47d256bbb$var$tmpPt);
    out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $02eb7bb47d256bbb$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $02eb7bb47d256bbb$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $02eb7bb47d256bbb$var$CMD.L:
                d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $02eb7bb47d256bbb$var$CMD.C:
                d = (0, $dr1jo.cubicProjectPoint)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $02eb7bb47d256bbb$var$CMD.Q:
                d = (0, $dr1jo.quadraticProjectPoint)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $02eb7bb47d256bbb$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++]; // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $02eb7bb47d256bbb$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $02eb7bb47d256bbb$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $02eb7bb47d256bbb$var$projectPointToRect(x0, y0, width, height, x, y, $02eb7bb47d256bbb$var$tmpPt);
                break;
            case $02eb7bb47d256bbb$var$CMD.Z:
                d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, x0, y0, x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
        }
    }
    return minDist;
} // Temporal varible for intermediate usage.
var $02eb7bb47d256bbb$var$pt0 = new (0, $bMDnR.default)();
var $02eb7bb47d256bbb$var$pt1 = new (0, $bMDnR.default)();
var $02eb7bb47d256bbb$var$pt2 = new (0, $bMDnR.default)();
var $02eb7bb47d256bbb$var$dir = new (0, $bMDnR.default)();
var $02eb7bb47d256bbb$var$dir2 = new (0, $bMDnR.default)();
function $02eb7bb47d256bbb$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent(); // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $izqgC.invert)([], targetTransform);
    var len = labelLineModel.get('length2') || 0;
    if (anchorPoint) $02eb7bb47d256bbb$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $02eb7bb47d256bbb$var$getCandidateAnchor(candidate, 0, labelRect, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir);
        (0, $bMDnR.default).scaleAndAdd($02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir, len); // Transform to target coord space.
        $02eb7bb47d256bbb$var$pt1.transform(targetInversedTransform); // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($02eb7bb47d256bbb$var$pt1) : target instanceof (0, $ghQ8v.default) ? $02eb7bb47d256bbb$var$nearestPointOnPath($02eb7bb47d256bbb$var$pt1, target.path, $02eb7bb47d256bbb$var$pt2) : $02eb7bb47d256bbb$var$nearestPointOnRect($02eb7bb47d256bbb$var$pt1, boundingRect, $02eb7bb47d256bbb$var$pt2); // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist; // Transform back to global space.
            $02eb7bb47d256bbb$var$pt1.transform(targetTransform);
            $02eb7bb47d256bbb$var$pt2.transform(targetTransform);
            $02eb7bb47d256bbb$var$pt2.toArray(points[0]);
            $02eb7bb47d256bbb$var$pt1.toArray(points[1]);
            $02eb7bb47d256bbb$var$pt0.toArray(points[2]);
        }
    }
    $02eb7bb47d256bbb$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
    labelLine.setShape({
        points: points
    });
} // Temporal variable for the limitTurnAngle function
var $02eb7bb47d256bbb$var$tmpArr = [];
var $02eb7bb47d256bbb$var$tmpProjPoint = new (0, $bMDnR.default)();
function $02eb7bb47d256bbb$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI; // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
    $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
    $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
    (0, $bMDnR.default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$pt1);
    (0, $bMDnR.default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
    var len1 = $02eb7bb47d256bbb$var$dir.len();
    var len2 = $02eb7bb47d256bbb$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $02eb7bb47d256bbb$var$dir.scale(1 / len1);
    $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
    var angleCos = $02eb7bb47d256bbb$var$dir.dot($02eb7bb47d256bbb$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
        $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr); // Calculate new projected length with limited minTurnAngle and get the new connect point
        $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI - minTurnAngle)); // Limit the new calculated connect point between pt1 and pt2.
        var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
        else if (t > 1) (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
        $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $02eb7bb47d256bbb$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
    $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
    $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
    (0, $bMDnR.default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0);
    (0, $bMDnR.default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
    var len1 = $02eb7bb47d256bbb$var$dir.len();
    var len2 = $02eb7bb47d256bbb$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $02eb7bb47d256bbb$var$dir.scale(1 / len1);
    $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
    var angleCos = $02eb7bb47d256bbb$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
        $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($02eb7bb47d256bbb$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI / 2 - newAngle)); // Limit the new calculated connect point between pt1 and pt2.
            var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
            else if (t > 1) (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
        }
        $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $02eb7bb47d256bbb$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === 'normal';
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName); // Make sure display.
    stateObj.ignore = ignore; // Set smooth
    var smooth = stateModel.get('smooth');
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel('lineStyle').getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $02eb7bb47d256bbb$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $eLEew.dist(points[0], points[1]);
        var len2 = $eLEew.dist(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $eLEew.lerp([], points[1], points[0], moveLen / len1);
        var midPoint2 = $eLEew.lerp([], points[1], points[2], moveLen / len2);
        var midPoint1 = $eLEew.lerp([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $02eb7bb47d256bbb$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get('show');
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $fIXXx.DISPLAY_STATES).length; i++){
        var stateName = (0, $fIXXx.DISPLAY_STATES)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === 'normal';
        if (stateModel) {
            var stateShow = stateModel.get('show');
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $bahqM.retrieve2)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $bahqM.retrieve2)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states.normal;
                if (stateObj) stateObj.ignore = true;
                continue;
            } // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $32bXc.default)();
                targetEl.setTextGuideLine(labelLine); // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $02eb7bb47d256bbb$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                 // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $02eb7bb47d256bbb$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $bahqM.defaults)(labelLine.style, defaultStyle); // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get('showAbove');
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false; // Custom the buildPath.
        labelLine.buildPath = $02eb7bb47d256bbb$var$buildLabelLinePath;
    }
}
function $02eb7bb47d256bbb$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || 'labelLine';
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}

});





parcelRegister("koMvQ", function(module, exports) {

$parcel$export(module.exports, "install", () => $ed9bae1f5fcebf9c$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9d3yg = parcelRequire("9d3yg");
function $ed9bae1f5fcebf9c$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('svg', (0, $9d3yg.default));
}

});
parcelRegister("9d3yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b481536a5986ad8$export$2e2bcd8739ae039);

var $dE0Hq = parcelRequire("dE0Hq");

var $bahqM = parcelRequire("bahqM");

var $ghQ8v = parcelRequire("ghQ8v");

var $gcbBH = parcelRequire("gcbBH");

var $45jlh = parcelRequire("45jlh");

var $iN8gp = parcelRequire("iN8gp");

var $9mQ8G = parcelRequire("9mQ8G");

var $brSrY = parcelRequire("brSrY");

var $i53xG = parcelRequire("i53xG");

var $b6V4m = parcelRequire("b6V4m");

var $k0bb8 = parcelRequire("k0bb8");
function $6b481536a5986ad8$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $6b481536a5986ad8$var$getSvgProxy(el) {
    if (el instanceof (0, $ghQ8v.default)) return 0, $k0bb8.path;
    else if (el instanceof (0, $gcbBH.default)) return 0, $k0bb8.image;
    else if (el instanceof (0, $45jlh.default)) return 0, $k0bb8.text;
    else return 0, $k0bb8.path;
}
function $6b481536a5986ad8$var$checkParentAvailable(parent, child) {
    return child && parent && child.parentNode !== parent;
}
function $6b481536a5986ad8$var$insertAfter(parent, child, prevSibling) {
    if ($6b481536a5986ad8$var$checkParentAvailable(parent, child) && prevSibling) {
        var nextSibling = prevSibling.nextSibling;
        nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
    }
}
function $6b481536a5986ad8$var$prepend(parent, child) {
    if ($6b481536a5986ad8$var$checkParentAvailable(parent, child)) {
        var firstChild = parent.firstChild;
        firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
    }
}
function $6b481536a5986ad8$var$remove(parent, child) {
    if (child && parent && child.parentNode === parent) parent.removeChild(child);
}
function $6b481536a5986ad8$var$removeFromMyParent(child) {
    if (child && child.parentNode) child.parentNode.removeChild(child);
}
function $6b481536a5986ad8$var$getSvgElement(displayable) {
    return displayable.__svgEl;
}
var $6b481536a5986ad8$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts, zrId) {
        this.type = 'svg';
        this.refreshHover = $6b481536a5986ad8$var$createMethodNotSupport('refreshHover');
        this.pathToImage = $6b481536a5986ad8$var$createMethodNotSupport('pathToImage');
        this.configLayer = $6b481536a5986ad8$var$createMethodNotSupport('configLayer');
        this.root = root;
        this.storage = storage;
        this._opts = opts = $bahqM.extend({}, opts || {});
        var svgDom = (0, $dE0Hq.createElement)('svg');
        svgDom.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns', 'http://www.w3.org/2000/svg');
        svgDom.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
        svgDom.setAttribute('version', '1.1');
        svgDom.setAttribute('baseProfile', 'full');
        svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
        var bgRoot = (0, $dE0Hq.createElement)('g');
        svgDom.appendChild(bgRoot);
        var svgRoot = (0, $dE0Hq.createElement)('g');
        svgDom.appendChild(svgRoot);
        this._gradientManager = new (0, $9mQ8G.default)(zrId, svgRoot);
        this._patternManager = new (0, $brSrY.default)(zrId, svgRoot);
        this._clipPathManager = new (0, $i53xG.default)(zrId, svgRoot);
        this._shadowManager = new (0, $b6V4m.default)(zrId, svgRoot);
        var viewport = document.createElement('div');
        viewport.style.cssText = 'overflow:hidden;position:relative';
        this._svgDom = svgDom;
        this._svgRoot = svgRoot;
        this._backgroundRoot = bgRoot;
        this._viewport = viewport;
        root.appendChild(viewport);
        viewport.appendChild(svgDom);
        this.resize(opts.width, opts.height);
        this._visibleList = [];
    }
    SVGPainter.prototype.getType = function() {
        return 'svg';
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._svgRoot;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.refresh = function() {
        var list = this.storage.getDisplayList(true);
        this._paintList(list);
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._backgroundRoot && this._backgroundNode) this._backgroundRoot.removeChild(this._backgroundNode);
        var bgNode = (0, $dE0Hq.createElement)('rect');
        bgNode.setAttribute('width', this.getWidth());
        bgNode.setAttribute('height', this.getHeight());
        bgNode.setAttribute('x', 0);
        bgNode.setAttribute('y', 0);
        bgNode.setAttribute('id', 0);
        var _a = (0, $dE0Hq.normalizeColor)(backgroundColor), color = _a.color, opacity = _a.opacity;
        bgNode.setAttribute('fill', color);
        bgNode.setAttribute('fill-opacity', opacity);
        this._backgroundRoot.appendChild(bgNode);
        this._backgroundNode = bgNode;
    };
    SVGPainter.prototype.createSVGElement = function(tag) {
        return (0, $dE0Hq.createElement)(tag);
    };
    SVGPainter.prototype.paintOne = function(el) {
        var svgProxy = $6b481536a5986ad8$var$getSvgProxy(el);
        svgProxy && svgProxy.brush(el);
        return $6b481536a5986ad8$var$getSvgElement(el);
    };
    SVGPainter.prototype._paintList = function(list) {
        var gradientManager = this._gradientManager;
        var patternManager = this._patternManager;
        var clipPathManager = this._clipPathManager;
        var shadowManager = this._shadowManager;
        gradientManager.markAllUnused();
        patternManager.markAllUnused();
        clipPathManager.markAllUnused();
        shadowManager.markAllUnused();
        var svgRoot = this._svgRoot;
        var visibleList = this._visibleList;
        var listLen = list.length;
        var newVisibleList = [];
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            var svgProxy = $6b481536a5986ad8$var$getSvgProxy(displayable);
            var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
            if (!displayable.invisible) {
                if (displayable.__dirty || !svgElement) {
                    svgProxy && svgProxy.brush(displayable);
                    svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                    if (svgElement && displayable.style) {
                        gradientManager.update(displayable.style.fill);
                        gradientManager.update(displayable.style.stroke);
                        patternManager.update(displayable.style.fill);
                        patternManager.update(displayable.style.stroke);
                        shadowManager.update(svgElement, displayable);
                    }
                    displayable.__dirty = 0;
                }
                if (svgElement) newVisibleList.push(displayable);
            }
        }
        var diff = (0, $iN8gp.default)(visibleList, newVisibleList);
        var prevSvgElement;
        var topPrevSvgElement;
        for(var i = 0; i < diff.length; i++){
            var item = diff[i];
            if (item.removed) for(var k = 0; k < item.count; k++){
                var displayable = visibleList[item.indices[k]];
                var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                (0, $i53xG.hasClipPath)(displayable) ? $6b481536a5986ad8$var$removeFromMyParent(svgElement) : $6b481536a5986ad8$var$remove(svgRoot, svgElement);
            }
        }
        var prevDisplayable;
        var currentClipGroup;
        for(var i = 0; i < diff.length; i++){
            var item = diff[i];
            if (item.removed) continue;
            for(var k = 0; k < item.count; k++){
                var displayable = newVisibleList[item.indices[k]];
                var clipGroup = clipPathManager.update(displayable, prevDisplayable);
                if (clipGroup !== currentClipGroup) {
                    prevSvgElement = topPrevSvgElement;
                    if (clipGroup) {
                        prevSvgElement ? $6b481536a5986ad8$var$insertAfter(svgRoot, clipGroup, prevSvgElement) : $6b481536a5986ad8$var$prepend(svgRoot, clipGroup);
                        topPrevSvgElement = clipGroup;
                        prevSvgElement = null;
                    }
                    currentClipGroup = clipGroup;
                }
                var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                prevSvgElement ? $6b481536a5986ad8$var$insertAfter(currentClipGroup || svgRoot, svgElement, prevSvgElement) : $6b481536a5986ad8$var$prepend(currentClipGroup || svgRoot, svgElement);
                prevSvgElement = svgElement || prevSvgElement;
                if (!currentClipGroup) topPrevSvgElement = prevSvgElement;
                gradientManager.markUsed(displayable);
                gradientManager.addWithoutUpdate(svgElement, displayable);
                patternManager.markUsed(displayable);
                patternManager.addWithoutUpdate(svgElement, displayable);
                clipPathManager.markUsed(displayable);
                prevDisplayable = displayable;
            }
        }
        gradientManager.removeUnused();
        patternManager.removeUnused();
        clipPathManager.removeUnused();
        shadowManager.removeUnused();
        this._visibleList = newVisibleList;
    };
    SVGPainter.prototype.resize = function(width, height) {
        var viewport = this._viewport;
        viewport.style.display = 'none';
        var opts = this._opts;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        width = this._getSize(0);
        height = this._getSize(1);
        viewport.style.display = '';
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            var viewportStyle = viewport.style;
            viewportStyle.width = width + 'px';
            viewportStyle.height = height + 'px';
            var svgRoot = this._svgDom;
            svgRoot.setAttribute('width', width + '');
            svgRoot.setAttribute('height', height + '');
        }
        if (this._backgroundNode) {
            this._backgroundNode.setAttribute('width', width);
            this._backgroundNode.setAttribute('height', height);
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype._getSize = function(whIdx) {
        var opts = this._opts;
        var wh = [
            'width',
            'height'
        ][whIdx];
        var cwh = [
            'clientWidth',
            'clientHeight'
        ][whIdx];
        var plt = [
            'paddingLeft',
            'paddingTop'
        ][whIdx];
        var prb = [
            'paddingRight',
            'paddingBottom'
        ][whIdx];
        if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
        var root = this.root;
        var stl = document.defaultView.getComputedStyle(root);
        return (root[cwh] || $6b481536a5986ad8$var$parseInt10(stl[wh]) || $6b481536a5986ad8$var$parseInt10(root.style[wh])) - ($6b481536a5986ad8$var$parseInt10(stl[plt]) || 0) - ($6b481536a5986ad8$var$parseInt10(stl[prb]) || 0) | 0;
    };
    SVGPainter.prototype.dispose = function() {
        this.root.innerHTML = '';
        this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
    };
    SVGPainter.prototype.clear = function() {
        var viewportNode = this._viewport;
        if (viewportNode && viewportNode.parentNode) viewportNode.parentNode.removeChild(viewportNode);
    };
    SVGPainter.prototype.toDataURL = function() {
        this.refresh();
        var svgDom = this._svgDom;
        var outerHTML = svgDom.outerHTML || (svgDom.parentNode && svgDom.parentNode).innerHTML;
        var html = encodeURIComponent(outerHTML.replace(/></g, '>\n\r<'));
        return 'data:image/svg+xml;charset=UTF-8,' + html;
    };
    return SVGPainter;
}();
function $6b481536a5986ad8$var$createMethodNotSupport(method) {
    return function() {
        $bahqM.logError('In SVG mode painter not support method "' + method + '"');
    };
}
var $6b481536a5986ad8$export$2e2bcd8739ae039 = $6b481536a5986ad8$var$SVGPainter;

});
parcelRegister("dE0Hq", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $9eef8dacfbb7af72$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "normalizeColor", () => $9eef8dacfbb7af72$export$4cde5df63f53f473);

var $d6udH = parcelRequire("d6udH");
function $9eef8dacfbb7af72$export$c8a8987d4410bf2d(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
}
function $9eef8dacfbb7af72$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === 'transparent') color = 'none';
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = (0, $d6udH.parse)(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}

});

parcelRegister("iN8gp", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae3369130c6c165$export$2e2bcd8739ae039);
function $dae3369130c6c165$var$diff(oldArr, newArr, equals) {
    if (!equals) equals = function(a, b) {
        return a === b;
    };
    oldArr = oldArr.slice();
    newArr = newArr.slice();
    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var editLength = 1;
    var maxEditLength = newLen + oldLen;
    var bestPath = [
        {
            newPos: -1,
            components: []
        }
    ];
    var oldPos = $dae3369130c6c165$var$extractCommon(bestPath[0], newArr, oldArr, 0, equals);
    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
        var indices = [];
        for(var i = 0; i < newArr.length; i++)indices.push(i);
        return [
            {
                indices: indices,
                count: newArr.length,
                added: false,
                removed: false
            }
        ];
    }
    function execEditLength() {
        for(var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2){
            var basePath;
            var addPath = bestPath[diagonalPath - 1];
            var removePath = bestPath[diagonalPath + 1];
            var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
            if (addPath) bestPath[diagonalPath - 1] = undefined;
            var canAdd = addPath && addPath.newPos + 1 < newLen;
            var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
            if (!canAdd && !canRemove) {
                bestPath[diagonalPath] = undefined;
                continue;
            }
            if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
                basePath = $dae3369130c6c165$var$clonePath(removePath);
                $dae3369130c6c165$var$pushComponent(basePath.components, false, true);
            } else {
                basePath = addPath;
                basePath.newPos++;
                $dae3369130c6c165$var$pushComponent(basePath.components, true, false);
            }
            oldPos = $dae3369130c6c165$var$extractCommon(basePath, newArr, oldArr, diagonalPath, equals);
            if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) return $dae3369130c6c165$var$buildValues(basePath.components);
            else bestPath[diagonalPath] = basePath;
        }
        editLength++;
    }
    while(editLength <= maxEditLength){
        var ret = execEditLength();
        if (ret) return ret;
    }
}
function $dae3369130c6c165$var$extractCommon(basePath, newArr, oldArr, diagonalPath, equals) {
    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var newPos = basePath.newPos;
    var oldPos = newPos - diagonalPath;
    var commonCount = 0;
    while(newPos + 1 < newLen && oldPos + 1 < oldLen && equals(newArr[newPos + 1], oldArr[oldPos + 1])){
        newPos++;
        oldPos++;
        commonCount++;
    }
    if (commonCount) basePath.components.push({
        count: commonCount,
        added: false,
        removed: false,
        indices: []
    });
    basePath.newPos = newPos;
    return oldPos;
}
function $dae3369130c6c165$var$pushComponent(components, added, removed) {
    var last = components[components.length - 1];
    if (last && last.added === added && last.removed === removed) components[components.length - 1] = {
        count: last.count + 1,
        added: added,
        removed: removed,
        indices: []
    };
    else components.push({
        count: 1,
        added: added,
        removed: removed,
        indices: []
    });
}
function $dae3369130c6c165$var$buildValues(components) {
    var componentPos = 0;
    var componentLen = components.length;
    var newPos = 0;
    var oldPos = 0;
    for(; componentPos < componentLen; componentPos++){
        var component = components[componentPos];
        if (!component.removed) {
            var indices = [];
            for(var i = newPos; i < newPos + component.count; i++)indices.push(i);
            component.indices = indices;
            newPos += component.count;
            if (!component.added) oldPos += component.count;
        } else {
            for(var i = oldPos; i < oldPos + component.count; i++)component.indices.push(i);
            oldPos += component.count;
        }
    }
    return components;
}
function $dae3369130c6c165$var$clonePath(path) {
    return {
        newPos: path.newPos,
        components: path.components.slice(0)
    };
}
function $dae3369130c6c165$export$2e2bcd8739ae039(oldArr, newArr, equal) {
    return $dae3369130c6c165$var$diff(oldArr, newArr, equal);
}

});

parcelRegister("9mQ8G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d1e9cd7c4fb6054$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $akOIm = parcelRequire("akOIm");

var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");
function $6d1e9cd7c4fb6054$var$isLinearGradient(value) {
    return value.type === 'linear';
}
function $6d1e9cd7c4fb6054$var$isRadialGradient(value) {
    return value.type === 'radial';
}
function $6d1e9cd7c4fb6054$var$isGradient(value) {
    return value && (value.type === 'linear' || value.type === 'radial');
}
var $6d1e9cd7c4fb6054$var$GradientManager = function(_super) {
    (0, $3VFsf.__extends)(GradientManager, _super);
    function GradientManager(zrId, svgRoot) {
        return _super.call(this, zrId, svgRoot, [
            'linearGradient',
            'radialGradient'
        ], '__gradient_in_use__') || this;
    }
    GradientManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
        if (displayable && displayable.style) {
            var that_1 = this;
            $bahqM.each([
                'fill',
                'stroke'
            ], function(fillOrStroke) {
                var value = displayable.style[fillOrStroke];
                if ($6d1e9cd7c4fb6054$var$isGradient(value)) {
                    var gradient = value;
                    var defs = that_1.getDefs(true);
                    var dom = void 0;
                    if (gradient.__dom) {
                        dom = gradient.__dom;
                        if (!defs.contains(gradient.__dom)) that_1.addDom(dom);
                    } else dom = that_1.add(gradient);
                    that_1.markUsed(displayable);
                    var id = dom.getAttribute('id');
                    svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
                }
            });
        }
    };
    GradientManager.prototype.add = function(gradient) {
        var dom;
        if ($6d1e9cd7c4fb6054$var$isLinearGradient(gradient)) dom = this.createElement('linearGradient');
        else if ($6d1e9cd7c4fb6054$var$isRadialGradient(gradient)) dom = this.createElement('radialGradient');
        else {
            $bahqM.logError('Illegal gradient type.');
            return null;
        }
        gradient.id = gradient.id || this.nextId++;
        dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
        this.updateDom(gradient, dom);
        this.addDom(dom);
        return dom;
    };
    GradientManager.prototype.update = function(gradient) {
        if (!$6d1e9cd7c4fb6054$var$isGradient(gradient)) return;
        var that = this;
        this.doUpdate(gradient, function() {
            var dom = gradient.__dom;
            if (!dom) return;
            var tagName = dom.tagName;
            var type = gradient.type;
            if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') that.updateDom(gradient, gradient.__dom);
            else {
                that.removeDom(gradient);
                that.add(gradient);
            }
        });
    };
    GradientManager.prototype.updateDom = function(gradient, dom) {
        if ($6d1e9cd7c4fb6054$var$isLinearGradient(gradient)) {
            dom.setAttribute('x1', gradient.x + '');
            dom.setAttribute('y1', gradient.y + '');
            dom.setAttribute('x2', gradient.x2 + '');
            dom.setAttribute('y2', gradient.y2 + '');
        } else if ($6d1e9cd7c4fb6054$var$isRadialGradient(gradient)) {
            dom.setAttribute('cx', gradient.x + '');
            dom.setAttribute('cy', gradient.y + '');
            dom.setAttribute('r', gradient.r + '');
        } else {
            $bahqM.logError('Illegal gradient type.');
            return;
        }
        if (gradient.global) dom.setAttribute('gradientUnits', 'userSpaceOnUse');
        else dom.setAttribute('gradientUnits', 'objectBoundingBox');
        dom.innerHTML = '';
        var colors = gradient.colorStops;
        for(var i = 0, len = colors.length; i < len; ++i){
            var stop_1 = this.createElement('stop');
            stop_1.setAttribute('offset', colors[i].offset * 100 + '%');
            var color = colors[i].color;
            if (color.indexOf('rgba') > -1) {
                var opacity = $d6udH.parse(color)[3];
                var hex = $d6udH.toHex(color);
                stop_1.setAttribute('stop-color', '#' + hex);
                stop_1.setAttribute('stop-opacity', opacity + '');
            } else stop_1.setAttribute('stop-color', colors[i].color);
            dom.appendChild(stop_1);
        }
        gradient.__dom = dom;
    };
    GradientManager.prototype.markUsed = function(displayable) {
        if (displayable.style) {
            var gradient = displayable.style.fill;
            if (gradient && gradient.__dom) _super.prototype.markDomUsed.call(this, gradient.__dom);
            gradient = displayable.style.stroke;
            if (gradient && gradient.__dom) _super.prototype.markDomUsed.call(this, gradient.__dom);
        }
    };
    return GradientManager;
}((0, $akOIm.default));
var $6d1e9cd7c4fb6054$export$2e2bcd8739ae039 = $6d1e9cd7c4fb6054$var$GradientManager;

});
parcelRegister("akOIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $78631c76dc8428b5$export$2e2bcd8739ae039);

var $dE0Hq = parcelRequire("dE0Hq");

var $bahqM = parcelRequire("bahqM");

var $ghQ8v = parcelRequire("ghQ8v");

var $gcbBH = parcelRequire("gcbBH");

var $45jlh = parcelRequire("45jlh");

var $k0bb8 = parcelRequire("k0bb8");
var $78631c76dc8428b5$var$MARK_UNUSED = '0';
var $78631c76dc8428b5$var$MARK_USED = '1';
var $78631c76dc8428b5$var$Definable = function() {
    function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
        this.nextId = 0;
        this._domName = '_dom';
        this.createElement = (0, $dE0Hq.createElement);
        this._zrId = zrId;
        this._svgRoot = svgRoot;
        this._tagNames = typeof tagNames === 'string' ? [
            tagNames
        ] : tagNames;
        this._markLabel = markLabel;
        if (domName) this._domName = domName;
    }
    Definable.prototype.getDefs = function(isForceCreating) {
        var svgRoot = this._svgRoot;
        var defs = this._svgRoot.getElementsByTagName('defs');
        if (defs.length === 0) {
            if (isForceCreating) {
                var defs_1 = svgRoot.insertBefore(this.createElement('defs'), svgRoot.firstChild);
                if (!defs_1.contains) defs_1.contains = function(el) {
                    var children = defs_1.children;
                    if (!children) return false;
                    for(var i = children.length - 1; i >= 0; --i){
                        if (children[i] === el) return true;
                    }
                    return false;
                };
                return defs_1;
            } else return null;
        } else return defs[0];
    };
    Definable.prototype.doUpdate = function(target, onUpdate) {
        if (!target) return;
        var defs = this.getDefs(false);
        if (target[this._domName] && defs.contains(target[this._domName])) {
            if (typeof onUpdate === 'function') onUpdate(target);
        } else {
            var dom = this.add(target);
            if (dom) target[this._domName] = dom;
        }
    };
    Definable.prototype.add = function(target) {
        return null;
    };
    Definable.prototype.addDom = function(dom) {
        var defs = this.getDefs(true);
        if (dom.parentNode !== defs) defs.appendChild(dom);
    };
    Definable.prototype.removeDom = function(target) {
        var defs = this.getDefs(false);
        if (defs && target[this._domName]) {
            defs.removeChild(target[this._domName]);
            target[this._domName] = null;
        }
    };
    Definable.prototype.getDoms = function() {
        var defs = this.getDefs(false);
        if (!defs) return [];
        var doms = [];
        $bahqM.each(this._tagNames, function(tagName) {
            var tags = defs.getElementsByTagName(tagName);
            for(var i = 0; i < tags.length; i++)doms.push(tags[i]);
        });
        return doms;
    };
    Definable.prototype.markAllUnused = function() {
        var doms = this.getDoms();
        var that = this;
        $bahqM.each(doms, function(dom) {
            dom[that._markLabel] = $78631c76dc8428b5$var$MARK_UNUSED;
        });
    };
    Definable.prototype.markDomUsed = function(dom) {
        dom && (dom[this._markLabel] = $78631c76dc8428b5$var$MARK_USED);
    };
    Definable.prototype.markDomUnused = function(dom) {
        dom && (dom[this._markLabel] = $78631c76dc8428b5$var$MARK_UNUSED);
    };
    Definable.prototype.isDomUnused = function(dom) {
        return dom && dom[this._markLabel] !== $78631c76dc8428b5$var$MARK_USED;
    };
    Definable.prototype.removeUnused = function() {
        var _this = this;
        var defs = this.getDefs(false);
        if (!defs) return;
        var doms = this.getDoms();
        $bahqM.each(doms, function(dom) {
            if (_this.isDomUnused(dom)) defs.removeChild(dom);
        });
    };
    Definable.prototype.getSvgProxy = function(displayable) {
        if (displayable instanceof (0, $ghQ8v.default)) return 0, $k0bb8.path;
        else if (displayable instanceof (0, $gcbBH.default)) return 0, $k0bb8.image;
        else if (displayable instanceof (0, $45jlh.default)) return 0, $k0bb8.text;
        else return 0, $k0bb8.path;
    };
    Definable.prototype.getSvgElement = function(displayable) {
        return displayable.__svgEl;
    };
    return Definable;
}();
var $78631c76dc8428b5$export$2e2bcd8739ae039 = $78631c76dc8428b5$var$Definable;

});
parcelRegister("k0bb8", function(module, exports) {

$parcel$export(module.exports, "path", () => $e8fc7a90186e67dc$export$bb654e07daaf8c3a);
$parcel$export(module.exports, "image", () => $e8fc7a90186e67dc$export$5c452ff88e35e47d);
$parcel$export(module.exports, "text", () => $e8fc7a90186e67dc$export$6f093cfa640b7166);

var $dE0Hq = parcelRequire("dE0Hq");

var $gcbBH = parcelRequire("gcbBH");

var $b7ZX8 = parcelRequire("b7ZX8");

var $bahqM = parcelRequire("bahqM");

var $cpB91 = parcelRequire("cpB91");
var $e8fc7a90186e67dc$var$NONE = 'none';
var $e8fc7a90186e67dc$var$mathRound = Math.round;
var $e8fc7a90186e67dc$var$mathSin = Math.sin;
var $e8fc7a90186e67dc$var$mathCos = Math.cos;
var $e8fc7a90186e67dc$var$PI = Math.PI;
var $e8fc7a90186e67dc$var$PI2 = Math.PI * 2;
var $e8fc7a90186e67dc$var$degree = 180 / $e8fc7a90186e67dc$var$PI;
var $e8fc7a90186e67dc$var$EPSILON = 1e-4;
function $e8fc7a90186e67dc$var$round3(val) {
    return $e8fc7a90186e67dc$var$mathRound(val * 1e3) / 1e3;
}
function $e8fc7a90186e67dc$var$round4(val) {
    return $e8fc7a90186e67dc$var$mathRound(val * 1e4) / 1e4;
}
function $e8fc7a90186e67dc$var$isAroundZero(val) {
    return val < $e8fc7a90186e67dc$var$EPSILON && val > -$e8fc7a90186e67dc$var$EPSILON;
}
function $e8fc7a90186e67dc$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $e8fc7a90186e67dc$var$NONE;
}
function $e8fc7a90186e67dc$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $e8fc7a90186e67dc$var$NONE;
}
function $e8fc7a90186e67dc$var$setTransform(svgEl, m) {
    if (m) $e8fc7a90186e67dc$var$attr(svgEl, 'transform', 'matrix(' + $e8fc7a90186e67dc$var$round3(m[0]) + ',' + $e8fc7a90186e67dc$var$round3(m[1]) + ',' + $e8fc7a90186e67dc$var$round3(m[2]) + ',' + $e8fc7a90186e67dc$var$round3(m[3]) + ',' + $e8fc7a90186e67dc$var$round4(m[4]) + ',' + $e8fc7a90186e67dc$var$round4(m[5]) + ')');
}
function $e8fc7a90186e67dc$var$attr(el, key, val) {
    if (!val || val.type !== 'linear' && val.type !== 'radial') el.setAttribute(key, val);
}
function $e8fc7a90186e67dc$var$attrXLink(el, key, val) {
    el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
}
function $e8fc7a90186e67dc$var$attrXML(el, key, val) {
    el.setAttributeNS('http://www.w3.org/XML/1998/namespace', key, val);
}
function $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $gcbBH.default)) {
        $e8fc7a90186e67dc$var$attr(svgEl, 'opacity', opacity + '');
        return;
    }
    if ($e8fc7a90186e67dc$var$pathHasFill(style)) {
        var fill = (0, $dE0Hq.normalizeColor)(style.fill);
        $e8fc7a90186e67dc$var$attr(svgEl, 'fill', fill.color);
        $e8fc7a90186e67dc$var$attr(svgEl, 'fill-opacity', (style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity) + '');
    } else $e8fc7a90186e67dc$var$attr(svgEl, 'fill', $e8fc7a90186e67dc$var$NONE);
    if ($e8fc7a90186e67dc$var$pathHasStroke(style)) {
        var stroke = (0, $dE0Hq.normalizeColor)(style.stroke);
        $e8fc7a90186e67dc$var$attr(svgEl, 'stroke', stroke.color);
        var strokeWidth = style.lineWidth;
        var strokeScale_1 = style.strokeNoScale ? el.getLineScale() : 1;
        $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-width', (strokeScale_1 ? strokeWidth / strokeScale_1 : 0) + '');
        $e8fc7a90186e67dc$var$attr(svgEl, 'paint-order', style.strokeFirst ? 'stroke' : 'fill');
        $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-opacity', (style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity) + '');
        var lineDash = style.lineDash && strokeWidth > 0 && (0, $cpB91.normalizeLineDash)(style.lineDash, strokeWidth);
        if (lineDash) {
            var lineDashOffset = style.lineDashOffset;
            if (strokeScale_1 && strokeScale_1 !== 1) {
                lineDash = (0, $bahqM.map)(lineDash, function(rawVal) {
                    return rawVal / strokeScale_1;
                });
                if (lineDashOffset) {
                    lineDashOffset /= strokeScale_1;
                    lineDashOffset = $e8fc7a90186e67dc$var$mathRound(lineDashOffset);
                }
            }
            $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dasharray', lineDash.join(','));
            $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dashoffset', (lineDashOffset || 0) + '');
        } else $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dasharray', $e8fc7a90186e67dc$var$NONE);
        style.lineCap && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-linecap', style.lineCap);
        style.lineJoin && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-linejoin', style.lineJoin);
        style.miterLimit && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-miterlimit', style.miterLimit + '');
    } else $e8fc7a90186e67dc$var$attr(svgEl, 'stroke', $e8fc7a90186e67dc$var$NONE);
}
var $e8fc7a90186e67dc$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function() {
        this._d = [];
        this._str = '';
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var firstCmd = this._d.length === 0;
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = $e8fc7a90186e67dc$var$isAroundZero(dThetaPositive - $e8fc7a90186e67dc$var$PI2) || (clockwise ? dTheta >= $e8fc7a90186e67dc$var$PI2 : -dTheta >= $e8fc7a90186e67dc$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $e8fc7a90186e67dc$var$PI2 : dTheta % $e8fc7a90186e67dc$var$PI2 + $e8fc7a90186e67dc$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ($e8fc7a90186e67dc$var$isAroundZero(dThetaPositive)) large = false;
        else large = unifiedTheta >= $e8fc7a90186e67dc$var$PI === !!clockwise;
        var x0 = $e8fc7a90186e67dc$var$round4(cx + rx * $e8fc7a90186e67dc$var$mathCos(startAngle));
        var y0 = $e8fc7a90186e67dc$var$round4(cy + ry * $e8fc7a90186e67dc$var$mathSin(startAngle));
        if (isCircle) {
            if (clockwise) dTheta = $e8fc7a90186e67dc$var$PI2 - 1e-4;
            else dTheta = -$e8fc7a90186e67dc$var$PI2 + 1e-4;
            large = true;
            if (firstCmd) this._d.push('M', x0, y0);
        }
        var x = $e8fc7a90186e67dc$var$round4(cx + rx * $e8fc7a90186e67dc$var$mathCos(startAngle + dTheta));
        var y = $e8fc7a90186e67dc$var$round4(cy + ry * $e8fc7a90186e67dc$var$mathSin(startAngle + dTheta));
        if (isNaN(x0) || isNaN(y0) || isNaN(rx) || isNaN(ry) || isNaN(psi) || isNaN($e8fc7a90186e67dc$var$degree) || isNaN(x) || isNaN(y)) return '';
        this._d.push('A', $e8fc7a90186e67dc$var$round4(rx), $e8fc7a90186e67dc$var$round4(ry), $e8fc7a90186e67dc$var$mathRound(psi * $e8fc7a90186e67dc$var$degree), +large, +clockwise, x, y);
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add('M', x, y);
        this._add('L', x + w, y);
        this._add('L', x + w, y + h);
        this._add('L', x, y + h);
        this._add('L', x, y);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add('Z');
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        this._d.push(cmd);
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            this._d.push($e8fc7a90186e67dc$var$round4(val));
        }
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? '' : this._d.join(' ');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $e8fc7a90186e67dc$export$bb654e07daaf8c3a = {
    brush: function(el) {
        var style = el.style;
        var svgEl = el.__svgEl;
        if (!svgEl) {
            svgEl = (0, $dE0Hq.createElement)('path');
            el.__svgEl = svgEl;
        }
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (el.shapeChanged()) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || el.style.strokePercent < 1) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new $e8fc7a90186e67dc$var$SVGPathRebuilder();
            svgPathBuilder.reset();
            path.rebuildPath(svgPathBuilder, el.style.strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
        }
        $e8fc7a90186e67dc$var$attr(svgEl, 'd', svgPathBuilder.getStr());
        $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el);
        $e8fc7a90186e67dc$var$setTransform(svgEl, el.transform);
    }
};
var $e8fc7a90186e67dc$export$5c452ff88e35e47d = {
    brush: function(el) {
        var style = el.style;
        var image = style.image;
        if (image instanceof HTMLImageElement) image = image.src;
        else if (image instanceof HTMLCanvasElement) image = image.toDataURL();
        if (!image) return;
        var x = style.x || 0;
        var y = style.y || 0;
        var dw = style.width;
        var dh = style.height;
        var svgEl = el.__svgEl;
        if (!svgEl) {
            svgEl = (0, $dE0Hq.createElement)('image');
            el.__svgEl = svgEl;
        }
        if (image !== el.__imageSrc) {
            $e8fc7a90186e67dc$var$attrXLink(svgEl, 'href', image);
            el.__imageSrc = image;
        }
        $e8fc7a90186e67dc$var$attr(svgEl, 'width', dw + '');
        $e8fc7a90186e67dc$var$attr(svgEl, 'height', dh + '');
        $e8fc7a90186e67dc$var$attr(svgEl, 'x', x + '');
        $e8fc7a90186e67dc$var$attr(svgEl, 'y', y + '');
        $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el);
        $e8fc7a90186e67dc$var$setTransform(svgEl, el.transform);
    }
};
var $e8fc7a90186e67dc$var$TEXT_ALIGN_TO_ANCHOR = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function $e8fc7a90186e67dc$var$adjustTextY(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') y += lineHeight / 2;
    else if (textBaseline === 'bottom') y -= lineHeight / 2;
    return y;
}
var $e8fc7a90186e67dc$export$6f093cfa640b7166 = {
    brush: function(el) {
        var style = el.style;
        var text = style.text;
        text != null && (text += '');
        if (!text || isNaN(style.x) || isNaN(style.y)) return;
        var textSvgEl = el.__svgEl;
        if (!textSvgEl) {
            textSvgEl = (0, $dE0Hq.createElement)('text');
            $e8fc7a90186e67dc$var$attrXML(textSvgEl, 'xml:space', 'preserve');
            el.__svgEl = textSvgEl;
        }
        var font = style.font || (0, $b7ZX8.DEFAULT_FONT);
        var textSvgElStyle = textSvgEl.style;
        textSvgElStyle.font = font;
        textSvgEl.textContent = text;
        $e8fc7a90186e67dc$var$bindStyle(textSvgEl, style, el);
        $e8fc7a90186e67dc$var$setTransform(textSvgEl, el.transform);
        var x = style.x || 0;
        var y = $e8fc7a90186e67dc$var$adjustTextY(style.y || 0, (0, $b7ZX8.getLineHeight)(font), style.textBaseline);
        var textAlign = $e8fc7a90186e67dc$var$TEXT_ALIGN_TO_ANCHOR[style.textAlign] || style.textAlign;
        $e8fc7a90186e67dc$var$attr(textSvgEl, 'dominant-baseline', 'central');
        $e8fc7a90186e67dc$var$attr(textSvgEl, 'text-anchor', textAlign);
        $e8fc7a90186e67dc$var$attr(textSvgEl, 'x', x + '');
        $e8fc7a90186e67dc$var$attr(textSvgEl, 'y', y + '');
    }
};

});



parcelRegister("brSrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $855c73ff662bd5dc$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $akOIm = parcelRequire("akOIm");

var $bahqM = parcelRequire("bahqM");

var $63nvx = parcelRequire("63nvx");

var $822uQ = parcelRequire("822uQ");
function $855c73ff662bd5dc$var$isPattern(value) {
    return value && (!!value.image || !!value.svgElement);
}
var $855c73ff662bd5dc$var$patternDomMap = new (0, $822uQ.default)();
var $855c73ff662bd5dc$var$PatternManager = function(_super) {
    (0, $3VFsf.__extends)(PatternManager, _super);
    function PatternManager(zrId, svgRoot) {
        return _super.call(this, zrId, svgRoot, [
            'pattern'
        ], '__pattern_in_use__') || this;
    }
    PatternManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
        if (displayable && displayable.style) {
            var that_1 = this;
            $bahqM.each([
                'fill',
                'stroke'
            ], function(fillOrStroke) {
                var pattern = displayable.style[fillOrStroke];
                if ($855c73ff662bd5dc$var$isPattern(pattern)) {
                    var defs = that_1.getDefs(true);
                    var dom = $855c73ff662bd5dc$var$patternDomMap.get(pattern);
                    if (dom) {
                        if (!defs.contains(dom)) that_1.addDom(dom);
                    } else dom = that_1.add(pattern);
                    that_1.markUsed(displayable);
                    var id = dom.getAttribute('id');
                    svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
                }
            });
        }
    };
    PatternManager.prototype.add = function(pattern) {
        if (!$855c73ff662bd5dc$var$isPattern(pattern)) return;
        var dom = this.createElement('pattern');
        pattern.id = pattern.id == null ? this.nextId++ : pattern.id;
        dom.setAttribute('id', 'zr' + this._zrId + '-pattern-' + pattern.id);
        dom.setAttribute('x', '0');
        dom.setAttribute('y', '0');
        dom.setAttribute('patternUnits', 'userSpaceOnUse');
        this.updateDom(pattern, dom);
        this.addDom(dom);
        return dom;
    };
    PatternManager.prototype.update = function(pattern) {
        if (!$855c73ff662bd5dc$var$isPattern(pattern)) return;
        var that = this;
        this.doUpdate(pattern, function() {
            var dom = $855c73ff662bd5dc$var$patternDomMap.get(pattern);
            that.updateDom(pattern, dom);
        });
    };
    PatternManager.prototype.updateDom = function(pattern, patternDom) {
        var svgElement = pattern.svgElement;
        if (svgElement instanceof SVGElement) {
            if (svgElement.parentNode !== patternDom) {
                patternDom.innerHTML = '';
                patternDom.appendChild(svgElement);
                patternDom.setAttribute('width', pattern.svgWidth + '');
                patternDom.setAttribute('height', pattern.svgHeight + '');
            }
        } else {
            var img = void 0;
            var prevImage = patternDom.getElementsByTagName('image');
            if (prevImage.length) {
                if (pattern.image) img = prevImage[0];
                else {
                    patternDom.removeChild(prevImage[0]);
                    return;
                }
            } else if (pattern.image) img = this.createElement('image');
            if (img) {
                var imageSrc = void 0;
                var patternImage = pattern.image;
                if (typeof patternImage === 'string') imageSrc = patternImage;
                else if (patternImage instanceof HTMLImageElement) imageSrc = patternImage.src;
                else if (patternImage instanceof HTMLCanvasElement) imageSrc = patternImage.toDataURL();
                if (imageSrc) {
                    img.setAttribute('href', imageSrc);
                    img.setAttribute('x', '0');
                    img.setAttribute('y', '0');
                    var hostEl = {
                        dirty: function() {}
                    };
                    var createdImage = (0, $63nvx.createOrUpdateImage)(imageSrc, img, hostEl, function(img) {
                        patternDom.setAttribute('width', img.width + '');
                        patternDom.setAttribute('height', img.height + '');
                    });
                    if (createdImage && createdImage.width && createdImage.height) {
                        patternDom.setAttribute('width', createdImage.width + '');
                        patternDom.setAttribute('height', createdImage.height + '');
                    }
                    patternDom.appendChild(img);
                }
            }
        }
        var x = pattern.x || 0;
        var y = pattern.y || 0;
        var rotation = (pattern.rotation || 0) / Math.PI * 180;
        var scaleX = pattern.scaleX || 1;
        var scaleY = pattern.scaleY || 1;
        var transform = "translate(" + x + ", " + y + ") rotate(" + rotation + ") scale(" + scaleX + ", " + scaleY + ")";
        patternDom.setAttribute('patternTransform', transform);
        $855c73ff662bd5dc$var$patternDomMap.set(pattern, patternDom);
    };
    PatternManager.prototype.markUsed = function(displayable) {
        if (displayable.style) {
            if ($855c73ff662bd5dc$var$isPattern(displayable.style.fill)) _super.prototype.markDomUsed.call(this, $855c73ff662bd5dc$var$patternDomMap.get(displayable.style.fill));
            if ($855c73ff662bd5dc$var$isPattern(displayable.style.stroke)) _super.prototype.markDomUsed.call(this, $855c73ff662bd5dc$var$patternDomMap.get(displayable.style.stroke));
        }
    };
    return PatternManager;
}((0, $akOIm.default));
var $855c73ff662bd5dc$export$2e2bcd8739ae039 = $855c73ff662bd5dc$var$PatternManager;

});

parcelRegister("i53xG", function(module, exports) {

$parcel$export(module.exports, "hasClipPath", () => $d29b710c2ddb799a$export$3918818844b1239b);
$parcel$export(module.exports, "default", () => $d29b710c2ddb799a$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $akOIm = parcelRequire("akOIm");

var $bahqM = parcelRequire("bahqM");

var $dPYp9 = parcelRequire("dPYp9");
function $d29b710c2ddb799a$var$generateClipPathsKey(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(',');
}
function $d29b710c2ddb799a$export$3918818844b1239b(displayable) {
    var clipPaths = displayable.__clipPaths;
    return clipPaths && clipPaths.length > 0;
}
var $d29b710c2ddb799a$var$ClippathManager = function(_super) {
    (0, $3VFsf.__extends)(ClippathManager, _super);
    function ClippathManager(zrId, svgRoot) {
        var _this = _super.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__') || this;
        _this._refGroups = {};
        _this._keyDuplicateCount = {};
        return _this;
    }
    ClippathManager.prototype.markAllUnused = function() {
        _super.prototype.markAllUnused.call(this);
        var refGroups = this._refGroups;
        for(var key in refGroups)if (refGroups.hasOwnProperty(key)) this.markDomUnused(refGroups[key]);
        this._keyDuplicateCount = {};
    };
    ClippathManager.prototype._getClipPathGroup = function(displayable, prevDisplayable) {
        if (!$d29b710c2ddb799a$export$3918818844b1239b(displayable)) return;
        var clipPaths = displayable.__clipPaths;
        var keyDuplicateCount = this._keyDuplicateCount;
        var clipPathKey = $d29b710c2ddb799a$var$generateClipPathsKey(clipPaths);
        if ((0, $dPYp9.isClipPathChanged)(clipPaths, prevDisplayable && prevDisplayable.__clipPaths)) {
            keyDuplicateCount[clipPathKey] = keyDuplicateCount[clipPathKey] || 0;
            keyDuplicateCount[clipPathKey] && (clipPathKey += '-' + keyDuplicateCount[clipPathKey]);
            keyDuplicateCount[clipPathKey]++;
        }
        return this._refGroups[clipPathKey] || (this._refGroups[clipPathKey] = this.createElement('g'));
    };
    ClippathManager.prototype.update = function(displayable, prevDisplayable) {
        var clipGroup = this._getClipPathGroup(displayable, prevDisplayable);
        if (clipGroup) {
            this.markDomUsed(clipGroup);
            this.updateDom(clipGroup, displayable.__clipPaths);
        }
        return clipGroup;
    };
    ClippathManager.prototype.updateDom = function(parentEl, clipPaths) {
        if (clipPaths && clipPaths.length > 0) {
            var defs = this.getDefs(true);
            var clipPath = clipPaths[0];
            var clipPathEl = void 0;
            var id = void 0;
            if (clipPath._dom) {
                id = clipPath._dom.getAttribute('id');
                clipPathEl = clipPath._dom;
                if (!defs.contains(clipPathEl)) defs.appendChild(clipPathEl);
            } else {
                id = 'zr' + this._zrId + '-clip-' + this.nextId;
                ++this.nextId;
                clipPathEl = this.createElement('clipPath');
                clipPathEl.setAttribute('id', id);
                defs.appendChild(clipPathEl);
                clipPath._dom = clipPathEl;
            }
            var svgProxy = this.getSvgProxy(clipPath);
            svgProxy.brush(clipPath);
            var pathEl = this.getSvgElement(clipPath);
            clipPathEl.innerHTML = '';
            clipPathEl.appendChild(pathEl);
            parentEl.setAttribute('clip-path', 'url(#' + id + ')');
            if (clipPaths.length > 1) this.updateDom(clipPathEl, clipPaths.slice(1));
        } else if (parentEl) parentEl.setAttribute('clip-path', 'none');
    };
    ClippathManager.prototype.markUsed = function(displayable) {
        var _this = this;
        if (displayable.__clipPaths) $bahqM.each(displayable.__clipPaths, function(clipPath) {
            if (clipPath._dom) _super.prototype.markDomUsed.call(_this, clipPath._dom);
        });
    };
    ClippathManager.prototype.removeUnused = function() {
        _super.prototype.removeUnused.call(this);
        var newRefGroupsMap = {};
        var refGroups = this._refGroups;
        for(var key in refGroups)if (refGroups.hasOwnProperty(key)) {
            var group = refGroups[key];
            if (!this.isDomUnused(group)) newRefGroupsMap[key] = group;
            else if (group.parentNode) group.parentNode.removeChild(group);
        }
        this._refGroups = newRefGroupsMap;
    };
    return ClippathManager;
}((0, $akOIm.default));
var $d29b710c2ddb799a$export$2e2bcd8739ae039 = $d29b710c2ddb799a$var$ClippathManager;

});

parcelRegister("b6V4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $816c8609515aa333$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $akOIm = parcelRequire("akOIm");

var $dE0Hq = parcelRequire("dE0Hq");
var $816c8609515aa333$var$ShadowManager = function(_super) {
    (0, $3VFsf.__extends)(ShadowManager, _super);
    function ShadowManager(zrId, svgRoot) {
        var _this = _super.call(this, zrId, svgRoot, [
            'filter'
        ], '__filter_in_use__', '_shadowDom') || this;
        _this._shadowDomMap = {};
        _this._shadowDomPool = [];
        return _this;
    }
    ShadowManager.prototype._getFromPool = function() {
        var shadowDom = this._shadowDomPool.pop();
        if (!shadowDom) {
            shadowDom = this.createElement('filter');
            shadowDom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + this.nextId++);
            var domChild = this.createElement('feDropShadow');
            shadowDom.appendChild(domChild);
            this.addDom(shadowDom);
        }
        return shadowDom;
    };
    ShadowManager.prototype.update = function(svgElement, displayable) {
        var style = displayable.style;
        if ($816c8609515aa333$var$hasShadow(style)) {
            var shadowKey = $816c8609515aa333$var$getShadowKey(displayable);
            var shadowDom = displayable._shadowDom = this._shadowDomMap[shadowKey];
            if (!shadowDom) {
                shadowDom = this._getFromPool();
                this._shadowDomMap[shadowKey] = shadowDom;
            }
            this.updateDom(svgElement, displayable, shadowDom);
        } else this.remove(svgElement, displayable);
    };
    ShadowManager.prototype.remove = function(svgElement, displayable) {
        if (displayable._shadowDom != null) {
            displayable._shadowDom = null;
            svgElement.removeAttribute('filter');
        }
    };
    ShadowManager.prototype.updateDom = function(svgElement, displayable, shadowDom) {
        var domChild = shadowDom.children[0];
        var style = displayable.style;
        var globalScale = displayable.getGlobalScale();
        var scaleX = globalScale[0];
        var scaleY = globalScale[1];
        if (!scaleX || !scaleY) return;
        var offsetX = style.shadowOffsetX || 0;
        var offsetY = style.shadowOffsetY || 0;
        var blur = style.shadowBlur;
        var normalizedColor = (0, $dE0Hq.normalizeColor)(style.shadowColor);
        domChild.setAttribute('dx', offsetX / scaleX + '');
        domChild.setAttribute('dy', offsetY / scaleY + '');
        domChild.setAttribute('flood-color', normalizedColor.color);
        domChild.setAttribute('flood-opacity', normalizedColor.opacity + '');
        var stdDx = blur / 2 / scaleX;
        var stdDy = blur / 2 / scaleY;
        var stdDeviation = stdDx + ' ' + stdDy;
        domChild.setAttribute('stdDeviation', stdDeviation);
        shadowDom.setAttribute('x', '-100%');
        shadowDom.setAttribute('y', '-100%');
        shadowDom.setAttribute('width', '300%');
        shadowDom.setAttribute('height', '300%');
        displayable._shadowDom = shadowDom;
        var id = shadowDom.getAttribute('id');
        svgElement.setAttribute('filter', 'url(#' + id + ')');
    };
    ShadowManager.prototype.removeUnused = function() {
        var defs = this.getDefs(false);
        if (!defs) return;
        var shadowDomsPool = this._shadowDomPool;
        var shadowDomMap = this._shadowDomMap;
        for(var key in shadowDomMap)if (shadowDomMap.hasOwnProperty(key)) shadowDomsPool.push(shadowDomMap[key]);
        this._shadowDomMap = {};
    };
    return ShadowManager;
}((0, $akOIm.default));
var $816c8609515aa333$export$2e2bcd8739ae039 = $816c8609515aa333$var$ShadowManager;
function $816c8609515aa333$var$hasShadow(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $816c8609515aa333$var$getShadowKey(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}

});



parcelRegister("2HWES", function(module, exports) {

$parcel$export(module.exports, "getXAxisConfiguration", () => $4873fe759adbd590$export$1808d69f600e9ee6);
$parcel$export(module.exports, "getYAxisConfiguration", () => $4873fe759adbd590$export$a9dea35efaf7afd0);
$parcel$export(module.exports, "getGridConfiguration", () => $4873fe759adbd590$export$a124e1c1031832ab);
$parcel$export(module.exports, "getTooltipConfiguration", () => $4873fe759adbd590$export$ed4f31d6303e81ef);


var $kh4KP = parcelRequire("kh4KP");

var $8AhUZ = parcelRequire("8AhUZ");
const $4873fe759adbd590$export$1808d69f600e9ee6 = (axisLabelsData)=>({
        type: (0, $8AhUZ.X_AXIS_TYPE),
        boundaryGap: false,
        axisLine: {
            lineStyle: {
                color: (0, $8AhUZ.AXIS_COLOR)
            }
        },
        axisLabel: {
            color: (0, $8AhUZ.AXIS_LABEL_COLOR)
        },
        data: axisLabelsData
    });
const $4873fe759adbd590$export$a9dea35efaf7afd0 = ({ yAxisFormatter: yAxisFormatter, minMaxConfig: minMaxConfig })=>{
    const config = {
        type: (0, $8AhUZ.Y_AXIS_TYPE),
        splitLine: {
            show: true,
            lineStyle: {
                color: (0, $8AhUZ.AXIS_COLOR)
            }
        },
        axisLabel: {
            color: (0, $8AhUZ.AXIS_LABEL_COLOR),
            showMaxLabel: true,
            formatter: yAxisFormatter
        },
        minInterval: 1,
        boundaryGap: [
            '0',
            '5%'
        ],
        ...minMaxConfig
    };
    return config;
};
const $4873fe759adbd590$export$a124e1c1031832ab = ()=>({
        show: true,
        borderColor: (0, $8AhUZ.AXIS_COLOR),
        left: '5%',
        right: '3%',
        bottom: '15%'
    });
const $4873fe759adbd590$export$ed4f31d6303e81ef = (formatter)=>({
        backgroundColor: `var(--ds-background-neutral-bold, ${(0, $5e0c0d4e15efb4a6$exports).N900})`,
        trigger: (0, $8AhUZ.TOOL_TIP_TRIGGER),
        triggerOn: 'none',
        transitionDuration: 0,
        textStyle: {
            color: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`
        },
        extraCssText: `box-shadow: ${"var(--ds-shadow-raised, 0 0 8px rgba(0, 0, 0, 0.3))"}`,
        axisPointer: {
            type: 'shadow',
            shadowStyle: {
                color: (0, $kh4KP.default)('color.background.neutral.subtle.hovered', (0, $5e0c0d4e15efb4a6$exports).N10A)
            }
        },
        formatter: formatter
    });

});
parcelRegister("8AhUZ", function(module, exports) {

$parcel$export(module.exports, "X_AXIS_TYPE", () => $f4286fa749e3f39c$export$6f19b351decf0777);
$parcel$export(module.exports, "Y_AXIS_TYPE", () => $f4286fa749e3f39c$export$4d827148a5ec3256);
$parcel$export(module.exports, "AXIS_COLOR", () => $f4286fa749e3f39c$export$12df7fe4b8077ee9);
$parcel$export(module.exports, "AXIS_LABEL_COLOR", () => $f4286fa749e3f39c$export$b5ee262accc33477);
$parcel$export(module.exports, "TOOL_TIP_TRIGGER", () => $f4286fa749e3f39c$export$bbaf67291ac3f6);


var $kh4KP = parcelRequire("kh4KP");
const $f4286fa749e3f39c$export$6f19b351decf0777 = 'category';
const $f4286fa749e3f39c$export$4d827148a5ec3256 = 'value';
const $f4286fa749e3f39c$export$12df7fe4b8077ee9 = (0, $kh4KP.default)('color.border', (0, $5e0c0d4e15efb4a6$exports).N40);
const $f4286fa749e3f39c$export$b5ee262accc33477 = (0, $kh4KP.default)('color.text.subtle', (0, $5e0c0d4e15efb4a6$exports).N300);
const $f4286fa749e3f39c$export$bbaf67291ac3f6 = 'axis';

});


parcelRegister("aMUni", function(module, exports) {

$parcel$export(module.exports, "useChartEvents", () => $d20e00222cfcabfd$export$17a4e5f119c7d26e);

var $5uXOq = parcelRequire("5uXOq");

var $80afZ = parcelRequire("80afZ");

var $hXLCJ = parcelRequire("hXLCJ");

var $7SUn6 = parcelRequire("7SUn6");
const $d20e00222cfcabfd$export$17a4e5f119c7d26e = ({ onPointSelect: onPointSelect, source: source })=>{
    const chartRef = (0, $5uXOq.useRef)(undefined);
    const highlightedPointRef = (0, $5uXOq.useRef)(undefined);
    const setCurrentHighlightedPoint = (0, $5uXOq.useCallback)(()=>{
        highlightedPointRef.current && chartRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        chartRef.current.dispatchAction(highlightedPointRef.current);
    }, []);
    const highlightPoint = (0, $5uXOq.useCallback)((params)=>{
        if (!chartRef.current) return;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        chartRef.current.dispatchAction({
            type: (0, $7SUn6.GRAPH_ACTION_TYPES).DOWNPLAY_STALE_POINT
        });
        highlightedPointRef.current = {
            type: (0, $7SUn6.GRAPH_ACTION_TYPES).HIGHLIGHT_SELECTED_POINT,
            seriesIndex: params.seriesIndex,
            seriesName: params.seriesName,
            dataIndex: params.dataIndex,
            name: params.name
        };
        setCurrentHighlightedPoint();
    }, [
        setCurrentHighlightedPoint
    ]);
    const downplayPoint = (0, $5uXOq.useCallback)(()=>{
        if (!chartRef.current) return;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        chartRef.current.dispatchAction({
            type: (0, $7SUn6.GRAPH_ACTION_TYPES).DOWNPLAY_STALE_POINT
        });
        highlightedPointRef.current = undefined;
    }, []);
    const refreshOptions = (0, $5uXOq.useCallback)((config)=>{
        chartRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        chartRef.current.setOption(config, {
            notMerge: true
        });
    }, []);
    const activateTooltipOnMouseOver = (0, $5uXOq.useCallback)((params)=>{
        chartRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        chartRef.current.dispatchAction({
            type: (0, $7SUn6.GRAPH_ACTION_TYPES).SHOW_TOOL_TIP,
            seriesIndex: params.seriesIndex,
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string | Node'.
            seriesName: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(params.seriesName),
            dataIndex: params.dataIndex,
            name: params.name
        });
        // highlighted previous selected chart point got
        setCurrentHighlightedPoint();
    }, [
        setCurrentHighlightedPoint
    ]);
    const hideTooltipOnMouseOut = (0, $5uXOq.useCallback)(()=>{
        chartRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        chartRef.current.dispatchAction({
            type: (0, $7SUn6.GRAPH_ACTION_TYPES).HIDE_TIP
        });
        chartRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        chartRef.current.dispatchAction({
            type: (0, $7SUn6.GRAPH_ACTION_TYPES).DOWNPLAY_STALE_POINT
        });
        setCurrentHighlightedPoint();
    }, [
        setCurrentHighlightedPoint
    ]);
    // TODO: Hacky code because Echarts doesn't support a11y. We have to do all these to get access to the series to trigger mouse like events on keypress. Remove it after highcharts are implemented
    const findSeries = (0, $5uXOq.useCallback)((echartsInstance, path)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const color = path.getAttribute('stroke');
        const transform = path// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        .getAttribute('transform').split('matrix(')[1].split(')')[0].split(',');
        const transformX = Math.round(transform[4] * 100) / 100;
        const transformY = Math.round(transform[5] * 100) / 100;
        const seriesIndex = source.chartSeries.findIndex((series)=>series.itemStyle.color === color);
        const series = source.chartSeries[seriesIndex];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const seriesInstance = Object.values(echartsInstance._chartsMap).find(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        (instance)=>instance._data._visual.style.fill === color);
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const index = seriesInstance._data._graphicEls.findIndex((item)=>{
            if (Math.round(item.x * 100) / 100 === transformX && Math.round(item.y * 100) / 100 === transformY) return true;
            return false;
        });
        return {
            data: series.data[index],
            seriesName: series.name
        };
    }, [
        source.chartSeries
    ]);
    // register chart events on chart mount
    const registerEvents = (0, $5uXOq.useCallback)((echartsInstance)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const paths = chartRef.current._dom.querySelectorAll('path[d="M 1 0 A 1 1 0 1 1 1 -0.0001"]');
        for(let pathIndex = 0; pathIndex < paths.length; pathIndex++)paths[pathIndex].setAttribute('tabindex', 0);
        // NOTE: when this event listener is removed when migrating to the new charting library
        // please remove the "error.stack?.includes('reports-common')" condition in
        // src/packages/platform/test-utils/test-cleanup/src/common/utils/symmetric-listeners.tsx
        // see https://atlassian.slack.com/archives/CL6HC337Z/p1708926151196649?thread_ts=1708914082.486629&cid=CL6HC337Z
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        chartRef.current._dom.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter' && event.target.nodeName === 'path' && event.target.getAttribute('tabindex')) {
                const { data: data } = findSeries(echartsInstance, event.target);
                if (onPointSelect) onPointSelect({
                    data: data
                });
            }
        });
        if (!echartsInstance) return;
        // click event to highlight specific point on chart
        if (onPointSelect) echartsInstance.on((0, $7SUn6.GRAPH_EVENT_TYPES).CLICK, (params)=>{
            onPointSelect(params);
        });
        // mouseover event to enable tooltip
        echartsInstance.on((0, $7SUn6.GRAPH_EVENT_TYPES).MOUSE_OVER, activateTooltipOnMouseOver);
        // mouseout event to hide tooltip
        echartsInstance.on((0, $7SUn6.GRAPH_EVENT_TYPES).MOUSE_OUT, hideTooltipOnMouseOut);
    }, [
        onPointSelect,
        activateTooltipOnMouseOver,
        hideTooltipOnMouseOut,
        findSeries
    ]);
    const initChartEventsOnMount = (0, $5uXOq.useCallback)((echartsInstance)=>{
        chartRef.current = echartsInstance;
        registerEvents(echartsInstance);
    }, [
        registerEvents
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (chartRef.current) {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            chartRef.current.off((0, $7SUn6.GRAPH_EVENT_TYPES).CLICK);
            // scoped useState values doesn't seems to be updated when callback functions are triggered.
            // re-register event if callback function changes.
            chartRef.current && onPointSelect && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            chartRef.current.on((0, $7SUn6.GRAPH_EVENT_TYPES).CLICK, onPointSelect);
        }
    }, [
        onPointSelect
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // un register all events on un-mount & dispose chart reference
            (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, $7SUn6.GRAPH_EVENT_TYPES), (event)=>{
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                chartRef.current && chartRef.current.off(event);
            });
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            chartRef.current && chartRef.current.dispose();
        }, []);
    return {
        initChartEventsOnMount: initChartEventsOnMount,
        highlightPoint: highlightPoint,
        downplayPoint: downplayPoint,
        refreshOptions: refreshOptions
    };
};

});
parcelRegister("hXLCJ", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("7SUn6", function(module, exports) {

$parcel$export(module.exports, "GRAPH_ACTION_TYPES", () => $f90f361440644135$export$a53d967d2b838a48);
$parcel$export(module.exports, "GRAPH_EVENT_TYPES", () => $f90f361440644135$export$226af313a4ea871b);
const $f90f361440644135$export$a53d967d2b838a48 = {
    HIGHLIGHT_SELECTED_POINT: 'highlight',
    DOWNPLAY_STALE_POINT: 'downplay',
    SHOW_TOOL_TIP: 'showTip',
    HIDE_TIP: 'hideTip'
};
const $f90f361440644135$export$226af313a4ea871b = {
    CLICK: 'click',
    MOUSE_OVER: 'mouseover',
    MOUSE_OUT: 'mouseout'
};

});


parcelRegister("61iTG", function(module, exports) {

$parcel$export(module.exports, "formatTooltip", () => $c89ec9eec217bdd6$export$4f4aa504c717f7cb);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");

var $8QpSo = parcelRequire("8QpSo");

var $9joA7 = parcelRequire("9joA7");

var $fhrez = parcelRequire("fhrez");


var $gwIPs = parcelRequire("gwIPs");

var $9nenm = parcelRequire("9nenm");

var $cnldZ = parcelRequire("cnldZ");

var $dVijb = parcelRequire("dVijb");
const $c89ec9eec217bdd6$var$getCalendarIcon = (0, $8QpSo.default)(()=>(0, $9joA7.renderToStaticMarkup)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fhrez))), {
        label: "",
        primaryColor: `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N50})`,
        size: "medium"
    })));
const $c89ec9eec217bdd6$var$getYAxisValue = (intl, { data: data })=>(0, $cnldZ.getFormattedLabel)(data.valueType, data.value, intl.formatMessage);
const $c89ec9eec217bdd6$export$9cf787c92908daee = (intl, points)=>points.map((point)=>`${point.marker} ${$c89ec9eec217bdd6$var$getYAxisValue(intl, point)} - ${(0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(point.seriesName)}`).join('<br />');
const $c89ec9eec217bdd6$export$4f4aa504c717f7cb = (intl, points, searchBy)=>`<div style="padding: ${0, $gwIPs.gridSize}px;
                border-radius: ${(0, $gwIPs.gridSize) * 0.375}px;">
                <span style="display: flex;align-items: center;">
                    ${$c89ec9eec217bdd6$var$getCalendarIcon()}
                    <span style="font-size:${(0, $gwIPs.gridSize) * 2}px; align-self: flex-end;">
                        ${searchBy === (0, $9nenm.SEARCH_BY).weekly ? intl.formatMessage((0, $dVijb.default).weekStartingLabel, {
        formattedDate: points[0].data.formattedDate
    }) : points[0].data.formattedDate}
                    </span>
                </span>
                <br />
                ${$c89ec9eec217bdd6$export$9cf787c92908daee(intl, points)}
            </div>
            `;

});
parcelRegister("9joA7", function(module, exports) {

$parcel$export(module.exports, "version", () => $6c78f4cae7505685$export$83d89fbfd8236492, (v) => $6c78f4cae7505685$export$83d89fbfd8236492 = v);
$parcel$export(module.exports, "renderToString", () => $6c78f4cae7505685$export$80e7718417253a51, (v) => $6c78f4cae7505685$export$80e7718417253a51 = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $6c78f4cae7505685$export$eb3a06aef9e6ee51, (v) => $6c78f4cae7505685$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToNodeStream", () => $6c78f4cae7505685$export$307591e98609eddd, (v) => $6c78f4cae7505685$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $6c78f4cae7505685$export$b23711c915539651, (v) => $6c78f4cae7505685$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToReadableStream", () => $6c78f4cae7505685$export$7020a3240b287705, (v) => $6c78f4cae7505685$export$7020a3240b287705 = v);
var $6c78f4cae7505685$export$83d89fbfd8236492;
var $6c78f4cae7505685$export$80e7718417253a51;
var $6c78f4cae7505685$export$eb3a06aef9e6ee51;
var $6c78f4cae7505685$export$307591e98609eddd;
var $6c78f4cae7505685$export$b23711c915539651;
var $6c78f4cae7505685$export$7020a3240b287705;
'use strict';
var $6c78f4cae7505685$var$l, $6c78f4cae7505685$var$s;

$6c78f4cae7505685$var$l = (parcelRequire("6aMuy"));

$6c78f4cae7505685$var$s = (parcelRequire("l7JfX"));
$6c78f4cae7505685$export$83d89fbfd8236492 = $6c78f4cae7505685$var$l.version;
$6c78f4cae7505685$export$80e7718417253a51 = $6c78f4cae7505685$var$l.renderToString;
$6c78f4cae7505685$export$eb3a06aef9e6ee51 = $6c78f4cae7505685$var$l.renderToStaticMarkup;
$6c78f4cae7505685$export$307591e98609eddd = $6c78f4cae7505685$var$l.renderToNodeStream;
$6c78f4cae7505685$export$b23711c915539651 = $6c78f4cae7505685$var$l.renderToStaticNodeStream;
$6c78f4cae7505685$export$7020a3240b287705 = $6c78f4cae7505685$var$s.renderToReadableStream;

});
parcelRegister("6aMuy", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $47e94abb28b53633$export$307591e98609eddd, (v) => $47e94abb28b53633$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $47e94abb28b53633$export$eb3a06aef9e6ee51, (v) => $47e94abb28b53633$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $47e94abb28b53633$export$b23711c915539651, (v) => $47e94abb28b53633$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $47e94abb28b53633$export$80e7718417253a51, (v) => $47e94abb28b53633$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $47e94abb28b53633$export$83d89fbfd8236492, (v) => $47e94abb28b53633$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $47e94abb28b53633$export$307591e98609eddd;
var $47e94abb28b53633$export$eb3a06aef9e6ee51;
var $47e94abb28b53633$export$b23711c915539651;
var $47e94abb28b53633$export$80e7718417253a51;
var $47e94abb28b53633$export$83d89fbfd8236492;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $47e94abb28b53633$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $47e94abb28b53633$var$p = Object.prototype.hasOwnProperty, $47e94abb28b53633$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $47e94abb28b53633$var$ha = {}, $47e94abb28b53633$var$ia = {};
function $47e94abb28b53633$var$ja(a) {
    if ($47e94abb28b53633$var$p.call($47e94abb28b53633$var$ia, a)) return !0;
    if ($47e94abb28b53633$var$p.call($47e94abb28b53633$var$ha, a)) return !1;
    if ($47e94abb28b53633$var$fa.test(a)) return $47e94abb28b53633$var$ia[a] = !0;
    $47e94abb28b53633$var$ha[a] = !0;
    return !1;
}
function $47e94abb28b53633$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $47e94abb28b53633$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $47e94abb28b53633$var$ka = /[\-:]([a-z])/g;
function $47e94abb28b53633$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
    $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
    $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
    $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$47e94abb28b53633$var$t.xlinkHref = new $47e94abb28b53633$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $47e94abb28b53633$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $47e94abb28b53633$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($47e94abb28b53633$var$u).forEach(function(a) {
    $47e94abb28b53633$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $47e94abb28b53633$var$u[b] = $47e94abb28b53633$var$u[a];
    });
});
var $47e94abb28b53633$var$na = /["'&<>]/;
function $47e94abb28b53633$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $47e94abb28b53633$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $47e94abb28b53633$var$oa = /([A-Z])/g, $47e94abb28b53633$var$pa = /^ms-/, $47e94abb28b53633$var$qa = Array.isArray;
function $47e94abb28b53633$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $47e94abb28b53633$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $47e94abb28b53633$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $47e94abb28b53633$var$w(2, null);
        case "math":
            return $47e94abb28b53633$var$w(3, null);
        case "foreignObject":
            return $47e94abb28b53633$var$w(1, null);
        case "table":
            return $47e94abb28b53633$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $47e94abb28b53633$var$w(5, null);
        case "colgroup":
            return $47e94abb28b53633$var$w(7, null);
        case "tr":
            return $47e94abb28b53633$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $47e94abb28b53633$var$w(1, null) : a;
}
var $47e94abb28b53633$var$sa = new Map;
function $47e94abb28b53633$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($47e94abb28b53633$var$l(62));
    b = !0;
    for(var d in c)if ($47e94abb28b53633$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $47e94abb28b53633$var$v(d);
                f = $47e94abb28b53633$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $47e94abb28b53633$var$sa.get(e);
                void 0 !== g ? e = g : (g = $47e94abb28b53633$var$v(e.replace($47e94abb28b53633$var$oa, "-$1").toLowerCase().replace($47e94abb28b53633$var$pa, "-ms-")), $47e94abb28b53633$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $47e94abb28b53633$var$p.call($47e94abb28b53633$var$u, d) ? "" + f : f + "px" : $47e94abb28b53633$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $47e94abb28b53633$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $47e94abb28b53633$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $47e94abb28b53633$var$t.hasOwnProperty(c) ? $47e94abb28b53633$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
            }
        } else if ($47e94abb28b53633$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
        }
    }
}
function $47e94abb28b53633$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($47e94abb28b53633$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($47e94abb28b53633$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $47e94abb28b53633$var$ua(a) {
    var b = "";
    $5uXOq.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $47e94abb28b53633$var$va(a, b, c, d) {
    a.push($47e94abb28b53633$var$A(c));
    var f = c = null, e;
    for(e in b)if ($47e94abb28b53633$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $47e94abb28b53633$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $47e94abb28b53633$var$y(a, f, c);
    return "string" === typeof c ? (a.push($47e94abb28b53633$var$v(c)), null) : c;
}
var $47e94abb28b53633$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $47e94abb28b53633$var$xa = new Map;
function $47e94abb28b53633$var$A(a) {
    var b = $47e94abb28b53633$var$xa.get(a);
    if (void 0 === b) {
        if (!$47e94abb28b53633$var$wa.test(a)) throw Error($47e94abb28b53633$var$l(65, a));
        b = "<" + a;
        $47e94abb28b53633$var$xa.set(a, b);
    }
    return b;
}
function $47e94abb28b53633$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($47e94abb28b53633$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($47e94abb28b53633$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $47e94abb28b53633$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $47e94abb28b53633$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($47e94abb28b53633$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($47e94abb28b53633$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $47e94abb28b53633$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $47e94abb28b53633$var$ua(h), $47e94abb28b53633$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $47e94abb28b53633$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($47e94abb28b53633$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($47e94abb28b53633$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(91));
                default:
                    $47e94abb28b53633$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($47e94abb28b53633$var$l(92));
                if ($47e94abb28b53633$var$qa(n) && 1 < n.length) throw Error($47e94abb28b53633$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($47e94abb28b53633$var$v("" + e));
            return null;
        case "input":
            a.push($47e94abb28b53633$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($47e94abb28b53633$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $47e94abb28b53633$var$x(a, d, g, m);
            }
            null !== n ? $47e94abb28b53633$var$x(a, d, "checked", n) : null !== k && $47e94abb28b53633$var$x(a, d, "checked", k);
            null !== e ? $47e94abb28b53633$var$x(a, d, "value", e) : null !== h && $47e94abb28b53633$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($47e94abb28b53633$var$A("menuitem"));
            for(var C in c)if ($47e94abb28b53633$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(400));
                default:
                    $47e94abb28b53633$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($47e94abb28b53633$var$A("title"));
            e = null;
            for(q in c)if ($47e94abb28b53633$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(434));
                default:
                    $47e94abb28b53633$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($47e94abb28b53633$var$A(b));
            g = e = null;
            for(k in c)if ($47e94abb28b53633$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $47e94abb28b53633$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($47e94abb28b53633$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($47e94abb28b53633$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($47e94abb28b53633$var$A(b));
            for(var D in c)if ($47e94abb28b53633$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(399, b));
                default:
                    $47e94abb28b53633$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $47e94abb28b53633$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $47e94abb28b53633$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $47e94abb28b53633$var$va(a, c, b, d);
            a.push($47e94abb28b53633$var$A(b));
            g = e = null;
            for(m in c)if ($47e94abb28b53633$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $47e94abb28b53633$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $47e94abb28b53633$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $47e94abb28b53633$var$v(h), '"');
            }
            a.push(">");
            $47e94abb28b53633$var$y(a, g, e);
            return e;
    }
}
function $47e94abb28b53633$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($47e94abb28b53633$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $47e94abb28b53633$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($47e94abb28b53633$var$l(397));
    }
}
function $47e94abb28b53633$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($47e94abb28b53633$var$l(397));
    }
}
var $47e94abb28b53633$var$Ca = /[<\u2028\u2029]/g;
function $47e94abb28b53633$var$Da(a) {
    return JSON.stringify(a).replace($47e94abb28b53633$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $47e94abb28b53633$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $47e94abb28b53633$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($47e94abb28b53633$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($47e94abb28b53633$var$v(b)), a = !0);
    return a;
}
var $47e94abb28b53633$var$B = Object.assign, $47e94abb28b53633$var$Ga = Symbol.for("react.element"), $47e94abb28b53633$var$Ha = Symbol.for("react.portal"), $47e94abb28b53633$var$Ia = Symbol.for("react.fragment"), $47e94abb28b53633$var$Ja = Symbol.for("react.strict_mode"), $47e94abb28b53633$var$Ka = Symbol.for("react.profiler"), $47e94abb28b53633$var$La = Symbol.for("react.provider"), $47e94abb28b53633$var$Ma = Symbol.for("react.context"), $47e94abb28b53633$var$Na = Symbol.for("react.forward_ref"), $47e94abb28b53633$var$Oa = Symbol.for("react.suspense"), $47e94abb28b53633$var$Pa = Symbol.for("react.suspense_list"), $47e94abb28b53633$var$Qa = Symbol.for("react.memo"), $47e94abb28b53633$var$Ra = Symbol.for("react.lazy"), $47e94abb28b53633$var$Sa = Symbol.for("react.scope"), $47e94abb28b53633$var$Ta = Symbol.for("react.debug_trace_mode"), $47e94abb28b53633$var$Ua = Symbol.for("react.legacy_hidden"), $47e94abb28b53633$var$Va = Symbol.for("react.default_value"), $47e94abb28b53633$var$Wa = Symbol.iterator;
function $47e94abb28b53633$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $47e94abb28b53633$var$Ia:
            return "Fragment";
        case $47e94abb28b53633$var$Ha:
            return "Portal";
        case $47e94abb28b53633$var$Ka:
            return "Profiler";
        case $47e94abb28b53633$var$Ja:
            return "StrictMode";
        case $47e94abb28b53633$var$Oa:
            return "Suspense";
        case $47e94abb28b53633$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $47e94abb28b53633$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $47e94abb28b53633$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $47e94abb28b53633$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $47e94abb28b53633$var$Qa:
            return b = a.displayName || null, null !== b ? b : $47e94abb28b53633$var$Xa(a.type) || "Memo";
        case $47e94abb28b53633$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $47e94abb28b53633$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $47e94abb28b53633$var$Ya = {};
function $47e94abb28b53633$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $47e94abb28b53633$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $47e94abb28b53633$var$E = null;
function $47e94abb28b53633$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($47e94abb28b53633$var$l(401));
        } else {
            if (null === c) throw Error($47e94abb28b53633$var$l(401));
            $47e94abb28b53633$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $47e94abb28b53633$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $47e94abb28b53633$var$$a(a);
}
function $47e94abb28b53633$var$ab(a) {
    var b = a.parent;
    null !== b && $47e94abb28b53633$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $47e94abb28b53633$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($47e94abb28b53633$var$l(402));
    a.depth === b.depth ? $47e94abb28b53633$var$F(a, b) : $47e94abb28b53633$var$bb(a, b);
}
function $47e94abb28b53633$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($47e94abb28b53633$var$l(402));
    a.depth === c.depth ? $47e94abb28b53633$var$F(a, c) : $47e94abb28b53633$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $47e94abb28b53633$var$G(a) {
    var b = $47e94abb28b53633$var$E;
    b !== a && (null === b ? $47e94abb28b53633$var$ab(a) : null === a ? $47e94abb28b53633$var$$a(b) : b.depth === a.depth ? $47e94abb28b53633$var$F(b, a) : b.depth > a.depth ? $47e94abb28b53633$var$bb(b, a) : $47e94abb28b53633$var$cb(b, a), $47e94abb28b53633$var$E = a);
}
var $47e94abb28b53633$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $47e94abb28b53633$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $47e94abb28b53633$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $47e94abb28b53633$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $47e94abb28b53633$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $47e94abb28b53633$var$B({}, e, h)) : $47e94abb28b53633$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $47e94abb28b53633$var$fb = {
    id: 1,
    overflow: ""
};
function $47e94abb28b53633$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $47e94abb28b53633$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $47e94abb28b53633$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $47e94abb28b53633$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $47e94abb28b53633$var$H = Math.clz32 ? Math.clz32 : $47e94abb28b53633$var$hb, $47e94abb28b53633$var$ib = Math.log, $47e94abb28b53633$var$jb = Math.LN2;
function $47e94abb28b53633$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($47e94abb28b53633$var$ib(a) / $47e94abb28b53633$var$jb | 0) | 0;
}
function $47e94abb28b53633$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $47e94abb28b53633$var$lb = "function" === typeof Object.is ? Object.is : $47e94abb28b53633$var$kb, $47e94abb28b53633$var$I = null, $47e94abb28b53633$var$ob = null, $47e94abb28b53633$var$J = null, $47e94abb28b53633$var$K = null, $47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$M = !1, $47e94abb28b53633$var$N = 0, $47e94abb28b53633$var$O = null, $47e94abb28b53633$var$P = 0;
function $47e94abb28b53633$var$Q() {
    if (null === $47e94abb28b53633$var$I) throw Error($47e94abb28b53633$var$l(321));
    return $47e94abb28b53633$var$I;
}
function $47e94abb28b53633$var$pb() {
    if (0 < $47e94abb28b53633$var$P) throw Error($47e94abb28b53633$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $47e94abb28b53633$var$qb() {
    null === $47e94abb28b53633$var$K ? null === $47e94abb28b53633$var$J ? ($47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$J = $47e94abb28b53633$var$K = $47e94abb28b53633$var$pb()) : ($47e94abb28b53633$var$L = !0, $47e94abb28b53633$var$K = $47e94abb28b53633$var$J) : null === $47e94abb28b53633$var$K.next ? ($47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$K = $47e94abb28b53633$var$K.next = $47e94abb28b53633$var$pb()) : ($47e94abb28b53633$var$L = !0, $47e94abb28b53633$var$K = $47e94abb28b53633$var$K.next);
    return $47e94abb28b53633$var$K;
}
function $47e94abb28b53633$var$rb() {
    $47e94abb28b53633$var$ob = $47e94abb28b53633$var$I = null;
    $47e94abb28b53633$var$M = !1;
    $47e94abb28b53633$var$J = null;
    $47e94abb28b53633$var$P = 0;
    $47e94abb28b53633$var$K = $47e94abb28b53633$var$O = null;
}
function $47e94abb28b53633$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $47e94abb28b53633$var$tb(a, b, c) {
    $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
    $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
    if ($47e94abb28b53633$var$L) {
        var d = $47e94abb28b53633$var$K.queue;
        b = d.dispatch;
        if (null !== $47e94abb28b53633$var$O && (c = $47e94abb28b53633$var$O.get(d), void 0 !== c)) {
            $47e94abb28b53633$var$O.delete(d);
            d = $47e94abb28b53633$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $47e94abb28b53633$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $47e94abb28b53633$var$K.memoizedState,
            b
        ];
    }
    a = a === $47e94abb28b53633$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $47e94abb28b53633$var$K.memoizedState = a;
    a = $47e94abb28b53633$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $47e94abb28b53633$var$ub.bind(null, $47e94abb28b53633$var$I, a);
    return [
        $47e94abb28b53633$var$K.memoizedState,
        a
    ];
}
function $47e94abb28b53633$var$vb(a, b) {
    $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
    $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $47e94abb28b53633$var$K) {
        var c = $47e94abb28b53633$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$47e94abb28b53633$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $47e94abb28b53633$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $47e94abb28b53633$var$ub(a, b, c) {
    if (25 <= $47e94abb28b53633$var$P) throw Error($47e94abb28b53633$var$l(301));
    if (a === $47e94abb28b53633$var$I) {
        if ($47e94abb28b53633$var$M = !0, a = {
            action: c,
            next: null
        }, null === $47e94abb28b53633$var$O && ($47e94abb28b53633$var$O = new Map), c = $47e94abb28b53633$var$O.get(b), void 0 === c) $47e94abb28b53633$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $47e94abb28b53633$var$wb() {
    throw Error($47e94abb28b53633$var$l(394));
}
function $47e94abb28b53633$var$R() {}
var $47e94abb28b53633$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $47e94abb28b53633$var$Q();
        return a._currentValue2;
    },
    useMemo: $47e94abb28b53633$var$vb,
    useReducer: $47e94abb28b53633$var$tb,
    useRef: function(a) {
        $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
        $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
        var b = $47e94abb28b53633$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $47e94abb28b53633$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $47e94abb28b53633$var$tb($47e94abb28b53633$var$sb, a);
    },
    useInsertionEffect: $47e94abb28b53633$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $47e94abb28b53633$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $47e94abb28b53633$var$R,
    useEffect: $47e94abb28b53633$var$R,
    useDebugValue: $47e94abb28b53633$var$R,
    useDeferredValue: function(a) {
        $47e94abb28b53633$var$Q();
        return a;
    },
    useTransition: function() {
        $47e94abb28b53633$var$Q();
        return [
            !1,
            $47e94abb28b53633$var$wb
        ];
    },
    useId: function() {
        var a = $47e94abb28b53633$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $47e94abb28b53633$var$H(a) - 1)).toString(32) + b;
        var c = $47e94abb28b53633$var$S;
        if (null === c) throw Error($47e94abb28b53633$var$l(404));
        b = $47e94abb28b53633$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $47e94abb28b53633$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($47e94abb28b53633$var$l(407));
        return c();
    }
}, $47e94abb28b53633$var$S = null, $47e94abb28b53633$var$yb = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $47e94abb28b53633$var$zb(a) {
    console.error(a);
    return null;
}
function $47e94abb28b53633$var$T() {}
function $47e94abb28b53633$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $47e94abb28b53633$var$zb : f,
        onAllReady: void 0 === e ? $47e94abb28b53633$var$T : e,
        onShellReady: void 0 === g ? $47e94abb28b53633$var$T : g,
        onShellError: void 0 === h ? $47e94abb28b53633$var$T : h,
        onFatalError: void 0 === k ? $47e94abb28b53633$var$T : k
    };
    c = $47e94abb28b53633$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $47e94abb28b53633$var$Bb(b, a, null, c, n, $47e94abb28b53633$var$Ya, null, $47e94abb28b53633$var$fb);
    m.push(a);
    return b;
}
function $47e94abb28b53633$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $47e94abb28b53633$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $47e94abb28b53633$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $47e94abb28b53633$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $47e94abb28b53633$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $47e94abb28b53633$var$Db(a, b, c, d, f) {
    $47e94abb28b53633$var$I = {};
    $47e94abb28b53633$var$ob = b;
    $47e94abb28b53633$var$N = 0;
    for(a = c(d, f); $47e94abb28b53633$var$M;)$47e94abb28b53633$var$M = !1, $47e94abb28b53633$var$N = 0, $47e94abb28b53633$var$P += 1, $47e94abb28b53633$var$K = null, a = c(d, f);
    $47e94abb28b53633$var$rb();
    return a;
}
function $47e94abb28b53633$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($47e94abb28b53633$var$l(108, $47e94abb28b53633$var$Xa(d) || "Unknown", h));
            d = $47e94abb28b53633$var$B({}, g, c);
        }
        b.legacyContext = d;
        $47e94abb28b53633$var$X(a, b, f);
        b.legacyContext = g;
    } else $47e94abb28b53633$var$X(a, b, f);
}
function $47e94abb28b53633$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $47e94abb28b53633$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $47e94abb28b53633$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $47e94abb28b53633$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $47e94abb28b53633$var$eb(e, c, d, f);
            $47e94abb28b53633$var$Eb(a, b, e, c);
        } else {
            e = $47e94abb28b53633$var$Za(c, b.legacyContext);
            f = $47e94abb28b53633$var$Db(a, b, c, d, e);
            var g = 0 !== $47e94abb28b53633$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $47e94abb28b53633$var$eb(f, c, d, e), $47e94abb28b53633$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $47e94abb28b53633$var$gb(d, 1, 0);
                try {
                    $47e94abb28b53633$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $47e94abb28b53633$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $47e94abb28b53633$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $47e94abb28b53633$var$ra(g, c, d);
        $47e94abb28b53633$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $47e94abb28b53633$var$Ua:
            case $47e94abb28b53633$var$Ta:
            case $47e94abb28b53633$var$Ja:
            case $47e94abb28b53633$var$Ka:
            case $47e94abb28b53633$var$Ia:
                $47e94abb28b53633$var$X(a, b, d.children);
                return;
            case $47e94abb28b53633$var$Pa:
                $47e94abb28b53633$var$X(a, b, d.children);
                return;
            case $47e94abb28b53633$var$Sa:
                throw Error($47e94abb28b53633$var$l(343));
            case $47e94abb28b53633$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $47e94abb28b53633$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $47e94abb28b53633$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($47e94abb28b53633$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $47e94abb28b53633$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $47e94abb28b53633$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $47e94abb28b53633$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $47e94abb28b53633$var$Na:
                d = $47e94abb28b53633$var$Db(a, b, c.render, d, f);
                if (0 !== $47e94abb28b53633$var$N) {
                    c = b.treeContext;
                    b.treeContext = $47e94abb28b53633$var$gb(c, 1, 0);
                    try {
                        $47e94abb28b53633$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $47e94abb28b53633$var$X(a, b, d);
                return;
            case $47e94abb28b53633$var$Qa:
                c = c.type;
                d = $47e94abb28b53633$var$Fb(c, d);
                $47e94abb28b53633$var$Gb(a, b, c, d, f);
                return;
            case $47e94abb28b53633$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $47e94abb28b53633$var$E;
                $47e94abb28b53633$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $47e94abb28b53633$var$X(a, b, f);
                a = $47e94abb28b53633$var$E;
                if (null === a) throw Error($47e94abb28b53633$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $47e94abb28b53633$var$Va ? a.context._defaultValue : d;
                a = $47e94abb28b53633$var$E = a.parent;
                b.context = a;
                return;
            case $47e94abb28b53633$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $47e94abb28b53633$var$X(a, b, d);
                return;
            case $47e94abb28b53633$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $47e94abb28b53633$var$Fb(c, d);
                $47e94abb28b53633$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($47e94abb28b53633$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $47e94abb28b53633$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $47e94abb28b53633$var$Ga:
                $47e94abb28b53633$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $47e94abb28b53633$var$Ha:
                throw Error($47e94abb28b53633$var$l(257));
            case $47e94abb28b53633$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $47e94abb28b53633$var$X(a, b, c);
                return;
        }
        if ($47e94abb28b53633$var$qa(c)) {
            $47e94abb28b53633$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $47e94abb28b53633$var$Wa && c[$47e94abb28b53633$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $47e94abb28b53633$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($47e94abb28b53633$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $47e94abb28b53633$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $47e94abb28b53633$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $47e94abb28b53633$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $47e94abb28b53633$var$gb(e, d, f);
        try {
            $47e94abb28b53633$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $47e94abb28b53633$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $47e94abb28b53633$var$X(a, b, c);
    } catch (k) {
        if ($47e94abb28b53633$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $47e94abb28b53633$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $47e94abb28b53633$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $47e94abb28b53633$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $47e94abb28b53633$var$G(e), k;
    }
}
function $47e94abb28b53633$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $47e94abb28b53633$var$Kb(this, b, a);
}
function $47e94abb28b53633$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($47e94abb28b53633$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $47e94abb28b53633$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $47e94abb28b53633$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $47e94abb28b53633$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $47e94abb28b53633$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($47e94abb28b53633$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $47e94abb28b53633$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $47e94abb28b53633$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($47e94abb28b53633$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($47e94abb28b53633$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $47e94abb28b53633$var$Cb(a) {
    if (2 !== a.status) {
        var b = $47e94abb28b53633$var$E, c = $47e94abb28b53633$var$yb.current;
        $47e94abb28b53633$var$yb.current = $47e94abb28b53633$var$xb;
        var d = $47e94abb28b53633$var$S;
        $47e94abb28b53633$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $47e94abb28b53633$var$G(g.context);
                    try {
                        $47e94abb28b53633$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $47e94abb28b53633$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($47e94abb28b53633$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $47e94abb28b53633$var$V(h, q);
                            null === n ? $47e94abb28b53633$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $47e94abb28b53633$var$Mb(a, a.destination);
        } catch (z) {
            $47e94abb28b53633$var$V(a, z), $47e94abb28b53633$var$W(a, z);
        } finally{
            $47e94abb28b53633$var$S = d, $47e94abb28b53633$var$yb.current = c, c === $47e94abb28b53633$var$xb && $47e94abb28b53633$var$G(b);
        }
    }
}
function $47e94abb28b53633$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $47e94abb28b53633$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($47e94abb28b53633$var$l(390));
    }
}
function $47e94abb28b53633$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $47e94abb28b53633$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $47e94abb28b53633$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $47e94abb28b53633$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $47e94abb28b53633$var$za(b, a.responseState, d);
        $47e94abb28b53633$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $47e94abb28b53633$var$za(b, a.responseState, d.id), $47e94abb28b53633$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($47e94abb28b53633$var$l(391));
    $47e94abb28b53633$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $47e94abb28b53633$var$Ob(a, b, c) {
    $47e94abb28b53633$var$Aa(b, a.responseState, c.formatContext, c.id);
    $47e94abb28b53633$var$Nb(a, b, c);
    return $47e94abb28b53633$var$Ba(b, c.formatContext);
}
function $47e94abb28b53633$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$47e94abb28b53633$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($47e94abb28b53633$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $47e94abb28b53633$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($47e94abb28b53633$var$l(392));
        return $47e94abb28b53633$var$Ob(a, b, d);
    }
    $47e94abb28b53633$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $47e94abb28b53633$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $47e94abb28b53633$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($47e94abb28b53633$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $47e94abb28b53633$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $47e94abb28b53633$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $47e94abb28b53633$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$47e94abb28b53633$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$47e94abb28b53633$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$47e94abb28b53633$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $47e94abb28b53633$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $47e94abb28b53633$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $47e94abb28b53633$var$Mb(a, a.destination);
    } catch (d) {
        $47e94abb28b53633$var$V(a, d), $47e94abb28b53633$var$W(a, d);
    }
}
function $47e94abb28b53633$var$Sb() {}
function $47e94abb28b53633$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $47e94abb28b53633$var$Ab(a, $47e94abb28b53633$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $47e94abb28b53633$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $47e94abb28b53633$var$Cb(a);
    $47e94abb28b53633$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $47e94abb28b53633$var$Mb(a, h);
        } catch (m) {
            $47e94abb28b53633$var$V(a, m), $47e94abb28b53633$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($47e94abb28b53633$var$l(426));
    return g;
}
$47e94abb28b53633$export$307591e98609eddd = function() {
    throw Error($47e94abb28b53633$var$l(207));
};
$47e94abb28b53633$export$eb3a06aef9e6ee51 = function(a, b) {
    return $47e94abb28b53633$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$47e94abb28b53633$export$b23711c915539651 = function() {
    throw Error($47e94abb28b53633$var$l(208));
};
$47e94abb28b53633$export$80e7718417253a51 = function(a, b) {
    return $47e94abb28b53633$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$47e94abb28b53633$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("l7JfX", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $f60d5b61c638db60$export$7020a3240b287705, (v) => $f60d5b61c638db60$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $f60d5b61c638db60$export$83d89fbfd8236492, (v) => $f60d5b61c638db60$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f60d5b61c638db60$export$7020a3240b287705;
var $f60d5b61c638db60$export$83d89fbfd8236492;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $f60d5b61c638db60$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f60d5b61c638db60$var$l = null, $f60d5b61c638db60$var$n = 0;
function $f60d5b61c638db60$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $f60d5b61c638db60$var$n && (a.enqueue(new Uint8Array($f60d5b61c638db60$var$l.buffer, 0, $f60d5b61c638db60$var$n)), $f60d5b61c638db60$var$l = new Uint8Array(512), $f60d5b61c638db60$var$n = 0), a.enqueue(b);
        else {
            var c = $f60d5b61c638db60$var$l.length - $f60d5b61c638db60$var$n;
            c < b.length && (0 === c ? a.enqueue($f60d5b61c638db60$var$l) : ($f60d5b61c638db60$var$l.set(b.subarray(0, c), $f60d5b61c638db60$var$n), a.enqueue($f60d5b61c638db60$var$l), b = b.subarray(c)), $f60d5b61c638db60$var$l = new Uint8Array(512), $f60d5b61c638db60$var$n = 0);
            $f60d5b61c638db60$var$l.set(b, $f60d5b61c638db60$var$n);
            $f60d5b61c638db60$var$n += b.length;
        }
    }
}
function $f60d5b61c638db60$var$t(a, b) {
    $f60d5b61c638db60$var$p(a, b);
    return !0;
}
function $f60d5b61c638db60$var$ba(a) {
    $f60d5b61c638db60$var$l && 0 < $f60d5b61c638db60$var$n && (a.enqueue(new Uint8Array($f60d5b61c638db60$var$l.buffer, 0, $f60d5b61c638db60$var$n)), $f60d5b61c638db60$var$l = null, $f60d5b61c638db60$var$n = 0);
}
var $f60d5b61c638db60$var$ca = new TextEncoder;
function $f60d5b61c638db60$var$u(a) {
    return $f60d5b61c638db60$var$ca.encode(a);
}
function $f60d5b61c638db60$var$w(a) {
    return $f60d5b61c638db60$var$ca.encode(a);
}
function $f60d5b61c638db60$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $f60d5b61c638db60$var$x = Object.prototype.hasOwnProperty, $f60d5b61c638db60$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f60d5b61c638db60$var$fa = {}, $f60d5b61c638db60$var$ha = {};
function $f60d5b61c638db60$var$ia(a) {
    if ($f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$ha, a)) return !0;
    if ($f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$fa, a)) return !1;
    if ($f60d5b61c638db60$var$ea.test(a)) return $f60d5b61c638db60$var$ha[a] = !0;
    $f60d5b61c638db60$var$fa[a] = !0;
    return !1;
}
function $f60d5b61c638db60$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $f60d5b61c638db60$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f60d5b61c638db60$var$ja = /[\-:]([a-z])/g;
function $f60d5b61c638db60$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
    $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
    $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
    $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f60d5b61c638db60$var$z.xlinkHref = new $f60d5b61c638db60$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $f60d5b61c638db60$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f60d5b61c638db60$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f60d5b61c638db60$var$B).forEach(function(a) {
    $f60d5b61c638db60$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f60d5b61c638db60$var$B[b] = $f60d5b61c638db60$var$B[a];
    });
});
var $f60d5b61c638db60$var$oa = /["'&<>]/;
function $f60d5b61c638db60$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $f60d5b61c638db60$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $f60d5b61c638db60$var$pa = /([A-Z])/g, $f60d5b61c638db60$var$qa = /^ms-/, $f60d5b61c638db60$var$ra = Array.isArray, $f60d5b61c638db60$var$sa = $f60d5b61c638db60$var$w("<script>"), $f60d5b61c638db60$var$ta = $f60d5b61c638db60$var$w("\x3c/script>"), $f60d5b61c638db60$var$ua = $f60d5b61c638db60$var$w('<script src="'), $f60d5b61c638db60$var$va = $f60d5b61c638db60$var$w('<script type="module" src="'), $f60d5b61c638db60$var$wa = $f60d5b61c638db60$var$w('" async="">\x3c/script>'), $f60d5b61c638db60$var$xa = /(<\/|<)(s)(cript)/gi;
function $f60d5b61c638db60$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $f60d5b61c638db60$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $f60d5b61c638db60$var$sa : $f60d5b61c638db60$var$w('<script nonce="' + $f60d5b61c638db60$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $f60d5b61c638db60$var$u(("" + c).replace($f60d5b61c638db60$var$xa, $f60d5b61c638db60$var$ya)), $f60d5b61c638db60$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($f60d5b61c638db60$var$ua, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d[c])), $f60d5b61c638db60$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($f60d5b61c638db60$var$va, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(f[d])), $f60d5b61c638db60$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $f60d5b61c638db60$var$w(a + "P:"),
        segmentPrefix: $f60d5b61c638db60$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $f60d5b61c638db60$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $f60d5b61c638db60$var$Aa(a) {
    return $f60d5b61c638db60$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $f60d5b61c638db60$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $f60d5b61c638db60$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $f60d5b61c638db60$var$D(2, null);
        case "math":
            return $f60d5b61c638db60$var$D(3, null);
        case "foreignObject":
            return $f60d5b61c638db60$var$D(1, null);
        case "table":
            return $f60d5b61c638db60$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $f60d5b61c638db60$var$D(5, null);
        case "colgroup":
            return $f60d5b61c638db60$var$D(7, null);
        case "tr":
            return $f60d5b61c638db60$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $f60d5b61c638db60$var$D(1, null) : a;
}
var $f60d5b61c638db60$var$Ca = $f60d5b61c638db60$var$w("\x3c!-- --\x3e");
function $f60d5b61c638db60$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($f60d5b61c638db60$var$Ca);
    a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(b)));
    return !0;
}
var $f60d5b61c638db60$var$Ea = new Map, $f60d5b61c638db60$var$Fa = $f60d5b61c638db60$var$w(' style="'), $f60d5b61c638db60$var$Ga = $f60d5b61c638db60$var$w(":"), $f60d5b61c638db60$var$Ha = $f60d5b61c638db60$var$w(";");
function $f60d5b61c638db60$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($f60d5b61c638db60$var$k(62));
    b = !0;
    for(var d in c)if ($f60d5b61c638db60$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d));
                f = $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $f60d5b61c638db60$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $f60d5b61c638db60$var$w($f60d5b61c638db60$var$C(e.replace($f60d5b61c638db60$var$pa, "-$1").toLowerCase().replace($f60d5b61c638db60$var$qa, "-ms-"))), $f60d5b61c638db60$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$B, d) ? $f60d5b61c638db60$var$u("" + f) : $f60d5b61c638db60$var$u(f + "px") : $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($f60d5b61c638db60$var$Fa, e, $f60d5b61c638db60$var$Ga, f)) : a.push($f60d5b61c638db60$var$Ha, e, $f60d5b61c638db60$var$Ga, f);
        }
    }
    b || a.push($f60d5b61c638db60$var$E);
}
var $f60d5b61c638db60$var$H = $f60d5b61c638db60$var$w(" "), $f60d5b61c638db60$var$I = $f60d5b61c638db60$var$w('="'), $f60d5b61c638db60$var$E = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$Ja = $f60d5b61c638db60$var$w('=""');
function $f60d5b61c638db60$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $f60d5b61c638db60$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $f60d5b61c638db60$var$z.hasOwnProperty(c) ? $f60d5b61c638db60$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $f60d5b61c638db60$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$Ja) : !1 !== d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
            }
        } else if ($f60d5b61c638db60$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($f60d5b61c638db60$var$H, $f60d5b61c638db60$var$u(c), $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
        }
    }
}
var $f60d5b61c638db60$var$K = $f60d5b61c638db60$var$w(">"), $f60d5b61c638db60$var$Ka = $f60d5b61c638db60$var$w("/>");
function $f60d5b61c638db60$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($f60d5b61c638db60$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($f60d5b61c638db60$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($f60d5b61c638db60$var$u("" + b));
    }
}
function $f60d5b61c638db60$var$La(a) {
    var b = "";
    $5uXOq.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $f60d5b61c638db60$var$Ma = $f60d5b61c638db60$var$w(' selected=""');
function $f60d5b61c638db60$var$Na(a, b, c, d) {
    a.push($f60d5b61c638db60$var$M(c));
    var f = c = null, e;
    for(e in b)if ($f60d5b61c638db60$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $f60d5b61c638db60$var$J(a, d, e, g);
        }
    }
    a.push($f60d5b61c638db60$var$K);
    $f60d5b61c638db60$var$L(a, f, c);
    return "string" === typeof c ? (a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(c))), null) : c;
}
var $f60d5b61c638db60$var$Oa = $f60d5b61c638db60$var$w("\n"), $f60d5b61c638db60$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $f60d5b61c638db60$var$Qa = new Map;
function $f60d5b61c638db60$var$M(a) {
    var b = $f60d5b61c638db60$var$Qa.get(a);
    if (void 0 === b) {
        if (!$f60d5b61c638db60$var$Pa.test(a)) throw Error($f60d5b61c638db60$var$k(65, a));
        b = $f60d5b61c638db60$var$w("<" + a);
        $f60d5b61c638db60$var$Qa.set(a, b);
    }
    return b;
}
var $f60d5b61c638db60$var$Ra = $f60d5b61c638db60$var$w("<!DOCTYPE html>");
function $f60d5b61c638db60$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($f60d5b61c638db60$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($f60d5b61c638db60$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $f60d5b61c638db60$var$J(a, d, r, h);
                }
            }
            a.push($f60d5b61c638db60$var$K);
            $f60d5b61c638db60$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($f60d5b61c638db60$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($f60d5b61c638db60$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $f60d5b61c638db60$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $f60d5b61c638db60$var$La(h), $f60d5b61c638db60$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($f60d5b61c638db60$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($f60d5b61c638db60$var$Ma);
            } else q && a.push($f60d5b61c638db60$var$Ma);
            a.push($f60d5b61c638db60$var$K);
            $f60d5b61c638db60$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($f60d5b61c638db60$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($f60d5b61c638db60$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(91));
                default:
                    $f60d5b61c638db60$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($f60d5b61c638db60$var$K);
            if (null != r) {
                if (null != e) throw Error($f60d5b61c638db60$var$k(92));
                if ($f60d5b61c638db60$var$ra(r) && 1 < r.length) throw Error($f60d5b61c638db60$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($f60d5b61c638db60$var$Oa);
            null !== e && a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C("" + e)));
            return null;
        case "input":
            a.push($f60d5b61c638db60$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($f60d5b61c638db60$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $f60d5b61c638db60$var$J(a, d, g, q);
            }
            null !== r ? $f60d5b61c638db60$var$J(a, d, "checked", r) : null !== m && $f60d5b61c638db60$var$J(a, d, "checked", m);
            null !== e ? $f60d5b61c638db60$var$J(a, d, "value", e) : null !== h && $f60d5b61c638db60$var$J(a, d, "value", h);
            a.push($f60d5b61c638db60$var$Ka);
            return null;
        case "menuitem":
            a.push($f60d5b61c638db60$var$M("menuitem"));
            for(var A in c)if ($f60d5b61c638db60$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(400));
                default:
                    $f60d5b61c638db60$var$J(a, d, A, e);
            }
            a.push($f60d5b61c638db60$var$K);
            return null;
        case "title":
            a.push($f60d5b61c638db60$var$M("title"));
            e = null;
            for(v in c)if ($f60d5b61c638db60$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(434));
                default:
                    $f60d5b61c638db60$var$J(a, d, v, g);
            }
            a.push($f60d5b61c638db60$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($f60d5b61c638db60$var$M(b));
            g = e = null;
            for(m in c)if ($f60d5b61c638db60$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $f60d5b61c638db60$var$J(a, d, m, h);
            }
            a.push($f60d5b61c638db60$var$K);
            if (null != g) {
                if (null != e) throw Error($f60d5b61c638db60$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($f60d5b61c638db60$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($f60d5b61c638db60$var$Oa, $f60d5b61c638db60$var$u(c)) : a.push($f60d5b61c638db60$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($f60d5b61c638db60$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($f60d5b61c638db60$var$M(b));
            for(var F in c)if ($f60d5b61c638db60$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(399, b));
                default:
                    $f60d5b61c638db60$var$J(a, d, F, e);
            }
            a.push($f60d5b61c638db60$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $f60d5b61c638db60$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($f60d5b61c638db60$var$Ra), $f60d5b61c638db60$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $f60d5b61c638db60$var$Na(a, c, b, d);
            a.push($f60d5b61c638db60$var$M(b));
            g = e = null;
            for(q in c)if ($f60d5b61c638db60$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $f60d5b61c638db60$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $f60d5b61c638db60$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($f60d5b61c638db60$var$H, $f60d5b61c638db60$var$u(q), $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(h)), $f60d5b61c638db60$var$E);
            }
            a.push($f60d5b61c638db60$var$K);
            $f60d5b61c638db60$var$L(a, g, e);
            return e;
    }
}
var $f60d5b61c638db60$var$Ta = $f60d5b61c638db60$var$w("</"), $f60d5b61c638db60$var$Ua = $f60d5b61c638db60$var$w(">"), $f60d5b61c638db60$var$Va = $f60d5b61c638db60$var$w('<template id="'), $f60d5b61c638db60$var$Wa = $f60d5b61c638db60$var$w('"></template>'), $f60d5b61c638db60$var$Xa = $f60d5b61c638db60$var$w("\x3c!--$--\x3e"), $f60d5b61c638db60$var$Ya = $f60d5b61c638db60$var$w('\x3c!--$?--\x3e<template id="'), $f60d5b61c638db60$var$Za = $f60d5b61c638db60$var$w('"></template>'), $f60d5b61c638db60$var$$a = $f60d5b61c638db60$var$w("\x3c!--$!--\x3e"), $f60d5b61c638db60$var$ab = $f60d5b61c638db60$var$w("\x3c!--/$--\x3e"), $f60d5b61c638db60$var$bb = $f60d5b61c638db60$var$w("<template"), $f60d5b61c638db60$var$cb = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$db = $f60d5b61c638db60$var$w(' data-dgst="');
$f60d5b61c638db60$var$w(' data-msg="');
$f60d5b61c638db60$var$w(' data-stck="');
var $f60d5b61c638db60$var$eb = $f60d5b61c638db60$var$w("></template>");
function $f60d5b61c638db60$var$fb(a, b, c) {
    $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$Ya);
    if (null === c) throw Error($f60d5b61c638db60$var$k(395));
    $f60d5b61c638db60$var$p(a, c);
    return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$Za);
}
var $f60d5b61c638db60$var$gb = $f60d5b61c638db60$var$w('<div hidden id="'), $f60d5b61c638db60$var$hb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ib = $f60d5b61c638db60$var$w("</div>"), $f60d5b61c638db60$var$jb = $f60d5b61c638db60$var$w('<svg aria-hidden="true" style="display:none" id="'), $f60d5b61c638db60$var$kb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$lb = $f60d5b61c638db60$var$w("</svg>"), $f60d5b61c638db60$var$mb = $f60d5b61c638db60$var$w('<math aria-hidden="true" style="display:none" id="'), $f60d5b61c638db60$var$nb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ob = $f60d5b61c638db60$var$w("</math>"), $f60d5b61c638db60$var$pb = $f60d5b61c638db60$var$w('<table hidden id="'), $f60d5b61c638db60$var$qb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$rb = $f60d5b61c638db60$var$w("</table>"), $f60d5b61c638db60$var$sb = $f60d5b61c638db60$var$w('<table hidden><tbody id="'), $f60d5b61c638db60$var$tb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ub = $f60d5b61c638db60$var$w("</tbody></table>"), $f60d5b61c638db60$var$vb = $f60d5b61c638db60$var$w('<table hidden><tr id="'), $f60d5b61c638db60$var$wb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$xb = $f60d5b61c638db60$var$w("</tr></table>"), $f60d5b61c638db60$var$yb = $f60d5b61c638db60$var$w('<table hidden><colgroup id="'), $f60d5b61c638db60$var$zb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$Ab = $f60d5b61c638db60$var$w("</colgroup></table>");
function $f60d5b61c638db60$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$gb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$hb);
        case 2:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$jb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$kb);
        case 3:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$mb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$nb);
        case 4:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$pb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$qb);
        case 5:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$sb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$tb);
        case 6:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$vb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$wb);
        case 7:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$yb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$zb);
        default:
            throw Error($f60d5b61c638db60$var$k(397));
    }
}
function $f60d5b61c638db60$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ib);
        case 2:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$lb);
        case 3:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ob);
        case 4:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$rb);
        case 5:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ub);
        case 6:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$xb);
        case 7:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$Ab);
        default:
            throw Error($f60d5b61c638db60$var$k(397));
    }
}
var $f60d5b61c638db60$var$Db = $f60d5b61c638db60$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $f60d5b61c638db60$var$Eb = $f60d5b61c638db60$var$w('$RS("'), $f60d5b61c638db60$var$Gb = $f60d5b61c638db60$var$w('","'), $f60d5b61c638db60$var$Hb = $f60d5b61c638db60$var$w('")\x3c/script>'), $f60d5b61c638db60$var$Ib = $f60d5b61c638db60$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $f60d5b61c638db60$var$Jb = $f60d5b61c638db60$var$w('$RC("'), $f60d5b61c638db60$var$Kb = $f60d5b61c638db60$var$w('","'), $f60d5b61c638db60$var$Lb = $f60d5b61c638db60$var$w('")\x3c/script>'), $f60d5b61c638db60$var$Mb = $f60d5b61c638db60$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $f60d5b61c638db60$var$Nb = $f60d5b61c638db60$var$w('$RX("'), $f60d5b61c638db60$var$Ob = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$Pb = $f60d5b61c638db60$var$w(")\x3c/script>"), $f60d5b61c638db60$var$Qb = $f60d5b61c638db60$var$w(","), $f60d5b61c638db60$var$Rb = /[<\u2028\u2029]/g;
function $f60d5b61c638db60$var$Sb(a) {
    return JSON.stringify(a).replace($f60d5b61c638db60$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $f60d5b61c638db60$var$N = Object.assign, $f60d5b61c638db60$var$Tb = Symbol.for("react.element"), $f60d5b61c638db60$var$Ub = Symbol.for("react.portal"), $f60d5b61c638db60$var$Vb = Symbol.for("react.fragment"), $f60d5b61c638db60$var$Wb = Symbol.for("react.strict_mode"), $f60d5b61c638db60$var$Xb = Symbol.for("react.profiler"), $f60d5b61c638db60$var$Yb = Symbol.for("react.provider"), $f60d5b61c638db60$var$Zb = Symbol.for("react.context"), $f60d5b61c638db60$var$$b = Symbol.for("react.forward_ref"), $f60d5b61c638db60$var$ac = Symbol.for("react.suspense"), $f60d5b61c638db60$var$bc = Symbol.for("react.suspense_list"), $f60d5b61c638db60$var$cc = Symbol.for("react.memo"), $f60d5b61c638db60$var$dc = Symbol.for("react.lazy"), $f60d5b61c638db60$var$ec = Symbol.for("react.scope"), $f60d5b61c638db60$var$fc = Symbol.for("react.debug_trace_mode"), $f60d5b61c638db60$var$gc = Symbol.for("react.legacy_hidden"), $f60d5b61c638db60$var$hc = Symbol.for("react.default_value"), $f60d5b61c638db60$var$ic = Symbol.iterator;
function $f60d5b61c638db60$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f60d5b61c638db60$var$Vb:
            return "Fragment";
        case $f60d5b61c638db60$var$Ub:
            return "Portal";
        case $f60d5b61c638db60$var$Xb:
            return "Profiler";
        case $f60d5b61c638db60$var$Wb:
            return "StrictMode";
        case $f60d5b61c638db60$var$ac:
            return "Suspense";
        case $f60d5b61c638db60$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f60d5b61c638db60$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $f60d5b61c638db60$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $f60d5b61c638db60$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f60d5b61c638db60$var$cc:
            return b = a.displayName || null, null !== b ? b : $f60d5b61c638db60$var$jc(a.type) || "Memo";
        case $f60d5b61c638db60$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $f60d5b61c638db60$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $f60d5b61c638db60$var$kc = {};
function $f60d5b61c638db60$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $f60d5b61c638db60$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $f60d5b61c638db60$var$O = null;
function $f60d5b61c638db60$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($f60d5b61c638db60$var$k(401));
        } else {
            if (null === c) throw Error($f60d5b61c638db60$var$k(401));
            $f60d5b61c638db60$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $f60d5b61c638db60$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $f60d5b61c638db60$var$mc(a);
}
function $f60d5b61c638db60$var$nc(a) {
    var b = a.parent;
    null !== b && $f60d5b61c638db60$var$nc(b);
    a.context._currentValue = a.value;
}
function $f60d5b61c638db60$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($f60d5b61c638db60$var$k(402));
    a.depth === b.depth ? $f60d5b61c638db60$var$P(a, b) : $f60d5b61c638db60$var$oc(a, b);
}
function $f60d5b61c638db60$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($f60d5b61c638db60$var$k(402));
    a.depth === c.depth ? $f60d5b61c638db60$var$P(a, c) : $f60d5b61c638db60$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $f60d5b61c638db60$var$Q(a) {
    var b = $f60d5b61c638db60$var$O;
    b !== a && (null === b ? $f60d5b61c638db60$var$nc(a) : null === a ? $f60d5b61c638db60$var$mc(b) : b.depth === a.depth ? $f60d5b61c638db60$var$P(b, a) : b.depth > a.depth ? $f60d5b61c638db60$var$oc(b, a) : $f60d5b61c638db60$var$pc(b, a), $f60d5b61c638db60$var$O = a);
}
var $f60d5b61c638db60$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $f60d5b61c638db60$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $f60d5b61c638db60$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $f60d5b61c638db60$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $f60d5b61c638db60$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $f60d5b61c638db60$var$N({}, e, h)) : $f60d5b61c638db60$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $f60d5b61c638db60$var$sc = {
    id: 1,
    overflow: ""
};
function $f60d5b61c638db60$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $f60d5b61c638db60$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $f60d5b61c638db60$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $f60d5b61c638db60$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $f60d5b61c638db60$var$uc = Math.clz32 ? Math.clz32 : $f60d5b61c638db60$var$vc, $f60d5b61c638db60$var$wc = Math.log, $f60d5b61c638db60$var$xc = Math.LN2;
function $f60d5b61c638db60$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f60d5b61c638db60$var$wc(a) / $f60d5b61c638db60$var$xc | 0) | 0;
}
function $f60d5b61c638db60$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f60d5b61c638db60$var$zc = "function" === typeof Object.is ? Object.is : $f60d5b61c638db60$var$yc, $f60d5b61c638db60$var$R = null, $f60d5b61c638db60$var$Ac = null, $f60d5b61c638db60$var$Bc = null, $f60d5b61c638db60$var$S = null, $f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$Cc = !1, $f60d5b61c638db60$var$U = 0, $f60d5b61c638db60$var$V = null, $f60d5b61c638db60$var$Dc = 0;
function $f60d5b61c638db60$var$W() {
    if (null === $f60d5b61c638db60$var$R) throw Error($f60d5b61c638db60$var$k(321));
    return $f60d5b61c638db60$var$R;
}
function $f60d5b61c638db60$var$Ec() {
    if (0 < $f60d5b61c638db60$var$Dc) throw Error($f60d5b61c638db60$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $f60d5b61c638db60$var$Fc() {
    null === $f60d5b61c638db60$var$S ? null === $f60d5b61c638db60$var$Bc ? ($f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$Bc = $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Ec()) : ($f60d5b61c638db60$var$T = !0, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Bc) : null === $f60d5b61c638db60$var$S.next ? ($f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$S.next = $f60d5b61c638db60$var$Ec()) : ($f60d5b61c638db60$var$T = !0, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$S.next);
    return $f60d5b61c638db60$var$S;
}
function $f60d5b61c638db60$var$Gc() {
    $f60d5b61c638db60$var$Ac = $f60d5b61c638db60$var$R = null;
    $f60d5b61c638db60$var$Cc = !1;
    $f60d5b61c638db60$var$Bc = null;
    $f60d5b61c638db60$var$Dc = 0;
    $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$V = null;
}
function $f60d5b61c638db60$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f60d5b61c638db60$var$Ic(a, b, c) {
    $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
    $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
    if ($f60d5b61c638db60$var$T) {
        var d = $f60d5b61c638db60$var$S.queue;
        b = d.dispatch;
        if (null !== $f60d5b61c638db60$var$V && (c = $f60d5b61c638db60$var$V.get(d), void 0 !== c)) {
            $f60d5b61c638db60$var$V.delete(d);
            d = $f60d5b61c638db60$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $f60d5b61c638db60$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $f60d5b61c638db60$var$S.memoizedState,
            b
        ];
    }
    a = a === $f60d5b61c638db60$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $f60d5b61c638db60$var$S.memoizedState = a;
    a = $f60d5b61c638db60$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $f60d5b61c638db60$var$Jc.bind(null, $f60d5b61c638db60$var$R, a);
    return [
        $f60d5b61c638db60$var$S.memoizedState,
        a
    ];
}
function $f60d5b61c638db60$var$Kc(a, b) {
    $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
    $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $f60d5b61c638db60$var$S) {
        var c = $f60d5b61c638db60$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$f60d5b61c638db60$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $f60d5b61c638db60$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f60d5b61c638db60$var$Jc(a, b, c) {
    if (25 <= $f60d5b61c638db60$var$Dc) throw Error($f60d5b61c638db60$var$k(301));
    if (a === $f60d5b61c638db60$var$R) {
        if ($f60d5b61c638db60$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $f60d5b61c638db60$var$V && ($f60d5b61c638db60$var$V = new Map), c = $f60d5b61c638db60$var$V.get(b), void 0 === c) $f60d5b61c638db60$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $f60d5b61c638db60$var$Lc() {
    throw Error($f60d5b61c638db60$var$k(394));
}
function $f60d5b61c638db60$var$Mc() {}
var $f60d5b61c638db60$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $f60d5b61c638db60$var$W();
        return a._currentValue;
    },
    useMemo: $f60d5b61c638db60$var$Kc,
    useReducer: $f60d5b61c638db60$var$Ic,
    useRef: function(a) {
        $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
        $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
        var b = $f60d5b61c638db60$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $f60d5b61c638db60$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $f60d5b61c638db60$var$Ic($f60d5b61c638db60$var$Hc, a);
    },
    useInsertionEffect: $f60d5b61c638db60$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $f60d5b61c638db60$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $f60d5b61c638db60$var$Mc,
    useEffect: $f60d5b61c638db60$var$Mc,
    useDebugValue: $f60d5b61c638db60$var$Mc,
    useDeferredValue: function(a) {
        $f60d5b61c638db60$var$W();
        return a;
    },
    useTransition: function() {
        $f60d5b61c638db60$var$W();
        return [
            !1,
            $f60d5b61c638db60$var$Lc
        ];
    },
    useId: function() {
        var a = $f60d5b61c638db60$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $f60d5b61c638db60$var$uc(a) - 1)).toString(32) + b;
        var c = $f60d5b61c638db60$var$Nc;
        if (null === c) throw Error($f60d5b61c638db60$var$k(404));
        b = $f60d5b61c638db60$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $f60d5b61c638db60$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($f60d5b61c638db60$var$k(407));
        return c();
    }
}, $f60d5b61c638db60$var$Nc = null, $f60d5b61c638db60$var$Pc = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $f60d5b61c638db60$var$Qc(a) {
    console.error(a);
    return null;
}
function $f60d5b61c638db60$var$X() {}
function $f60d5b61c638db60$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $f60d5b61c638db60$var$Qc : f,
        onAllReady: void 0 === e ? $f60d5b61c638db60$var$X : e,
        onShellReady: void 0 === g ? $f60d5b61c638db60$var$X : g,
        onShellError: void 0 === h ? $f60d5b61c638db60$var$X : h,
        onFatalError: void 0 === m ? $f60d5b61c638db60$var$X : m
    };
    c = $f60d5b61c638db60$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $f60d5b61c638db60$var$Tc(b, a, null, c, r, $f60d5b61c638db60$var$kc, null, $f60d5b61c638db60$var$sc);
    q.push(a);
    return b;
}
function $f60d5b61c638db60$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $f60d5b61c638db60$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $f60d5b61c638db60$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $f60d5b61c638db60$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $f60d5b61c638db60$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $f60d5b61c638db60$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $f60d5b61c638db60$var$Wc(a, b, c, d, f) {
    $f60d5b61c638db60$var$R = {};
    $f60d5b61c638db60$var$Ac = b;
    $f60d5b61c638db60$var$U = 0;
    for(a = c(d, f); $f60d5b61c638db60$var$Cc;)$f60d5b61c638db60$var$Cc = !1, $f60d5b61c638db60$var$U = 0, $f60d5b61c638db60$var$Dc += 1, $f60d5b61c638db60$var$S = null, a = c(d, f);
    $f60d5b61c638db60$var$Gc();
    return a;
}
function $f60d5b61c638db60$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($f60d5b61c638db60$var$k(108, $f60d5b61c638db60$var$jc(d) || "Unknown", h));
            d = $f60d5b61c638db60$var$N({}, g, c);
        }
        b.legacyContext = d;
        $f60d5b61c638db60$var$Z(a, b, f);
        b.legacyContext = g;
    } else $f60d5b61c638db60$var$Z(a, b, f);
}
function $f60d5b61c638db60$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $f60d5b61c638db60$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f60d5b61c638db60$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $f60d5b61c638db60$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $f60d5b61c638db60$var$rc(e, c, d, f);
            $f60d5b61c638db60$var$Xc(a, b, e, c);
        } else {
            e = $f60d5b61c638db60$var$lc(c, b.legacyContext);
            f = $f60d5b61c638db60$var$Wc(a, b, c, d, e);
            var g = 0 !== $f60d5b61c638db60$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $f60d5b61c638db60$var$rc(f, c, d, e), $f60d5b61c638db60$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $f60d5b61c638db60$var$tc(d, 1, 0);
                try {
                    $f60d5b61c638db60$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $f60d5b61c638db60$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $f60d5b61c638db60$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $f60d5b61c638db60$var$Ba(g, c, d);
        $f60d5b61c638db60$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($f60d5b61c638db60$var$Ta, $f60d5b61c638db60$var$u(c), $f60d5b61c638db60$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $f60d5b61c638db60$var$gc:
            case $f60d5b61c638db60$var$fc:
            case $f60d5b61c638db60$var$Wb:
            case $f60d5b61c638db60$var$Xb:
            case $f60d5b61c638db60$var$Vb:
                $f60d5b61c638db60$var$Z(a, b, d.children);
                return;
            case $f60d5b61c638db60$var$bc:
                $f60d5b61c638db60$var$Z(a, b, d.children);
                return;
            case $f60d5b61c638db60$var$ec:
                throw Error($f60d5b61c638db60$var$k(343));
            case $f60d5b61c638db60$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $f60d5b61c638db60$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $f60d5b61c638db60$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($f60d5b61c638db60$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($f60d5b61c638db60$var$Ca), q.status = 1, $f60d5b61c638db60$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $f60d5b61c638db60$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $f60d5b61c638db60$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $f60d5b61c638db60$var$$b:
                d = $f60d5b61c638db60$var$Wc(a, b, c.render, d, f);
                if (0 !== $f60d5b61c638db60$var$U) {
                    c = b.treeContext;
                    b.treeContext = $f60d5b61c638db60$var$tc(c, 1, 0);
                    try {
                        $f60d5b61c638db60$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $f60d5b61c638db60$var$Z(a, b, d);
                return;
            case $f60d5b61c638db60$var$cc:
                c = c.type;
                d = $f60d5b61c638db60$var$Yc(c, d);
                $f60d5b61c638db60$var$Zc(a, b, c, d, f);
                return;
            case $f60d5b61c638db60$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $f60d5b61c638db60$var$O;
                $f60d5b61c638db60$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $f60d5b61c638db60$var$Z(a, b, f);
                a = $f60d5b61c638db60$var$O;
                if (null === a) throw Error($f60d5b61c638db60$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $f60d5b61c638db60$var$hc ? a.context._defaultValue : d;
                a = $f60d5b61c638db60$var$O = a.parent;
                b.context = a;
                return;
            case $f60d5b61c638db60$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $f60d5b61c638db60$var$Z(a, b, d);
                return;
            case $f60d5b61c638db60$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $f60d5b61c638db60$var$Yc(c, d);
                $f60d5b61c638db60$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($f60d5b61c638db60$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $f60d5b61c638db60$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $f60d5b61c638db60$var$Tb:
                $f60d5b61c638db60$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $f60d5b61c638db60$var$Ub:
                throw Error($f60d5b61c638db60$var$k(257));
            case $f60d5b61c638db60$var$dc:
                var d = c._init;
                c = d(c._payload);
                $f60d5b61c638db60$var$Z(a, b, c);
                return;
        }
        if ($f60d5b61c638db60$var$ra(c)) {
            $f60d5b61c638db60$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $f60d5b61c638db60$var$ic && c[$f60d5b61c638db60$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $f60d5b61c638db60$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($f60d5b61c638db60$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $f60d5b61c638db60$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $f60d5b61c638db60$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $f60d5b61c638db60$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $f60d5b61c638db60$var$tc(e, d, f);
        try {
            $f60d5b61c638db60$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $f60d5b61c638db60$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $f60d5b61c638db60$var$Z(a, b, c);
    } catch (m) {
        if ($f60d5b61c638db60$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $f60d5b61c638db60$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $f60d5b61c638db60$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $f60d5b61c638db60$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $f60d5b61c638db60$var$Q(e), m;
    }
}
function $f60d5b61c638db60$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $f60d5b61c638db60$var$dd(this, b, a);
}
function $f60d5b61c638db60$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($f60d5b61c638db60$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $f60d5b61c638db60$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $f60d5b61c638db60$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $f60d5b61c638db60$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $f60d5b61c638db60$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($f60d5b61c638db60$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $f60d5b61c638db60$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $f60d5b61c638db60$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($f60d5b61c638db60$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($f60d5b61c638db60$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $f60d5b61c638db60$var$Uc(a) {
    if (2 !== a.status) {
        var b = $f60d5b61c638db60$var$O, c = $f60d5b61c638db60$var$Pc.current;
        $f60d5b61c638db60$var$Pc.current = $f60d5b61c638db60$var$Oc;
        var d = $f60d5b61c638db60$var$Nc;
        $f60d5b61c638db60$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $f60d5b61c638db60$var$Q(g.context);
                    try {
                        $f60d5b61c638db60$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($f60d5b61c638db60$var$Ca), g.abortSet.delete(g), m.status = 1, $f60d5b61c638db60$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($f60d5b61c638db60$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $f60d5b61c638db60$var$Y(h, v);
                            null === r ? $f60d5b61c638db60$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $f60d5b61c638db60$var$fd(a, a.destination);
        } catch (G) {
            $f60d5b61c638db60$var$Y(a, G), $f60d5b61c638db60$var$Vc(a, G);
        } finally{
            $f60d5b61c638db60$var$Nc = d, $f60d5b61c638db60$var$Pc.current = c, c === $f60d5b61c638db60$var$Oc && $f60d5b61c638db60$var$Q(b);
        }
    }
}
function $f60d5b61c638db60$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Va);
            $f60d5b61c638db60$var$p(b, a.placeholderPrefix);
            a = $f60d5b61c638db60$var$u(d.toString(16));
            $f60d5b61c638db60$var$p(b, a);
            return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$f60d5b61c638db60$var$p(b, d[e]);
                f = $f60d5b61c638db60$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$f60d5b61c638db60$var$p(b, d[e]);
            e < d.length && (f = $f60d5b61c638db60$var$t(b, d[e]));
            return f;
        default:
            throw Error($f60d5b61c638db60$var$k(390));
    }
}
function $f60d5b61c638db60$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $f60d5b61c638db60$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$$a), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$bb), d && ($f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$db), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d))), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$cb)), $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$eb), $f60d5b61c638db60$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $f60d5b61c638db60$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $f60d5b61c638db60$var$fb(b, a.responseState, d);
        $f60d5b61c638db60$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $f60d5b61c638db60$var$fb(b, a.responseState, d.id), $f60d5b61c638db60$var$gd(a, b, c);
    else {
        $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($f60d5b61c638db60$var$k(391));
        $f60d5b61c638db60$var$hd(a, b, c[0]);
    }
    return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$ab);
}
function $f60d5b61c638db60$var$id(a, b, c) {
    $f60d5b61c638db60$var$Bb(b, a.responseState, c.formatContext, c.id);
    $f60d5b61c638db60$var$hd(a, b, c);
    return $f60d5b61c638db60$var$Cb(b, c.formatContext);
}
function $f60d5b61c638db60$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$f60d5b61c638db60$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $f60d5b61c638db60$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Ib));
    if (null === d) throw Error($f60d5b61c638db60$var$k(395));
    c = $f60d5b61c638db60$var$u(c.toString(16));
    $f60d5b61c638db60$var$p(b, d);
    $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Kb);
    $f60d5b61c638db60$var$p(b, a.segmentPrefix);
    $f60d5b61c638db60$var$p(b, c);
    return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Lb);
}
function $f60d5b61c638db60$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($f60d5b61c638db60$var$k(392));
        return $f60d5b61c638db60$var$id(a, b, d);
    }
    $f60d5b61c638db60$var$id(a, b, d);
    a = a.responseState;
    $f60d5b61c638db60$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Eb) : (a.sentCompleteSegmentFunction = !0, $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Db));
    $f60d5b61c638db60$var$p(b, a.segmentPrefix);
    f = $f60d5b61c638db60$var$u(f.toString(16));
    $f60d5b61c638db60$var$p(b, f);
    $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Gb);
    $f60d5b61c638db60$var$p(b, a.placeholderPrefix);
    $f60d5b61c638db60$var$p(b, f);
    return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Hb);
}
function $f60d5b61c638db60$var$fd(a, b) {
    $f60d5b61c638db60$var$l = new Uint8Array(512);
    $f60d5b61c638db60$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $f60d5b61c638db60$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$f60d5b61c638db60$var$p(b, d[c]);
            c < d.length && $f60d5b61c638db60$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $f60d5b61c638db60$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Nb) : (h.sentClientRenderFunction = !0, $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Mb));
            if (null === m) throw Error($f60d5b61c638db60$var$k(395));
            $f60d5b61c638db60$var$p(d, m);
            $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Ob);
            if (q || r || v) $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(q || "")));
            if (r || v) $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(r || "")));
            v && ($f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(v))));
            if (!$f60d5b61c638db60$var$t(d, $f60d5b61c638db60$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$f60d5b61c638db60$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $f60d5b61c638db60$var$ba(b);
        $f60d5b61c638db60$var$l = new Uint8Array(512);
        $f60d5b61c638db60$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$f60d5b61c638db60$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$f60d5b61c638db60$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $f60d5b61c638db60$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $f60d5b61c638db60$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $f60d5b61c638db60$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $f60d5b61c638db60$var$fd(a, a.destination);
    } catch (d) {
        $f60d5b61c638db60$var$Y(a, d), $f60d5b61c638db60$var$Vc(a, d);
    }
}
$f60d5b61c638db60$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $f60d5b61c638db60$var$Rc(a, $f60d5b61c638db60$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $f60d5b61c638db60$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $f60d5b61c638db60$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $f60d5b61c638db60$var$fd(h, a);
                        } catch (A) {
                            $f60d5b61c638db60$var$Y(h, A), $f60d5b61c638db60$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $f60d5b61c638db60$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $f60d5b61c638db60$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $f60d5b61c638db60$var$Uc(h);
    });
};
$f60d5b61c638db60$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("dVijb", function(module, exports) {

$parcel$export(module.exports, "default", () => $329939dd47a716cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $329939dd47a716cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    weekStartingLabel: {
        "id": "servicedesk-reports-common.chart.tooltip.week-starting-label",
        "defaultMessage": "Week starting - {formattedDate}"
    }
});

});



parcelRegister("aVOcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc817eaf65198e6c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $89thI = parcelRequire("89thI");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $cnldZ = parcelRequire("cnldZ");

var $3HHkL = parcelRequire("3HHkL");
const $bc817eaf65198e6c$var$seriesActionContainerStyles = null;
const $bc817eaf65198e6c$var$OverallSummary = ({ isEditable: isEditable = false, onEditSeriesClick: onEditSeriesClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onRemoveSeriesClick: onRemoveSeriesClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), chartSeries: chartSeries = [], reportLink: reportLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const list = (0, $5uXOq.useMemo)(()=>chartSeries.map(({ seriesIndex: seriesIndex, name: name, summaryValue: { value: value, valueType: valueType }, itemStyle: itemStyle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$LabelValuePair, {
                key: seriesIndex
            }, reportLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
                href: reportLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$Label, {
                itemStyle: itemStyle
            }, (0, $cnldZ.getFormattedLabel)(valueType, value, formatMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$Label, {
                itemStyle: itemStyle
            }, (0, $cnldZ.getFormattedLabel)(valueType, value, formatMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, name), isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$Inline, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                "data-test-id": "servicedesk-reports-common.ui.overall-summary.edit-series",
                className: (0, $bwpsq.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
                appearance: "link",
                onClick: ()=>{
                    onEditSeriesClick(seriesIndex);
                },
                spacing: "none"
            }, formatMessage((0, $3HHkL.default).editLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                "data-test-id": "servicedesk-reports-common.ui.overall-summary.remove-series",
                className: (0, $bwpsq.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
                appearance: "link",
                onClick: ()=>{
                    onRemoveSeriesClick(seriesIndex);
                }
            }, formatMessage((0, $3HHkL.default).removeLabel)))))), [
        chartSeries,
        formatMessage,
        isEditable,
        onEditSeriesClick,
        onRemoveSeriesClick,
        reportLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$Inline, {
        "data-test-id": "servicedesk-reports-common.ui.overall-summary.label-value-list"
    }, list);
};
var $bc817eaf65198e6c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bc817eaf65198e6c$var$OverallSummary;
const $bc817eaf65198e6c$var$Inline = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bc817eaf65198e6c$var$LabelValuePair = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1y6m _18s86ucv _p12f68cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $bc817eaf65198e6c$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { itemStyle: itemStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1btszcl": (0, $lD23V.default)(__cmplp.itemStyle.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazrmj3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3HHkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40de30121fc8c3c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f40de30121fc8c3c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editLabel: {
        "id": "servicedesk-reports-common.overall-summary.edit-label",
        "defaultMessage": "Edit"
    },
    removeLabel: {
        "id": "servicedesk-reports-common.overall-summary.remove-label",
        "defaultMessage": "Remove"
    }
});

});


parcelRegister("dZIz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f853dd7089102710$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2Ccf7 = parcelRequire("2Ccf7");

var $dAFqR = parcelRequire("dAFqR");

var $esPpy = parcelRequire("esPpy");

var $kU57e = parcelRequire("kU57e");

var $4lDEP = parcelRequire("4lDEP");

var $3z9Bw = parcelRequire("3z9Bw");
const $f853dd7089102710$var$Table = ({ summaryResource: summaryResource, drilldownResource: drilldownResource, isDisabled: isDisabled, selectedDrillDownPoint: selectedDrillDownPoint, onSetDrillDownPoint: onSetDrillDownPoint, onDrilldownPageChange: onDrilldownPageChange })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!drilldownResource.loading && drilldownResource.data) (0, $2Ccf7.DrillDownReportExperience).success();
    }, [
        drilldownResource.loading,
        drilldownResource.data
    ]);
    if (summaryResource.error !== undefined || drilldownResource.error !== undefined || summaryResource.data === undefined) {
        if (drilldownResource.error !== undefined) (0, $2Ccf7.DrillDownReportExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAFqR.default), null);
    }
    if (!selectedDrillDownPoint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3z9Bw.SummaryTable), {
        isDisabled: isDisabled,
        source: summaryResource.data,
        onSelect: ({ data: data })=>{
            onSetDrillDownPoint(data);
        }
    });
    const { data: data, loading: loading } = drilldownResource;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lDEP.SeriesPicker), {
        source: summaryResource.data,
        selectedDrillDownPoint: selectedDrillDownPoint,
        onSwitchSeries: onSetDrillDownPoint,
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        onSwitchTable: ()=>onSetDrillDownPoint()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $esPpy.default), {
        onPageChange: onDrilldownPageChange,
        ...data,
        loading: loading
    }), data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kU57e.PaginationLabel), {
        label: data.paginationCountString
    }));
};
var $f853dd7089102710$export$2e2bcd8739ae039 = $f853dd7089102710$var$Table;

});
parcelRegister("2Ccf7", function(module, exports) {

$parcel$export(module.exports, "DrillDownReportExperience", () => $14a6fe6a77e02e76$export$8d3c23ffc1a7f28f);

var $hNAhd = parcelRequire("hNAhd");
var $d3cxT = parcelRequire("d3cxT");
const $14a6fe6a77e02e76$export$8d3c23ffc1a7f28f = new (0, $d3cxT.UFOExperience)('jsm-drill-down-reports', {
    performanceType: (0, $hNAhd.ExperiencePerformanceTypes).InlineResult,
    type: (0, $hNAhd.ExperienceTypes).Experience
});

});

parcelRegister("esPpy", function(module, exports) {

$parcel$export(module.exports, "default", () => $50257e68a7751e61$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4HnMH = parcelRequire("4HnMH");

var $4hGw3 = parcelRequire("4hGw3");

var $8RXs9 = parcelRequire("8RXs9");

var $aC16r = parcelRequire("aC16r");

var $1Gl9g = parcelRequire("1Gl9g");

var $fUIaM = parcelRequire("fUIaM");
const $50257e68a7751e61$var$IssueTable = ({ page: page, pageSize: pageSize, loading: loading, intl: intl, onPageChange: onPageChange, rows: rows = [], columns: columns = [], totalIssues: totalIssues })=>{
    const paginationi18n = (0, $5uXOq.useMemo)(()=>({
            prev: intl.formatMessage((0, $fUIaM.default).paginationPrev),
            next: intl.formatMessage((0, $fUIaM.default).paginationNext)
        }), [
        intl
    ]);
    const head = (0, $5uXOq.useMemo)(()=>(0, $1Gl9g.default)(columns), [
        columns
    ]);
    const formattedRows = (0, $5uXOq.useMemo)(()=>(0, $aC16r.default)({
            rows: rows,
            totalIssues: totalIssues,
            page: page,
            pageSize: pageSize
        }), [
        pageSize,
        page,
        rows,
        totalIssues
    ]);
    const emptyView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        header: intl.formatMessage((0, $fUIaM.default).noData)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($50257e68a7751e61$var$TableContainer, {
        "data-test-id": "servicedesk-reports-common.ui.table.issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HnMH.default), {
        testId: "servicedesk-reports-common.ui.table.issue-table.issue-table",
        page: page,
        rowsPerPage: pageSize,
        head: head,
        rows: formattedRows,
        onSetPage: onPageChange,
        isLoading: loading,
        paginationi18n: paginationi18n,
        emptyView: emptyView,
        isFixedSize: true
    }));
};
var $50257e68a7751e61$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($50257e68a7751e61$var$IssueTable);
const $50257e68a7751e61$var$TableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4HnMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1662e3bd77a31953$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3tZix = parcelRequire("3tZix");

var $ePBXU = parcelRequire("ePBXU");


var $fJ8fu = parcelRequire("fJ8fu");

var $jzf8j = parcelRequire("jzf8j");

var $jLR0u = parcelRequire("jLR0u");

var $6sIax = parcelRequire("6sIax");

var $jADNY = parcelRequire("jADNY");

var $9U8do = parcelRequire("9U8do");

var $6RegO = parcelRequire("6RegO");

var $6HZYK = parcelRequire("6HZYK");

var $kIKJh = parcelRequire("kIKJh");
function $1662e3bd77a31953$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65:
            return 0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b;
        case 0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b:
            return 0, $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $1662e3bd77a31953$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $ePBXU.default), onSort: providedOnSort = (0, $ePBXU.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $ePBXU.default), onRankEnd: providedOnRankEnd = (0, $ePBXU.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $fJ8fu.validateSortKey)(sortKey, head);
        (0, $fJ8fu.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b) : $1662e3bd77a31953$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $fJ8fu.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3) : (0, $84ed9e4a9d8bc04e$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLR0u.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLR0u.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6RegO.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzf8j.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzf8j.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kIKJh.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1662e3bd77a31953$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzf8j.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6HZYK.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9U8do.default), {
        isLoading: isLoading,
        spinnerSize: (0, $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $1662e3bd77a31953$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("pP0mX")));
const $1662e3bd77a31953$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sIax.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jADNY.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1662e3bd77a31953$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1662e3bd77a31953$export$2e2bcd8739ae039 = $1662e3bd77a31953$var$DynamicTable;

});
const $84ed9e4a9d8bc04e$export$1dee026a19752d6b = 'ASC';
const $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65 = 'DESC';
const $84ed9e4a9d8bc04e$export$71dd4c8ecd45e95f = 'small';
const $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3 = 'large';
const $84ed9e4a9d8bc04e$export$3843c586a90b9cbf = 0.22;

parcelRegister("fJ8fu", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $0b4e248d23054ea5$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $0b4e248d23054ea5$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $0b4e248d23054ea5$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $0b4e248d23054ea5$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $0b4e248d23054ea5$export$c476bbe5da59992d);
const $0b4e248d23054ea5$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $0b4e248d23054ea5$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $0b4e248d23054ea5$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $0b4e248d23054ea5$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $0b4e248d23054ea5$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $0b4e248d23054ea5$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $0b4e248d23054ea5$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $0b4e248d23054ea5$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("jzf8j", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $6268977714d3a60f$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $6268977714d3a60f$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $6268977714d3a60f$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $6268977714d3a60f$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kI0wk = parcelRequire("kI0wk");
function $6268977714d3a60f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6268977714d3a60f$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $6268977714d3a60f$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $6268977714d3a60f$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $6268977714d3a60f$var$bodyBorder = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $kI0wk.tableBorder).borderColor}`
});
const $6268977714d3a60f$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$6268977714d3a60f$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $kI0wk.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$6268977714d3a60f$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $kI0wk.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$6268977714d3a60f$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $kI0wk.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$6268977714d3a60f$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $kI0wk.row).focusOutline
        },
        css: [
            $6268977714d3a60f$var$tableStyles,
            isFixedSize && $6268977714d3a60f$var$fixedSizeTableStyles,
            hasDataRow && $6268977714d3a60f$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $6268977714d3a60f$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $6268977714d3a60f$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("caption", {
        css: $6268977714d3a60f$var$captionStyles
    }, children);
const $6268977714d3a60f$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $6268977714d3a60f$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6268977714d3a60f$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("kI0wk", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $9974f44b1695e005$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $9974f44b1695e005$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $9974f44b1695e005$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $9974f44b1695e005$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $9974f44b1695e005$export$38d703b73e2cf64d);

const $9974f44b1695e005$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $9974f44b1695e005$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$5e0c0d4e15efb4a6$export$e2ef2124cf4024b1})`
};
const $9974f44b1695e005$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$5e0c0d4e15efb4a6$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$5e0c0d4e15efb4a6$export$8c13c2ee36917869})`
};
const $9974f44b1695e005$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$5e0c0d4e15efb4a6$export$e2ef2124cf4024b1})`
};
const $9974f44b1695e005$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`
};

});


parcelRegister("jLR0u", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $54cdefac0984b4b4$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $54cdefac0984b4b4$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $54cdefac0984b4b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $54cdefac0984b4b4$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $54cdefac0984b4b4$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $54cdefac0984b4b4$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $54cdefac0984b4b4$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $54cdefac0984b4b4$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $54cdefac0984b4b4$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("6sIax", function(module, exports) {

$parcel$export(module.exports, "default", () => $53da208a879d72db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a9OW0 = parcelRequire("a9OW0");

var $1Pqf3 = parcelRequire("1Pqf3");
class $53da208a879d72db$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Pqf3.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $53da208a879d72db$var$Body = (0, $a9OW0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53da208a879d72db$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$53da208a879d72db$export$2e2bcd8739ae039 = $53da208a879d72db$var$Body;

});
parcelRegister("a9OW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $edbcee14c230083b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $fJ8fu = parcelRequire("fJ8fu");
const $edbcee14c230083b$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $edbcee14c230083b$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $edbcee14c230083b$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $edbcee14c230083b$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $edbcee14c230083b$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fJ8fu.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $edbcee14c230083b$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fJ8fu.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("1Pqf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4779384176b4c279$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iUcq0 = parcelRequire("iUcq0");

var $3XgHO = parcelRequire("3XgHO");
const $4779384176b4c279$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XgHO.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUcq0.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4779384176b4c279$export$2e2bcd8739ae039 = $4779384176b4c279$var$Row;

});
parcelRegister("iUcq0", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $d30ee5ee0063c639$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $1m2mo = parcelRequire("1m2mo");
const $d30ee5ee0063c639$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1m2mo.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1m2mo.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $1m2mo.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $1m2mo.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1m2mo.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("1m2mo", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $d8ccab06ac906831$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $d8ccab06ac906831$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $d8ccab06ac906831$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $d8ccab06ac906831$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $d8ccab06ac906831$export$f7913df521f684e2);

var $f8Sb3 = parcelRequire("f8Sb3");
function $d8ccab06ac906831$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8ccab06ac906831$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $d8ccab06ac906831$export$708a733455f59a29 = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: `var(${$d8ccab06ac906831$var$CSS_VAR_WIDTH})`
});
const $d8ccab06ac906831$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $d8ccab06ac906831$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $d8ccab06ac906831$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$d8ccab06ac906831$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $d8ccab06ac906831$export$f7913df521f684e2 = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("3XgHO", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $af2d9e5a0754aac8$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jzf8j = parcelRequire("jzf8j");
const $af2d9e5a0754aac8$var$rowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $jzf8j.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $af2d9e5a0754aac8$var$rowBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $jzf8j.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $af2d9e5a0754aac8$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $jzf8j.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $jzf8j.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $af2d9e5a0754aac8$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $af2d9e5a0754aac8$var$rowStyles,
            isHighlighted ? $af2d9e5a0754aac8$var$rowHighlightedBackgroundStyles : $af2d9e5a0754aac8$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("jADNY", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $7fe634067da084ba$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $7fe634067da084ba$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("9U8do", function(module, exports) {

$parcel$export(module.exports, "default", () => $a976c8ae95331425$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9MjbF = parcelRequire("9MjbF");


var $iCYjE = parcelRequire("iCYjE");
class $a976c8ae95331425$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $84ed9e4a9d8bc04e$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCYjE.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCYjE.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCYjE.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("iCYjE", function(module, exports) {

$parcel$export(module.exports, "Container", () => $8c5b5a3e0d77de99$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $8c5b5a3e0d77de99$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $8c5b5a3e0d77de99$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $8c5b5a3e0d77de99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c5b5a3e0d77de99$export$c335a80381ec61f5 = '--contents-opacity';
const $8c5b5a3e0d77de99$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $8c5b5a3e0d77de99$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $8c5b5a3e0d77de99$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $8c5b5a3e0d77de99$var$contentsContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: `var(${$8c5b5a3e0d77de99$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $8c5b5a3e0d77de99$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$8c5b5a3e0d77de99$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $8c5b5a3e0d77de99$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $8c5b5a3e0d77de99$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $8c5b5a3e0d77de99$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $8c5b5a3e0d77de99$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("6RegO", function(module, exports) {

$parcel$export(module.exports, "default", () => $73246af8667d57d9$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $5uXOq = parcelRequire("5uXOq");

var $9MjbF = parcelRequire("9MjbF");


var $57cqj = parcelRequire("57cqj");
class $73246af8667d57d9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $84ed9e4a9d8bc04e$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57cqj.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57cqj.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57cqj.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("57cqj", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e96fc2e7276db978$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e96fc2e7276db978$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e96fc2e7276db978$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $e96fc2e7276db978$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e96fc2e7276db978$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e96fc2e7276db978$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e96fc2e7276db978$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e96fc2e7276db978$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e96fc2e7276db978$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e96fc2e7276db978$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e96fc2e7276db978$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e96fc2e7276db978$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e96fc2e7276db978$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("6HZYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $37c1df4e208237d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4qDpj = parcelRequire("4qDpj");
class $37c1df4e208237d5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qDpj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("4qDpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc085b9842df5f8f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3tZix = parcelRequire("3tZix");

var $ePBXU = parcelRequire("ePBXU");

var $hpEeR = parcelRequire("hpEeR");

var $g8eK6 = parcelRequire("g8eK6");

var $vdokb = parcelRequire("vdokb");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $ir5yp = parcelRequire("ir5yp");

var $59CZH = parcelRequire("59CZH");

var $2gMRD = parcelRequire("2gMRD");

var $hHMPU = parcelRequire("hHMPU");

var $iEuL0 = parcelRequire("iEuL0");
const $cc085b9842df5f8f$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $cc085b9842df5f8f$var$paginationMenuStyles = (0, $jJ1Sb.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $cc085b9842df5f8f$var$paginationMenuItemStyles = (0, $jJ1Sb.xcss)({
    marginBlockStart: 'space.0'
});
const $cc085b9842df5f8f$var$navigatorIconWrapperStyles = (0, $jJ1Sb.xcss)({
    paddingInline: 'space.075'
});
function $cc085b9842df5f8f$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($g8eK6))) : (0, (/*@__PURE__*/$parcel$interopDefault($vdokb)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "span",
        xcss: $cc085b9842df5f8f$var$navigatorIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $cc085b9842df5f8f$var$InnerPagination({ components: components = (0, $hHMPU.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $hHMPU.emptyObject), max: max = 7, onChange: onChange = (0, $ePBXU.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $2gMRD.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $hpEeR.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$cc085b9842df5f8f$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
            as: "li",
            xcss: $cc085b9842df5f8f$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59CZH.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir5yp.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc085b9842df5f8f$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $cc085b9842df5f8f$var$paginationMenuStyles
    }, (0, $iEuL0.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir5yp.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc085b9842df5f8f$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $cc085b9842df5f8f$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($cc085b9842df5f8f$var$InnerPagination));
var $cc085b9842df5f8f$export$2e2bcd8739ae039 = $cc085b9842df5f8f$var$Pagination;

});
parcelRegister("g8eK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbe8d442bfeee8c1$var$_react = $bbe8d442bfeee8c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bbe8d442bfeee8c1$var$_chevronLeft = $bbe8d442bfeee8c1$var$_interopRequireDefault((parcelRequire("afR4G")));

var $bbe8d442bfeee8c1$var$_chevronLeftLarge = $bbe8d442bfeee8c1$var$_interopRequireDefault((parcelRequire("8IaEt")));
function $bbe8d442bfeee8c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbe8d442bfeee8c1$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $bbe8d442bfeee8c1$var$_react.default.createElement($bbe8d442bfeee8c1$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $bbe8d442bfeee8c1$var$_chevronLeftLarge.default
    }, props));
$bbe8d442bfeee8c1$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $bbe8d442bfeee8c1$var$_default = module.exports.default = $bbe8d442bfeee8c1$var$ChevronLeftIcon;

});

parcelRegister("vdokb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05dd489ad229a550$var$_react = $05dd489ad229a550$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $05dd489ad229a550$var$_chevronRight = $05dd489ad229a550$var$_interopRequireDefault((parcelRequire("cSFUi")));

var $05dd489ad229a550$var$_chevronRightLarge = $05dd489ad229a550$var$_interopRequireDefault((parcelRequire("kerag")));
function $05dd489ad229a550$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05dd489ad229a550$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $05dd489ad229a550$var$_react.default.createElement($05dd489ad229a550$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $05dd489ad229a550$var$_chevronRightLarge.default
    }, props));
$05dd489ad229a550$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $05dd489ad229a550$var$_default = module.exports.default = $05dd489ad229a550$var$ChevronRightIcon;

});

parcelRegister("ir5yp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ea1965bd5ec3ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");
function $c2ea1965bd5ec3ed$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("59CZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e3a9a9eebcabfb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");
function $56e3a9a9eebcabfb$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("2gMRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a0e0d0a90cae6f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $8tUJa = parcelRequire("8tUJa");
const $f7a0e0d0a90cae6f$var$containerStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    position: 'relative'
});
function $f7a0e0d0a90cae6f$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $f7a0e0d0a90cae6f$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tUJa.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("hHMPU", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $f762102d0338cc3f$export$3f860eba1218f8d3);
const $f762102d0338cc3f$export$3f860eba1218f8d3 = {};

});

parcelRegister("iEuL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $498d7e9a00b3b2c9$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $498d7e9a00b3b2c9$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $498d7e9a00b3b2c9$export$2e2bcd8739ae039 = $498d7e9a00b3b2c9$var$collapseRange;

});



parcelRegister("kIKJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad77d12c9a6c0a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fJ8fu = parcelRequire("fJ8fu");

var $70ohB = parcelRequire("70ohB");

var $k3WmL = parcelRequire("k3WmL");

var $8W5hl = parcelRequire("8W5hl");
class $1ad77d12c9a6c0a5$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    UNSAFE_componentWillMount() {
        (0, $fJ8fu.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fJ8fu.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $k3WmL.default) : (0, $8W5hl.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70ohB.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ad77d12c9a6c0a5$export$2e2bcd8739ae039 = $1ad77d12c9a6c0a5$var$TableHead;

});
parcelRegister("70ohB", function(module, exports) {

$parcel$export(module.exports, "Head", () => $0db5b585a9120982$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $0db5b585a9120982$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");



var $kI0wk = parcelRequire("kI0wk");

var $1m2mo = parcelRequire("1m2mo");
function $0db5b585a9120982$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0db5b585a9120982$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $0db5b585a9120982$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $0db5b585a9120982$var$headStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderBlockEnd: `none`
});
const $0db5b585a9120982$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("thead", {
        css: [
            $0db5b585a9120982$var$headStyles,
            isRanking && $0db5b585a9120982$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $0db5b585a9120982$var$headCellBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $kI0wk.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$0db5b585a9120982$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a)})`}`
    }
});
const $0db5b585a9120982$var$onClickStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $0db5b585a9120982$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $kI0wk.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $kI0wk.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $kI0wk.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $kI0wk.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $kI0wk.MSThemeColors).Text}`
            }
        }
    }
});
const $0db5b585a9120982$var$ascendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $kI0wk.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $kI0wk.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $0db5b585a9120982$var$descendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $kI0wk.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $kI0wk.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $0db5b585a9120982$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1m2mo.getTruncationStyleVars)({
            width: width
        }),
        [$0db5b585a9120982$var$CSS_VAR_TEXT_COLOR]: (0, $kI0wk.head).textColor
    };
    const isASC = sortOrder === (0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1m2mo.cellStyles),
            $0db5b585a9120982$var$headCellBaseStyles,
            onClick && $0db5b585a9120982$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1m2mo.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $1m2mo.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $1m2mo.overflowTruncateStyles),
            isSortable && $0db5b585a9120982$var$baseStyles,
            isASC && $0db5b585a9120982$var$ascendingStyles,
            isDESC && $0db5b585a9120982$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("k3WmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6486d691c2f08565$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2DzWE = parcelRequire("2DzWE");

var $fJ8fu = parcelRequire("fJ8fu");

var $8W5hl = parcelRequire("8W5hl");
class $6486d691c2f08565$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fJ8fu.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8W5hl.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $6486d691c2f08565$var$RankableTableHeadCell = (0, $2DzWE.default)($6486d691c2f08565$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6486d691c2f08565$export$2e2bcd8739ae039 = $6486d691c2f08565$var$RankableTableHeadCell;

});
parcelRegister("2DzWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf89bc848ceb22a4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $bf89bc848ceb22a4$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("8W5hl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3231954efe281351$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $70ohB = parcelRequire("70ohB");
const $3231954efe281351$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70ohB.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3231954efe281351$export$2e2bcd8739ae039 = $3231954efe281351$var$TableHeadCell;

});



parcelRegister("pP0mX", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("i4UfJ")
]).then(()=>parcelRequire('7mthO'));

});


parcelRegister("aC16r", function(module, exports) {

$parcel$export(module.exports, "default", () => $b985b6cda10df468$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ij7C8 = parcelRequire("ij7C8");

var $ljZL8 = parcelRequire("ljZL8");
const $b985b6cda10df468$var$getTableRows = ({ totalIssues: totalIssues, pageSize: pageSize, rows: rows, page: page = 1 })=>{
    let totalRows = [];
    const totalPages = Math.ceil(totalIssues / pageSize);
    if (!rows || !rows.length) return totalRows;
    const visibleRows = rows.map((row)=>{
        const cells = row.map((field, index)=>({
                key: `field-${index}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljZL8.default), field)
            }));
        return {
            cells: cells
        };
    });
    const emptyRow = {
        cells: []
    };
    const numberOfPreviousRows = (page - 1) * pageSize;
    const numberOfNextRows = Math.max(0, (totalPages - page) * pageSize);
    const previousRows = (0, (/*@__PURE__*/$parcel$interopDefault($ij7C8)))(Array(numberOfPreviousRows), emptyRow);
    const nextRows = (0, (/*@__PURE__*/$parcel$interopDefault($ij7C8)))(Array(numberOfNextRows), emptyRow);
    totalRows = [
        ...previousRows,
        ...visibleRows,
        ...nextRows
    ];
    return totalRows;
};
var $b985b6cda10df468$export$2e2bcd8739ae039 = $b985b6cda10df468$var$getTableRows;

});
parcelRegister("ij7C8", function(module, exports) {

var $bTFL0 = parcelRequire("bTFL0");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */ function $d53fe857806ab26c$var$fill(array, value, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    if (start && typeof start != 'number' && $4rDUz(array, value, start)) {
        start = 0;
        end = length;
    }
    return $bTFL0(array, value, start, end);
}
module.exports = $d53fe857806ab26c$var$fill;

});
parcelRegister("bTFL0", function(module, exports) {

var $kPZpS = parcelRequire("kPZpS");

var $6u9J6 = parcelRequire("6u9J6");
/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */ function $8a9538e21a24514e$var$baseFill(array, value, start, end) {
    var length = array.length;
    start = $kPZpS(start);
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end === undefined || end > length ? length : $kPZpS(end);
    if (end < 0) end += length;
    end = start > end ? 0 : $6u9J6(end);
    while(start < end)array[start++] = value;
    return array;
}
module.exports = $8a9538e21a24514e$var$baseFill;

});
parcelRegister("6u9J6", function(module, exports) {

var $gPWEE = parcelRequire("gPWEE");

var $kPZpS = parcelRequire("kPZpS");
/** Used as references for the maximum length and index of an array. */ var $4b8d16e2178c6ba7$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */ function $4b8d16e2178c6ba7$var$toLength(value) {
    return value ? $gPWEE($kPZpS(value), 0, $4b8d16e2178c6ba7$var$MAX_ARRAY_LENGTH) : 0;
}
module.exports = $4b8d16e2178c6ba7$var$toLength;

});
parcelRegister("gPWEE", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $c41ee85d08292e29$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $c41ee85d08292e29$var$baseClamp;

});




parcelRegister("ljZL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0922bfcb2bb7fda$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");

var $1m92z = parcelRequire("1m92z");

var $jcw0u = parcelRequire("jcw0u");

var $g5X3G = parcelRequire("g5X3G");

var $dIdda = parcelRequire("dIdda");

var $dlQrJ = parcelRequire("dlQrJ");

var $4IaNM = parcelRequire("4IaNM");

var $1k2a1 = parcelRequire("1k2a1");

var $3EaUd = parcelRequire("3EaUd");

var $hy166 = parcelRequire("hy166");

var $4oLCE = parcelRequire("4oLCE");

var $5Ahqf = parcelRequire("5Ahqf");

var $lDWfd = parcelRequire("lDWfd");
/**
     Hacky way to transform Reports response to React components.
     Ideally we should change the response but it involves too much work.
 */ const $d0922bfcb2bb7fda$var$FieldRenderer = ({ fieldHtml: fieldHtml, fieldClass: fieldClass })=>{
    const [paramReportId] = (0, $dIdda.usePathParam)('reportId');
    const [paramTimescaleId] = (0, $dIdda.usePathParam)('timescaleId');
    const { push: push } = (0, $dIdda.useRouterActions)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fieldHtml;
    if (tempDiv && tempDiv.firstChild) {
        if (tempDiv.querySelector('SD-KB-DIALOG-LINK')) {
            const el = tempDiv.firstChild;
            // satisfy flow
            if (el instanceof Element) {
                const kbLinkProps = (0, $lDWfd.getKbLinkProps)(el);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ahqf.default), kbLinkProps);
            }
        }
        if (fieldClass === 'reporter' || fieldClass === 'assignee') {
            const agentFieldProps = (0, $lDWfd.getAgentFieldProps)(tempDiv);
            if (agentFieldProps !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3EaUd.default), {
                agent: {
                    ...agentFieldProps
                }
            });
        }
        if (tempDiv.querySelector('.sd-feedback-rating-column')) {
            const rating = tempDiv.querySelectorAll('.sd-feedback-rating-column .feedback-star').length;
            return (0, $hy166.default)[rating];
        }
        if (tempDiv.querySelector('.report-drilldown-field-view-article-user')) {
            const nameSpan = tempDiv.querySelector('.drilldown-field-username');
            const image = tempDiv.querySelector('img');
            if (nameSpan instanceof Element && image instanceof Element) {
                const name = nameSpan.innerHTML;
                const imageSrc = String(image.getAttribute('src'));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1k2a1.default), {
                    name: name,
                    imageUrl: imageSrc,
                    withBorder: true
                });
            }
        }
        if (tempDiv.querySelector('.sd-request-type')) {
            const image = tempDiv.querySelector('img');
            if (image instanceof Element) {
                const name = tempDiv.innerText || '';
                const imageSrc = String(image.getAttribute('src'));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1k2a1.default), {
                    name: name,
                    imageUrl: imageSrc
                });
            }
        }
        if (fieldClass === 'status') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oLCE.RequestStatus), {
            source: tempDiv.children[0]
        });
        if (fieldClass === 'issuekey' || fieldClass === 'summary') {
            const reportId = (0, $dlQrJ.toReportId)(String(paramReportId));
            const timescaleId = paramTimescaleId !== undefined ? Number(paramTimescaleId) : undefined;
            const link = tempDiv.querySelector('a[data-issue-key]') || tempDiv.querySelector('a[data-jira-key]');
            if (!link) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'fieldRendererPayloadAssumptions',
                        packageName: 'jiraServicedeskReportsCommon',
                        teamName: 'itsm-saga'
                    }
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, fieldHtml);
            }
            // @ts-expect-error - TS2339 - Property 'dataset' does not exist on type 'Element'. | TS2339 - Property 'dataset' does not exist on type 'Element'.
            const issueKey = link.dataset.issueKey || link.dataset.jiraKey;
            const onClick = (event)=>{
                if (!reportId) return;
                const { ctrlKey: ctrlKey, metaKey: metaKey } = event;
                // Let default browser behaviour occur when opening link in new tab/window
                // metaKey for macOS cmd. ctrKey for other OSes.
                if (ctrlKey || metaKey) return;
                if (issueKey) {
                    const path = (0, $4IaNM.getReportsFragment)(reportId, (0, $g5X3G.toIssueKey)(issueKey), timescaleId);
                    event.preventDefault();
                    push(path);
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
                as: "p"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                // @ts-expect-error - TS2339 - Property 'dataset' does not exist on type 'Element'.
                "data-issue-key": link.dataset.issueKey,
                href: link?.attributes?.getNamedItem('href')?.value,
                onClick: onClick
            }, link.textContent)));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(fieldHtml, {
                ALLOWED_TAGS: [
                    'p',
                    'strong',
                    'span',
                    'a'
                ],
                ALLOWED_ATTR: [
                    'data-issue-key',
                    'href'
                ]
            })
        }
    });
};
var $d0922bfcb2bb7fda$export$2e2bcd8739ae039 = $d0922bfcb2bb7fda$var$FieldRenderer;

});
parcelRegister("dlQrJ", function(module, exports) {

$parcel$export(module.exports, "toReportId", () => $dc5652368490c1ea$export$19ba7e9702c884f7);
const $dc5652368490c1ea$export$19ba7e9702c884f7 = (reportId)=>reportId;
const $dc5652368490c1ea$export$1d8d88bc534f5ef6 = (reportId)=>reportId;

});

parcelRegister("4IaNM", function(module, exports) {

$parcel$export(module.exports, "getReportsFragment", () => $bcf83f1a6058c734$export$59ea3cac05f90154);
const $bcf83f1a6058c734$export$59ea3cac05f90154 = (reportId, issueKey, timescaleId)=>timescaleId !== undefined ? `${timescaleId}/${String(issueKey)}` : `${String(reportId)}/timescale/2/${String(issueKey)}`;

});

parcelRegister("1k2a1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9d073dfa148432$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1f9d073dfa148432$var$ArticleProfile = ({ imageUrl: imageUrl, name: name, withBorder: withBorder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f9d073dfa148432$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f9d073dfa148432$var$ImageWrapper, {
        src: imageUrl,
        alt: name,
        withBorder: withBorder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f9d073dfa148432$var$NameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, name)));
var $1f9d073dfa148432$export$2e2bcd8739ae039 = $1f9d073dfa148432$var$ArticleProfile;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f9d073dfa148432$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $1f9d073dfa148432$var$ImageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withBorder: withBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_vqks4j": (0, $lD23V.default)(__cmplp.withBorder ? '50%' : 0)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1ejb _p12f1ejb _2rkoo7dz",
            __cmplp.className
        ])
    });
});
const $1f9d073dfa148432$var$NameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz41tcg _19bvutpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3EaUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $49233a0b4004cc6f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dWTaZ = parcelRequire("dWTaZ");

var $kYYfm = parcelRequire("kYYfm");


var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");
const $49233a0b4004cc6f$var$AgentCell = ({ agent: agent, TenantContextSubscriber: TenantContextSubscriber = (0, $9OXo1.TenantContextSubscriber), Link: Link })=>{
    const baseUrl = '';
    const { avatarUrl: avatarUrl, displayName: displayName, accountId: accountId } = agent;
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYYfm.AsyncProfileCardNext), {
        accountId: agent.accountId,
        TenantContextSubscriber: TenantContextSubscriber,
        actions: [
            (0, $e6a2e0952e4731b8$export$23cedd3261bd8015)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49233a0b4004cc6f$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49233a0b4004cc6f$var$StyledAgent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        src: avatarUrl,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Link, {
        href: `${baseUrl}/jira/people/${accountId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49233a0b4004cc6f$var$DisplayName, null, displayName)))));
    return null;
};
$49233a0b4004cc6f$var$AgentCell.defaultProps = {
    Link: (0, $dIdda.Link)
};
var $49233a0b4004cc6f$export$2e2bcd8739ae039 = $49233a0b4004cc6f$var$AgentCell;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49233a0b4004cc6f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4swc3 _1e0c1txw _y3gn1e5h",
            __cmplp.className
        ])
    });
});
const $49233a0b4004cc6f$var$StyledAgent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _bfhk18uv _19itidpf _2rko1l7b _1yt4otz2 _1bsb1osq _4t3izwfg _1reo15vq _syaz1kw7 _11c81psy _zg8l4jg8 _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
const $49233a0b4004cc6f$var$DisplayName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _vwz419ii _19bvu2gc _2hwxu2gc _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kYYfm", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $15521008cc986085$export$a3c0845f856d4292);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $15521008cc986085$var$LazyComponent = (0, $hPtZI.lazy)(()=>(parcelRequire("beEVQ")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $15521008cc986085$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15521008cc986085$var$LazyComponent, props)));
var $15521008cc986085$export$2e2bcd8739ae039 = $15521008cc986085$export$a3c0845f856d4292;

});
parcelRegister("gcl1l", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $ecfe970d67067a10$export$c7209ce2e0d060ea);

var $7NJFp = parcelRequire("7NJFp");
const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7NJFp.isLoaderError)(error)
    });

});

parcelRegister("beEVQ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("hPzOn"),
    $6fhBS("ek7ue")
]).then(()=>parcelRequire('jO6eK'));

});


// values which are passed into the tracking callback by atlaskit
const $e6a2e0952e4731b8$export$febebefae5a09065 = 'profile-card.loaded';
const $e6a2e0952e4731b8$export$3ca1936ee743bd18 = 'profile-card.view';
const $e6a2e0952e4731b8$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $e6a2e0952e4731b8$export$86aa8b9c379ebbbd = 'profile-card.error';
const $e6a2e0952e4731b8$export$4442e31da6ba4127 = 'profile-card.click';
const $e6a2e0952e4731b8$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$2549357601611c61 = 'loadError';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';


parcelRegister("hy166", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c845628001a65b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iASWI = parcelRequire("iASWI");

var $jWahG = parcelRequire("jWahG");

var $2z7BY = parcelRequire("2z7BY");

const $2c845628001a65b9$var$getStars = (rating, scale = 5)=>{
    const stars = (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(scale).map((starIndex)=>starIndex < rating ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2z7BY))), {
            testId: "servicedesk-reports-common.ui.table.issue-table.body.field-renderer.fields.ratings.star-filled-icon",
            key: starIndex,
            primaryColor: `var(--ds-icon-accent-orange, ${(0, $5e0c0d4e15efb4a6$exports).Y300})`,
            label: `${starIndex} star filled`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWahG))), {
            testId: "servicedesk-reports-common.ui.table.issue-table.body.field-renderer.fields.ratings.star-icon",
            key: starIndex,
            primaryColor: `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$exports).N60})`,
            label: `${starIndex} star unfilled`
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, stars);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2c845628001a65b9$var$Ratings = (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(6).map((id)=>$2c845628001a65b9$var$getStars(id));
var $2c845628001a65b9$export$2e2bcd8739ae039 = $2c845628001a65b9$var$Ratings;

});
parcelRegister("iASWI", function(module, exports) {

var $irTmi = parcelRequire("irTmi");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d89635f071f7433a$var$range = $irTmi();
module.exports = $d89635f071f7433a$var$range;

});
parcelRegister("irTmi", function(module, exports) {

var $7DMj9 = parcelRequire("7DMj9");

var $4rDUz = parcelRequire("4rDUz");

var $kJ0Lf = parcelRequire("kJ0Lf");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $d6e5b0af0cc26ead$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $kJ0Lf(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $kJ0Lf(end);
        step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
        return $7DMj9(start, end, step, fromRight);
    };
}
module.exports = $d6e5b0af0cc26ead$var$createRange;

});
parcelRegister("7DMj9", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $5901a5dd7694a169$var$baseRange;

});




parcelRegister("4oLCE", function(module, exports) {

$parcel$export(module.exports, "RequestStatus", () => $506e958c4ae57ed7$export$600e7c1f9e0414e1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $53KbV = parcelRequire("53KbV");

var $eddAM = parcelRequire("eddAM");

var $MGmIU = parcelRequire("MGmIU");
const $506e958c4ae57ed7$export$600e7c1f9e0414e1 = ({ source: source })=>{
    let appearance = 'default';
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const tooltipTemp = document.createElement('span');
    tooltipTemp.innerHTML = source.getAttribute('data-tooltip') || '';
    if (source.classList.contains('jira-issue-status-lozenge-indeterminate')) appearance = 'inprogress';
    else if (source.classList.contains('jira-issue-status-lozenge-done')) appearance = 'success';
    const tooltipTitle = tooltipTemp.querySelector('.jira-issue-status-tooltip-title');
    const tooltipDesc = tooltipTemp.querySelector('.jira-issue-status-tooltip-desc');
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, tooltipTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($506e958c4ae57ed7$var$TooltipTitle, null, tooltipTitle.innerText)), tooltipDesc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($506e958c4ae57ed7$var$TooltipDescription, null, tooltipDesc.innerText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: tooltipContent,
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
        appearance: appearance
    }, source.textContent));
};
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $506e958c4ae57ed7$var$TooltipTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "b", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz15cr",
            __cmplp.className
        ])
    });
});
const $506e958c4ae57ed7$var$TooltipDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz15cr _19pku2gc _11c81oud",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5Ahqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb1e621b75eea29$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l7Yzv = parcelRequire("l7Yzv");

var $dOHxT = parcelRequire("dOHxT");
var $ezPyr = parcelRequire("ezPyr");
var $hEKJD = parcelRequire("hEKJD");
var $D0YJV = parcelRequire("D0YJV");
var $lkDqR = parcelRequire("lkDqR");

var $9MjbF = parcelRequire("9MjbF");


var $41j30 = parcelRequire("41j30");

var $9fuVs = parcelRequire("9fuVs");

var $iXVV6 = parcelRequire("iXVV6");

var $cAofY = parcelRequire("cAofY");

var $dIdda = parcelRequire("dIdda");

var $cwU1O = parcelRequire("cwU1O");

var $5XuaQ = parcelRequire("5XuaQ");
const $6fb1e621b75eea29$var$KbLink = ({ name: name, link: link, iframeSrc: iframeSrc, editLink: editLink, shareable: shareable })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { data: data } = (0, $dIdda.useResource)((0, $cAofY.serviceDeskContextResource));
    const onClick = (e)=>{
        e.preventDefault();
        setIsOpen(true);
    };
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: `${data?.customerUrl}/${link}`,
        onClick: (e)=>onClick(e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6fb1e621b75eea29$var$LinkInnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, name), !shareable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7Yzv))), {
        primaryColor: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`,
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "test"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkDqR.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOHxT.default), {
        width: "x-large",
        onClose: ()=>setIsOpen(!isOpen),
        height: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEKJD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $D0YJV.default), null, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ezPyr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwU1O.default), {
        name: name,
        src: iframeSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XuaQ.default), {
        editLink: editLink,
        link: `${data?.customerUrl}/${link}`,
        onCancel: ()=>setIsOpen(false)
    }))))));
};
var $6fb1e621b75eea29$export$2e2bcd8739ae039 = $6fb1e621b75eea29$var$KbLink;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6fb1e621b75eea29$var$LinkInnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l7Yzv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6193cb5a888632d$var$_react = $f6193cb5a888632d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $f6193cb5a888632d$var$_lockLocked = $f6193cb5a888632d$var$_interopRequireDefault((parcelRequire("b8UGF")));
function $f6193cb5a888632d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f6193cb5a888632d$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f6193cb5a888632d$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $f6193cb5a888632d$var$_lockLocked.default
    }));
$f6193cb5a888632d$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f6193cb5a888632d$var$_default = module.exports.default = $f6193cb5a888632d$var$LockFilledIcon;

});
parcelRegister("b8UGF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::416fbcb8404b026ec5d40aeabfb0a441>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81cc69f0199c5498$var$_react = $81cc69f0199c5498$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $81cc69f0199c5498$var$_UNSAFE_baseNew = $81cc69f0199c5498$var$_interopRequireDefault((parcelRequire("huIZN")));
function $81cc69f0199c5498$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81cc69f0199c5498$var$LockLockedIcon = (props)=>/*#__PURE__*/ $81cc69f0199c5498$var$_react.default.createElement($81cc69f0199c5498$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$81cc69f0199c5498$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $81cc69f0199c5498$var$_default = module.exports.default = $81cc69f0199c5498$var$LockLockedIcon;

});


parcelRegister("41j30", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2f3c33a6194375$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $dIdda = parcelRequire("dIdda");
function $7c2f3c33a6194375$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), rest, children);
}
var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})($7c2f3c33a6194375$var$Link);

});

parcelRegister("9fuVs", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $1dd87679d9ca363b$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $1dd87679d9ca363b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k4r7E = parcelRequire("k4r7E");
const $1dd87679d9ca363b$export$ebbb59327adb551a = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k4r7E.rootRegistry));
const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $5uXOq.useMemo)(()=>new (0, $k4r7E.ShortcutRegistry)(), []);
    const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, $k4r7E.rootRegistry);
    (0, $5uXOq.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;

});
parcelRegister("k4r7E", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $a65fecdbaed23de2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $lbWm4 = parcelRequire("lbWm4");

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $FISJv = parcelRequire("FISJv");

var $lIZQG = parcelRequire("lIZQG");
const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $lIZQG.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $lIZQG.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $lIZQG.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();

});
parcelRegister("lIZQG", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $ca3344250c7b7406$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $ca3344250c7b7406$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $ca3344250c7b7406$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $ca3344250c7b7406$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $ca3344250c7b7406$var$toKey = (e)=>{
    if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("cwU1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b882eeeca5e1a3c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");
const $5b882eeeca5e1a3c$var$Body = ({ name: name, src: src })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("iframe", {
        onLoad: ()=>setIsLoading(false),
        frameBorder: "0",
        title: name,
        src: src,
        height: "100%",
        width: "100%"
    }));
};
var $5b882eeeca5e1a3c$export$2e2bcd8739ae039 = $5b882eeeca5e1a3c$var$Body;

});

parcelRegister("5XuaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a78218f2d3f08fd3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $foBuY = parcelRequire("foBuY");
var $89thI = parcelRequire("89thI");

var $ew1KI = parcelRequire("ew1KI");

var $bvt08 = parcelRequire("bvt08");

var $9KB2r = parcelRequire("9KB2r");


var $8RXs9 = parcelRequire("8RXs9");

var $UFJ9V = parcelRequire("UFJ9V");
const $a78218f2d3f08fd3$var$FadeOut = ({ show: show, children: children })=>{
    const [shouldRender, setRender] = (0, $5uXOq.useState)(show);
    (0, $5uXOq.useEffect)(()=>{
        if (show) setRender(true);
    }, [
        show
    ]);
    const onAnimationEnd = ()=>{
        if (!show) setRender(false);
    };
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a78218f2d3f08fd3$var$FadeWrapper, {
        show: show,
        onAnimationEnd: onAnimationEnd
    }, children) : null;
};
const $a78218f2d3f08fd3$export$a06f1c675e846f6f = ({ onCancel: onCancel, editLink: editLink, link: link, intl: intl })=>{
    const linkTextArea = (0, $5uXOq.useRef)(null);
    const [copied, setCopied] = (0, $5uXOq.useState)(false);
    const copyToClipboard = ()=>{
        if (linkTextArea.current !== null) {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            linkTextArea.current.select(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.execCommand('copy');
            setCopied(true);
            setTimeout(()=>{
                setCopied(false);
            }, 1000);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvt08.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a78218f2d3f08fd3$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $foBuY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "default",
        href: editLink,
        target: "_blank"
    }, intl.formatMessage((0, $UFJ9V.default).editPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KB2r.default), {
        value: link,
        isReadOnly: true,
        isCompact: true,
        ref: linkTextArea
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "default",
        onClick: ()=>copyToClipboard()
    }, intl.formatMessage((0, $UFJ9V.default).copyLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a78218f2d3f08fd3$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a78218f2d3f08fd3$var$FadeOut, {
        show: copied
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ew1KI))), {
        primaryColor: `var(--ds-icon-success, ${(0, $5e0c0d4e15efb4a6$exports).G300})`,
        size: "medium",
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        onClick: ()=>onCancel()
    }, intl.formatMessage((0, $UFJ9V.default).cancel)))));
};
var $a78218f2d3f08fd3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($a78218f2d3f08fd3$export$a06f1c675e846f6f);
const $a78218f2d3f08fd3$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a78218f2d3f08fd3$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb7vkz",
            __cmplp.className
        ])
    });
});
const $a78218f2d3f08fd3$var$fadeOut = /*#__PURE__*/ (0, $47bDC.keyframes)({
    from: {
        opacity: 1
    },
    to: {
        opacity: 0
    }
});
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a78218f2d3f08fd3$var$FadeWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1sra7lj-0"
})`animation:${(props)=>!props.show ? $a78218f2d3f08fd3$var$fadeOut : '' // eslint-disable-line @typescript-eslint/no-explicit-any
} 0.8s linear;`;

});
parcelRegister("ew1KI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a91569d696204514$var$_react = $a91569d696204514$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $a91569d696204514$var$_checkCircle = $a91569d696204514$var$_interopRequireDefault((parcelRequire("aJG7e")));
function $a91569d696204514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a91569d696204514$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $a91569d696204514$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $a91569d696204514$var$_checkCircle.default
    }));
$a91569d696204514$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $a91569d696204514$var$_default = module.exports.default = $a91569d696204514$var$CheckCircleOutlineIcon;

});
parcelRegister("aJG7e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d0ec6a015a1e935$var$_react = $7d0ec6a015a1e935$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7d0ec6a015a1e935$var$_UNSAFE_baseNew = $7d0ec6a015a1e935$var$_interopRequireDefault((parcelRequire("huIZN")));
function $7d0ec6a015a1e935$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d0ec6a015a1e935$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7d0ec6a015a1e935$var$_react.default.createElement($7d0ec6a015a1e935$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$7d0ec6a015a1e935$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7d0ec6a015a1e935$var$_default = module.exports.default = $7d0ec6a015a1e935$var$CheckCircleIcon;

});


parcelRegister("9KB2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $783c51fcaaba60da$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3tZix = parcelRequire("3tZix");

var $ajFFo = parcelRequire("ajFFo");
const $783c51fcaaba60da$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $783c51fcaaba60da$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$783c51fcaaba60da$var$analyticsParams
    });
    const handleOnBlur = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$783c51fcaaba60da$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $5uXOq.useMemo)(()=>(0, $ajFFo.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $ajFFo.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $783c51fcaaba60da$export$2e2bcd8739ae039 = $783c51fcaaba60da$var$Textfield;

});
parcelRegister("ajFFo", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $edefbc44b2662399$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $edefbc44b2662399$export$3eeb47dc8e6249d9);

const $edefbc44b2662399$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $edefbc44b2662399$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $edefbc44b2662399$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $edefbc44b2662399$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $edefbc44b2662399$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $edefbc44b2662399$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $edefbc44b2662399$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $edefbc44b2662399$var$backgroundColor[appearance],
        borderColor: $edefbc44b2662399$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $edefbc44b2662399$var$backgroundColorHover[appearance],
            borderColor: $edefbc44b2662399$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $edefbc44b2662399$var$backgroundColorFocus[appearance],
            borderColor: $edefbc44b2662399$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$edefbc44b2662399$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $edefbc44b2662399$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $edefbc44b2662399$var$getMaxWidth = (width)=>!width ? `100%` : width in $edefbc44b2662399$var$widthMap ? $edefbc44b2662399$var$widthMap[width] : +width;
const $edefbc44b2662399$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$edefbc44b2662399$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $edefbc44b2662399$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $edefbc44b2662399$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("UFJ9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $a017ddc50c2bce82$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a017ddc50c2bce82$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyLink: {
        "id": "servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.copy-link",
        "defaultMessage": "Copy link"
    },
    editPage: {
        "id": "servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.edit-page",
        "defaultMessage": "Edit page"
    },
    cancel: {
        "id": "servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.cancel",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("lDWfd", function(module, exports) {

$parcel$export(module.exports, "getKbLinkProps", () => $b67205cee8595deb$export$26ed3646363ada0a);
$parcel$export(module.exports, "getAgentFieldProps", () => $b67205cee8595deb$export$ec2cadd99971a33);
const $b67205cee8595deb$export$11493bbdcbc7d6ce = (baseUrl, pageId, applicationId)=>{
    const originUrl = new URL(baseUrl).origin;
    const url = new URL(`${originUrl}/servicedesk/customer/kb/view/${pageId}`);
    url.searchParams.append('applicationId', applicationId);
    return url.toString();
};
const $b67205cee8595deb$export$8137b2ada5bef74a = (pageId, applicationId)=>`kb/view/${pageId}?applicationId=${applicationId}`;
const $b67205cee8595deb$export$29a4f5ce2fc7e182 = (baseUrl, pageId)=>`${baseUrl}/pages/editpage.action?pageId=${pageId}`;
const $b67205cee8595deb$export$26ed3646363ada0a = (el)=>{
    const name = String(el.getAttribute('DATA-TITLE'));
    const pageId = String(el.getAttribute('DATA-ID'));
    const baseUrl = String(el.getAttribute('DATA-APPLINK-URL'));
    const applicationId = String(el.getAttribute('DATA-APPLINK-ID'));
    const shareable = el.getAttribute('data-shareable') === 'true' || el.getAttribute('data-hidepadlock') === 'true' || false;
    const iframeSrc = `${baseUrl}/plugins/servlet/remotepageview?pageId=${pageId}`;
    const link = $b67205cee8595deb$export$8137b2ada5bef74a(Number(pageId), applicationId);
    const editLink = $b67205cee8595deb$export$29a4f5ce2fc7e182(baseUrl, Number(pageId));
    return {
        iframeSrc: iframeSrc,
        link: link,
        editLink: editLink,
        shareable: shareable,
        name: name
    };
};
const $b67205cee8595deb$export$ec2cadd99971a33 = (el)=>{
    const userAnchor = el.querySelector('.user-hover');
    // satisfy flow
    if (userAnchor instanceof Element) {
        const href = String(userAnchor.getAttribute('href'));
        const accountId = href.substring(href.indexOf('accountId=') + 10);
        return {
            accountId: accountId,
            displayName: userAnchor.innerHTML,
            avatarUrl: ''
        };
    }
    return undefined;
};

});



parcelRegister("1Gl9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $440ff202ea5eba49$export$2e2bcd8739ae039);
const $440ff202ea5eba49$var$getTableHeader = (columns)=>{
    const cells = columns.map((column, index)=>({
            key: `column-${index}`,
            content: column.columnName
        }));
    return {
        cells: cells
    };
};
var $440ff202ea5eba49$export$2e2bcd8739ae039 = $440ff202ea5eba49$var$getTableHeader;

});

parcelRegister("fUIaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b2fea5e73aebf32$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5b2fea5e73aebf32$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    paginationPrev: {
        "id": "servicedesk-reports-common.table.issue-table.pagination-prev",
        "defaultMessage": "Prev"
    },
    paginationNext: {
        "id": "servicedesk-reports-common.table.issue-table.pagination-next",
        "defaultMessage": "Next"
    },
    noData: {
        "id": "servicedesk-reports-common.table.issue-table.no-data",
        "defaultMessage": "No data found for this period"
    }
});

});


parcelRegister("kU57e", function(module, exports) {

$parcel$export(module.exports, "PaginationLabel", () => $4c1e5997643ffb4a$export$5742121915cb78c6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $kTrC2 = parcelRequire("kTrC2");
const $4c1e5997643ffb4a$export$5742121915cb78c6 = ({ label: label = '', start: start = 0, end: end = 0, size: size = 0 })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c1e5997643ffb4a$var$Label, null, label);
    if (size > 0 && end >= start) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c1e5997643ffb4a$var$Label, null, formatMessage((0, $kTrC2.default).paginationMessage, {
        start: start,
        end: end,
        size: size
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c1e5997643ffb4a$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1aaxusic _19pkidpf _2hwxidpf _otyridpf _18u0idpf _t9ec1i9q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kTrC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8f40023897ce001$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d8f40023897ce001$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    paginationMessage: {
        "id": "servicedesk-reports-common.table.pagination-count-label.pagination-message",
        "defaultMessage": "{start}-{end} of {size}"
    }
});

});


parcelRegister("4lDEP", function(module, exports) {

$parcel$export(module.exports, "SeriesPicker", () => $0945e11bffe29a73$export$b2b877c4ab1b9a94);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $89thI = parcelRequire("89thI");

var $j6ZuL = parcelRequire("j6ZuL");

var $gwIPs = parcelRequire("gwIPs");

var $8RXs9 = parcelRequire("8RXs9");

var $3nKyk = parcelRequire("3nKyk");

var $fSMNO = parcelRequire("fSMNO");
const $0945e11bffe29a73$export$a88f400462875b1a = ({ intl: { formatMessage: formatMessage }, source: { chartSeries: chartSeries, searchBy: searchBy }, selectedDrillDownPoint: selectedDrillDownPoint, onSwitchSeries: onSwitchSeries, onSwitchTable: onSwitchTable })=>{
    const seriesPickerWithLabel = (0, $5uXOq.useMemo)(()=>{
        let seriesPicker;
        if (chartSeries.length === 1) {
            const { itemStyle: itemStyle, name: name } = chartSeries[0];
            seriesPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$OptionWithHighlighter, {
                background: itemStyle.color
            }, name);
        } else {
            const selectableOptions = chartSeries.map(({ name: name, ...rest })=>({
                    label: name,
                    value: rest
                }));
            const selectedOption = selectableOptions.find(({ value: { seriesIndex: seriesIndex } })=>seriesIndex === selectedDrillDownPoint.seriesIndex);
            seriesPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6ZuL.default), {
                value: selectedOption,
                options: selectableOptions,
                // @ts-expect-error - TS2322 - Type '{ readonly option: (styles: any, { value: { itemStyle: { color }, }, }: ItemStyleValue) => any; readonly singleValue: (styles: any, { data: { value: { itemStyle: { color }, }, }, }: {    data: ItemStyleValue;}) => any; readonly container: (styles: any) => any; }' is not assignable to type 'Partial<Styles<{ label: string; value: { [key: string]: string | number; type: string; typeKey?: string | undefined; seriesId: string; seriesIndex: number; showAllSymbol: boolean; summaryValue: YAxisData; ... 7 more ...; seriesType?: SeriesType | undefined; }; }, false, GroupTypeBase<...>>>'.
                styles: $0945e11bffe29a73$var$colourStyles,
                // @ts-expect-error - TS2339 - Property 'value' does not exist on type '{ label: string; value: { [key: string]: string | number; type: string; typeKey?: string | undefined; seriesId: string; seriesIndex: number; showAllSymbol: boolean; summaryValue: YAxisData; ... 7 more ...; seriesType?: SeriesType | undefined; }; } | null'.
                onChange: ({ value: { seriesId: seriesId, seriesIndex: seriesIndex } })=>{
                    onSwitchSeries({
                        ...selectedDrillDownPoint,
                        seriesId: seriesId,
                        seriesIndex: seriesIndex
                    });
                }
            });
        }
        const timeInterval = (0, $fSMNO.getSelectedTimePeriodMessage)(searchBy, selectedDrillDownPoint.expandedDate, formatMessage);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$InlineLabel, {
            as: "label",
            for: "react-select-2-input"
        }, formatMessage((0, $3nKyk.default).seriesPickerDetailsLabel)), seriesPicker, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$InlineLabel, null, timeInterval));
    }, [
        chartSeries,
        formatMessage,
        onSwitchSeries,
        searchBy,
        selectedDrillDownPoint
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$Container, {
        "data-test-id": "servicedesk-reports-common.ui.table.series-picker.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$SeriesPickerWrapper, null, seriesPickerWithLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "link",
        onClick: onSwitchTable
    }, formatMessage((0, $3nKyk.default).returnToSummary)));
};
const $0945e11bffe29a73$export$b2b877c4ab1b9a94 = (0, $8RXs9.default)($0945e11bffe29a73$export$a88f400462875b1a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0945e11bffe29a73$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bahesu3 _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $0945e11bffe29a73$var$SeriesPickerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _2hwx1wug",
            __cmplp.className
        ])
    });
});
const $0945e11bffe29a73$var$OptionWithHighlighter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_192fqt6": (0, $lD23V.default)(__cmplp.background)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4u2gc _1kt9b3bt _cfu11o8l _1s6k10d2 _1n6qu2gc _eid3u2gc _7dwz1ilg",
            __cmplp.className
        ])
    });
});
const $0945e11bffe29a73$var$InlineLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0945e11bffe29a73$var$getOptionHighlighter = (color = '#ccc')=>({
        alignItems: 'center',
        display: 'flex',
        ':before': {
            content: '" "',
            display: 'block',
            background: color,
            marginRight: `${0, $gwIPs.gridSize}px`,
            padding: `${0, $gwIPs.gridSize}px`
        }
    });
const $0945e11bffe29a73$var$colourStyles = {
    option: (styles, { value: { itemStyle: { color: color } } })=>({
            ...styles,
            ...$0945e11bffe29a73$var$getOptionHighlighter(color)
        }),
    singleValue: (styles, { data: { value: { itemStyle: { color: color } } } })=>({
            ...styles,
            ...$0945e11bffe29a73$var$getOptionHighlighter(color)
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    container: (styles)=>({
            ...styles,
            padding: "var(--ds-space-100, 8px)",
            width: '25%'
        })
};

});
parcelRegister("3nKyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $758c1a91a74cd054$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $758c1a91a74cd054$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    seriesPickerDetailsLabel: {
        "id": "servicedesk-reports-common.table.series-picker.series-picker-details-label",
        "defaultMessage": "Details for"
    },
    atDateTime: {
        "id": "servicedesk-reports-common.table.series-picker.at-date-time",
        "defaultMessage": "at {dateTimestamp}"
    },
    onDate: {
        "id": "servicedesk-reports-common.table.series-picker.on-date",
        "defaultMessage": "on {dateTimestamp}"
    },
    inWeek: {
        "id": "servicedesk-reports-common.table.series-picker.in-week",
        "defaultMessage": "in week starting {dateTimestamp}"
    },
    inMonth: {
        "id": "servicedesk-reports-common.table.series-picker.in-month",
        "defaultMessage": "in {dateTimestamp}"
    },
    returnToSummary: {
        "id": "servicedesk-reports-common.table.series-picker.return-to-summary",
        "defaultMessage": "Return to summary table"
    }
});

});

parcelRegister("fSMNO", function(module, exports) {

$parcel$export(module.exports, "getSelectedTimePeriodMessage", () => $454bba9396fbb2b8$export$6c208bc6fa2d1ece);

var $9nenm = parcelRequire("9nenm");

var $3nKyk = parcelRequire("3nKyk");
const $454bba9396fbb2b8$export$755b91df20ec2f47 = (searchBy)=>{
    switch(searchBy){
        case (0, $9nenm.SEARCH_BY).hourly:
            return (0, $3nKyk.default).atDateTime;
        case (0, $9nenm.SEARCH_BY).weekly:
            return (0, $3nKyk.default).inWeek;
        case (0, $9nenm.SEARCH_BY).monthly:
            return (0, $3nKyk.default).inMonth;
        default:
            return (0, $3nKyk.default).onDate;
    }
};
const $454bba9396fbb2b8$export$6c208bc6fa2d1ece = (searchBy, dateTimestamp, formatMessage)=>{
    const message = $454bba9396fbb2b8$export$755b91df20ec2f47(searchBy);
    return formatMessage(message, {
        dateTimestamp: dateTimestamp
    });
};

});


parcelRegister("3z9Bw", function(module, exports) {

$parcel$export(module.exports, "SummaryTable", () => $23d99969d3c45cd4$export$dcecbe055cf73c86);

var $5uXOq = parcelRequire("5uXOq");

var $45O0y = parcelRequire("45O0y");

var $koVbs = parcelRequire("koVbs");

var $babc9 = parcelRequire("babc9");
const $23d99969d3c45cd4$var$paginationi18n = {
    next: '',
    prev: ''
};
const $23d99969d3c45cd4$export$dcecbe055cf73c86 = ({ source: source, onSelect: onSelect, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const head = (0, $5uXOq.useMemo)(()=>(0, $babc9.createHead)(source, {
            formatMessage: formatMessage
        }), [
        formatMessage,
        source
    ]);
    const rows = (0, $5uXOq.useMemo)(()=>(0, $babc9.createRows)(source, {
            formatMessage: formatMessage,
            onClick: onSelect,
            isDisabled: isDisabled
        }), [
        formatMessage,
        isDisabled,
        onSelect,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "servicedesk-reports-common.ui.table.summary-table.summary-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45O0y.default), {
        head: head,
        rows: rows,
        paginationi18n: $23d99969d3c45cd4$var$paginationi18n,
        isFixedSize: true
    }));
};

});
parcelRegister("45O0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5917fcb39f65d1f3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ePBXU = parcelRequire("ePBXU");

var $fJ8fu = parcelRequire("fJ8fu");

var $4HnMH = parcelRequire("4HnMH");
class $5917fcb39f65d1f3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $ePBXU.default),
            onSort: (0, $ePBXU.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HnMH.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $fJ8fu.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});

parcelRegister("babc9", function(module, exports) {

$parcel$export(module.exports, "createHead", () => $c1a79a1b61bc2a63$export$b87bd21e0602bd96);
$parcel$export(module.exports, "createRows", () => $c1a79a1b61bc2a63$export$d7ac61300192caab);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $89thI = parcelRequire("89thI");

var $dyC2h = parcelRequire("dyC2h");

var $9nenm = parcelRequire("9nenm");

var $cnldZ = parcelRequire("cnldZ");

var $8TqM4 = parcelRequire("8TqM4");

var $7TzgI = parcelRequire("7TzgI");
const $c1a79a1b61bc2a63$export$b87bd21e0602bd96 = ({ chartSeries: chartSeries }, { formatMessage: formatMessage })=>{
    const cells = chartSeries.map(({ seriesIndex: seriesIndex, name: name })=>({
            key: `${seriesIndex}`,
            content: name
        }));
    cells.unshift({
        key: 'date-column',
        content: formatMessage((0, $7TzgI.default).dateColumnLabel)
    });
    return {
        cells: cells
    };
};
const $c1a79a1b61bc2a63$export$bf3bed7d90816f1c = ({ seriesIndex: seriesIndex, dataIndex: dataIndex, data: data, value: value, valueType: valueType, onClick: onClick, isDisabled: isDisabled, formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        isDisabled: isDisabled,
        appearance: "link",
        onClick: ()=>{
            onClick({
                seriesIndex: seriesIndex,
                dataIndex: dataIndex,
                data: data
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1a79a1b61bc2a63$var$ButtonLabel, {
        "data-test-id": "servicedesk-reports-common.ui.table.summary-table.button-label"
    }, (0, $cnldZ.getFormattedLabel)(valueType, value, formatMessage)));
const $c1a79a1b61bc2a63$export$d7ac61300192caab = ({ chartSeries: chartSeries, searchBy: searchBy }, { formatMessage: formatMessage, onClick: onClick, isDisabled: isDisabled })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    chartSeries.reduce((accumulator, { name: name, data: data, seriesIndex: seriesIndex })=>{
        data.forEach((pointData)=>{
            const { id: id, expandedDate: expandedDate, value: value, valueType: valueType, dataIndex: dataIndex } = pointData;
            const row = accumulator.find(({ key: key })=>key === `${id}`);
            if (!row) {
                const label = searchBy === (0, $9nenm.SEARCH_BY).weekly ? formatMessage((0, $7TzgI.default).weekStartingLabel, {
                    expandedDate: expandedDate
                }) : expandedDate;
                const cells = [
                    {
                        key: `${name}-${expandedDate}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TqM4.LabelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dyC2h.default), {
                            name: "dateLabel",
                            label: label
                        }, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))))
                    },
                    {
                        key: `${name}-${id}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1a79a1b61bc2a63$export$bf3bed7d90816f1c, {
                            isDisabled: isDisabled,
                            seriesIndex: seriesIndex,
                            dataIndex: dataIndex,
                            value: value,
                            valueType: valueType,
                            data: pointData,
                            onClick: onClick,
                            formatMessage: formatMessage
                        })
                    }
                ];
                accumulator.push({
                    key: `${id}`,
                    cells: cells
                });
            } else row.cells.push({
                key: `${name}-${id}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1a79a1b61bc2a63$export$bf3bed7d90816f1c, {
                    isDisabled: isDisabled,
                    seriesIndex: seriesIndex,
                    dataIndex: dataIndex,
                    value: value,
                    valueType: valueType,
                    data: pointData,
                    onClick: onClick,
                    formatMessage: formatMessage
                })
            });
        });
        return accumulator;
    }, []);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1a79a1b61bc2a63$var$ButtonLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41wcj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7TzgI", function(module, exports) {

$parcel$export(module.exports, "default", () => $41bbeabca1bbc633$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $41bbeabca1bbc633$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    weekStartingLabel: {
        "id": "servicedesk-reports-common.table.summary-table.week-starting-label",
        "defaultMessage": "Week starting - {expandedDate}"
    },
    dateColumnLabel: {
        "id": "servicedesk-reports-common.table.summary-table.date-column-label",
        "defaultMessage": "Date"
    }
});

});




parcelRegister("kuEHb", function(module, exports) {

$parcel$export(module.exports, "kbRequestsReportsPageLoad", () => $f9c0f3cfc2ad3eb2$export$64c48e4611415eec);

var $cHBMC = parcelRequire("cHBMC");
const $f9c0f3cfc2ad3eb2$export$64c48e4611415eec = (0, $cHBMC.metrics).pageLoad({
    key: 'service-management.kb-requests-reports'
});

});

parcelRegister("8u51m", function(module, exports) {

$parcel$export(module.exports, "APP_DEFAULTS", () => $7ff0c24a5324a8a2$export$533ff3a9b30dcc50);
$parcel$export(module.exports, "APP_PAGINATION_DEFAULTS", () => $7ff0c24a5324a8a2$export$f31fb3281b965fce);
const $7ff0c24a5324a8a2$export$533ff3a9b30dcc50 = {
    searchByPastSevenDays: 2,
    timeBreakdown: 'd'
};
const $7ff0c24a5324a8a2$export$f31fb3281b965fce = {
    start: 0,
    limit: 50
};

});


parcelRegister("fySF6", function(module, exports) {

$parcel$export(module.exports, "useUrlActions", () => $4fcd234ce1a5dd19$export$a3fe1c11ec400f1c);
$parcel$export(module.exports, "getCsvUrl", () => $4fcd234ce1a5dd19$export$90f14bb6f669812c);
$parcel$export(module.exports, "getCsvForGeneratedReport", () => $4fcd234ce1a5dd19$export$8c9a255147c6f59d);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $32TkL = parcelRequire("32TkL");

var $bvS9p = parcelRequire("bvS9p");

var $dIdda = parcelRequire("dIdda");

var $8u51m = parcelRequire("8u51m");
const $4fcd234ce1a5dd19$export$a3fe1c11ec400f1c = ({ baseUrl: baseUrl, projectKey: projectKey, routerProps: { reportId: reportId } })=>{
    const [{ location: pathname }, { push: push }] = (0, $dIdda.useRouter)();
    const modifyPageUrl = (0, $5uXOq.useCallback)((query)=>{
        const queryString = (0, $ebyGx.stringify)({
            startTime: query.startDate,
            endTime: query.endDate,
            timeBreakdown: query.timeBreakdown
        }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
        (0, $32TkL.stringifyOptions));
        const timescaleId = query.timescaleId !== undefined ? query.timescaleId.toString() : '';
        const targetUrl = `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports/${reportId}/timescale/${timescaleId}${queryString ? `?${queryString}` : ''}`;
        // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'Location' and 'string' have no overlap.
        if (pathname !== targetUrl) push(targetUrl);
    }, [
        baseUrl,
        pathname,
        projectKey,
        push,
        reportId
    ]);
    return {
        modifyPageUrl: modifyPageUrl
    };
};
const $4fcd234ce1a5dd19$var$getDrillDrownCsvUrlForCustomTimeScale = (urlPrefix, { reportId: reportId, timeBreakdown: timeBreakdown }, { id: id, seriesId: seriesId })=>`${urlPrefix}/series-date-range/${reportId}/${seriesId}/csv?${(0, $ebyGx.stringify)({
        date: id,
        timeBreakdown: timeBreakdown
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions))}`;
const $4fcd234ce1a5dd19$var$getCsvUrlForCustomTimeScale = (urlPrefix, { reportId: reportId, startDate: startDate, endDate: endDate, timeBreakdown: timeBreakdown })=>`${urlPrefix}/report-date-range/${reportId}/csv?${(0, $ebyGx.stringify)({
        startDate: startDate,
        endDate: endDate,
        timeBreakdown: timeBreakdown
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions))}`;
const $4fcd234ce1a5dd19$var$getCsvUrlForTimescale = (urlPrefix, { reportId: reportId }, timescaleId)=>`${urlPrefix}/report/predefined/${reportId}/csv?${(0, $ebyGx.stringify)({
        timescaleId: timescaleId
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions))}`;
const $4fcd234ce1a5dd19$var$getDrillDownCsvUrlForTimescale = (urlPrefix, { reportId: reportId }, timescaleId, { id: id, seriesId: seriesId })=>`${urlPrefix}/series/predefined/${reportId}/${seriesId}/csv?${(0, $ebyGx.stringify)({
        date: id,
        timescaleId: timescaleId
    }, // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    (0, $32TkL.stringifyOptions))}`;
const $4fcd234ce1a5dd19$export$90f14bb6f669812c = (baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint)=>{
    const timescaleId = dateFilterQuery.timescaleId === undefined ? (0, $8u51m.APP_DEFAULTS).searchByPastSevenDays : dateFilterQuery.timescaleId;
    const urlPrefix = `${baseUrl}/rest/servicedesk/reports/1/servicedesk/${projectKey}/export`;
    if ((0, $bvS9p.isCustomTimeScale)(timescaleId)) return selectedDrillDownPoint !== undefined ? $4fcd234ce1a5dd19$var$getDrillDrownCsvUrlForCustomTimeScale(urlPrefix, dateFilterQuery, selectedDrillDownPoint) : $4fcd234ce1a5dd19$var$getCsvUrlForCustomTimeScale(urlPrefix, dateFilterQuery);
    return selectedDrillDownPoint !== undefined ? $4fcd234ce1a5dd19$var$getDrillDownCsvUrlForTimescale(urlPrefix, dateFilterQuery, timescaleId, selectedDrillDownPoint) : $4fcd234ce1a5dd19$var$getCsvUrlForTimescale(urlPrefix, dateFilterQuery, timescaleId);
};
const $4fcd234ce1a5dd19$export$8c9a255147c6f59d = (baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint, taskId)=>{
    if (taskId !== undefined && selectedDrillDownPoint === undefined) return `${baseUrl}/rest/servicedesk/reports/1/reports/async/${projectKey}/export/csv?&jobID=${taskId}`;
    return $4fcd234ce1a5dd19$export$90f14bb6f669812c(baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint);
};

});




parcelRegister("eEETY", function(module, exports) {

$parcel$export(module.exports, "default", () => $335aa4f5fc63025e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $dIdda = parcelRequire("dIdda");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$335aa4f5fc63025e$export$2e2bcd8739ae039 = ()=>{
    const [{ match: { params: params }, location: location }] = (0, $dIdda.useRouter)();
    const routerProps = (0, $5uXOq.useMemo)(()=>{
        const reportId = params.reportId || '';
        const timescaleId = params.timescaleId !== undefined ? Number(params.timescaleId) : undefined;
        const { startTime: startDate, endTime: endDate, timeBreakdown: timeBreakdown } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
        return {
            reportId: reportId,
            timescaleId: timescaleId,
            startDate: startDate,
            endDate: endDate,
            timeBreakdown: timeBreakdown
        };
    }, [
        location.search,
        params.reportId,
        params.timescaleId
    ]);
    return routerProps;
};

});




//# sourceMappingURL=async-servicedesk-kb-requests-reports.290a3cb6.js.map
